const DICTIONARY = {
  "#28A, Chilaw - Colombo Main Rd, Wennappuwa, Sri Lanka": {
    si: "#28A, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0dc0\u0dd9\u0db1\u0dca\u0db1\u0db4\u0dca\u0db4\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "#28A, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bc6\u0ba9\u0bcd\u0ba9\u0baa\u0bcd\u0baa\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "04 Ymma Cross Rd, Sri Lanka": {
    si: "04 Ymma \u0dc4\u0dbb\u0dc3\u0dca \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "04 Ymma Cross Rd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "06 A6, Polgahawela, Sri Lanka": {
    si: "06 A6, \u0db4\u0ddc\u0dbd\u0dca\u0d9c\u0dc4\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "06 A6, \u0baa\u0bca\u0bb2\u0bcd\u0b95\u0bb9\u0bb5\u0bc6\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "06 South, Colombo, Sri Lanka": {
    si: "06 \u0daf\u0d9a\u0dd4\u0dab, \u0d9a\u0ddc\u0dc5\u0db9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "06 \u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "07, Tissa Road, Ambalanthota": {
    si: "07, \u0dad\u0dd2\u0dc3\u0dca\u0dc3 \u0db4\u0dcf\u0dbb, \u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0dad\u0ddc\u0da7",
    ta: "07, \u0ba4\u0bbf\u0bb8\u0bcd\u0bb8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8",
  },
  "09, JAYAMAWATHA, HIRIPITIYAWA, Galnewa, Sri Lanka": {
    si: "09, \u0da2\u0dba\u0db8\u0dcf\u0dc0\u0dad, \u0dc4\u0dd2\u0dbb\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba\u0dcf\u0dc0, \u0d9c\u0dbd\u0dca\u0db1\u0dd1\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "09, \u0b9c\u0baf\u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0bb9\u0bbf\u0bb0\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0bb5\u0bbe, \u0b95\u0bb2\u0bcd\u0ba9\u0bc7\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "1    , Badulla, Sri Lanka": {
    si: "1, \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "1, \u0baa\u0ba4\u0bc1\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "1 A26, Karalliyadda, Sri Lanka": {
    si: "1 A26, \u0d9a\u0dbb\u0dbd\u0dca\u0dbd\u0dd2\u0dba\u0daf\u0dca\u0daf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "1 A26, \u0b95\u0bb0\u0bb2\u0bcd\u0bb2\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "1 Avissawella Rd, Pannipitiya 10230, Sri Lanka": {
    si: "1 \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba 10230, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "1 \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf 10230, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "1 High Level Rd, Hanwella, Sri Lanka": {
    si: "1 \u0dc4\u0dba\u0dd2\u0dbd\u0dd9\u0dc0\u0dbd\u0dca \u0db4\u0dcf\u0dbb, \u0dc4\u0d82\u0dc0\u0dd0\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "1 \u0b89\u0baf\u0bb0\u0bcd\u0ba8\u0bbf\u0bb2\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb9\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "1 Kandy Rd, Kiribathgoda 11600, Sri Lanka": {
    si: "1 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0dd2\u0dbb\u0dd2\u0db6\u0dad\u0dca\u0d9c\u0ddc\u0da9 11600, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "1 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0b95\u0bbf\u0bb0\u0bbf\u0baa\u0ba4\u0bcd\u0b95\u0bca\u0b9f 11600, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "1 Old Batticaloa Rd, Mutur, Sri Lanka": {
    si: "1 \u0db4\u0dd0\u0dbb\u0dab\u0dd2 \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4 \u0db4\u0dcf\u0dbb, \u0db8\u0dd4\u0dad\u0dd6\u0dbb\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "1 \u0baa\u0bb4\u0bc8\u0baf \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bc2\u0ba4\u0bc2\u0bb0\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "1 Samurdhi Mawatha, Heiyanthuduwa, Sri Lanka": {
    si: "1 \u0dc3\u0db8\u0dd8\u0daf\u0dca\u0db0\u0dd2 \u0db8\u0dcf\u0dc0\u0dad, \u0dc4\u0dd9\u0dba\u0dd2\u0dba\u0db1\u0dca\u0dad\u0dd4\u0da9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "1 \u0b9a\u0bae\u0bc1\u0bb0\u0bcd\u0ba4\u0bcd\u0ba4\u0bbf \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0bb9\u0bc6\u0baf\u0bcd\u0baf\u0ba9\u0bcd\u0ba4\u0bc1\u0b9f\u0bc1\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "1 Sri Sumanatissa Mawatha, Colombo 01300, Sri Lanka": {
    si: "1 \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dc3\u0dd4\u0db8\u0db1\u0dad\u0dd2\u0dc3\u0dca\u0dc3 \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 01300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "1 \u0bb8\u0bcd\u0bb0\u0bc0 \u0b9a\u0bc1\u0bae\u0ba9\u0ba4\u0bbf\u0bb8\u0bcd\u0bb8 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 01300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "1 st floor , Namal filling station, Galle 80000, Sri Lanka": {
    si: "1 \u0dc0\u0db1 \u0db8\u0dc4\u0dbd, \u0db1\u0dcf\u0db8\u0dbd\u0dca \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd 80000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "1 \u0bb5\u0ba4\u0bc1 \u0ba4\u0bb3\u0bae\u0bcd, \u0ba8\u0bbe\u0bae\u0bb2\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0bbe\u0bb2\u0bbf 80000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "10 A6, Trincomalee, Sri Lanka": {
    si: "10 A6, \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "10 A6, \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "10 Hirimbura Cross Rd, Galle 80000, Sri Lanka": {
    si: "10 \u0dc4\u0dd2\u0dbb\u0dd2\u0db9\u0dd4\u0dbb \u0dc4\u0dbb\u0dc3\u0dca \u0db4\u0dcf\u0dbb, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd 80000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "10 \u0bb9\u0bbf\u0bb0\u0bbf\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bbe \u0b95\u0bbf\u0bb0\u0bbe\u0bb8\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1, \u0b95\u0bbe\u0bb2\u0bbf 80000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "10 Kandy Rd, Kadawatha, Sri Lanka": {
    si: "10 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0da9\u0dc0\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "10 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0b95\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "10 Mangala Road, Gampaha, Sri Lanka": {
    si: "10 \u0db8\u0d82\u0d9c\u0dbd \u0db4\u0dcf\u0dbb, \u0d9c\u0db8\u0dca\u0db4\u0dc4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "10 \u0bae\u0b99\u0bcd\u0b95\u0bb3 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "10, New Kandy Rd, Weliweriya": {
    si: "10, \u0db1\u0dc0 \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dc0\u0dd0\u0dbd\u0dd2\u0dc0\u0dda\u0dbb\u0dd2\u0dba",
    ta: "10, \u0baa\u0bc1\u0ba4\u0bbf\u0baf \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bc6\u0bb2\u0bbf\u0bb5\u0bc7\u0bb0\u0bbf\u0baf",
  },
  "100 B143, Batapola, Sri Lanka": {
    si: "100 B143, \u0db6\u0da7\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "100 B143, \u0baa\u0b9f\u0baa\u0bca\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "100 Mankuliya Rd, Negombo, Sri Lanka": {
    si: "100 \u0db8\u0d82\u0d9a\u0dd4\u0dbd\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "100 \u0bae\u0bbe\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bbf\u0baf \u0b9a\u0bbe\u0bb2\u0bc8, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "100 Pallimunai Rd, Mannar, Sri Lanka": {
    si: "100 \u0db4\u0dbd\u0dca\u0dbd\u0dd2\u0db8\u0dd4\u0db1\u0dd9\u0dba\u0dd2 \u0db4\u0dcf\u0dbb, \u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "100 \u0baa\u0bb3\u0bcd\u0bb3\u0bbf\u0bae\u0bc1\u0ba9\u0bc8 \u0bb0\u0bcb\u0b9f\u0bc1, \u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "101 Rajapakse Broadway, Negombo, Sri Lanka": {
    si: "101 \u0dbb\u0dcf\u0da2\u0db4\u0d9a\u0dca\u0dc2 \u0db6\u0dca\u200d\u0dbb\u0ddd\u0da9\u0dca\u0dc0\u0dda, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "101 \u0bb0\u0bbe\u0b9c\u0baa\u0b95\u0bcd\u0b9a\u0bc7 \u0baa\u0bbf\u0bb0\u0bbe\u0b9f\u0bcd\u0bb5\u0bc7, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "102 Colombo - Ratnapura - Wellawaya - Batticaloa Rd, Colombo 00500, Sri Lanka":
    {
      si: "102 \u0d9a\u0ddc\u0dc5\u0db9 - \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb - \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4 \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0dc5\u0db9 00500, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "102 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf - \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00500, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "103 Negombo Rd, Ja-Ela, Sri Lanka": {
    si: "103 \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0da2\u0dcf-\u0d87\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "103 \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b9c\u0bbe-\u0b8e\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "103/1/B High Level Rd, Pannipitiya 10230, Sri Lanka": {
    si: "103/1/B \u0dc4\u0dba\u0dd2\u0dbd\u0dd9\u0dc0\u0dbd\u0dca \u0db4\u0dcf\u0dbb, \u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba 10230, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "103/1/B \u0b89\u0baf\u0bb0\u0bcd \u0bae\u0b9f\u0bcd\u0b9f \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf 10230, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "105 Pannala-Kuliyapitiya Rd, Sri Lanka": {
    si: "105 \u0db4\u0db1\u0dca\u0db1\u0dbd-\u0d9a\u0dd4\u0dbd\u0dd2\u0dba\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "105 \u0baa\u0ba9\u0bcd\u0ba9\u0bb2-\u0b95\u0bc1\u0bb2\u0bbf\u0baf\u0bbe\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0b9a\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "105, 1 Kandy Rd, Kiribathgoda": {
    si: "105, 1 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0dd2\u0dbb\u0dd2\u0db6\u0dad\u0dca\u0d9c\u0ddc\u0da9",
    ta: "105, 1 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0b95\u0bbf\u0bb0\u0bbf\u0baa\u0ba4\u0bcd\u0b95\u0bca\u0b9f",
  },
  "105A Dickson Moters Rd, Kurunegala, Sri Lanka": {
    si: "105A \u0da9\u0dd2\u0d9a\u0dca\u0dc3\u0db1\u0dca \u0db8\u0ddd\u0da7\u0dbb\u0dca\u0dc3\u0dca \u0db4\u0dcf\u0dbb, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "105A \u0b9f\u0bbf\u0b95\u0bcd\u0b9a\u0ba9\u0bcd \u0bae\u0bcb\u0b9f\u0bcd\u0b9f\u0bb0\u0bcd\u0bb8\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "106, Negombo Rd, Katuwellegama": {
    si: "106, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0d9a\u0da7\u0dd4\u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dda\u0d9c\u0db8",
    ta: "106, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bc7\u0b95\u0bae",
  },
  "1069 A9, Sri Lanka": {
    si: "1069 A9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "1069 A9, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "107 Kandy Rd, Vavuniya, Sri Lanka": {
    si: "107 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "107 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "108 Colombo - Horana Rd, Polgasowita": {
    si: "108 \u0d9a\u0ddc\u0dc5\u0db9 - \u0dc4\u0ddc\u0dbb\u0dab \u0db4\u0dcf\u0dbb, \u0db4\u0ddc\u0dbd\u0dca\u0d9c\u0dc3\u0dca\u0d95\u0dc0\u0dd2\u0da7",
    ta: "108 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bb9\u0bca\u0bb0\u0ba3 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bca\u0bb2\u0bcd\u0b95\u0b9a\u0bcb\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f",
  },
  "108-17 Kandy Rd, Nawalapitiya": {
    si: "108-17 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0db1\u0dcf\u0dc0\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "108-17 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bbe\u0bb5\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf",
  },
  "110 Sir James Pieris Mawatha, Colombo - 02": {
    si: "110 \u0dc1\u0dca\u200d\u0dbb\u0dd3\u0db8\u0dad\u0dca \u0da2\u0dda\u0db8\u0dca\u0dc3\u0dca \u0db4\u0dd3\u0dbb\u0dd2\u0dc3\u0dca \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 - 02",
    ta: "110 \u0b9a\u0bb0\u0bcd \u0b9c\u0bc7\u0bae\u0bcd\u0bb8\u0bcd \u0baa\u0bc0\u0bb0\u0bbf\u0bb8\u0bcd \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - 02",
  },
  "110a Colombo - Kandy Rd, Kiribathgoda 11300, Sri Lanka": {
    si: "110a \u0d9a\u0ddc\u0dc5\u0db9 - \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0dd2\u0dbb\u0dd2\u0db6\u0dad\u0dca\u0d9c\u0ddc\u0da9 11300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "110a \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0b95\u0bbf\u0bb0\u0bbf\u0baa\u0ba4\u0bcd\u0b95\u0bca\u0b9f 11300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "111 1st Cross St, Colombo 01100, Sri Lanka": {
    si: "111 1 \u0dc0\u0db1 \u0dc4\u0dbb\u0dc3\u0dca \u0dc1\u0dcf\u0db1\u0dca\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 01100, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "111 1\u0bb5\u0ba4\u0bc1 \u0b95\u0bc1\u0bb1\u0bc1\u0b95\u0bcd\u0b95\u0bc1, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 01100, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "111 B239, Pannipitiya, Sri Lanka": {
    si: "111 B239, \u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "111 B239, \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "111 Negombo Rd, Peliyagoda": {
    si: "111 \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9",
    ta: "111 \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc7\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f",
  },
  "112 AB44, Nawa Madagama, Sri Lanka": {
    si: "112 AB44, \u0db1\u0dc0 \u0db8\u0dd0\u0daf\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "112 AB44, \u0ba8\u0bb5\u0bbe \u0bae\u0b9f\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "112 Ab44, Nawa Madagama Deiattakandiya": {
    si: "112 Ab44, \u0db1\u0dc0 \u0db8\u0dd0\u0daf\u0d9c\u0db8 \u0daf\u0dd9\u0dba\u0dd2\u0d85\u0dad\u0dca\u0dad\u0d9a\u0dab\u0dca\u0da9\u0dd2\u0dba",
    ta: "112 Ab44, \u0ba8\u0bb5 \u0bae\u0b9f\u0b95\u0bae \u0b9f\u0bc0\u0b85\u0b9f\u0bcd\u0b9f\u0b95\u0ba3\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "112 Kandy - Jaffna Hwy, Matale": {
    si: "112 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb - \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0db8\u0dcf\u0dad\u0dbd\u0dda",
    ta: "112 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf - \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8",
  },
  "116 Pamunugama Rd, Bopitiya, Sri Lanka": {
    si: "116 \u0db4\u0db8\u0dd4\u0dab\u0dd4\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0db6\u0ddd\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "116 \u0baa\u0bae\u0bc1\u0ba9\u0bc1\u0b95\u0bae \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0bcb\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "117 Karamettiya Kandakettiya Road, Karametiya, Sri Lanka": {
    si: "117 \u0d9a\u0dbb\u0db8\u0dd0\u0da7\u0dca\u0da7\u0dd2\u0dba \u0d9a\u0db1\u0dca\u0daf\u0d9a\u0dd0\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0d9a\u0dbb\u0db8\u0dd0\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "117 \u0b95\u0bb0\u0bae\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0b95\u0ba8\u0bcd\u0ba4\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb0\u0bae\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "119 Peradeniya Rd, Kandy": {
    si: "119 \u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb",
    ta: "119 \u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf",
  },
  "119 Peradeniya Rd, Kandy 20000, Sri Lanka": {
    si: "119 \u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb 20000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "119 \u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf 20000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "12 Galle Rd, Ahungalla": {
    si: "12 \u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0d85\u0dc4\u0dd4\u0db1\u0dca\u0d9c\u0dbd\u0dca\u0dbd",
    ta: "12 \u0b95\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0bb9\u0bc1\u0b99\u0bcd\u0b95\u0bb2\u0bcd\u0bb2",
  },
  "12 Galle Rd, Ahungalla, Sri Lanka": {
    si: "12 \u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0d85\u0dc4\u0dd4\u0db1\u0dca\u0d9c\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "12 \u0b95\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0bb9\u0bc1\u0b99\u0bcd\u0b95\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "120 B413, Rikillagaskada, Sri Lanka": {
    si: "120 \u0db6\u0dd3 413, \u0dbb\u0dd2\u0d9a\u0dd2\u0dbd\u0dca\u0dbd\u0d9c\u0dc3\u0dca\u0d9a\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "120 B413, \u0bb0\u0bbf\u0b95\u0bbf\u0bb2\u0bcd\u0bb2\u0b95\u0bb8\u0bcd\u0b95\u0b9f, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "121 Negombo - Giriulla Rd, Katana, Sri Lanka": {
    si: "121 \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 - \u0d9c\u0dd2\u0dbb\u0dd2\u0d8b\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d9a\u0da7\u0dcf\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "121 \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0b9f\u0bcd\u0b9f\u0bbe\u0ba9, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "121Th Km Post, Galkulama, Sri Lanka": {
    si: "121 \u0dc0\u0dd0\u0db1\u0dd2 \u0d9a\u0dd2\u0dbd\u0ddd\u0db8\u0dd3\u0da7\u0dbb\u0dca \u0d9a\u0dab\u0dd4\u0dc0, \u0d9c\u0dbd\u0dca\u0d9a\u0dd4\u0dbd\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "121\u0bb5\u0ba4\u0bc1 \u0b95\u0bbf\u0bae\u0bc0 \u0b85\u0b9e\u0bcd\u0b9a\u0bb2\u0bcd, \u0b95\u0bb2\u0bcd\u0b95\u0bc1\u0bb2\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "122 Avissawella Rd, Maharagama": {
    si: "122 \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0dbb\u0d9c\u0db8",
    ta: "122 \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bb9\u0bb0\u0b95\u0bae",
  },
  "122 Avissawella Rd, Maharagama 10280, Sri Lanka": {
    si: "122 \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0dbb\u0d9c\u0db8 10280, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "122 \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 \u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0b95\u0bb0\u0b95\u0bae 10280, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "122 Kegalle Bypass Rd, Kegalle, Sri Lanka": {
    si: "122 \u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd \u0db6\u0dba\u0dd2\u0db4\u0dcf\u0dc3\u0dca \u0db4\u0dcf\u0dbb, \u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "122 \u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8 \u0baa\u0bc8\u0baa\u0bbe\u0bb8\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "122 Negombo Rd, Peliyagoda, Sri Lanka": {
    si: "122 \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "122 \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0bc7\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "13 Point Pedro East Coast Rd, Point Pedro, Sri Lanka": {
    si: "13 \u0db4\u0dda\u0daf\u0dd4\u0dbb\u0dd4\u0dad\u0dd4\u0da9\u0dd4\u0dc0 \u0db1\u0dd0\u0d9c\u0dd9\u0db1\u0dc4\u0dd2\u0dbb \u0dc0\u0dd9\u0dbb\u0dc5 \u0dad\u0dd3\u0dbb\u0dba, \u0db4\u0dda\u0daf\u0dd4\u0dbb\u0dd4\u0dad\u0dd4\u0da9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "13 \u0baa\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8 \u0b95\u0bbf\u0bb4\u0b95\u0bcd\u0b95\u0bc1 \u0b95\u0b9f\u0bb1\u0bcd\u0b95\u0bb0\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "130 A2, Dehiwala-Mount Lavinia": {
    si: "130 A2, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd - \u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3",
    ta: "130 A2, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8-\u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8",
  },
  "130 A2, Dehiwala-Mount Lavinia, Sri Lanka": {
    si: "130 A2, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd-\u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "130 A2, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8-\u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "130c Colombo - Horana Rd, Piliyandala, Sri Lanka": {
    si: "130c \u0d9a\u0ddc\u0dc5\u0db9 - \u0dc4\u0ddc\u0dbb\u0dab \u0db4\u0dcf\u0dbb, \u0db4\u0dd2\u0dc5\u0dd2\u0dba\u0db1\u0dca\u0daf\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "130c \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bb9\u0bca\u0bb0\u0ba3 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bbf\u0bb2\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "1322, Kankesanthurai, Road, Kokkuvil": {
    si: "1322, \u0d9a\u0db1\u0dca\u0d9a\u0dc3\u0db1\u0dca\u0dad\u0dd4\u0dbb\u0dda, \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0d9a\u0dca\u0d9a\u0dd4\u0dc0\u0dd2\u0dbd\u0dca",
    ta: "1322, \u0b95\u0bbe\u0b99\u0bcd\u0b95\u0bc7\u0b9a\u0ba9\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bca\u0b95\u0bcd\u0b95\u0bc1\u0bb5\u0bbf\u0bb2\u0bcd",
  },
  "133 Stace Rd, Colombo, Sri Lanka": {
    si: "133 \u0dc3\u0dca\u0da7\u0dda\u0dc3\u0dca \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0dc5\u0db9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "133 Stace Rd, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "134 Avissawella Rd, Maharagama": {
    si: "134 \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0dbb\u0d9c\u0db8",
    ta: "134 \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bb9\u0bb0\u0b95\u0bae",
  },
  "134 High Level Rd, Maharagama 10280, Sri Lanka": {
    si: "134 \u0dc4\u0dba\u0dd2\u0dbd\u0dd9\u0dc0\u0dbd\u0dca \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0dbb\u0d9c\u0db8 10280, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "134 \u0b89\u0baf\u0bb0\u0bcd \u0bae\u0b9f\u0bcd\u0b9f \u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0bb9\u0bb0\u0b95\u0bae 10280, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "136, Nuwaraeliya Road, Dalpitiya Atabage": {
    si: "136, \u0db1\u0dd4\u0dc0\u0dbb\u0d91\u0dc5\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0daf\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0d85\u0da7\u0db6\u0dcf\u0d9c\u0dda",
    ta: "136, \u0ba8\u0bc1\u0bb5\u0bb0\u0bc6\u0bb2\u0bbf\u0baf\u0bbe \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0b85\u0b9f\u0bcd\u0b9f\u0baa\u0bbe\u0b95\u0bc7",
  },
  "137 Talawa Rd, Eppawala": {
    si: "137 \u0dad\u0dbd\u0dcf\u0dc0 \u0db4\u0dcf\u0dbb, \u0d91\u0db4\u0dca\u0db4\u0dcf\u0dc0\u0dbd",
    ta: "137 \u0ba4\u0bb2\u0bb5\u0bbe \u0bb5\u0bc0\u0ba4\u0bbf, \u0b8e\u0baa\u0bcd\u0baa\u0bbe\u0bb5\u0bb2",
  },
  "137 Talawa Rd, Eppawala, Sri Lanka": {
    si: "137 \u0dad\u0dbd\u0dcf\u0dc0 \u0db4\u0dcf\u0dbb, \u0d91\u0db4\u0dca\u0db4\u0dcf\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "137 \u0ba4\u0bb2\u0bb5\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0b8e\u0baa\u0bcd\u0baa\u0bbe\u0bb5\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "138 A4, Colombo 00500, Sri Lanka": {
    si: "138 A4, \u0d9a\u0ddc\u0dc5\u0db9 00500, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "138 A4, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00500, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "139/1 Anagarika Dharmapala Mawatha, Matara, Sri Lanka": {
    si: "139/1 \u0d85\u0db1\u0d9c\u0dcf\u0dbb\u0dd2\u0d9a \u0db0\u0dbb\u0dca\u0db8\u0db4\u0dcf\u0dbd \u0db8\u0dcf\u0dc0\u0dad, \u0db8\u0dcf\u0dad\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "139/1 \u0b85\u0ba9\u0b95\u0bbe\u0bb0\u0bbf\u0b95 \u0ba4\u0bb0\u0bcd\u0bae\u0baa\u0bbe\u0bb2 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "14 Nittambuwa - Ruwanwella Rd, Ruwanwella, Sri Lanka": {
    si: "14 \u0db1\u0dd2\u0da7\u0dca\u0da7\u0db9\u0dd4\u0dc0 - \u0dbb\u0dd4\u0dc0\u0db1\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0dbb\u0dd4\u0dc0\u0db1\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "14 \u0ba8\u0bbf\u0b9f\u0bcd\u0b9f\u0bae\u0bcd\u0baa\u0bc1\u0bb5 - \u0bb0\u0bc1\u0bb5\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb0\u0bc1\u0bb5\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "140 Avissawella Rd, Homagama": {
    si: "140 \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0dc4\u0ddd\u0db8\u0dcf\u0d9c\u0db8",
    ta: "140 \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0bcb\u0bae\u0bbe\u0b95\u0bae",
  },
  "143 E L Senanayake Veediya, Kandy, Sri Lanka": {
    si: "143 \u0d8a \u0d91\u0dbd\u0dca \u0dc3\u0dda\u0db1\u0dcf\u0db1\u0dcf\u0dba\u0d9a \u0dc0\u0dd3\u0daf\u0dd2\u0dba, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "143 \u0b87 \u0b8e\u0bb2\u0bcd \u0b9a\u0bc7\u0ba9\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "143 Negombo-colombo Main Rd, Ja-ela": {
    si: "143 \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0-\u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0da2\u0dcf-\u0d87\u0dbd",
    ta: "143 \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1-\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b9c\u0bbe-\u0b8e\u0bb2",
  },
  "144 Katugastota-Kurunegala-Puttalam Highway, Kurunegala, Sri Lanka": {
    si: "144 \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7-\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd-\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "144 \u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8-\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd-\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "147 Avissawella Rd, Pannipitiya": {
    si: "147 \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "147 \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "147 Kandy Rd, Gampola 20500, Sri Lanka": {
    si: "147 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9c\u0db8\u0dca\u0db4\u0ddc\u0dbd 20500, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "147 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bae\u0bcd\u0baa\u0bb3\u0bc8 20500, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "148 A2, Dehiwala-Mount Lavinia, Sri Lanka": {
    si: "148 A2, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd-\u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "148 A2, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8-\u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "148 High Level Rd, Nugegoda 10250, Sri Lanka": {
    si: "148 High level Rd, Nugegoda 10250, Sri Lanka",
    ta: "148 \u0b89\u0baf\u0bb0\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0ba8\u0bc1\u0b95\u0bc7\u0b95\u0bca\u0b9f 10250, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "148 Sri Bodhi Rd, Gampaha, Sri Lanka": {
    si: "148 \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0db6\u0ddd\u0db0\u0dd2 \u0db4\u0dcf\u0dbb, \u0d9c\u0db8\u0dca\u0db4\u0dc4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "148 \u0bb8\u0bcd\u0bb0\u0bc0 \u0baa\u0bcb\u0ba4\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "148/12, Pahala Hanwella, Hanwella": {
    si: "148/12, \u0db4\u0dc4\u0dc5 \u0dc4\u0d82\u0dc0\u0dd0\u0dbd\u0dca\u0dbd, \u0dc4\u0d82\u0dc0\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "148/12, \u0baa\u0bb9\u0bb2 \u0bb9\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2, \u0bb9\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2",
  },
  "151 Jayanthi Mawatha, Anuradhapura 50000, Sri Lanka": {
    si: "151 \u0da2\u0dba\u0db1\u0dca\u0dad\u0dd2 \u0db8\u0dcf\u0dc0\u0dad, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb 50000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "151 \u0b9c\u0bc6\u0baf\u0ba8\u0bcd\u0ba4\u0bbf \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd 50000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "151, New Kandy Rd": {
    si: "151, \u0db1\u0dc0 \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb",
    ta: "151, \u0baa\u0bc1\u0ba4\u0bbf\u0baf \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1",
  },
  "151a Jayanthi Mawatha, Anuradhapura": {
    si: "151a \u0da2\u0dba\u0db1\u0dca\u0dad\u0dd2 \u0db8\u0dcf\u0dc0\u0dad, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb",
    ta: "151a \u0b9c\u0bc6\u0baf\u0ba8\u0bcd\u0ba4\u0bbf \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd",
  },
  "153 B235, Moratuwa, Sri Lanka": {
    si: "153 B235, \u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "153 B235, \u0bae\u0bca\u0bb0\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "153 Kasthuriyar Rd, Jaffna, Sri Lanka": {
    si: "153 \u0d9a\u0dc3\u0dca\u0dad\u0dd4\u0dbb\u0dd2\u0dba\u0dbb\u0dca \u0db4\u0dcf\u0dbb, \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "153 \u0b95\u0bb8\u0bcd\u0ba4\u0bc2\u0bb0\u0bbf\u0baf\u0bbe\u0bb0\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "16 B419, Sri Lanka": {
    si: "16 \u0db6\u0dd3 419, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "16 B419, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "16 Haragama Rd, Rikillagaskada, Sri Lanka": {
    si: "16 \u0dc4\u0dcf\u0dbb\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0dbb\u0dd2\u0d9a\u0dd2\u0dbd\u0dca\u0dbd\u0d9c\u0dc3\u0dca\u0d9a\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "16 \u0bb9\u0bb0\u0b95\u0bae\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb0\u0bbf\u0b95\u0bbf\u0bb2\u0bcd\u0bb2\u0b95\u0bb8\u0bcd\u0b95\u0b9f, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "16/1/1, Kandy-Jaffna Highway, Matale, Sri Lanka": {
    si: "16/1/1, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb-\u0dba\u0dcf\u0db4\u0db1\u0dba \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0db8\u0dcf\u0dad\u0dbd\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "16/1/1, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf-\u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "161 Colombo Main Rd, Beruwala": {
    si: "161 \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0db6\u0dda\u0dbb\u0dd4\u0dc0\u0dbd",
    ta: "161 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc7\u0bb0\u0bc1\u0bb5\u0bb3\u0bc8",
  },
  "166 Egodawatta Rd, Chilaw, Sri Lanka": {
    si: "166 \u0d91\u0d9c\u0ddc\u0da9\u0dc0\u0dad\u0dca\u0dad \u0db4\u0dcf\u0dbb, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "166 \u0b8e\u0b95\u0bca\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "16d Jayanthi Mawatha, Anuradhapura, Sri Lanka": {
    si: "16d \u0da2\u0dba\u0db1\u0dca\u0dad\u0dd2 \u0db8\u0dcf\u0dc0\u0dad, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "16d \u0b9c\u0bc6\u0baf\u0ba8\u0bcd\u0ba4\u0bbf \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "17 Ja Ela-Ekala-Gampaha-Yakkala Hwy, Ja-Ela, Sri Lanka": {
    si: "17 \u0da2\u0dcf \u0d87\u0dbd-\u0d92\u0d9a\u0dbd-\u0d9c\u0db8\u0dca\u0db4\u0dc4-\u0dba\u0d9a\u0dca\u0d9a\u0dbd Hwy, \u0da2\u0dcf-\u0d87\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "17 \u0b9c\u0bbe \u0b8e\u0bb2-\u0b8e\u0b95\u0bb2-\u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe-\u0baf\u0b95\u0bcd\u0b95\u0bb2 \u0bb9\u0bc6\u0bb5\u0bbf, \u0b9c\u0bbe-\u0b8e\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "170 High Level Rd, Nugegoda": {
    si: "170 \u0dc4\u0dba\u0dd2\u0dbd\u0dd9\u0dc0\u0dbd\u0dca \u0db4\u0dcf\u0dbb, \u0db1\u0dd4\u0d9c\u0dda\u0d9c\u0ddc\u0da9",
    ta: "170 \u0b89\u0baf\u0bb0\u0bcd \u0bae\u0b9f\u0bcd\u0b9f \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc1\u0b95\u0bc7\u0b95\u0bca\u0b9f",
  },
  "171 Avissawella - Hatton - Nuwara Eliya Hwy, Sri Lanka": {
    si: "171 \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd - \u0dc4\u0dd0\u0da7\u0db1\u0dca - \u0db1\u0dd4\u0dc0\u0dbb\u0d91\u0dc5\u0dd2\u0dba Hwy, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "171 \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 - \u0bb9\u0b9f\u0bcd\u0b9f\u0ba9\u0bcd - \u0ba8\u0bc1\u0bb5\u0bb0\u0bc6\u0bb2\u0bbf\u0baf\u0bbe Hwy, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "171 B247, Kurunegala 60000, Sri Lanka": {
    si: "171 B247, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd 60000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "171 B247, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd 60000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "171 Maya Ave, Colombo 00500, Sri Lanka": {
    si: "171 \u0db8\u0dcf\u0dba\u0dcf \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 00500, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "171 \u0bae\u0bbe\u0baf\u0bbe \u0b85\u0bb5\u0bc7, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00500, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "172 Nawala Rd, Nugegoda": {
    si: "172 \u0db1\u0dcf\u0dc0\u0dbd \u0db4\u0dcf\u0dbb, \u0db1\u0dd4\u0d9c\u0dda\u0d9c\u0ddc\u0da9",
    ta: "172 \u0ba8\u0bbe\u0bb5\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc1\u0b95\u0bc7\u0b95\u0bca\u0b9f",
  },
  "173 Galle Rd, Dehiwala-Mount Lavinia": {
    si: "173 \u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd-\u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3",
    ta: "173 \u0b95\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8-\u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8",
  },
  "173 High Level Rd, Colombo 00500, Sri Lanka": {
    si: "173 \u0dc4\u0dba\u0dd2\u0dbd\u0dd9\u0dc0\u0dbd\u0dca \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0dc5\u0db9 00500, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "173 \u0b89\u0baf\u0bb0\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00500, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "173a Galle Rd, Beruwala, Sri Lanka": {
    si: "173a \u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0db6\u0dda\u0dbb\u0dd4\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "173a \u0b95\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc7\u0bb0\u0bc1\u0bb5\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "174 Nawala Rd, Sri Jayawardenepura Kotte 11222, Sri Lanka": {
    si: "174 \u0db1\u0dcf\u0dc0\u0dbd \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1\u0db4\u0dd4\u0dbb \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda 11222, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "174 \u0ba8\u0bbe\u0bb5\u0bb2 \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb8\u0bcd\u0bb0\u0bc0 \u0b9c\u0bc6\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0baa\u0bc1\u0bb0 \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7 11222, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "177 Colombo - Batticaloa Hwy, Balangoda": {
    si: "177 \u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 Hwy, \u0db6\u0dbd\u0d82\u0d9c\u0ddc\u0da9",
    ta: "177 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bc8",
  },
  "18 Beragama Road, Ambalantota, Sri Lanka": {
    si: "18 \u0db6\u0dd9\u0dbb\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0dad\u0ddc\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "18 \u0baa\u0bc6\u0bb0\u0b95\u0bae \u0b9a\u0bbe\u0bb2\u0bc8, \u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "180 Kurunegala-Narammala-Madampe Rd, Galahitiyawa, Sri Lanka": {
    si: "180 \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd-\u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd-\u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda \u0db4\u0dcf\u0dbb, \u0d9c\u0dbd\u0dc4\u0dd2\u0da7\u0dd2\u0dba\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "180 \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd-\u0ba8\u0bbe\u0bb0\u0bae\u0bcd\u0bae\u0bb2-\u0bae\u0b9f\u0bae\u0bcd\u0baa\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb2\u0bbe\u0bb9\u0bbf\u0ba4\u0bbf\u0baf\u0bbe\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "181 High Level Rd, Nugegoda 10250, Sri Lanka": {
    si: "181 \u0dc4\u0dba\u0dd2\u0dbd\u0dd9\u0dc0\u0dbd\u0dca \u0db4\u0dcf\u0dbb, \u0db1\u0dd4\u0d9c\u0dda\u0d9c\u0ddc\u0da9 10250, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "181 \u0b89\u0baf\u0bb0\u0bcd \u0bae\u0b9f\u0bcd\u0b9f \u0b9a\u0bbe\u0bb2\u0bc8, \u0ba8\u0bc1\u0b95\u0bc7\u0b95\u0bca\u0b9f 10250, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "186 Outer Circular Rd, Puttalam, Sri Lanka": {
    si: "186 \u0db4\u0dd2\u0da7\u0dad \u0dc0\u0da7\u0dbb\u0dc0\u0dd4\u0db8\u0dca \u0db4\u0dcf\u0dbb, \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "186 \u0bb5\u0bc6\u0bb3\u0bbf \u0bb5\u0b9f\u0bcd\u0b9f\u0baa\u0bcd \u0baa\u0bbe\u0ba4\u0bc8, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "187 A9, Akurana, Sri Lanka": {
    si: "187 A9, \u0d85\u0d9a\u0dd4\u0dbb\u0dab, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "187 A9, \u0b85\u0b95\u0bcd\u0b95\u0bc1\u0bb0\u0ba3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "188A Ja Ela-Ekala-Gampaha-Yakkala Hwy, Gampaha, Sri Lanka": {
    si: "188A \u0da2\u0dcf \u0d87\u0dbd-\u0d92\u0d9a\u0dbd-\u0d9c\u0db8\u0dca\u0db4\u0dc4-\u0dba\u0d9a\u0dca\u0d9a\u0dbd \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0d9c\u0db8\u0dca\u0db4\u0dc4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "188A \u0b9c\u0bbe \u0b8e\u0bb2-\u0b8e\u0b95\u0bb2-\u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe-\u0baf\u0b95\u0bcd\u0b95\u0bb2\u0bbe \u0bb9\u0bc6\u0bb5\u0bbf, \u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "189 Katuwana Rd, Homagama, Sri Lanka": {
    si: "189 \u0d9a\u0da7\u0dd4\u0dc0\u0db1 \u0db4\u0dcf\u0dbb, \u0dc4\u0ddd\u0db8\u0dcf\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "189 \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe\u0ba9 \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb9\u0bcb\u0bae\u0bbe\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "192 Ampara-Uhana-Maha Oya Hwy, Sri Lanka": {
    si: "192 \u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb-\u0d8b\u0dc4\u0db1-\u0db8\u0dc4 \u0d94\u0dba Hwy, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "192 \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8-\u0b89\u0bb9\u0bbe\u0ba9-\u0bae\u0bb9\u0bbe \u0b93\u0baf\u0bbe \u0bb9\u0bc6\u0bb5\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "196 Hokandara - Kottawa Rd, Sri Jayawardenepura Kotte, Sri Lanka": {
    si: "196 \u0dc4\u0ddd\u0d9a\u0db1\u0dca\u0daf\u0dbb - \u0d9a\u0ddc\u0da7\u0dca\u0da7\u0dcf\u0dc0 \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1\u0db4\u0dd4\u0dbb \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "196 \u0bb9\u0bcb\u0b95\u0ba8\u0bcd\u0ba4\u0bb0\u0bbe - \u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0bbe\u0bb5 \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb8\u0bcd\u0bb0\u0bc0 \u0b9c\u0bc6\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0baa\u0bc1\u0bb0 \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "196 Prince Of Wales Ave, Colombo": {
    si: "196 \u0dc0\u0dda\u0dbd\u0dca\u0dc3\u0dca \u0d9a\u0dd4\u0db8\u0dbb \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9",
    ta: "196 \u0b87\u0bb3\u0bb5\u0bb0\u0b9a\u0bb0\u0bcd \u0b86\u0b83\u0baa\u0bcd \u0bb5\u0bc7\u0bb2\u0bcd\u0bb8\u0bcd \u0b8f\u0bb5\u0bcd, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "196 Prince of Wales Ave, Colombo, Sri Lanka": {
    si: "196 \u0dc0\u0dda\u0dbd\u0dca\u0dc3\u0dca \u0d9a\u0dd4\u0db8\u0dbb \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "196 \u0bb5\u0bc7\u0bb2\u0bcd\u0bb8\u0bcd \u0b87\u0bb3\u0bb5\u0bb0\u0b9a\u0bb0\u0bcd \u0b8f\u0bb5\u0bcd, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "1c Sri Sumangala S Rd, Kalutara 12000, Sri Lanka": {
    si: "1c \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dc3\u0dd4\u0db8\u0d82\u0d9c\u0dbd \u0d91\u0dc3\u0dca \u0db4\u0dcf\u0dbb, \u0d9a\u0dc5\u0dd4\u0dad\u0dbb 12000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "1c \u0bb8\u0bcd\u0bb0\u0bc0 \u0b9a\u0bc1\u0bae\u0b99\u0bcd\u0b95\u0bb2\u0bbe S Rd, \u0b95\u0bb3\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8 12000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2 Bandaranaike Mawatha, Nuwara Eliya 22200, Sri Lanka": {
    si: "2 \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0db1\u0dcf\u0dba\u0d9a \u0db8\u0dcf\u0dc0\u0dad, \u0db1\u0dd4\u0dc0\u0dbb\u0d91\u0dc5\u0dd2\u0dba 22200, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2 \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0ba8\u0bc1\u0bb5\u0bb0\u0bc6\u0bb2\u0bbf\u0baf\u0bbe 22200, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2 C.A. Ariyatilaka Mawatha, Matara 81000, Sri Lanka": {
    si: "2 \u0dc3\u0dd3.\u0d92. \u0d86\u0dbb\u0dd2\u0dba\u0dad\u0dd2\u0dbd\u0d9a \u0db8\u0dcf\u0dc0\u0dad, \u0db8\u0dcf\u0dad\u0dbb 81000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2 \u0b9a\u0bbf.\u0b8f. \u0b86\u0bb0\u0bbf\u0baf\u0ba4\u0bbf\u0bb2\u0b95 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8 81000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2 Kandy Rd, Trincomalee 31000, Sri Lanka": {
    si: "2 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba 31000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 31000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2, Havelock Rd, Colombo": {
    si: "2, \u0dc4\u0dd0\u0dc0\u0dca\u0dbd\u0ddc\u0d9a\u0dca \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0dc5\u0db9",
    ta: "2, \u0bb9\u0bc6\u0bb5\u0bcd\u0bb2\u0bbe\u0b95\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "20 AB20, Valvettithurai, Sri Lanka": {
    si: "20 AB20, \u0dc0\u0dd0\u0dbd\u0dca\u0dc0\u0dd0\u0da7\u0dd2\u0dad\u0dd4\u0dbb\u0dd9\u0dba\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "20 AB20, \u0bb5\u0bb2\u0bcd\u0bb5\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "200 Katugastota - Kurunegala - Puttalam Hwy, Kurunegala, Sri Lanka": {
    si: "200 \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 Hwy, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "200 \u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd \u0bb9\u0bc6\u0bb5\u0bbf, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2012 Katunayake - Veyangoda Rd, Veyangoda": {
    si: "2012 \u0d9a\u0da7\u0dd4\u0db1\u0dcf\u0dba\u0d9a - \u0dc0\u0dda\u0dba\u0db1\u0dca\u0d9c\u0ddc\u0da9 \u0db4\u0dcf\u0dbb, \u0dc0\u0dda\u0dba\u0db1\u0dca\u0d9c\u0ddc\u0da9",
    ta: "2012 \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 - \u0bb5\u0bc6\u0baf\u0b99\u0bcd\u0b95\u0bca\u0b9f \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bc6\u0baf\u0b99\u0bcd\u0b95\u0bca\u0b9f",
  },
  "2012 Katunayake-Veyangoda Rd, Veyangoda 11100, Sri Lanka": {
    si: "2012 \u0d9a\u0da7\u0dd4\u0db1\u0dcf\u0dba\u0d9a-\u0dc0\u0dda\u0dba\u0db1\u0dca\u0d9c\u0ddc\u0da9 \u0db4\u0dcf\u0dbb, \u0dc0\u0dda\u0dba\u0db1\u0dca\u0d9c\u0ddc\u0da9 11100, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2012 \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95-\u0bb5\u0bc7\u0baf\u0b99\u0bcd\u0b95\u0bca\u0b9f \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bc7\u0baf\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe 11100, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "203 Main St, Kalmunai": {
    si: "203 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc1\u0dcf\u0db1\u0dca\u0dad, \u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda",
    ta: "203 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd, \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8",
  },
  "203 Main Street, Kalmunai 32300, Sri Lanka": {
    si: "203 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc0\u0dd3\u0daf\u0dd2\u0dba, \u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda 32300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "203 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8 32300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "204 Colombo-Galle-Hambantota-Wellawaya Highway Aluthgama A2, Aluthgama, Sri Lanka":
    {
      si: "204 \u0d9a\u0ddc\u0dc5\u0db9-\u0d9c\u0dcf\u0dbd\u0dca\u0dbd-\u0dc4\u0db8\u0dca\u0db6\u0db1\u0dca\u0dad\u0ddc\u0da7-\u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba \u0d85\u0dbd\u0dd4\u0dad\u0dca\u0d9c\u0db8 A2, \u0d85\u0dbd\u0dd4\u0dad\u0dca\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "204 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1-\u0b95\u0bbe\u0bb2\u0bbf-\u0b85\u0bae\u0bcd\u0baa\u0bbe\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8-\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8 \u0b85\u0bb2\u0bc1\u0ba4\u0bcd\u0b95\u0bae A2, \u0b85\u0bb2\u0bc1\u0ba4\u0bcd\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "206 Kandy Rd, Dambulla, Sri Lanka": {
    si: "206 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "206 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "207 Dimutu Mawata, Sri Lanka": {
    si: "207 Dimutu Mawata, Sri Lanka",
    ta: "207 Dimutu Mawata, Sri Lanka",
  },
  "207/04/16, Wilimbula, Henegama": {
    si: "207/04/16, \u0dc0\u0dd2\u0dbd\u0dd2\u0db9\u0dd4\u0dbd, \u0dc4\u0dda\u0db1\u0dda\u0d9c\u0db8",
    ta: "207/04/16, \u0bb5\u0bbf\u0bb2\u0bbf\u0bae\u0bcd\u0baa\u0bc1\u0bb2, \u0bb9\u0bc6\u0ba9\u0bc7\u0b95\u0bae",
  },
  "21 Mahathma Gandhi Rd, Jaffna, Sri Lanka": {
    si: "21 \u0db8\u0dc4\u0dad\u0dca\u0db8\u0dcf \u0d9c\u0dcf\u0db1\u0dca\u0db0\u0dd2 \u0db4\u0dcf\u0dbb, \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "21 \u0bae\u0b95\u0bbe\u0ba4\u0bcd\u0bae\u0bbe \u0b95\u0bbe\u0ba8\u0bcd\u0ba4\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "213 Main St, Kalmunai": {
    si: "213 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc1\u0dcf\u0db1\u0dca\u0dad, \u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda",
    ta: "213 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd, \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8",
  },
  "22 Panama Rd, Pottuvil, Sri Lanka": {
    si: "22 \u0db4\u0dcf\u0db1\u0db8 \u0db4\u0dcf\u0dbb, \u0db4\u0ddc\u0dad\u0dd4\u0dc0\u0dd2\u0dbd\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "22 \u0baa\u0ba9\u0bbe\u0bae\u0bbe \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bca\u0ba4\u0bcd\u0ba4\u0bc1\u0bb5\u0bbf\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "220 A10, Pellandeniya, Sri Lanka": {
    si: "220 A10, \u0db4\u0dd0\u0dbd\u0dca\u0dbd\u0db1\u0dca\u0daf\u0dd9\u0dab\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "220 A10, Pellandeniya, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "220-196 Mahiyangana Rd, Badulla": {
    si: "220-196 \u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1 \u0db4\u0dcf\u0dbb, \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "220-196 \u0bae\u0bb9\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0ba9\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0ba4\u0bc1\u0bb3\u0bc8",
  },
  "224 Hettipola Rd, Kuliyapitiya 60200, Sri Lanka": {
    si: "224 \u0dc4\u0dd9\u0da7\u0dca\u0da7\u0dd2\u0db4\u0ddc\u0dbd \u0db4\u0dcf\u0dbb, \u0d9a\u0dd4\u0dbd\u0dd2\u0dba\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba 60200, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "224 Hettipola Rd, Kuliyapitiya 60200, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "225 Galle Rd, Moratuwa 10400, Sri Lanka": {
    si: "225 \u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0 10400, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "225 \u0b95\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bca\u0bb0\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe 10400, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2253 Port Access Road, Dondra, Sri Lanka": {
    si: "2253 \u0dc0\u0dbb\u0dcf\u0dba \u0db4\u0dd2\u0dc0\u0dd2\u0dc3\u0dd4\u0db8\u0dca \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0daf\u0dd9\u0dc0\u0dd4\u0db1\u0dca\u0daf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2253 \u0ba4\u0bc1\u0bb1\u0bc8\u0bae\u0bc1\u0b95 \u0b85\u0ba3\u0bc1\u0b95\u0bb2\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0b9f\u0bcb\u0ba3\u0bcd\u0b9f\u0bcd\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "226F+PM8, New Kandy Rd, Sri Lanka": {
    si: "226F+PM8, \u0db1\u0dc0 \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "226F+PM8, New Kandy Rd, Sri Lanka",
  },
  "234 Negombo-Colombo Main Rd, Ja-Ela, Sri Lanka": {
    si: "234 \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0-\u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0da2\u0dcf-\u0d87\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "234 \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1-\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b9c\u0bbe-\u0b8e\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "236 Gannoruwa Road, Sri Lanka": {
    si: "236 \u0d9c\u0db1\u0dca\u0db1\u0ddd\u0dbb\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "236 \u0b95\u0ba9\u0bcd\u0ba9\u0bcb\u0bb0\u0bc1\u0bb5\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "237, Colombo - Batticaloa Hwy, Akkaraipattu": {
    si: "237, \u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 Hwy, \u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0db4\u0dad\u0dca\u0dad\u0dd4\u0dc0",
    ta: "237, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bc8\u0baa\u0bcd\u0baa\u0bb1\u0bcd\u0bb1\u0bc1",
  },
  "23RH+F58, Pulastigama, Sri Lanka": {
    si: "23RH+F58, \u0db4\u0dd4\u0dbd\u0dc3\u0dca\u0dad\u0dd2\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "23RH+F58, \u0baa\u0bc1\u0bb2\u0bb8\u0bcd\u0ba4\u0bbf\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "240 A2, Dehiwala-Mount Lavinia, Sri Lanka": {
    si: "240 A2, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd-\u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "240 A2, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8-\u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "241 Kurunegala - Dambulla Rd, Galewela, Sri Lanka": {
    si: "241 \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d9c\u0dbd\u0dda\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "241 \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bb2\u0bc7\u0bb5\u0bc6\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2423+CJM, Sri Lanka": {
    si: "2423+CJM, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2423+CJM, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "246 Negombo-Colombo Main Rd, Wattala 11300, Sri Lanka": {
    si: "246 \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0-\u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0dc0\u0dad\u0dca\u0dad\u0dbd 11300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "246 \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1-\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8 11300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "248-240 Katugastota-Kurunegala-Puttalam Hwy, Katugastota, Sri Lanka": {
    si: "248-240 \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7-\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd-\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 Hwy, \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "248-240 \u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bbe-\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd-\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd Hwy, \u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "24RF+7MF, Colombo - Kandy Rd, 11730, Sri Lanka": {
    si: "24RF+7MF, \u0d9a\u0ddc\u0dc5\u0db9 - \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, 11730, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "24RF+7MF, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, 11730, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "24VJ+GM6, Sri Lanka": {
    si: "24VJ+GM6, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "24VJ+GM6, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "25   -    , Kotikawatta 10600, Sri Lanka": {
    si: "25 -, \u0d9a\u0ddc\u0da7\u0dd2\u0d9a\u0dcf\u0dc0\u0dad\u0dca\u0dad 10600, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "25 - , \u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8 10600, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "251 Maithripala Senanayake Mawatha, Anuradhapura": {
    si: "251 \u0db8\u0ddb\u0dad\u0dca\u200d\u0dbb\u0dd3\u0db4\u0dcf\u0dbd \u0dc3\u0dda\u0db1\u0dcf\u0db1\u0dcf\u0dba\u0d9a \u0db8\u0dcf\u0dc0\u0dad, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb",
    ta: "251 \u0bae\u0bc8\u0ba4\u0bcd\u0ba4\u0bbf\u0bb0\u0bbf\u0baa\u0bbe\u0bb2 \u0b9a\u0bc7\u0ba9\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd",
  },
  "252 A2, Dehiwala-Mount Lavinia, Sri Lanka": {
    si: "252 A2, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd-\u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "252 A2, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8-\u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "253, Nagoda. Kadana": {
    si: "253, \u0db1\u0dcf\u0d9c\u0ddc\u0da9. \u0d9a\u0daf\u0dcf\u0db1",
    ta: "253, \u0ba8\u0bbe\u0b95\u0bca\u0b9f. \u0b95\u0b9f\u0ba9\u0bbe",
  },
  "253a George R. De Silva Mawatha, Colombo 01300, Sri Lanka": {
    si: "253a \u0da2\u0ddd\u0dbb\u0dca\u0da2\u0dca \u0d86\u0dbb\u0dca \u0daf \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 01300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "253a \u0b9c\u0bcb\u0bb0\u0bcd\u0b9c\u0bcd \u0b86\u0bb0\u0bcd. \u0b9f\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 01300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "255 A1, Pilimathalawa, Sri Lanka": {
    si: "255 A1, \u0db4\u0dd2\u0dc5\u0dd2\u0db8\u0dad\u0dbd\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "255 A1, \u0baa\u0bbf\u0bb2\u0bbf\u0bae\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "257 A2, Dehiwala-Mount Lavinia, Sri Lanka": {
    si: "257 A2, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd-\u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "257 A2, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8-\u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "257 A28, Sri Lanka": {
    si: "257 A28, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "257 A28, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "259 Colombo - Kandy Rd, Warakapola 71600, Sri Lanka": {
    si: "259 \u0d9a\u0ddc\u0dc5\u0db9 - \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dc0\u0dbb\u0d9a\u0dcf\u0db4\u0ddc\u0dbd 71600, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "259 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0bb5\u0bbe\u0bb0\u0b95\u0bcd\u0b95\u0bbe\u0baa\u0bca\u0bb2 71600, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "259 Galle Rd, Galle 80000, Sri Lanka": {
    si: "259 \u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd 80000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "259 Galle Rd, Galle 80000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "25GQ+V27, Amithirigala, Sri Lanka": {
    si: "25GQ+V27, \u0d85\u0db8\u0dd2\u0dad\u0dd2\u0dbb\u0dd2\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "25GQ+V27, \u0b85\u0bae\u0bbf\u0ba4\u0bbf\u0bb0\u0bbf\u0b95\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "25R8+3JV, Madulsima, Sri Lanka": {
    si: "25R8+3JV, \u0db8\u0da9\u0dd4\u0dbd\u0dca\u0dc3\u0dd2\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "25R8+3JV, \u0bae\u0ba4\u0bc1\u0bb2\u0bcd\u0b9a\u0bbf\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "26, Piliyandala Rd, Piliyandala": {
    si: "26, \u0db4\u0dd2\u0dc5\u0dd2\u0dba\u0db1\u0dca\u0daf\u0dbd \u0db4\u0dcf\u0dbb, \u0db4\u0dd2\u0dc5\u0dd2\u0dba\u0db1\u0dca\u0daf\u0dbd",
    ta: "26, \u0baa\u0bbf\u0bb2\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bbf\u0bb2\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bb2\u0bc8",
  },
  "263 Katugastota Rd, Kandy 20000, Sri Lanka": {
    si: "263 \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7 \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb 20000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "263 Katugastota Rd, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf 20000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "264 Galle Rd, Beruwala": {
    si: "264 \u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0db6\u0dda\u0dbb\u0dd4\u0dc0\u0dbd",
    ta: "264 \u0b95\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc7\u0bb0\u0bc1\u0bb5\u0bb3\u0bc8",
  },
  "264 Galle Rd, Beruwala, Sri Lanka": {
    si: "264 \u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0db6\u0dda\u0dbb\u0dd4\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "264 \u0b95\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc7\u0bb0\u0bc1\u0bb5\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "265-275 Katugastota Rd, Kandy": {
    si: "265-275 \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7 \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb",
    ta: "265-275 \u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf",
  },
  "266 A5, Passara, Sri Lanka": {
    si: "266 A5, \u0db4\u0dc3\u0dca\u0dc3\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "266 A5, \u0baa\u0b9a\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "267 Colombo - Galle Main Rd, Colombo 00400, Sri Lanka": {
    si: "267 \u0d9a\u0ddc\u0dc5\u0db9 - \u0d9c\u0dcf\u0dbd\u0dca\u0dbd \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0dc5\u0db9 00400, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "267 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bbe\u0bb2\u0bbf \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00400, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "267 Colombo - Galle Main Rd, Colombo 4": {
    si: "267 \u0d9a\u0ddc\u0dc5\u0db9 - \u0d9c\u0dcf\u0dbd\u0dca\u0dbd \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0dc5\u0db9 4",
    ta: "267 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bbe\u0bb2\u0bbf \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 4",
  },
  "26H9+582,    , Galle 80000, Sri Lanka": {
    si: "26H9+582, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd 80000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "26H9+582, , \u0b95\u0bbe\u0bb2\u0bbf 80000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "26J8+WX Galle, Sri Lanka": {
    si: "26J8+WX \u0d9c\u0dcf\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "26J8+WX \u0b95\u0bbe\u0bb2\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "26MW+G5Q, Access Road, Galle, Sri Lanka": {
    si: "26MW+G5Q, \u0db4\u0dca\u200d\u0dbb\u0dc0\u0dda\u0dc1 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "26MW+G5Q, \u0b85\u0ba3\u0bc1\u0b95\u0bb2\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bbe\u0bb2\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "26PH+HGX, Galle 80000, Sri Lanka": {
    si: "26PH+HGX, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd 80000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "26PH+HGX, \u0b95\u0bbe\u0bb2\u0bbf 80000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "26PJ+C53, Galle 80000, Sri Lanka": {
    si: "26PJ+C53, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd 80000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "26PJ+C53, \u0b95\u0bbe\u0bb2\u0bbf 80000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "26R3+R73, Peradeniya-Badulla-Chenkaladi Hwy, Lunugala, Sri Lanka": {
    si: "26R3+R73, \u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba-\u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd-\u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2 Hwy, \u0dbd\u0dd4\u0dab\u0dd4\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "26R3+R73, \u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8-\u0baa\u0ba4\u0bc1\u0bb3\u0bc8-\u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf Hwy, \u0bb2\u0bc1\u0ba9\u0bc1\u0b95\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "26X6+H4Q IOC Fuel Station, Wakwella Rd, Galle 80000, Sri Lanka": {
    si: "26X6+H4Q IOC \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0dc0\u0d9a\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd 80000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "26X6+H4Q IOC \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0bb5\u0b95\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bbe\u0bb2\u0bbf 80000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "27/8b Lake Rd, Boralesgamuwa": {
    si: "27/8b \u0dc0\u0dd0\u0dc0 \u0db4\u0dcf\u0dbb, \u0db6\u0ddc\u0dbb\u0dbd\u0dd0\u0dc3\u0dca\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "27/8b \u0bb2\u0bc7\u0b95\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1, \u0baa\u0bca\u0bb0\u0bb2\u0bb8\u0bcd\u0b95\u0bae\u0bc1\u0bb5",
  },
  "270-278 Negombo - Colombo Main Rd, Ja-Ela": {
    si: "270-278 \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0da2\u0dcf-\u0d87\u0dbd",
    ta: "270-278 \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b9c\u0bbe-\u0b8e\u0bb2",
  },
  "272 Mile Post, Warnagiriya, Dombagahawela": {
    si: "272 \u0dc3\u0dd0\u0dad\u0db4\u0dd4\u0db8\u0dca \u0d9a\u0dab\u0dd4\u0dc0, \u0dc0\u0dbb\u0dca\u0dab\u0d9c\u0dd2\u0dbb\u0dd2\u0dba, \u0daf\u0ddc\u0db9\u0d9c\u0dc4\u0dc0\u0dd9\u0dbd",
    ta: "272 \u0bae\u0bc8\u0bb2\u0bcd \u0baa\u0bcb\u0bb8\u0bcd\u0b9f\u0bcd, \u0bb5\u0bb0\u0bcd\u0ba3\u0b95\u0bbf\u0bb0\u0bbf\u0baf, \u0ba4\u0bca\u0bae\u0bcd\u0baa\u0b95\u0bb9\u0bb5\u0bc6\u0bb2",
  },
  "273 Negombo-Colombo Main Rd, Ragama, Sri Lanka": {
    si: "273 \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0-\u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0dbb\u0dcf\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "273 \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1-\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb0\u0bbe\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "274C+4CJ, Anuradhapura-Padeniya Highway, Galgamuwa, Sri Lanka": {
    si: "274C+4CJ, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb-\u0db4\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0d9c\u0dbd\u0dca\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "274C+4CJ, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd-\u0baa\u0ba4\u0bc6\u0ba9\u0bbf\u0baf \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bb2\u0bcd\u0b95\u0bae\u0bc1\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "278, Kandy Road, Nunavil, Chavakachcheri": {
    si: "278, \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0db1\u0dd4\u0db1\u0dcf\u0dc0\u0dd2\u0dbd\u0dca, \u0da0\u0dcf\u0dc0\u0d9a\u0da0\u0dca\u0da0\u0dda\u0dbb\u0dd2",
    ta: "278, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc1\u0ba3\u0bbe\u0bb5\u0bbf\u0bb2\u0bcd, \u0b9a\u0bbe\u0bb5\u0b95\u0b9a\u0bcd\u0b9a\u0bc7\u0bb0\u0bbf",
  },
  "279, Dambulla Road, Kirigalpotta, Matale": {
    si: "279, \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d9a\u0dd2\u0dbb\u0dd2\u0d9c\u0dbd\u0dca\u0db4\u0ddc\u0dad\u0dca\u0dad, \u0db8\u0dcf\u0dad\u0dbd\u0dda",
    ta: "279, \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bbf\u0bb0\u0bbf\u0b95\u0bb2\u0bcd\u0baa\u0bca\u0ba4\u0bcd\u0ba4, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8",
  },
  "27QC+CR9, Bibile - Medagama - Nakkala Rd, Sri Lanka": {
    si: "27QC+CR9, \u0db6\u0dd2\u0db6\u0dd2\u0dbd - \u0db8\u0dd0\u0daf\u0d9c\u0db8 - \u0db1\u0d9a\u0dca\u0d9a\u0dbd \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "27QC+CR9, Bibile - Medagama - Nakkala Rd, Sri Lanka",
  },
  "27WM+X7J, Mahagalkadawala, Sri Lanka": {
    si: "27WM+X7J, \u0db8\u0dc4\u0d9c\u0dbd\u0dca\u0d9a\u0da9\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "27WM+X7J, \u0bae\u0bb9\u0b95\u0bb2\u0bcd\u0b95\u0b9f\u0bb5\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "28 New Kandy Rd, Weliweriya, Sri Lanka": {
    si: "28 \u0db1\u0dc0 \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dc0\u0dd0\u0dbd\u0dd2\u0dc0\u0dda\u0dbb\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "28 \u0baa\u0bc1\u0ba4\u0bbf\u0baf \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb5\u0bc6\u0bb2\u0bbf\u0bb5\u0bc7\u0bb0\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "28 Polgahawela-Kegalle Hwy, Sri Lanka": {
    si: "28 \u0db4\u0ddc\u0dbd\u0dca\u0d9c\u0dc4\u0dc0\u0dd9\u0dbd-\u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd Hwy, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "28 \u0baa\u0bca\u0bb2\u0bcd\u0b95\u0bb9\u0bb5\u0bc6\u0bb2-\u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8 Hwy, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "28 Polgahawela-kegalle Highway": {
    si: "28 \u0db4\u0ddc\u0dbd\u0dca\u0d9c\u0dc4\u0dc0\u0dd9\u0dbd-\u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba",
    ta: "28 \u0baa\u0bca\u0bb2\u0bcd\u0b95\u0bb9\u0bb5\u0bc6\u0bb2-\u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8 \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8",
  },
  "283 Kurunegala - Dambulla Rd, Melsiripura, Sri Lanka": {
    si: "283 \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dd0\u0dbd\u0dca\u0dc3\u0dd2\u0dbb\u0dd2\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "283 \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0bc6\u0bb2\u0bcd\u0b9a\u0bbf\u0bb0\u0bbf\u0baa\u0bc1\u0bb0, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "285 Pasyala - Giriulla Rd, Mirigama 11200, Sri Lanka": {
    si: "285 \u0db4\u0dc3\u0dca\u0dba\u0dcf\u0dbd - \u0d9c\u0dd2\u0dbb\u0dd2\u0d8b\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dd3\u0dbb\u0dd2\u0d9c\u0db8 11200, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "285 \u0baa\u0bb8\u0bcd\u0baf\u0bbe\u0bb2\u0bbe - \u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0bc0\u0bb0\u0bbf\u0b95\u0bae 11200, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "29 Nallur-Oddumadam Rd, Jaffna, Sri Lanka": {
    si: "29 \u0db1\u0dbd\u0dca\u0dbd\u0dd6\u0dbb\u0dca-\u0d94\u0da9\u0dca\u0da9\u0dd4\u0db8\u0da9\u0db8\u0dca \u0db4\u0dcf\u0dbb, \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "29 \u0ba8\u0bb2\u0bcd\u0bb2\u0bc2\u0bb0\u0bcd-\u0b92\u0b9f\u0bcd\u0b9f\u0bc1\u0bae\u0b9f\u0bae\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "290 A2, Hikkaduwa": {
    si: "290 A2, \u0dc4\u0dd2\u0d9a\u0dca\u0d9a\u0da9\u0dd4\u0dc0",
    ta: "290 A2, \u0bb9\u0bbf\u0b95\u0bcd\u0b95\u0b9f\u0bc1\u0bb5\u0bc8",
  },
  "290 Galle Rd, Hikkaduwa, Sri Lanka": {
    si: "290 \u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0dc4\u0dd2\u0d9a\u0dca\u0d9a\u0da9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "290 \u0b95\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0bbf\u0b95\u0bcd\u0b95\u0b9f\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "291b, Sri Road, Hokandara": {
    si: "291b, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0db4\u0dcf\u0dbb, \u0dc4\u0ddd\u0d9a\u0db1\u0dca\u0daf\u0dbb",
    ta: "291b, \u0bb8\u0bcd\u0bb0\u0bc0 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0bcb\u0b95\u0ba8\u0bcd\u0ba4\u0bb0\u0bbe",
  },
  "293 A2, Galle, Sri Lanka": {
    si: "293 A2, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "293 A2, \u0b95\u0bbe\u0bb2\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "293, Magalle,Galle": {
    si: "293, \u0db8\u0dcf\u0d9c\u0dbd\u0dca\u0dbd, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd",
    ta: "293, \u0bae\u0bbe\u0b95\u0bb2\u0bc8, \u0b95\u0bbe\u0bb2\u0bbf",
  },
  "295 Negombo-Colombo Main Rd, Negombo, Sri Lanka": {
    si: "295 \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0-\u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "295 \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1-\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "297/7 Dr Danister De Silva Mawatha, Colombo 00900, Sri Lanka": {
    si: "297/7 \u0d86\u0da0\u0dcf\u0dbb\u0dca\u0dba \u0da9\u0dd0\u0db1\u0dd2\u0dc3\u0dca\u0da7\u0dbb\u0dca \u0daf \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 00900, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "297/7 \u0b9f\u0bbe\u0b95\u0bcd\u0b9f\u0bb0\u0bcd \u0b9f\u0bbe\u0ba9\u0bbf\u0bb8\u0bcd\u0b9f\u0bb0\u0bcd \u0b9f\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00900, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "29PQ+8F3, Imaduwa, Sri Lanka": {
    si: "29PQ+8F3, \u0d89\u0db8\u0daf\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "29PQ+8F3, \u0b87\u0bae\u0ba4\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2CVW+PC6, Bulnewa, Sri Lanka": {
    si: "2CVW+PC6, \u0db6\u0dd4\u0dbd\u0dca\u0db1\u0dd1\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2CVW+PC6, \u0baa\u0bc1\u0bb2\u0bcd\u0ba9\u0bc7\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2H68+VGR, Thihagoda, Sri Lanka": {
    si: "2H68+VGR, \u0dad\u0dd2\u0dc4\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2H68+VGR, \u0ba4\u0bbf\u0bb9\u0bbe\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2HPX+3X8, Kekirawa, Sri Lanka": {
    si: "2HPX+3X8, \u0d9a\u0dd0\u0d9a\u0dd2\u0dbb\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2HPX+3X8, \u0b95\u0bc6\u0b95\u0bbf\u0bb0\u0bbe\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2HRW+6VP, Kekirawa, Sri Lanka": {
    si: "2HRW+6VP, \u0d9a\u0dd0\u0d9a\u0dd2\u0dbb\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2HRW+6VP, \u0b95\u0bc6\u0b95\u0bbf\u0bb0\u0bbe\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2JR2+X6F, Kekirawa-Ganewalpola Rd, Kekirawa, Sri Lanka": {
    si: "2JR2+X6F, \u0d9a\u0dd0\u0d9a\u0dd2\u0dbb\u0dcf\u0dc0-\u0d9c\u0dab\u0dda\u0dc0\u0dbd\u0dca\u0db4\u0ddc\u0dbd \u0db4\u0dcf\u0dbb, \u0d9a\u0dd0\u0d9a\u0dd2\u0dbb\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2JR2+X6F, \u0b95\u0bc6\u0b95\u0bcd\u0b95\u0bbf\u0bb0\u0bbe\u0bb5-\u0b95\u0ba9\u0bc7\u0bb5\u0bb2\u0bcd\u0baa\u0bca\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bc6\u0b95\u0bcd\u0b95\u0bbf\u0bb0\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2M77+QV3, Pundaluoya, Sri Lanka": {
    si: "2M77+QV3, \u0db4\u0dd4\u0dab\u0dca\u0da9\u0dc5\u0dd4\u0d94\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2M77+QV3, \u0baa\u0bc2\u0ba3\u0bcd\u0b9f\u0bb2\u0bc1\u0b93\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2P2R+5J Mampuri, Sri Lanka": {
    si: "2P2R+5J \u0db8\u0dcf\u0db8\u0dca\u0db4\u0dd4\u0dbb\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2P2R+5J \u0bae\u0bbe\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2PWM+XP9, Beliatta, Sri Lanka": {
    si: "2PWM+XP9, \u0db6\u0dd9\u0dbd\u0dd2\u0d85\u0dad\u0dca\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2PWM+XP9, \u0baa\u0bc6\u0bb2\u0bbf\u0baf\u0b9f\u0bcd\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2QFX+H6P, Sea Avenues, Tangalle, Sri Lanka": {
    si: "2QFX+H6P, \u0db8\u0dd4\u0dc4\u0dd4\u0daf\u0dd4 \u0db8\u0dcf\u0dc0\u0dad, \u0dad\u0d82\u0d9c\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2QFX+H6P, \u0b9a\u0bc0 \u0b85\u0bb5\u0bc6\u0ba9\u0bcd\u0baf\u0bc2\u0bb8\u0bcd, \u0ba4\u0b99\u0bcd\u0b95\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2QGV+8JM, Tangalle, Sri Lanka": {
    si: "2QGV+8JM, \u0dad\u0d82\u0d9c\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2QGV+8JM, \u0ba4\u0b99\u0bcd\u0b95\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2QHV+RHG, Tangalle, Sri Lanka": {
    si: "2QHV+RHG, \u0dad\u0d82\u0d9c\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2QHV+RHG, \u0ba4\u0b99\u0bcd\u0b95\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2QPC+54F, Moragaswewa, Sri Lanka": {
    si: "2QPC+54F, \u0db8\u0ddc\u0dbb\u0d9c\u0dc3\u0dca\u0dc0\u0dd0\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2QPC+54F, \u0bae\u0bca\u0bb0\u0b95\u0bb8\u0bcd\u0bb5\u0bc6\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2QQ4+X65, Habarana Roundabout, Habarana, Sri Lanka": {
    si: "2QQ4+X65, \u0dc4\u0db6\u0dbb\u0dab \u0dc0\u0da7\u0dbb\u0dc0\u0dd4\u0db8, \u0dc4\u0db6\u0dbb\u0dab, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2QQ4+X65, \u0bb9\u0baa\u0bb0\u0ba9\u0bbe \u0bb0\u0bb5\u0bc1\u0ba3\u0bcd\u0b9f\u0bbe\u0ba9\u0bbe, \u0bb9\u0baa\u0bb0\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2R4Q+G7H, Puttalam, Sri Lanka": {
    si: "2R4Q+G7H, \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2R4Q+G7H, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2RGP+WJ8, Katugastota-Kurunegala-Puttalam Hwy, Puttalam, Sri Lanka": {
    si: "2RGP+WJ8, \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7-\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd-\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 Hwy, \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2RGP+WJ8, \u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8-\u0b95\u0bc1\u0bb0\u0bc1\u0ba3\u0bbe\u0b95\u0bb2\u0bcd-\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd Hwy, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2RJH+6GJ, Puttalam, Sri Lanka": {
    si: "2RJH+6GJ, \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2RJH+6GJ, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2V4M+VX Mannar, Sri Lanka": {
    si: "2V4M+VX \u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2V4M+VX \u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2V58+M6P, Wattala, Sri Lanka": {
    si: "2V58+M6P, \u0dc0\u0dad\u0dca\u0dad\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2V58+M6P, \u0bb5\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2V9X+9Q7, Magammana, Sri Lanka": {
    si: "2V9X+9Q7, \u0db8\u0dcf\u0d9c\u0db8\u0dca\u0db8\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2V9X+9Q7, \u0bae\u0b95\u0bae\u0bcd\u0bae\u0bbe\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2VJ4+8WM, Senakudirippuwa, Sri Lanka": {
    si: "2VJ4+8WM, \u0dc3\u0dda\u0db1\u0d9a\u0dd4\u0da9\u0dd2\u0dbb\u0dd2\u0db4\u0dca\u0db4\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2VJ4+8WM, \u0b9a\u0bc7\u0ba9\u0b95\u0bc1\u0b9f\u0bbf\u0bb0\u0bbf\u0baa\u0bcd\u0baa\u0bc1\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2W7Q+7PR, Sri Lanka": {
    si: "2W7Q+7PR, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2W7Q+7PR, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2WQ4+H63, Maradankadawala-Habarana-Thirukkondaiadimadu Hwy, Minneriya, Sri Lanka":
    {
      si: "2WQ4+H63, \u0db8\u0dbb\u0daf\u0db1\u0dca\u0d9a\u0da9\u0dc0\u0dbd-\u0dc4\u0db6\u0dbb\u0dab-\u0dad\u0dd2\u0dbb\u0dd4\u0d9a\u0dca\u0d9a\u0ddc\u0db1\u0dca\u0daf\u0d85\u0da9\u0dd2\u0db8\u0da9\u0dd4 Hwy, \u0db8\u0dd2\u0db1\u0dca\u0db1\u0dda\u0dbb\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "2WQ4+H63, \u0bae\u0bb0\u0ba4\u0ba9\u0bcd\u0b95\u0b9f\u0bb5\u0bb2-\u0bb9\u0baa\u0bb0\u0ba3\u0bc8-\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcd\u0b95\u0bca\u0ba3\u0bcd\u0b9f\u0bc8\u0baf\u0bbe\u0b9f\u0bbf\u0bae\u0b9f\u0bc1 Hwy, \u0bae\u0bbf\u0ba9\u0bcd\u0ba9\u0bc7\u0bb0\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "2X22+J5W, 12/E Kandy Rd, Kadawatha 11850, Sri Lanka": {
    si: "2X22+J5W, 12/E \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0da9\u0dc0\u0dad 11850, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2X22+J5W, 12/E \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8 11850, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2XGJ+WFF, Kadawatha, Sri Lanka": {
    si: "2XGJ+WFF, \u0d9a\u0da9\u0dc0\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2XGJ+WFF, \u0b95\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2XPR+295, Sri Lanka": {
    si: "2XPR+295, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2XPR+295, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2XR2+827, Hingurakgoda, Sri Lanka": {
    si: "2XR2+827, \u0dc4\u0dd2\u0d9f\u0dd4\u0dbb\u0d9a\u0dca\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2XR2+827, \u0bb9\u0bbf\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0bbe\u0b95\u0bcd\u0b95\u0bcb\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "2d Avissawella Rd, Godagama, Sri Lanka": {
    si: "2d \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d9c\u0ddc\u0da9\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "2d \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bca\u0b9f\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "30 minutes to 3 hours": {
    si: "\u0dc0\u0dd2\u0db1\u0dcf\u0da9\u0dd2 30 \u0dc3\u0dd2\u0da7 \u0db4\u0dd0\u0dba 3 \u0daf\u0d9a\u0dca\u0dc0\u0dcf",
    ta: "30 \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0b99\u0bcd\u0b95\u0bb3\u0bcd \u0bae\u0bc1\u0ba4\u0bb2\u0bcd 3 \u0bae\u0ba3\u0bbf \u0ba8\u0bc7\u0bb0\u0bae\u0bcd \u0bb5\u0bb0\u0bc8",
  },
  "301 Avissawella Rd, Hanwella, Sri Lanka": {
    si: "301 \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0dc4\u0d82\u0dc0\u0dd0\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "301 \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb9\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "302 Dangedara Road, Galle 80000, Sri Lanka": {
    si: "302 \u0daf\u0d82\u0d9c\u0dd9\u0daf\u0dbb \u0db4\u0dcf\u0dbb, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd 80000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "302 \u0b9f\u0bbe\u0b99\u0bcd\u0b95\u0bc7\u0ba4\u0bb0 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bbe\u0bb2\u0bbf 80000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "303 Negombo Rd, Wattala, Sri Lanka": {
    si: "303 \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0dc0\u0dad\u0dca\u0dad\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "303 \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb5\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "304 Dr Colvin R de Silva Mawatha, Colombo 01000, Sri Lanka": {
    si: "304 \u0d86\u0da0\u0dcf\u0dbb\u0dca\u0dba \u0d9a\u0ddc\u0dbd\u0dca\u0dc0\u0dd2\u0db1\u0dca \u0d86\u0dbb\u0dca \u0daf \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 01000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "304 \u0b9f\u0bbe\u0b95\u0bcd\u0b9f\u0bb0\u0bcd \u0b95\u0bca\u0bb2\u0bcd\u0bb5\u0bbf\u0ba9\u0bcd \u0b86\u0bb0\u0bcd \u0b9f\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 01000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "304 Union Pl, Colombo": {
    si: "304 \u0dba\u0dd4\u0db1\u0dd2\u0dba\u0db1\u0dca \u0db4\u0dd3\u0d91\u0dbd\u0dca, \u200b\u200b\u0d9a\u0ddc\u0dc5\u0db9",
    ta: "304 \u0baf\u0bc2\u0ba9\u0bbf\u0baf\u0ba9\u0bcd \u0baa\u0bbf\u0b8e\u0bb2\u0bcd, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "306 Kotte Rd, Nugegoda": {
    si: "306 Kotte Rd, Nugegoda",
    ta: "306 \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc1\u0b95\u0bc7\u0b95\u0bca\u0b9f",
  },
  "306 Kotte Rd, Nugegoda 10100, Sri Lanka": {
    si: "306 \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda \u0db4\u0dcf\u0dbb, \u0db1\u0dd4\u0d9c\u0dda\u0d9c\u0ddc\u0da9 10100, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "306 Kotte Rd, Nugegoda 10100, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "308 B308, Sri Lanka": {
    si: "308 B308, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "308 B308, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "30mins - 3hrs": {
    si: "\u0db8\u0dd2\u0db1\u0dd2\u0dad\u0dca\u0dad\u0dd4 30 - \u0db4\u0dd0\u0dba 3 \u0dba\u0dd2",
    ta: "30 \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0b99\u0bcd\u0b95\u0bb3\u0bcd - 3 \u0bae\u0ba3\u0bbf \u0ba8\u0bc7\u0bb0\u0bae\u0bcd",
  },
  "311 Sri Sangaraja Mawatha, Colombo 01000, Sri Lanka": {
    si: "311 \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dc3\u0d82\u0d9d\u0dbb\u0dcf\u0da2 \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 01000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "311 \u0bb8\u0bcd\u0bb0\u0bc0 \u0b9a\u0b99\u0bcd\u0b95\u0bb0\u0bbe\u0b9c \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 01000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "312 Chilaw - Colombo Main Rd, Negombo 11500, Sri Lanka": {
    si: "312 \u0dc4\u0dbd\u0dcf\u0dc0\u0dad - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 11500, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "312 \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 11500, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "312 Galle Rd, Dehiwala-Mount Lavinia, Sri Lanka": {
    si: "312 \u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd-\u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "312 \u0b95\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8-\u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "313 De Soysa Rd, Moratuwa": {
    si: "313 \u0daf \u0dc3\u0ddc\u0dba\u0dd2\u0dc3\u0dcf \u0db4\u0dcf\u0dbb, \u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0",
    ta: "313 \u0b9f\u0bbf \u0b9a\u0bca\u0baf\u0bcd\u0b9a\u0bbe \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bca\u0bb0\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5",
  },
  "315a Kandy Rd, Kadawatha 11850, Sri Lanka": {
    si: "315a \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0da9\u0dc0\u0dad 11850, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "315a \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0b95\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8 11850, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "31a Hatton - Maskeliya - Dalhousie Rd, Hatton, Sri Lanka": {
    si: "31a \u0dc4\u0dd0\u0da7\u0db1\u0dca - \u0db8\u0dc3\u0dca\u0d9a\u0dd9\u0dc5\u0dd2\u0dba - \u0da9\u0dbd\u0dca\u0dc4\u0dc0\u0dd4\u0dc3\u0dd2 \u0db4\u0dcf\u0dbb, \u0dc4\u0dd0\u0da7\u0db1\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "31a \u0bb9\u0b9f\u0bcd\u0b9f\u0ba9\u0bcd - \u0bae\u0bb8\u0bcd\u0b95\u0bc6\u0bb2\u0bbf\u0baf\u0bbe - Dalhousie Rd, Hatton, Sri Lanka",
  },
  "32 Castle Ln, Colombo 00400, Sri Lanka": {
    si: "32 \u0d9a\u0dcf\u0dc3\u0dbd\u0dca \u0d91\u0dbd\u0dca\u0d91\u0db1\u0dca, \u0d9a\u0ddc\u0dc5\u0db9 00400, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "32 Castle Ln, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00400, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "32 Coustom Rd, Beruwala": {
    si: "32 \u0d9a\u0dc3\u0dca\u0da7\u0db8\u0dca \u0db4\u0dcf\u0dbb, \u0db6\u0dda\u0dbb\u0dd4\u0dc0\u0dbd",
    ta: "32 Custom Rd, \u0baa\u0bc7\u0bb0\u0bc1\u0bb5\u0bb3\u0bc8",
  },
  "32 Coustom Rd, Beruwala, Sri Lanka": {
    si: "32 \u0d9a\u0dc3\u0dca\u0da7\u0db8\u0dca \u0db4\u0dcf\u0dbb, \u0db6\u0dda\u0dbb\u0dd4\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "32 Custom Rd, \u0baa\u0bc7\u0bb0\u0bc1\u0bb5\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "32 Kandy - Jaffna Hwy, Medawachchiya, Sri Lanka": {
    si: "32 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb - \u0dba\u0dcf\u0db4\u0db1\u0dba Hwy, \u0db8\u0dd0\u0daf\u0dc0\u0da0\u0dca\u0da0\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "32 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf - \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0bae\u0bc7\u0b9f\u0bb5\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "323 Havelock Rd, Colombo 00500, Sri Lanka": {
    si: "323 \u0dc4\u0dd0\u0dc0\u0dca\u0dbd\u0ddc\u0d9a\u0dca \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0dc5\u0db9 00500, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "323 \u0bb9\u0bc7\u0bb5\u0bcd\u0bb2\u0bbe\u0b95\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00500, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "32300, Kalmunai 32300, Sri Lanka": {
    si: "32300, \u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda 32300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "32300, \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8 32300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "328a New Kandy Rd, Sri Lanka": {
    si: "328a \u0db1\u0dc0 \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "328a \u0baa\u0bc1\u0ba4\u0bbf\u0baf \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "32GC+R68, Gampaha, Sri Lanka": {
    si: "32GC+R68, \u0d9c\u0db8\u0dca\u0db4\u0dc4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "32GC+R68, \u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "32JQ+P5G, Yakkala - Radawana Rd, Yakkala, Sri Lanka": {
    si: "32JQ+P5G, \u0dba\u0d9a\u0dca\u0d9a\u0dbd - \u0dbb\u0daf\u0dcf\u0dc0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0dba\u0d9a\u0dca\u0d9a\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "32JQ+P5G, Yakkala - Radawana Rd, Yakkala, Sri Lanka",
  },
  "32MH+F98, Unnamed Rd, Sungavila, Sri Lanka": {
    si: "32MH+F98, \u0db1\u0db8\u0dca \u0db1\u0ddc\u0d9a\u0dc5 \u0db4\u0dcf\u0dbb, \u0dc3\u0dd4\u0d82\u0d9c\u0dc0\u0dd2\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "32MH+F98, \u0baa\u0bc6\u0baf\u0bb0\u0bbf\u0b9f\u0baa\u0bcd\u0baa\u0b9f\u0bbe\u0ba4 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b9a\u0bc1\u0b99\u0bcd\u0b95\u0bb5\u0bbf\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "32RC+F3G, Gampaha, Sri Lanka": {
    si: "32RC+F3G, \u0d9c\u0db8\u0dca\u0db4\u0dc4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "32RC+F3G, \u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "33 Colombo - Galle Main Rd, Panadura, Sri Lanka": {
    si: "33 \u0d9a\u0ddc\u0dc5\u0db9 - \u0d9c\u0dcf\u0dbd\u0dca\u0dbd \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "33 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bbe\u0bb2\u0bbf \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bbe\u0ba3\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "33 D D. S. Senanayake Mawatha, Colombo 00700, Sri Lanka": {
    si: "33 D D. S. \u0dc3\u0dda\u0db1\u0dcf\u0db1\u0dcf\u0dba\u0d9a \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 00700, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "33 D. D. S. \u0b9a\u0bc7\u0ba9\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00700, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "33 Kandy Rd, Yakkala, Sri Lanka": {
    si: "33 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dba\u0d9a\u0dca\u0d9a\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "33 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0baf\u0b95\u0bcd\u0b95\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3339+R23, Wathurugama Rd, Malwathu Hiripitiya, Sri Lanka": {
    si: "3339+R23, \u0dc0\u0dad\u0dd4\u0dbb\u0dd4\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0db8\u0dbd\u0dca\u0dc0\u0dad\u0dd4 \u0dc4\u0dd2\u0dbb\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3339+R23, \u0bb5\u0ba4\u0bc1\u0bb0\u0bc1\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bb2\u0bcd\u0bb5\u0ba4\u0bcd\u0ba4\u0bc1 \u0bb9\u0bbf\u0bb0\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "337 Karukupone Rd, Bangadeniya, Sri Lanka": {
    si: "337 \u0d9a\u0dbb\u0dd4\u0d9a\u0dd4\u0db4\u0ddc\u0db1\u0dca \u0db4\u0dcf\u0dbb, \u0db6\u0d82\u0d9c\u0daf\u0dd9\u0dab\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "337 \u0b95\u0bb0\u0bc1\u0b95\u0bc1\u0baa\u0bcb\u0ba9\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0b99\u0bcd\u0b95\u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "34 Ampara Rd, Sammanthurai 32200, Sri Lanka": {
    si: "34 \u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb \u0db4\u0dcf\u0dbb, \u0dc3\u0db8\u0dca\u0db8\u0db1\u0dca\u0dad\u0dd4\u0dbb\u0dda 32200, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "34 \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b9a\u0bae\u0bcd\u0bae\u0bbe\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8 32200, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "340b Lake Rd, Boralesgamuwa 10290, Sri Lanka": {
    si: "340b \u0dbd\u0dda\u0d9a\u0dca \u0db4\u0dcf\u0dbb, \u0db6\u0ddc\u0dbb\u0dbd\u0dd0\u0dc3\u0dca\u0d9c\u0db8\u0dd4\u0dc0 10290, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "340b Lake Rd, \u0baa\u0bca\u0bb0\u0bb2\u0bb8\u0bcd\u0b95\u0bae\u0bc1\u0bb5 10290, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "344 Galle Rd, Kalutara, Sri Lanka": {
    si: "344 \u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0d9a\u0dc5\u0dd4\u0dad\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "344 \u0b95\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb3\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "345 Puttalam - Anuradhapura - Trincomalee Hwy, Anuradhapura, Sri Lanka": {
    si: "345 \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 - \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb - \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "345 \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "346 Dompe - Pugoda Road, Sri Lanka": {
    si: "346 \u0daf\u0ddc\u0db8\u0dca\u0db4\u0dda - \u0db4\u0dd6\u0d9c\u0ddc\u0da9 \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "346 \u0b9f\u0bcb\u0bae\u0bcd\u0baa\u0bc7 - \u0baa\u0bc2\u0b95\u0bcb\u0b9f\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "348 Yatiyana, Sri Lanka": {
    si: "348 \u0dba\u0da7\u0dd2\u0dba\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "348 \u0baf\u0ba4\u0bbf\u0baf\u0bbe\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "349F+FJ Wathurugama, Sri Lanka": {
    si: "349F+FJ \u0dc0\u0dad\u0dd4\u0dbb\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "349F+FJ \u0bb5\u0ba4\u0bc1\u0bb0\u0bc1\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "34RR+MF3, Rathgama, Sri Lanka": {
    si: "34RR+MF3, \u0dbb\u0dad\u0dca\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "34RR+MF3, \u0bb0\u0ba4\u0bcd\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "35 Kandy Rd, 21300, Sri Lanka": {
    si: "35 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, 21300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "35 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, 21300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "35, Aluthgama-mathugama Rd, Welipenna": {
    si: "35, \u0d85\u0dbd\u0dd4\u0dad\u0dca\u0d9c\u0db8-\u0db8\u0dad\u0dd4\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0dc0\u0dd0\u0dbd\u0dd2\u0db4\u0dd0\u0db1\u0dca\u0db1",
    ta: "35, \u0b85\u0bb3\u0bc1\u0ba4\u0bcd\u0b95\u0bae-\u0bae\u0ba4\u0bc1\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bc6\u0bb2\u0bbf\u0baa\u0bc6\u0ba9\u0bcd\u0ba9",
  },
  "352 A1, Mawanella, Sri Lanka": {
    si: "352 A1, \u0db8\u0dcf\u0dc0\u0db1\u0dd0\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "352 A1, \u0bae\u0bbe\u0bb5\u0ba9\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "352 Kotte Rd, Sri Jayawardenepura Kotte 10100, Sri Lanka": {
    si: "352 \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1\u0db4\u0dd4\u0dbb \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda 10100, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "352 Kotte Rd, Sri Jayawardenepura Kotte 10100, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "357 Pasyala - Giriulla Rd, Mirigama, Sri Lanka": {
    si: "357 \u0db4\u0dc3\u0dca\u0dba\u0dcf\u0dbd - \u0d9c\u0dd2\u0dbb\u0dd2\u0d8b\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dd3\u0dbb\u0dd2\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "357 \u0baa\u0bb8\u0bcd\u0baf\u0bbe\u0bb2\u0bbe - \u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0bc0\u0bb0\u0bbf\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "358/4 Colombo - Kandy Rd, Mawanella": {
    si: "358/4 \u0d9a\u0ddc\u0dc5\u0db9 - \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0db8\u0dcf\u0dc0\u0db1\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "358/4 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0bae\u0bbe\u0bb5\u0ba9\u0bb2\u0bcd\u0bb2\u0bc8",
  },
  "359 Dickson Moters Rd, Kurunegala, Sri Lanka": {
    si: "359 \u0da9\u0dd2\u0d9a\u0dca\u0dc3\u0db1\u0dca \u0db8\u0ddd\u0da7\u0dbb\u0dca\u0dc3\u0dca \u0db4\u0dcf\u0dbb, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "359 \u0b9f\u0bbf\u0b95\u0bcd\u0b9a\u0ba9\u0bcd \u0bae\u0bcb\u0b9f\u0bcd\u0b9f\u0bb0\u0bcd\u0bb8\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "35C6+QXF, Galle, Sri Lanka": {
    si: "35C6+QXF, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "35C6+QXF, \u0b95\u0bbe\u0bb2\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "35w, Negombo-kurunegala Rd, Bopitiya": {
    si: "35w, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0-\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd \u0db4\u0dcf\u0dbb, \u0db6\u0ddd\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "35w, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1-\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bcb\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "363 Kandy Rd, Kelaniya, Sri Lanka": {
    si: "363 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0dd0\u0dbd\u0dab\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "363 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0b95\u0bb3\u0ba9\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "364b High Level Rd, Nugegoda, Sri Lanka": {
    si: "364b \u0dc4\u0dba\u0dd2\u0dbd\u0dd9\u0dc0\u0dbd\u0dca \u0db4\u0dcf\u0dbb, \u0db1\u0dd4\u0d9c\u0dda\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "364b \u0b89\u0baf\u0bb0\u0bcd\u0bae\u0b9f\u0bcd\u0b9f \u0b9a\u0bbe\u0bb2\u0bc8, \u0ba8\u0bc1\u0b95\u0bc7\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3653+JCM, Galle 80000, Sri Lanka": {
    si: "3653+JCM, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd 80000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3653+JCM, \u0b95\u0bbe\u0bb2\u0bbf 80000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "366J+5RM,      , Galle 80000, Sri Lanka": {
    si: "366J+5RM, , \u0d9c\u0dcf\u0dbd\u0dca\u0dbd 80000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "366J+5RM, , \u0b95\u0bbe\u0bb2\u0bbf 80000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "369, Ambepussa - Kurunegala - Trincomalee Hwy, Kurunegala": {
    si: "369, \u0d85\u0db9\u0dda\u0db4\u0dd4\u0dc3\u0dca\u0dc3 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd",
    ta: "369, \u0b85\u0bae\u0bcd\u0baa\u0bc7\u0baa\u0bc1\u0bb8\u0bcd\u0bb8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 Hwy, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd",
  },
  "36HX+9GC, Sri Lanka": {
    si: "36HX+9GC, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "36HX+9GC, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "37 High Level Rd, Homagama 10250, Sri Lanka": {
    si: "37 \u0dc4\u0dba\u0dd2\u0dbd\u0dd9\u0dc0\u0dbd\u0dca \u0db4\u0dcf\u0dbb, \u0dc4\u0ddd\u0db8\u0dcf\u0d9c\u0db8 10250, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "37 \u0b89\u0baf\u0bb0\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb9\u0bcb\u0bae\u0bbe\u0b95\u0bae 10250, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "37 Maha Vihara Rd, Ambalangoda, Sri Lanka": {
    si: "37 \u0db8\u0dc4\u0dcf \u0dc0\u0dd2\u0dc4\u0dcf\u0dbb \u0db4\u0dcf\u0dbb, \u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "37 \u0bae\u0b95\u0bbe \u0bb5\u0bbf\u0b95\u0bbe\u0bb0\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "37, Station Cross Rd, Batticaloa": {
    si: "37, \u0daf\u0dd4\u0db8\u0dca\u0dbb\u0dd2\u0dba \u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba \u0dc4\u0dbb\u0dc3\u0dca \u0db4\u0dcf\u0dbb, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0",
    ta: "37, \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd \u0b95\u0bc1\u0bb1\u0bc1\u0b95\u0bcd\u0b95\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1",
  },
  "370 Avissawella Rd, Pannipitiya": {
    si: "370 \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "370 \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "370 High Level Rd, Pannipitiya 10230, Sri Lanka": {
    si: "370 High level Rd, Pannipitiya 10230, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "370 \u0b89\u0baf\u0bb0\u0bcd \u0bae\u0b9f\u0bcd\u0b9f \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf 10230, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "372 Matale Rd, Akurana, Sri Lanka": {
    si: "372 \u0db8\u0dcf\u0dad\u0dbd\u0dda \u0db4\u0dcf\u0dbb, \u0d85\u0d9a\u0dd4\u0dbb\u0dab, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "372 \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0b95\u0bcd\u0b95\u0bc1\u0bb0\u0ba3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "372/4 04th Ln, Matara, Sri Lanka": {
    si: "372/4 04 \u0dc0\u0db1 Ln, \u0db8\u0dcf\u0dad\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "372/4 04\u0bb5\u0ba4\u0bc1 Ln, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "374-364 Avissawella Rd, Nugegoda": {
    si: "374-364 \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db1\u0dd4\u0d9c\u0dda\u0d9c\u0ddc\u0da9",
    ta: "374-364 \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc1\u0b95\u0bc7\u0b95\u0bca\u0b9f",
  },
  "378 B295, Moratuwa 10400, Sri Lanka": {
    si: "378 B295, \u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0 10400, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "378 B295, \u0bae\u0bca\u0bb0\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe 10400, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3797+9X Ruwanwella, Sri Lanka": {
    si: "3797+9X \u0dbb\u0dd4\u0dc0\u0db1\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3797+9X \u0bb0\u0bc1\u0bb5\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "38 Station Rd, Wattala 11300, Sri Lanka": {
    si: "38 \u0daf\u0dd4\u0db8\u0dca\u0dbb\u0dd2\u0dba \u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba \u0db4\u0dcf\u0dbb, \u0dc0\u0dad\u0dca\u0dad\u0dbd 11300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "38 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8 11300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "380 Al - Maslam N Rd, Kalmunai, Sri Lanka": {
    si: "380 \u0d85\u0dbd\u0dca - \u0db8\u0dc3\u0dca\u0dbd\u0db8\u0dca \u0d91\u0db1\u0dca \u0db4\u0dcf\u0dbb, \u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "380 \u0b85\u0bb2\u0bcd - \u0bae\u0bb8\u0bcd\u0bb2\u0bbe\u0bae\u0bcd N Rd, \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "381 Kotte - Bope Rd, Sri Lanka": {
    si: "381 \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda - \u0db6\u0ddd\u0db4\u0dda \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "381 \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7 - \u0baa\u0bcb\u0baa\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "383 Colombo - Batticaloa Hwy, Ratnapura, Sri Lanka": {
    si: "383 \u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "383 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "384/54, Wakwella Rd, Galle": {
    si: "384/54, \u0dc0\u0d9a\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd",
    ta: "384/54, \u0bb5\u0b95\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bbe\u0bb2\u0bbf",
  },
  "386 Colombo - Kandy Rd, Pilimathalawa, Sri Lanka": {
    si: "386 \u0d9a\u0ddc\u0dc5\u0db9 - \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0db4\u0dd2\u0dc5\u0dd2\u0db8\u0dad\u0dbd\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "386 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0baa\u0bbf\u0bb2\u0bbf\u0bae\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "38Q3+2Q2, Akmeemana, Sri Lanka": {
    si: "38Q3+2Q2, \u0d85\u0d9a\u0dca\u0db8\u0dd3\u0db8\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "38Q3+2Q2, \u0b85\u0b95\u0bcd\u0bae\u0bc0\u0bae\u0ba9, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "396, 4th Mile Stone, Mannar Road,Nelukkulan, Vavuniya": {
    si: "396, 4 \u0dc0\u0db1 \u0dc3\u0dd0\u0dad\u0db4\u0dd4\u0db8\u0dca \u0d9c\u0dbd\u0dca, \u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8 \u0db4\u0dcf\u0dbb, \u0db1\u0dd9\u0dc5\u0dd4\u0d9a\u0dca\u0d9a\u0dd4\u0dbd\u0db1\u0dca, \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0",
    ta: "396, 4\u0bb5\u0ba4\u0bc1 \u0bae\u0bc8\u0bb2\u0bcd \u0b95\u0bb2\u0bcd, \u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc6\u0bb3\u0bc1\u0b95\u0bcd\u0b95\u0bc1\u0bb3\u0ba9\u0bcd, \u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe",
  },
  "398 Galagedara - Rambukkana Rd, Galagedara, Sri Lanka": {
    si: "398 \u0d9c\u0dbd\u0d9c\u0dd9\u0daf\u0dbb - \u0dbb\u0db9\u0dd4\u0d9a\u0dca\u0d9a\u0db1 \u0db4\u0dcf\u0dbb, \u0d9c\u0dbd\u0d9c\u0dd9\u0daf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "398 \u0b95\u0bb2\u0b95\u0bc6\u0ba4\u0bb0 - \u0bb0\u0bae\u0bcd\u0baa\u0bc1\u0b95\u0bcd\u0b95\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb2\u0b95\u0bc6\u0ba4\u0bb0, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3FQJ+22G, Sri Lanka": {
    si: "3FQJ+22G, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3FQJ+22G, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3G37+45 Kanakarayankulam, Sri Lanka": {
    si: "3G37+45 \u0d9a\u0db1\u0d9a\u0dbb\u0dcf\u0dba\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3G37+45 \u0b95\u0ba9\u0b95\u0bb0\u0bbe\u0baf\u0ba9\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3G4P+R4W, Nawalapitiya, Sri Lanka": {
    si: "3G4P+R4W, \u0db1\u0dcf\u0dc0\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3G4P+R4W, \u0ba8\u0bbe\u0bb5\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3G4P+R7X, Kandy Rd, Nawalapitiya, Sri Lanka": {
    si: "3G4P+R7X, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0db1\u0dcf\u0dc0\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3G4P+R7X, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0ba8\u0bbe\u0bb5\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3G8Q+XVV, Sri Lanka": {
    si: "3G8Q+XVV, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3G8Q+XVV, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3G9P+GPX, Ipalogama, Sri Lanka": {
    si: "3G9P+GPX, \u0d89\u0db4\u0dbd\u0ddd\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3G9P+GPX, \u0b87\u0baa\u0bcd\u0baa\u0bb2\u0bcb\u0b95\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3HH8+J3W, Matara - Hakmana Rd, Kamburupitiya 81000, Sri Lanka": {
    si: "3HH8+J3W, \u0db8\u0dcf\u0dad\u0dbb - \u0dc4\u0d9a\u0dca\u0db8\u0db1 \u0db4\u0dcf\u0dbb, \u0d9a\u0db9\u0dd4\u0dbb\u0dd4\u0db4\u0dd2\u0da7\u0dd2\u0dba 81000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3HH8+J3W, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8 - \u0bb9\u0b95\u0bcd\u0bae\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bc1\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf 81000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3HJ8+7FV, B415, Kamburupitiya 81100, Sri Lanka": {
    si: "3HJ8+7FV, B415, \u0d9a\u0db9\u0dd4\u0dbb\u0dd4\u0db4\u0dd2\u0da7\u0dd2\u0dba 81100, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3HJ8+7FV, B415, \u0b95\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bc1\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf 81100, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3JMW+9HC, Hakmana - Beliatte - Tangalle Rd, Hakmana, Sri Lanka": {
    si: "3JMW+9HC, \u0dc4\u0d9a\u0dca\u0db8\u0db1 - \u0db6\u0dd9\u0dbd\u0dd2\u0d85\u0dad\u0dca\u0dad\u0dda - \u0dad\u0d82\u0d9c\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0dc4\u0d9a\u0dca\u0db8\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3JMW+9HC, \u0bb9\u0b95\u0bcd\u0bae\u0bbe\u0ba9\u0bbe - \u0baa\u0bc6\u0bb2\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0bc7 - \u0ba4\u0b99\u0bcd\u0b95\u0bbe\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0b95\u0bcd\u0bae\u0bbe\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3JMW+Q3W, Hakmana, Sri Lanka": {
    si: "3JMW+Q3W, \u0dc4\u0d9a\u0dca\u0db8\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3JMW+Q3W, \u0bb9\u0b95\u0bcd\u0bae\u0bbe\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3JRJ+QGG, Ganewalpola, Sri Lanka": {
    si: "3JRJ+QGG, \u0d9c\u0db1\u0dda\u0dc0\u0dbd\u0dca\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3JRJ+QGG, \u0b95\u0ba3\u0bc7\u0bb5\u0bb2\u0bcd\u0baa\u0bcb\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3JRJ+R6 Ganewalpola, Sri Lanka": {
    si: "3JRJ+R6 \u0d9c\u0db1\u0dda\u0dc0\u0dbd\u0dca\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3JRJ+R6 \u0b95\u0ba3\u0bc7\u0bb5\u0bb2\u0bcd\u0baa\u0bca\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3M76+HJ3, Nedunkeni, Sri Lanka": {
    si: "3M76+HJ3, \u0db1\u0dd0\u0daf\u0dd4\u0db1\u0dca\u0d9a\u0dda\u0db1\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3M76+HJ3, \u0ba8\u0bc6\u0b9f\u0bc1\u0b99\u0bcd\u0b95\u0bc7\u0ba3\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3M9M+HW7, Tawalantenne, Sri Lanka": {
    si: "3M9M+HW7, \u0dad\u0dc0\u0dbd\u0db1\u0dca\u0dad\u0dd0\u0db1\u0dca\u0db1\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3M9M+HW7, \u0ba4\u0bb5\u0bb2\u0ba8\u0bcd\u0ba4\u0bc6\u0ba9\u0bcd\u0ba9\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3P2M+2HJ, Walasmulla Road, Beliatta, Sri Lanka": {
    si: "3P2M+2HJ, \u0dc0\u0dbd\u0dc3\u0dca\u0db8\u0dd4\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db6\u0dd9\u0dbd\u0dd2\u0d85\u0dad\u0dca\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3P2M+2HJ, \u0bb5\u0bb2\u0bb8\u0bcd\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0bc6\u0bb2\u0bbf\u0baf\u0b9f\u0bcd\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3P2P+9HR, Norochcholai, Sri Lanka": {
    si: "3P2P+9HR, \u0db1\u0ddc\u0dbb\u0ddc\u0da0\u0dca\u0da0\u0ddd\u0dbd\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3P2P+9HR, \u0ba8\u0bca\u0bb0\u0bcb\u0b9a\u0bcd\u0b9a\u0bcb\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3RCG+QX Puttalam, Sri Lanka": {
    si: "3RCG+QX \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3RCG+QX \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3RV2+R7P, Padiyapelella, Sri Lanka": {
    si: "3RV2+R7P, \u0db4\u0daf\u0dd2\u0dba\u0db4\u0dd0\u0dbd\u0dd0\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3RV2+R7P, \u0baa\u0ba4\u0bbf\u0baf\u0baa\u0bc6\u0bb2\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3VGX+PV Kalametiya, Sri Lanka": {
    si: "3VGX+PV \u0d9a\u0dbd\u0db8\u0dd0\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3VGX+PV \u0b95\u0bb2\u0bae\u0bc7\u0ba4\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3VMV+J3X, Ja-Ela, Sri Lanka": {
    si: "3VMV+J3X, \u0da2\u0dcf-\u0d87\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3VMV+J3X, \u0b9c\u0bbe-\u0b8e\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3VMV+R68, Ja-Ela, Sri Lanka": {
    si: "3VMV+R68, \u0da2\u0dcf-\u0d87\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3VMV+R68, \u0b9c\u0bbe-\u0b8e\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3VPR+R3R, Negombo-Colombo Main Rd, Ja-Ela, Sri Lanka": {
    si: "3VPR+R3R, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0-\u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0da2\u0dcf-\u0d87\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3VPR+R3R, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1-\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b9c\u0bbe-\u0b8e\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3VR8+9XV, Ranna, Sri Lanka": {
    si: "3VR8+9XV, \u0dbb\u0db1\u0dca\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3VR8+9XV, \u0bb0\u0ba9\u0bcd\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3VXP+H2X, Dandugama, Sri Lanka": {
    si: "3VXP+H2X, \u0daf\u0dac\u0dd4\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3VXP+H2X, \u0ba4\u0ba3\u0bcd\u0b9f\u0bc1\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3W3P+4G5, Ragama Batuwatta Road, Narangoda Paluwa, Sri Lanka": {
    si: "3W3P+4G5, \u0dbb\u0dcf\u0d9c\u0db8 \u0db6\u0da7\u0dd4\u0dc0\u0dad\u0dca\u0dad \u0db4\u0dcf\u0dbb, \u0db1\u0dcf\u0dbb\u0d82\u0d9c\u0ddc\u0da9 \u0db4\u0dcf\u0dc5\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3W3P+4G5, \u0bb0\u0bbe\u0b95\u0bae \u0baa\u0b9f\u0bc1\u0bb5\u0ba4\u0bcd\u0ba4 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bbe\u0bb0\u0b99\u0bcd\u0b95\u0bca\u0b9f \u0baa\u0bb2\u0bc1\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3X4G+GH Yatiyalpathana, Sri Lanka": {
    si: "3X4G+GH \u0dba\u0da7\u0dd2\u0dba\u0dbd\u0dca\u0db4\u0dad\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3X4G+GH \u0baf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0bb2\u0bcd\u0baa\u0ba4\u0ba9, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3X96+PFG, Ganemulla, Sri Lanka": {
    si: "3X96+PFG, \u0d9c\u0db1\u0dda\u0db8\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3X96+PFG, \u0b95\u0ba3\u0bc7\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3XC6+6M9, Ganemulla, Sri Lanka": {
    si: "3XC6+6M9, \u0d9c\u0db1\u0dda\u0db8\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3XC6+6M9, \u0b95\u0ba3\u0bc7\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "3rd Mile Post, Ridiyagama Road, Bolana, Sri Lanka": {
    si: "3 \u0d9a\u0dab\u0dd4\u0dc0, \u0dbb\u0dd2\u0daf\u0dd2\u0dba\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0db6\u0ddd\u0dbd\u0dcf\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "3\u0bb5\u0ba4\u0bc1 \u0bae\u0bc8\u0bb2\u0bcd \u0baa\u0bcb\u0bb8\u0bcd\u0b9f\u0bcd, \u0bb0\u0bbf\u0ba4\u0bbf\u0baf\u0b95\u0bae \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0bcb\u0bb2\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4 A4, Kalmunai 32300, Sri Lanka": {
    si: "4 A4, \u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda 32300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4 A4, \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8 32300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "40 Colombo - Kandy Rd, Kalagedihena": {
    si: "40 \u0d9a\u0ddc\u0dc5\u0db9 - \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0dbd\u0d9c\u0dd9\u0da9\u0dd2\u0dc4\u0dda\u0db1",
    ta: "40 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb2\u0b95\u0bc6\u0b9f\u0bbf\u0bb9\u0bc7\u0ba9",
  },
  "40 Colombo - Kandy Rd, Kalagedihena, Sri Lanka": {
    si: "40 \u0d9a\u0ddc\u0dc5\u0db9 - \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0dbd\u0d9c\u0dd9\u0da9\u0dd2\u0dc4\u0dda\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "40 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0b95\u0bb2\u0b95\u0bc6\u0b9f\u0bbf\u0bb9\u0bc7\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "403 Udumulla Rd, Sri Jayawardenepura Kotte": {
    si: "403 \u0d8b\u0da9\u0dd4\u0db8\u0dd4\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1\u0db4\u0dd4\u0dbb \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda",
    ta: "403 \u0b89\u0b9f\u0bc1\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb8\u0bcd\u0bb0\u0bc0 \u0b9c\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0baa\u0bc1\u0bb0 \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7",
  },
  "4030 Colombo - Batticaloa Hwy, Maruthamunai, Sri Lanka": {
    si: "4030 \u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 Hwy, \u0db8\u0dbb\u0dd4\u0dad\u0db8\u0dd4\u0db1\u0dba\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4030 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0bae\u0bb0\u0bc1\u0ba4\u0bae\u0bc1\u0ba9\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "404/1, Negombo Road, Wattala.": {
    si: "404/1, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0dc0\u0dad\u0dca\u0dad\u0dbd.",
    ta: "404/1, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8.",
  },
  "407 Udumulla Rd, Angoda 10620, Sri Lanka": {
    si: "407 \u0d8b\u0da9\u0dd4\u0db8\u0dd4\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d85\u0d82\u0d9c\u0ddc\u0da9 10620, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "407 \u0b89\u0b9f\u0bc1\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0b99\u0bcd\u0b95\u0bca\u0b9f 10620, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "41 Chilaw - Colombo Main Rd, Chilaw": {
    si: "41 \u0dc4\u0dbd\u0dcf\u0dc0\u0dad - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad",
    ta: "41 \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd",
  },
  "41 Chilaw - Colombo Main Rd, Chilaw, Sri Lanka": {
    si: "41 \u0dc4\u0dbd\u0dcf\u0dc0\u0dad - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "41 \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "415 Galle Rd, Dehiwala - Mount Lavinia": {
    si: "415 \u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd - \u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3",
    ta: "415 \u0b95\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8 - \u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8",
  },
  "415 Galle Rd, Dehiwala-Mount Lavinia 10390, Sri Lanka": {
    si: "415 \u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd-\u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3 10390, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "415 \u0b95\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8-\u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8 10390, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "421 Negombo Rd, Wattala 11300, Sri Lanka": {
    si: "421 \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0dc0\u0dad\u0dca\u0dad\u0dbd 11300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "421 \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb5\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8 11300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "42CH+XP7, Aluthgama-Wigoda Rd, Bemmulla, Sri Lanka": {
    si: "42CH+XP7, \u0d85\u0dbd\u0dd4\u0dad\u0dca\u0d9c\u0db8-\u0dc0\u0dd2\u0d9c\u0ddc\u0da9 \u0db4\u0dcf\u0dbb, \u0db6\u0dd9\u0db8\u0dca\u0db8\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "42CH+XP7, \u0b85\u0bb2\u0bc1\u0ba4\u0bcd\u0b95\u0bae-\u0bb5\u0bbf\u0b95\u0bca\u0b9f\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0bc6\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "42FG+35R, Ambalantota, Sri Lanka": {
    si: "42FG+35R, \u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0dad\u0ddc\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "42FG+35R, \u0b85\u0bae\u0bcd\u0baa\u0bb2\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "42FH+49H, A2, Ambalantota, Sri Lanka": {
    si: "42FH+49H, A2, \u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0dad\u0ddc\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "42FH+49H, A2, \u0b85\u0bae\u0bcd\u0baa\u0bb2\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "42J9+G7Q, Diyasenpura, Sri Lanka": {
    si: "42J9+G7Q, \u0daf\u0dd2\u0dba\u0dc3\u0dd9\u0db1\u0dca\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "42J9+G7Q, \u0ba4\u0bbf\u0baf\u0b9a\u0bc6\u0ba9\u0bcd\u0baa\u0bc1\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "43, Ahangama": {
    si: "43, \u0d85\u0dc4\u0d82\u0d9c\u0db8",
    ta: "43, \u0b85\u0bb9\u0b99\u0bcd\u0b95\u0bbe\u0bae\u0bbe",
  },
  "43GC+JCR, A1, Kalagedihena, Sri Lanka": {
    si: "43GC+JCR, A1, \u0d9a\u0dbd\u0d9c\u0dd9\u0da9\u0dd2\u0dc4\u0dda\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "43GC+JCR, A1, \u0b95\u0bb2\u0b95\u0bc6\u0b9f\u0bbf\u0bb9\u0bc7\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "43PR+J7P, A1, Nittambuwa, Sri Lanka": {
    si: "43PR+J7P, A1, \u0db1\u0dd2\u0da7\u0dca\u0da7\u0db9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "43PR+J7P, A1, \u0ba8\u0bbf\u0b9f\u0bcd\u0b9f\u0bae\u0bcd\u0baa\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "43RV+PQV, A1, Nittambuwa, Sri Lanka": {
    si: "43RV+PQV, A1, \u0db1\u0dd2\u0da7\u0dca\u0da7\u0db9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "43RV+PQV, A1, \u0ba8\u0bbf\u0b9f\u0bcd\u0b9f\u0bae\u0bcd\u0baa\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "43VW+XFV, A1, Nittambuwa, Sri Lanka": {
    si: "43VW+XFV, A1, \u0db1\u0dd2\u0da7\u0dca\u0da7\u0db9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "43VW+XFV, A1, \u0ba8\u0bbf\u0b9f\u0bcd\u0b9f\u0bae\u0bcd\u0baa\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "44 Negombo Rd, Kandana 11320, Sri Lanka": {
    si: "44 \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0d9a\u0db3\u0dcf\u0db1 11320, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "44 \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0ba8\u0bcd\u0ba4\u0bbe\u0ba9\u0bc8 11320, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "44 Ratnapura Road, Horana, Sri Lanka": {
    si: "44 \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb \u0db4\u0dcf\u0dbb, \u0dc4\u0ddc\u0dbb\u0dab, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "44 \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0bca\u0bb0\u0ba3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "444G+277, Dodanduwa, Sri Lanka": {
    si: "444G+277, \u0daf\u0ddc\u0da9\u0db1\u0dca\u0daf\u0dd6\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "444G+277, \u0b9f\u0bcb\u0b9f\u0ba9\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "447P+92F, Hunupola, Sri Lanka": {
    si: "447P+92F, \u0dc4\u0dd4\u0dab\u0dd4\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "447P+92F, Hunupola, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "44FC+VFH, Main St, Hambantota, Sri Lanka": {
    si: "44FC+VFH, Main St, Hambantota, Sri Lanka",
    ta: "44FC+VFH, Main St, Hambantota, Sri Lanka",
  },
  "44FG+RCV, Kachcheri Rd, Hambantota, Sri Lanka": {
    si: "44FG+RCV, \u0d9a\u0da0\u0dca\u0da0\u0dda\u0dbb\u0dd2 \u0db4\u0dcf\u0dbb, \u0dc4\u0db8\u0dca\u0db6\u0db1\u0dca\u0dad\u0ddc\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "44FG+RCV, \u0b95\u0b9a\u0bcd\u0b9a\u0bc7\u0bb0\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "44FH+5G5, Hambantota, Sri Lanka": {
    si: "44FH+5G5, \u0dc4\u0db8\u0dca\u0db6\u0db1\u0dca\u0dad\u0ddc\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "44FH+5G5, \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "44RP+PQ5, Hikkaduwa - Baddegama Rd, Gonapinuwala, Sri Lanka": {
    si: "44RP+PQ5, \u0dc4\u0dd2\u0d9a\u0dca\u0d9a\u0da9\u0dd4\u0dc0 - \u0db6\u0daf\u0dca\u0daf\u0dda\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0d9c\u0ddd\u0db1\u0dcf\u0db4\u0dd3\u0db1\u0dd4\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "44RP+PQ5, \u0bb9\u0bbf\u0b95\u0bcd\u0b95\u0b9f\u0bc1\u0bb5\u0bbe - \u0baa\u0ba4\u0bcd\u0ba4\u0bc7\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bcb\u0ba9\u0bbe\u0baa\u0bbf\u0ba9\u0bc1\u0bb5\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "44VQ+574, Gonapinuwala, Sri Lanka": {
    si: "44VQ+574, \u0d9c\u0ddd\u0db1\u0dcf\u0db4\u0dd3\u0db1\u0dd4\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "44VQ+574, \u0b95\u0bcb\u0ba9\u0bbe\u0baa\u0bbf\u0ba9\u0bc1\u0bb5\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "45 Colombo - Horana Rd, Piliyandala": {
    si: "45 \u0d9a\u0ddc\u0dc5\u0db9 - \u0dc4\u0ddc\u0dbb\u0dab \u0db4\u0dcf\u0dbb, \u0db4\u0dd2\u0dc5\u0dd2\u0dba\u0db1\u0dca\u0daf\u0dbd",
    ta: "45 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bb9\u0bca\u0bb0\u0ba3 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bbf\u0bb2\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bb2\u0bc8",
  },
  "45 Minuwangoda Rd, Kotugoda, Sri Lanka": {
    si: "45 \u0db8\u0dd2\u0db1\u0dd4\u0dc0\u0db1\u0dca\u0d9c\u0ddc\u0da9 \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0da7\u0dd4\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "45 \u0bae\u0bbf\u0ba9\u0bc1\u0bb5\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bca\u0b9f\u0bc1\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "45/1 Main Street, Piliyandala, Moratuwa 10400, Sri Lanka": {
    si: "45/1 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc0\u0dd3\u0daf\u0dd2\u0dba, \u0db4\u0dd2\u0dc5\u0dd2\u0dba\u0db1\u0dca\u0daf\u0dbd, \u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0 10400, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "45/1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bbf\u0bb2\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bb2\u0bbe, \u0bae\u0bca\u0bb0\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe 10400, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "452 debarawawe, Tissamaharama Rd, Debarawewa, Sri Lanka": {
    si: "452 \u0daf\u0dd9\u0db6\u0dbb\u0dc0\u0dcf\u0dc0\u0dda, \u0dad\u0dd2\u0dc3\u0dca\u0dc3\u0db8\u0dc4\u0dcf\u0dbb\u0dcf\u0db8 \u0db4\u0dcf\u0dbb, \u0daf\u0dd9\u0db6\u0dbb\u0dc0\u0dd0\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "452 \u0b9f\u0bbf\u0baa\u0bb0\u0bb5\u0bbe\u0bb5\u0bc7, \u0ba4\u0bbf\u0bb8\u0bcd\u0bb8\u0bae\u0bb9\u0bbe\u0bb0\u0bbe\u0bae \u0bb0\u0bcb\u0b9f\u0bc1, \u0ba4\u0bc6\u0baa\u0bb0\u0bb5\u0bc6\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "45B AB10, Colombo, Sri Lanka": {
    si: "45B AB10, \u0d9a\u0ddc\u0dc5\u0db9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "45B AB10, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "46 Kandy Rd, Matale, Sri Lanka": {
    si: "46 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0db8\u0dcf\u0dad\u0dbd\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "46 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "468 Colombo - Kandy Rd, Kadawatha": {
    si: "468 \u0d9a\u0ddc\u0dc5\u0db9 - \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0da9\u0dc0\u0dad",
    ta: "468 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0b95\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8",
  },
  "468 Kandy Rd, Kadawatha, Sri Lanka": {
    si: "468 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0da9\u0dc0\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "468 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4687+8JV, B128, Poddala, Sri Lanka": {
    si: "4687+8JV, B128, \u0db4\u0ddd\u0daf\u0dca\u0daf\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4687+8JV, B128, Poddala, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "469 Kandy Road Sardhapura A6, Sardhapura, Sri Lanka": {
    si: "469 \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb \u0dc3\u0dbb\u0dca\u0db0\u0dcf\u0db4\u0dd4\u0dbb A6, \u0dc3\u0dbb\u0dca\u0db0\u0dcf\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "469 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8 \u0b9a\u0bb0\u0bcd\u0ba4\u0bbe\u0baa\u0bc1\u0bb0\u0bbe A6, \u0b9a\u0bb0\u0bcd\u0ba4\u0bbe\u0baa\u0bc1\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "469, Kandy Road Sardhapura A6, Sardhapura": {
    si: "469, \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb \u0dc3\u0dbb\u0dca\u0db0\u0dcf\u0db4\u0dd4\u0dbb A6, \u0dc3\u0dbb\u0dca\u0db0\u0dcf\u0db4\u0dd4\u0dbb",
    ta: "469, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf \u0b9a\u0bb0\u0bcd\u0ba4\u0baa\u0bc1\u0bb0 A6, \u0b9a\u0bb0\u0bcd\u0ba4\u0baa\u0bc1\u0bb0",
  },
  "47 Mawanella - Hemmaththagama - Singhapitiya, Mawanella 71500, Sri Lanka": {
    si: "47 \u0db8\u0dcf\u0dc0\u0db1\u0dd0\u0dbd\u0dca\u0dbd - \u0dc4\u0dd9\u0db8\u0dca\u0db8\u0dad\u0dca\u0dad\u0d9c\u0db8 - \u0dc3\u0dd2\u0d82\u0dc4\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0db8\u0dcf\u0dc0\u0db1\u0dd0\u0dbd\u0dca\u0dbd 71500, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "47 \u0bae\u0bbe\u0bb5\u0ba9\u0bb2\u0bcd\u0bb2 - \u0bb9\u0bc6\u0bae\u0bcd\u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0b95\u0bae - \u0b9a\u0bbf\u0b99\u0bcd\u0b95\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0bae\u0bbe\u0bb5\u0ba9\u0bc6\u0bb2\u0bcd\u0bb2 71500, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "47M3+XV2, Wanduramba, Sri Lanka": {
    si: "47M3+XV2, \u0dc0\u0db3\u0dd4\u0dbb\u0db8\u0dca\u0db6, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "47M3+XV2, \u0bb5\u0ba8\u0bcd\u0ba4\u0bc1\u0bb0\u0bae\u0bcd\u0baa\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "48GH+R6 Mallavi, Sri Lanka": {
    si: "48GH+R6 \u0db8\u0dbd\u0dca\u0dbd\u0dcf\u0dc0\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "48GH+R6 \u0bae\u0bb2\u0bcd\u0bb2\u0bbe\u0bb5\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "48M6+XGH, Mankulam-Vellankulam Rd, Mallavi, Sri Lanka": {
    si: "48M6+XGH, \u0db8\u0dcf\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca-\u0dc0\u0dd9\u0dbd\u0dca\u0dbd\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca \u0db4\u0dcf\u0dbb, \u0db8\u0dbd\u0dca\u0dbd\u0dcf\u0dc0\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "48M6+XGH, \u0bae\u0bbe\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd-\u0bb5\u0bc6\u0bb3\u0bcd\u0bb3\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1, \u0bae\u0bb2\u0bcd\u0bb2\u0bbe\u0bb5\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "49 Hatton Rd, Ginigathhena 20680, Sri Lanka": {
    si: "49 \u0dc4\u0dd0\u0da7\u0db1\u0dca \u0db4\u0dcf\u0dbb, \u0d9c\u0dd2\u0db1\u0dd2\u0d9c\u0dad\u0dca\u0dc4\u0dda\u0db1 20680, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "49 \u0bb9\u0b9f\u0bcd\u0b9f\u0ba9\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bbf\u0ba9\u0bbf\u0b95\u0ba4\u0bcd\u0ba4\u0bc7\u0ba9\u0bc8 20680, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "491 Colombo - Galle Main Rd, Wadduwa, Sri Lanka": {
    si: "491 \u0d9a\u0ddc\u0dc5\u0db9 - \u0d9c\u0dcf\u0dbd\u0dca\u0dbd \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0dc0\u0dcf\u0daf\u0dca\u0daf\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "491 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bbe\u0bb2\u0bbf \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bbe\u0ba4\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "493 Puttalam Road, Wennappuwa": {
    si: "493 \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 \u0db4\u0dcf\u0dbb, \u0dc0\u0dd9\u0db1\u0dca\u0db1\u0db4\u0dca\u0db4\u0dd4\u0dc0",
    ta: "493 \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bc6\u0ba9\u0bcd\u0ba9\u0baa\u0bcd\u0baa\u0bc1\u0bb5",
  },
  "4943+73G, B480, Yakkalamulla, Sri Lanka": {
    si: "4943+73G, B480, \u0dba\u0d9a\u0dca\u0d9a\u0dbd\u0db8\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4943+73G, B480, \u0baf\u0b95\u0bcd\u0b95\u0bb2\u0bae\u0bc1\u0bb2\u0bcd\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4CMV+2WF, Mankulam, Sri Lanka": {
    si: "4CMV+2WF, \u0db8\u0dcf\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4CMV+2WF, \u0bae\u0bbe\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4CW6+V2J, Talawa Rd, Eppawala, Sri Lanka": {
    si: "4CW6+V2J, \u0dad\u0dbd\u0dcf\u0dc0 \u0db4\u0dcf\u0dbb, \u0d91\u0db4\u0dca\u0db4\u0dcf\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4CW6+V2J, \u0ba4\u0bb2\u0bc8\u0bb5\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0b8e\u0baa\u0bcd\u0baa\u0bbe\u0bb5\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4F2G+3R6 IOC Filling Station, Ketanwila Road, Akuressa, Sri Lanka": {
    si: "4F2G+3R6 IOC \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0dd0\u0da7\u0db1\u0dca\u0dc0\u0dd2\u0dbd \u0db4\u0dcf\u0dbb, \u0d85\u0d9a\u0dd4\u0dbb\u0dd0\u0dc3\u0dca\u0dc3, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4F2G+3R6 IOC \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0bc7\u0ba4\u0ba9\u0bcd\u0bb5\u0bbf\u0bb2 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b85\u0b95\u0bc1\u0bb0\u0bc6\u0bb8\u0bcd\u0bb8\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4GGH+PRP, Sri Lanka": {
    si: "4GGH+PRP, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4GGH+PRP, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4HG5+67P, Urubokka Road, Ransagoda, Sri Lanka": {
    si: "4HG5+67P, \u0d8c\u0dbb\u0dd4\u0db6\u0ddc\u0d9a\u0dca\u0d9a \u0db4\u0dcf\u0dbb, \u0dbb\u0db1\u0dca\u0dc3\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4HG5+67P, \u0b8a\u0bb0\u0bc1\u0baa\u0bca\u0b95\u0bcd\u0b95 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb0\u0ba9\u0bcd\u0b9a\u0b95\u0bca\u0b9f, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4HH9+2P Wadinagala, Sri Lanka": {
    si: "4HH9+2P \u0dc0\u0da9\u0dd2\u0db1\u0dcf\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4HH9+2P \u0bb5\u0b9f\u0bbf\u0ba9\u0bbe\u0b95\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4HJ6+CPP, Maradankadawala, Sri Lanka": {
    si: "4HJ6+CPP, \u0db8\u0dbb\u0daf\u0db1\u0dca\u0d9a\u0da9\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4HJ6+CPP, \u0bae\u0bb0\u0ba4\u0ba9\u0bcd\u0b95\u0b9f\u0bb5\u0bbe\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4JX4+GXX, B98, Deiyandara, Sri Lanka": {
    si: "4JX4+GXX, B98, \u0daf\u0dd9\u0dba\u0dd2\u0dba\u0db1\u0dca\u0daf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4JX4+GXX, B98, \u0ba4\u0bc6\u0baf\u0bcd\u0baf\u0ba8\u0bcd\u0ba4\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4P2H+6J Talaimannar, Sri Lanka": {
    si: "4P2H+6J \u0dad\u0dbd\u0dd9\u0dba\u0dd2\u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4P2H+6J \u0ba4\u0bb2\u0bc8\u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4P4H+8PV, Talaimannar Pier, Sri Lanka": {
    si: "4P4H+8PV, \u0dad\u0dbd\u0dd9\u0dba\u0dd2\u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8 \u0db4\u0dd2\u0dba\u0dbb\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4P4H+8PV, \u0ba4\u0bb2\u0bc8\u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd \u0baa\u0bc8\u0baf\u0bb0\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4P85+CW Thalawila, Sri Lanka": {
    si: "4P85+CW \u0dad\u0dbd\u0dc0\u0dd2\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4P85+CW \u0ba4\u0bb2\u0bb5\u0bbf\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4QX6+HP5, Weeraketiya, Sri Lanka": {
    si: "4QX6+HP5, \u0dc0\u0dd3\u0dbb\u0d9a\u0dd0\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4QX6+HP5, \u0bb5\u0bc0\u0bb0\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4QX7+6C7, Weeraketiya, Sri Lanka": {
    si: "4QX7+6C7, \u0dc0\u0dd3\u0dbb\u0d9a\u0dd0\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4QX7+6C7, \u0bb5\u0bc0\u0bb0\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4QXM+HX8, Haragama Rd, Rikillagaskada, Sri Lanka": {
    si: "4QXM+HX8, \u0dc4\u0dcf\u0dbb\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0dbb\u0dd2\u0d9a\u0dd2\u0dbd\u0dca\u0dbd\u0d9c\u0dc3\u0dca\u0d9a\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4QXM+HX8, \u0bb9\u0bb0\u0b95\u0bae\u0bbe \u0bb0\u0bcb\u0b9f\u0bc1, \u0bb0\u0bbf\u0b95\u0bbf\u0bb2\u0bcd\u0bb2\u0b95\u0bb8\u0bcd\u0b95\u0b9f, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4Th Mile Post, Peliyagoda, Sri Lanka": {
    si: "4 \u0dc0\u0db1 \u0dc3\u0dd0\u0dad\u0db4\u0dd4\u0db8\u0dca \u0d9a\u0dab\u0dd4\u0dc0, \u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4\u0bb5\u0ba4\u0bc1 \u0bae\u0bc8\u0bb2\u0bcd \u0baa\u0bcb\u0bb8\u0bcd\u0b9f\u0bcd, \u0baa\u0bc7\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4VC2+2V, Thambiluvil, Sri Lanka": {
    si: "4VC2+2V, \u0dad\u0db8\u0dca\u0db6\u0dd2\u0dbd\u0dd4\u0dc0\u0dd2\u0dbd\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4VC2+2V, \u0ba4\u0bae\u0bcd\u0baa\u0bbf\u0bb2\u0bc1\u0bb5\u0bbf\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4VCH+VHV, Bandarawatta, West, Sri Lanka": {
    si: "4VCH+VHV, \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0dc0\u0dad\u0dca\u0dad, \u0db6\u0da7\u0dc4\u0dd2\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4VCH+VHV, \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0bae\u0bc7\u0bb1\u0bcd\u0b95\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4VJG+Q8P, Negombo, Sri Lanka": {
    si: "4VJG+Q8P, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4VJG+Q8P, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4VW4+4GX, Mahaweli Raja Mawatha, Keerthibandarapura, Sri Lanka": {
    si: "4VW4+4GX, \u0db8\u0dc4\u0dc0\u0dd0\u0dbd\u0dd2 \u0dbb\u0da2 \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0dd3\u0dbb\u0dca\u0dad\u0dd2\u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4VW4+4GX, \u0bae\u0b95\u0bbe\u0bb5\u0bb2\u0bbf \u0bb0\u0bbe\u0b9c\u0bbe \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bc0\u0bb0\u0bcd\u0ba4\u0bcd\u0ba4\u0bbf\u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0baa\u0bc1\u0bb0, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4VWV+8Q3 Kuswala Fuel Station, Katunayake, Sri Lanka": {
    si: "4VWV+8Q3 \u0d9a\u0dd4\u0dc3\u0dca\u0dc0\u0dbd \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0da7\u0dd4\u0db1\u0dcf\u0dba\u0d9a, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4VWV+8Q3 \u0b95\u0bc1\u0bb8\u0bcd\u0bb5\u0bbe\u0bb2\u0bbe \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4W5J+W99, Hungama, Sri Lanka": {
    si: "4W5J+W99, \u0dc4\u0dd4\u0d82\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4W5J+W99, \u0bb9\u0b99\u0bcd\u0b95\u0bbe\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4WF9+742, Kotugoda Road, Katunayake, Sri Lanka": {
    si: "4WF9+742, \u0d9a\u0ddc\u0da7\u0dd4\u0d9c\u0ddc\u0da9 \u0db4\u0dcf\u0dbb, \u0d9a\u0da7\u0dd4\u0db1\u0dcf\u0dba\u0d9a, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4WF9+742, \u0b95\u0bca\u0b9f\u0bc1\u0b95\u0bca\u0b9f \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4WJG+RGG, Gampaha, Sri Lanka": {
    si: "4WJG+RGG, \u0d9c\u0db8\u0dca\u0db4\u0dc4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4WJG+RGG, \u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4X5G+F5Q, Nonagama, Sri Lanka": {
    si: "4X5G+F5Q, \u0db1\u0ddd\u0db1\u0dcf\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4X5G+F5Q, \u0ba8\u0bcb\u0ba9\u0bbe\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4XGJ+MCF, Udugampola, Sri Lanka": {
    si: "4XGJ+MCF, \u0d8b\u0da9\u0dd4\u0d9c\u0db8\u0dca\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4XGJ+MCF, \u0b89\u0b9f\u0bc1\u0b95\u0bae\u0bcd\u0baa\u0bca\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4XR8+G2X, Medirigiriya, Sri Lanka": {
    si: "4XR8+G2X, \u0db8\u0dd0\u0daf\u0dd2\u0dbb\u0dd2\u0d9c\u0dd2\u0dbb\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4XR8+G2X, \u0bae\u0bc6\u0ba4\u0bbf\u0bb0\u0bbf\u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "4XR9+QQ9, Medirigiriya, Sri Lanka": {
    si: "4XR9+QQ9, \u0db8\u0dd0\u0daf\u0dd2\u0dbb\u0dd2\u0d9c\u0dd2\u0dbb\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "4XR9+QQ9, \u0bae\u0bc6\u0ba4\u0bbf\u0bb0\u0bbf\u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5 Colombo - Ratnapura - Wellawaya - Batticaloa Rd, Kalmunai 32300, Sri Lanka":
    {
      si: "5 \u0d9a\u0ddc\u0dc5\u0db9 - \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb - \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4 \u0db4\u0dcf\u0dbb, \u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda 32300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "5 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf - \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 \u0bb0\u0bcb\u0b9f\u0bc1, \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8 32300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "5 Peradeniya - Badulla - Chenkaladi Hwy, Udapalatha, Sri Lanka": {
    si: "5 \u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba - \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd - \u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2 Hwy, \u0d8b\u0da9\u0db4\u0dbd\u0dcf\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5 \u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8 - \u0baa\u0ba4\u0bc1\u0bb3\u0bc8 - \u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf Hwy, Udapalatha, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "51, Main Street, Sri Lanka": {
    si: "51, \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc0\u0dd3\u0daf\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "51, \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "51, Meegahajandura Rd, Sooriyawewa": {
    si: "51, \u0db8\u0dd3\u0d9c\u0dc4\u0da2\u0db3\u0dd4\u0dbb \u0db4\u0dcf\u0dbb, \u0dc3\u0dd6\u0dbb\u0dd2\u0dba\u0dc0\u0dd0\u0dc0",
    ta: "51, \u0bae\u0bc0\u0b95\u0bb9\u0b9c\u0ba8\u0bcd\u0ba4\u0bc1\u0bb0 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b9a\u0bc2\u0bb0\u0bbf\u0baf\u0bb5\u0bc6\u0bb5",
  },
  "524W+V9J, Rajamal Uyana Mawatha, Veyangoda 11100, Sri Lanka": {
    si: "524W+V9J, \u0dbb\u0da2\u0db8\u0dbd\u0dca \u0d8b\u0dba\u0db1 \u0db8\u0dcf\u0dc0\u0dad, \u0dc0\u0dda\u0dba\u0db1\u0dca\u0d9c\u0ddc\u0da9 11100, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "524W+V9J, \u0bb0\u0bbe\u0b9c\u0bae\u0bb2\u0bcd \u0b89\u0baf\u0ba9 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0bb5\u0bc7\u0baf\u0b99\u0bcd\u0b95\u0bca\u0b9f 11100, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "529 Bandarawela By Pass Rd, Bandarawela, Sri Lanka": {
    si: "529 \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0dc0\u0dd9\u0dbd \u0db6\u0dba\u0dd2\u0db4\u0dcf\u0dc3\u0dca \u0db4\u0dcf\u0dbb, \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "529 \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0bb5\u0bb3\u0bc8 \u0baa\u0bc8 \u0baa\u0bbe\u0bb8\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1, \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0bb5\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "52A Rattagala - Gonagaldeniya Rd, Waharaka, Sri Lanka": {
    si: "52A \u0dbb\u0da7\u0dca\u0da7\u0d9c\u0dbd - \u0d9c\u0ddd\u0db1\u0d9c\u0dbd\u0dca\u0daf\u0dd9\u0dab\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0dc0\u0dc4\u0dbb\u0d9a, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "52A \u0bb0\u0b9f\u0bcd\u0b9f\u0b95\u0bb2 - \u0b95\u0bcb\u0ba9\u0b95\u0bb2\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bb9\u0bb0\u0b95, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5335+MH2, Veyangoda 11100, Sri Lanka": {
    si: "5335+MH2, \u0dc0\u0dda\u0dba\u0db1\u0dca\u0d9c\u0ddc\u0da9 11100, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5335+MH2, \u0bb5\u0bc7\u0baf\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe 11100, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5337+H4Q Pubic Hospital(OPD), Veyangoda 11100, Sri Lanka": {
    si: "5337+H4Q \u0db8\u0dc4\u0da2\u0db1 \u0dbb\u0ddd\u0dc4\u0dbd (OPD), \u0dc0\u0dda\u0dba\u0db1\u0dca\u0d9c\u0ddc\u0da9 11100, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5337+H4Q \u0baa\u0bca\u0ba4\u0bc1 \u0bae\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb5\u0bae\u0ba9\u0bc8(OPD), \u0bb5\u0bc7\u0baf\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe 11100, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "534 New Hunupitiya Rd, Kelaniya": {
    si: "534 \u0db1\u0dc0 \u0dc4\u0dd4\u0dab\u0dd4\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0d9a\u0dd0\u0dbd\u0dab\u0dd2\u0dba",
    ta: "534 \u0baa\u0bc1\u0ba4\u0bbf\u0baf \u0bb9\u0bc1\u0ba9\u0bc1\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb3\u0ba9\u0bbf",
  },
  "539/3A B214, Sri Lanka": {
    si: "539/3A B214, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "539/3A B214, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "53VW+4P4, Kahawa - Batapola Rd, Meetiyagoda 80330, Sri Lanka": {
    si: "53VW+4P4, \u0d9a\u0dc4\u0dc0 - \u0db6\u0da7\u0db4\u0ddc\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dd3\u0da7\u0dd2\u0dba\u0dcf\u0d9c\u0ddc\u0da9 80330, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "53VW+4P4, \u0b95\u0bb9\u0bbe\u0bb5\u0bbe - \u0baa\u0b9f\u0baa\u0bca\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bc0\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0bbe\u0b95\u0bca\u0b9f 80330, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "53XV+62X, Kaleliya - Medagampitiya Rd, Pallewela, Sri Lanka": {
    si: "53XV+62X, \u0d9a\u0dbd\u0dca\u0d91\u0dbd\u0dd2\u0dba - \u0db8\u0dd0\u0daf\u0d9c\u0db8\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db4\u0dbd\u0dca\u0dbd\u0dd9\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "53XV+62X, \u0b95\u0bb2\u0bc7\u0bb2\u0bbf\u0baf\u0bbe - \u0bae\u0bc6\u0ba4\u0b95\u0bae\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0bb2\u0bcd\u0bb2\u0bc7\u0bb5\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "53XW+CR Kalaoya, Sri Lanka": {
    si: "53XW+CR \u0d9a\u0dbd\u0dcf\u0d94\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "53XW+CR \u0b95\u0bb2\u0bbe\u0b93\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "54 St Anthony's Mawatha, Colombo - 07": {
    si: "54 \u0dc1\u0dcf\u0db1\u0dca\u0dad \u0d85\u0db1\u0dca\u0dad\u0ddd\u0db1\u0dd2 \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 - 07",
    ta: "54 \u0baa\u0bc1\u0ba9\u0bbf\u0ba4 \u0b85\u0ba8\u0bcd\u0ba4\u0bcb\u0ba9\u0bbf \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - 07",
  },
  "542 Ambepussa - Kurunegala - Trincomalee Hwy, Dambulla, Sri Lanka": {
    si: "542 \u0d85\u0db9\u0dda\u0db4\u0dd4\u0dc3\u0dca\u0dc3 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "542 \u0b85\u0bae\u0bcd\u0baa\u0bc7\u0baa\u0bc1\u0bb8\u0bcd\u0bb8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "542 Oddumadam Road, Jaffna": {
    si: "542 \u0d94\u0da9\u0dca\u0da9\u0dd4\u0db8\u0da9\u0db8\u0dca \u0db4\u0dcf\u0dbb, \u0dba\u0dcf\u0db4\u0db1\u0dba",
    ta: "542 \u0b93\u0b9f\u0bcd\u0b9f\u0bc1\u0bae\u0b9f\u0bae\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd",
  },
  "542a B123, Talagala, Sri Lanka": {
    si: "542a B123, \u0dad\u0dbd\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "542a B123, \u0ba4\u0bb2\u0b95\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "543W+C26, Hambantota, Sri Lanka": {
    si: "543W+C26, \u0dc4\u0db8\u0dca\u0db6\u0db1\u0dca\u0dad\u0ddc\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "543W+C26, \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "549F+2GV, Pasyala, Sri Lanka": {
    si: "549F+2GV, \u0db4\u0dc3\u0dca\u0dba\u0dcf\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "549F+2GV, \u0baa\u0bb8\u0bcd\u0baf\u0bbe\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "54M8+472, Veyangoda, Sri Lanka": {
    si: "54M8+472, \u0dc0\u0dda\u0dba\u0db1\u0dca\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "54M8+472, \u0bb5\u0bc7\u0baf\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "54MQ+2FP Lanka Filing Station Aluthwala, Aluthwala, Sri Lanka": {
    si: "54MQ+2FP \u0dbd\u0d82\u0d9a\u0dcf \u0d9c\u0ddc\u0db1\u0dd4 \u0d9a\u0dd2\u0dbb\u0dd3\u0db8\u0dda \u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba \u0d85\u0dbd\u0dd4\u0dad\u0dca\u0dc0\u0dbd, \u0d85\u0dbd\u0dd4\u0dad\u0dca\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "54MQ+2FP \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba4\u0bbe\u0b95\u0bcd\u0b95\u0bb2\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd \u0b85\u0bb2\u0bc1\u0ba4\u0bcd\u0bb5\u0bbe\u0bb2\u0bbe, \u0b85\u0bb2\u0bc1\u0ba4\u0bcd\u0bb5\u0bbe\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "559H+RM5, Baddegama, Sri Lanka": {
    si: "559H+RM5, \u0db6\u0daf\u0dca\u0daf\u0dda\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "559H+RM5, \u0baa\u0ba4\u0bcd\u0ba4\u0bc7\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "55JR+8Q9, Nayapamulla - Unanwitiya - Nagoda, Baddegama, Sri Lanka": {
    si: "55JR+8Q9, \u0db1\u0dcf\u0dba\u0db4\u0db8\u0dd4\u0dbd\u0dca\u0dbd - \u0d8b\u0db1\u0db1\u0dca\u0dc0\u0dd2\u0da7\u0dd2\u0dba - \u0db1\u0dcf\u0d9c\u0ddc\u0da9, \u0db6\u0daf\u0dca\u0daf\u0dda\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "55JR+8Q9, \u0ba8\u0baf\u0baa\u0bae\u0bc1\u0bb2\u0bcd\u0bb2 - \u0b89\u0ba9\u0ba9\u0bcd\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf - \u0ba8\u0bbe\u0b95\u0bca\u0b9f, \u0baa\u0ba4\u0bcd\u0ba4\u0bc7\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "55V2+7P2, Colombo - Kandy Rd, Weweldeniya, Sri Lanka": {
    si: "55V2+7P2, \u0d9a\u0ddc\u0dc5\u0db9 - \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dc0\u0dda\u0dc0\u0dd0\u0dbd\u0dca\u0daf\u0dd9\u0dab\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "55V2+7P2, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0bb5\u0bc6\u0bb5\u0bc6\u0bb2\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "55X3+5WC, A1, Weweldeniya, Sri Lanka": {
    si: "55X3+5WC, A1, \u0dc0\u0dda\u0dc0\u0dd0\u0dbd\u0dca\u0daf\u0dd9\u0dab\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "55X3+5WC, A1, Weweldeniya, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "55a S. De S. Jayasinghe Mawatha, Nugegoda, Sri Lanka": {
    si: "55a \u0d91\u0dc3\u0dca. \u0daf \u0d91\u0dc3\u0dca. \u0da2\u0dba\u0dc3\u0dd2\u0d82\u0dc4 \u0db8\u0dcf\u0dc0\u0dad, \u0db1\u0dd4\u0d9c\u0dda\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "55a S. De S. \u0b9c\u0bc6\u0baf\u0b9a\u0bbf\u0b99\u0bcd\u0b95 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0ba8\u0bc1\u0b95\u0bc7\u0b95\u0bca\u0b9f, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "561/60, Maithripala Senanayake Mawatha, Anuradhapura, Sri Lanka": {
    si: "561/60, \u0db8\u0ddb\u0dad\u0dca\u200d\u0dbb\u0dd3\u0db4\u0dcf\u0dbd \u0dc3\u0dda\u0db1\u0dcf\u0db1\u0dcf\u0dba\u0d9a \u0db8\u0dcf\u0dc0\u0dad, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "561/60, \u0bae\u0bc8\u0ba4\u0bcd\u0ba4\u0bbf\u0bb0\u0bbf\u0baa\u0bbe\u0bb2 \u0b9a\u0bc7\u0ba9\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "562 Negombo Rd, Ragama 11010, Sri Lanka": {
    si: "562 \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0dbb\u0dcf\u0d9c\u0db8 11010, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "562 \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb0\u0bbe\u0b95\u0bae 11010, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "562C+J7X, Rajanganaya, Sri Lanka": {
    si: "562C+J7X, \u0dbb\u0dcf\u0da2\u0dcf\u0d82\u0d9c\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "562C+J7X, \u0bb0\u0bbe\u0b9c\u0bbe\u0b99\u0bcd\u0b95\u0ba9\u0bc8\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "564F+4HF, Bibile, Sri Lanka": {
    si: "564F+4HF, \u0db6\u0dd2\u0db6\u0dd2\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "564F+4HF, \u0baa\u0bbf\u0baa\u0bbf\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "564F+4M3, Peradeniya-Badulla-Chenkaladi Hwy, Bibile, Sri Lanka": {
    si: "564F+4M3, \u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba-\u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd-\u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2 Hwy, \u0db6\u0dd2\u0db6\u0dd2\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "564F+4M3, \u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8-\u0baa\u0ba4\u0bc1\u0bb3\u0bc8-\u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf Hwy, \u0baa\u0bbf\u0baa\u0bbf\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "566 Elvitigala Mawatha, Colombo 00700, Sri Lanka": {
    si: "566 \u0d87\u0dbd\u0dca\u0dc0\u0dd2\u0da7\u0dd2\u0d9c\u0dbd \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 00700, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "566 \u0b8e\u0bb2\u0bcd\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bb2 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00700, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "566G+24C, Bibile, Sri Lanka": {
    si: "566G+24C, \u0db6\u0dd2\u0db6\u0dd2\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "566G+24C, \u0baa\u0bbf\u0baa\u0bbf\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "567C+P9X, Rajanganaya, Sri Lanka": {
    si: "567C+P9X, \u0dbb\u0dcf\u0da2\u0dcf\u0d82\u0d9c\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "567C+P9X, \u0bb0\u0bbe\u0b9c\u0bbe\u0b99\u0bcd\u0b95\u0ba9\u0bc8\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "568 Trincomalee Hwy,  , Sri Lanka": {
    si: "568 \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "568 \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 Hwy, , \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "572F+GH8, Wanduramba - Mapalagama Rd, Aralliya Urala, Sri Lanka": {
    si: "572F+GH8, \u0dc0\u0db3\u0dd4\u0dbb\u0db9 - \u0db8\u0dcf\u0db4\u0dbd\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0d85\u0dbb\u0dbd\u0dd2\u0dba \u0d8c\u0dbb\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "572F+GH8, \u0bb5\u0ba8\u0bcd\u0ba4\u0bc1\u0bb0\u0bae\u0bcd\u0baa\u0bbe - \u0bae\u0bbe\u0baa\u0bb2\u0b95\u0bae \u0b9a\u0bbe\u0bb2\u0bc8, \u0b85\u0bb0\u0bb2\u0bcd\u0bb2\u0bbf\u0baf \u0b89\u0bb0\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "573W+WFV, Tambuttegama, Sri Lanka": {
    si: "573W+WFV, \u0dad\u0db9\u0dd4\u0dad\u0dca\u0dad\u0dda\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "573W+WFV, \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bc7\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "587, Pamunugama Road, Thalahena, Negombo, Sri Lanka": {
    si: "587, \u0db4\u0db8\u0dd4\u0dab\u0dd4\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0dad\u0dbd\u0dcf\u0dc4\u0dda\u0db1, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "587, \u0baa\u0bae\u0bc1\u0ba9\u0bc1\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bb2\u0bbe\u0bb9\u0bc7\u0ba9\u0bbe, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "593 Troop Centre, Sri Lanka": {
    si: "593 \u0db7\u0da7 \u0db8\u0db0\u0dca\u200d\u0dba\u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "593 \u0ba4\u0bc1\u0bb0\u0bc1\u0baa\u0bcd\u0baa\u0bc1 \u0bae\u0bc8\u0baf\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "598 Colombo - Galle - Hambantota - Wellawaya Hwy, Colombo 00300, Sri Lanka":
    {
      si: "598 \u0d9a\u0ddc\u0dc5\u0db9 - \u0d9c\u0dcf\u0dbd\u0dca\u0dbd - \u0dc4\u0db8\u0dca\u0db6\u0db1\u0dca\u0dad\u0ddc\u0da7 - \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba Hwy, \u0d9a\u0ddc\u0dc5\u0db9 00300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "598 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bbe\u0bb2\u0bbf - \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 - \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf \u0bb9\u0bc6\u0bb5\u0bcd\u0bb5\u0bbf, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "5FF5+J9V, Dippitiya, Sri Lanka": {
    si: "5FF5+J9V, \u0daf\u0dd2\u0db4\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5FF5+J9V, \u0b9f\u0bbf\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5GC2+V4M, Horewala - Hemmathagama Rd, Hemmathagama, Sri Lanka": {
    si: "5GC2+V4M, \u0dc4\u0ddc\u0dbb\u0dda\u0dc0\u0dbd - \u0dc4\u0dd9\u0db8\u0dca\u0db8\u0dcf\u0dad\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0dc4\u0dd9\u0db8\u0dca\u0db8\u0dcf\u0dad\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5GC2+V4M, Horewala - Hemmathagama Rd, Hemmathagama, Sri Lanka",
  },
  "5GF2+G8 Hemmathagama, Sri Lanka": {
    si: "5GF2+G8 \u0dc4\u0dd9\u0db8\u0dca\u0db8\u0dcf\u0dad\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5GF2+G8 \u0bb9\u0bc6\u0bae\u0bcd\u0bae\u0bbe\u0ba4\u0b95\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5H58+X3X, Gampola, Sri Lanka": {
    si: "5H58+X3X, \u0d9c\u0db8\u0dca\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5H58+X3X, \u0b95\u0bae\u0bcd\u0baa\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5H8C+JXW, Peradeniya - Badulla - Chenkaladi Hwy, Gampola, Sri Lanka": {
    si: "5H8C+JXW, \u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba - \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd - \u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2 Hwy, \u0d9c\u0db8\u0dca\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5H8C+JXW, \u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8 - \u0baa\u0ba4\u0bc1\u0bb3\u0bc8 - \u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf Hwy, \u0b95\u0bae\u0bcd\u0baa\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5HQR+MQH, Sri Lanka": {
    si: "5HQR+MQH, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5HQR+MQH, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5HXQ+PG5, Thihagoda - Kamburupitiya - Mawarala - Kotapola Rd, Mawarala, Sri Lanka":
    {
      si: "5HXQ+PG5, \u0dad\u0dd2\u0dc4\u0d9c\u0ddc\u0da9 - \u0d9a\u0db9\u0dd4\u0dbb\u0dd4\u0db4\u0dd2\u0da7\u0dd2\u0dba - \u0db8\u0dcf\u0dc0\u0dbb\u0dbd - \u0d9a\u0ddc\u0da7\u0db4\u0ddc\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dcf\u0dc0\u0dbb\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "5HXQ+PG5, \u0ba4\u0bbf\u0bb9\u0bbe\u0b95\u0bca\u0b9f - \u0b95\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bc1\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf - \u0bae\u0bbe\u0bb5\u0bb0\u0bb2 - \u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0baa\u0bca\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bb5\u0bb0\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "5M54+R9X, Oddusuddan, Sri Lanka": {
    si: "5M54+R9X, \u0d94\u0da9\u0dca\u0da9\u0dd4\u0dc3\u0dd4\u0da9\u0dcf\u0db1\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5M54+R9X, \u0b92\u0b9f\u0bcd\u0b9f\u0bc1\u0b9a\u0bc1\u0b9f\u0bcd\u0b9f\u0bbe\u0ba9\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5M5X+97H, Walasmulla, Sri Lanka": {
    si: "5M5X+97H, \u0dc0\u0dbd\u0dc3\u0dca\u0db8\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5M5X+97H, \u0bb5\u0bb2\u0bb8\u0bcd\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5MGX+4P2, Deltota, Sri Lanka": {
    si: "5MGX+4P2, \u0daf\u0dd9\u0dbd\u0dca\u0dad\u0ddc\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5MGX+4P2, \u0b9f\u0bc6\u0bb2\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5MHQ+935, Deltota, Sri Lanka": {
    si: "5MHQ+935, \u0daf\u0dd9\u0dbd\u0dca\u0dad\u0ddc\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5MHQ+935, \u0b9f\u0bc6\u0bb2\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5MX9+3X8, Galaha, Sri Lanka": {
    si: "5MX9+3X8, \u0d9c\u0dbd\u0dc4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5MX9+3X8, \u0b95\u0bb2\u0bb9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5QGH+393, Soysa Rd, Hanguranketa, Sri Lanka": {
    si: "5QGH+393, \u200b\u200b\u0dc3\u0ddc\u0dba\u0dd2\u0dc3\u0dcf \u0db4\u0dcf\u0dbb, \u0dc4\u0d9f\u0dd4\u0dbb\u0db1\u0dca\u0d9a\u0dd9\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5QGH+393, \u200b\u200bSoysa Rd, Hanguranketa, Sri Lanka",
  },
  "5RVC+JPJ, Negombo, Sri Lanka": {
    si: "5RVC+JPJ, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5RVC+JPJ, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5V4W+WX Eraminiyaya, Sri Lanka": {
    si: "5V4W+WX \u0d91\u0dbb\u0db8\u0dd2\u0dab\u0dd2\u0dba\u0dcf\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5V4W+WX \u0b8e\u0bb0\u0bbe\u0bae\u0bbf\u0ba9\u0bbf\u0baf\u0bbe\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5V5F+43J, Katunayake, Sri Lanka": {
    si: "5V5F+43J, \u0d9a\u0da7\u0dd4\u0db1\u0dcf\u0dba\u0d9a, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5V5F+43J, \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5V7X+W93, Angunakolapelessa Rd, Agunukolapelessa, Sri Lanka": {
    si: "5V7X+W93, \u0d85\u0d9f\u0dd4\u0dab\u0dd4\u0d9a\u0ddc\u0dc5\u0db4\u0dd0\u0dbd\u0dd0\u0dc3\u0dca\u0dc3 \u0db4\u0dcf\u0dbb, \u0d85\u0d9c\u0dd4\u0dab\u0dd4\u0d9a\u0ddc\u0dbd\u0db4\u0dd0\u0dbd\u0dd0\u0dc3\u0dca\u0dc3, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5V7X+W93, \u0b85\u0b99\u0bcd\u0b95\u0bc1\u0ba9\u0b95\u0bca\u0bb2\u0baa\u0bc6\u0bb2\u0bb8\u0bcd\u0bb8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0b95\u0bc1\u0ba9\u0bc1\u0b95\u0bca\u0bb2\u0baa\u0bc6\u0bb2\u0bb8\u0bcd\u0bb8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5VP6+386, Wanathavilluwa, Sri Lanka": {
    si: "5VP6+386, \u0dc0\u0db1\u0dcf\u0dad\u0dc0\u0dd2\u0dbd\u0dca\u0dbd\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5VP6+386, \u0bb5\u0ba9\u0bbe\u0ba4\u0bb5\u0bbf\u0bb2\u0bcd\u0bb2\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5VX3+9P6, Negombo, Sri Lanka": {
    si: "5VX3+9P6, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5VX3+9P6, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5W9X+VH9, Siriwardhana Rd, Minuwangoda, Sri Lanka": {
    si: "5W9X+VH9, \u0dc3\u0dd2\u0dbb\u0dd2\u0dc0\u0dbb\u0dca\u0db0\u0db1 \u0db4\u0dcf\u0dbb, \u0db8\u0dd2\u0db1\u0dd4\u0dc0\u0db1\u0dca\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5W9X+VH9, Siriwardhana Rd, Minuwangoda, Sri Lanka",
  },
  "5WGC+8XQ, Yatiyana, Sri Lanka": {
    si: "5WGC+8XQ, \u0dba\u0da7\u0dd2\u0dba\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5WGC+8XQ, \u0baf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0bbe\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5X7W+3WC, Gampaha, Sri Lanka": {
    si: "5X7W+3WC, \u0d9c\u0db8\u0dca\u0db4\u0dc4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5X7W+3WC, \u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "5a Shasanawardhanarama Rd, Homagama, Sri Lanka": {
    si: "5a \u0dc1\u0dcf\u0dc3\u0db1\u0dc0\u0dbb\u0dca\u0db0\u0db1\u0dcf\u0dbb\u0dcf\u0db8 \u0db4\u0dcf\u0dbb, \u0dc4\u0ddd\u0db8\u0dcf\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "5a \u0b9a\u0bbe\u0b9a\u0ba9\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0bb0\u0bbe\u0bae \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb9\u0bcb\u0bae\u0bbe\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "61360 Kalpitiya Rd, Kalpitiya, Sri Lanka": {
    si: "61360 \u0d9a\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0d9a\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "61360 \u0b95\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "616 Kandy-Jaffna Highway, Matale 21000, Sri Lanka": {
    si: "616 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb-\u0dba\u0dcf\u0db4\u0db1\u0dba \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0db8\u0dcf\u0dad\u0dbd\u0dda 21000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "616 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf-\u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8 21000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "618/b/1 Colombo - Batticaloa Hwy, Eheliyagoda 07": {
    si: "618/b/1 \u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 Hwy, \u0d87\u0dc4\u0dd0\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9 07",
    ta: "618/b/1 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0b8e\u0bb9\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f 07",
  },
  "618/b/1 Colombo - Batticaloa Hwy, Eheliyagoda, Sri Lanka": {
    si: "618/b/1 \u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 Hwy, \u0d87\u0dc4\u0dd0\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "618/b/1 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0b8e\u0bb9\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "626, Thirukkondaiadimadu Hwy, Polonnaruwa": {
    si: "626, \u0dad\u0dd2\u0dbb\u0dd4\u0d9a\u0dca\u0d9a\u0ddc\u0dab\u0dca\u0da9\u0dd2\u0dba\u0dcf\u0da9\u0dd2\u0db8\u0da9\u0dd4 Hwy, \u0db4\u0ddc\u0dc5\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0",
    ta: "626, \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcd\u0b95\u0bca\u0ba3\u0bcd\u0b9f\u0bc8\u0baf\u0b9f\u0bbf\u0bae\u0b9f\u0bc1 Hwy, \u0baa\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5\u0bc8",
  },
  "629 Dr Danister De Silva Mawatha, Colombo": {
    si: "629 \u0d86\u0da0\u0dcf\u0dbb\u0dca\u0dba \u0da9\u0dd0\u0db1\u0dd2\u0dc3\u0dca\u0da7\u0dbb\u0dca \u0daf \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9",
    ta: "629 \u0b9f\u0bbe\u0b95\u0bcd\u0b9f\u0bb0\u0bcd \u0b9f\u0bc7\u0ba9\u0bbf\u0bb8\u0bcd\u0b9f\u0bb0\u0bcd \u0b9f\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "6297+CMR, Divulapitiya, Sri Lanka": {
    si: "6297+CMR, \u0daf\u0dd2\u0dc0\u0dd4\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6297+CMR, \u0ba4\u0bbf\u0bb5\u0bc1\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "62F9+FFW, Divulapitiya, Sri Lanka": {
    si: "62F9+FFW, \u0daf\u0dd2\u0dc0\u0dd4\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "62F9+FFW, \u0ba4\u0bbf\u0bb5\u0bc1\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "630 Biyagama Rd, Peliyagoda": {
    si: "630 \u0db6\u0dd2\u0dba\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9",
    ta: "630 \u0baa\u0bbf\u0baf\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc7\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f",
  },
  "639 Negombo - Giriulla Rd, Sri Lanka": {
    si: "639 \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 - \u0d9c\u0dd2\u0dbb\u0dd2\u0d8b\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "639 \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "63H7+73R, Banduragoda, Sri Lanka": {
    si: "63H7+73R, \u0db6\u0db1\u0dca\u0daf\u0dd4\u0dbb\u0dcf\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "63H7+73R, \u0baa\u0bbe\u0ba3\u0bcd\u0b9f\u0bc1\u0bb0\u0bbe\u0b95\u0bcb\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "63M3+3R3, Ambalangoda, Sri Lanka": {
    si: "63M3+3R3, \u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "63M3+3R3, \u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bcb\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "64 Kalpitiya Rd, Norochcholai": {
    si: "64 \u0d9a\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db1\u0ddc\u0dbb\u0ddc\u0da0\u0dca\u0da0\u0ddd\u0dbd\u0dda",
    ta: "64 \u0b95\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bca\u0bb0\u0bcb\u0b9a\u0bcd\u0b9a\u0bcb\u0bb2\u0bc8",
  },
  "64, S. De S. Jayasinghe Mawatha": {
    si: "64, \u0d91\u0dc3\u0dca. \u0daf \u0d91\u0dc3\u0dca. \u0da2\u0dba\u0dc3\u0dd2\u0d82\u0dc4 \u0db8\u0dcf\u0dc0\u0dad",
    ta: "64, \u0b8e\u0bb8\u0bcd.\u0b9f\u0bbf. \u0b8e\u0bb8\u0bcd. \u0b9c\u0baf\u0b9a\u0bbf\u0b99\u0bcd\u0b95 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8",
  },
  "64CF+F4V, B143, Batapola, Sri Lanka": {
    si: "64CF+F4V, B143, \u0db6\u0da7\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "64CF+F4V, B143, \u0baa\u0b9f\u0baa\u0bca\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "64F7+WJQ, Kahawa - Batapola Rd, Batapola, Sri Lanka": {
    si: "64F7+WJQ, \u0d9a\u0dc4\u0dc0 - \u0db6\u0da7\u0db4\u0ddc\u0dbd \u0db4\u0dcf\u0dbb, \u0db6\u0da7\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "64F7+WJQ, \u0b95\u0bb9\u0bbe\u0bb5\u0bbe - \u0baa\u0b9f\u0baa\u0bca\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0b9f\u0baa\u0bca\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "64WH+XPH, Mirigama, Sri Lanka": {
    si: "64WH+XPH, \u0db8\u0dd3\u0dbb\u0dd2\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "64WH+XPH, \u0bae\u0bc0\u0bb0\u0bbf\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "64XJ+M6P,   -    , Mirigama, Sri Lanka": {
    si: "64XJ+M6P, - , \u0db8\u0dd3\u0dbb\u0dd2\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "64XJ+M6P, - , \u0bae\u0bc0\u0bb0\u0bbf\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "65/2,urapolard, Pugoda": {
    si: "65/2, \u0d8b\u0dbb\u0db4\u0ddc\u0dbd\u0dcf\u0dbb\u0dca\u0da9\u0dca, \u0db4\u0dd6\u0d9c\u0ddc\u0da9",
    ta: "65/2, \u0b89\u0bb0\u0baa\u0bcb\u0bb2\u0bbe\u0bb0\u0bcd\u0b9f\u0bcd, \u0baa\u0bc2\u0b95\u0bcb\u0b9f\u0bbe",
  },
  "66 Kandy Rd, Trincomalee, Sri Lanka": {
    si: "66 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "66 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "662 Eriyawetiya Rd, Kiribathgoda, Sri Lanka": {
    si: "662 \u0d8a\u0dbb\u0dd2\u0dba\u0dc0\u0dd0\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0d9a\u0dd2\u0dbb\u0dd2\u0db6\u0dad\u0dca\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "662 \u0b8e\u0bb0\u0bbf\u0baf\u0bb5\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bbf\u0bb0\u0bbf\u0baa\u0ba4\u0bcd\u0b95\u0bca\u0b9f, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "66H2+23X, Warakapola, Sri Lanka": {
    si: "66H2+23X, \u0dc0\u0dbb\u0d9a\u0dcf\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "66H2+23X, \u0bb5\u0bbe\u0bb0\u0b95\u0bcd\u0b95\u0bbe\u0baa\u0bca\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "66J2+5PQ, Warakapola, Sri Lanka": {
    si: "66J2+5PQ, \u0dc0\u0dbb\u0d9a\u0dcf\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "66J2+5PQ, \u0bb5\u0bbe\u0bb0\u0b95\u0bcd\u0b95\u0bbe\u0baa\u0bca\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "66V6+XWW, Ambepussa - Kurunegala - Trincomalee Hwy, Ambepussa, Sri Lanka": {
    si: "66V6+XWW, \u0d85\u0db9\u0dda\u0db4\u0dd4\u0dc3\u0dca\u0dc3 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba Hwy, \u0d85\u0db9\u0dda\u0db4\u0dd4\u0dc3\u0dca\u0dc3, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "66V6+XWW, \u0b85\u0bae\u0bcd\u0baa\u0bc7\u0baa\u0bc1\u0bb8\u0bcd\u0bb8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 Hwy, \u0b85\u0bae\u0bcd\u0baa\u0bc7\u0baa\u0bc1\u0bb8\u0bcd\u0bb8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "67 D S Senanayake Mawatha, Hingurakgoda, Sri Lanka": {
    si: "67 \u0da9\u0dd3 \u0d91\u0dc3\u0dca \u0dc3\u0dda\u0db1\u0dcf\u0db1\u0dcf\u0dba\u0d9a \u0db8\u0dcf\u0dc0\u0dad, \u0dc4\u0dd2\u0d9f\u0dd4\u0dbb\u0d9a\u0dca\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "67 \u0b9f\u0bbf \u0b8e\u0bb8\u0bcd \u0b9a\u0bc7\u0ba9\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0bb9\u0bbf\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0bbe\u0b95\u0bcd\u0b95\u0bca\u0b9f, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "67JH+9MG, Sri Lanka": {
    si: "67JH+9MG, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "67JH+9MG, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "67M7+Q34, Nelundeniya, Sri Lanka": {
    si: "67M7+Q34, \u0db1\u0dd9\u0dc5\u0dd4\u0db1\u0dca\u0daf\u0dd9\u0dab\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "67M7+Q34, \u0ba8\u0bc6\u0bb2\u0bc1\u0ba8\u0bcd\u0ba4\u0bc7\u0ba9\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "67f Walter Gunasekara Mawatha, Sri Jayawardenepura Kotte 11222, Sri Lanka": {
    si: "67f \u0dc0\u0ddd\u0dbd\u0dca\u0da7\u0dbb\u0dca \u0d9c\u0dd4\u0dab\u0dc3\u0dda\u0d9a\u0dbb \u0db8\u0dcf\u0dc0\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1\u0db4\u0dd4\u0dbb \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda 11222, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "67f \u0bb5\u0bbe\u0bb2\u0bcd\u0b9f\u0bb0\u0bcd \u0b95\u0bc1\u0ba3\u0b9a\u0bc7\u0b95\u0bb0 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0bb8\u0bcd\u0bb0\u0bc0 \u0b9c\u0bc6\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0baa\u0bc1\u0bb0 \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7 11222, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "67p, Urubokka Road, Ransagoda": {
    si: "67p, \u0d8c\u0dbb\u0dd4\u0db6\u0ddc\u0d9a\u0dca\u0d9a \u0db4\u0dcf\u0dbb, \u0dbb\u0db1\u0dca\u0dc3\u0d9c\u0ddc\u0da9",
    ta: "67p, \u0b8a\u0bb0\u0bc1\u0baa\u0bca\u0b95\u0bcd\u0b95 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb0\u0ba9\u0bcd\u0b9a\u0b95\u0bca\u0b9f",
  },
  "68 Bandaranaike Mawatha, Ratnapura, Sri Lanka": {
    si: "68 \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0db1\u0dcf\u0dba\u0d9a \u0db8\u0dcf\u0dc0\u0dad, \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "68 \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "68P5+3XM Threeweel Park, Galigamuwa, Sri Lanka": {
    si: "68P5+3XM \u0dad\u0dca\u200d\u0dbb\u0dd3\u0dc0\u0dd3\u0dbd\u0dca \u0d8b\u0daf\u0dca\u200d\u0dba\u0dcf\u0db1\u0dba, \u0d9c\u0dbd\u0dd2\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "68P5+3XM \u0ba4\u0bcd\u0bb0\u0bc0\u0bb5\u0bc0\u0bb2\u0bcd \u0baa\u0bbe\u0bb0\u0bcd\u0b95\u0bcd, \u0b95\u0bb2\u0bbf\u0b95\u0bae\u0bc1\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "68QJ+MFJ, Tissa - Kirinde Rd, Kirinda, Sri Lanka": {
    si: "68QJ+MFJ, \u0dad\u0dd2\u0dc3\u0dca\u0dc3 - \u0d9a\u0dd2\u0dbb\u0dd2\u0db1\u0dca\u0daf\u0dda \u0db4\u0dcf\u0dbb, \u0d9a\u0dd2\u0dbb\u0dd2\u0db1\u0dca\u0daf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "68QJ+MFJ, \u0ba4\u0bbf\u0bb8\u0bcd\u0bb8\u0bbe - \u0b95\u0bbf\u0bb0\u0bbf\u0ba3\u0bcd\u0b9f\u0bc7 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bbf\u0bb0\u0bbf\u0ba8\u0bcd\u0ba4\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "692 Matale Rd, Akurana": {
    si: "692 \u0db8\u0dcf\u0dad\u0dbd\u0dda \u0db4\u0dcf\u0dbb, \u0d85\u0d9a\u0dd4\u0dbb\u0dab",
    ta: "692 \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0b95\u0bcd\u0b95\u0bc1\u0bb0\u0ba3\u0bc8",
  },
  "69Q3+C76, Talawa, Sri Lanka": {
    si: "69Q3+C76, \u0dad\u0dbd\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "69Q3+C76, \u0ba4\u0bb2\u0bc8\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "69W4+2H, Kegalle, Sri Lanka": {
    si: "69W4+2H, \u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "69W4+2H, \u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6FX5+J2H, Mawanella, Sri Lanka": {
    si: "6FX5+J2H, \u0db8\u0dcf\u0dc0\u0db1\u0dd0\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6FX5+J2H, \u0bae\u0bbe\u0bb5\u0ba9\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6H5X+RF4, Kovilakanda, Sri Lanka": {
    si: "6H5X+RF4, \u0d9a\u0ddd\u0dc0\u0dd2\u0dbd\u0d9a\u0db1\u0dca\u0daf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6H5X+RF4, \u0b95\u0bcb\u0bb5\u0bbf\u0bb2\u0b95\u0ba3\u0bcd\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6HQJ+55 Polwatta, Sri Lanka": {
    si: "6HQJ+55 \u0db4\u0ddc\u0dbd\u0dca\u0dc0\u0dad\u0dca\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6HQJ+55 \u0baa\u0bca\u0bb2\u0bcd\u0bb5\u0ba4\u0bcd\u0ba4, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6M58+3MF, Kirama, Sri Lanka": {
    si: "6M58+3MF, \u0d9a\u0dd2\u0dbb\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6M58+3MF, \u0b95\u0bbf\u0bb0\u0bbe\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6MGC+JCJ, Hingurana, Sri Lanka": {
    si: "6MGC+JCJ, \u0dc4\u0dd2\u0d9f\u0dd4\u0dbb\u0dcf\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6MGC+JCJ, \u0bb9\u0bbf\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0bbe\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6P73+3WR, Epic Encounters Terminal Rd, Kandakuliya, Sri Lanka": {
    si: "6P73+3WR, Epic Encounters Terminal Rd, Kandakuliya, Sri Lanka",
    ta: "6P73+3WR, Epic Encounters Terminal Rd, Kandakuliya, Sri Lanka",
  },
  "6Q92+XP8, Mailapitiya, Sri Lanka": {
    si: "6Q92+XP8, \u0db8\u0dba\u0dd2\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6Q92+XP8, \u0bae\u0bc8\u0bb2\u0bbe\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6QHX+4G Tanniyutttu, Sri Lanka": {
    si: "6QHX+4G \u0dad\u0db1\u0dca\u0db1\u0dd2\u0dba\u0dd4\u0dad\u0dca\u0dad\u0dd4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6QHX+4G \u0ba4\u0ba9\u0bcd\u0ba9\u0bbf\u0baf\u0bc2\u0b9f\u0bcd\u0b9f\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6QHX+8M9, Tanniyutttu, Sri Lanka": {
    si: "6QHX+8M9, \u0dad\u0db1\u0dca\u0db1\u0dd2\u0dba\u0dd4\u0dad\u0dca\u0dad\u0dd4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6QHX+8M9, \u0ba4\u0ba9\u0bcd\u0ba9\u0bbf\u0baf\u0bc2\u0b9f\u0bcd\u0b9f\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6QP8+PG8, Kalpitiya, Sri Lanka": {
    si: "6QP8+PG8, \u0d9a\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6QP8+PG8, \u0b95\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6QQ8+3Q, Kalpitiya, Sri Lanka": {
    si: "6QQ8+3Q, \u0d9a\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6QQ8+3Q, \u0b95\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6R3H+H28, Negombo, Sri Lanka": {
    si: "6R3H+H28, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6R3H+H28, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6R3H+H3M, Negombo, Sri Lanka": {
    si: "6R3H+H3M, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6R3H+H3M, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6R5J+Q74, Negombo, Sri Lanka": {
    si: "6R5J+Q74, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6R5J+Q74, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6R5Q+FX8, Negombo, Sri Lanka": {
    si: "6R5Q+FX8, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6R5Q+FX8, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6R5Q+HWJ, Negombo, Sri Lanka": {
    si: "6R5Q+HWJ, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6R5Q+HWJ, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6R5X+CMR, Sinnamuhattuvaram, Sri Lanka": {
    si: "6R5X+CMR, \u0dc3\u0dd2\u0db1\u0dca\u0db1\u0db8\u0dd4\u0dc4\u0dad\u0dca\u0dad\u0dd4\u0dc0\u0dbb\u0db8\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6R5X+CMR, \u0b9a\u0bbf\u0ba9\u0bcd\u0ba9\u0bae\u0bc1\u0bb9\u0ba4\u0bcd\u0ba4\u0bc1\u0bb5\u0bbe\u0bb0\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6R7W+QPR, Negombo, Sri Lanka": {
    si: "6R7W+QPR, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6R7W+QPR, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6RCC+WQQ, Sri Lanka": {
    si: "6RCC+WQQ, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6RCC+WQQ, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6RCQ+MHP, Akkaraipattu, Sri Lanka": {
    si: "6RCQ+MHP, \u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0dd9\u0dba\u0dd2\u0db4\u0dad\u0dca\u0dad\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6RCQ+MHP, \u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bc8\u0baa\u0bcd\u0baa\u0bb1\u0bcd\u0bb1\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6RCX+CQF, Akkaraipattu, Sri Lanka": {
    si: "6RCX+CQF, \u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0db4\u0dad\u0dca\u0dad\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6RCX+CQF, \u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bc8\u0baa\u0bcd\u0baa\u0bb1\u0bcd\u0bb1\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6RP2+4F Karative, Sri Lanka": {
    si: "6RP2+4F Karative, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6RP2+4F \u0b95\u0bb0\u0bc7\u0b9f\u0bbf\u0bb5\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6RQX+97Q, Chilaw - Colombo Main Road, Negombo, Sri Lanka": {
    si: "6RQX+97Q, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6RQX+97Q, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6V4W+G84, Kimbulapitiya Rd, Kimbulapitiya, Sri Lanka": {
    si: "6V4W+G84, \u0d9a\u0dd2\u0db9\u0dd4\u0dbd\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0d9a\u0dd2\u0db9\u0dd4\u0dbd\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6V4W+G84, Kimbulapitiya Rd, Kimbulapitiya, Sri Lanka",
  },
  "6V83+F22, Akkaraipattu, Sri Lanka": {
    si: "6V83+F22, \u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0db4\u0dad\u0dca\u0dad\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6V83+F22, \u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bc8\u0baa\u0bcd\u0baa\u0bb1\u0bcd\u0bb1\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6VFH+6RV, Negombo, Sri Lanka": {
    si: "6VFH+6RV, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6VFH+6RV, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6VG2+987, Negombo, Sri Lanka": {
    si: "6VG2+987, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6VG2+987, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6W6V+FCR, Dagonna Rd, Aluthepola, Sri Lanka": {
    si: "6W6V+FCR, Dagonna Rd, Aluthepola, Sri Lanka",
    ta: "6W6V+FCR, Dagonna Rd, Aluthepola, Sri Lanka",
  },
  "6WJ5+85W, Miriswatte, Sri Lanka": {
    si: "6WJ5+85W, \u0db8\u0dd2\u0dbb\u0dd2\u0dc3\u0dca\u0dc0\u0dad\u0dca\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6WJ5+85W, \u0bae\u0bbf\u0bb0\u0bbf\u0bb8\u0bcd\u0bb5\u0ba4\u0bcd\u0ba4\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6X3W+4P8, Ballapana, Sri Lanka": {
    si: "6X3W+4P8, \u0db6\u0dbd\u0dca\u0dbd\u0db4\u0dcf\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6X3W+4P8, \u0baa\u0bb2\u0bcd\u0bb2\u0baa\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6XHQ+PW8, Marandagahamula, Sri Lanka": {
    si: "6XHQ+PW8, \u0db8\u0dbb\u0db3\u0d9c\u0dc4\u0db8\u0dd4\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6XHQ+PW8, \u0bae\u0bb0\u0ba8\u0bcd\u0ba4\u0b95\u0bb9\u0bae\u0bc1\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6XHW+724, Negombo - Mirigama Rd, Marandagahamula, Sri Lanka": {
    si: "6XHW+724, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 - \u0db8\u0dd3\u0dbb\u0dd2\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0db8\u0dbb\u0db3\u0d9c\u0dc4\u0db8\u0dd4\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6XHW+724, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0bc0\u0bb0\u0bbf\u0b95\u0bae \u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0bb0\u0ba8\u0bcd\u0ba4\u0b95\u0bb9\u0bae\u0bc1\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6XJ8+VJ3, Dunagaha, Sri Lanka": {
    si: "6XJ8+VJ3, \u0daf\u0dd4\u0db1\u0d9c\u0dc4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6XJ8+VJ3, \u0ba4\u0bc1\u0ba9\u0b95\u0bbe\u0bb9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6XJF+HQQ, Dunagaha, Sri Lanka": {
    si: "6XJF+HQQ, Dunagaha, Sri Lanka",
    ta: "6XJF+HQQ, \u0ba4\u0bc1\u0ba9\u0b95\u0bbe\u0bb9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "6th Mile Post, Yatagala Kanda Rd, Uragasmanhandiya": {
    si: "6 \u0d9a\u0dab\u0dd4\u0dc0, \u0dba\u0da7\u0d9c\u0dbd \u0d9a\u0db1\u0dca\u0daf \u0db4\u0dcf\u0dbb, \u0d8c\u0dbb\u0d9c\u0dc3\u0dca\u0db8\u0db1\u0dca\u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba",
    ta: "6\u0bb5\u0ba4\u0bc1 \u0bae\u0bc8\u0bb2\u0bcd \u0b85\u0b9e\u0bcd\u0b9a\u0bb2\u0bcd, \u0baf\u0b9f\u0b95\u0bb2 \u0b95\u0ba3\u0bcd\u0b9f \u0bb5\u0bc0\u0ba4\u0bbf, \u0b89\u0bb0\u0b95\u0bb8\u0bcd\u0bae\u0ba9\u0bcd\u0bb9\u0ba8\u0bcd\u0ba4\u0bbf\u0baf",
  },
  "6th Mile post, Hingurakdamana, Hingurakgoda, Sri Lanka": {
    si: "6 \u0d9a\u0dab\u0dd4\u0dc0, \u0dc4\u0dd2\u0d9f\u0dd4\u0dbb\u0d9a\u0dca\u0daf\u0db8\u0db1, \u0dc4\u0dd2\u0d9f\u0dd4\u0dbb\u0d9a\u0dca\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "6\u0bb5\u0ba4\u0bc1 \u0bae\u0bc8\u0bb2\u0bcd \u0baa\u0bcb\u0bb8\u0bcd\u0b9f\u0bcd, \u0bb9\u0bbf\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0b95\u0bcd\u0b9f\u0bae\u0ba9, \u0bb9\u0bbf\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0bbe\u0b95\u0bcd\u0b95\u0bcb\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7 Manampitiya Hospital Rd, Manampitiya  , Sri Lanka": {
    si: "7 \u0db8\u0db1\u0db8\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0dbb\u0ddd\u0dc4\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0db1\u0db8\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7 \u0bae\u0ba9\u0bae\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0bae\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb5\u0bae\u0ba9\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0ba9\u0bae\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "70 Mahakumarage Rd, Colombo": {
    si: "70 \u0db8\u0dc4\u0d9a\u0dd4\u0db8\u0dcf\u0dbb\u0d9c\u0dda \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0dc5\u0db9",
    ta: "70 \u0bae\u0bb9\u0bbe\u0b95\u0bc1\u0bae\u0bbe\u0bb0\u0b95\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "702 A2, Panadura, Sri Lanka": {
    si: "702 A2, \u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "702 A2, \u0baa\u0bbe\u0ba3\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "702 Colombo Main Rd, Panadura": {
    si: "702 \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb",
    ta: "702 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bbe\u0ba3\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  "71/1/2 Avissawella Rd, Maharagama 10280, Sri Lanka": {
    si: "71/1/2 \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0dbb\u0d9c\u0db8 10280, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "71/1/2 \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 \u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0bb9\u0bb0\u0b95\u0bae 10280, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "712 Maradana Rd, Colombo 01000, Sri Lanka": {
    si: "712 \u0db8\u0dbb\u0daf\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0dc5\u0db9 01000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "712 \u0bae\u0bb0\u0bc1\u0ba4\u0bbe\u0ba9\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 01000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "712 Waragoda Rd, Peliyagoda, Sri Lanka": {
    si: "712 \u0dc0\u0dbb\u0dcf\u0d9c\u0ddc\u0da9 \u0db4\u0dcf\u0dbb, \u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "712 \u0bb5\u0bbe\u0bb0\u0b95\u0bcb\u0b9f\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0bc7\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "717 P De S Kularatne Mawatha, Colombo 01000, Sri Lanka": {
    si: "717 \u0db4\u0dd3 \u0daf \u0d91\u0dc3\u0dca \u0d9a\u0dd4\u0dbd\u0dbb\u0dad\u0dca\u0db1 \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 01000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "717 \u0baa\u0bbf \u0b9f\u0bbf \u0b8e\u0bb8\u0bcd \u0b95\u0bc1\u0bb2\u0bb0\u0ba4\u0bcd\u0ba9 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 01000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "717 P De S Kularatne Mawatha, Colombo 10": {
    si: "717 \u0db4\u0dd3 \u0daf \u0d91\u0dc3\u0dca \u0d9a\u0dd4\u0dbd\u0dbb\u0dad\u0dca\u0db1 \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 10",
    ta: "717 \u0baa\u0bbf \u0b9f\u0bbf \u0b8e\u0bb8\u0bcd \u0b95\u0bc1\u0bb2\u0bb0\u0ba4\u0bcd\u0ba9 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 10",
  },
  "739F+P8, Andaulpotha, Sri Lanka": {
    si: "739F+P8, \u0d86\u0db1\u0dca\u0daf\u0d8b\u0dbd\u0dca\u0db4\u0ddc\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "739F+P8, \u0b86\u0ba3\u0bcd\u0b9f\u0bb5\u0bc1\u0bb2\u0bcd\u0baa\u0bca\u0ba4\u0bcd\u0ba4\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "739X+CXV, Karandeniya, Sri Lanka": {
    si: "739X+CXV, \u0d9a\u0dbb\u0db1\u0dca\u0daf\u0dd9\u0dab\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "739X+CXV, \u0b95\u0bb0\u0ba8\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "73CV+CGH, Karandeniya, Sri Lanka": {
    si: "73CV+CGH, \u0d9a\u0dbb\u0db1\u0dca\u0daf\u0dd9\u0dab\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "73CV+CGH, \u0b95\u0bb0\u0ba8\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "73M8+Q24, Kotadeniyawa, Sri Lanka": {
    si: "73M8+Q24, \u0d9a\u0ddc\u0da7\u0daf\u0dd9\u0dab\u0dd2\u0dba\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "73M8+Q24, \u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "74 Anuradhapura - Padeniya Highway, Galgamuwa": {
    si: "74 \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb - \u0db4\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0d9c\u0dbd\u0dca\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "74 \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd - \u0baa\u0ba4\u0bc6\u0ba9\u0bbf\u0baf \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bb2\u0bcd\u0b95\u0bae\u0bc1\u0bb5",
  },
  "74 Anuradhapura-Padeniya Highway, Galgamuwa, Sri Lanka": {
    si: "74 \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb-\u0db4\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0d9c\u0dbd\u0dca\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "74 \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd-\u0baa\u0ba4\u0bc6\u0ba9\u0bbf\u0baf \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bb2\u0bcd\u0b95\u0bae\u0bc1\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "74 Hatton - Maskeliya - Dalhousie Rd, Hatton, Sri Lanka": {
    si: "74 \u0dc4\u0dd0\u0da7\u0db1\u0dca - \u0db8\u0dc3\u0dca\u0d9a\u0dd9\u0dc5\u0dd2\u0dba - \u0da9\u0dbd\u0dca\u0dc4\u0dc0\u0dd4\u0dc3\u0dd2 \u0db4\u0dcf\u0dbb, \u0dc4\u0dd0\u0da7\u0db1\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "74 \u0bb9\u0b9f\u0bcd\u0b9f\u0ba9\u0bcd - \u0bae\u0bb8\u0bcd\u0b95\u0bc6\u0bb2\u0bbf\u0baf\u0bbe - \u0b9f\u0bb2\u0bcd\u0bb9\u0bcc\u0b9a\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0b9f\u0bcd\u0b9f\u0ba9\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "74/1 De La Salle St, Colombo, Sri Lanka": {
    si: "74/1 \u0daf \u0dbd\u0dcf \u0dc3\u0dd0\u0dbd\u0dca \u0dc1\u0dcf\u0db1\u0dca\u0dad, \u0d9a\u0ddc\u0dc5\u0db9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "74/1 De La Salle St, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "742R+RCQ, Kumulamunai, Sri Lanka": {
    si: "742R+RCQ, \u0d9a\u0dd4\u0db8\u0dd4\u0dbd\u0db8\u0dd4\u0db1\u0dd9\u0dba\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "742R+RCQ, \u0b95\u0bc1\u0bae\u0bc1\u0bb3\u0bae\u0bc1\u0ba9\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "749P+RJ5, Sri Lanka": {
    si: "749P+RJ5, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "749P+RJ5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "74RM+HJ3,   -    , Mirigama, Sri Lanka": {
    si: "74RM+HJ3, - , \u0db8\u0dd3\u0dbb\u0dd2\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "74RM+HJ3, - , \u0bae\u0bc0\u0bb0\u0bbf\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "75 Mankuliya Rd, Negombo": {
    si: "75 \u0db8\u0dcf\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "75 \u0bae\u0bbe\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "75 Mankuliya Rd, Negombo, Sri Lanka": {
    si: "75 \u0db8\u0dcf\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "75 \u0bae\u0bbe\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bbf\u0baf \u0b9a\u0bbe\u0bb2\u0bc8, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "75Q6+VJ4, B14, Elpitiya, Sri Lanka": {
    si: "75Q6+VJ4, B14, \u0d87\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "75Q6+VJ4, B14, \u0b8e\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "75W9+37V, Elpitiya, Sri Lanka": {
    si: "75W9+37V, \u0d87\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "75W9+37V, \u0b8e\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "762 Galle Rd, Colombo, Sri Lanka": {
    si: "762 \u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0dc5\u0db9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "762 \u0b95\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7664+J9X, Nochchiyagama, Sri Lanka": {
    si: "7664+J9X, \u0db1\u0ddc\u0da0\u0dca\u0da0\u0dd2\u0dba\u0dcf\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7664+J9X, \u0ba8\u0bca\u0b9a\u0bcd\u0b9a\u0bbf\u0baf\u0bbe\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "766G+C97, Andalla - Tissa, Weerawila, Sri Lanka": {
    si: "766G+C97, \u0d87\u0db1\u0dca\u0daf\u0dbd\u0dca\u0dbd - \u0dad\u0dd2\u0dc3\u0dca\u0dc3, \u0dc0\u0dd3\u0dbb\u0dc0\u0dd2\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "766G+C97, \u0b86\u0ba3\u0bcd\u0b9f\u0bb2\u0bcd\u0bb2\u0bbe - \u0ba4\u0bbf\u0bb8\u0bcd\u0bb8, \u0bb5\u0bc0\u0bb0\u0bb5\u0bbf\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "76VR+M34, B9, Alawwa, Sri Lanka": {
    si: "76VR+M34, B9, \u0d85\u0dbd\u0dc0\u0dca\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "76VR+M34, B9, \u0b85\u0bb2\u0bb5\u0bcd\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "76XF+2JW, B9, Alawwa, Sri Lanka": {
    si: "76XF+2JW, B9, \u0d85\u0dbd\u0dc0\u0dca\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "76XF+2JW, B9, \u0b85\u0bb2\u0bb5\u0bcd\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "777/e/2, Samurdhi Mawatha, Heiyanthuduwa": {
    si: "777/\u0d8a/2, \u0dc3\u0db8\u0dd8\u0daf\u0dca\u0db0\u0dd2 \u0db8\u0dcf\u0dc0\u0dad, \u0dc4\u0dd9\u0dba\u0dd2\u0dba\u0db1\u0dca\u0dad\u0dd4\u0da9\u0dd4\u0dc0",
    ta: "777/e/2, \u0b9a\u0bae\u0bc1\u0bb0\u0bcd\u0ba4\u0bcd\u0ba4\u0bbf \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0bb9\u0bc6\u0baf\u0bcd\u0baf\u0ba9\u0bcd\u0ba4\u0bc1\u0b9f\u0bc1\u0bb5",
  },
  "77HP+58F, Tissamaharama, Sri Lanka": {
    si: "77HP+58F, \u0dad\u0dd2\u0dc3\u0dca\u0dc3\u0db8\u0dc4\u0dcf\u0dbb\u0dcf\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "77HP+58F, \u0ba4\u0bbf\u0bb8\u0bcd\u0bb8\u0bae\u0bb9\u0bbe\u0bb0\u0bbe\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "77HP+762, Tissamaharama, Sri Lanka": {
    si: "77HP+762, \u0dad\u0dd2\u0dc3\u0dca\u0dc3\u0db8\u0dc4\u0dcf\u0dbb\u0dcf\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "77HP+762, \u0ba4\u0bbf\u0bb8\u0bcd\u0bb8\u0bae\u0bb9\u0bbe\u0bb0\u0bbe\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "77J2+3M Sinharagama, Sri Lanka": {
    si: "77J2+3M \u0dc3\u0dd2\u0d82\u0dc4\u0dcf\u0dbb\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "77J2+3M \u0b9a\u0bbf\u0b99\u0bcd\u0b95\u0bb0\u0b95\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "78 Canal Rd, Wattala, Sri Lanka": {
    si: "78 \u0d87\u0dbd \u0db4\u0dcf\u0dbb, \u0dc0\u0dad\u0dca\u0dad\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "78 \u0b95\u0bbe\u0bb2\u0bcd\u0bb5\u0bbe\u0baf\u0bcd \u0baa\u0bbe\u0ba4\u0bc8, \u0bb5\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "782M+C84 Ceypetco Filling Station, Colombo - Kandy Rd, Kegalle, Sri Lanka": {
    si: "782M+C84 \u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0ddc\u0dc5\u0db9 - \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "782M+C84 Ceypetco \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "783R+38H, Kegalle, Sri Lanka": {
    si: "783R+38H, \u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "783R+38H, \u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7892+36 Lukasgoda, Sri Lanka": {
    si: "7892+36 \u0dbd\u0dd6\u0d9a\u0dc3\u0dca\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7892+36 \u0bb2\u0bc1\u0b95\u0bbe\u0bb8\u0bcd\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7932+H7 Kegalle, Sri Lanka": {
    si: "7932+H7 \u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7932+H7 \u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "793M+MM Molagoda, Sri Lanka": {
    si: "793M+MM \u0db8\u0ddc\u0dbd\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "793M+MM \u0bae\u0bca\u0bb2\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7C2V+6JM, Mawanella, Sri Lanka": {
    si: "7C2V+6JM, \u0db8\u0dcf\u0dc0\u0db1\u0dd0\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7C2V+6JM, \u0bae\u0bbe\u0bb5\u0ba9\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7F6R+6VC, Deniyaya - Wiharahena Road, Morawaka, Sri Lanka": {
    si: "7F6R+6VC, \u0daf\u0dd9\u0db1\u0dd2\u0dba\u0dcf\u0dba - \u0dc0\u0dd2\u0dc4\u0dbb\u0dc4\u0dda\u0db1 \u0db4\u0dcf\u0dbb, \u0db8\u0ddc\u0dbb\u0dc0\u0d9a, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7F6R+6VC, \u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe\u0baf - \u0bb5\u0bbf\u0bb9\u0bbe\u0bb0\u0bb9\u0bc7\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bca\u0bb0\u0bb5\u0b95, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7G49+RJX, Kadugannawa, Sri Lanka": {
    si: "7G49+RJX, \u0d9a\u0da9\u0dd4\u0d9c\u0db1\u0dca\u0db1\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7G49+RJX, \u0b95\u0b9f\u0bc1\u0b95\u0ba9\u0bcd\u0ba9\u0bbe\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7GWR+JXM, Kotapola, Sri Lanka": {
    si: "7GWR+JXM, \u0d9a\u0ddc\u0da7\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7GWR+JXM, \u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0baa\u0bca\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7JF5+JXF, Kandy, Sri Lanka": {
    si: "7JF5+JXF, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7JF5+JXF, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7JH9+RX5, Kandy 20000, Sri Lanka": {
    si: "7JH9+RX5, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb 20000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7JH9+RX5, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf 20000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7JMG+964, Kandy, Sri Lanka": {
    si: "7JMG+964, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7JMG+964, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7JQP+HQ2, Sri Lanka": {
    si: "7JQP+HQ2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7JQP+HQ2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7JVX+3JV, Kandy, Sri Lanka": {
    si: "7JVX+3JV, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7JVX+3JV, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7JWP+C96, Kandy, Sri Lanka": {
    si: "7JWP+C96, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7JWP+C96, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7M8R+4P2, Walasmulla - Katuwana - Middeniya Road, Katuwana, Sri Lanka": {
    si: "7M8R+4P2, \u0dc0\u0dbd\u0dc3\u0dca\u0db8\u0dd4\u0dbd\u0dca\u0dbd - \u0d9a\u0da7\u0dd4\u0dc0\u0dcf\u0db1 - \u0db8\u0dd2\u0daf\u0dca\u0daf\u0dd9\u0db1\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0d9a\u0da7\u0dd4\u0dc0\u0dcf\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7M8R+4P2, \u0bb5\u0bb2\u0bb8\u0bcd\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe - \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe\u0ba9 - \u0bae\u0bbf\u0ba4\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe\u0ba9, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7MHH+QG2, A26, Nattarampota 20168, Sri Lanka": {
    si: "7MHH+QG2, A26, \u0db1\u0dad\u0dca\u0dad\u0dbb\u0db8\u0dca\u0db4\u0ddc\u0da7 20168, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7MHH+QG2, A26, \u0ba8\u0bbe\u0b9f\u0bcd\u0b9f\u0bb0\u0bae\u0bcd\u0baa\u0bca\u0b9f\u0bcd\u0b9f\u0bbe 20168, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7MM7+VCH, Tennekumbura, Sri Lanka": {
    si: "7MM7+VCH, \u0dad\u0dd0\u0db1\u0dca\u0db1\u0d9a\u0dd4\u0db9\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7MM7+VCH, \u0ba4\u0bc6\u0ba9\u0bcd\u0ba9\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7MRF+R22, Ampara, Sri Lanka": {
    si: "7MRF+R22, \u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7MRF+R22, \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7MRG+FVW, Ampara, Sri Lanka": {
    si: "7MRG+FVW, \u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7MRG+FVW, \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7MVP+598, Ampara, Sri Lanka": {
    si: "7MVP+598, \u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7MVP+598, \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7MVR+GMW, A31, Ampara, Sri Lanka": {
    si: "7MVR+GMW, A31, \u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7MVR+GMW, A31, \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7PJ8+99 Galenbindunuwewa, Sri Lanka": {
    si: "7PJ8+99 \u0d9c\u0dbd\u0dd9\u0db1\u0dca\u0db6\u0dd2\u0db3\u0dd4\u0dab\u0dd4\u0dc0\u0dd0\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7PJ8+99 Galenbindunuwewa, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7PMC+6G9, Balagolla, Sri Lanka": {
    si: "7PMC+6G9, \u0db6\u0dbd\u0d9c\u0ddc\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7PMC+6G9, \u0baa\u0bb2\u0b95\u0bca\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7PR9+64 Galenbindunuwewa, Sri Lanka": {
    si: "7PR9+64 \u0d9c\u0dbd\u0dd9\u0db1\u0dca\u0db6\u0dd2\u0db3\u0dd4\u0dab\u0dd4\u0dc0\u0dd0\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7PR9+64 \u0b95\u0bb2\u0bc6\u0ba9\u0bcd\u0baa\u0bbf\u0ba8\u0bcd\u0ba4\u0bc1\u0ba9\u0bc1\u0bb5\u0bc6\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7PXP+G4C, Digana, Sri Lanka": {
    si: "7PXP+G4C, \u0daf\u0dd2\u0d9c\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7PXP+G4C, \u0ba4\u0bbf\u0b95\u0ba9, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7Q2J+JQ Middeniya, Sri Lanka": {
    si: "7Q2J+JQ \u0db8\u0dd2\u0daf\u0dca\u0daf\u0dd9\u0db1\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7Q2J+JQ \u0bae\u0bbf\u0ba4\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7Q37+MRR, Middeniya-Panamure Rd, Middeniya, Sri Lanka": {
    si: "7Q37+MRR, \u0db8\u0dd2\u0daf\u0dca\u0daf\u0dd9\u0db1\u0dd2\u0dba-\u0db4\u0db1\u0dcf\u0db8\u0dd4\u0dbb\u0dda \u0db4\u0dcf\u0dbb, \u0db8\u0dd2\u0daf\u0dca\u0daf\u0dd9\u0db1\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7Q37+MRR, Middeniya-Panamure Rd, Middeniya, Sri Lanka",
  },
  "7R8V+G72, Kammalthura, Sri Lanka": {
    si: "7R8V+G72, \u0d9a\u0db8\u0dca\u0db8\u0dbd\u0dca\u0dad\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7R8V+G72, \u0b95\u0bae\u0bcd\u0bae\u0bb2\u0bcd\u0ba4\u0bc1\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7RJ7+PC, Udathenna, Sri Lanka": {
    si: "7RJ7+PC, \u0d8b\u0da9\u0dad\u0dd0\u0db1\u0dca\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7RJ7+PC, \u0b89\u0b9f\u0ba4\u0bc6\u0ba9\u0bcd\u0ba9, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7V33+9V3, Negombo, Sri Lanka": {
    si: "7V33+9V3, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7V33+9V3, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7V33+GMM, Addalaichenai, Sri Lanka": {
    si: "7V33+GMM, \u0d85\u0da9\u0dca\u0da9\u0dcf\u0dbd\u0dd2\u0da0\u0dda\u0db1\u0dba\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7V33+GMM, \u0b85\u0b9f\u0bcd\u0b9f\u0bbe\u0bb3\u0bc8\u0b9a\u0bcd\u0b9a\u0bc7\u0ba9\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7V43+HR7, Addalaichenai, Sri Lanka": {
    si: "7V43+HR7, \u0d85\u0da9\u0dca\u0da9\u0dcf\u0dbd\u0dd2\u0da0\u0dda\u0db1\u0dba\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7V43+HR7, \u0b85\u0b9f\u0bcd\u0b9f\u0bbe\u0bb3\u0bc8\u0b9a\u0bcd\u0b9a\u0bc7\u0ba9\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7V75+423, Negombo, Sri Lanka": {
    si: "7V75+423, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7V75+423, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7VC7+X8G, Gampaha, Sri Lanka": {
    si: "7VC7+X8G, \u0d9c\u0db8\u0dca\u0db4\u0dc4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7VC7+X8G, \u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7VF7+4P4, Palamunai, Sri Lanka": {
    si: "7VF7+4P4, \u0db4\u0dbd\u0db8\u0dd4\u0db1\u0dd9\u0dba\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7VF7+4P4, \u0baa\u0bbe\u0bb2\u0bae\u0bc1\u0ba9\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7VG7+GH Sahana Gama, Sri Lanka": {
    si: "7VG7+GH \u0dc3\u0dc4\u0db1 \u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7VG7+GH \u0b9a\u0bb9\u0bbe\u0ba9\u0bbe \u0b95\u0bbe\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7VP3+GH7, Chilaw - Colombo Main Rd, Bolawatta, Sri Lanka": {
    si: "7VP3+GH7, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0db6\u0ddd\u0dbd\u0dc0\u0dad\u0dca\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7VP3+GH7, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bcb\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7VR2+JWV, Kammala, Sri Lanka": {
    si: "7VR2+JWV, \u0d9a\u0db8\u0dca\u0db8\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7VR2+JWV, \u0b95\u0bae\u0bcd\u0bae\u0bbe\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7VVP+654, Embilipitiya, Sri Lanka": {
    si: "7VVP+654, \u0d87\u0db9\u0dd2\u0dbd\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7VVP+654, \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0bb2\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7VWJ+343, Dankotuwa, Sri Lanka": {
    si: "7VWJ+343, \u0daf\u0d82\u0d9a\u0ddc\u0da7\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7VWJ+343, \u0ba4\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7VWM+V6H, Dankotuwa, Sri Lanka": {
    si: "7VWM+V6H, \u0daf\u0d82\u0d9a\u0ddc\u0da7\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7VWM+V6H, \u0ba4\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7VXM+F59, Dankotuwa, Sri Lanka": {
    si: "7VXM+F59, \u0daf\u0d82\u0d9a\u0ddc\u0da7\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7VXM+F59, \u0ba4\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7W6Q+8P9, Kochchikade - Halpe Rd, Katana, Sri Lanka": {
    si: "7W6Q+8P9, \u0d9a\u0ddc\u0da0\u0dca\u0da0\u0dd2\u0d9a\u0da9\u0dda - \u0dc4\u0dbd\u0dca\u0db4\u0dda \u0db4\u0dcf\u0dbb, \u0d9a\u0da7\u0dcf\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7W6Q+8P9, \u0b95\u0bca\u0b9a\u0bcd\u0b9a\u0bbf\u0b95\u0bcd\u0b95\u0b9f\u0bc8 - \u0bb9\u0bb2\u0bcd\u0baa\u0bc7 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0b9f\u0bcd\u0b9f\u0bbe\u0ba9, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7XF6+2M7, Badalgama, Sri Lanka": {
    si: "7XF6+2M7, \u0db6\u0da9\u0dbd\u0dca\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7XF6+2M7, \u0baa\u0b9f\u0bb2\u0bcd\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7XJ9+7RJ,  -   , Sooriyawewa, Sri Lanka": {
    si: "7XJ9+7RJ, - , \u0dc3\u0dd6\u0dbb\u0dd2\u0dba\u0dc0\u0dd0\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7XJ9+7RJ, - , \u0b9a\u0bc2\u0bb0\u0bbf\u0baf\u0bb5\u0bc6\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7XPH+97W, Badalgama, Sri Lanka": {
    si: "7XPH+97W, \u0db6\u0da9\u0dbd\u0dca\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7XPH+97W, \u0baa\u0b9f\u0bb2\u0bcd\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "7XPP+F24, Badalgama, Sri Lanka": {
    si: "7XPP+F24, \u0db6\u0da9\u0dbd\u0dca\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "7XPP+F24, \u0baa\u0b9f\u0bb2\u0bcd\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8 Esplanade Rd, Bandarawela, Sri Lanka": {
    si: "8 Esplanade \u0db4\u0dcf\u0dbb, \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8 Esplanade Rd, \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0bb5\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8 Sri Gnavimala Mawatha, Gampaha, Sri Lanka": {
    si: "8 \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0da5\u0dcf\u0db1\u0dc0\u0dd2\u0db8\u0dbd \u0db8\u0dcf\u0dc0\u0dad, \u0d9c\u0db8\u0dca\u0db4\u0dc4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8 \u0bb8\u0bcd\u0bb0\u0bc0 \u0b9e\u0bbe\u0ba9\u0bb5\u0bbf\u0bae\u0bb2 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "820 AB38, Sri Lanka": {
    si: "820 AB38, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "820 AB38, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "821 Kaduwela Rd, Malabe, Sri Lanka": {
    si: "821 \u0d9a\u0da9\u0dd4\u0dc0\u0dd9\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dcf\u0dbd\u0db6\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "821 \u0b95\u0b9f\u0bc1\u0bb5\u0bc6\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bbe\u0bb2\u0baa\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8253+F2C, Town, Sri Lanka": {
    si: "8253+F2C, \u0db1\u0d9c\u0dbb\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8253+F2C, \u0b9f\u0bb5\u0bc1\u0ba9\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "82G2+Q67, Meegahajandura Rd, Sooriyawewa, Sri Lanka": {
    si: "82G2+Q67, \u0db8\u0dd3\u0d9c\u0dc4\u0da2\u0db3\u0dd4\u0dbb \u0db4\u0dcf\u0dbb, \u0dc3\u0dd6\u0dbb\u0dd2\u0dba\u0dc0\u0dd0\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "82G2+Q67, \u0bae\u0bc0\u0b95\u0bb9\u0b9c\u0ba8\u0bcd\u0ba4\u0bc1\u0bb0\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0b9a\u0bc2\u0bb0\u0bbf\u0baf\u0bb5\u0bc6\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "82H9+XJC, Negombo-Kurunegala Rd, Pannala, Sri Lanka": {
    si: "82H9+XJC, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0-\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd \u0db4\u0dcf\u0dbb, \u0db4\u0db1\u0dca\u0db1\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "82H9+XJC, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1-\u0b95\u0bc1\u0bb0\u0bc1\u0ba3\u0bbe\u0b95\u0bb2\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0ba9\u0bcd\u0ba9\u0bbe\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "82HC+FWR, Pannala Police Station Rd, Pannala, Sri Lanka": {
    si: "82HC+FWR, \u0db4\u0db1\u0dca\u0db1\u0dbd \u0db4\u0ddc\u0dbd\u0dd2\u0dc3\u0dca \u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba \u0db4\u0dcf\u0dbb, \u0db4\u0db1\u0dca\u0db1\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "82HC+FWR, \u0baa\u0ba9\u0bcd\u0ba9\u0bbe\u0bb2\u0bbe \u0b95\u0bbe\u0bb5\u0bb2\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1, \u0baa\u0ba9\u0bcd\u0ba9\u0bbe\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "82JG+4H8, Pannala, Sri Lanka": {
    si: "82JG+4H8, \u0db4\u0db1\u0dca\u0db1\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "82JG+4H8, \u0baa\u0ba9\u0bcd\u0ba9\u0bbe\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "83G9+35W, Negombo-Kurunegala Rd, Bopitiya, Sri Lanka": {
    si: "83G9+35W, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0-\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd \u0db4\u0dcf\u0dbb, \u0db6\u0ddd\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "83G9+35W, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1-\u0b95\u0bc1\u0bb0\u0bc1\u0ba3\u0bbe\u0b95\u0bb2\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0bcb\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "83VJ+7W8, B55, Uragasmanhandiya, Sri Lanka": {
    si: "83VJ+7W8, B55, \u0d8c\u0dbb\u0d9c\u0dc3\u0dca\u0db8\u0db1\u0dca\u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "83VJ+7W8, B55, \u0b89\u0bb0\u0b95\u0bb8\u0bcd\u0bae\u0ba9\u0bcd\u0bb9\u0ba8\u0bcd\u0ba4\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "84, St. Andrews Road, Mutuwal Dockland Mutuwal, Colombo, Sri Lanka": {
    si: "84, \u0dc1\u0dcf\u0db1\u0dca\u0dad \u0d87\u0db1\u0dca\u0da9\u0df2\u0dc3\u0dca \u0db4\u0dcf\u0dbb, \u0db8\u0dd4\u0dad\u0dd4\u0dc0\u0dbd\u0dca \u0da9\u0ddc\u0d9a\u0dca\u0dbd\u0db1\u0dca\u0da9\u0dca \u0db8\u0dd4\u0dad\u0dd4\u0dc0\u0dbd\u0dca, \u0d9a\u0ddc\u0dc5\u0db9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "84, \u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd \u0b86\u0ba3\u0bcd\u0b9f\u0bcd\u0bb0\u0bc2\u0bb8\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0bc1\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe\u0bb2\u0bcd \u0b9f\u0bbe\u0b95\u0bcd\u0bb2\u0bc7\u0ba3\u0bcd\u0b9f\u0bcd \u0bae\u0bc1\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe\u0bb2\u0bcd, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8464+53 Loluwagoda, Sri Lanka": {
    si: "8464+53 \u0dbd\u0ddd\u0dbd\u0dd4\u0dc0\u0dcf\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8464+53 \u0bb2\u0bca\u0bb2\u0bc1\u0bb5\u0bbe\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "84HC+RRW, Giriulla, Sri Lanka": {
    si: "84HC+RRW, \u0d9c\u0dd2\u0dbb\u0dd2\u0d8b\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "84HC+RRW, \u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "84HC+WXV, Giriulla, Sri Lanka": {
    si: "84HC+WXV, \u0d9c\u0dd2\u0dbb\u0dd2\u0d8b\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "84HC+WXV, \u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "84PR+CP6, Giriulla, Sri Lanka": {
    si: "84PR+CP6, \u0d9c\u0dd2\u0dbb\u0dd2\u0d8b\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "84PR+CP6, \u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "84Q7+9V Uragasmanhandiya, Sri Lanka": {
    si: "84Q7+9V \u0d8c\u0dbb\u0d9c\u0dc3\u0dca\u0db8\u0db1\u0dca\u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "84Q7+9V \u0b89\u0bb0\u0b95\u0bb8\u0bcd\u0bae\u0ba9\u0bcd\u0bb9\u0ba8\u0bcd\u0ba4\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "85MG+W9R, Boyawalana, Sri Lanka": {
    si: "85MG+W9R, \u0db6\u0ddd\u0dba\u0dc0\u0dbd\u0dcf\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "85MG+W9R, \u0baa\u0bcb\u0baf\u0bb5\u0bb2\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "865J+3Q8, Sandungama Rd, Pannegamuwa, Sri Lanka": {
    si: "865J+3Q8, \u0dc3\u0db3\u0dd4\u0db1\u0dca\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0db4\u0db1\u0dca\u0db1\u0dda\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "865J+3Q8, \u0b9a\u0ba8\u0bcd\u0ba4\u0bc1\u0b99\u0bcd\u0b95\u0bae \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0ba9\u0bcd\u0ba9\u0bc7\u0b95\u0bae\u0bc1\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "86GJ+J7P, Sri Lanka": {
    si: "86GJ+J7P, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "86GJ+J7P, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "86V2+FJ Mattala, Sri Lanka": {
    si: "86V2+FJ \u0db8\u0dad\u0dca\u0dad\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "86V2+FJ \u0bae\u0ba4\u0bcd\u0ba4\u0bb3, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "87 Ratnapura - Horana - Panadura Hwy, Bandaragama, Sri Lanka": {
    si: "87 \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb - \u0dc4\u0ddc\u0dbb\u0dab - \u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb Hwy, \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "87 \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf - \u0bb9\u0bca\u0bb0\u0ba3\u0bc8 - \u0baa\u0bbe\u0ba9\u0ba4\u0bc1\u0bb1\u0bc8 Hwy, \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "87 Rest House Rd, Kitulgala, Sri Lanka": {
    si: "87 \u0dad\u0dcf\u0db1\u0dcf\u0dba\u0db8 \u0db4\u0dcf\u0dbb, \u0d9a\u0dd2\u0dad\u0dd4\u0dbd\u0dca\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "87 \u0bb0\u0bc6\u0bb8\u0bcd\u0b9f\u0bcd \u0bb9\u0bb5\u0bc1\u0bb8\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1, \u0b95\u0bbf\u0ba4\u0bc1\u0bb2\u0bcd\u0b95\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "87FX+HX4, Allai-Kantalai Rd, Serunuwara, Sri Lanka": {
    si: "87FX+HX4, \u0d85\u0dbd\u0dca\u0dbd\u0dba\u0dd2-\u0d9a\u0db1\u0dca\u0dad\u0dbd\u0dcf\u0dba\u0dd2 \u0db4\u0dcf\u0dbb, \u0dc3\u0dda\u0dbb\u0dd4\u0db1\u0dd4\u0dc0\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "87FX+HX4, \u0b85\u0bb2\u0bcd\u0bb2\u0bc8-\u0b95\u0ba8\u0bcd\u0ba4\u0bb3\u0bbe\u0baf\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0b9a\u0bc7\u0bb0\u0bc1\u0ba8\u0bc1\u0bb5\u0bb0, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8865+J7W, Sri Lanka": {
    si: "8865+J7W, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8865+J7W, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "88G4+HW Beralihela, Sri Lanka": {
    si: "88G4+HW \u0db6\u0dd9\u0dbb\u0dbd\u0dd2\u0dc4\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "88G4+HW \u0baa\u0bc6\u0bb0\u0bb2\u0bbf\u0bb9\u0bc6\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "88b S. De S. Jayasinghe Mawatha, Nugegoda": {
    si: "88b \u0d91\u0dc3\u0dca. \u0daf \u0d91\u0dc3\u0dca. \u0da2\u0dba\u0dc3\u0dd2\u0d82\u0dc4 \u0db8\u0dcf\u0dc0\u0dad, \u0db1\u0dd4\u0d9c\u0dda\u0d9c\u0ddc\u0da9",
    ta: "88b S. De S. \u0b9c\u0baf\u0b9a\u0bbf\u0b99\u0bcd\u0b95 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0ba8\u0bc1\u0b95\u0bc7\u0b95\u0bca\u0b9f",
  },
  "89 Vavuniya-Parayanalankulam Hwy, Vavuniya 43000, Sri Lanka": {
    si: "89 \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0-\u0db4\u0dbb\u0dba\u0db1\u0dbd\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca Hwy, \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0 43000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "89 \u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe-\u0baa\u0bb0\u0bbe\u0baf\u0ba9\u0bbe\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd Hwy, \u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe 43000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "89G8+7HW, Anuradhapura, Sri Lanka": {
    si: "89G8+7HW, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "89G8+7HW, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "89QW+M5W, Rambukkana, Sri Lanka": {
    si: "89QW+M5W, \u0dbb\u0db9\u0dd4\u0d9a\u0dca\u0d9a\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "89QW+M5W, \u0bb0\u0bae\u0bcd\u0baa\u0bc1\u0b95\u0bcd\u0b95\u0ba9\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8C25+4P Ariviyal Nagar, Sri Lanka": {
    si: "8C25+4P \u0d85\u0dbb\u0dd2\u0dc0\u0dd2\u0dba\u0dbd\u0dca \u0db1\u0d9c\u0dbb\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8C25+4P \u0b85\u0bb1\u0bbf\u0bb5\u0bbe\u0bb2\u0bcd \u0ba8\u0b95\u0bb0\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8C7C+V74, Anuradhapura, Sri Lanka": {
    si: "8C7C+V74, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8C7C+V74, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8CM6+WPJ, Anuradhapura, Sri Lanka": {
    si: "8CM6+WPJ, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8CM6+WPJ, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8CQ6+VH2, Anuradhapura, Sri Lanka": {
    si: "8CQ6+VH2, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8CQ6+VH2, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8CQ7+QWV, Anuradhapura, Sri Lanka": {
    si: "8CQ7+QWV, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8CQ7+QWV, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8FM8+6RX, Sri Lanka": {
    si: "8FM8+6RX, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8FM8+6RX, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8HGX+8MH, Nugawela, Sri Lanka": {
    si: "8HGX+8MH, \u0db1\u0dd4\u0d9c\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8HGX+8MH, \u0ba8\u0bc1\u0b95\u0bb5\u0bc6\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8HJC+CCW, Aladeniya, Sri Lanka": {
    si: "8HJC+CCW, \u0d85\u0dbd\u0daf\u0dd9\u0dab\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8HJC+CCW, \u0b85\u0bb2\u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8HQ4+WC3, Hedeniya, Sri Lanka": {
    si: "8HQ4+WC3, \u0dc4\u0dd9\u0daf\u0dd9\u0dab\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8HQ4+WC3, \u0bb9\u0bc6\u0b9f\u0bc6\u0ba9\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8HW5+6PP, Deniyaya - Wiharahena Rd, Deniyaya, Sri Lanka": {
    si: "8HW5+6PP, \u0daf\u0dd9\u0db1\u0dd2\u0dba\u0dcf\u0dba - \u0dc0\u0dd2\u0dc4\u0dcf\u0dbb\u0dc4\u0dda\u0db1 \u0db4\u0dcf\u0dbb, \u0daf\u0dd9\u0db1\u0dd2\u0dba\u0dcf\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8HW5+6PP, \u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe\u0baf - \u0bb5\u0bbf\u0bb9\u0bbe\u0bb0\u0bb9\u0bc7\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8J3P+23F, Kotapola - Urubokka Rd, Urubokka, Sri Lanka": {
    si: "8J3P+23F, \u0d9a\u0ddc\u0da7\u0db4\u0ddc\u0dbd - \u0d8c\u0dbb\u0dd4\u0db6\u0ddc\u0d9a\u0dca\u0d9a \u0db4\u0dcf\u0dbb, \u0d8c\u0dbb\u0dd4\u0db6\u0ddc\u0d9a\u0dca\u0d9a, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8J3P+23F, \u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0baa\u0bca\u0bb2 - \u0b8a\u0bb0\u0bc1\u0baa\u0bca\u0b95\u0bcd\u0b95 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b8a\u0bb0\u0bc1\u0baa\u0bca\u0b95\u0bcd\u0b95\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8J5P+XJ7, Kandy, Sri Lanka": {
    si: "8J5P+XJ7, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8J5P+XJ7, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8JMC+9WR, Katugastota, Sri Lanka": {
    si: "8JMC+9WR, \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8JMC+9WR, \u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8M87+3WW, A27, Ampara, Sri Lanka": {
    si: "8M87+3WW, A27, \u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8M87+3WW, A27, \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8M87+V82, A27, Ampara, Sri Lanka": {
    si: "8M87+V82, A27, \u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8M87+V82, A27, \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8MGF+86C, Madawala, Sri Lanka": {
    si: "8MGF+86C, \u0db8\u0da9\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8MGF+86C, \u0bae\u0b9f\u0bb5\u0bbe\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8MXJ+WFP, Wattegama, Sri Lanka": {
    si: "8MXJ+WFP, \u0dc0\u0dad\u0dca\u0dad\u0dda\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8MXJ+WFP, \u0bb5\u0ba4\u0bcd\u0ba4\u0bc7\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8P56+VX Menikhinna, Sri Lanka": {
    si: "8P56+VX \u0db8\u0dd0\u0dab\u0dd2\u0d9a\u0dca\u0dc4\u0dd2\u0db1\u0dca\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8P56+VX \u0bae\u0bc6\u0ba9\u0bbf\u0b95\u0bcd\u0bb9\u0bbf\u0ba9\u0bcd\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8P82+V2H, Madawala - Rajawella Rd, Menikhinna, Sri Lanka": {
    si: "8P82+V2H, \u0db8\u0da9\u0dc0\u0dbd - \u0dbb\u0da2\u0dc0\u0dd0\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dd0\u0dab\u0dd2\u0d9a\u0dca\u0dc4\u0dd2\u0db1\u0dca\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8P82+V2H, \u0bae\u0b9f\u0bb5\u0bb3\u0bc8 - \u0bb0\u0bbe\u0b9c\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bc6\u0ba9\u0bbf\u0b95\u0bcd\u0bb9\u0bbf\u0ba9\u0bcd\u0ba9, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8Q67+6CH, Karalliyadda, Sri Lanka": {
    si: "8Q67+6CH, \u0d9a\u0dbb\u0dbd\u0dca\u0dbd\u0dd2\u0dba\u0daf\u0dca\u0daf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8Q67+6CH, \u0b95\u0bb0\u0bb2\u0bcd\u0bb2\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8R6P+JF Embilipitiya, Sri Lanka": {
    si: "8R6P+JF \u0d87\u0db9\u0dd2\u0dbd\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8R6P+JF \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0bb2\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8RFW+77R, Nainamadama, Sri Lanka": {
    si: "8RFW+77R, \u0db1\u0dba\u0dd2\u0db1\u0db8\u0da9\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8RFW+77R, \u0ba8\u0bc8\u0ba9\u0bbe\u0bae\u0b9f\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8RGW+X4C, Puttalam Road, Nainamadama, Sri Lanka": {
    si: "8RGW+X4C, \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 \u0db4\u0dcf\u0dbb, \u0db1\u0dba\u0dd2\u0db1\u0db8\u0da9\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8RGW+X4C, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc8\u0ba9\u0bbe\u0bae\u0b9f\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8RHM+X2G, Wennappuwa, Sri Lanka": {
    si: "8RHM+X2G, \u0dc0\u0dd9\u0db1\u0dca\u0db1\u0db4\u0dca\u0db4\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8RHM+X2G, \u0bb5\u0bc6\u0ba9\u0bcd\u0ba9\u0baa\u0bcd\u0baa\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8RPW+FQ Nintavur, Sri Lanka": {
    si: "8RPW+FQ \u0db1\u0dd2\u0db1\u0dca\u0daf\u0dc0\u0dd4\u0dbb\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8RPW+FQ \u0ba8\u0bbf\u0ba8\u0bcd\u0ba4\u0bb5\u0bc2\u0bb0\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8VM3+W59, A18, Embilipitiya, Sri Lanka": {
    si: "8VM3+W59, A18, \u0d87\u0db9\u0dd2\u0dbd\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8VM3+W59, A18, \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0bb2\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8VM5+VGF, Embilipitiya, Sri Lanka": {
    si: "8VM5+VGF, \u0d87\u0db9\u0dd2\u0dbd\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8VM5+VGF, \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0bb2\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8VX7+H5J, Wennappuwa, Sri Lanka": {
    si: "8VX7+H5J, \u0dc0\u0dd9\u0db1\u0dca\u0db1\u0db4\u0dca\u0db4\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8VX7+H5J, \u0bb5\u0bc6\u0ba9\u0bcd\u0ba9\u0baa\u0bcd\u0baa\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8X98+PXX, Sri Lanka": {
    si: "8X98+PXX, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8X98+PXX, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8XJV+WCG, Mahiyanganaya, Sri Lanka": {
    si: "8XJV+WCG, \u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8XJV+WCG, \u0bae\u0bb9\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0ba9\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8XQR+QQ9, Mahiyanganaya, Sri Lanka": {
    si: "8XQR+QQ9, \u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8XQR+QQ9, \u0bae\u0bb9\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0ba9\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "8XQR+WWF, Mahiyanganaya, Sri Lanka": {
    si: "8XQR+WWF, \u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "8XQR+WWF, \u0bae\u0bb9\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0ba9\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9 Yakkala Rd, Gampaha": {
    si: "9 \u0dba\u0d9a\u0dca\u0d9a\u0dbd \u0db4\u0dcf\u0dbb, \u0d9c\u0db8\u0dca\u0db4\u0dc4",
    ta: "9 \u0baf\u0b95\u0bcd\u0b95\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe",
  },
  "9293+5QJ, Kantale, Sri Lanka": {
    si: "9293+5QJ, \u0d9a\u0db1\u0dca\u0dad\u0dbd\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9293+5QJ, \u0b95\u0ba8\u0bcd\u0ba4\u0bb3\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "92J6+896, Sri Lanka": {
    si: "92J6+896, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "92J6+896, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "93R9+QGJ, Kurunegala, Sri Lanka": {
    si: "93R9+QGJ, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "93R9+QGJ, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "948 Kandy - Jaffna Hwy, Rambewa, Sri Lanka": {
    si: "948 \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb - \u0dba\u0dcf\u0db4\u0db1\u0dba Hwy, \u0dbb\u0db9\u0dd1\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "948 \u0b95\u0ba3\u0bcd\u0b9f\u0bbf - \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd \u0bb9\u0bc6\u0bb5\u0bbf, \u0bb0\u0bae\u0bcd\u0baa\u0bc7\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "948X+333 Gas Station, B27, Dambadeniya, Sri Lanka": {
    si: "948X+333 \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, B27, \u0daf\u0db9\u0daf\u0dd9\u0dab\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "948X+333 \u0b8e\u0bb0\u0bbf\u0bb5\u0bbe\u0baf\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, B27, \u0ba4\u0bae\u0bcd\u0baa\u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "95 Peradeniya-Badulla-Chenkaladi Hwy, Keppetipola, Sri Lanka": {
    si: "95 \u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba-\u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd-\u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2 Hwy, \u0d9a\u0dd0\u0db4\u0dca\u0db4\u0dd9\u0da7\u0dd2\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "95 \u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8-\u0baa\u0ba4\u0bc1\u0bb3\u0bc8-\u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf Hwy, \u0b95\u0bc6\u0baa\u0bcd\u0baa\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baa\u0bca\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "96 A6, Mullipotana, Sri Lanka": {
    si: "96 A6, \u0db8\u0dd4\u0dbd\u0dca\u0dbd\u0dd2\u0db4\u0ddc\u0dad\u0dcf\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "96 A6, \u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbf\u0baa\u0bca\u0ba4\u0bcd\u0ba4\u0bbe\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "96H8+PG Nakalagamuwa, Sri Lanka": {
    si: "96H8+PG \u0db1\u0dcf\u0d9a\u0dbd\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "96H8+PG \u0ba8\u0bbe\u0b95\u0bb2\u0b95\u0bae\u0bc1\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "96XR+5J3, Padiyatalawa, Sri Lanka": {
    si: "96XR+5J3, \u0db4\u0daf\u0dd2\u0dba\u0dad\u0dbd\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "96XR+5J3, \u0baa\u0ba4\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9854+HHH, Divulkumbura, Sri Lanka": {
    si: "9854+HHH, \u0daf\u0dd2\u0dc0\u0dd4\u0dbd\u0dca\u0d9a\u0dd4\u0db9\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9854+HHH, \u0ba4\u0bbf\u0bb5\u0bc1\u0bb2\u0bcd\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "998 Narammala - Kuliyapitiya Rd, Andiyagala": {
    si: "998 \u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd - \u0d9a\u0dd4\u0dbd\u0dd2\u0dba\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0d86\u0dab\u0dca\u0da9\u0dd2\u0dba\u0d9c\u0dbd",
    ta: "998 \u0ba8\u0bbe\u0bb0\u0bae\u0bcd\u0bae\u0bb2 - \u0b95\u0bc1\u0bb3\u0bbf\u0baf\u0bbe\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b86\u0ba3\u0bcd\u0b9f\u0bbf\u0baf\u0b95\u0bb2",
  },
  "998 Narammala-Kuliyapitiya Rd, Andiyagala, Sri Lanka": {
    si: "998 \u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd-\u0d9a\u0dd4\u0dbd\u0dd2\u0dba\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0d86\u0dab\u0dca\u0da9\u0dd2\u0dba\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "998 \u0ba8\u0bbe\u0bb0\u0bae\u0bcd\u0bae\u0bb2-\u0b95\u0bc1\u0bb2\u0bbf\u0baf\u0bbe\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0b9a\u0bbe\u0bb2\u0bc8, \u0b86\u0ba3\u0bcd\u0b9f\u0bbf\u0baf\u0b95\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9C48+787, Anuradhapura, Sri Lanka": {
    si: "9C48+787, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9C48+787, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9C4C+H5 Anuradhapura, Sri Lanka": {
    si: "9C4C+H5 \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9C4C+H5 \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9CHG+4G Anuradhapura, Sri Lanka": {
    si: "9CHG+4G \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9CHG+4G \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9CR5+W45, Kandy - Jaffna Hwy, Kilinochchi, Sri Lanka": {
    si: "9CR5+W45, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb - \u0dba\u0dcf\u0db4\u0db1\u0dba Hwy, \u0d9a\u0dd2\u0dbd\u0dd2\u0db1\u0ddc\u0da0\u0dca\u0da0\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9CR5+W45, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf - \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd \u0bb9\u0bc6\u0bb5\u0bbf, \u0b95\u0bbf\u0bb3\u0bbf\u0ba8\u0bca\u0b9a\u0bcd\u0b9a\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9G56+66F, Puttalam - Anuradhapura - Trincomalee Hwy, Mihintale, Sri Lanka": {
    si: "9G56+66F, \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 - \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb - \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba Hwy, \u0db8\u0dd2\u0dc4\u0dd2\u0db1\u0dca\u0dad\u0dbd\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9G56+66F, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 Hwy, \u0bae\u0bbf\u0bb9\u0bbf\u0ba8\u0bcd\u0ba4\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9GFG+R9X Madawala Junction (     ), Galagedara, Sri Lanka": {
    si: "9GFG+R9X \u0db8\u0da9\u0dc0\u0dbd \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba (), \u0d9c\u0dbd\u0d9c\u0dd9\u0daf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9GFG+R9X \u0bae\u0b9f\u0bb5\u0bb3\u0bc8 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0baa\u0bcd\u0baa\u0bc1 (), \u0b95\u0bb2\u0b95\u0bc6\u0ba4\u0bb0, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9GPX+P7Q, Parantan-Mullaitivu Hwy, Visuvamadu, Sri Lanka": {
    si: "9GPX+P7Q, \u0db4\u0dbb\u0db1\u0dca\u0dad\u0db1\u0dca-\u0db8\u0dd4\u0dbd\u0dad\u0dd2\u0dc0\u0dca Hwy, \u0dc0\u0dd2\u0dc1\u0dca\u0dc0\u0db8\u0da9\u0dd4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9GPX+P7Q, \u0baa\u0bb0\u0ba8\u0bcd\u0ba4\u0ba9\u0bcd-\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bc8\u0ba4\u0bcd\u0ba4\u0bc0\u0bb5\u0bc1 Hwy, \u0bb5\u0bbf\u0b9a\u0bc1\u0bb5\u0bae\u0b9f\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9HHP+XJV, Poojapitiya, Sri Lanka": {
    si: "9HHP+XJV, \u0db4\u0dd6\u0da2\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9HHP+XJV, \u0baa\u0bc2\u0b9c\u0bbe\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9HJQ+F6 Tammannewa, Sri Lanka": {
    si: "9HJQ+F6 \u0dad\u0db8\u0dca\u0db8\u0dd0\u0db1\u0dca\u0db1\u0dd1\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9HJQ+F6 \u0ba4\u0bae\u0bcd\u0bae\u0ba9\u0bcd\u0ba9\u0bc7\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9HV3+63R, Ambatenne-Bokkawela-Arambekade Rd, Bokkawala, Sri Lanka": {
    si: "9HV3+63R, \u0d85\u0db9\u0dad\u0dd0\u0db1\u0dca\u0db1\u0dda-\u0db6\u0ddc\u0d9a\u0dca\u0d9a\u0dcf\u0dc0\u0dd9\u0dbd-\u0d85\u0dbb\u0db9\u0dda\u0d9a\u0da9\u0dda \u0db4\u0dcf\u0dbb, \u0db6\u0ddc\u0d9a\u0dca\u0d9a\u0dcf\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9HV3+63R, \u0b85\u0bae\u0bcd\u0baa\u0ba4\u0bc6\u0ba9\u0bcd\u0ba9-\u0baa\u0bca\u0b95\u0bcd\u0b95\u0bb5\u0bc6\u0bb2-\u0b85\u0bb0\u0bae\u0bcd\u0baa\u0bc7\u0b95\u0bcd\u0b95\u0b9f\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bca\u0b95\u0bcd\u0b95\u0bb5\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9J58+7XV, Kudugala, Sri Lanka": {
    si: "9J58+7XV, \u0d9a\u0dd4\u0da9\u0dd4\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9J58+7XV, \u0b95\u0bc1\u0b9f\u0bc1\u0b95\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9J5V+F93, Uhana, Sri Lanka": {
    si: "9J5V+F93, \u0d8b\u0dc4\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9J5V+F93, \u0b89\u0bb9\u0bbe\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9JPG+Q5R, Weranketagoda, Sri Lanka": {
    si: "9JPG+Q5R, \u0dc0\u0dda\u0dbb\u0db1\u0dca\u0d9a\u0dd9\u0da7\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9JPG+Q5R, \u0bb5\u0bc6\u0bb0\u0ba9\u0bcd\u0b95\u0bc6\u0b9f\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9R3W+8CJ, Nintavur, Sri Lanka": {
    si: "9R3W+8CJ, \u0db1\u0dd2\u0db1\u0dca\u0daf\u0dc0\u0dd6\u0dbb\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9R3W+8CJ, \u0ba8\u0bbf\u0ba8\u0bcd\u0ba4\u0bb5\u0bc2\u0bb0\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9R5P+72C, Katuneriya, Sri Lanka": {
    si: "9R5P+72C, \u0d9a\u0da7\u0dd4\u0db1\u0dda\u0dbb\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9R5P+72C, \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0ba9\u0bc7\u0bb0\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9R5W+63G, Nintavur, Sri Lanka": {
    si: "9R5W+63G, \u0db1\u0dd2\u0db1\u0dca\u0daf\u0dc0\u0dd6\u0dbb\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9R5W+63G, \u0ba8\u0bbf\u0ba8\u0bcd\u0ba4\u0bb5\u0bc2\u0bb0\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9R62+WX5, Karativu-Ampara Hwy, Sammanthurai, Sri Lanka": {
    si: "9R62+WX5, Karativu-Ampara Hwy, Sammanthurai, Sri Lanka",
    ta: "9R62+WX5, \u0b95\u0bbe\u0bb0\u0bc8\u0ba4\u0bc0\u0bb5\u0bc1-\u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8 Hwy, \u0b9a\u0bae\u0bcd\u0bae\u0bbe\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9R73+8JX, Sammanthurai, Sri Lanka": {
    si: "9R73+8JX, \u0dc3\u0db8\u0dca\u0db8\u0db1\u0dca\u0dad\u0dd4\u0dbb\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9R73+8JX, \u0b9a\u0bae\u0bcd\u0bae\u0bbe\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9R9G+RWM, Sri Lanka": {
    si: "9R9G+RWM, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9R9G+RWM, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9RCC+M5H, Karativu-Ampara Highway, Karaitivu, Sri Lanka": {
    si: "9RCC+M5H, \u0d9a\u0dcf\u0dbb\u0dad\u0dd2\u0dc0\u0dca-\u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0d9a\u0dbb\u0dd9\u0dba\u0dd2\u0dad\u0dd2\u0dc0\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9RCC+M5H, \u0b95\u0bbe\u0bb0\u0bc8\u0ba4\u0bc0\u0bb5\u0bc1-\u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8 \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bbe\u0bb0\u0bc8\u0ba4\u0bc0\u0bb5\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9RPJ+HJV, Marawila, Sri Lanka": {
    si: "9RPJ+HJV, \u0db8\u0dcf\u0dbb\u0dc0\u0dd2\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9RPJ+HJV, \u0bae\u0bbe\u0bb0\u0bb5\u0bbf\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9RPP+5QH, Karaitivu 32250, Sri Lanka": {
    si: "9RPP+5QH, \u0d9a\u0dbb\u0dd9\u0dba\u0dd2\u0dad\u0dd2\u0dc0\u0dca 32250, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9RPP+5QH, \u0b95\u0bbe\u0bb0\u0bc8\u0ba4\u0bc0\u0bb5\u0bc1 32250, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9RPP+JM4, Riyal Sawmill Rd, Karaitivu 32250, Sri Lanka": {
    si: "9RPP+JM4, \u0dbb\u0dd2\u0dba\u0dcf\u0dbd\u0dca \u0dc3\u0ddd\u0db8\u0dd2\u0dbd\u0dca \u0db4\u0dcf\u0dbb, \u0d9a\u0dbb\u0dd9\u0dba\u0dd2\u0dad\u0dd2\u0dc0\u0dca 32250, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9RPP+JM4, Ryal Sawmill Rd, \u0b95\u0bbe\u0bb0\u0bc8\u0ba4\u0bc0\u0bb5\u0bc1 32250, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9Th Mile Post, Kadawatha, Sri Lanka": {
    si: "9 \u0dc0\u0dd0\u0db1\u0dd2 \u0dc3\u0dd0\u0dad\u0db4\u0dd4\u0db8\u0dca \u0d9a\u0dab\u0dd4\u0dc0, \u0d9a\u0da9\u0dc0\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9\u0bb5\u0ba4\u0bc1 \u0bae\u0bc8\u0bb2\u0bcd \u0baa\u0bcb\u0bb8\u0bcd\u0b9f\u0bcd, \u0b95\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9V7J+55Q, Bothalegama, Sri Lanka": {
    si: "9V7J+55Q, \u0db6\u0ddd\u0dad\u0dbd\u0dda\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9V7J+55Q, \u0baa\u0bcb\u0ba4\u0bcd\u0ba4\u0bb2\u0bc7\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9W38+H2 Sewanagala, Sri Lanka": {
    si: "9W38+H2 \u0dc3\u0dd9\u0dc0\u0db1\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9W38+H2 \u0b9a\u0bc6\u0bb5\u0ba9\u0b95\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9WH3+W7 Yakdessawa, Sri Lanka": {
    si: "9WH3+W7 \u0dba\u0d9a\u0dca\u0daf\u0dd9\u0dc3\u0dca\u0dc3\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9WH3+W7 \u0baf\u0b95\u0bcd\u0ba4\u0bc7\u0b9a\u0bbe\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9X22+MP3, Hasalaka New Town, Sri Lanka": {
    si: "9X22+MP3, \u0dc4\u0dc3\u0dbd\u0d9a \u0db1\u0dc0 \u0db1\u0d9c\u0dbb\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9X22+MP3, \u0bb9\u0b9a\u0bb2\u0b95\u0bbe \u0baa\u0bc1\u0ba4\u0bbf\u0baf \u0ba8\u0b95\u0bb0\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9XJV+XQW, Mahiyanganaya, Sri Lanka": {
    si: "9XJV+XQW, \u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9XJV+XQW, \u0bae\u0bb9\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0ba9\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9XXH+R5R, Pannala, Sri Lanka": {
    si: "9XXH+R5R, \u0db4\u0db1\u0dca\u0db1\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "9XXH+R5R, \u0baa\u0ba9\u0bcd\u0ba9\u0bbe\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "9a Vallai-Tellippalai-Araly Rd, Kalaiyadi, Sri Lanka": {
    si: "9a Vallai-Tellippalai-Araly Rd, Kalaiyadi, Sri Lanka",
    ta: "9a \u0bb5\u0bb2\u0bcd\u0bb2\u0bc8-\u0ba4\u0bc6\u0bb2\u0bcd\u0bb2\u0bbf\u0baa\u0bcd\u0baa\u0bb3\u0bc8-\u0b85\u0bb0\u0bbe\u0bb2\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0b95\u0bbe\u0bb3\u0bc8\u0baf\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "< 30mins": {
    si: "< \u0dc0\u0dd2\u0db1\u0dcf\u0da9\u0dd2 30",
    ta: "< 30 \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0b99\u0bcd\u0b95\u0bb3\u0bcd",
  },
  "<1 Hr Ago": {
    si: "<\u0db4\u0dd0\u0dba 1 \u0d9a\u0da7 \u0db4\u0dd9\u0dbb",
    ta: "<1 \u0bae\u0ba3\u0bbf\u0ba8\u0bc7\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0bb1\u0bcd\u0b95\u0bc1 \u0bae\u0bc1\u0ba9\u0bcd\u0baa\u0bc1",
  },
  "<1 Week Ago": {
    si: "<\u0dc3\u0dad\u0dd2\u0dba\u0d9a\u0da7 \u0db4\u0dd9\u0dbb",
    ta: "<1 \u0bb5\u0bbe\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0bb1\u0bcd\u0b95\u0bc1 \u0bae\u0bc1\u0ba9\u0bcd\u0baa\u0bc1",
  },
  "<12 Hrs Ago": {
    si: "<\u0db4\u0dd0\u0dba 12 \u0d9a\u0da7 \u0db4\u0dd9\u0dbb",
    ta: "<12 \u0bae\u0ba3\u0bbf\u0ba8\u0bc7\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0bb1\u0bcd\u0b95\u0bc1 \u0bae\u0bc1\u0ba9\u0bcd\u0baa\u0bc1",
  },
  "<24 Hrs Ago": {
    si: "<\u0db4\u0dd0\u0dba 24 \u0d9a\u0da7 \u0db4\u0dd9\u0dbb",
    ta: "<24 \u0bae\u0ba3\u0bbf\u0ba8\u0bc7\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0bb1\u0bcd\u0b95\u0bc1 \u0bae\u0bc1\u0ba9\u0bcd\u0baa\u0bc1",
  },
  "<3 Hrs Ago": {
    si: "<\u0db4\u0dd0\u0dba 3 \u0d9a\u0da7 \u0db4\u0dd9\u0dbb",
    ta: "<3 \u0bae\u0ba3\u0bbf\u0ba8\u0bc7\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0bb1\u0bcd\u0b95\u0bc1 \u0bae\u0bc1\u0ba9\u0bcd\u0baa\u0bc1",
  },
  "<6 Hrs Ago": {
    si: "<\u0db4\u0dd0\u0dba 6 \u0d9a\u0da7 \u0db4\u0dd9\u0dbb",
    ta: "<6 \u0bae\u0ba3\u0bbf\u0ba8\u0bc7\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0bb1\u0bcd\u0b95\u0bc1 \u0bae\u0bc1\u0ba9\u0bcd\u0baa\u0bc1",
  },
  "> 3hrs": {
    si: "> \u0db4\u0dd0\u0dba 3 \u0dba\u0dd2",
    ta: "> 3 \u0bae\u0ba3\u0bbf",
  },
  "A & J DEVELOPERS & CONSULTANTS (PVT": {
    si: "A & J \u0dc3\u0d82\u0dc0\u0dbb\u0dca\u0db0\u0d9a\u0dba\u0dd2\u0db1\u0dca \u0dc3\u0dc4 \u0d8b\u0db4\u0daf\u0dda\u0dc1\u0d9a\u0dba\u0dd2\u0db1\u0dca (PVT",
    ta: "\u0b8f & \u0b9c\u0bc7 \u0b9f\u0bc6\u0bb5\u0bb2\u0baa\u0bcd\u0baa\u0bb0\u0bcd\u0b95\u0bb3\u0bcd & \u0b86\u0bb2\u0bcb\u0b9a\u0b95\u0bb0\u0bcd\u0b95\u0bb3\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf",
  },
  "A A S H AMARASINHA": {
    si: "\u0d92 \u0d92 \u0d91\u0dc3\u0dca \u0d91\u0da0\u0dca \u0d85\u0db8\u0dbb\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b8f \u0b8f \u0b8e\u0bb8\u0bcd \u0b8e\u0b9a\u0bcd \u0b85\u0bae\u0bb0\u0b9a\u0bbf\u0ba9\u0bcd\u0bb9\u0bbe",
  },
  "A ARUNA SURANGA": {
    si: "A ARUNA SURANGA",
    ta: "A ARUNA SURANGA",
  },
  "A B A  JABBAR": {
    si: "\u0d92 \u0db6\u0dd3 \u0d92 \u0da2\u0db6\u0dca\u0db6\u0dcf\u0dbb\u0dca",
    ta: "\u0b8f \u0baa\u0bbf \u0b8f \u0b9c\u0baa\u0bcd\u0baa\u0bbe\u0bb0\u0bcd",
  },
  "A D YAPA": {
    si: "A D \u0dba\u0dcf\u0db4\u0dcf",
    ta: "\u0b92\u0bb0\u0bc1 \u0b9f\u0bbf \u0baf\u0bbe\u0baa\u0bbe",
  },
  "A DE S JAYAWARDENA & SON": {
    si: "\u0d92 \u0da9\u0dd3 \u0d91\u0dc3\u0dca \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0dcf",
    ta: "\u0b8f \u0b9f\u0bbf \u0b8e\u0bb8\u0bcd \u0b9c\u0bc6\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0bbe & \u0bae\u0b95\u0ba9\u0bcd",
  },
  "A G G RAWIN GANITHA": {
    si: "A G G RAWIN GANITHA",
    ta: "\u0b8f \u0b9c\u0bbf \u0b9c\u0bbf \u0bb0\u0bbe\u0bb5\u0bbf\u0ba9\u0bcd \u0b95\u0ba3\u0bbf\u0ba4\u0bbe",
  },
  "A H J LABDEEN": {
    si: "\u0d92 \u0d91\u0da0\u0dca \u0da2\u0dda \u0dbd\u0dd0\u0db6\u0dca\u0daf\u0dd3\u0db1\u0dca",
    ta: "\u0b8f \u0b8e\u0b9a\u0bcd \u0b9c\u0bc7 \u0bb2\u0baa\u0bcd\u0ba4\u0bc0\u0ba9\u0bcd",
  },
  "A H M HUSSAIN HADJIAR SONS": {
    si: "\u0d92 \u0d91\u0da0\u0dca \u0d91\u0db8\u0dca \u0dc4\u0dd4\u0dc3\u0dda\u0db1\u0dca \u0dc4\u0da2\u0dd2\u0dba\u0dcf\u0dbb\u0dca \u0db4\u0dd4\u0dad\u0dd4\u0db1\u0dca",
    ta: "\u0b8f \u0b8e\u0b9a\u0bcd \u0b8e\u0bae\u0bcd \u0bb9\u0bc1\u0b9a\u0bc8\u0ba9\u0bcd \u0bb9\u0bbe\u0b9c\u0bbf\u0baf\u0bbe\u0bb0\u0bcd \u0bae\u0b95\u0ba9\u0bcd\u0b95\u0bb3\u0bcd",
  },
  "A H M M.THABIDUDEEN": {
    si: "\u0d92 \u0d91\u0da0\u0dca \u0d91\u0db8\u0dca \u0d91\u0db8\u0dca \u0dad\u0db6\u0dd2\u0daf\u0dd4\u0daf\u0dd3\u0db1\u0dca",
    ta: "\u0b8f \u0b8e\u0b9a\u0bcd \u0b8e\u0bae\u0bcd \u0b8e\u0bae\u0bcd.\u0ba4\u0bbe\u0baa\u0bbf\u0ba4\u0bc1\u0ba4\u0bc0\u0ba9\u0bcd",
  },
  "A H SUNIL": {
    si: "\u0d92 \u0d91\u0da0\u0dca \u0dc3\u0dd4\u0db1\u0dd2\u0dbd\u0dca",
    ta: "\u0b8f \u0b8e\u0b9a\u0bcd \u0b9a\u0bc1\u0ba9\u0bbf\u0bb2\u0bcd",
  },
  "A H WIMALATUNGA & SON (PVT) LTD.": {
    si: "A H \u0dc0\u0dd2\u0db8\u0dbd\u0dad\u0dd4\u0d82\u0d9c \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb (PVT) LTD.",
    ta: "\u0b8f \u0b8e\u0b9a\u0bcd \u0bb5\u0bbf\u0bae\u0bb2\u0ba4\u0bc1\u0b99\u0bcd\u0b95 & \u0b9a\u0ba9\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd.",
  },
  "A J ABEYWICKRAMA": {
    si: "\u0d92 \u0da2\u0dda \u0d85\u0db6\u0dda\u0dc0\u0dd2\u0d9a\u0dca\u200d\u0dbb\u0db8",
    ta: "\u0b8f \u0b9c\u0bc7 \u0b85\u0baa\u0bc7\u0bb5\u0bbf\u0b95\u0bcd\u0bb0\u0bae",
  },
  "A J M FARRY. (M/s. A J FUEL MART)": {
    si: "\u0d92 \u0da2\u0dda \u0d91\u0db8\u0dca \u0dc6\u0dcf\u0dbb\u0dd2. (M/s. A J FUEL MART)",
    ta: "\u0b8f \u0b9c\u0bc7 \u0b8e\u0bae\u0bcd \u0b83\u0baa\u0bbe\u0bb0\u0bbf. (M/s. AJ FUEL MART)",
  },
  "A J S JAYAKODY": {
    si: "\u0d92 \u0da2\u0dda \u0d91\u0dc3\u0dca \u0da2\u0dba\u0d9a\u0ddc\u0da9\u0dd2",
    ta: "\u0b8f \u0b9c\u0bc7 \u0b8e\u0bb8\u0bcd \u0b9c\u0bc6\u0baf\u0b95\u0bcd\u0b95\u0bca\u0b9f\u0bbf",
  },
  "A L M HANIFA": {
    si: "\u0d92 \u0d91\u0dbd\u0dca \u0d91\u0db8\u0dca \u0dc4\u0db1\u0dd3\u0dc6\u0dcf",
    ta: "\u0b8f \u0b8e\u0bb2\u0bcd \u0b8e\u0bae\u0bcd \u0bb9\u0ba9\u0bbf\u0baa\u0bbe",
  },
  "A M  THANANAYAGAM": {
    si: "\u0d92 \u0d91\u0db8\u0dca \u0dad\u0db1\u0db1\u0dcf\u0dba\u0d9c\u0db8\u0dca",
    ta: "\u0b8f \u0b8e\u0bae\u0bcd \u0ba4\u0ba9\u0ba8\u0bbe\u0baf\u0b95\u0bae\u0bcd",
  },
  "A M A ABOOBUCKER LEBBE & SONS": {
    si: "\u0d92 \u0d91\u0db8\u0dca \u0d92 \u0d85\u0db6\u0dd6\u0db6\u0d9a\u0dbb\u0dca \u0dbd\u0dd9\u0db6\u0dca\u0db6\u0dda \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b8f \u0b8e\u0bae\u0bcd \u0b8f \u0b85\u0baa\u0bc2\u0baa\u0b95\u0bcd\u0b95\u0bb0\u0bcd \u0bb2\u0bc6\u0baa\u0bcd\u0baa\u0bc7 & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "A M D N ARTHANAYAKE": {
    si: "\u0d92 \u0d91\u0db8\u0dca \u0da9\u0dd3 \u0d91\u0db1\u0dca \u0d85\u0dbb\u0dca\u0dae\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b8f \u0b8e\u0bae\u0bcd \u0b9f\u0bbf \u0b8e\u0ba9\u0bcd \u0b85\u0bb0\u0bcd\u0ba4\u0bcd\u0ba4\u0ba8\u0bbe\u0baf\u0b95\u0bc7",
  },
  "A M D P AMARASINGHE": {
    si: "\u0d92 \u0d91\u0db8\u0dca \u0da9\u0dd3 \u0db4\u0dd3 \u0d85\u0db8\u0dbb\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b8f \u0b8e\u0bae\u0bcd \u0b9f\u0bbf \u0baa\u0bbf \u0b85\u0bae\u0bb0\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "A M M .NIJAM": {
    si: "A M M .NIJAM",
    ta: "\u0b8f \u0b8e\u0bae\u0bcd \u0b8e\u0bae\u0bcd .\u0ba8\u0bbf\u0b9c\u0bbe\u0bae\u0bcd",
  },
  "A M NANDAWATHI": {
    si: "\u0d92 \u0d91\u0db8\u0dca \u0db1\u0db1\u0dca\u0daf\u0dcf\u0dc0\u0dad\u0dd3",
    ta: "\u0b8f \u0b8e\u0bae\u0bcd \u0ba8\u0ba8\u0bcd\u0ba4\u0bbe\u0bb5\u0ba4\u0bbf",
  },
  "A M SUNIL GUNARATHNA": {
    si: "\u0d92 \u0d91\u0db8\u0dca \u0dc3\u0dd4\u0db1\u0dd2\u0dbd\u0dca \u0d9c\u0dd4\u0dab\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b8f \u0b8e\u0bae\u0bcd \u0b9a\u0bc1\u0ba9\u0bbf\u0bb2\u0bcd \u0b95\u0bc1\u0ba3\u0bb0\u0ba4\u0bcd\u0ba9\u0bbe",
  },
  "A M THANANAYAGHAM": {
    si: "\u0d92 \u0d91\u0db8\u0dca \u0dad\u0dab\u0db1\u0dcf\u0dba\u0d9c\u0db8\u0dca",
    ta: "\u0b8f \u0b8e\u0bae\u0bcd \u0ba4\u0ba9\u0ba8\u0bbe\u0baf\u0b95\u0bae\u0bcd",
  },
  "A M U B ARAMPOLA": {
    si: "\u0d92 \u0d91\u0db8\u0dca \u0dba\u0dd6 \u0db6\u0dd3 \u0d85\u0dbb\u0db8\u0dca\u0db4\u0ddc\u0dbd",
    ta: "\u0b8f \u0b8e\u0bae\u0bcd \u0baf\u0bc1 \u0baa\u0bbf \u0b85\u0bb1\u0bae\u0bcd\u0baa\u0bcb\u0bb2",
  },
  "A M.NIJAM": {
    si: "M.NIJAM",
    ta: "\u0b92\u0bb0\u0bc1 \u0b8e\u0bae\u0bcd.\u0ba8\u0bbf\u0b9c\u0bbe\u0bae\u0bcd",
  },
  "A MADAWAN": {
    si: "\u0db8\u0dcf\u0da9\u0dc0\u0db1\u0dca \u0d9a\u0dd9\u0db1\u0dd9\u0d9a\u0dca",
    ta: "\u0b92\u0bb0\u0bc1 \u0bae\u0bbe\u0ba4\u0bb5\u0ba9\u0bcd",
  },
  "A R THILAK KUMARA": {
    si: "\u0d92 \u0d86\u0dbb\u0dca \u0dad\u0dd2\u0dbd\u0d9a\u0dca \u0d9a\u0dd4\u0db8\u0dcf\u0dbb",
    ta: "\u0b8f \u0b86\u0bb0\u0bcd \u0ba4\u0bbf\u0bb2\u0b95\u0bcd \u0b95\u0bc1\u0bae\u0bbe\u0bb0",
  },
  "A R WIJESINGHE": {
    si: "\u0d92 \u0d86\u0dbb\u0dca \u0dc0\u0dd2\u0da2\u0dda\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b8f \u0b86\u0bb0\u0bcd \u0bb5\u0bbf\u0b9c\u0bc7\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "A V HINNIAPPUHAMI & CO": {
    si: "\u0d92 \u0dc0\u0dd3 \u0dc4\u0dd2\u0db1\u0dca\u0db1\u0dd2\u0d85\u0db4\u0dca\u0db4\u0dd4\u0dc4\u0dcf\u0db8\u0dd2 \u0dc3\u0dc4 \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0b8f \u0bb5\u0bbf \u0bb9\u0bbf\u0ba9\u0bcd\u0ba9\u0bbf\u0baf\u0baa\u0bcd\u0baa\u0bc1\u0bb9\u0bbe\u0bae\u0bbf & \u0b95\u0bcb",
  },
  "A W DAVITH APPUHAMY & SONS": {
    si: "\u0d92 \u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0da9\u0dda\u0dc0\u0dd2\u0dad\u0dca \u0d85\u0db4\u0dca\u0db4\u0dd4\u0dc4\u0dcf\u0db8\u0dd2 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b8f \u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b9f\u0bc7\u0bb5\u0bbf\u0b9f\u0bcd \u0b85\u0baa\u0bcd\u0baa\u0bc1\u0bb9\u0bbe\u0bae\u0bbf & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "A W RANASINGHE": {
    si: "\u0d92 \u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0dbb\u0dab\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b8f \u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0bb0\u0ba3\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "A W W ROHANA BANDARA": {
    si: "\u0d92 \u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0dbb\u0ddd\u0dc4\u0dab \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb",
    ta: "A W W \u0bb0\u0bcb\u0bb9\u0ba9 \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0",
  },
  "A Z M HASSIM": {
    si: "A Z M \u0dc4\u0dc3\u0dd2\u0db8\u0dca",
    ta: "\u0b8f \u0b87\u0b9a\u0b9f\u0bcd \u0b8e\u0bae\u0bcd \u0bb9\u0bbe\u0b9a\u0bbf\u0bae\u0bcd",
  },
  "A-9,Road,-Kilinochchi": {
    si: "A-9, \u0db4\u0dcf\u0dbb,-\u0d9a\u0dd2\u0dbd\u0dd2\u0db1\u0ddc\u0da0\u0dca\u0da0\u0dd2",
    ta: "\u0b8f-9, \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bbf\u0bb3\u0bbf\u0ba8\u0bca\u0b9a\u0bcd\u0b9a\u0bbf",
  },
  "A. L. G.GONAKUMBURA .": {
    si: "\u0d92.\u0d91\u0dbd\u0dca.\u0da2\u0dd3.\u0d9c\u0ddd\u0db1\u0d9a\u0dd4\u0db9\u0dd4\u0dbb.",
    ta: "\u0b8f.\u0b8e\u0bb2\u0bcd.\u0b9c\u0bbf.\u0b95\u0bcb\u0ba9\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bbe.",
  },
  "A.A.D.PERERA VIYAPARAYA": {
    si: "\u0d92.\u0da9\u0dd3.\u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf \u0dc0\u0dd2\u0dba\u0db4\u0dbb\u0dba\u0dcf",
    ta: "\u0b8f.\u0b8f.\u0b9f\u0bbf.\u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe \u0bb5\u0bbf\u0baf\u0bbe\u0baa\u0bb0\u0bbe\u0baf",
  },
  "A.A.KAFOOR": {
    si: "A.A.KAFOOR",
    ta: "\u0b8f.\u0b8f.\u0b95\u0baa\u0bc2\u0bb0\u0bcd",
  },
  "A.ALISABRI": {
    si: "A.ALISABRI",
    ta: "\u0b85.\u0b85\u0bb2\u0bbf\u0b9a\u0bbe\u0baa\u0bcd\u0bb0\u0bbf",
  },
  "A.B.WIJESINGHE": {
    si: "\u0d92.\u0db6\u0dd3.\u0dc0\u0dd2\u0da2\u0dda\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b8f.\u0baa\u0bbf.\u0bb5\u0bbf\u0b9c\u0bc7\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "A.C.H.H.DE COSTA": {
    si: "A.C.H.H.DE COSTA",
    ta: "A.C.H.H.DE \u0b95\u0bcb\u0bb8\u0bcd\u0b9f\u0bbe",
  },
  "A.C.MALLIYAWADU": {
    si: "\u0d92.\u0dc3\u0dd3.\u0db8\u0dbd\u0dca\u0dbd\u0dd2\u0dba\u0dc0\u0dcf\u0da9\u0dd4",
    ta: "\u0b8f.\u0b9a\u0bbf.\u0bae\u0bb2\u0bcd\u0bb2\u0bbf\u0baf\u0bb5\u0bbe\u0b9f\u0bc1",
  },
  "A.H.S.JAYAWEERA": {
    si: "\u0d92.\u0d91\u0da0\u0dca.\u0d91\u0dc3\u0dca.\u0da2\u0dba\u0dc0\u0dd3\u0dbb",
    ta: "\u0b8f.\u0b8e\u0b9a\u0bcd.\u0b8e\u0bb8\u0bcd.\u0b9c\u0bc6\u0baf\u0bb5\u0bc0\u0bb0",
  },
  "A.H.WIMALATUNGA & SON (PVT) LTD": {
    si: "A.H.Wimmalatunga & SON (PVT) LTD",
    ta: "\u0b8f.\u0b8e\u0b9a\u0bcd.\u0bb5\u0bbf\u0bae\u0bb2\u0ba4\u0bc1\u0b99\u0bcd\u0b95 & \u0bae\u0b95\u0ba9\u0bcd (\u0baa\u0bbf.\u0bb5\u0bbf.\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "A.I.C.FERNANDO": {
    si: "\u0d92.\u0d85\u0dba\u0dd2.\u0dc3\u0dd3.\u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0b8f.\u0b90.\u0b9a\u0bbf.\u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "A.L.M.MUSTAPHA": {
    si: "\u0d92.\u0d91\u0dbd\u0dca.\u0d91\u0db8\u0dca.\u0db8\u0dd4\u0dc3\u0dca\u0dad\u0dcf\u0db4\u0dcf",
    ta: "\u0b8f.\u0b8e\u0bb2\u0bcd.\u0b8e\u0bae\u0bcd.\u0bae\u0bc1\u0bb8\u0bcd\u0ba4\u0baa\u0bbe",
  },
  "A.M. ENTERPRISES": {
    si: "\u0d92.\u0d91\u0db8\u0dca. \u0dc0\u0dca\u0dba\u0dc0\u0dc3\u0dcf\u0dba\u0db1\u0dca",
    ta: "\u0ba8\u0bbe\u0ba9\u0bcd. \u0ba8\u0bbf\u0bb1\u0bc1\u0bb5\u0ba9\u0b99\u0bcd\u0b95\u0bb3\u0bcd",
  },
  "A.M.I.HASSAN": {
    si: "\u0d92.\u0d91\u0db8\u0dca.\u0d85\u0dba\u0dd2.\u0dc4\u0dc3\u0db1\u0dca",
    ta: "\u0b8f.\u0b8e\u0bae\u0bcd.\u0b90.\u0bb9\u0bbe\u0b9a\u0ba9\u0bcd",
  },
  "A.M.THANGANAYAGAM": {
    si: "\u0d92.\u0d91\u0db8\u0dca.\u0dad\u0d82\u0d9c\u0db1\u0dcf\u0dba\u0d9c\u0db8\u0dca",
    ta: "\u0b8f.\u0b8e\u0bae\u0bcd.\u0ba4\u0b99\u0bcd\u0b95\u0ba8\u0bbe\u0baf\u0b95\u0bae\u0bcd",
  },
  "A.P.GUNAWARDENA  & COMPANY(PVT)LTD": {
    si: "A.P.Gunawardena & company(PVT)LTD",
    ta: "\u0b8f.\u0baa\u0bbf.\u0b95\u0bc1\u0ba3\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0bbe & \u0b95\u0bae\u0bcd\u0baa\u0bc6\u0ba9\u0bbf(\u0baa\u0bbf.\u0bb5\u0bbf.\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "A.RANATUNGA & SON": {
    si: "A.\u0dbb\u0dab\u0dad\u0dd4\u0d82\u0d9c \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0dcf",
    ta: "\u0b85.\u0bb0\u0ba3\u0ba4\u0bc1\u0b99\u0bcd\u0b95 & \u0bae\u0b95\u0ba9\u0bcd",
  },
  "A.W.BENETTE": {
    si: "A.W.BENETTE",
    ta: "A.W.BENETTE",
  },
  "A.rasamany Fuel Station, Sinnapananakadu - Akkaraipattu": {
    si: "A.rasamany \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0dc3\u0dd2\u0db1\u0dca\u0db1\u0db4\u0dcf\u0db1\u0d9a\u0dcf\u0da9\u0dd4 - \u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0db4\u0dad\u0dca\u0dad\u0dd4\u0dc0",
    ta: "\u0b8f.\u0bb0\u0bbe\u0b9a\u0bbe\u0bae\u0ba3\u0bbf \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b9a\u0bbf\u0ba9\u0bcd\u0ba9\u0baa\u0bcd\u0baa\u0ba9\u0b95\u0bcd\u0b95\u0bbe\u0b9f\u0bc1 - \u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bc8\u0baa\u0bcd\u0baa\u0bb1\u0bcd\u0bb1\u0bc1",
  },
  "A1, Gampaha": {
    si: "A1, \u0d9c\u0db8\u0dca\u0db4\u0dc4",
    ta: "A1, \u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe",
  },
  "A1, Kadawatha": {
    si: "A1, \u0d9a\u0da9\u0dc0\u0dad",
    ta: "A1, \u0b95\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8",
  },
  "A1, Kajugama, Sri Lanka": {
    si: "A1, \u0d9a\u0da2\u0dd4\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "A1, \u0b95\u0b9c\u0bc1\u0b95\u0bbe\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "A1, Nittambuwa": {
    si: "A1, \u0db1\u0dd2\u0da7\u0dca\u0da7\u0db9\u0dd4\u0dc0",
    ta: "A1, \u0ba8\u0bbf\u0b9f\u0bcd\u0b9f\u0bae\u0bcd\u0baa\u0bc1\u0bb5",
  },
  "A1, Sri Lanka": {
    si: "A1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "A1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "A14, Pesalai": {
    si: "A14, \u0db4\u0dda\u0dc3\u0dcf\u0dbd\u0dda",
    ta: "A14, \u0baa\u0bc7\u0b9a\u0bbe\u0bb2\u0bc8",
  },
  "A17, Imaduwa": {
    si: "A17, \u0d89\u0db8\u0daf\u0dd6\u0dc0",
    ta: "A17, \u0b87\u0bae\u0ba4\u0bc1\u0bb5\u0bbe",
  },
  "A17, Pitabeddara": {
    si: "A17, \u0db4\u0dd2\u0da7\u0db6\u0dd0\u0daf\u0dca\u0daf\u0dbb",
    ta: "A17, \u0baa\u0bbf\u0b9f\u0baa\u0bc6\u0ba4\u0bcd\u0ba4\u0bb0",
  },
  "A17, Rakwana": {
    si: "A17, \u0dbb\u0d9a\u0dca\u0dc0\u0dcf\u0db1",
    ta: "A17, \u0bb0\u0b95\u0bcd\u0bb5\u0bbe\u0ba9\u0bbe",
  },
  "A17, Sri Lanka": {
    si: "A17, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "A17, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "A18, Embilipitiya": {
    si: "A18, \u0d87\u0db9\u0dd2\u0dbd\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "A18, \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0bb2\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "A18, Godakawela": {
    si: "A18, \u0d9c\u0ddc\u0da9\u0d9a\u0dc0\u0dd9\u0dbd",
    ta: "A18, \u0b95\u0bca\u0b9f\u0b95\u0bb5\u0bc6\u0bb2",
  },
  "A18, Kahawatta": {
    si: "A18, \u0d9a\u0dc4\u0dc0\u0dad\u0dca\u0dad",
    ta: "A18, \u0b95\u0bb9\u0bb5\u0ba4\u0bcd\u0ba4",
  },
  "A18, Madampe": {
    si: "A18, \u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda",
    ta: "A18, \u0bae\u0bbe\u0ba4\u0bae\u0bcd\u0baa\u0bc7",
  },
  "A2, Beruwala": {
    si: "A2, \u0db6\u0dda\u0dbb\u0dd4\u0dc0\u0dbd",
    ta: "A2, \u0baa\u0bc7\u0bb0\u0bc1\u0bb5\u0bb3\u0bc8",
  },
  "A2, Dehiwala-Mount Lavinia, Sri Lanka": {
    si: "A2, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd-\u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "A2, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8-\u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "A2, Dehiwala-mount Lavinia": {
    si: "A2, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd - \u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3",
    ta: "A2, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8-\u0bae\u0bb5\u0bc1\u0ba3\u0bcd\u0b9f\u0bcd \u0bb2\u0bbe\u0bb5\u0bbf\u0ba9\u0bbf\u0baf\u0bbe",
  },
  "A2, Kalutara": {
    si: "A2, \u0d9a\u0dc5\u0dd4\u0dad\u0dbb",
    ta: "A2, \u0b95\u0bb3\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  "A2, Maggona": {
    si: "A2, \u0db8\u0d9c\u0dca\u0d9c\u0ddc\u0db1",
    ta: "A2, \u0bae\u0b95\u0bcb\u0ba9\u0bbe",
  },
  "A2, Matara": {
    si: "A2, \u0db8\u0dcf\u0dad\u0dbb",
    ta: "A2, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8",
  },
  "A21, Ruwanwella": {
    si: "\u0d92 21, \u0dbb\u0dd4\u0dc0\u0db1\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "A21, \u0bb0\u0bc1\u0bb5\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2",
  },
  "A26, Hunnasgiriya, Sri Lanka": {
    si: "A26, \u0dc4\u0dd4\u0db1\u0dca\u0db1\u0dc3\u0dca\u0d9c\u0dd2\u0dbb\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "A26, \u0bb9\u0bc1\u0ba9\u0bcd\u0ba9\u0bb8\u0bcd\u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "A26, Mahiyanganaya": {
    si: "\u0d92 26, \u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1\u0dba",
    ta: "A26, \u0bae\u0bb9\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0ba9\u0bc8",
  },
  "A26, Nattarampota": {
    si: "A26, \u0db1\u0dad\u0dca\u0dad\u0dbb\u0db8\u0dca\u0db4\u0ddc\u0da7",
    ta: "A26, \u0ba8\u0bbe\u0b9f\u0bcd\u0b9f\u0bb0\u0bae\u0bcd\u0baa\u0bca\u0b9f",
  },
  "A27, Ampara": {
    si: "\u0d92 27, \u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb",
    ta: "A27, \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8",
  },
  "A28, Daladagama": {
    si: "A28, \u0daf\u0dc5\u0daf\u0dcf\u0d9c\u0db8",
    ta: "A28, \u0ba4\u0bb2\u0ba4\u0bbe\u0b95\u0bae",
  },
  "A28, Talawa": {
    si: "A28, \u0dad\u0dbd\u0dcf\u0dc0",
    ta: "A28, \u0ba4\u0bb2\u0bc8\u0bb5\u0bbe",
  },
  "A3, Dandugama": {
    si: "A3, \u0daf\u0dac\u0dd4\u0d9c\u0db8",
    ta: "A3, \u0ba4\u0ba3\u0bcd\u0b9f\u0bc1\u0b95\u0bae",
  },
  "A3, Sri Lanka": {
    si: "A3, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "A3, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "A3, Wattala - Mabola Rd, Wattala": {
    si: "A3, \u0dc0\u0dad\u0dca\u0dad\u0dbd - \u0db8\u0dcf\u0db6\u0ddd\u0dbd \u0db4\u0dcf\u0dbb, \u0dc0\u0dad\u0dca\u0dad\u0dbd",
    ta: "A3, \u0bb5\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8 - \u0bae\u0bbe\u0baa\u0bcb\u0bb2\u0bbe \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8",
  },
  "A4 Paradise Place, Kuruwita, Sri Lanka": {
    si: "A4 \u0db4\u0dd0\u0dbb\u0da9\u0dba\u0dd2\u0dc3\u0dca \u0db4\u0dd9\u0daf\u0dd9\u0dc3, \u0d9a\u0dd4\u0dbb\u0dd4\u0dc0\u0dd2\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "A4 \u0baa\u0bbe\u0bb0\u0b9f\u0bc8\u0bb8\u0bcd \u0baa\u0bbf\u0bb3\u0bc7\u0bb8\u0bcd, \u0b95\u0bc1\u0bb0\u0bc1\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "A5, Pussellawa": {
    si: "A5, \u0db4\u0dd4\u0dc3\u0dca\u0dc3\u0dd0\u0dbd\u0dca\u0dbd\u0dcf\u0dc0",
    ta: "A5, \u0baa\u0bc1\u0bb8\u0bcd\u0bb8\u0bb2\u0bcd\u0bb2\u0bbe\u0bb5",
  },
  "A5-Peradeniya": {
    si: "A5-\u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba",
    ta: "A5 - \u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8",
  },
  "A7, Ginigathhena": {
    si: "A7, \u0d9c\u0dd2\u0db1\u0dd2\u0d9c\u0dad\u0dca\u0dc4\u0dda\u0db1",
    ta: "A7, \u0b95\u0bbf\u0ba9\u0bbf\u0b95\u0ba4\u0bcd\u0ba4\u0bc7\u0ba9",
  },
  "A7, Kotagala": {
    si: "A7, \u0d9a\u0ddc\u0da7\u0d9c\u0dbd",
    ta: "A7, \u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0b95\u0bb2\u0bc8",
  },
  "A7, Sri Lanka": {
    si: "A7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "A7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "A8, Horana": {
    si: "A8, \u0dc4\u0ddc\u0dbb\u0dab",
    ta: "A8, \u0bb9\u0bca\u0bb0\u0ba3\u0bc8",
  },
  "A9 A9, Sri Lanka": {
    si: "A9 A9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "A9 A9, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "A9, Chavakachcheri": {
    si: "A9, \u0da0\u0dcf\u0dc0\u0d9a\u0da0\u0dca\u0da0\u0dda\u0dbb\u0dd2",
    ta: "A9, \u0b9a\u0bbe\u0bb5\u0b95\u0b9a\u0bcd\u0b9a\u0bc7\u0bb0\u0bbf",
  },
  "A9, Jaffna": {
    si: "A9, \u0dba\u0dcf\u0db4\u0db1\u0dba",
    ta: "\u0b8f9, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd",
  },
  "A9, Mankulam": {
    si: "A9, \u0db8\u0dcf\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca",
    ta: "A9, \u0bae\u0bbe\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd",
  },
  "A9, Medawachchiya": {
    si: "A9, \u0db8\u0dd0\u0daf\u0dc0\u0da0\u0dca\u0da0\u0dd2\u0dba",
    ta: "\u0b8f9, \u0bae\u0ba4\u0bb5\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf",
  },
  ABATALE: {
    si: "ABATALE",
    ta: "ABATALE",
  },
  "ABC FILLING STATION": {
    si: "ABC \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b8f\u0baa\u0bbf\u0b9a\u0bbf \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "ABDUL AZEEZ & SONS": {
    si: "\u0d85\u0db6\u0dca\u0daf\u0dd4\u0dbd\u0dca \u0d85\u0dc3\u0dd3\u0dc3\u0dca \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b85\u0baa\u0bcd\u0ba4\u0bc1\u0bb2\u0bcd \u0b85\u0b9c\u0bc0\u0bb8\u0bcd & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "ABDUL RAHUMAN SALEEM": {
    si: "\u0d85\u0db6\u0dca\u0daf\u0dd4\u0dbd\u0dca \u0dbb\u0dc4\u0dd4\u0db8\u0dcf\u0db1\u0dca \u0dc3\u0dbd\u0dd3\u0db8\u0dca",
    ta: "\u0b85\u0baa\u0bcd\u0ba4\u0bc1\u0bb2\u0bcd \u0bb0\u0b95\u0bc1\u0bae\u0bbe\u0ba9\u0bcd \u0b9a\u0bb2\u0bc0\u0bae\u0bcd",
  },
  "ABUTHAHIR  ALHAJ  M F": {
    si: "\u0d85\u0db6\u0dd4\u0dad\u0dcf\u0dc4\u0dd2\u0dbb\u0dca \u0d85\u0dbd\u0dca\u0dc4\u0dcf\u0da2\u0dca \u0d91\u0db8\u0dca \u0d91\u0dc6\u0dca",
    ta: "\u0b85\u0baa\u0bc1\u0ba4\u0bbe\u0bb9\u0bbf\u0bb0\u0bcd \u0b85\u0bb2\u0bcd\u0bb9\u0bbe\u0b9c\u0bcd \u0b8e\u0bae\u0bcd.\u0b8e\u0b83\u0baa\u0bcd",
  },
  "ADA FRANCIS APPUHAMY LANKA PIRAVUMH": {
    si: "\u0d85\u0da9\u0dcf \u0dc6\u0dca\u200d\u0dbb\u0dd0\u0db1\u0dca\u0dc3\u0dd2\u0dc3\u0dca \u0d85\u0db4\u0dca\u0db4\u0dd4\u0dc4\u0dcf\u0db8\u0dd2 \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4",
    ta: "\u0b85\u0b9f\u0bbe \u0baa\u0bbf\u0bb0\u0bbe\u0ba9\u0bcd\u0b9a\u0bbf\u0bb8\u0bcd \u0b85\u0baa\u0bcd\u0baa\u0bc1\u0bb9\u0bbe\u0bae\u0bbf \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0baa\u0bbf\u0bb1\u0bb5\u0bc1\u0bae\u0bcd",
  },
  "AGALAWATTA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d85\u0d9c\u0dbd\u0dc0\u0dad\u0dca\u0dad MPCS",
    ta: "\u0b85\u0b95\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4 MPCS LTD",
  },
  "AGNSK ALKEGAMA,": {
    si: "AGNSK Alkegama,",
    ta: "AGNSK \u0b85\u0bb2\u0bcd\u0b95\u0bc7\u0b95\u0bbe\u0bae\u0bbe,",
  },
  "AGRA ENTERPRISES (PVT) LTD": {
    si: "AGRA ENTERPRISES (PVT) LTD",
    ta: "\u0b86\u0b95\u0bcd\u0bb0\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "AH Dispensary, Mahiyangana-Badulla Road, Ambekandura, Kuruvithenna, Mahiyangana Rd, Sri Lanka":
    {
      si: "AH \u0db6\u0dd9\u0dc4\u0dd9\u0dad\u0dca \u0dc1\u0dcf\u0dbd\u0dcf\u0dc0, \u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1-\u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d85\u0db9\u0dda\u0d9a\u0db3\u0dd4\u0dbb, \u0d9a\u0dd4\u0dbb\u0dd4\u0dc0\u0dd2\u0dad\u0dd0\u0db1\u0dca\u0db1, \u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1 \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "AH \u0bae\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0b95\u0bae\u0bcd, \u0bae\u0bb9\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0ba9\u0bc8-\u0baa\u0ba4\u0bc1\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0bae\u0bcd\u0baa\u0bc7\u0b95\u0ba8\u0bcd\u0ba4\u0bc1\u0bb0, \u0b95\u0bc1\u0bb0\u0bc1\u0bb5\u0bbf\u0ba4\u0bc6\u0ba9\u0bcd\u0ba9, \u0bae\u0bb9\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0ba9\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "AHAMED  SHAUL HAMEED": {
    si: "\u0d85\u0dc4\u0db8\u0da9\u0dca \u0dc2\u0dcf\u0dc0\u0dd4\u0dbd\u0dca \u0dc4\u0db8\u0dd3\u0da9\u0dca",
    ta: "\u0b85\u0bb9\u0bae\u0b9f\u0bcd \u0bb7\u0bbe\u0bb2\u0bcd \u0bb9\u0bae\u0bc0\u0ba4\u0bc1",
  },
  "AIRPORT & AVIATION SERVICES(SL) LTD": {
    si: "\u0d9c\u0dd4\u0dc0\u0db1\u0dca\u0dad\u0ddc\u0da7\u0dd4\u0db4\u0dc5 \u0dc3\u0dc4 \u0d9c\u0dd4\u0dc0\u0db1\u0dca \u0dc3\u0dda\u0dc0\u0dcf (\u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b8f\u0bb0\u0bcd\u0baa\u0bcb\u0bb0\u0bcd\u0b9f\u0bcd & \u0b8f\u0bb5\u0bbf\u0baf\u0bc7\u0bb7\u0ba9\u0bcd \u0b9a\u0bb0\u0bcd\u0bb5\u0bc0\u0b9a\u0bb8\u0bcd(SL) LTD",
  },
  "AJITH PUTHA FILLING STATION (PVT) L": {
    si: "\u0d85\u0da2\u0dd2\u0dad\u0dca \u0db4\u0dd4\u0dad\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0d91\u0dbd\u0dca",
    ta: "\u0b85\u0b9c\u0bbf\u0ba4\u0bcd \u0baa\u0bc2\u0ba4\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0b8e\u0bb2\u0bcd",
  },
  "AKKARAIPATTU CENTRAL MPCS LTD": {
    si: "\u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0db4\u0dad\u0dca\u0dad\u0dd4 \u0db8\u0db0\u0dca\u200d\u0dba\u0db8 MPCS LTD",
    ta: "\u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bc8\u0baa\u0bcd\u0baa\u0bb1\u0bcd\u0bb1\u0bc1 \u0bae\u0ba4\u0bcd\u0ba4\u0bbf\u0baf MPCS LTD",
  },
  "AKKARAIPATTU SOUTH MPCS LTD": {
    si: "\u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0db4\u0dad\u0dca\u0dad\u0dd4 \u0daf\u0d9a\u0dd4\u0dab\u0dd4 MPCS LTD",
    ta: "\u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bc8\u0baa\u0bcd\u0baa\u0bb1\u0bcd\u0bb1\u0bc1 \u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1 MPCS LTD",
  },
  "AKKARAYAN MPCS LTD": {
    si: "\u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0dba\u0db1\u0dca MPCS LTD",
    ta: "\u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bbe\u0baf\u0ba9\u0bcd MPCS LTD",
  },
  AKURANA: {
    si: "\u0d85\u0d9a\u0dd4\u0dbb\u0dab",
    ta: "\u0b85\u0b95\u0bc1\u0bb0\u0bbe\u0ba9\u0bbe",
  },
  "ALAVEDDY MALLAKAM MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d85\u0dbd\u0dc0\u0dd9\u0da9\u0dca\u0da9\u0dd2 \u0db8\u0dbd\u0dca\u0dbd\u0d9a\u0db8\u0dca \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b85\u0bb3\u0bb5\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf \u0bae\u0bb2\u0bcd\u0bb2\u0b95\u0bae\u0bcd MPCS LTD",
  },
  "ALAWWA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d85\u0dbd\u0dc0\u0dca\u0dc0 \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b85\u0bb2\u0bb5\u0bcd\u0bb5\u0bbe MPCS LTD",
  },
  "ALAYADIVEMBU MPCS LTD": {
    si: "\u0d87\u0dbd\u0dba\u0da9\u0dd2\u0dc0\u0dd9\u0db9\u0dd4 MPCS LTD",
    ta: "\u0b86\u0bb2\u0bc8\u0ba4\u0bc0\u0bb5\u0bc1 \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0b9a\u0bbf\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "ALBERT GUNARATNE AGENCIES": {
    si: "\u0d87\u0dbd\u0dca\u0db6\u0da7\u0dca \u0d9c\u0dd4\u0dab\u0dbb\u0dad\u0dca\u0db1 \u0d92\u0da2\u0db1\u0dca\u0dc3\u0dd2",
    ta: "\u0b86\u0bb2\u0bcd\u0baa\u0bb0\u0bcd\u0b9f\u0bcd \u0b95\u0bc1\u0ba3\u0bb0\u0ba4\u0bcd\u0ba9\u0bc7 \u0b8f\u0b9c\u0bc6\u0ba9\u0bcd\u0b9a\u0bbf\u0b95\u0bb3\u0bcd",
  },
  "ALHAJ S A C.ABDUL NAZAR": {
    si: "\u0d85\u0dbd\u0dca\u0dc4\u0dcf\u0da2\u0dca \u0d91\u0dc3\u0dca \u0d92 \u0dc3\u0dd3 \u0d85\u0db6\u0dca\u0daf\u0dd4\u0dbd\u0dca \u0db1\u0dc3\u0dcf\u0dbb\u0dca",
    ta: "\u0b85\u0bb2\u0bcd\u0bb9\u0bbe\u0b9c\u0bcd \u0b8e\u0bb8\u0bcd \u0b8f \u0b9a\u0bbf.\u0b85\u0baa\u0bcd\u0ba4\u0bc1\u0bb2\u0bcd \u0ba8\u0bbe\u0b9a\u0bb0\u0bcd",
  },
  "ALHAJ STS AHAMED & SONS PVT LTD.": {
    si: "\u0d85\u0dbd\u0dca\u0dc4\u0dcf\u0da2\u0dca \u0d91\u0dc3\u0dca\u0da7\u0dd3\u0d91\u0dc3\u0dca \u0d85\u0dc4\u0db8\u0da9\u0dca \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd \u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a \u0dc3\u0db8\u0dcf\u0d9c\u0db8.",
    ta: "\u0b85\u0bb2\u0bcd\u0bb9\u0bbe\u0b9c\u0bcd \u0b8e\u0bb8\u0bcd\u0b9f\u0bbf\u0b8e\u0bb8\u0bcd \u0b85\u0b95\u0bae\u0ba4\u0bc1 & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd \u0baa\u0bbf\u0bb0\u0bc8\u0bb5\u0bc7\u0b9f\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd.",
  },
  "ALIGHT FILLING STATION": {
    si: "LAIGHT \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b87\u0bb1\u0b99\u0bcd\u0b95\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "ALLIANCE ENTERPRISES": {
    si: "\u0d91\u0dbd\u0dba\u0db1\u0dca\u0dc3\u0dca \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b85\u0bb2\u0bc8\u0baf\u0ba9\u0bcd\u0bb8\u0bcd \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  ALUTHGAMA: {
    si: "\u0d85\u0dbd\u0dd4\u0dad\u0dca\u0d9c\u0db8",
    ta: "\u0b85\u0bb3\u0bc1\u0ba4\u0bcd\u0b95\u0bbe\u0bae\u0bbe",
  },
  "ALVAPILLAI SANTHARUBAN": {
    si: "\u0d85\u0dbd\u0dca\u0dc0\u0dcf\u0db4\u0dd2\u0dbd\u0dca\u0dbd\u0dda \u0dc1\u0dcf\u0db1\u0dca\u0dad\u0dbb\u0dd4\u0db6\u0db1\u0dca",
    ta: "\u0b85\u0bb2\u0bcd\u0bb5\u0bbe\u0baa\u0bcd\u0baa\u0bbf\u0bb3\u0bcd\u0bb3\u0bc8 \u0b9a\u0bbe\u0ba8\u0bcd\u0ba4\u0bb0\u0bc2\u0baa\u0ba9\u0bcd",
  },
  AMBALANGODA: {
    si: "\u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0d9c\u0ddc\u0da9",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f",
  },
  "AMBALANGODA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0d9c\u0ddc\u0da9 MPCS",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f MPCS LTD",
  },
  AMPARA: {
    si: "\u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb0\u0bbe",
  },
  "AMPARA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb0\u0bbe MPCS LTD",
  },
  ANAMADUWA: {
    si: "\u0d86\u0dab\u0db8\u0da9\u0dd4\u0dc0",
    ta: "\u0b86\u0ba9\u0bae\u0b9f\u0bc1\u0bb5",
  },
  "ANAMADUWA MPCS": {
    si: "\u0d86\u0dab\u0db8\u0da9\u0dd4\u0dc0 \u0d91\u0db8\u0dca.\u0db4\u0dd3.\u0dc3\u0dd3.\u0d91\u0dc3\u0dca",
    ta: "\u0b86\u0ba9\u0bae\u0b9f\u0bc1\u0bb5 \u0b8e\u0bae\u0bcd.\u0baa\u0bbf.\u0b9a\u0bbf.\u0b8e\u0bb8\u0bcd",
  },
  ANGUNAKOLAPELESSA: {
    si: "\u0d85\u0d9f\u0dd4\u0dab\u0d9a\u0ddc\u0dc5\u0db4\u0dd0\u0dbd\u0dd0\u0dc3\u0dca\u0dc3",
    ta: "\u0b85\u0b99\u0bcd\u0b95\u0bc1\u0ba9\u0b95\u0bca\u0bb2\u0baa\u0bc6\u0bb2\u0bb8\u0bcd\u0bb8",
  },
  "ANOJA FERNANDO": {
    si: "\u0d85\u0db1\u0ddd\u0da2\u0dcf \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0b85\u0ba9\u0bcb\u0b9c\u0bbe \u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "ANUHAYA STORES": {
    si: "\u0d85\u0db1\u0dd4\u0dc4\u0dba\u0dcf \u0dc3\u0dca\u0da7\u0ddd\u0dbb\u0dca\u0dc3\u0dca",
    ta: "\u0b85\u0ba9\u0bc1\u0bb9\u0baf\u0bbe \u0bb8\u0bcd\u0b9f\u0bcb\u0bb0\u0bcd\u0bb8\u0bcd",
  },
  "ANURADHAPURA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd MPCS LTD",
  },
  "ARALIYA FILLING STATION": {
    si: "\u0d85\u0dbb\u0dbd\u0dd2\u0dba \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b85\u0bb0\u0bb2\u0bbf\u0baf\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "AROSHINI INDUNIL PERERA (MRS.LAKSHM": {
    si: "\u0d85\u0dbb\u0ddd\u0dc2\u0dd2\u0db1\u0dd3 \u0d89\u0db3\u0dd4\u0db1\u0dd2\u0dbd\u0dca \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf (\u0dbd\u0d9a\u0dca\u0dc2\u0db8\u0dca \u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba",
    ta: "\u0b85\u0bb0\u0bcb\u0bb7\u0bbf\u0ba9\u0bbf \u0b87\u0ba8\u0bcd\u0ba4\u0bc1\u0ba9\u0bbf\u0bb2\u0bcd \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe (\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf.\u0bb2\u0b95\u0bcd\u0bb7\u0bcd\u0bae\u0bcd",
  },
  "ARUMUGAM RASAMANI": {
    si: "\u0d86\u0dbb\u0dd4\u0db8\u0dd4\u0d9c\u0db8\u0dca \u0dbb\u0dcf\u0dc3\u0db8\u0db1\u0dd2",
    ta: "\u0b86\u0bb1\u0bc1\u0bae\u0bc1\u0b95\u0bae\u0bcd \u0bb0\u0bbe\u0b9a\u0bbe\u0bae\u0ba3\u0bbf",
  },
  "ASEERVATHAM AROCKIYANATHAR": {
    si: "\u0d85\u0dc3\u0dd3\u0dbb\u0dca\u0dc0\u0dad\u0db8\u0dca \u0d85\u0dbb\u0d9a\u0dca\u0d9a\u0dd2\u0dba\u0db1\u0dcf\u0dad\u0dbb\u0dca",
    ta: "\u0b86\u0b9a\u0bc0\u0bb0\u0bcd\u0bb5\u0bbe\u0ba4\u0bae\u0bcd \u0b86\u0bb0\u0bcb\u0b95\u0bcd\u0b95\u0bbf\u0baf\u0ba8\u0bbe\u0ba4\u0bb0\u0bcd",
  },
  "ASIGIRI MPCS LTD": {
    si: "ASIGIRI MPCS LTD",
    ta: "\u0b85\u0b9a\u0bbf\u0b95\u0bbf\u0bb0\u0bbf MPCS LTD",
  },
  "ASIRI LANKA": {
    si: "\u0d86\u0dc3\u0dd2\u0dbb\u0dd2 \u0dbd\u0d82\u0d9a\u0dcf",
    ta: "\u0b86\u0b9a\u0bbf\u0bb0\u0bbf \u0bb2\u0b99\u0bcd\u0b95\u0bbe",
  },
  "ATTANAGALLA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d85\u0dad\u0dca\u0dad\u0db1\u0d9c\u0dbd\u0dca\u0dbd MPCS",
    ta: "\u0b85\u0ba4\u0bcd\u0ba4\u0ba9\u0b95\u0bb2\u0bcd\u0bb2 MPCS LTD",
  },
  "ATTANAGALLA MPCS LTD.": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d85\u0dad\u0dca\u0dad\u0db1\u0d9c\u0dbd\u0dca\u0dbd MPCS.",
    ta: "\u0b85\u0ba4\u0bcd\u0ba4\u0ba9\u0b95\u0bb2\u0bcd\u0bb2 MPCS LTD.",
  },
  "AUTO CARE CENTRE (PVT) LTD": {
    si: "\u0d94\u0da7\u0ddd \u0d9a\u0dd9\u0dba\u0dcf\u0dbb\u0dca \u0dc3\u0dd9\u0db1\u0dca\u0da7\u0dbb\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0b95\u0bc7\u0bb0\u0bcd \u0b9a\u0bc6\u0ba9\u0bcd\u0b9f\u0bb0\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "AUTO CARE FILLING STATION (PVT) LTD": {
    si: "\u0d94\u0da7\u0ddd \u0d9a\u0dd9\u0dba\u0dcf\u0dbb\u0dca \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0b95\u0bc7\u0bb0\u0bcd \u0b83\u0baa\u0bbf\u0bb2\u0bcd\u0bb2\u0bbf\u0b99\u0bcd \u0bb8\u0bcd\u0b9f\u0bc7\u0bb7\u0ba9\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "AUTO SERVICES DAMBULLA (PVT) LTD": {
    si: "\u0d94\u0da7\u0ddd \u0dc3\u0dbb\u0dca\u0dc0\u0dd2\u0dc3\u0dc3\u0dca \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0b9a\u0bb0\u0bcd\u0bb5\u0bc0\u0b9a\u0bb8\u0bcd \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "AUTO SUPER SERVICE CENTRE": {
    si: "\u0dc3\u0dca\u0dc0\u0dba\u0d82\u0d9a\u0dca\u200d\u0dbb\u0dd3\u0dba \u0dc3\u0dd4\u0db4\u0dd2\u0dbb\u0dd2 \u0dc3\u0dda\u0dc0\u0dcf \u0db8\u0db0\u0dca\u200d\u0dba\u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba",
    ta: "\u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0b9a\u0bc2\u0baa\u0bcd\u0baa\u0bb0\u0bcd \u0b9a\u0bb0\u0bcd\u0bb5\u0bc0\u0bb8\u0bcd \u0b9a\u0bc6\u0ba9\u0bcd\u0b9f\u0bb0\u0bcd",
  },
  "AYOMA KALHARA FILLING STATION (PVT)": {
    si: "\u0d85\u0dba\u0ddd\u0db8\u0dcf \u0d9a\u0dbd\u0dca\u0dc4\u0dcf\u0dbb \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a)",
    ta: "\u0b85\u0baf\u0bcb\u0bae\u0bbe \u0b95\u0bb2\u0bcd\u0bb9\u0bbe\u0bb0\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf)",
  },
  "Ab10, Peliyagoda": {
    si: "Ab10, \u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9",
    ta: "\u0b8f\u0baa\u0bbf10, \u0baa\u0bc7\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f",
  },
  "Ab16, Jaffna": {
    si: "Ab16, \u0dba\u0dcf\u0db4\u0db1\u0dba",
    ta: "\u0b8f\u0baa\u0bbf16, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd",
  },
  "Ab17, Kalaiyadi": {
    si: "Ab17, \u0d9a\u0dbd\u0dba\u0dd2\u0dba\u0dcf\u0da9\u0dd2",
    ta: "\u0b8f\u0baa\u0bbf17, \u0b95\u0bbe\u0bb3\u0bc8\u0baf\u0b9f\u0bbf",
  },
  "Ab20, Point Pedro": {
    si: "Ab20, \u0db4\u0dda\u0daf\u0dd4\u0dbb\u0dd4\u0dad\u0dd4\u0da9\u0dd4\u0dc0",
    ta: "\u0b8f\u0baa\u0bbf20, \u0baa\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  "Abhinawaramaya Temple - Wanathavilluwa, Wanathavilluwa": {
    si: "\u0d85\u0db7\u0dd2\u0db1\u0dc0\u0dcf\u0dbb\u0dcf\u0db8 \u0dc0\u0dd2\u0dc4\u0dcf\u0dbb\u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba - \u0dc0\u0db1\u0dcf\u0dad\u0dc0\u0dd2\u0dbd\u0dca\u0dbd\u0dd4\u0dc0, \u0dc0\u0db1\u0dcf\u0dad\u0dc0\u0dd2\u0dbd\u0dca\u0dbd\u0dd4\u0dc0",
    ta: "\u0b85\u0baa\u0bbf\u0ba8\u0bb5\u0bb0\u0bae\u0bbe\u0baf \u0b86\u0bb2\u0baf\u0bae\u0bcd - \u0bb5\u0ba9\u0bbe\u0ba4\u0bb5\u0bbf\u0bb2\u0bcd\u0bb2\u0bc1\u0bb5, \u0bb5\u0ba9\u0bbe\u0ba4\u0bb5\u0bbf\u0bb2\u0bcd\u0bb2\u0bc1\u0bb5\u0bbe",
  },
  "Access Road Nugaduwa,Galle": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0dc0\u0dda\u0dc1 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba \u0db1\u0dd4\u0d9c\u0daf\u0dd6\u0dc0, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd",
    ta: "\u0b85\u0ba3\u0bc1\u0b95\u0bb2\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf \u0ba8\u0bc1\u0b95\u0b9f\u0bc1\u0bb5, \u0b95\u0bbe\u0bb2\u0bbf",
  },
  Addalachchanai: {
    si: "\u0d85\u0da9\u0dca\u0da9\u0dcf\u0dbd\u0da0\u0dca\u0da0\u0db1\u0dba\u0dd2",
    ta: "\u0b85\u0b9f\u0bcd\u0b9f\u0bbe\u0bb2\u0b9a\u0bcd\u0b9a\u0ba9\u0bc8",
  },
  Addalaichenai: {
    si: "\u0d85\u0da9\u0dca\u0da9\u0dcf\u0dbd\u0dd2\u0da0\u0dda\u0db1\u0dba\u0dd2",
    ta: "\u0b85\u0b9f\u0bcd\u0b9f\u0bbe\u0bb3\u0bc8\u0b9a\u0bcd\u0b9a\u0bc7\u0ba9\u0bc8",
  },
  "Addapallam, Nintavour": {
    si: "\u0d85\u0da9\u0db4\u0dbd\u0dca\u0dbd\u0db8\u0dca, \u0db1\u0dd2\u0db1\u0dca\u0daf\u0dc0\u0dd6\u0dbb\u0dca",
    ta: "\u0b85\u0b9f\u0baa\u0bcd\u0baa\u0bb3\u0bcd\u0bb3\u0bae\u0bcd, \u0ba8\u0bbf\u0ba8\u0bcd\u0ba4\u0bb5\u0bc2\u0bb0\u0bcd",
  },
  Agalawatta: {
    si: "\u0d85\u0d9c\u0dbd\u0dc0\u0dad\u0dca\u0dad",
    ta: "\u0b85\u0b95\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4",
  },
  "Agalawatta, Agalawatta, Sri Lanka": {
    si: "\u0d85\u0d9c\u0dbd\u0dc0\u0dad\u0dca\u0dad, \u0d85\u0d9c\u0dbd\u0dc0\u0dad\u0dca\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b85\u0b95\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b85\u0b95\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Ahangama: {
    si: "\u0d85\u0dc4\u0d82\u0d9c\u0db8",
    ta: "\u0b85\u0bb9\u0b99\u0bcd\u0b95\u0bbe\u0bae\u0bbe",
  },
  "Airport Road, Anuradhapura": {
    si: "\u0d9c\u0dd4\u0dc0\u0db1\u0dca\u0dad\u0ddc\u0da7\u0dd4\u0db4\u0dbd \u0db4\u0dcf\u0dbb, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb",
    ta: "\u0bb5\u0bbf\u0bae\u0bbe\u0ba9 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd",
  },
  "Akarawattha Nagollagoda Road,Nagollagoda": {
    si: "\u0d85\u0d9a\u0dbb\u0dc0\u0dad\u0dca\u0dad \u0db1\u0dcf\u0d9c\u0ddc\u0dbd\u0dca\u0dbd\u0dcf\u0d9c\u0ddc\u0da9 \u0db4\u0dcf\u0dbb, \u0db1\u0dcf\u0d9c\u0ddc\u0dbd\u0dca\u0dbd\u0dcf\u0d9c\u0ddc\u0da9",
    ta: "\u0b85\u0b95\u0bb0\u0bb5\u0ba4\u0bcd\u0ba4 \u0ba8\u0bbe\u0b95\u0bca\u0bb2\u0bcd\u0bb2\u0b95\u0bca\u0b9f \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bbe\u0b95\u0bca\u0bb2\u0bcd\u0bb2\u0b95\u0bca\u0b9f",
  },
  Akarawita: {
    si: "\u0d85\u0d9a\u0dbb\u0dc0\u0dd2\u0da7",
    ta: "\u0b85\u0b95\u0bb0\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f",
  },
  Akkaraipattu: {
    si: "\u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0db4\u0dad\u0dca\u0dad\u0dd4\u0dc0",
    ta: "\u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bc8\u0baa\u0bcd\u0baa\u0bb1\u0bcd\u0bb1\u0bc1",
  },
  "Akkaraipattu - Deeghavapi - Ambalam Aru Rd, Akkaraipattu": {
    si: "\u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0db4\u0dad\u0dca\u0dad\u0dd4 - \u0daf\u0dd3\u0d9d\u0dc0\u0dcf\u0db4\u0dd2 - \u0d85\u0db8\u0dca\u0db6\u0dbd\u0db8\u0dca \u0d86\u0dbb\u0dd4 \u0db4\u0dcf\u0dbb, \u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0db4\u0dad\u0dca\u0dad\u0dd4",
    ta: "\u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bc8\u0baa\u0bcd\u0baa\u0bb1\u0bcd\u0bb1\u0bc1 - \u0ba4\u0bc0\u0b95\u0bb5\u0bbe\u0baa\u0bbf - \u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bae\u0bcd \u0b86\u0bb1\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bc8\u0baa\u0bcd\u0baa\u0bb1\u0bcd\u0bb1\u0bc1",
  },
  Akkarayan: {
    si: "\u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0dcf\u0dba\u0db1\u0dca",
    ta: "\u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bbe\u0baf\u0ba9\u0bcd",
  },
  Akurana: {
    si: "\u0d85\u0d9a\u0dd4\u0dbb\u0dab",
    ta: "\u0b85\u0b95\u0bcd\u0b95\u0bc1\u0bb1\u0ba3\u0bc8",
  },
  Akuressa: {
    si: "Akuressa",
    ta: "Akuressa",
  },
  "Akuressa Rd, Godagama": {
    si: "\u0d85\u0d9a\u0dd4\u0dbb\u0dd0\u0dc3\u0dca\u0dc3 \u0db4\u0dcf\u0dbb, \u0d9c\u0ddc\u0da9\u0d9c\u0db8",
    ta: "\u0b85\u0b95\u0bc1\u0bb0\u0bb8\u0bcd\u0bb8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bca\u0b9f\u0b95\u0bae",
  },
  "Aladeniya, Werellagama": {
    si: "\u0d85\u0dbd\u0daf\u0dd9\u0dab\u0dd2\u0dba \u0dc0\u0dd0\u0dbb\u0dd0\u0dbd\u0dca\u0dbd\u0d9c\u0db8",
    ta: "\u0b85\u0bb2\u0ba4\u0bc6\u0ba9\u0bbf\u0baf, \u0bb5\u0bc6\u0bb0\u0bb2\u0bcd\u0bb2\u0b95\u0bae",
  },
  "Alaveddy Centre": {
    si: "\u0d85\u0dbd\u0dc0\u0dd9\u0da9\u0dca\u0da9\u0dd2 \u0db8\u0db0\u0dca\u0dba\u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba",
    ta: "\u0b85\u0bb3\u0bb5\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf \u0bae\u0bc8\u0baf\u0bae\u0bcd",
  },
  Alawatugoda: {
    si: "\u0d85\u0dbd\u0dc0\u0dad\u0dd4\u0d9c\u0ddc\u0da9",
    ta: "\u0b85\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4\u0bc1\u0b95\u0bca\u0b9f",
  },
  Alawwa: {
    si: "\u0d85\u0dbd\u0dc0\u0dca\u0dc0",
    ta: "\u0b85\u0bb2\u0bb5\u0bcd\u0bb5\u0bbe",
  },
  "Alawwa - Maharagama Rd, Boyawalana": {
    si: "\u0d85\u0dbd\u0dc0\u0dca\u0dc0 - \u0db8\u0dc4\u0dbb\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0db6\u0ddd\u0dba\u0dc0\u0dbd\u0dcf\u0db1",
    ta: "\u0b85\u0bb2\u0bb5\u0bcd\u0bb5 - \u0bae\u0bb9\u0bb0\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bcb\u0baf\u0bb5\u0bb2\u0ba9",
  },
  Alayadivembu: {
    si: "\u0d86\u0dbd\u0dba\u0da9\u0dd2\u0dc0\u0dd9\u0db8\u0dca\u0db6\u0dd4",
    ta: "\u0b86\u0bb2\u0bc8\u0baf\u0b9f\u0bbf\u0bb5\u0bc7\u0bae\u0bcd\u0baa\u0bc1",
  },
  "All Fuels": {
    si: "\u0dc3\u0dd2\u0dba\u0dbd\u0dd4\u0db8 \u0d89\u0db1\u0dca\u0db0\u0db1",
    ta: "\u0b85\u0ba9\u0bc8\u0ba4\u0bcd\u0ba4\u0bc1 \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd\u0b95\u0bb3\u0bcd",
  },
  "Allai-kantalai Rd, Serunuwara": {
    si: "\u0d85\u0dbd\u0dca\u0dbd\u0dba\u0dd2 \u0d9a\u0db1\u0dca\u0dad\u0dbd\u0dda \u0db4\u0dcf\u0dbb, \u0dc3\u0dda\u0dbb\u0dd4\u0db1\u0dd4\u0dc0\u0dbb",
    ta: "\u0b85\u0bb2\u0bcd\u0bb2\u0bc8-\u0b95\u0ba8\u0bcd\u0ba4\u0bb3\u0bbe\u0baf\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0b9a\u0bc7\u0bb0\u0bc1\u0ba8\u0bc1\u0bb5\u0bb0",
  },
  "Alpitiya Rd, Karandeniya": {
    si: "\u0d87\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0d9a\u0dbb\u0db1\u0dca\u0daf\u0dd9\u0dab\u0dd2\u0dba",
    ta: "\u0b85\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb0\u0ba8\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf",
  },
  "Alupothagama, J8J3+XXG, Sri Lanka": {
    si: "\u0d85\u0dc5\u0dd4\u0db4\u0ddc\u0dad\u0dcf\u0d9c\u0db8, J8J3+XXG, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b85\u0bb2\u0bc1\u0baa\u0bcb\u0ba4\u0b95\u0bae\u0bbe, J8J3+XXG, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Aluth Waththa-chilaw": {
    si: "\u0d85\u0dbd\u0dd4\u0dad\u0dca \u0dc0\u0dad\u0dca\u0dad-\u0dc4\u0dbd\u0dcf\u0dc0\u0dad",
    ta: "Aluth Waththa-chilaw",
  },
  Aluthgama: {
    si: "\u0d85\u0dbd\u0dd4\u0dad\u0dca\u0d9c\u0db8",
    ta: "\u0b85\u0bb3\u0bc1\u0ba4\u0bcd\u0b95\u0bae",
  },
  "Aluthgama Road, Neboda": {
    si: "\u0d85\u0dbd\u0dd4\u0dad\u0dca\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0db1\u0dd1\u0db6\u0ddc\u0da9",
    ta: "\u0b85\u0bb3\u0bc1\u0ba4\u0bcd\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc6\u0baa\u0bcb\u0b9f",
  },
  "Aluthmawatha, Colombo": {
    si: "\u0d85\u0dbd\u0dd4\u0dad\u0dca\u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9",
    ta: "\u0b85\u0bb3\u0bc1\u0ba4\u0bcd\u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "Aluthwewa Pubudu Pre School, Sri Lanka": {
    si: "\u0d85\u0dbd\u0dd4\u0dad\u0dca\u0dc0\u0dd0\u0dc0 \u0db4\u0dd4\u0db6\u0dd4\u0daf\u0dd4 \u0db4\u0dd9\u0dbb \u0db4\u0dcf\u0dc3\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b85\u0bb2\u0bc1\u0ba4\u0bcd\u0bb5\u0bc6\u0bb5 \u0baa\u0bc1\u0baa\u0bc1\u0ba4\u0bc1 \u0bae\u0bc1\u0ba9\u0bcd\u0baa\u0bb3\u0bcd\u0bb3\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Aluthwewa, Angunukolapelessa": {
    si: "\u0d85\u0dbd\u0dd4\u0dad\u0dca\u0dc0\u0dd0\u0dc0, \u0d85\u0d9f\u0dd4\u0dab\u0dd4\u0d9a\u0ddc\u0dbd\u0db4\u0dd0\u0dbd\u0dd0\u0dc3\u0dca\u0dc3",
    ta: "\u0b85\u0bb2\u0bc1\u0ba4\u0bcd\u0bb5\u0bc6\u0bb5, \u0b85\u0b99\u0bcd\u0b95\u0bc1\u0ba9\u0bc1\u0b95\u0bca\u0bb2\u0baa\u0bc6\u0bb2\u0bb8\u0bcd\u0bb8",
  },
  "Ambagaha Junction Bus Stop, Sri Lanka": {
    si: "\u0d85\u0db9\u0d9c\u0dc4 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0b95\u0bb9\u0bbe \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0baa\u0bcd\u0baa\u0bc1 \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Ambagasdowa: {
    si: "\u0d85\u0db9\u0d9c\u0dc3\u0dca\u0daf\u0ddd\u0dc0",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0b95\u0bb8\u0bcd\u0b9f\u0bcb\u0bb5\u0bbe",
  },
  Ambalangoda: {
    si: "\u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0d9c\u0ddc\u0da9",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f",
  },
  "Ambalangoda Clock Tower, A2, Ambalangoda, Sri Lanka": {
    si: "\u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0d9c\u0ddc\u0da9 \u0d94\u0dbb\u0dbd\u0ddd\u0dc3\u0dd4 \u0d9a\u0dab\u0dd4\u0dc0, A2, \u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe \u0b95\u0b9f\u0bbf\u0b95\u0bbe\u0bb0 \u0b95\u0bcb\u0baa\u0bc1\u0bb0\u0bae\u0bcd, A2, \u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Ambalangoda Fishshry Harbour, Market Rd, Ambalangoda, Sri Lanka": {
    si: "\u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0d9c\u0ddc\u0da9 \u0db0\u0dd3\u0dc0\u0dbb \u0dc0\u0dbb\u0dcf\u0dba, \u0db8\u0dcf\u0dbb\u0dca\u0d9a\u0da7\u0dca \u0db4\u0dcf\u0dbb, \u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe \u0bae\u0bc0\u0ba9\u0bcd\u0bb5\u0bb3\u0ba4\u0bcd \u0ba4\u0bc1\u0bb1\u0bc8\u0bae\u0bc1\u0b95\u0bae\u0bcd, \u0b9a\u0ba8\u0bcd\u0ba4\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Ambalangoda-elpitiy-pitigala Rd, Karandeniya": {
    si: "\u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0d9c\u0ddc\u0da9 - \u0d87\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba - \u0db4\u0dd2\u0da7\u0dd2\u0d9c\u0dbd \u0db4\u0dcf\u0dbb, \u0d9a\u0dbb\u0db1\u0dca\u0daf\u0dd9\u0dab\u0dd2\u0dba",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f-\u0b8e\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf-\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb0\u0ba8\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf",
  },
  Ambalantota: {
    si: "\u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0dad\u0ddc\u0da7",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8",
  },
  "Ambanpitiya, Galigamuwa": {
    si: "\u0d85\u0db9\u0db1\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0d9c\u0dbd\u0dd2\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0ba9\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b95\u0bb2\u0bbf\u0b95\u0bae\u0bc1\u0bb5",
  },
  "Ambaraluwa Temple Bus Stop, Sri Lanka": {
    si: "\u0d85\u0db9\u0dbb\u0dc5\u0dd4\u0dc0 \u0db4\u0db1\u0dca\u0dc3\u0dbd \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bb0\u0bb2\u0bc1\u0bb5\u0bbe \u0b95\u0bcb\u0baf\u0bbf\u0bb2\u0bcd \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Ambathale: {
    si: "\u0d85\u0db9\u0dad\u0dbd\u0dda",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0ba4\u0bcd\u0ba4\u0bbe\u0bb2\u0bc7",
  },
  "Ambathanna, Katugastota": {
    si: "\u0d85\u0db9\u0dad\u0dd0\u0db1\u0dca\u0db1, \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0ba4\u0bcd\u0ba4\u0ba9\u0bcd\u0ba9, \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8",
  },
  "Ambepussa - Kurunegala - Trincomalee Highway, Galewela": {
    si: "\u0d85\u0db9\u0dda\u0db4\u0dd4\u0dc3\u0dca\u0dc3 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0d9c\u0dbd\u0dda\u0dc0\u0dd9\u0dbd",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bc7\u0baa\u0bc1\u0bb8\u0bcd\u0bb8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bb2\u0bc7\u0bb5\u0bc6\u0bb2",
  },
  "Ambepussa - Kurunegala - Trincomalee Highway, Melsiripura": {
    si: "\u0d85\u0db9\u0dda\u0db4\u0dd4\u0dc3\u0dca\u0dc3 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0db8\u0dd0\u0dbd\u0dca\u0dc3\u0dd2\u0dbb\u0dd2\u0db4\u0dd4\u0dbb",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bc7\u0baa\u0bc1\u0bb8\u0bcd\u0bb8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0bc6\u0bb2\u0bcd\u0b9a\u0bbf\u0bb0\u0bbf\u0baa\u0bc1\u0bb0",
  },
  "Ambepussa - Kurunegala - Trincomalee Hwy, Dambulla": {
    si: "\u0d85\u0db9\u0dda\u0db4\u0dd4\u0dc3\u0dca\u0dc3 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bc7\u0baa\u0bc1\u0bb8\u0bcd\u0bb8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 Hwy, \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8",
  },
  "Ambepussa - Kurunegala - Trincomalee Hwy, Ipalawa": {
    si: "\u0d85\u0db9\u0dda\u0db4\u0dd4\u0dc3\u0dca\u0dc3 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0d89\u0db4\u0dbd\u0dcf\u0dc0",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bc7\u0baa\u0bc1\u0bb8\u0bcd\u0bb8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 Hwy, \u0b87\u0baa\u0bb2\u0bbe\u0bb5",
  },
  "Ambepussa - Kurunegala - Trincomalee Hwy, Kurunegala": {
    si: "\u0d85\u0db9\u0dda\u0db4\u0dd4\u0dc3\u0dca\u0dc3 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba Hwy, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bc7\u0baa\u0bc1\u0bb8\u0bcd\u0bb8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 Hwy, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd",
  },
  "Ambepussa - Kurunegala - Trincomalee Hwy, Thorayaya": {
    si: "\u0d85\u0db9\u0dda\u0db4\u0dd4\u0dc3\u0dca\u0dc3 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba Hwy, Thorayaya",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bc7\u0baa\u0bc1\u0bb8\u0bcd\u0bb8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 Hwy, \u0ba4\u0bcb\u0bb0\u0bbe\u0baf\u0baf\u0bbe",
  },
  "Ambepussa - Trincomalee Hwy, Kantale": {
    si: "\u0d85\u0db9\u0dda\u0db4\u0dd4\u0dc3\u0dca\u0dc3 - \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0d9a\u0db1\u0dca\u0dad\u0dbd\u0dda",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bc7\u0baa\u0bc1\u0bb8\u0bcd\u0bb8 - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 Hwy, \u0b95\u0ba8\u0bcd\u0ba4\u0bb3\u0bbe\u0baf\u0bcd",
  },
  Amithirigala: {
    si: "\u0d85\u0db8\u0dd2\u0dad\u0dd2\u0dbb\u0dd2\u0d9c\u0dbd",
    ta: "\u0b85\u0bae\u0bbf\u0ba4\u0bbf\u0bb0\u0bbf\u0b95\u0bb2",
  },
  Ampara: {
    si: "\u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8",
  },
  "Ampara Rd, Monaragala": {
    si: "\u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb \u0db4\u0dcf\u0dbb, \u0db8\u0ddc\u0db1\u0dbb\u0dcf\u0d9c\u0dbd",
    ta: "\u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bca\u0ba9\u0bb0\u0bbe\u0b95\u0bb2\u0bc8",
  },
  "Ampilanturai-veeramunai Rd, Mandur": {
    si: "\u0d85\u0db8\u0dca\u0db4\u0dd2\u0dbd\u0db1\u0dca\u0dad\u0dd4\u0dbb\u0dda-\u0dc0\u0dd3\u0dbb\u0db8\u0dd4\u0db1\u0dd9\u0dba\u0dd2 \u0db4\u0dcf\u0dbb, \u0db8\u0db1\u0dca\u0da9\u0dd6\u0dbb\u0dca",
    ta: "\u0b86\u0bae\u0bcd\u0baa\u0bbf\u0bb2\u0bbe\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8-\u0bb5\u0bc0\u0bb0\u0bae\u0bc1\u0ba9\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0ba3\u0bcd\u0b9f\u0bc2\u0bb0\u0bcd",
  },
  "Anagarika Dharmapala Mawatha, Kandy 20000": {
    si: "\u0d85\u0db1\u0d9c\u0dcf\u0dbb\u0dd2\u0d9a \u0db0\u0dbb\u0dca\u0db8\u0db4\u0dcf\u0dbd \u0db8\u0dcf\u0dc0\u0dad, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb 20000",
    ta: "\u0b85\u0ba9\u0b95\u0bbe\u0bb0\u0bbf\u0b95 \u0ba4\u0bb0\u0bcd\u0bae\u0baa\u0bbe\u0bb2 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf 20000",
  },
  "Andal Oya Junction, Weranketagoda": {
    si: "\u0d86\u0db3\u0dcf\u0dbd\u0dca \u0d94\u0dba \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0dc0\u0dda\u0dbb\u0db1\u0dca\u0d9a\u0dd0\u0da7\u0d9c\u0ddc\u0da9",
    ta: "\u0b86\u0ba3\u0bcd\u0b9f\u0bbe\u0bb3\u0bcd \u0b93\u0baf\u0bbe \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0bb5\u0bc6\u0bb0\u0ba9\u0bcd\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0b95\u0bca\u0b9f",
  },
  "Andalla - Tissa, Weerawila": {
    si: "\u0d85\u0db3\u0dbd\u0dca\u0dbd - \u0dad\u0dd2\u0dc3\u0dca\u0dc3, \u0dc0\u0dd3\u0dbb\u0dc0\u0dd2\u0dbd",
    ta: "\u0b86\u0ba3\u0bcd\u0b9f\u0bb2\u0bcd\u0bb2 - \u0ba4\u0bbf\u0bb8\u0bcd\u0bb8, \u0bb5\u0bc0\u0bb0\u0bb5\u0bbf\u0bb2",
  },
  "Andarawewa - Balaluwewa Rd, Galnewa": {
    si: "\u0d85\u0db1\u0dca\u0daf\u0dbb\u0dc0\u0dd0\u0dc0 - \u0db6\u0dbd\u0dbd\u0dd4\u0dc0\u0dd0\u0dc0 \u0db4\u0dcf\u0dbb, \u0d9c\u0dbd\u0dca\u0db1\u0dd1\u0dc0",
    ta: "\u0b85\u0ba8\u0bcd\u0ba4\u0bb0\u0bb5\u0bc6\u0bb5 - \u0baa\u0bb2\u0bb2\u0bc1\u0bb5\u0bc6\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb2\u0bcd\u0ba8\u0bc7\u0bb5",
  },
  "Andarayaya, Polpithigama": {
    si: "\u0d85\u0db1\u0dca\u0daf\u0dbb\u0dba\u0dcf\u0dba, \u0db4\u0ddc\u0dbd\u0dca\u0db4\u0dd2\u0dad\u0dd2\u0d9c\u0db8",
    ta: "\u0b85\u0ba8\u0bcd\u0ba4\u0bb0\u0baf\u0bbe\u0baf, \u0baa\u0bca\u0bb2\u0bcd\u0baa\u0bbf\u0ba4\u0bbf\u0b95\u0bae",
  },
  Andaulpotha: {
    si: "\u0d86\u0db1\u0dca\u0daf\u0dc0\u0dd4\u0dbd\u0dca\u0db4\u0ddc\u0dad",
    ta: "\u0b86\u0ba3\u0bcd\u0b9f\u0bbe\u0bb3\u0bcd\u0baa\u0bca\u0ba4",
  },
  Andigama: {
    si: "\u0d86\u0dac\u0dd2\u0d9c\u0db8",
    ta: "\u0b86\u0ba3\u0bcd\u0b9f\u0bbf\u0b95\u0bae",
  },
  "Angoda Fuel Filling Station": {
    si: "\u0d85\u0d82\u0d9c\u0ddc\u0da9 \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b85\u0b99\u0bcd\u0b95\u0bca\u0b9f \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  Anuradhapura: {
    si: "\u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb",
    ta: "\u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd",
  },
  "Anuradhapura - Padeniya Highway": {
    si: "\u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb - \u0db4\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba",
    ta: "\u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd - \u0baa\u0ba4\u0bc6\u0ba9\u0bbf\u0baf \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8",
  },
  "Anuradhapura - Rambewa Hwy": {
    si: "\u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb - \u0dbb\u0db9\u0dd1\u0dc0 Hwy",
    ta: "\u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd - \u0bb0\u0bae\u0bcd\u0baa\u0bc7\u0bb5 Hwy",
  },
  "Anuradhapura.": {
    si: "\u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb.",
    ta: "\u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd.",
  },
  "Any Diesel": {
    si: "\u0d95\u0db1\u0dd1\u0db8 \u0da9\u0dd3\u0dc3\u0dbd\u0dca",
    ta: "\u0b8f\u0ba4\u0bc7\u0ba9\u0bc1\u0bae\u0bcd \u0b9f\u0bc0\u0b9a\u0bb2\u0bcd",
  },
  "Any Petrol": {
    si: "\u0d95\u0db1\u0dd1\u0db8 \u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0dbd\u0dca",
    ta: "\u0b8e\u0ba8\u0bcd\u0ba4 \u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bcd",
  },
  "Approach the rail road, Trincomalee, Sri Lanka": {
    si: "\u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0, \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0daf\u0dd4\u0db8\u0dca\u0dbb\u0dd2\u0dba \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba\u0da7 \u0db4\u0dd2\u0dc0\u0dd2\u0dc3\u0dd9\u0db1\u0dca\u0db1",
    ta: "\u0bb0\u0baf\u0bbf\u0bb2\u0bcd \u0baa\u0bbe\u0ba4\u0bc8\u0baf\u0bc8 \u0b85\u0ba3\u0bc1\u0b95\u0bb5\u0bc1\u0bae\u0bcd, \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Aralaganwila: {
    si: "\u0d85\u0dbb\u0dbd\u0d9c\u0d82\u0dc0\u0dd2\u0dbd",
    ta: "\u0b85\u0bb0\u0bb2\u0b95\u0b99\u0bcd\u0bb5\u0bbf\u0bb2",
  },
  "Arambekema-hambegamuwa": {
    si: "\u0d85\u0dbb\u0db9\u0d9a\u0dd0\u0db8 - \u0dc4\u0db8\u0dca\u0db6\u0dd9\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0b85\u0bb0\u0bae\u0bcd\u0baa\u0bc7\u0b95\u0bc6\u0bae-\u0bb9\u0bae\u0bcd\u0baa\u0bc7\u0b95\u0bae\u0bc1\u0bb5",
  },
  Aranayake: {
    si: "\u0d85\u0dbb\u0dab\u0dcf\u0dba\u0d9a",
    ta: "\u0b85\u0bb0\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "Arasadi School, Sri Lanka": {
    si: "\u0d85\u0dbb\u0dc3\u0daf\u0dd2 \u0db4\u0dcf\u0dc3\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b85\u0bb0\u0b9a\u0b9f\u0bbf \u0baa\u0bb3\u0bcd\u0bb3\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Arawwala Rd, Pannipitiya": {
    si: "\u0d87\u0dbb\u0dd0\u0dc0\u0dca\u0dc0\u0dbd \u0db4\u0dcf\u0dbb, \u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0b85\u0bb0\u0bb5\u0bcd\u0bb5\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Ariviyal Nagar": {
    si: "\u0d85\u0dbb\u0dd2\u0dc0\u0dd2\u0dba\u0dbd\u0dca \u0db1\u0d9c\u0dbb\u0dca",
    ta: "\u0b85\u0bb1\u0bbf\u0bb5\u0bbf\u0baf\u0bb2\u0bcd \u0ba8\u0b95\u0bb0\u0bcd",
  },
  "Army Camp-r, Sandunpura": {
    si: "\u0dba\u0dd4\u0db0 \u0dc4\u0db8\u0dd4\u0daf\u0dcf \u0d9a\u0db3\u0dc0\u0dd4\u0dbb - \u0d86\u0dbb\u0dca, \u0dc3\u0db3\u0dd4\u0db1\u0dca\u0db4\u0dd4\u0dbb",
    ta: "\u0b87\u0bb0\u0bbe\u0ba3\u0bc1\u0bb5 \u0bae\u0bc1\u0b95\u0bbe\u0bae\u0bcd-\u0b86\u0bb0\u0bcd, \u0b9a\u0ba8\u0bcd\u0ba4\u0bc1\u0ba9\u0bcd\u0baa\u0bc1\u0bb0\u0bbe",
  },
  Athurugiriya: {
    si: "\u0d85\u0dad\u0dd4\u0dbb\u0dd4\u0d9c\u0dd2\u0dbb\u0dd2\u0dba",
    ta: "\u0b85\u0ba4\u0bc1\u0bb0\u0bc1\u0b95\u0bbf\u0bb0\u0bbf\u0baf",
  },
  "Attanagalla - Ruwanwella Bust stop, Sri Lanka": {
    si: "\u0d85\u0dad\u0dca\u0dad\u0db1\u0d9c\u0dbd\u0dca\u0dbd - \u0dbb\u0dd4\u0dc0\u0db1\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b85\u0ba4\u0bcd\u0ba4\u0ba9\u0b95\u0bb2\u0bcd\u0bb2 - \u0bb0\u0bc1\u0bb5\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Auto Care Filling Station, A1, Kegalle": {
    si: "\u0d94\u0da7\u0ddd \u0d9a\u0dd9\u0dba\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, A1, \u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd",
    ta: "\u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0b95\u0bc7\u0bb0\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, A1, \u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8",
  },
  Avissawella: {
    si: "\u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd",
    ta: "\u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8",
  },
  "Avissawella - Hatton - Nuwara Eliya Hwy, Nanuoya": {
    si: "\u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd - \u0dc4\u0dd0\u0da7\u0db1\u0dca - \u0db1\u0dd4\u0dc0\u0dbb\u0d91\u0dc5\u0dd2\u0dba Hwy, \u0db1\u0dcf\u0db1\u0dd4\u0d94\u0dba",
    ta: "\u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 - \u0bb9\u0b9f\u0bcd\u0b9f\u0ba9\u0bcd - \u0ba8\u0bc1\u0bb5\u0bb0\u0bc6\u0bb2\u0bbf\u0baf\u0bbe Hwy, \u0ba8\u0bbe\u0ba9\u0bc1\u0b93\u0baf\u0bbe",
  },
  "Avissawella - Hatton - Nuwara Eliya Hwy, Talawakelle": {
    si: "\u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd - \u0dc4\u0dd0\u0da7\u0db1\u0dca - \u0db1\u0dd4\u0dc0\u0dbb\u0d91\u0dc5\u0dd2\u0dba Hwy, \u0dad\u0dbd\u0dc0\u0dcf\u0d9a\u0dd0\u0dbd\u0dda",
    ta: "\u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 - \u0bb9\u0b9f\u0bcd\u0b9f\u0ba9\u0bcd - \u0ba8\u0bc1\u0bb5\u0bb0\u0bc6\u0bb2\u0bbf\u0baf\u0bbe Hwy, \u0ba4\u0bb2\u0bb5\u0bbe\u0b95\u0bcd\u0b95\u0bb2\u0bc8",
  },
  "Avissawella Rd, Homagama": {
    si: "\u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0dc4\u0ddd\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0bcb\u0bae\u0bbe\u0b95\u0bae",
  },
  "Avissawella Rd, Maharagama": {
    si: "\u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0dbb\u0d9c\u0db8",
    ta: "\u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bb9\u0bb0\u0b95\u0bae",
  },
  "Avissawella Rd, Nugegoda": {
    si: "\u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db1\u0dd4\u0d9c\u0dda\u0d9c\u0ddc\u0da9",
    ta: "\u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc1\u0b95\u0bc7\u0b95\u0bca\u0b9f",
  },
  "Avissawella Rd, Pannipitiya": {
    si: "\u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  Awissawella: {
    si: "\u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd",
    ta: "\u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8",
  },
  "B & S AUTO ENTERPRISES(PVT)LTD": {
    si: "B & S AUTO ENTERPRISES(PVT)LTD",
    ta: "\u0baa\u0bbf & \u0b8e\u0bb8\u0bcd \u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "B D P GUNASEKERA & SONS": {
    si: "\u0db6\u0dd3 \u0da9\u0dd3 \u0db4\u0dd3 \u0d9c\u0dd4\u0dab\u0dc3\u0dda\u0d9a\u0dbb \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0baa\u0bbf \u0b9f\u0bbf \u0baa\u0bbf \u0b95\u0bc1\u0ba3\u0b9a\u0bc7\u0b95\u0bb0 & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "B H B D K NIROSHAN": {
    si: "\u0db6\u0dd3 \u0d91\u0da0\u0dca \u0db6\u0dd3 \u0da9\u0dd3 \u0d9a\u0dda \u0db1\u0dd2\u0dbb\u0ddd\u0dc2\u0db1\u0dca",
    ta: "\u0baa\u0bbf \u0b8e\u0b9a\u0bcd \u0baa\u0bbf \u0b9f\u0bbf \u0b95\u0bc7 \u0ba8\u0bbf\u0bb0\u0bcb\u0bb7\u0ba9\u0bcd",
  },
  "B H PARAKUM": {
    si: "\u0db6\u0dd3 \u0d91\u0da0\u0dca \u0db4\u0dd0\u0dbb\u0d9a\u0dd4\u0db8\u0dca",
    ta: "\u0baa\u0bbf \u0b8e\u0b9a\u0bcd \u0baa\u0bb1\u0b95\u0bcd\u0b95\u0bc1\u0bae\u0bcd",
  },
  "B H RANASINGHE": {
    si: "\u0db6\u0dd3 \u0d91\u0da0\u0dca \u0dbb\u0dab\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0baa\u0bbf \u0b8e\u0b9a\u0bcd \u0bb0\u0ba3\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "B K J S AMARADASA": {
    si: "\u0db6\u0dd3 \u0d9a\u0dda \u0da2\u0dda \u0d91\u0dc3\u0dca \u0d85\u0db8\u0dbb\u0daf\u0dcf\u0dc3",
    ta: "\u0baa\u0bbf \u0b95\u0bc7 \u0b9c\u0bc7 \u0b8e\u0bb8\u0bcd \u0b85\u0bae\u0bb0\u0ba4\u0bbe\u0b9a\u0bbe",
  },
  "B M N BASNAYAKE": {
    si: "\u0db6\u0dd3 \u0d91\u0db8\u0dca \u0d91\u0db1\u0dca \u0db6\u0dc3\u0dca\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0baa\u0bbf \u0b8e\u0bae\u0bcd \u0b8e\u0ba9\u0bcd \u0baa\u0bbe\u0bb8\u0bcd\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95\u0bc7",
  },
  "B M S BANDARANAYAKE": {
    si: "\u0db6\u0dd3 \u0d91\u0db8\u0dca \u0d91\u0dc3\u0dca \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0baa\u0bbf \u0b8e\u0bae\u0bcd \u0b8e\u0bb8\u0bcd \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "B P MORAWAKA & SONS LTD": {
    si: "\u0db6\u0dd3 \u0db4\u0dd3 \u0db8\u0ddc\u0dbb\u0dc0\u0d9a \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd \u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad",
    ta: "\u0baa\u0bbf \u0baa\u0bbf \u0bae\u0bca\u0bb0\u0bb5\u0bbe\u0b95\u0bcd\u0b95\u0bbe & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "B R M B B RATHNAYAKE": {
    si: "\u0db6\u0dd3 \u0d86\u0dbb\u0dca \u0d91\u0db8\u0dca \u0db6\u0dd3 \u0db6\u0dd3 \u0dbb\u0dad\u0dca\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0baa\u0bbf \u0b86\u0bb0\u0bcd \u0b8e\u0bae\u0bcd \u0baa\u0bbf \u0baa\u0bbf \u0bb0\u0ba4\u0bcd\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "B S COORAY": {
    si: "\u0db6\u0dd3 \u0d91\u0dc3\u0dca \u0d9a\u0dd4\u0dbb\u0dda",
    ta: "\u0baa\u0bbf \u0b8e\u0bb8\u0bcd \u0b95\u0bc2\u0bb0\u0bc7",
  },
  "B S I JAYASENA": {
    si: "\u0db6\u0dd3 \u0d91\u0dc3\u0dca \u0d85\u0dba\u0dd2 \u0da2\u0dba\u0dc3\u0dda\u0db1",
    ta: "\u0baa\u0bbf \u0b8e\u0bb8\u0bcd \u0b90 \u0b9c\u0baf\u0b9a\u0bc7\u0ba9",
  },
  "B S S .DAYARATHNA": {
    si: "B S S .\u0daf\u0dba\u0dcf\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0baa\u0bbf \u0b8e\u0bb8\u0bcd \u0b8e\u0bb8\u0bcd .\u0ba4\u0baf\u0bbe\u0bb0\u0ba4\u0bcd\u0ba9\u0bbe",
  },
  "B SAMARAWEERA  & SON": {
    si: "\u0db6\u0dd3 \u0dc3\u0db8\u0dbb\u0dc0\u0dd3\u0dbb \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dcf",
    ta: "\u0baa\u0bbf \u0b9a\u0bae\u0bb0\u0bb5\u0bc0\u0bb0 & \u0bae\u0b95\u0ba9\u0bcd",
  },
  "B V De P RODRIGO": {
    si: "\u0db6\u0dd3 \u0dc0\u0dd3 \u0daf \u0db4\u0dd3 \u0dbb\u0ddc\u0daf\u0dca\u0dbb\u0dd2\u0d9c\u0ddd",
    ta: "\u0baa\u0bbf \u0bb5\u0bbf \u0b9f\u0bbf \u0baa\u0bbf \u0bb0\u0bcb\u0b9f\u0bcd\u0bb0\u0bbf\u0b95\u0bcb",
  },
  "B. M. A. V. MAPA": {
    si: "B. M. A. V. MAPA",
    ta: "B. M. A. V. MAPA",
  },
  "B.A.M.RIZVI": {
    si: "B.A.M.RIZVI",
    ta: "\u0baa\u0bbf.\u0b8f.\u0b8e\u0bae\u0bcd.\u0bb0\u0bbf\u0bb8\u0bcd\u0bb5\u0bbf",
  },
  "B.A.RANIL PRIYANTHA": {
    si: "\u0db6\u0dd3.\u0d92.\u0dbb\u0db1\u0dd2\u0dbd\u0dca \u0db4\u0dca\u200d\u0dbb\u0dd2\u0dba\u0db1\u0dca\u0dad",
    ta: "\u0baa\u0bbf.\u0b8f.\u0bb0\u0ba3\u0bbf\u0bb2\u0bcd \u0baa\u0bbf\u0bb0\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bbe",
  },
  "B.D.S.G.SERVICE STATION (PVT) LTD": {
    si: "B.D.S.G.SERVICE STATION (PVT) LTD",
    ta: "B.D.S.G.SERVICE STATION (PVT) LTD",
  },
  "B.K.S. COMPANY (PVT)LTD": {
    si: "\u0db6\u0dd3.\u0d9a\u0dda.\u0d91\u0dc3\u0dca. COMPANY (PVT)LTD",
    ta: "\u0baa\u0bbf.\u0b95\u0bc7.\u0b8e\u0bb8\u0bcd. \u0ba8\u0bbf\u0bb1\u0bc1\u0bb5\u0ba9\u0bae\u0bcd (PVT) LTD",
  },
  "B.M GUNERATHHAMY": {
    si: "\u0db6\u0dd3.\u0d91\u0db8\u0dca \u0d9c\u0dd4\u0dab\u0dbb\u0dad\u0dca\u0dc4\u0dcf\u0db8\u0dd2",
    ta: "\u0baa\u0bbf.\u0b8e\u0bae\u0bcd.\u0b95\u0bc1\u0ba3\u0bb0\u0ba4\u0bcd\u0bb9\u0bae\u0bbf",
  },
  "B.M.S.BANDARANAYAKE": {
    si: "\u0db6\u0dd3.\u0d91\u0db8\u0dca.\u0d91\u0dc3\u0dca.\u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0baa\u0bbf.\u0b8e\u0bae\u0bcd.\u0b8e\u0bb8\u0bcd.\u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "B.S.I.JAYASENA": {
    si: "\u0db6\u0dd3.\u0d91\u0dc3\u0dca.\u0d85\u0dba\u0dd2.\u0da2\u0dba\u0dc3\u0dda\u0db1",
    ta: "\u0baa\u0bbf.\u0b8e\u0bb8\u0bcd.\u0b90.\u0b9c\u0bc6\u0baf\u0b9a\u0bc7\u0ba9",
  },
  "B.V.JAYAWARDANA": {
    si: "\u0db6\u0dd3.\u0dc0\u0dd3.\u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1",
    ta: "\u0baa\u0bbf.\u0bb5\u0bbf.\u0b9c\u0bc6\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9",
  },
  "B111, Sri Lanka": {
    si: "B111, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "B111, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "B128, Baddegama": {
    si: "\u0db6\u0dd3 128, \u0db6\u0daf\u0dca\u0daf\u0dda\u0d9c\u0db8",
    ta: "B128, \u0baa\u0ba4\u0bcd\u0ba4\u0bc7\u0b95\u0bae",
  },
  "B128, Poddala": {
    si: "\u0db6\u0dd3 128, \u0db4\u0ddd\u0daf\u0dca\u0daf\u0dbd",
    ta: "B128, \u0baa\u0bcb\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe",
  },
  "B14, Kurundugahahetekma": {
    si: "B14, Kurundugahahetekma",
    ta: "B14, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1\u0b95\u0bb9\u0bbe\u0bb9\u0bc6\u0b9f\u0bc6\u0b95\u0bcd\u0bae\u0bbe",
  },
  "B143, Batapola": {
    si: "\u0db6\u0dd3 143, \u0db6\u0da7\u0db4\u0ddc\u0dbd",
    ta: "B143, \u0baa\u0b9f\u0baa\u0bca\u0bb2",
  },
  "B149, Norwood": {
    si: "B149, \u0db1\u0ddd\u0dbb\u0dca\u0dc0\u0dd4\u0da9\u0dca",
    ta: "B149, \u0ba8\u0bbe\u0bb0\u0bcd\u0bb5\u0bc2\u0b9f\u0bcd",
  },
  "B157 Horana - Anguruwatota - Mathugama - Aluthgama Road, Anguruwatota": {
    si: "B157 \u0dc4\u0ddc\u0dbb\u0dab - \u0d85\u0d9f\u0dd4\u0dbb\u0dd4\u0dc0\u0dcf\u0dad\u0ddc\u0da7 - \u0db8\u0dad\u0dd4\u0d9c\u0db8 - \u0d85\u0dbd\u0dd4\u0dad\u0dca\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0d85\u0d9f\u0dd4\u0dbb\u0dd4\u0dc0\u0dcf\u0dad\u0ddc\u0da7",
    ta: "B157 \u0bb9\u0bca\u0bb0\u0ba3 - \u0b85\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0bc1\u0bb5\u0ba4\u0bca\u0b9f\u0bcd\u0b9f - \u0bae\u0ba4\u0bcd\u0ba4\u0bc1\u0b95\u0bae - \u0b85\u0bb3\u0bc1\u0ba4\u0bcd\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0bc1\u0bb5\u0ba4\u0bca\u0b9f\u0bcd\u0b9f",
  },
  "B158, Pitigala": {
    si: "\u0db6\u0dd3 158, \u0db4\u0dd2\u0da7\u0dd2\u0d9c\u0dbd",
    ta: "B158, \u0baa\u0bbf\u0b9f\u0bbf\u0b95\u0bb2",
  },
  "B167, Kobeigane": {
    si: "\u0db6\u0dd3 167, \u0d9a\u0ddc\u0db6\u0dd9\u0dba\u0dd2\u0d9c\u0db1\u0dda",
    ta: "\u0baa\u0bbf167, \u0b95\u0bcb\u0baa\u0bbf\u0b95\u0ba9\u0bc7",
  },
  "B2, Sri Lanka": {
    si: "B2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "B2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "B247, Sri Lanka": {
    si: "B247, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "B247, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "B287, Hingurakgoda": {
    si: "\u0db6\u0dd3 287, \u0dc4\u0dd2\u0d9f\u0dd4\u0dbb\u0d9a\u0dca\u0d9c\u0ddc\u0da9",
    ta: "B287, \u0bb9\u0bbf\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0bbe\u0b95\u0bcd\u0b95\u0bca\u0b9f",
  },
  "B288, Udugampola": {
    si: "\u0db6\u0dd3 288, \u0d8b\u0da9\u0dd4\u0d9c\u0db8\u0dca\u0db4\u0ddc\u0dbd",
    ta: "B288, \u0b89\u0b9f\u0bc1\u0b95\u0bae\u0bcd\u0baa\u0bca\u0bb2",
  },
  "B304, Bulathsinhala": {
    si: "\u0db6\u0dd3 304, \u0db6\u0dd4\u0dbd\u0dad\u0dca\u0dc3\u0dd2\u0d82\u0dc4\u0dbd",
    ta: "B304, \u0baa\u0bc1\u0bb2\u0ba4\u0bcd\u0b9a\u0bbf\u0b99\u0bcd\u0b95\u0bb3",
  },
  "B304, Sri Lanka": {
    si: "B304, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "B304, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "B322, Sri Lanka": {
    si: "B322, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "B322, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "B353, Boralanda, Sri Lanka": {
    si: "B353, \u0db6\u0ddc\u0dbb\u0dbd\u0db1\u0dca\u0daf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "B353, \u0baa\u0bca\u0bb0\u0bb2\u0ba3\u0bcd\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "B356, Sri Lanka": {
    si: "B356, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "B356, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "B374, Panama Road, Pottuvil": {
    si: "\u0db6\u0dd3 374, \u0db4\u0dcf\u0db1\u0db8 \u0db4\u0dcf\u0dbb, \u0db4\u0ddc\u0dad\u0dd4\u0dc0\u0dd2\u0dbd\u0dca",
    ta: "B374, \u0baa\u0bbe\u0ba9\u0bae\u0bbe \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bca\u0ba4\u0bcd\u0ba4\u0bc1\u0bb5\u0bbf\u0bb2\u0bcd",
  },
  "B415, Sri Lanka": {
    si: "B415, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "B415, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "B427, Udawalawa": {
    si: "\u0db6\u0dd3 427, \u0d8b\u0da9\u0dc0\u0dbd\u0dc0",
    ta: "B427, \u0b89\u0b9f\u0bb5\u0bb2\u0bb5",
  },
  "B445, Veyangoda": {
    si: "\u0db6\u0dd3 445, \u0dc0\u0dda\u0dba\u0db1\u0dca\u0d9c\u0ddc\u0da9",
    ta: "B445, \u0bb5\u0bc6\u0baf\u0b99\u0bcd\u0b95\u0bca\u0b9f",
  },
  "B47, Sri Jayawardenepura Kotte": {
    si: "\u0db6\u0dd3 47, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1\u0db4\u0dd4\u0dbb \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda",
    ta: "B47, \u0bb8\u0bcd\u0bb0\u0bc0 \u0b9c\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0baa\u0bc1\u0bb0 \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7",
  },
  "B486, Embilipitiya": {
    si: "\u0db6\u0dd3 486, \u0d87\u0db9\u0dd2\u0dbd\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "B486, \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0bb2\u0bbf\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "B55, Hakmana": {
    si: "\u0db6\u0dd355, \u0dc4\u0d9a\u0dca\u0db8\u0db1",
    ta: "\u0baa\u0bbf55, \u0bb9\u0b95\u0bcd\u0bae\u0ba9\u0bbe",
  },
  "B55, Uragasmanhandiya": {
    si: "\u0db6\u0dd355, \u0d8c\u0dbb\u0d9c\u0dc3\u0dca\u0db8\u0d82\u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba",
    ta: "B55, \u0b89\u0bb0\u0b95\u0bb8\u0bcd\u0bae\u0ba9\u0bcd\u0bb9\u0ba8\u0bcd\u0ba4\u0bbf\u0baf\u0bbe",
  },
  "BADULLA MPCS LTD": {
    si: "\u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd MPCS LTD",
    ta: "\u0baa\u0ba4\u0bc1\u0bb3\u0bc8 MPCS LTD",
  },
  "BALANGODA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db6\u0dbd\u0db1\u0dca\u0d9c\u0ddc\u0da9 MPCS",
    ta: "\u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f MPCS LTD",
  },
  "BALAPITIYA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db6\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba MPCS",
    ta: "\u0baa\u0bbe\u0bb2\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0bbe MPCS LTD",
  },
  "BAMUNUSINGHE & COMPANY (PVT) LTD": {
    si: "\u0db6\u0db8\u0dd4\u0dab\u0dd4\u0dc3\u0dd2\u0d82\u0dc4 \u0dc3\u0dc4 \u0dc3\u0db8\u0dcf\u0d9c\u0db8 (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0baa\u0bbe\u0bae\u0bc1\u0ba9\u0bc1\u0b9a\u0bbf\u0b99\u0bcd\u0b95 & \u0b95\u0bae\u0bcd\u0baa\u0ba9\u0bbf (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  BANDARAGAMA: {
    si: "\u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0d9c\u0db8",
    ta: "\u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0b95\u0bae",
  },
  "BANDARAGAMA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0d9c\u0db8 MPCS",
    ta: "\u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0b95\u0bae MPCS LTD",
  },
  BANDARAWELA: {
    si: "\u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0dc0\u0dd9\u0dbd",
    ta: "\u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0bb5\u0bb3\u0bc8",
  },
  "BANDARAWELA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0dc0\u0dd9\u0dbd \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0bb5\u0bb3\u0bc8 MPCS LTD",
  },
  "BANDULA SENANAYAKE & COMPANY(PVT)LT": {
    si: "\u0db6\u0db1\u0dca\u0daf\u0dd4\u0dbd \u0dc3\u0dda\u0db1\u0dcf\u0db1\u0dcf\u0dba\u0d9a \u0dc3\u0dc4 \u0dc3\u0db8\u0dcf\u0d9c\u0db8 (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) LT",
    ta: "\u0baa\u0ba8\u0bcd\u0ba4\u0bc1\u0bb2 \u0b9a\u0bc7\u0ba9\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 & \u0b95\u0bae\u0bcd\u0baa\u0ba9\u0bbf (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0b8e\u0bb2\u0bcd.\u0b9f\u0bbf",
  },
  "BAS DIL HAULIERS & ENT. (PVT) LTD": {
    si: "\u0db6\u0dcf\u0dc3\u0dca \u0da9\u0dd2\u0dbd\u0dca \u0dc4\u0dcf\u0dbd\u0dd2\u0dba\u0dbb\u0dca\u0dc3\u0dca \u0dc3\u0dc4 \u0d91\u0db1\u0dca.\u0da7\u0dd3. (PVT) LTD",
    ta: "\u0baa\u0bbe\u0bb8\u0bcd \u0ba4\u0bbf\u0bb2\u0bcd \u0bb9\u0bbe\u0bb2\u0bbf\u0baf\u0bb0\u0bcd\u0bb8\u0bcd & ENT. (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  BATTARAMULLA: {
    si: "\u0db6\u0dad\u0dca\u0dad\u0dbb\u0db8\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0baa\u0ba4\u0bcd\u0ba4\u0bb0\u0bae\u0bc1\u0bb2\u0bcd\u0bb2",
  },
  BATTICOLOA: {
    si: "\u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0",
    ta: "\u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1",
  },
  "BELIATTA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db6\u0dd9\u0dbd\u0dd2\u0d85\u0dad\u0dca\u0dad \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0baa\u0bc6\u0bb2\u0bbf\u0baf\u0bbe\u0b9f\u0bcd\u0b9f\u0bbe MPCS LTD",
  },
  "BELIHULOYA TRAVELS": {
    si: "\u0db6\u0dd9\u0dbd\u0dd2\u0dc4\u0dd4\u0dbd\u0dca\u0d94\u0dba \u0da7\u0dca\u200d\u0dbb\u0dd0\u0dc0\u0dbd\u0dca\u0dc3\u0dca",
    ta: "\u0baa\u0bc6\u0bb2\u0bbf\u0bb9\u0bc1\u0bb2\u0bcb\u0baf\u0bbe \u0b9f\u0bbf\u0bb0\u0bbe\u0bb5\u0bb2\u0bcd\u0bb8\u0bcd",
  },
  "BEN HEWA ASSOCIATES (PVT) LTD": {
    si: "\u0db6\u0dd9\u0db1\u0dca \u0dc4\u0dda\u0dc0\u0dcf \u0d87\u0dc3\u0ddd\u0dc3\u0dd2\u0dba\u0dda\u0da7\u0dca\u0dc3\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0baa\u0bc6\u0ba9\u0bcd \u0bb9\u0bc6\u0bb5\u0bbe \u0b85\u0b9a\u0bcb\u0b9a\u0bbf\u0baf\u0bc7\u0b9f\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "BERALAPANATARA  MPCS  LTD": {
    si: "BERALAPANATARA MPCS LTD",
    ta: "\u0baa\u0bc7\u0bb0\u0bb2\u0baa\u0ba8\u0bbe\u0ba4\u0bb0\u0bbe MPCS LTD",
  },
  "BERALAPANATHARA MPCS Ltd": {
    si: "BERALAPANATARA MPCS Ltd",
    ta: "\u0baa\u0bc7\u0bb0\u0bb2\u0baa\u0ba8\u0bbe\u0ba4\u0bb0\u0bbe \u0b8e\u0bae\u0bcd.\u0baa\u0bbf.\u0b9a\u0bbf.\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "BERUWALA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db6\u0dda\u0dbb\u0dd4\u0dc0\u0dbd MPCS",
    ta: "\u0baa\u0bc7\u0bb0\u0bc1\u0bb5\u0bb3\u0bc8 MPCS LTD",
  },
  "BIBILE KOTAGAMA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db6\u0dd2\u0db6\u0dd2\u0dbd\u0dda \u0d9a\u0ddc\u0da7\u0d9c\u0db8 MPCS",
    ta: "\u0baa\u0bbf\u0baa\u0bbf\u0bb2\u0bcd \u0b95\u0bcb\u0b9f\u0b95\u0bbe\u0bae\u0bbe MPCS LTD",
  },
  BINGIRIYA: {
    si: "\u0db6\u0dd2\u0d82\u0d9c\u0dd2\u0dbb\u0dd2\u0dba",
    ta: "\u0baa\u0bbf\u0b99\u0bcd\u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bbe",
  },
  "BINGIRIYA MPCS": {
    si: "\u0db6\u0dd2\u0d82\u0d9c\u0dd2\u0dbb\u0dd2\u0dba \u0d91\u0db8\u0dca.\u0db4\u0dd3.\u0dc3\u0dd3.\u0d91\u0dc3\u0dca",
    ta: "\u0baa\u0bbf\u0b99\u0bcd\u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bbe \u0b8e\u0bae\u0bcd.\u0baa\u0bbf.\u0b9a\u0bbf.\u0b8e\u0bb8\u0bcd",
  },
  "BINGIRIYA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db6\u0dd2\u0d82\u0d9c\u0dd2\u0dbb\u0dd2\u0dba \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0baa\u0bbf\u0b99\u0bcd\u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bbe MPCS LTD",
  },
  "BINTENNAPATTU MPCS LTD": {
    si: "\u0db6\u0dd2\u0db1\u0dca\u0dad\u0dd0\u0db1\u0dca\u0db1\u0db4\u0dad\u0dca\u0dad\u0dd4 MPCS LTD",
    ta: "\u0baa\u0bbf\u0ba9\u0bcd\u0ba4\u0bc6\u0ba9\u0bcd\u0ba9\u0baa\u0bcd\u0baa\u0b9f\u0bcd\u0b9f\u0bc1 MPCS LTD",
  },
  BORALESGAMUWA: {
    si: "\u0db6\u0ddc\u0dbb\u0dbd\u0dd0\u0dc3\u0dca\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "BORALESGAMUWA",
  },
  "BRIAN DINUSHA": {
    si: "\u0db6\u0dca\u200d\u0dbb\u0dba\u0db1\u0dca \u0daf\u0dd2\u0db1\u0dd4\u0dc2\u0dcf",
    ta: "\u0baa\u0bbf\u0bb0\u0bc8\u0baf\u0ba9\u0bcd \u0ba4\u0bbf\u0ba9\u0bc1\u0bb7\u0bbe",
  },
  "BRIGHT DEALERS": {
    si: "\u0daf\u0dd3\u0db4\u0dca\u0dad\u0dd2\u0db8\u0dad\u0dca \u0db6\u0dd9\u0daf\u0dcf\u0dc4\u0dbb\u0dd2\u0db1\u0dca\u0db1\u0db1\u0dca",
    ta: "\u0baa\u0bbf\u0bb0\u0b95\u0bbe\u0b9a\u0bae\u0bbe\u0ba9 \u0b9f\u0bc0\u0bb2\u0bb0\u0bcd\u0b95\u0bb3\u0bcd",
  },
  "BROWN & CO LTD": {
    si: "\u0db6\u0dca\u200d\u0dbb\u0dc0\u0dd4\u0db1\u0dca \u0dc3\u0dc4 CO LTD",
    ta: "\u0baa\u0bbf\u0bb0\u0bb5\u0bc1\u0ba9\u0bcd & \u0b95\u0bcb \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "BT/ LIVE STOCK BREEDER'S CS LTD": {
    si: "BT/ LIVE STOCK BREEDER's CS LTD",
    ta: "BT/ \u0bb2\u0bc8\u0bb5\u0bcd \u0bb8\u0bcd\u0b9f\u0bbe\u0b95\u0bcd \u0baa\u0bcd\u0bb0\u0bc0\u0b9f\u0bb0\u0bcd\u0bb8\u0bcd CS LTD",
  },
  "BULATHKOHUPITIYA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db6\u0dd4\u0dbd\u0dad\u0dca\u0d9a\u0ddc\u0dc4\u0dd4\u0db4\u0dd2\u0da7\u0dd2\u0dba MPCS",
    ta: "\u0baa\u0bc1\u0bb2\u0ba4\u0bcd\u0b95\u0bcb\u0bb9\u0bc1\u0baa\u0bbf\u0b9f\u0bbf\u0baf\u0bbe MPCS LTD",
  },
  "BULATHSINHALA MPCS LTD": {
    si: "\u0db6\u0dd4\u0dbd\u0dad\u0dca\u0dc3\u0dd2\u0d82\u0dc4\u0dbd MPCS LTD",
    ta: "\u0baa\u0bc1\u0bb2\u0ba4\u0bcd\u0b9a\u0bbf\u0b99\u0bcd\u0b95\u0bb3 MPCS LTD",
  },
  "BUSINESS DEVELOPMENT COOP. SOCIETY": {
    si: "\u0dc0\u0dca\u200d\u0dba\u0dcf\u0db4\u0dcf\u0dbb \u0dc3\u0d82\u0dc0\u0dbb\u0dca\u0db0\u0db1 \u0dc3\u0db8\u0dd4\u0db4\u0d9a\u0dcf\u0dbb\u0dba. \u0dc3\u0db8\u0dcf\u0da2\u0dba",
    ta: "\u0bb5\u0ba3\u0bbf\u0b95 \u0bb5\u0bb3\u0bb0\u0bcd\u0b9a\u0bcd\u0b9a\u0bbf \u0b95\u0bc2\u0b9f\u0bcd\u0b9f\u0bc1\u0bb1\u0bb5\u0bc1. \u0b9a\u0bae\u0bc2\u0b95\u0bae\u0bcd",
  },
  "BUTTALA MPCS LTD": {
    si: "\u0db6\u0dd4\u0dad\u0dca\u0dad\u0dbd MPCS LTD",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3 MPCS LTD",
  },
  Badalgama: {
    si: "\u0db6\u0da9\u0dbd\u0dca\u0d9c\u0db8",
    ta: "\u0baa\u0b9f\u0bb2\u0bcd\u0b95\u0bae",
  },
  Badalkumbura: {
    si: "\u0db6\u0da9\u0dbd\u0dca\u0d9a\u0dd4\u0db9\u0dd4\u0dbb",
    ta: "\u0baa\u0b9f\u0bb2\u0bcd\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bbe",
  },
  "Badalkumbura, Badalkumbura, Sri Lanka": {
    si: "\u0db6\u0da9\u0dbd\u0dca\u0d9a\u0dd4\u0db9\u0dd4\u0dbb, \u0db6\u0da9\u0dbd\u0dca\u0d9a\u0dd4\u0db9\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0b9f\u0bb2\u0bcd\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bbe, \u0baa\u0b9f\u0bb2\u0bcd\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Baddegama: {
    si: "\u0db6\u0daf\u0dca\u0daf\u0dda\u0d9c\u0db8",
    ta: "\u0baa\u0ba4\u0bcd\u0ba4\u0bc7\u0b95\u0bae",
  },
  "Baddegama Rd -Gonapinuwala": {
    si: "\u0db6\u0daf\u0dca\u0daf\u0dda\u0d9c\u0db8 \u0db4\u0dcf\u0dbb - \u0d9c\u0ddd\u0db1\u0dcf\u0db4\u0dd3\u0db1\u0dd4\u0dc0\u0dbd",
    ta: "\u0baa\u0ba4\u0bcd\u0ba4\u0bc7\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf -\u0b95\u0bcb\u0ba9\u0bbe\u0baa\u0bbf\u0ba9\u0bc1\u0bb5\u0bb2",
  },
  "Baddegama Road, Wanduramba, Galle": {
    si: "\u0db6\u0daf\u0dca\u0daf\u0dda\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0dc0\u0db3\u0dd4\u0dbb\u0db9, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd",
    ta: "\u0baa\u0ba4\u0bcd\u0ba4\u0bc7\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0ba8\u0bcd\u0ba4\u0bc1\u0bb0\u0bae\u0bcd\u0baa, \u0b95\u0bbe\u0bb2\u0bbf",
  },
  Badulla: {
    si: "\u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0baa\u0ba4\u0bc1\u0bb3\u0bc8",
  },
  "Badulla Road, Bibile": {
    si: "\u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db6\u0dd2\u0db6\u0dd2\u0dbd",
    ta: "\u0baa\u0ba4\u0bc1\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bbf\u0baa\u0bbf\u0bb2\u0bc8",
  },
  Badulle: {
    si: "\u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd\u0dda",
    ta: "\u0baa\u0ba4\u0bc1\u0bb2\u0bcd\u0bb2\u0bc7",
  },
  Balagolla: {
    si: "\u0db6\u0dbd\u0d9c\u0ddc\u0dbd\u0dca\u0dbd",
    ta: "\u0baa\u0bb2\u0b95\u0bca\u0bb2\u0bcd\u0bb2\u0bbe",
  },
  Balangoda: {
    si: "\u0db6\u0dbd\u0db1\u0dca\u0d9c\u0ddc\u0da9",
    ta: "\u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f",
  },
  "Balapitiya Primary College, Balapitiya, Sri Lanka": {
    si: "\u0db6\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dca\u200d\u0dbb\u0dcf\u0dae\u0db8\u0dd2\u0d9a \u0dc0\u0dd2\u0daf\u0dca\u200d\u0dba\u0dcf\u0dbd\u0dba, \u0db6\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bb2\u0baa\u0bbf\u0b9f\u0bbf\u0baf\u0bbe \u0b86\u0bb0\u0bae\u0bcd\u0baa\u0b95\u0bcd \u0b95\u0bb2\u0bcd\u0bb2\u0bc2\u0bb0\u0bbf, \u0baa\u0bb2\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Ballaketuwa, Balleketuwa, Sri Lanka": {
    si: "\u0db6\u0dbd\u0dca\u0dbd\u0d9a\u0dd9\u0da7\u0dd4\u0dc0, \u0db6\u0dd0\u0dbd\u0dca\u0dbd\u0d9a\u0dd9\u0da7\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bb2\u0bcd\u0bb2\u0b95\u0bc6\u0b9f\u0bc1\u0bb5\u0bbe, \u0baa\u0bb2\u0bcd\u0bb2\u0bc7\u0b95\u0bc6\u0b9f\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Bambalapitiya, Colombo": {
    si: "\u0db6\u0db8\u0dca\u0db6\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0d9a\u0ddc\u0dc5\u0db9",
    ta: "\u0baa\u0bae\u0bcd\u0baa\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "Bamunawala,kurunegala": {
    si: "\u0db6\u0db8\u0dd4\u0dab\u0dcf\u0dc0\u0dbd, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd",
    ta: "\u0baa\u0bae\u0bc1\u0ba9\u0bbe\u0bb5\u0bb2, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd",
  },
  Bandaragama: {
    si: "\u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0d9c\u0db8",
    ta: "\u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0b95\u0bae",
  },
  "Bandarawatta Fuel Station, Puttalam - Colombo Rd, Seeduwa": {
    si: "\u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0dc0\u0dad\u0dca\u0dad \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0dc3\u0dd3\u0daf\u0dd6\u0dc0",
    ta: "\u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8 \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b9a\u0bc0\u0ba4\u0bc1\u0bb5",
  },
  Bandarawela: {
    si: "\u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0dc0\u0dd9\u0dbd",
    ta: "\u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0bb5\u0bb3\u0bc8",
  },
  "Bandarawela-Badulla Rd, Kumbalwela": {
    si: "\u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0dc0\u0dd9\u0dbd-\u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d9a\u0dd4\u0db9\u0dbd\u0dca\u0dc0\u0dd9\u0dbd",
    ta: "\u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0bb5\u0bb3\u0bc8-\u0baa\u0ba4\u0bc1\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bb2\u0bcd\u0bb5\u0bc6\u0bb2",
  },
  Bangadeniya: {
    si: "\u0db6\u0d82\u0d9c\u0daf\u0dd9\u0dab\u0dd2\u0dba",
    ta: "\u0baa\u0b99\u0bcd\u0b95\u0ba4\u0bc6\u0ba9\u0bbf\u0baf",
  },
  "Bangadeniya-andigama-anamaduwa Rd": {
    si: "\u0db6\u0d82\u0d9c\u0daf\u0dd9\u0dab\u0dd2\u0dba-\u0d86\u0dab\u0dca\u0da9\u0dd2\u0d9c\u0db8-\u0d86\u0dab\u0db8\u0da9\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb",
    ta: "\u0baa\u0b99\u0bcd\u0b95\u0ba4\u0bc6\u0ba9\u0bbf\u0baf-\u0b86\u0ba3\u0bcd\u0b9f\u0bbf\u0b95\u0bae-\u0b86\u0ba9\u0bae\u0b9f\u0bc1\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  "Bar Junction, Sri Lanka": {
    si: "\u0db6\u0dcf\u0dbb\u0dca \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bbe\u0bb0\u0bcd \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Barampola Junction": {
    si: "\u0db6\u0dd0\u0dbb\u0db8\u0dca\u0db4\u0ddc\u0dbd \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba",
    ta: "\u0baa\u0bb0\u0bae\u0bcd\u0baa\u0bca\u0bb2 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf",
  },
  "Baseline Rd, Colombo": {
    si: "\u0db6\u0dda\u0dc3\u0dca\u0dbd\u0dba\u0dd2\u0db1\u0dca \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0dc5\u0db9",
    ta: "\u0baa\u0bc7\u0bb8\u0bcd\u0bb2\u0bc8\u0ba9\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "Batepola, Dunagaha": {
    si: "\u0db6\u0da7\u0dda\u0db4\u0ddc\u0dbd, \u0daf\u0dd6\u0db1\u0d9c\u0dc4",
    ta: "\u0baa\u0b9f\u0bc7\u0baa\u0bca\u0bb2, \u0ba4\u0bc1\u0ba9\u0b95\u0bb9\u0bbe",
  },
  Batticaloa: {
    si: "\u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0",
    ta: "\u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1",
  },
  "Batticaloa - Thirukkondiadimadu - Trincomalee Highway, Oddamavadi": {
    si: "\u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 - \u0dad\u0dd2\u0dbb\u0dd4\u0d9a\u0dca\u0d9a\u0ddc\u0dab\u0dca\u0da9\u0dd2\u0dba\u0dcf\u0da9\u0dd2\u0db8\u0da9\u0dd4 - \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0d94\u0da9\u0dca\u0da9\u0db8\u0dcf\u0dc0\u0da9\u0dd2",
    ta: "\u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcd\u0b95\u0bca\u0ba3\u0bcd\u0b9f\u0bbf\u0baf\u0b9f\u0bbf\u0bae\u0b9f\u0bc1 - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0b93\u0b9f\u0bcd\u0b9f\u0bae\u0bbe\u0bb5\u0b9f\u0bbf",
  },
  "Batticaloa Rd, Kalmunai": {
    si: "\u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda",
    ta: "\u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8",
  },
  "Batticaloa Rd, Karaitivu": {
    si: "\u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0d9a\u0dbb\u0dd9\u0dba\u0dd2\u0dad\u0dd2\u0dc0\u0dca",
    ta: "\u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bbe\u0bb0\u0bc8\u0ba4\u0bc0\u0bb5\u0bc1",
  },
  "Batticaloa Rd, Sainthamaruthu": {
    si: "\u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0dc3\u0dba\u0dd2\u0db1\u0dca\u0daf\u0db8\u0dbb\u0dd4\u0daf\u0dd4",
    ta: "\u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b9a\u0bbe\u0baf\u0bcd\u0ba8\u0bcd\u0ba4\u0bae\u0bb0\u0bc1\u0ba4\u0bc1",
  },
  Batuwatte: {
    si: "\u0db6\u0da7\u0dd4\u0dc0\u0dad\u0dca\u0dad",
    ta: "\u0baa\u0b9f\u0bc1\u0bb5\u0ba4\u0bcd\u0ba4",
  },
  "Bazaar St, Vavuniya": {
    si: "\u0db6\u0dc3\u0dcf\u0dbb\u0dca \u0dc1\u0dcf\u0db1\u0dca\u0dad, \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0",
    ta: "\u0baa\u0b9c\u0bbe\u0bb0\u0bcd \u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd, \u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe",
  },
  "Beach Road, Point Pedro": {
    si: "\u0db6\u0dd3\u0da0\u0dca \u0db4\u0dcf\u0dbb, \u0db4\u0dda\u0daf\u0dd4\u0dbb\u0dd4\u0dad\u0dd4\u0da9\u0dd4\u0dc0",
    ta: "\u0baa\u0bc0\u0b9a\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1, \u0baa\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  "Belek Kade Junction Bus Stop, Dehiwala-Mount Lavinia": {
    si: "\u0db6\u0dd9\u0dbd\u0dd9\u0d9a\u0dca \u0d9a\u0da9\u0dda \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd - \u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3",
    ta: "\u0baa\u0bc6\u0bb2\u0b95\u0bcd \u0b95\u0b9f\u0bc7 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8-\u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8",
  },
  "Belek Kade Junction Bus Stop, RV7H+PVJ, Dehiwala-Mount Lavinia, Sri Lanka": {
    si: "\u0db6\u0dd9\u0dbd\u0dd9\u0d9a\u0dca \u0d9a\u0da9\u0dda \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, RV7H+PVJ, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd-\u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bc6\u0bb2\u0bc6\u0b95\u0bcd \u0b95\u0b9f\u0bc7 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, RV7H+PVJ, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8-\u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Beliatta: {
    si: "\u0db6\u0dd9\u0dbd\u0dd2\u0d85\u0dad\u0dca\u0dad",
    ta: "\u0baa\u0bc6\u0bb2\u0bbf\u0baf\u0b9f\u0bcd\u0b9f\u0bbe",
  },
  Belihuloya: {
    si: "\u0db6\u0dd9\u0dbd\u0dd2\u0dc4\u0dd4\u0dbd\u0dca\u0d94\u0dba",
    ta: "\u0baa\u0bc6\u0bb2\u0bbf\u0bb9\u0bc1\u0bb2\u0bcb\u0baf\u0bbe",
  },
  "Bellapitiya,Aguruwathota": {
    si: "\u0db6\u0dd9\u0dbd\u0dca\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0d85\u0d9c\u0dd4\u0dbb\u0dd4\u0dc0\u0dcf\u0dad\u0ddc\u0da7",
    ta: "\u0baa\u0bc6\u0bb2\u0bcd\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b85\u0b95\u0bc1\u0bb0\u0bc1\u0bb5\u0ba4\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f",
  },
  Bemmulla: {
    si: "\u0db6\u0dd9\u0db8\u0dca\u0db8\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0baa\u0bc6\u0bae\u0bcd\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe",
  },
  "Beragama Road, Ambalantota": {
    si: "\u0db6\u0dd9\u0dbb\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0dad\u0ddc\u0da7",
    ta: "\u0baa\u0bc6\u0bb0\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8",
  },
  Beruwala: {
    si: "\u0db6\u0dda\u0dbb\u0dd4\u0dc0\u0dbd",
    ta: "\u0baa\u0bc7\u0bb0\u0bc1\u0bb5\u0bb3\u0bc8",
  },
  Betticalow: {
    si: "\u0db6\u0dd9\u0da7\u0dd2\u0d9a\u0dbd\u0dc0\u0dca",
    ta: "\u0baa\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bcd\u0b95\u0bb2\u0bbe\u0bb5\u0bcd",
  },
  Bibile: {
    si: "\u0db6\u0dd2\u0db6\u0dd2\u0dbd\u0dda",
    ta: "\u0baa\u0bbf\u0baa\u0bbf\u0bb2\u0bc7",
  },
  "Bibile - Medagama - Nakkala Rd Medagama": {
    si: "\u0db6\u0dd2\u0db6\u0dd2\u0dbd - \u0db8\u0dd0\u0daf\u0d9c\u0db8 - \u0db1\u0d9a\u0dca\u0d9a\u0dbd \u0db4\u0dcf\u0dbb \u0db8\u0dd0\u0daf\u0d9c\u0db8",
    ta: "Bibile - Medagama - Nakkala Rd Medagama",
  },
  "Bibile-uraniya-mahiyangana Rd, Mahiyanganaya": {
    si: "Bibile-uraniya-mahiyangana \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1\u0dba",
    ta: "Bibile-uraniya-mahiyangana Rd, Mahiyangana",
  },
  "Bogahagoda Fuel Station, A17,akuressa Rd - Bogahagoda-Imaduwa": {
    si: "\u0db6\u0ddd\u0d9c\u0dc4\u0d9c\u0ddc\u0da9 \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, A17, \u0d85\u0d9a\u0dd4\u0dbb\u0dd0\u0dc3\u0dca\u0dc3 \u0db4\u0dcf\u0dbb - \u0db6\u0ddd\u0d9c\u0dc4\u0d9c\u0ddc\u0da9-\u0d89\u0db8\u0daf\u0dd4\u0dc0",
    ta: "\u0baa\u0bcb\u0b95\u0bb9\u0bbe\u0b95\u0bca\u0b9f \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, A17, \u0b85\u0b95\u0bcd\u0b95\u0bc1\u0bb0\u0bb8\u0bcd\u0bb8 \u0bb5\u0bc0\u0ba4\u0bbf - \u0baa\u0bcb\u0b95\u0bb9\u0bbe\u0b95\u0bca\u0b9f-\u0b87\u0bae\u0ba4\u0bc1\u0bb5",
  },
  "Bogas Handiya, Sri Lanka": {
    si: "\u0db6\u0ddd\u0d9c\u0dc3\u0dca \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bcb\u0b95\u0bb8\u0bcd \u0bb9\u0ba3\u0bcd\u0b9f\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Bogaswewa, Ikirigollewa": {
    si: "\u0db6\u0ddd\u0d9c\u0dc3\u0dca\u0dc0\u0dd0\u0dc0, \u0d89\u0d9a\u0dd2\u0dbb\u0dd2\u0d9c\u0ddc\u0dbd\u0dca\u0dbd\u0dd1\u0dc0",
    ta: "\u0baa\u0bcb\u0b95\u0bb8\u0bcd\u0bb5\u0bc6\u0bb5, \u0b87\u0b95\u0bbf\u0bb0\u0bbf\u0b95\u0bca\u0bb2\u0bcd\u0bb2\u0bc7\u0bb5",
  },
  Bokkawala: {
    si: "Bokkawala",
    ta: "Bokkawala",
  },
  Bolana: {
    si: "\u0db6\u0ddc\u0dbd\u0dcf\u0db1\u0dcf",
    ta: "\u0baa\u0bcb\u0bb2\u0ba9\u0bbe",
  },
  "Bollatha Church, Ja-Ela, Sri Lanka": {
    si: "\u0db6\u0ddc\u0dbd\u0dca\u0dbd\u0dad \u0db4\u0dbd\u0dca\u0dbd\u0dd2\u0dba, \u0da2\u0dcf-\u0d87\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bca\u0bb2\u0bcd\u0bb2\u0bbe\u0ba4\u0bbe \u0ba4\u0bc7\u0bb5\u0bbe\u0bb2\u0baf\u0bae\u0bcd, \u0b9c\u0bbe-\u0b8e\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Boossa: {
    si: "\u0db6\u0dd6\u0dc3\u0dca\u0dc3",
    ta: "\u0baa\u0bc2\u0bb8\u0bcd\u0bb8\u0bbe",
  },
  "Bop 400, Somawathiya Rd, Pulastigama": {
    si: "\u0db6\u0ddc\u0db4\u0dca 400, \u0dc3\u0ddd\u0db8\u0dcf\u0dc0\u0dad\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db4\u0dd4\u0dbd\u0dc3\u0dca\u0dad\u0dd2\u0d9c\u0db8",
    ta: "\u0baa\u0bca\u0baa\u0bcd 400, \u0b9a\u0bcb\u0bae\u0bbe\u0bb5\u0ba4\u0bbf\u0baf\u0bbe \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc1\u0bb2\u0bb8\u0bcd\u0ba4\u0bbf\u0b95\u0bae",
  },
  "Borella Rd, Athurugiriya Rd": {
    si: "\u0db6\u0ddc\u0dbb\u0dd0\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d85\u0dad\u0dd4\u0dbb\u0dd4\u0d9c\u0dd2\u0dbb\u0dd2\u0dba \u0db4\u0dcf\u0dbb",
    ta: "\u0baa\u0bca\u0bb0\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0ba4\u0bc1\u0bb0\u0bc1\u0b95\u0bbf\u0bb0\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  "Borella Rd, Athurugiriya Rd, Sri Lanka": {
    si: "\u0db6\u0ddc\u0dbb\u0dd0\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d85\u0dad\u0dd4\u0dbb\u0dd4\u0d9c\u0dd2\u0dbb\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bca\u0bb0\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0ba4\u0bc1\u0bb0\u0bc1\u0b95\u0bbf\u0bb0\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Browns Show Room, D.S. Senanayake Street, Ampara": {
    si: "Browns Show Room, D.S. \u0dc3\u0dda\u0db1\u0dcf\u0db1\u0dcf\u0dba\u0d9a \u0dc0\u0dd3\u0daf\u0dd2\u0dba, \u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb",
    ta: "\u0baa\u0bbf\u0bb0\u0bb5\u0bc1\u0ba9\u0bcd\u0bb8\u0bcd \u0bb7\u0bcb \u0bb0\u0bc2\u0bae\u0bcd, \u0b9f\u0bbf.\u0b8e\u0bb8\u0bcd. \u0b9a\u0bc7\u0ba9\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0ba4\u0bc6\u0bb0\u0bc1, \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8",
  },
  Bulathkohupitiya: {
    si: "\u0db6\u0dd4\u0dbd\u0dad\u0dca\u0d9a\u0ddc\u0dc4\u0dd4\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0baa\u0bc1\u0bb2\u0ba4\u0bcd\u0b95\u0bca\u0bb9\u0bc1\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  Bulnewa: {
    si: "\u0db6\u0dd4\u0dbd\u0dca\u0db1\u0dd1\u0dc0",
    ta: "\u0baa\u0bc1\u0bb2\u0bcd\u0ba9\u0bc7\u0bb5\u0bbe",
  },
  "Bus Stop, Colombo 01000, Sri Lanka": {
    si: "\u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0d9a\u0ddc\u0dc5\u0db9 01000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 01000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Bus Stop, Dandugama, Sri Lanka": {
    si: "\u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0daf\u0dac\u0dd4\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0ba4\u0ba3\u0bcd\u0b9f\u0bc1\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Bus Stop, Hanwella": {
    si: "\u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0dc4\u0d82\u0dc0\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0baa\u0bb8\u0bcd \u0bb8\u0bcd\u0b9f\u0bbe\u0baa\u0bcd, \u0bb9\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2",
  },
  "Bus Stop, Kadawatha, Sri Lanka": {
    si: "\u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0d9a\u0da9\u0dc0\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0b95\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Bus Stop, Moratuwa, Sri Lanka": {
    si: "\u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0bae\u0bca\u0bb0\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Bus Stop, Polgasowita, Sri Lanka": {
    si: "\u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0db4\u0ddc\u0dbd\u0dca\u0d9c\u0dc3\u0dca\u0d95\u0dc0\u0dd2\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0baa\u0bca\u0bb2\u0bcd\u0b95\u0b9a\u0bcb\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Bus Stop, Ragala, Sri Lanka": {
    si: "\u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0dbb\u0dcf\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0bb0\u0bbe\u0b95\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Bus Stop, Sri Lanka": {
    si: "\u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Bus Stop, Talawa, Sri Lanka": {
    si: "\u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0dad\u0dbd\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0ba4\u0bb2\u0bc8\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Buttala: {
    si: "\u0db6\u0dd4\u0dad\u0dca\u0dad\u0dbd",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb2",
  },
  "C & A FILLING STATION (PVT)  LTD": {
    si: "C & A \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd (PVT) LTD",
    ta: "\u0b9a\u0bbf & \u0b8f \u0b83\u0baa\u0bbf\u0bb2\u0bcd\u0bb2\u0bbf\u0b99\u0bcd \u0bb8\u0bcd\u0b9f\u0bc7\u0bb7\u0ba9\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "C B HALITH": {
    si: "\u0dc3\u0dd3 \u0db6\u0dd3 \u0dc4\u0dbd\u0dd2\u0dad\u0dca",
    ta: "\u0b9a\u0bbf \u0baa\u0bbf \u0bb9\u0bb2\u0bbf\u0ba4\u0bcd",
  },
  "C J ABEYRATNE": {
    si: "\u0dc3\u0dd3 \u0da2\u0dda \u0d85\u0db6\u0dda\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b9a\u0bbf \u0b9c\u0bc7 \u0b85\u0baa\u0bc7\u0bb0\u0ba4\u0bcd\u0ba9\u0bc7",
  },
  "C JAYASINGHE ARACHCHI": {
    si: "\u0dc3\u0dd3 \u0da2\u0dba\u0dc3\u0dd2\u0d82\u0dc4 \u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2",
    ta: "\u0b9a\u0bbf \u0b9c\u0baf\u0b9a\u0bbf\u0b99\u0bcd\u0b95 \u0b86\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf",
  },
  "C K K SENAVIRATNA": {
    si: "\u0dc3\u0dd3 \u0d9a\u0dda \u0d9a\u0dda \u0dc3\u0dd9\u0db1\u0dc0\u0dd2\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b9a\u0bbf \u0b95\u0bc7 \u0b95\u0bc7 \u0b9a\u0bc7\u0ba9\u0bb5\u0bbf\u0bb0\u0ba4\u0bcd\u0ba9\u0bbe",
  },
  "C K RAJAKARUNA": {
    si: "\u0dc3\u0dd3 \u0d9a\u0dda \u0dbb\u0dcf\u0da2\u0d9a\u0dbb\u0dd4\u0dab\u0dcf",
    ta: "\u0b9a\u0bbf \u0b95\u0bc7 \u0bb0\u0bbe\u0b9c\u0b95\u0bb0\u0bc1\u0ba3\u0bbe",
  },
  "C L M ENTERPRISES": {
    si: "\u0dc3\u0dd3 \u0d91\u0dbd\u0dca \u0d91\u0db8\u0dca \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b9a\u0bbf \u0b8e\u0bb2\u0bcd \u0b8e\u0bae\u0bcd \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "C M A K ENTERPRISE INTERNATIONAL(PV": {
    si: "\u0dc3\u0dd3 \u0d91\u0db8\u0dca \u0d92 \u0d9a\u0dda \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dca \u0d89\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db1\u0dd0\u0dc2\u0db1\u0dbd\u0dca (\u0db4\u0dd3\u0dc0\u0dd3",
    ta: "\u0b9a\u0bbf \u0b8e\u0bae\u0bcd \u0b8f \u0b95\u0bc7 \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0bb8\u0bcd \u0b87\u0ba9\u0bcd\u0b9f\u0bb0\u0bcd\u0ba8\u0bc7\u0bb7\u0ba9\u0bb2\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf",
  },
  "C N KAPURUGE": {
    si: "\u0dc3\u0dd3 \u0d91\u0db1\u0dca \u0d9a\u0db4\u0dd4\u0dbb\u0dd4\u0d9c\u0dda",
    ta: "\u0b9a\u0bbf \u0b8e\u0ba9\u0bcd \u0b95\u0baa\u0bc1\u0bb0\u0bc1\u0b95\u0bc7",
  },
  "C P ABDULLA & SONS": {
    si: "\u0dc3\u0dd3\u0db4\u0dd3 \u0d85\u0db6\u0dca\u0daf\u0dd4\u0dbd\u0dca\u0dbd\u0dcf \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b9a\u0bbf\u0baa\u0bbf \u0b85\u0baa\u0bcd\u0ba4\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "C P D.FERNANDO": {
    si: "\u0dc3\u0dd3 \u0db4\u0dd3 \u0da9\u0dd3 \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0b9a\u0bbf \u0baa\u0bbf \u0b9f\u0bbf.\u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "C P MOHAMED & SONS": {
    si: "\u0dc3\u0dd3\u0db4\u0dd3 \u0db8\u0ddc\u0dc4\u0ddc\u0db8\u0da9\u0dca \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b9a\u0bbf\u0baa\u0bbf \u0bae\u0bc1\u0b95\u0bae\u0ba4\u0bc1 & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "C S MUNASINGHE": {
    si: "\u0dc3\u0dd3 \u0d91\u0dc3\u0dca \u0db8\u0dd4\u0dab\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b9a\u0bbf \u0b8e\u0bb8\u0bcd \u0bae\u0bc1\u0ba9\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "C S R ARACHCHI": {
    si: "\u0dc3\u0dd3 \u0d91\u0dc3\u0dca \u0d86\u0dbb\u0dca \u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2",
    ta: "\u0b9a\u0bbf \u0b8e\u0bb8\u0bcd \u0b86\u0bb0\u0bcd \u0b86\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf",
  },
  "C.F.DE MEL & SONS (PVT) LTD": {
    si: "C.F.DE MEL & SONS (PVT) LTD",
    ta: "C.F.DE MEL & SONS (PVT) LTD",
  },
  "C.H.W.SENEVIRATNE": {
    si: "\u0dc3\u0dd3.\u0d91\u0da0\u0dca.\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0dc3\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b9a\u0bbf.\u0b8e\u0b9a\u0bcd.\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0b9a\u0bc6\u0ba9\u0bb5\u0bbf\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "C.J.P.ENTERPRISES (PVT) LTD": {
    si: "C.J.P.ENTERPRISES (PVT) LTD",
    ta: "C.J.P.ENTERPRISES (PVT) LTD",
  },
  "C.K.GONZAGA": {
    si: "\u0dc3\u0dd3.\u0d9a\u0dda.\u0d9c\u0ddc\u0db1\u0dca\u0dc3\u0dcf\u0d9c\u0dcf",
    ta: "\u0b9a\u0bbf.\u0b95\u0bc7.\u0b95\u0bcb\u0ba9\u0bcd\u0b9a\u0bbe\u0b95\u0bbe",
  },
  "C.K.WARUSAVITHANA & COMPANY (PVT) L": {
    si: "\u0dc3\u0dd3.\u0d9a\u0dda.\u0dc0\u0dbb\u0dd4\u0dc3\u0dc0\u0dd2\u0dad\u0dcf\u0db1 \u0dc3\u0dc4 \u0dc3\u0db8\u0dcf\u0d9c\u0db8 (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0d91\u0dbd\u0dca",
    ta: "\u0b9a\u0bbf.\u0b95\u0bc7.\u0bb5\u0bb0\u0bc1\u0b9a\u0bb5\u0bbf\u0ba4\u0bbe\u0ba9\u0bbe & \u0b95\u0bae\u0bcd\u0baa\u0bc6\u0ba9\u0bbf (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0b8e\u0bb2\u0bcd",
  },
  "C.KURUPPUARACHCHI": {
    si: "\u0dc3\u0dd3.\u0d9a\u0dd4\u0dbb\u0dd4\u0db4\u0dca\u0db4\u0dd4\u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2",
    ta: "\u0b9a\u0bbf.\u0b95\u0bc1\u0bb0\u0bc1\u0baa\u0bcd\u0baa\u0bc1\u0b86\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf",
  },
  "C.M.H.ENTERPRISES": {
    si: "\u0dc3\u0dd3.\u0d91\u0db8\u0dca.\u0d91\u0da0\u0dca.\u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b9a\u0bbf.\u0b8e\u0bae\u0bcd.\u0b8e\u0b9a\u0bcd.\u0b8e\u0ba9\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "C.PARAMANATHA": {
    si: "\u0dc3\u0dd3.\u0db4\u0dbb\u0db8\u0db1\u0dcf\u0dae",
    ta: "\u0b9a\u0bbf.\u0baa\u0bb0\u0bae\u0ba8\u0bbe\u0ba4",
  },
  "C.VETHANAYAKI": {
    si: "\u0dc3\u0dd3.\u0dc0\u0dda\u0dad\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b9a\u0bbf.\u0bb5\u0bc7\u0ba4\u0ba8\u0bbe\u0baf\u0b95\u0bbf",
  },
  "C.WEERAKONE": {
    si: "\u0dc3\u0dd3.\u0dc0\u0dd3\u0dbb\u0d9a\u0ddd\u0db1\u0dca",
    ta: "\u0b9a\u0bbf.\u0bb5\u0bc0\u0bb0\u0b95\u0bcb\u0ba9\u0bcd",
  },
  "C2R8+GVW, Dharga Town, Sri Lanka": {
    si: "C2R8+GVW, \u0daf\u0dbb\u0dca\u0d9c\u0dcf \u0db1\u0d9c\u0dbb\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "C2R8+GVW, \u0ba4\u0bb0\u0bcd\u0b95\u0bbe \u0b9f\u0bb5\u0bc1\u0ba9\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "C3FP+RFW, Sri Lanka": {
    si: "C3FP+RFW, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "C3FP+RFW, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "C3HQ+M76, Ittapane, Sri Lanka": {
    si: "C3HQ+M76, \u0d89\u0dad\u0dca\u0dad\u0db4\u0db1\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "C3HQ+M76, \u0b87\u0b9f\u0bcd\u0b9f\u0baa\u0bcd\u0baa\u0ba9\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "C4PJ+4CP, Thanamalwila, Sri Lanka": {
    si: "C4PJ+4CP, \u0dad\u0dab\u0db8\u0dbd\u0dca\u0dc0\u0dd2\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "C4PJ+4CP, \u0ba4\u0ba9\u0bae\u0bb2\u0bcd\u0bb5\u0bbf\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "C639+Q22, Pelawatta, Sri Lanka": {
    si: "C639+Q22, \u0db4\u0dd0\u0dbd\u0dc0\u0dad\u0dca\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "C639+Q22, \u0baa\u0bc6\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "C6J7+VW5, Narammala, Sri Lanka": {
    si: "C6J7+VW5, \u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "C6J7+VW5, \u0ba8\u0bbe\u0bb0\u0bae\u0bcd\u0bae\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "C6PC+8GW, Kurunegala-Narammala-Madampe Rd, Narammala, Sri Lanka": {
    si: "C6PC+8GW, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd-\u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd-\u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda \u0db4\u0dcf\u0dbb, \u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "C6PC+8GW, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd-\u0ba8\u0bbe\u0bb0\u0bae\u0bcd\u0bae\u0bb2-\u0bae\u0b9f\u0bae\u0bcd\u0baa\u0bc7 \u0b9a\u0bbe\u0bb2\u0bc8, \u0ba8\u0bbe\u0bb0\u0bae\u0bcd\u0bae\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "C7R6+FXV, Trincomalee Hwy, Mutur, Sri Lanka": {
    si: "C7R6+FXV, Trincomalee Hwy, Mutur, Sri Lanka",
    ta: "C7R6+FXV, Trincomalee Hwy, Mutur, Sri Lanka",
  },
  "C86G+4CW, Pothuhera, Sri Lanka": {
    si: "C86G+4CW, \u0db4\u0ddc\u0dad\u0dd4\u0dc4\u0dd0\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "C86G+4CW, Pothuhera, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "C87J+CP6, Kandula Pl, Kataragama, Sri Lanka": {
    si: "C87J+CP6, Kandula Pl, \u0d9a\u0dad\u0dbb\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "C87J+CP6, Kandula Pl, \u0b95\u0ba4\u0bbf\u0bb0\u0bcd\u0b95\u0bbe\u0bae\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "C88F+RQ9, Kandasuridugama Raja Mawatha, Kataragama, Sri Lanka": {
    si: "C88F+RQ9, \u0d9a\u0db3\u0dc3\u0dd4\u0dbb\u0dd2\u0daf\u0dd4\u0d9c\u0db8 \u0dbb\u0da2 \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0dad\u0dbb\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "C88F+RQ9, \u0b95\u0ba8\u0bcd\u0ba4\u0b9a\u0bc1\u0bb0\u0bbf\u0b9f\u0bc1\u0b95\u0bae \u0bb0\u0bbe\u0b9c\u0bbe \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0ba4\u0bbf\u0bb0\u0bcd\u0b95\u0bbe\u0bae\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "C8CH+8C4, 41 Colombo Road, Pothuhera, Sri Lanka": {
    si: "C8CH+8C4, 41 \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0db4\u0ddc\u0dad\u0dd4\u0dc4\u0dd0\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "C8CH+8C4, 41 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0bca\u0ba4\u0bcd\u0ba4\u0bc1\u0bb9\u0bc6\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CADILLAC FILLING STATION (PVT) LTD.": {
    si: "\u0d9a\u0dd0\u0da9\u0dd2\u0dbd\u0dd0\u0d9a\u0dca \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca.",
    ta: "\u0b95\u0bbe\u0b9f\u0bbf\u0bb2\u0bbe\u0b95\u0bcd \u0b83\u0baa\u0bbf\u0bb2\u0bcd\u0bb2\u0bbf\u0b99\u0bcd \u0bb8\u0bcd\u0b9f\u0bc7\u0bb7\u0ba9\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd.",
  },
  "CAFFOOR & CO": {
    si: "CAFFOOR \u0dc3\u0dc4 CO",
    ta: "CAFFOOR & CO",
  },
  "CANCEL-AGALAWATTA MPCS LTD": {
    si: "\u0d85\u0dc0\u0dbd\u0d82\u0d9c\u0dd4 \u0d9a\u0dbb\u0db1\u0dca\u0db1-\u0d85\u0d9c\u0dbd\u0dc0\u0dad\u0dca\u0dad MPCS LTD",
    ta: "\u0bb0\u0ba4\u0bcd\u0ba4\u0bc1-\u0b85\u0b95\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4 MPCS LTD",
  },
  "CANCEL-MS.  MANSOOR JAINUL ABDEEN": {
    si: "\u0d85\u0dc0\u0dbd\u0d82\u0d9c\u0dd4 \u0d9a\u0dbb\u0db1\u0dca\u0db1-MS. \u0db8\u0db1\u0dca\u0dc3\u0dd6\u0dbb\u0dca \u0da2\u0ddb\u0db1\u0dd4\u0dbd\u0dca \u0d86\u0db6\u0dca\u0daf\u0dd3\u0db1\u0dca",
    ta: "\u0bb0\u0ba4\u0bcd\u0ba4\u0bc1-\u0b8e\u0bae\u0bcd.\u0b8e\u0bb8\u0bcd. \u0bae\u0ba9\u0bcd\u0b9a\u0bc2\u0bb0\u0bcd \u0b9c\u0bc8\u0ba9\u0bc1\u0bb2\u0bcd \u0b86\u0baa\u0bcd\u0ba4\u0bc0\u0ba9\u0bcd",
  },
  "CANCEL-MS.GURUNAGAR FISHING": {
    si: "\u0d85\u0dc0\u0dbd\u0d82\u0d9c\u0dd4 \u0d9a\u0dbb\u0db1\u0dca\u0db1-MS.\u0d9c\u0dd4\u0dbb\u0dd4\u0db1\u0d9c\u0dbb\u0dca \u0db8\u0dc3\u0dd4\u0db1\u0dca \u0d87\u0dbd\u0dca\u0dbd\u0dd3\u0db8",
    ta: "\u0bb0\u0ba4\u0bcd\u0ba4\u0bc1-\u0b8e\u0bae\u0bcd.\u0b8e\u0bb8\u0bcd.\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0b95\u0bb0\u0bcd \u0bae\u0bc0\u0ba9\u0bcd\u0baa\u0bbf\u0b9f\u0bbf\u0ba4\u0bcd\u0ba4\u0bb2\u0bcd",
  },
  "CCG5+F5 Paranthan town-Kn/44, Sri Lanka": {
    si: "CCG5+F5 \u0db4\u0dbb\u0db1\u0dca\u0dad\u0db1\u0dca \u0db1\u0d9c\u0dbb\u0dba-Kn/44, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CCG5+F5 \u0baa\u0bb0\u0ba8\u0bcd\u0ba4\u0ba9\u0bcd \u0ba8\u0b95\u0bb0\u0bae\u0bcd-Kn/44, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CCMV+GJ3, Katugastota-Kurunegala-Puttalam Highway, Mawathagama, Sri Lanka": {
    si: "CCMV+GJ3, \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7-\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd-\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0db8\u0dcf\u0dc0\u0dad\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CCMV+GJ3, \u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8-\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd-\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CCP5+H4X, Parantan-Mullaitivu Hwy, Parantan, Sri Lanka": {
    si: "CCP5+H4X, \u0db4\u0dbb\u0db1\u0dca\u0dad\u0db1\u0dca-\u0db8\u0dd4\u0dbd\u0dad\u0dd2\u0dc0\u0dca Hwy, \u0db4\u0dbb\u0db1\u0dca\u0dad\u0db1\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CCP5+H4X, \u0baa\u0bb0\u0ba8\u0bcd\u0ba4\u0ba9\u0bcd-\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bc8\u0ba4\u0bcd\u0ba4\u0bc0\u0bb5\u0bc1 Hwy, \u0baa\u0bb0\u0ba8\u0bcd\u0ba4\u0ba9\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CENTRAL AGENCY": {
    si: "\u0db8\u0db0\u0dca\u0dba\u0db8 \u0db1\u0dd2\u0dba\u0ddd\u0da2\u0dd2\u0dad\u0dcf\u0dba\u0dad\u0db1\u0dba",
    ta: "\u0bae\u0ba4\u0bcd\u0ba4\u0bbf\u0baf \u0b8f\u0b9c\u0bc6\u0ba9\u0bcd\u0b9a\u0bbf",
  },
  "CEYLON FISHERIES CORPORATION": {
    si: "\u0dc3\u0dd2\u0dbd\u0ddd\u0db1\u0dca \u0dc6\u0dd2\u0dc2\u0dbb\u0dd3\u0dc3\u0dca \u0d9a\u0ddd\u0db4\u0dbb\u0dda\u0dc2\u0db1\u0dca",
    ta: "\u0b9a\u0bbf\u0bb2\u0bcb\u0ba9\u0bcd \u0b83\u0baa\u0bbf\u0bb7\u0bb0\u0bc0\u0bb8\u0bcd \u0b95\u0bbe\u0bb0\u0bcd\u0baa\u0bcd\u0baa\u0bb0\u0bc7\u0bb7\u0ba9\u0bcd",
  },
  "CEYLON FISHERIES HARBOUR CORPORATIO": {
    si: "\u0dc3\u0dd2\u0dbd\u0ddd\u0db1\u0dca \u0dc6\u0dd2\u0dc2\u0dbb\u0dd3\u0dc3\u0dca \u0dc4\u0dcf\u0db6\u0dbb\u0dca \u0d9a\u0ddd\u0db4\u0dbb\u0dda\u0dc2\u0db1\u0dca",
    ta: "\u0b9a\u0bbf\u0bb2\u0bcb\u0ba9\u0bcd \u0b83\u0baa\u0bbf\u0bb7\u0bb0\u0bc0\u0bb8\u0bcd \u0bb9\u0bbe\u0bb0\u0bcd\u0baa\u0bb0\u0bcd \u0b95\u0bbe\u0bb0\u0bcd\u0baa\u0bcd\u0baa\u0bb0\u0bc7\u0bb7\u0bbf\u0baf\u0bcb",
  },
  "CEYLON FISHERIES HARBOURS CORPORAT.": {
    si: "\u0dc3\u0dd2\u0dbd\u0ddd\u0db1\u0dca \u0dc6\u0dd2\u0dc2\u0dbb\u0dd3\u0dc3\u0dca \u0dc4\u0dcf\u0dbb\u0dca\u0db6\u0dbb\u0dca\u0dc3\u0dca \u0d9a\u0ddd\u0db4\u0dbb\u0dda\u0da7\u0dca.",
    ta: "\u0b9a\u0bbf\u0bb2\u0bcb\u0ba9\u0bcd \u0b83\u0baa\u0bbf\u0bb7\u0bb0\u0bc0\u0bb8\u0bcd \u0bb9\u0bbe\u0bb0\u0bcd\u0baa\u0bb0\u0bcd\u0bb8\u0bcd \u0b95\u0bbe\u0bb0\u0bcd\u0baa\u0bcd\u0baa\u0bb0\u0bc7\u0b9f\u0bcd.",
  },
  "CEYLON FISHERY HARBOUR CORPORATION": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db0\u0dd3\u0dc0\u0dbb \u0dc0\u0dbb\u0dcf\u0dba \u0dc3\u0d82\u0dc3\u0dca\u0dae\u0dcf\u0dc0",
    ta: "\u0b9a\u0bbf\u0bb2\u0bcb\u0ba9\u0bcd \u0b83\u0baa\u0bbf\u0bb7\u0bb0\u0bbf \u0bb9\u0bbe\u0bb0\u0bcd\u0baa\u0bb0\u0bcd \u0b95\u0bbe\u0bb0\u0bcd\u0baa\u0bcd\u0baa\u0bb0\u0bc7\u0bb7\u0ba9\u0bcd",
  },
  "CEYLON FISHERY HARBOURS CORP.": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db0\u0dd3\u0dc0\u0dbb \u0dc0\u0dbb\u0dcf\u0dba \u0dc3\u0d82\u0dc3\u0dca\u0dae\u0dcf\u0dc0.",
    ta: "\u0b9a\u0bbf\u0bb2\u0bcb\u0ba9\u0bcd \u0b83\u0baa\u0bbf\u0bb7\u0bb0\u0bbf \u0bb9\u0bbe\u0bb0\u0bcd\u0baa\u0bb0\u0bcd\u0bb8\u0bcd \u0b95\u0bbe\u0bb0\u0bcd\u0baa\u0bcd.",
  },
  "CEYLON FISHERY HARBOURS CORPORATION": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db0\u0dd3\u0dc0\u0dbb \u0dc0\u0dbb\u0dcf\u0dba \u0dc3\u0d82\u0dc3\u0dca\u0dae\u0dcf\u0dc0",
    ta: "\u0b9a\u0bbf\u0bb2\u0bcb\u0ba9\u0bcd \u0b83\u0baa\u0bbf\u0bb7\u0bb0\u0bbf \u0bb9\u0bbe\u0bb0\u0bcd\u0baa\u0bb0\u0bcd\u0bb8\u0bcd \u0b95\u0bbe\u0bb0\u0bcd\u0baa\u0bcd\u0baa\u0bb0\u0bc7\u0bb7\u0ba9\u0bcd",
  },
  "CEYLON TRANSPORT BOARD": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0d9c\u0db8\u0db1\u0dcf\u0d9c\u0db8\u0db1 \u0db8\u0dab\u0dca\u0da9\u0dbd\u0dba",
    ta: "\u0b9a\u0bbf\u0bb2\u0bcb\u0ba9\u0bcd \u0baa\u0bcb\u0b95\u0bcd\u0b95\u0bc1\u0bb5\u0bb0\u0ba4\u0bcd\u0ba4\u0bc1 \u0bb5\u0bbe\u0bb0\u0bbf\u0baf\u0bae\u0bcd",
  },
  "CF8G+6G5, Katugastota - Kurunegala - Puttalam Hwy, Weuda, Sri Lanka": {
    si: "CF8G+6G5, \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 Hwy, Weuda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CF8G+6G5, \u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd Hwy, Weuda, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CHAMARA SANDARUWAN RANAWEERA ARACHC": {
    si: "\u0da0\u0dcf\u0db8\u0dbb \u0dc3\u0db3\u0dbb\u0dd4\u0dc0\u0db1\u0dca \u0dbb\u0dab\u0dc0\u0dd3\u0dbb \u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2",
    ta: "\u0b9a\u0bbe\u0bae\u0bb0 \u0b9a\u0ba3\u0bcd\u0b9f\u0bb0\u0bc1\u0bb5\u0ba9\u0bcd \u0bb0\u0ba3\u0bb5\u0bc0\u0bb0 \u0b86\u0bb0\u0bbe\u0b9a\u0bcd",
  },
  "CHANDANA FILLING STATION": {
    si: "\u0da0\u0db1\u0dca\u0daf\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b9a\u0ba8\u0bcd\u0ba4\u0ba9\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "CHANDANI DHAMMEARACHCHI  MRS. D A": {
    si: "\u0da0\u0dcf\u0db1\u0dca\u0daf\u0db1\u0dd3 \u0db0\u0db8\u0dca\u0db8\u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2 \u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba. \u0da9\u0dd3 \u0d92",
    ta: "\u0b9a\u0bbe\u0ba8\u0bcd\u0ba4\u0ba9\u0bbf \u0ba4\u0bae\u0bcd\u0bae\u0bc7\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf \u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf. \u0b9f\u0bbf \u0b8f",
  },
  "CHANDRASENA  R A": {
    si: "\u0da0\u0db1\u0dca\u0daf\u0dca\u200d\u0dbb\u0dc3\u0dda\u0db1 \u0d86\u0dbb\u0dca.\u0d92",
    ta: "\u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0b9a\u0bc7\u0ba9 \u0b86\u0bb0\u0bcd.\u0b8f",
  },
  "CHANKANAI MPCS LTD": {
    si: "CHANKANAI MPCS LTD",
    ta: "\u0b9a\u0b99\u0bcd\u0b95\u0ba9\u0bc8 MPCS LTD",
  },
  "CHAVAKACHCHERI MPCS LTD": {
    si: "\u0da0\u0dcf\u0dc0\u0d9a\u0da0\u0dca\u0da0\u0dda\u0dbb\u0dd2 MPCS LTD",
    ta: "\u0b9a\u0bbe\u0bb5\u0b95\u0b9a\u0bcd\u0b9a\u0bc7\u0bb0\u0bbf MPCS LTD",
  },
  "CHG7+4J Galhinna, Sri Lanka": {
    si: "CHG7+4J \u0d9c\u0dbd\u0dca\u0dc4\u0dd2\u0db1\u0dca\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CHG7+4J \u0b95\u0bb2\u0bcd\u0bb9\u0bbf\u0ba9\u0bcd\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CHILAW MPCS LTD": {
    si: "CHILAW MPCS LTD",
    ta: "\u0b9a\u0bbf\u0bb2\u0bbe\u0bb5\u0bcd MPCS LTD",
  },
  "CHUNNAKAM MPCS LTD": {
    si: "\u0da0\u0dd4\u0db1\u0dca\u0db1\u0dcf\u0d9a\u0db8\u0dca MPCS LTD",
    ta: "\u0b9a\u0bc1\u0ba9\u0bcd\u0ba9\u0bbe\u0b95\u0bae\u0bcd MPCS LTD",
  },
  "CIMBA LANKA OIL DISTRIBUTORS (PVT)": {
    si: "\u0dc3\u0dd2\u0db8\u0dca\u0db6 \u0dbd\u0d82\u0d9a\u0dcf \u0d94\u0dba\u0dd2\u0dbd\u0dca \u0da9\u0dd2\u0dc3\u0dca\u0da7\u0dca\u200d\u0dbb\u0dd2\u0db6\u0dd2\u0dba\u0dd4\u0da7\u0dbb\u0dca\u0dc3\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a)",
    ta: "\u0b9a\u0bbf\u0bae\u0bcd\u0baa\u0bbe \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b8e\u0ba3\u0bcd\u0ba3\u0bc6\u0baf\u0bcd \u0bb5\u0bbf\u0ba8\u0bbf\u0baf\u0bcb\u0b95\u0bb8\u0bcd\u0ba4\u0bb0\u0bcd\u0b95\u0bb3\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf)",
  },
  "CITY AUTO SERVICES (PVT) LTD": {
    si: "CITY AUTO SERVICES (PVT) LTD",
    ta: "\u0b9a\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf \u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0b9a\u0bb0\u0bcd\u0bb5\u0bc0\u0b9a\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "CJ55+VMV, Alawatugoda, Sri Lanka": {
    si: "CJ55+VMV, \u0d85\u0dbd\u0dc0\u0dad\u0dd4\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CJ55+VMV, \u0b85\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4\u0bc1\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CJ56+C3Q, Alawatugoda, Sri Lanka": {
    si: "CJ56+C3Q, \u0d85\u0dbd\u0dc0\u0dad\u0dd4\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CJ56+C3Q, \u0b85\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4\u0bc1\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CJGJ+4J8, Ukuwela, Sri Lanka": {
    si: "CJGJ+4J8, \u0d8b\u0d9a\u0dd4\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CJGJ+4J8, Ukuwela, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CJQP+76C, Suriyakanda, Sri Lanka": {
    si: "CJQP+76C, \u0dc3\u0dd6\u0dbb\u0dd2\u0dba\u0d9a\u0db1\u0dca\u0daf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CJQP+76C, \u0b9a\u0bc2\u0bb0\u0bbf\u0baf\u0b95\u0ba8\u0bcd\u0ba4\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CM2R+HH Kolonna, Sri Lanka": {
    si: "CM2R+HH \u0d9a\u0ddc\u0dbd\u0ddc\u0db1\u0dca\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CM2R+HH \u0b95\u0bca\u0bb2\u0bca\u0ba9\u0bcd\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CMGP+445, Kahatagasdigiliya, Sri Lanka": {
    si: "CMGP+445, \u0d9a\u0dc4\u0da7\u0d9c\u0dc3\u0dca\u0daf\u0dd2\u0d9c\u0dd2\u0dbd\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CMGP+445, \u0b95\u0bb9\u0b9f\u0b95\u0bb8\u0bcd\u0ba4\u0bbf\u0b95\u0bbf\u0bb2\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CMGR+R56, Kahatagasdigiliya, Sri Lanka": {
    si: "CMGR+R56, \u0d9a\u0dc4\u0da7\u0d9c\u0dc3\u0dca\u0daf\u0dd2\u0d9c\u0dd2\u0dbd\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CMGR+R56, \u0b95\u0bb9\u0b9f\u0b95\u0bb8\u0bcd\u0ba4\u0bbf\u0b95\u0bbf\u0bb2\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "COLOMBO NORTH REGION TRANSPORT BOAR": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 \u0d8b\u0dad\u0dd4\u0dbb\u0dd4 \u0db4\u0dca\u200d\u0dbb\u0daf\u0dda\u0dc1\u0dba\u0dda \u0db4\u0dca\u200d\u0dbb\u0dc0\u0dcf\u0dc4\u0db1 \u0db6\u0ddd\u0dbb\u0dca",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0b9f\u0b95\u0bcd\u0b95\u0bc1 \u0baa\u0bbf\u0bb0\u0bbe\u0ba8\u0bcd\u0ba4\u0bbf\u0baf \u0baa\u0bcb\u0b95\u0bcd\u0b95\u0bc1\u0bb5\u0bb0\u0ba4\u0bcd\u0ba4\u0bc1 \u0baa\u0ba9\u0bcd\u0bb1\u0bbf",
  },
  "COLOMBO SOUTH COOP. SOCIETY  LTD": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 \u0daf\u0d9a\u0dd4\u0dab\u0dd4 \u0d9a\u0ddd\u0db4\u0dca. SOCIETY LTD",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1 \u0b95\u0bc2\u0b9f\u0bcd\u0b9f\u0bc1\u0bb1\u0bb5\u0bc1. \u0b9a\u0bca\u0b9a\u0bc8\u0b9f\u0bcd\u0b9f\u0bbf \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "COLOMBO SOUTH MPCS LTD": {
    si: "COLOMBO SOUTH MPCS LTD",
    ta: "COLOMBO SOUTH MPCS LTD",
  },
  "COLOMBO SOUTH MPCS LTD.": {
    si: "COLOMBO SOUTH MPCS LTD.",
    ta: "COLOMBO SOUTH MPCS LTD.",
  },
  "COLONNE SARATH": {
    si: "\u0d9a\u0ddc\u0dbd\u0ddc\u0db1\u0dca \u0dc3\u0dbb\u0dad\u0dca",
    ta: "\u0b95\u0bbe\u0bb2\u0ba9\u0bcd \u0b9a\u0bb0\u0ba4\u0bcd",
  },
  "CONSOLIDATED FREIGHTERS & AGEN. LTD": {
    si: "\u0d92\u0d9a\u0dcf\u0db6\u0daf\u0dca\u0db0 \u0db7\u0dcf\u0dab\u0dca\u0da9 \u0db4\u0dca\u200d\u0dbb\u0dc0\u0dcf\u0dc4\u0db1\u0dba \u0dc3\u0dc4 \u0d92\u0da2\u0db1\u0dca. \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b92\u0bb0\u0bc1\u0b99\u0bcd\u0b95\u0bbf\u0ba3\u0bc8\u0ba8\u0bcd\u0ba4 \u0b9a\u0bb0\u0b95\u0bcd\u0b95\u0bc1\u0b95\u0bb3\u0bcd & \u0b8f\u0b9c\u0bc6\u0ba9\u0bcd. LTD",
  },
  "CP8J+QJM, Sri Lanka": {
    si: "CP8J+QJM, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CP8J+QJM, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CQ6W+MMM, Udawalawa, Sri Lanka": {
    si: "CQ6W+MMM, \u0d8b\u0da9\u0dc0\u0dbd\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CQ6W+MMM, \u0b89\u0b9f\u0bb5\u0bb2\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CQ7G+P92, Kalmunai, Sri Lanka": {
    si: "CQ7G+P92, \u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CQ7G+P92, \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CQJC+65P, A18, Sri Lanka": {
    si: "CQJC+65P, A18, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CQJC+65P, A18, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CR7G+9RR, Kalmunai 32300, Sri Lanka": {
    si: "CR7G+9RR, \u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda 32300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CR7G+9RR, \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8 32300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CR7G+JGP, Kalmunai 32300, Sri Lanka": {
    si: "CR7G+JGP, \u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda 32300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CR7G+JGP, \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8 32300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CR7J+F7P, Chilaw - Colombo Main Rd, Marawila, Sri Lanka": {
    si: "CR7J+F7P, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0db8\u0dcf\u0dbb\u0dc0\u0dd2\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CR7J+F7P, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bbe\u0bb0\u0bb5\u0bbf\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CR7J+XQG, Marawila, Sri Lanka": {
    si: "CR7J+XQG, \u0db8\u0dcf\u0dbb\u0dc0\u0dd2\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CR7J+XQG, \u0bae\u0bbe\u0bb0\u0bb5\u0bbf\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CR85+RC9, Kalmunai-Chavalakadai Rd, Kalmunai, Sri Lanka": {
    si: "CR85+RC9, \u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda-\u0da0\u0dc0\u0dbd\u0d9a\u0da9\u0dba\u0dd2 \u0db4\u0dcf\u0dbb, \u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CR85+RC9, \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8-\u0b9a\u0bb5\u0bb3\u0b95\u0bcd\u0b95\u0b9f\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CRCJ+43X, Chilaw - Colombo Main Rd, Marawila, Sri Lanka": {
    si: "CRCJ+43X, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0db8\u0dcf\u0dbb\u0dc0\u0dd2\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CRCJ+43X, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bbe\u0bb0\u0bb5\u0bbf\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "CRIS HARIS GASLINE PARK": {
    si: "\u0d9a\u0dca\u200d\u0dbb\u0dd2\u0dc3\u0dca \u0dc4\u0dd0\u0dbb\u0dd2\u0dc3\u0dca \u0d9c\u0dd1\u0dc3\u0dca\u0dbd\u0dba\u0dd2\u0db1\u0dca \u0d8b\u0daf\u0dca\u200d\u0dba\u0dcf\u0db1\u0dba",
    ta: "\u0b95\u0bbf\u0bb0\u0bbf\u0bb8\u0bcd \u0bb9\u0bbe\u0bb0\u0bbf\u0bb8\u0bcd \u0b95\u0bc7\u0bb8\u0bcd\u0bb2\u0bc8\u0ba9\u0bcd \u0baa\u0bc2\u0b99\u0bcd\u0b95\u0bbe",
  },
  "CV79+2CG, Nattandiya, Sri Lanka": {
    si: "CV79+2CG, Nattandiya, Sri Lanka",
    ta: "CV79+2CG, Nattandiya, Sri Lanka",
  },
  "CXJX+7M7, Aluthgama, Sri Lanka": {
    si: "CXJX+7M7, \u0d85\u0dbd\u0dd4\u0dad\u0dca\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "CXJX+7M7, \u0b85\u0bb2\u0bc1\u0ba4\u0bcd\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Capital Junction VARIPATHANCHNAI, Siyambalanduwa-Damana-Ampara Hwy, Sri Lanka":
    {
      si: "\u0d85\u0d9c\u0db1\u0dd4\u0dc0\u0dbb \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba \u0dc0\u0dbb\u0dd2\u0db4\u0dad\u0d82\u0da0\u0db1\u0dba\u0dd2, \u0dc3\u0dd2\u0dba\u0db9\u0dbd\u0dcf\u0dab\u0dca\u0da9\u0dd4\u0dc0-\u0daf\u0db8\u0db1-\u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb Hwy, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "\u0ba4\u0bb2\u0bc8\u0ba8\u0b95\u0bb0\u0bcd \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf \u0bb5\u0bbe\u0bb0\u0bbf\u0baa\u0ba4\u0ba9\u0bcd\u0b9a\u0bcd\u0b9a\u0ba9\u0bc8, \u0b9a\u0bbf\u0baf\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0ba3\u0bcd\u0b9f\u0bc1\u0bb5-\u0ba4\u0bae\u0ba9-\u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8 \u0bb9\u0bc6\u0bb5\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "Central Camp - Ampara": {
    si: "\u0db8\u0db0\u0dca\u200d\u0dba\u0db8 \u0d9a\u0db3\u0dc0\u0dd4\u0dbb - \u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb",
    ta: "\u0bae\u0ba4\u0bcd\u0ba4\u0bbf\u0baf \u0bae\u0bc1\u0b95\u0bbe\u0bae\u0bcd - \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8",
  },
  "Ceypetco Filling Station - Parana Handiya": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd - \u0db4\u0dbb\u0dab \u0dc4\u0dd0\u0db1\u0dca\u0da9\u0dd2\u0dba",
    ta: "\u0b9a\u0bbf\u0baa\u0bc6\u0b9f\u0bcd\u0b95\u0bcb \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd - \u0baa\u0bb0\u0ba3 \u0bb9\u0ba3\u0bcd\u0b9f\u0bbf\u0baf\u0bbe",
  },
  "Ceypetco Filling Station, Ambalangoda": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0d9c\u0ddc\u0da9",
    ta: "\u0b9a\u0bbf\u0baa\u0bc6\u0b9f\u0bcd\u0b95\u0bcb \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe",
  },
  "Ceypetco Filling Station, Athurugiriya Rd, Pannipitiya": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d85\u0dad\u0dd4\u0dbb\u0dd4\u0d9c\u0dd2\u0dbb\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0b9a\u0bbf\u0baa\u0bc6\u0b9f\u0bcd\u0b95\u0bcb \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b85\u0ba4\u0bc1\u0bb0\u0bc1\u0b95\u0bbf\u0bb0\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Ceypetco Filling Station, B353,Boralanda-Welimada": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, B353, \u0db6\u0ddc\u0dbb\u0dbd\u0db1\u0dca\u0daf-\u0dc0\u0dd0\u0dbd\u0dd2\u0db8\u0da9",
    ta: "\u0b9a\u0bbf\u0baa\u0bc6\u0b9f\u0bcd\u0b95\u0bcb \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, B353, \u0baa\u0bca\u0bb0\u0bb2\u0ba8\u0bcd\u0ba4-\u0bb5\u0bc6\u0bb2\u0bbf\u0bae\u0b9f\u0bbe",
  },
  "Ceypetco Filling Station, Battulu Oya": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db6\u0dad\u0dca\u0dad\u0dd4\u0dbd\u0dd4 \u0d94\u0dba",
    ta: "\u0b9a\u0bbf\u0baa\u0bc6\u0b9f\u0bcd\u0b95\u0bcb \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0baa\u0b9f\u0bcd\u0b9f\u0bc1\u0bb2\u0bc1 \u0b93\u0baf\u0bbe",
  },
  "Ceypetco Filling Station, Colombo - Kandy Rd, Kegalle": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd",
    ta: "Ceypetco \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8",
  },
  "Ceypetco Filling Station, Kotapola": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0ddc\u0da7\u0db4\u0ddc\u0dbd",
    ta: "\u0b9a\u0bbf\u0baa\u0bc6\u0b9f\u0bcd\u0b95\u0bcb \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0baa\u0bca\u0bb2",
  },
  "Ceypetco Filling Station, Nedunkarny": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db1\u0dd9\u0da9\u0dd4\u0db1\u0dca\u0d9a\u0dbb\u0dca\u0db1\u0dd2",
    ta: "\u0b9a\u0bbf\u0baa\u0bc6\u0b9f\u0bcd\u0b95\u0bcb \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0ba8\u0bc6\u0b9f\u0bc1\u0b99\u0bcd\u0b95\u0bb0\u0bcd\u0ba3\u0bbf",
  },
  "Ceypetco Filling Station, Negombo": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0b9a\u0bbf\u0baa\u0bc6\u0b9f\u0bcd\u0b95\u0bcb \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "Ceypetco Filling Station, Urubokka": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d8c\u0dbb\u0dd4\u0db6\u0ddc\u0d9a\u0dca\u0d9a",
    ta: "\u0b9a\u0bbf\u0baa\u0bc6\u0b9f\u0bcd\u0b95\u0bcb \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b8a\u0bb0\u0bcd\u0baa\u0bca\u0b95\u0bcd\u0b95",
  },
  "Ceypetco Fuel Filling Station, B435, Kotikawatta": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db6\u0dd3 435, \u0d9a\u0ddc\u0da7\u0dd2\u0d9a\u0dcf\u0dc0\u0dad\u0dca\u0dad",
    ta: "Ceypetco \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, B435, \u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8",
  },
  "Ceypetco Fuel Station, B240, Malabe": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db6\u0dd3 240, \u0db8\u0dcf\u0dbd\u0db6\u0dda",
    ta: "Ceypetco \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, B240, \u0bae\u0bbe\u0bb2\u0baa\u0bc7",
  },
  "Ceypetco Fuel Station, Beragala-hali Ela Hwy, Bandarawela": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db6\u0dd9\u0dbb\u0d9c\u0dbd-\u0dc4\u0dcf\u0dbd\u0dd2 \u0d87\u0dbd Hwy, \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0dc0\u0dd9\u0dbd",
    ta: "\u0b9a\u0bbf\u0baa\u0bc6\u0b9f\u0bcd\u0b95\u0bcb \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0baa\u0bc6\u0bb0\u0b95\u0bb2-\u0bb9\u0bbe\u0bb2\u0bbf \u0b8e\u0bb2 \u0bb9\u0bc6\u0bb5\u0bbf, \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0bb5\u0bb3\u0bc8",
  },
  "Ceypetco Fuel Station, Colombo - Kandy Rd, Peliyagoda": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0ddc\u0dc5\u0db9 - \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9",
    ta: "Ceypetco \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc7\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f",
  },
  "Ceypetco Fuel Station, Dunagaha": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0daf\u0dd4\u0db1\u0d9c\u0dc4",
    ta: "\u0b9a\u0bbf\u0baa\u0bc6\u0b9f\u0bcd\u0b95\u0bcb \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0ba4\u0bc1\u0ba9\u0b95\u0bb9\u0bbe",
  },
  "Ceypetco Fuel Station, William Gopallawa Mawatha, Kandy": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0dc0\u0dd2\u0dbd\u0dd2\u0dba\u0db8\u0dca \u0d9c\u0ddc\u0db4\u0dbd\u0dca\u0dbd\u0dc0 \u0db8\u0dcf\u0dc0\u0dad, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb",
    ta: "Ceypetco \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0bb5\u0bbf\u0bb2\u0bcd\u0bb2\u0bbf\u0baf\u0bae\u0bcd \u0b95\u0bcb\u0baa\u0bb2\u0bcd\u0bb2\u0bb5 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf",
  },
  "Ceypetco Gas Station, Thalakiriyagama,Dambulla": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0d9c\u0dd1\u0dc3\u0dca \u0dc4\u0dbd, \u0dad\u0dbd\u0d9a\u0dd2\u0dbb\u0dd2\u0dba\u0dcf\u0d9c\u0db8, \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0b9a\u0bbf\u0baa\u0bc6\u0b9f\u0bcd\u0b95\u0bcb \u0b8e\u0bb0\u0bbf\u0bb5\u0bbe\u0baf\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0ba4\u0bb2\u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bbe\u0b95\u0bae, \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8",
  },
  "Ceypetco, A4, Monaragala": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd, \u0d92 4, \u0db8\u0ddc\u0db1\u0dbb\u0dcf\u0d9c\u0dbd",
    ta: "\u0b9a\u0bbf\u0baa\u0bc6\u0b9f\u0bcd\u0b95\u0bcb, \u0b8f4, \u0bae\u0bca\u0ba9\u0bb0\u0bbe\u0b95\u0bb2\u0bc8",
  },
  "Ceypetco, Kasthuriyar Rd, Jaffna": {
    si: "\u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd, \u0d9a\u0dc3\u0dca\u0dad\u0dd4\u0dbb\u0dd2\u0dba\u0dbb\u0dca \u0db4\u0dcf\u0dbb, \u0dba\u0dcf\u0db4\u0db1\u0dba",
    ta: "\u0b9a\u0bbf\u0baa\u0bc6\u0b9f\u0bcd\u0b95\u0bcb, \u0b95\u0bb8\u0bcd\u0ba4\u0bc2\u0bb0\u0bbf\u0baf\u0bbe\u0bb0\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd",
  },
  Chankanai: {
    si: "Chankanai",
    ta: "Chankanai",
  },
  Chawalakadai: {
    si: "\u0da0\u0dc0\u0dbd\u0d9a\u0da9\u0dba\u0dd2",
    ta: "\u0b9a\u0bb5\u0bb3\u0b95\u0bcd\u0b95\u0b9f\u0bc8",
  },
  Cheddikulam: {
    si: "\u0da0\u0dd9\u0da9\u0dca\u0da9\u0dd2\u0d9a\u0dd4\u0dbd\u0db8\u0dca",
    ta: "\u0b9a\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bc1\u0bb3\u0bae\u0bcd",
  },
  Chenkalady: {
    si: "\u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2",
    ta: "\u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf",
  },
  Chilaw: {
    si: "\u0db7\u0dbd\u0dcf\u0dc0\u0dad",
    ta: "\u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd",
  },
  "Chilaw - Colombo Main Rd, Madampe": {
    si: "\u0dc4\u0dbd\u0dcf\u0dc0\u0dad - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda",
    ta: "\u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bbe\u0ba4\u0bae\u0bcd\u0baa\u0bc7",
  },
  "Chilaw - Colombo Main Rd, Mahawewa": {
    si: "\u0dc4\u0dbd\u0dcf\u0dc0\u0dad - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0dc0\u0dd0\u0dc0",
    ta: "\u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bb9\u0bbe\u0bb5\u0bc6\u0bb5",
  },
  "Chilaw - Colombo Main Rd, Marawila": {
    si: "\u0dc4\u0dbd\u0dcf\u0dc0\u0dad - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0db8\u0dcf\u0dbb\u0dc0\u0dd2\u0dbd",
    ta: "\u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bbe\u0bb0\u0bb5\u0bbf\u0bb2",
  },
  "Chilaw - Colombo Main Road, Negombo": {
    si: "\u0dc4\u0dbd\u0dcf\u0dc0\u0dad - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "Chilaw - Wariyapola Rd": {
    si: "\u0dc4\u0dbd\u0dcf\u0dc0\u0dad - \u0dc0\u0dcf\u0dbb\u0dd2\u0dba\u0db4\u0ddc\u0dbd \u0db4\u0dcf\u0dbb",
    ta: "\u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd - \u0bb5\u0bbe\u0bb0\u0bbf\u0baf\u0baa\u0bca\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  "Chilaw - Wariyapola Rd, Bingiriya": {
    si: "\u0dc4\u0dbd\u0dcf\u0dc0\u0dad - \u0dc0\u0dcf\u0dbb\u0dd2\u0dba\u0db4\u0ddc\u0dbd \u0db4\u0dcf\u0dbb, \u0db6\u0dd2\u0d82\u0d9c\u0dd2\u0dbb\u0dd2\u0dba",
    ta: "\u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd - \u0bb5\u0bbe\u0bb0\u0bbf\u0baf\u0baa\u0bca\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bbf\u0b99\u0bcd\u0b95\u0bbf\u0bb0\u0bbf\u0baf",
  },
  "Chilaw Fish Market, Chilaw, Sri Lanka": {
    si: "\u0dc4\u0dbd\u0dcf\u0dc0\u0dad \u0db8\u0dcf\u0dc5\u0dd4 \u0dc0\u0dd9\u0dc5\u0db3\u0db4\u0ddc\u0dbd, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd \u0bae\u0bc0\u0ba9\u0bcd \u0b9a\u0ba8\u0bcd\u0ba4\u0bc8, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Chilaw Road, Marawila": {
    si: "\u0dc4\u0dbd\u0dcf\u0dc0\u0dad \u0db4\u0dcf\u0dbb, \u0db8\u0dcf\u0dbb\u0dc0\u0dd2\u0dbd",
    ta: "\u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bbe\u0bb0\u0bb5\u0bbf\u0bb2",
  },
  "Chillaw - Colombo Main Road, Ja-ela Kandana": {
    si: "\u0dc4\u0dbd\u0dcf\u0dc0\u0dad - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0da2\u0dcf-\u0d87\u0dbd \u0d9a\u0db3\u0dcf\u0db1",
    ta: "\u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b9c\u0bbe-\u0b8e\u0bb2 \u0b95\u0ba8\u0bcd\u0ba4\u0bbe\u0ba9\u0bc8",
  },
  Chunnakam: {
    si: "\u0da0\u0dd4\u0db1\u0dca\u0db1\u0dcf\u0d9a\u0db8\u0dca",
    ta: "\u0b9a\u0bc1\u0ba9\u0bcd\u0ba9\u0bbe\u0b95\u0bae\u0bcd",
  },
  "Chunnakam, Uduvil": {
    si: "\u0da0\u0dd4\u0db1\u0dca\u0db1\u0dcf\u0d9a\u0db8\u0dca, \u0d8b\u0da9\u0dd4\u0dc0\u0dd2\u0dbd\u0dca",
    ta: "\u0b9a\u0bc1\u0ba9\u0bcd\u0ba9\u0bbe\u0b95\u0bae\u0bcd, \u0b89\u0b9f\u0bc1\u0bb5\u0bbf\u0bb2\u0bcd",
  },
  "Circular Road, West": {
    si: "\u0dc0\u0da7\u0dbb\u0dc0\u0dd4\u0db8\u0dca \u0db4\u0dcf\u0dbb, \u0db6\u0da7\u0dc4\u0dd2\u0dbb",
    ta: "\u0bb5\u0b9f\u0bcd\u0b9f \u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0bc7\u0bb1\u0bcd\u0b95\u0bc1",
  },
  "Co-op Filling Station, A26, Karalliyadda": {
    si: "\u0dc3\u0db8\u0dd4\u0db4\u0d9a\u0dcf\u0dbb \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, A26, \u0d9a\u0dbb\u0dbd\u0dca\u0dbd\u0dd2\u0dba\u0daf\u0dca\u0daf",
    ta: "\u0b95\u0bc2\u0b9f\u0bcd\u0b9f\u0bc1\u0bb1\u0bb5\u0bc1 \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, A26, \u0b95\u0bb0\u0bb2\u0bcd\u0bb2\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0bbe",
  },
  "Co-op Filling Station, B9, Alawwa": {
    si: "\u0dc3\u0db8\u0dd4\u0db4\u0d9a\u0dcf\u0dbb \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db6\u0dd39, \u0d85\u0dbd\u0dc0\u0dca\u0dc0",
    ta: "\u0b95\u0bc2\u0b9f\u0bcd\u0b9f\u0bc1\u0bb1\u0bb5\u0bc1 \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, B9, \u0b85\u0bb2\u0bb5\u0bcd\u0bb5\u0bbe",
  },
  "Co-oparative Filling Station, Pothuhera": {
    si: "\u0dc3\u0db8\u0dd6\u0db4\u0d9a\u0dcf\u0dbb \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db4\u0ddc\u0dad\u0dd4\u0dc4\u0dd0\u0dbb",
    ta: "\u0b95\u0bc2\u0b9f\u0bcd\u0b9f\u0bc1\u0bb1\u0bb5\u0bc1 \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0baa\u0bca\u0ba4\u0bcd\u0ba4\u0bc1\u0bb9\u0bc6\u0bb0",
  },
  "Code - Data": {
    si: "\u0d9a\u0dda\u0dad\u0dba - \u0daf\u0dad\u0dca\u0dad",
    ta: "\u0b95\u0bc1\u0bb1\u0bbf\u0baf\u0bc0\u0b9f\u0bc1 - \u0ba4\u0bb0\u0bb5\u0bc1",
  },
  "Code - React App": {
    si: "\u0d9a\u0dda\u0dad\u0dba - \u0db4\u0dca\u0dbb\u0dad\u0dd2\u0d9a\u0dca\u0dbb\u0dd2\u0dba\u0dcf \u0dba\u0dd9\u0daf\u0dd4\u0db8",
    ta: "\u0b95\u0bc1\u0bb1\u0bbf\u0baf\u0bc0\u0b9f\u0bc1 - \u0bb0\u0bbf\u0baf\u0bbe\u0b95\u0bcd\u0b9f\u0bcd \u0b86\u0baa\u0bcd",
  },
  "Collombo Batticaloa Main Road, Oluvil": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0d94\u0dbd\u0dd4\u0dc0\u0dd2\u0dbd\u0dca",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b92\u0bb2\u0bc1\u0bb5\u0bbf\u0bb2\u0bcd",
  },
  Colombo: {
    si: "\u0d9a\u0ddc\u0dc5\u0db9",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "Colombo - 03": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - 03",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - 03",
  },
  "Colombo - 05": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - 05",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - 05",
  },
  "Colombo - Batticaloa Hwy, Akkaraipattu": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0db4\u0dad\u0dca\u0dad\u0dd4\u0dc0",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bc8\u0baa\u0bcd\u0baa\u0bb1\u0bcd\u0bb1\u0bc1",
  },
  "Colombo - Batticaloa Hwy, Avissawella": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 Hwy, \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8",
  },
  "Colombo - Batticaloa Hwy, Balangoda": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0db6\u0dbd\u0d82\u0d9c\u0ddc\u0da9",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bc8",
  },
  "Colombo - Batticaloa Hwy, Koslanda": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 Hwy, \u0d9a\u0ddc\u0dc3\u0dca\u0dbd\u0db1\u0dca\u0daf",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0b95\u0bca\u0bb8\u0bcd\u0bb2\u0bbe\u0ba8\u0bcd\u0ba4\u0bc8",
  },
  "Colombo - Batticaloa Hwy, Nintavur": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0db1\u0dd2\u0db1\u0dca\u0daf\u0dc0\u0dd6\u0dbb\u0dca",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0ba8\u0bbf\u0ba8\u0bcd\u0ba4\u0bb5\u0bc2\u0bb0\u0bcd",
  },
  "Colombo - Batticaloa Hwy, Pelmadulla": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 Hwy, \u0db4\u0dd0\u0dbd\u0dca\u0db8\u0da9\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, Pelmadulla",
  },
  "Colombo - Batticaloa Hwy, Ratnapura": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf",
  },
  "Colombo - Batticaloa Hwy, Thalankudah": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 Hwy, \u0dad\u0dcf\u0dbd\u0db1\u0dca\u0d9a\u0dd4\u0da9\u0dcf",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0ba4\u0bbe\u0bb4\u0b99\u0bcd\u0b95\u0bc1\u0b9f\u0bbe",
  },
  "Colombo - Batticoloa Hwy, Balangoda": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0db6\u0dbd\u0d82\u0d9c\u0ddc\u0da9",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bc8",
  },
  "Colombo - Batticoloa Hwy, Kuruwita": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0d9a\u0dd4\u0dbb\u0dd4\u0dc0\u0dd2\u0da7",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0b95\u0bc1\u0bb0\u0bc1\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f",
  },
  "Colombo - Galle - Hambantota - Wellawaya Highway, Dondra": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0d9c\u0dcf\u0dbd\u0dca\u0dbd - \u0dc4\u0db8\u0dca\u0db6\u0db1\u0dca\u0dad\u0ddc\u0da7 - \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0daf\u0dd9\u0dc0\u0dd4\u0db1\u0dca\u0daf\u0dbb",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bbe\u0bb2\u0bbf - \u0bb9\u0bae\u0bcd\u0baa\u0bbe\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 - \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0ba4\u0bca\u0ba9\u0bcd\u0bb1\u0bbe",
  },
  "Colombo - Galle - Hambantota - Wellawaya Hwy": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0d9c\u0dcf\u0dbd\u0dca\u0dbd - \u0dc4\u0db8\u0dca\u0db6\u0db1\u0dca\u0dad\u0ddc\u0da7 - \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba Hwy",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bbe\u0bb2\u0bbf - \u0bb9\u0bae\u0bcd\u0baa\u0bbe\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 - \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf Hwy",
  },
  "Colombo - Galle - Hambantota - Wellawaya Hwy, Dehiwala-Mount Lavinia": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0d9c\u0dcf\u0dbd\u0dca\u0dbd - \u0dc4\u0db8\u0dca\u0db6\u0db1\u0dca\u0dad\u0ddc\u0da7 - \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba Hwy, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd - \u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bbe\u0bb2\u0bbf - \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 - \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf Hwy, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8 - \u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8",
  },
  "Colombo - Galle - Hambantota - Wellawaya Hwy, Hungama": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0d9c\u0dcf\u0dbd\u0dca\u0dbd - \u0dc4\u0db8\u0dca\u0db6\u0db1\u0dca\u0dad\u0ddc\u0da7 - \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba Hwy, \u0dc4\u0dd4\u0d82\u0d9c\u0db8",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bbe\u0bb2\u0bbf - \u0bb9\u0bae\u0bcd\u0baa\u0bbe\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 - \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf Hwy, \u0bb9\u0b99\u0bcd\u0b95\u0bae",
  },
  "Colombo - Galle Main Rd, Kalutara": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0d9c\u0dcf\u0dbd\u0dca\u0dbd \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0d9a\u0dc5\u0dd4\u0dad\u0dbb",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bbe\u0bb2\u0bbf \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb3\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  "Colombo - Hanwella Low Level Rd, Colombo": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0dc4\u0d82\u0dc0\u0dd0\u0dbd\u0dca\u0dbd \u0dbd\u0ddd \u0dbd\u0dd9\u0dc0\u0dbd\u0dca \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0dc5\u0db9",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bb9\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 \u0bb2\u0bcb \u0bb2\u0bc6\u0bb5\u0bb2\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "Colombo - Kandy Rd, Kadawatha": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0da9\u0dc0\u0dad",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8",
  },
  "Colombo - Kandy Rd, Kiribathgoda": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0dd2\u0dbb\u0dd2\u0db6\u0dad\u0dca\u0d9c\u0ddc\u0da9",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bbf\u0bb0\u0bbf\u0baa\u0ba4\u0bcd\u0b95\u0bca\u0b9f",
  },
  "Colombo - Kandy Rd, Warakapola": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dc0\u0dbb\u0d9a\u0dcf\u0db4\u0ddc\u0dbd",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bb0\u0b95\u0bcd\u0b95\u0bbe\u0baa\u0bca\u0bb2",
  },
  "Colombo - Kandy Road, Kadugannawa": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0da9\u0dd4\u0d9c\u0db1\u0dca\u0db1\u0dcf\u0dc0",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0b9f\u0bc1\u0b95\u0ba9\u0bcd\u0ba9\u0bbe\u0bb5",
  },
  "Colombo - Ratnapura - Wellawaya - Batticaloa Rd": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb - \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf - \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  "Colombo - Ratnapura - Wellawaya - Batticaloa Rd, Kalmunai": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb - \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf - \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8",
  },
  "Colombo - Ratnapura - Wellawaya - Batticaloa Rd, Kalmunai, Sainthamaruthu": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb - \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda, \u0dc3\u0dba\u0dd2\u0db1\u0dca\u0daf\u0db8\u0dbb\u0dd4\u0dad\u0dd4",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf - \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8, \u0b9a\u0bbe\u0baf\u0bcd\u0ba8\u0bcd\u0ba4\u0bae\u0bb0\u0bc1\u0ba4\u0bc1",
  },
  "Colombo - Ratnapura - Wellawaya - Batticaloa Rd, Kaluwanchikudy": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb - \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0d9a\u0dbd\u0dd4\u0dc0\u0d82\u0da0\u0dd2\u0d9a\u0dd4\u0da9\u0dd2",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf - \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb3\u0bc1\u0bb5\u0bbe\u0b9e\u0bcd\u0b9a\u0bbf\u0b95\u0bcd\u0b95\u0bc1\u0b9f\u0bbf",
  },
  "Colombo - Ratnapura - Wellawaya - Batticaloa Rd, Monaragala": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb - \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0db8\u0ddc\u0db1\u0dbb\u0dcf\u0d9c\u0dbd",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf - \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bca\u0ba9\u0bb0\u0bbe\u0b95\u0bb2\u0bc8",
  },
  "Colombo - Ratnapura - Wellawaya - Batticaloa Rd, Nintavur": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb - \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0db1\u0dd2\u0db1\u0dca\u0daf\u0dc0\u0dd4\u0dbb\u0dca",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf - \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bbf\u0ba8\u0bcd\u0ba4\u0bb5\u0bc2\u0bb0\u0bcd",
  },
  "Colombo -15": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 -15",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 -15",
  },
  "Colombo 02": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 02",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 02",
  },
  "Colombo 14 - Jethawana Road": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 14 - \u0da2\u0dda\u0dad\u0dc0\u0db1 \u0db4\u0dcf\u0dbb",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 14 - \u0b9c\u0bc6\u0ba4\u0bb5\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  "Colombo 14 - Orugodawatte": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 14 - \u0d94\u0dbb\u0dd4\u0d9c\u0ddc\u0da9\u0dc0\u0dad\u0dca\u0dad",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 14 - \u0b92\u0bb0\u0bc1\u0b95\u0bca\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8",
  },
  "Colombo Batticlor Hwy, Sewanapitiya": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0dc3\u0dd9\u0dc0\u0dab\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1, \u0b9a\u0bc6\u0bb5\u0ba9\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Colombo Main Rd, Dehiwala - Mount Lavinia": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd - \u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8 - \u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8",
  },
  "Colombo Main Rd, Wadduwa": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0dc0\u0dcf\u0daf\u0dca\u0daf\u0dd4\u0dc0",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bbe\u0ba4\u0bc1\u0bb5",
  },
  "Colombo Plan Rd, Colombo": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 \u0dc3\u0dd0\u0dbd\u0dd0\u0dc3\u0dca\u0db8 \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0dc5\u0db9",
    ta: "Colombo Plan Rd, Colombo",
  },
  "Colombo Rd, 5W8W+JWW, Minuwangoda, Sri Lanka": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, 5W8W+JWW, \u0db8\u0dd2\u0db1\u0dd4\u0dc0\u0db1\u0dca\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb0\u0bcb\u0b9f\u0bc1, 5W8W+JWW, \u0bae\u0bbf\u0ba9\u0bc1\u0bb5\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Colombo Road, Bomugammana, Divulapitiya": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0db6\u0ddd\u0db8\u0dd4\u0d9c\u0db8\u0dca\u0db8\u0db1, \u0daf\u0dd2\u0dc0\u0dd4\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bcb\u0bae\u0bc1\u0b95\u0bae\u0bcd\u0bae\u0ba9, \u0ba4\u0bbf\u0bb5\u0bc1\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Colombo Road, Gampaha": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0d9c\u0db8\u0dca\u0db4\u0dc4",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe",
  },
  "Colombo- Batticaloa Hwy, Akkaraipattu": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0db4\u0dad\u0dca\u0dad\u0dd4\u0dc0",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1- \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bc8\u0baa\u0bcd\u0baa\u0bb1\u0bcd\u0bb1\u0bc1",
  },
  "Colombo- Stace Road": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0dc3\u0dca\u0da7\u0dda\u0dc3\u0dca \u0db4\u0dcf\u0dbb",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bb8\u0bcd\u0b9f\u0bc7\u0bb8\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1",
  },
  "Colombo-batticaloa Hwy": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9-\u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy",
  },
  "Colombo-batticaloa Hwy, Passara": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9-\u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 Hwy, \u0db4\u0dc3\u0dca\u0dc3\u0dbb",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1-\u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0baa\u0b9a\u0bb1\u0bc8",
  },
  "Colombo-horana Rd, Piliyandala": {
    si: "\u0d9a\u0ddc\u0dc5\u0db9 - \u0dc4\u0ddc\u0dbb\u0dab \u0db4\u0dcf\u0dbb, \u0db4\u0dd2\u0dc5\u0dd2\u0dba\u0db1\u0dca\u0daf\u0dbd",
    ta: "\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bb9\u0bca\u0bb0\u0ba3 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bbf\u0bb2\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bb2\u0bc8",
  },
  "Community Feed": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0da2\u0dcf \u0dc3\u0d82\u0d9c\u0dca\u200d\u0dbb\u0dc4\u0dba",
    ta: "\u0b9a\u0bae\u0bc2\u0b95 \u0b8a\u0b9f\u0bcd\u0b9f\u0bae\u0bcd",
  },
  "Copy App Link": {
    si: "\u0dba\u0dd9\u0daf\u0dd4\u0db8\u0dca \u0dc3\u0db6\u0dd0\u0db3\u0dd2\u0dba \u0db4\u0dd2\u0da7\u0db4\u0dad\u0dca \u0d9a\u0dbb\u0db1\u0dca\u0db1",
    ta: "\u0baa\u0baf\u0ba9\u0bcd\u0baa\u0bbe\u0b9f\u0bcd\u0b9f\u0bc1 \u0b87\u0ba3\u0bc8\u0baa\u0bcd\u0baa\u0bc8 \u0ba8\u0b95\u0bb2\u0bc6\u0b9f\u0bc1\u0b95\u0bcd\u0b95\u0bb5\u0bc1\u0bae\u0bcd",
  },
  "Court Complex Mulathivu, Mullaitivu, Sri Lanka": {
    si: "\u0d85\u0db0\u0dd2\u0d9a\u0dbb\u0dab \u0dc3\u0d82\u0d9a\u0dd3\u0dbb\u0dca\u0dab\u0dba \u0db8\u0dd4\u0dbd\u0dad\u0dd2\u0dc0\u0dca, \u0db8\u0dd4\u0dbd\u0dad\u0dd2\u0dc0\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba8\u0bc0\u0ba4\u0bbf\u0bae\u0ba9\u0bcd\u0bb1 \u0bb5\u0bb3\u0bbe\u0b95\u0bae\u0bcd \u0bae\u0bc1\u0bb2\u0ba4\u0bcd\u0ba4\u0bc0\u0bb5\u0bc1, \u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bc8\u0ba4\u0bcd\u0ba4\u0bc0\u0bb5\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Ctb Filling Station, A2, Dehiwala-mount Lavinia,Rathmalana": {
    si: "Ctb \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, A2, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd-\u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3, \u0dbb\u0dad\u0dca\u0db8\u0dbd\u0dcf\u0db1",
    ta: "Ctb \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, A2, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8 - \u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8, \u0b87\u0bb0\u0ba4\u0bcd\u0bae\u0bb2\u0bbe\u0ba9\u0bc8",
  },
  "D & T ORGANIZATION": {
    si: "D & T \u0dc3\u0d82\u0dc0\u0dd2\u0db0\u0dcf\u0db1\u0dba",
    ta: "\u0b9f\u0bbf & \u0b9f\u0bbf \u0b85\u0bae\u0bc8\u0baa\u0bcd\u0baa\u0bc1",
  },
  "D A CHULARATHNA": {
    si: "\u0da9\u0dd3 \u0d92 \u0da0\u0dd6\u0dbd\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b9f\u0bbf \u0b8f \u0b9a\u0bc2\u0bb2\u0bb0\u0ba4\u0bcd\u0ba9\u0bbe",
  },
  "D A W THILAKARATHNA": {
    si: "\u0da9\u0dd3 \u0d92 \u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0dad\u0dd2\u0dbd\u0d9a\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b9f\u0bbf \u0b8f \u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0ba4\u0bbf\u0bb2\u0b95\u0bb0\u0ba4\u0bcd\u0ba9\u0bbe",
  },
  "D B .DISSANAYAKE": {
    si: "D B .\u0daf\u0dd2\u0dc3\u0dcf\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b9f\u0bbf \u0baa\u0bbf .\u0ba4\u0bbf\u0b9a\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "D CHRISTIE ARRAWALA & SONS": {
    si: "\u0da9\u0dd3 \u0d9a\u0dca\u200d\u0dbb\u0dd2\u0dc3\u0dca\u0da7\u0dd2 \u0d85\u0dbb\u0dc0\u0dbd \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b9f\u0bbf \u0b95\u0bbf\u0bb1\u0bbf\u0bb8\u0bcd\u0b9f\u0bbf \u0b85\u0bb0\u0bcd\u0bb0\u0bb5\u0bbe\u0bb2\u0bbe & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "D D KASTHURIARACHCHI & SONS": {
    si: "\u0da9\u0dd3 \u0da9\u0dd3 \u0d9a\u0dc3\u0dca\u0dad\u0dd4\u0dbb\u0dd2\u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b9f\u0bbf \u0b9f\u0bbf \u0b95\u0bb8\u0bcd\u0ba4\u0bc1\u0bb0\u0bbf\u0baf\u0bbe\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "D G N PUSHPAKUMARA": {
    si: "\u0da9\u0dd3 \u0da2\u0dd3 \u0d91\u0db1\u0dca \u0db4\u0dd4\u0dc2\u0dca\u0db4\u0d9a\u0dd4\u0db8\u0dcf\u0dbb",
    ta: "\u0b9f\u0bbf \u0b9c\u0bbf \u0b8e\u0ba9\u0bcd \u0baa\u0bc1\u0bb7\u0bcd\u0baa\u0b95\u0bc1\u0bae\u0bbe\u0bb0",
  },
  "D H D U INDRARATNE": {
    si: "\u0da9\u0dd3 \u0d91\u0da0\u0dca \u0da9\u0dd3 \u0dba\u0dd6 \u0d89\u0db1\u0dca\u0daf\u0dca\u200d\u0dbb\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b9f\u0bbf \u0b8e\u0b9a\u0bcd \u0b9f\u0bbf \u0baf\u0bc1 \u0b87\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "D H DAYARATNA GUNAWARDANA": {
    si: "\u0da9\u0dd3 \u0d91\u0da0\u0dca \u0daf\u0dba\u0dcf\u0dbb\u0dad\u0dca\u0db1 \u0d9c\u0dd4\u0dab\u0dc0\u0dbb\u0dca\u0db0\u0db1",
    ta: "\u0b9f\u0bbf \u0b8e\u0b9a\u0bcd \u0ba4\u0baf\u0bbe\u0bb0\u0ba4\u0bcd\u0ba9 \u0b95\u0bc1\u0ba3\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9",
  },
  "D H G ANANDA": {
    si: "\u0da9\u0dd3 \u0d91\u0da0\u0dca \u0da2\u0dd3 \u0d86\u0db1\u0db1\u0dca\u0daf",
    ta: "\u0b9f\u0bbf \u0b8e\u0b9a\u0bcd \u0b9c\u0bbf \u0b86\u0ba9\u0ba8\u0bcd\u0ba4\u0bbe",
  },
  "D H J JAYAKODY BROTHERS": {
    si: "D H J \u0da2\u0dba\u0d9a\u0ddc\u0da9\u0dd2 \u0dc3\u0dc4\u0ddd\u0daf\u0dbb\u0dba\u0ddd",
    ta: "\u0b9f\u0bbf \u0b8e\u0b9a\u0bcd \u0b9c\u0bc7 \u0b9c\u0bc6\u0baf\u0b95\u0bcd\u0b95\u0bca\u0b9f\u0bbf \u0b9a\u0b95\u0bcb\u0ba4\u0bb0\u0bb0\u0bcd\u0b95\u0bb3\u0bcd",
  },
  "D I A JAYASINGHE": {
    si: "\u0da9\u0dd3 \u0d85\u0dba\u0dd2 \u0d92 \u0da2\u0dba\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b9f\u0bbf \u0b90 \u0b8f \u0b9c\u0bc6\u0baf\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "D I G D P GUNASEKARA": {
    si: "\u0da9\u0dd3 \u0d85\u0dba\u0dd2 \u0da2\u0dd3 \u0da9\u0dd3 \u0db4\u0dd3 \u0d9c\u0dd4\u0dab\u0dc3\u0dda\u0d9a\u0dbb",
    ta: "\u0b9f\u0bbf \u0b90 \u0b9c\u0bbf \u0b9f\u0bbf \u0baa\u0bbf \u0b95\u0bc1\u0ba3\u0b9a\u0bc7\u0b95\u0bb0",
  },
  "D J B S AMARASEKARA": {
    si: "\u0da9\u0dd3 \u0da2\u0dda \u0db6\u0dd3 \u0d91\u0dc3\u0dca \u0d85\u0db8\u0dbb\u0dc3\u0dda\u0d9a\u0dbb",
    ta: "\u0b9f\u0bbf \u0b9c\u0bc7 \u0baa\u0bbf \u0b8e\u0bb8\u0bcd \u0b85\u0bae\u0bb0\u0b9a\u0bc7\u0b95\u0bb0",
  },
  "D K W TRADERS (PVT) LTD": {
    si: "D K W TRADERS (PVT) LTD",
    ta: "\u0b9f\u0bbf \u0b95\u0bc7 \u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b9f\u0bbf\u0bb0\u0bc7\u0b9f\u0bb0\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "D L C C GUNASEKARA": {
    si: "\u0da9\u0dd3 \u0d91\u0dbd\u0dca \u0dc3\u0dd3 \u0dc3\u0dd3 \u0d9c\u0dd4\u0dab\u0dc3\u0dda\u0d9a\u0dbb",
    ta: "\u0b9f\u0bbf \u0b8e\u0bb2\u0bcd \u0b9a\u0bbf \u0b9a\u0bbf \u0b95\u0bc1\u0ba3\u0b9a\u0bc7\u0b95\u0bb0\u0ba9\u0bcd",
  },
  "D L GAMINI .THILAKARATNE": {
    si: "\u0da9\u0dd3 \u0d91\u0dbd\u0dca \u0d9c\u0dcf\u0db8\u0dd2\u0dab\u0dd3 .\u0dad\u0dd2\u0dbd\u0d9a\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b9f\u0bbf \u0b8e\u0bb2\u0bcd \u0b95\u0bbe\u0bae\u0bbf\u0ba9\u0bbf .\u0ba4\u0bbf\u0bb2\u0b95\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "D M A I DISSANAYAKE": {
    si: "\u0da9\u0dd3 \u0d91\u0db8\u0dca \u0d92 \u0d85\u0dba\u0dd2 \u0daf\u0dd2\u0dc3\u0dcf\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b9f\u0bbf \u0b8e\u0bae\u0bcd \u0b8f \u0b90 \u0ba4\u0bbf\u0b9a\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "D M R D B UKUWELA": {
    si: "\u0da9\u0dd3 \u0d91\u0db8\u0dca \u0d86\u0dbb\u0dca \u0da9\u0dd3 \u0db6\u0dd3 \u0d8b\u0d9a\u0dd4\u0dc0\u0dd9\u0dbd",
    ta: "\u0b9f\u0bbf \u0b8e\u0bae\u0bcd \u0b86\u0bb0\u0bcd \u0b9f\u0bbf \u0baa\u0bbf \u0b89\u0b95\u0bc1\u0bb5\u0bc6\u0bb2",
  },
  "D M R U KUMARA": {
    si: "\u0da9\u0dd3 \u0d91\u0db8\u0dca \u0d86\u0dbb\u0dca \u0dba\u0dd6 \u0d9a\u0dd4\u0db8\u0dcf\u0dbb",
    ta: "\u0b9f\u0bbf \u0b8e\u0bae\u0bcd \u0b86\u0bb0\u0bcd \u0baf\u0bc1 \u0b95\u0bc1\u0bae\u0bbe\u0bb0",
  },
  "D M SEELAWATHI": {
    si: "\u0da9\u0dd3 \u0d91\u0db8\u0dca \u0dc3\u0dd3\u0dbd\u0dc0\u0dad\u0dd3",
    ta: "\u0b9f\u0bbf \u0b8e\u0bae\u0bcd \u0b9a\u0bc0\u0bb2\u0bbe\u0bb5\u0ba4\u0bbf",
  },
  "D M SEELAWATHIE": {
    si: "\u0da9\u0dd3 \u0d91\u0db8\u0dca \u0dc3\u0dd3\u0dbd\u0dc0\u0dad\u0dd3",
    ta: "\u0b9f\u0bbf \u0b8e\u0bae\u0bcd \u0b9a\u0bc0\u0bb2\u0bbe\u0bb5\u0ba4\u0bbf",
  },
  "D N  T SISIRA KUMARA": {
    si: "\u0da9\u0dd3 \u0d91\u0db1\u0dca \u0da7\u0dd3 \u0dc3\u0dd2\u0dc3\u0dd2\u0dbb \u0d9a\u0dd4\u0db8\u0dcf\u0dbb",
    ta: "\u0b9f\u0bbf \u0b8e\u0ba9\u0bcd \u0b9f\u0bbf \u0b9a\u0bbf\u0b9a\u0bbf\u0bb0 \u0b95\u0bc1\u0bae\u0bbe\u0bb0",
  },
  "D N R K PERERA": {
    si: "\u0da9\u0dd3 \u0d91\u0db1\u0dca \u0d86\u0dbb\u0dca \u0d9a\u0dda \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b9f\u0bbf \u0b8e\u0ba9\u0bcd \u0b86\u0bb0\u0bcd \u0b95\u0bc7 \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "D R L E JAYAWARDENE": {
    si: "\u0da9\u0dd3 \u0d86\u0dbb\u0dca \u0d91\u0dbd\u0dca \u0d8a \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1",
    ta: "\u0b9f\u0bbf \u0b86\u0bb0\u0bcd \u0b8e\u0bb2\u0bcd \u0b87 \u0b9c\u0bc6\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0bcd\u0ba4\u0ba9\u0bc7",
  },
  "D R M WICRAMASEKERA HOLDINGS": {
    si: "\u0da9\u0dd3 \u0d86\u0dbb\u0dca \u0d91\u0db8\u0dca \u0dc0\u0dd2\u0d9a\u0dca\u200d\u0dbb\u0db8\u0dc3\u0dda\u0d9a\u0dbb \u0dc4\u0ddd\u0dbd\u0dca\u0da9\u0dd2\u0db1\u0dca\u0d9c\u0dca\u0dc3\u0dca",
    ta: "\u0b9f\u0bbf \u0b86\u0bb0\u0bcd \u0b8e\u0bae\u0bcd \u0bb5\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb0\u0bae\u0b9a\u0bc7\u0b95\u0bb0 \u0bb9\u0bcb\u0bb2\u0bcd\u0b9f\u0bbf\u0b99\u0bcd\u0bb8\u0bcd",
  },
  "D S GUNASEKARA FILLING & SERV(PVT)": {
    si: "D S \u0d9c\u0dd4\u0dab\u0dc3\u0dda\u0d9a\u0dbb \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca \u0dc3\u0dc4 \u0dc3\u0dda\u0dc0\u0dcf (PVT)",
    ta: "\u0b9f\u0bbf.\u0b8e\u0bb8\u0bcd.\u0b95\u0bc1\u0ba3\u0b9a\u0bc7\u0b95\u0bb0\u0bbe \u0b83\u0baa\u0bbf\u0bb2\u0bcd\u0bb2\u0bbf\u0b99\u0bcd & \u0b9a\u0bb0\u0bcd\u0bb5\u0bcd(\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf)",
  },
  "D S S N AUTO ENGINEERS (PVT)LTD": {
    si: "D S S N \u0d94\u0da7\u0ddd \u0d89\u0d82\u0da2\u0dd2\u0db1\u0dda\u0dbb\u0dd4\u0dc0\u0db1\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b9f\u0bbf \u0b8e\u0bb8\u0bcd \u0b8e\u0bb8\u0bcd \u0b8e\u0ba9\u0bcd \u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0b87\u0ba9\u0bcd\u0b9c\u0bbf\u0ba9\u0bbf\u0baf\u0bb0\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "D S Senanayake Mawatha, Hingurakgoda": {
    si: "\u0da9\u0dd3 \u0d91\u0dc3\u0dca \u0dc3\u0dda\u0db1\u0dcf\u0db1\u0dcf\u0dba\u0d9a \u0db8\u0dcf\u0dc0\u0dad, \u0dc4\u0dd2\u0d9f\u0dd4\u0dbb\u0d9a\u0dca\u0d9c\u0ddc\u0da9",
    ta: "\u0b9f\u0bbf \u0b8e\u0bb8\u0bcd \u0b9a\u0bc7\u0ba9\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0bb9\u0bbf\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0bbe\u0b95\u0bcd\u0b95\u0bca\u0b9f",
  },
  "D W FERNANDO AND SONS PVT. LTD.": {
    si: "\u0da9\u0dd3 \u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd \u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a \u0dc3\u0db8\u0dcf\u0d9c\u0db8. \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca.",
    ta: "\u0b9f\u0bbf \u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb \u0bae\u0bb1\u0bcd\u0bb1\u0bc1\u0bae\u0bcd \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd \u0baa\u0bbf\u0bb0\u0bc8\u0bb5\u0bc7\u0b9f\u0bcd. LTD.",
  },
  "D W FILLING STATION": {
    si: "D W \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "DW \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "D. S. Senanayke Rd, Ampara": {
    si: "D. S. \u0dc3\u0dda\u0db1\u0dcf\u0db1\u0dcf\u0dba\u0d9a \u0db4\u0dcf\u0dbb, \u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb",
    ta: "\u0b9f\u0bbf.\u0b8e\u0bb8\u0bcd. \u0b9a\u0bc7\u0ba9\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8",
  },
  "D. T. A. ATALE & SON ( PVT ) LTD": {
    si: "D. T. A. ATALE & SON (PVT) LTD",
    ta: "D. T. A. ATALE & SON (PVT) LTD",
  },
  "D.A. Dammika": {
    si: "\u0da9\u0dd3.\u0d92. \u0daf\u0db8\u0dca\u0db8\u0dd2\u0d9a",
    ta: "\u0b9f\u0bbf.\u0b8f. \u0ba4\u0bae\u0bcd\u0bae\u0bbf\u0b95\u0bbe",
  },
  "D.C. & L.C.SENASEKARA": {
    si: "\u0da9\u0dd3.\u0dc3\u0dd3. \u0dc3\u0dc4 \u0d91\u0dbd\u0dca.\u0dc3\u0dd3.\u0dc3\u0dda\u0db1\u0dc3\u0dda\u0d9a\u0dbb",
    ta: "\u0b9f\u0bbf.\u0b9a\u0bbf. & \u0b8e\u0bb2\u0bcd.\u0b9a\u0bbf. \u0b9a\u0bc7\u0ba9\u0b9a\u0bc7\u0b95\u0bb0",
  },
  "D.M.D.WILLIAM APPUHAMY & SONS": {
    si: "D.M.D.\u0dc0\u0dd2\u0dbd\u0dd2\u0dba\u0db8\u0dca \u0d85\u0db4\u0dca\u0db4\u0dd4\u0dc4\u0dcf\u0db8\u0dd2 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b9f\u0bbf.\u0b8e\u0bae\u0bcd.\u0b9f\u0bbf.\u0bb5\u0bbf\u0bb2\u0bcd\u0bb2\u0bbf\u0baf\u0bae\u0bcd \u0b85\u0baa\u0bcd\u0baa\u0bc1\u0bb9\u0bbe\u0bae\u0bbf & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "D.N.GALHENA - SH": {
    si: "\u0da9\u0dd3.\u0d91\u0db1\u0dca.\u0d9c\u0dbd\u0dca\u0dc4\u0dda\u0db1 - \u0d91\u0dc3\u0dca.\u0d91\u0da0\u0dca",
    ta: "\u0b9f\u0bbf.\u0b8e\u0ba9\u0bcd.\u0b95\u0bb2\u0bcd\u0bb9\u0bc7\u0ba9 - \u0b8e\u0bb8\u0bcd.\u0b8e\u0b9a\u0bcd",
  },
  "D.P.KUMARAGE": {
    si: "\u0da9\u0dd3.\u0db4\u0dd3.\u0d9a\u0dd4\u0db8\u0dcf\u0dbb\u0d9c\u0dda",
    ta: "\u0b9f\u0bbf.\u0baa\u0bbf.\u0b95\u0bc1\u0bae\u0bbe\u0bb0\u0bc7\u0b9c\u0bcd",
  },
  "D.S.Senanayake Mawatha, Colombo": {
    si: "\u0da9\u0dd3.\u0d91\u0dc3\u0dca.\u0dc3\u0dda\u0db1\u0dcf\u0db1\u0dcf\u0dba\u0d9a \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9",
    ta: "\u0b9f\u0bbf.\u0b8e\u0bb8\u0bcd.\u0b9a\u0bc7\u0ba9\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "D.W.A .HAPUARACHCHI & COMPANY": {
    si: "D.W.A .\u0dc4\u0db4\u0dd4\u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2 \u0dc3\u0dc4 \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "D.W.A .\u0bb9\u0baa\u0bcd\u0baa\u0bc1\u0b86\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf & \u0ba8\u0bbf\u0bb1\u0bc1\u0bb5\u0ba9\u0bae\u0bcd",
  },
  "D.W.A.U.DIKWELLA": {
    si: "\u0da9\u0dd3.\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0d92.\u0d8b.\u0daf\u0dd2\u0d9a\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0b9f\u0bbf.\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0b8f.\u0baf\u0bc1.\u0b9f\u0bbf\u0b95\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2",
  },
  "D.W.AJITH": {
    si: "\u0da9\u0dd3.\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0d85\u0da2\u0dd2\u0dad\u0dca",
    ta: "\u0b9f\u0bbf.\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0b85\u0b9c\u0bbf\u0ba4\u0bcd",
  },
  "DAMBADENIYA MPCS LTD": {
    si: "\u0daf\u0db9\u0daf\u0dd9\u0dab\u0dd2\u0dba MPCS LTD",
    ta: "\u0ba4\u0bae\u0bcd\u0baa\u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe MPCS LTD",
  },
  "DAMBULLA.": {
    si: "\u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd.",
    ta: "\u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe.",
  },
  "DAMITH ENTERPRISES": {
    si: "\u0daf\u0db8\u0dd2\u0dad\u0dca \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0ba4\u0bae\u0bbf\u0ba4\u0bcd \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "DARMADASA LIYANAGE": {
    si: "\u0daf\u0dbb\u0dca\u0db8\u0daf\u0dcf\u0dc3 \u0dbd\u0dd2\u0dba\u0db1\u0d9c\u0dda",
    ta: "\u0ba4\u0bb0\u0bcd\u0bae\u0ba4\u0bbe\u0b9a \u0bb2\u0bbf\u0baf\u0ba9\u0b95\u0bc7",
  },
  "DAVIDSON FILLING STATION": {
    si: "\u0da9\u0dda\u0dc0\u0dd2\u0da9\u0dca\u0dc3\u0db1\u0dca \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b9f\u0bc7\u0bb5\u0bbf\u0b9f\u0bcd\u0b9a\u0ba9\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "DERINIYAGALA PANAWELA MPCS LTD.": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0daf\u0dd9\u0dab\u0dd2\u0dba\u0dcf\u0d9c\u0dbd \u0db4\u0db1\u0dcf\u0dc0\u0dbd MPCS.",
    ta: "\u0ba4\u0bc6\u0bb0\u0bbf\u0ba9\u0bbf\u0baf\u0b95\u0bb2 \u0baa\u0ba9\u0bb5\u0bc6\u0bb2 MPCS LTD.",
  },
  "DEVTURU ENTERPRISES (PVT) LTD": {
    si: "DEVTURU ENTERPRISES (PVT) LTD",
    ta: "\u0ba4\u0bc7\u0bb5\u0bcd\u0ba4\u0bc1\u0bb0\u0bc1 \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "DHAMMIKA ENTERPRISES": {
    si: "\u0db0\u0db8\u0dca\u0db8\u0dd2\u0d9a \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0ba4\u0bae\u0bcd\u0bae\u0bbf\u0b95\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "DHANUSHKA ENGG. PVT LTD": {
    si: "\u0db0\u0db1\u0dd4\u0dc2\u0dca\u0d9a \u0d89\u0d82\u0da2\u0dd2\u0db1\u0dda\u0dbb\u0dd4. PVT LTD",
    ta: "\u0ba4\u0ba9\u0bc1\u0bb7\u0bcd\u0b95\u0bbe \u0b87\u0ba9\u0bcd\u0b9c\u0bbf. \u0baa\u0bbf\u0bb0\u0bc8\u0bb5\u0bc7\u0b9f\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "DICKWELLA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0daf\u0dd2\u0d9a\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd MPCS",
    ta: "\u0b9f\u0bbf\u0b95\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe MPCS LTD",
  },
  "DILKI ENTERPRISES": {
    si: "\u0daf\u0dd2\u0dbd\u0dca\u0d9a\u0dd2 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0ba4\u0bbf\u0bb2\u0bcd\u0b95\u0bbf \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "DIMBULAGALA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0daf\u0dd2\u0db9\u0dd4\u0dbd\u0dcf\u0d9c\u0dbd MPCS",
    ta: "\u0b9f\u0bbf\u0bae\u0bcd\u0baa\u0bc1\u0bb2\u0bbe\u0b95\u0bb2 MPCS LTD",
  },
  "DINA FAIROOS (PVT) LTD": {
    si: "DINA FAIROOS (PVT) LTD",
    ta: "\u0b9f\u0bbf\u0ba9\u0bbe \u0b83\u0baa\u0bc8\u0bb0\u0bc2\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "DISSANAYAKE ENTERPRICES": {
    si: "\u0daf\u0dd2\u0dc3\u0dcf\u0db1\u0dcf\u0dba\u0d9a \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0ba4\u0bbf\u0b9a\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "DISSANAYAKE ENTERPRISES": {
    si: "\u0daf\u0dd2\u0dc3\u0dcf\u0db1\u0dcf\u0dba\u0d9a \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0ba4\u0bbf\u0b9a\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "DISSANAYAKE MAN POWER TRANSPORT SUP": {
    si: "\u0daf\u0dd2\u0dc3\u0dcf\u0db1\u0dcf\u0dba\u0d9a \u0db8\u0dd2\u0db1\u0dd2\u0dc3\u0dca \u0db6\u0dbd \u0db4\u0dca\u200d\u0dbb\u0dc0\u0dcf\u0dc4\u0db1 \u0dc3\u0dc4\u0dcf\u0dba",
    ta: "\u0ba4\u0bbf\u0b9a\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0bae\u0ba9\u0bbf\u0ba4 \u0b9a\u0b95\u0bcd\u0ba4\u0bbf \u0baa\u0bcb\u0b95\u0bcd\u0b95\u0bc1\u0bb5\u0bb0\u0ba4\u0bcd\u0ba4\u0bc1 \u0b89\u0ba4\u0bb5\u0bbf",
  },
  "DIVULAPITIYA MPCS LTD": {
    si: "\u0daf\u0dd2\u0dc0\u0dd4\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba MPCS LTD",
    ta: "\u0ba4\u0bbf\u0bb5\u0bc1\u0bb2\u0bbe\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf MPCS LTD",
  },
  DODANGASLANDA: {
    si: "\u0daf\u0ddc\u0da9\u0d82\u0d9c\u0dc3\u0dca\u0dbd\u0db1\u0dca\u0daf",
    ta: "\u0ba4\u0bcb\u0b9f\u0b99\u0bcd\u0b95\u0bb8\u0bcd\u0bb2\u0bbe\u0ba3\u0bcd\u0b9f\u0bbe",
  },
  "DOMPE PUGODA MPCS LTD": {
    si: "\u0daf\u0ddc\u0db8\u0dca\u0db4\u0dda \u0db4\u0dd6\u0d9c\u0ddc\u0da9 MPCS LTD",
    ta: "\u0ba4\u0bca\u0bae\u0bcd\u0baa\u0bc7 \u0baa\u0bc2\u0b95\u0bcb\u0b9f\u0bbe MPCS LTD",
  },
  "DON DIAS DAMINDA JAYAMAL": {
    si: "\u0daf\u0ddc\u0db1\u0dca \u0da9\u0dba\u0dc3\u0dca \u0daf\u0db8\u0dd2\u0db1\u0dca\u0daf \u0da2\u0dba\u0db8\u0dcf\u0dbd\u0dca",
    ta: "\u0b9f\u0bbe\u0ba9\u0bcd \u0b9f\u0baf\u0bb8\u0bcd \u0ba4\u0bae\u0bbf\u0ba8\u0bcd\u0ba4 \u0b9c\u0bc6\u0baf\u0bae\u0bbe\u0bb2\u0bcd",
  },
  "DON SOMAPALA COMPANY PVT LTD": {
    si: "\u0daf\u0ddc\u0db1\u0dca \u0dc3\u0ddd\u0db8\u0db4\u0dcf\u0dbd \u0dc3\u0db8\u0dcf\u0d9c\u0db8 \u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0b9f\u0bbe\u0ba9\u0bcd \u0b9a\u0bcb\u0bae\u0baa\u0bbe\u0bb2 \u0b95\u0bae\u0bcd\u0baa\u0ba9\u0bbf \u0baa\u0bbf\u0bb0\u0bc8\u0bb5\u0bc7\u0b9f\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "DON SUMINDARA ABEYSINGHE": {
    si: "\u0daf\u0ddc\u0db1\u0dca \u0dc3\u0dd4\u0db8\u0dd2\u0db1\u0dca\u0daf\u0dbb \u0d85\u0db6\u0dda\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b9f\u0bca\u0ba9\u0bcd \u0b9a\u0bc1\u0bae\u0bbf\u0ba8\u0bcd\u0ba4\u0bb0 \u0b85\u0baa\u0bc7\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "DR.  SANJAYA SEDARA SENARATH": {
    si: "\u0d86\u0da0\u0dcf\u0dbb\u0dca\u0dba. \u0dc3\u0d82\u0da2\u0dba \u0dc3\u0dda\u0daf\u0dbb \u0dc3\u0dd9\u0db1\u0dbb\u0dad\u0dca",
    ta: "DR \u0b9a\u0b9e\u0bcd\u0b9a\u0baf \u0b9a\u0bc7\u0ba4\u0bb0 \u0b9a\u0bc6\u0ba9\u0bb0\u0ba4\u0bcd",
  },
  "DR.S.KETHESWARAM PILLAI": {
    si: "\u0d86\u0da0\u0dcf\u0dbb\u0dca\u0dba \u0d9a\u0dda\u0dad\u0dda\u0dc1\u0dca\u0dc0\u0dbb\u0db8\u0dca \u0db4\u0dd2\u0dbd\u0dca\u0dbd\u0dda",
    ta: "\u0b9f\u0bbe\u0b95\u0bcd\u0b9f\u0bb0\u0bcd.\u0b8e\u0bb8\u0bcd.\u0b95\u0bc7\u0ba4\u0bc7\u0bb8\u0bcd\u0bb5\u0bb0\u0bae\u0bcd \u0baa\u0bbf\u0bb3\u0bcd\u0bb3\u0bc8",
  },
  "Dalugama Kelaniya": {
    si: "Dalugama Kelaniya",
    ta: "Dalugama Kelaniya",
  },
  "Daluwakotuwa-Kochchikade": {
    si: "\u0daf\u0dc5\u0dd4\u0dc0\u0d9a\u0ddc\u0da7\u0dd4\u0dc0-\u0d9a\u0ddc\u0da0\u0dca\u0da0\u0dd2\u0d9a\u0da9\u0dda",
    ta: "\u0ba4\u0bb3\u0bc1\u0bb5\u0b95\u0bca\u0b9f\u0bc1\u0bb5 - \u0b95\u0bca\u0b9a\u0bcd\u0b9a\u0bbf\u0b95\u0bcd\u0b95\u0b9f\u0bc8",
  },
  "Dambadeniya B 27, Dambadeniya, Sri Lanka": {
    si: "\u0daf\u0db9\u0daf\u0dd9\u0dab\u0dd2\u0dba \u0db6\u0dd3 27, \u0daf\u0db9\u0daf\u0dd9\u0dab\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Dambadeniya B 27, Dambadeniya, Sri Lanka",
  },
  Dambulla: {
    si: "\u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8",
  },
  "Dambulla Road, Gokarella, Kurunegala": {
    si: "\u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d9c\u0ddc\u0d9a\u0dbb\u0dd0\u0dbd\u0dca\u0dbd, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd",
    ta: "\u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bca\u0b95\u0bb0\u0bc6\u0bb2\u0bcd\u0bb2, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd",
  },
  "Dambulla.": {
    si: "\u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd.",
    ta: "\u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8.",
  },
  "Dambulugama Junction, Ambepussa - Kurunegala - Trincomalee Hwy, Dambulla": {
    si: "\u0daf\u0db9\u0dd4\u0dbd\u0dd4\u0d9c\u0db8 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0d85\u0db9\u0dda\u0db4\u0dd4\u0dc3\u0dca\u0dc3 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb2\u0bc1\u0b95\u0bae \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0b85\u0bae\u0bcd\u0baa\u0bc7\u0baa\u0bc1\u0bb8\u0bcd\u0bb8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8",
  },
  Dankotuwa: {
    si: "\u0daf\u0db1\u0dca\u0d9a\u0ddc\u0da7\u0dd4\u0dc0",
    ta: "\u0ba4\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bc1\u0bb5",
  },
  "Darmapala Balika Maha Vidyalaya, Puwakdandawa, Sri Lanka": {
    si: "\u0daf\u0dbb\u0dca\u0db8\u0db4\u0dcf\u0dbd \u0db6\u0dcf\u0dbd\u0dd2\u0d9a\u0dcf \u0db8\u0dc4\u0dcf \u0dc0\u0dd2\u0daf\u0dca\u200d\u0dba\u0dcf\u0dbd\u0dba, \u0db4\u0dd4\u0dc0\u0d9a\u0dca\u0daf\u0dab\u0dca\u0da9\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba4\u0bb0\u0bcd\u0bae\u0baa\u0bbe\u0bb2 \u0baa\u0bbe\u0bb2\u0bbf\u0b95\u0bbe \u0bae\u0b95\u0bbe \u0bb5\u0bbf\u0ba4\u0bcd\u0ba4\u0bbf\u0baf\u0bbe\u0bb2\u0baf\u0bae\u0bcd, \u0baa\u0bc1\u0bb5\u0b95\u0bcd\u0ba4\u0ba3\u0bcd\u0b9f\u0bbe\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "De S Kularatne Mawatha, Colombo -10": {
    si: "\u0daf \u0d91\u0dc3\u0dca \u0d9a\u0dd4\u0dbd\u0dbb\u0dad\u0dca\u0db1 \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 -10",
    ta: "\u0b9f\u0bbf \u0b8e\u0bb8\u0bcd \u0b95\u0bc1\u0bb2\u0bb0\u0ba4\u0bcd\u0ba9 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 -10",
  },
  "Dehiattakandiya Petrol Stand, B517, Dehiattakandiya": {
    si: "\u0daf\u0dd9\u0dc4\u0dd2\u0d85\u0dad\u0dca\u0dad\u0d9a\u0dab\u0dca\u0da9\u0dd2\u0dba \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db6\u0dd3517, \u0daf\u0dd9\u0dc4\u0dd2\u0d85\u0dad\u0dca\u0dad\u0d9a\u0dab\u0dca\u0da9\u0dd2\u0dba",
    ta: "\u0ba4\u0bc6\u0bb9\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0b95\u0ba3\u0bcd\u0b9f\u0bbf\u0baf \u0baa\u0bc6\u0bb1\u0bcd\u0bb1\u0bcb\u0bb2\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, B517, \u0ba4\u0bc6\u0bb9\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0b95\u0ba3\u0bcd\u0b9f\u0bbf",
  },
  "Dehiowita - Deraniyagala - Noori Rd, Deraniyagala": {
    si: "\u0daf\u0dd9\u0dc4\u0dd2\u0d95\u0dc0\u0dd2\u0da7 - \u0daf\u0dd0\u0dbb\u0dab\u0dd2\u0dba\u0d9c\u0dbd - \u0db1\u0dd6\u0dbb\u0dd2 \u0db4\u0dcf\u0dbb, \u0daf\u0dd0\u0dbb\u0dab\u0dd2\u0dba\u0d9c\u0dbd",
    ta: "\u0ba4\u0bc6\u0bb9\u0bbf\u0baf\u0bcb\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f - \u0ba4\u0bc6\u0bb0\u0ba3\u0bbf\u0baf\u0b95\u0bb2 - \u0ba8\u0bc2\u0bb0\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bc6\u0bb0\u0ba3\u0bbf\u0baf\u0b95\u0bb2",
  },
  "Dehiwala - Mount Lavinia": {
    si: "\u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd - \u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3",
    ta: "\u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8 - \u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8",
  },
  "Delgoda - Pugoda Rd": {
    si: "\u0daf\u0dd9\u0dbd\u0dca\u0d9c\u0ddc\u0da9 - \u0db4\u0dd6\u0d9c\u0ddc\u0da9 \u0db4\u0dcf\u0dbb",
    ta: "\u0ba4\u0bc6\u0bb2\u0bcd\u0b95\u0bca\u0b9f - \u0baa\u0bc2\u0b95\u0bca\u0b9f \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  "Delkade, Koattagoda, Sri Lanka": {
    si: "\u0daf\u0dd9\u0dbd\u0dca\u0d9a\u0da9\u0dda, \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b9f\u0bc6\u0bb2\u0bcd\u0b95\u0b9f\u0bc7, \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0b95\u0bcb\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Deltota: {
    si: "\u0daf\u0dd9\u0dbd\u0dca\u0dad\u0ddc\u0da7",
    ta: "\u0b9f\u0bc6\u0bb2\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bbe",
  },
  "Demanhandiya - Miriswatta": {
    si: "\u0daf\u0dd9\u0db8\u0db1\u0dca\u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba - \u0db8\u0dd2\u0dbb\u0dd2\u0dc3\u0dca\u0dc0\u0dad\u0dca\u0dad",
    ta: "\u0ba4\u0bc6\u0bae\u0ba9\u0bcd\u0bb9\u0ba8\u0bcd\u0ba4\u0bbf\u0baf - \u0bae\u0bbf\u0bb0\u0bbf\u0bb8\u0bcd\u0bb5\u0ba4\u0bcd\u0ba4",
  },
  "Denipitiya Fuel Station, , Denipitiya, Weligama": {
    si: "\u0daf\u0dd9\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, , \u0daf\u0dd9\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc0\u0dd0\u0dbd\u0dd2\u0d9c\u0db8",
    ta: "\u0ba4\u0bc6\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, , \u0ba4\u0bc6\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0bb5\u0bc6\u0bb2\u0bbf\u0b95\u0bae",
  },
  "Deniyaya - Wiharahena Rd, Deniyaya": {
    si: "\u0daf\u0dd9\u0db1\u0dd2\u0dba\u0dcf\u0dba - \u0dc0\u0dd2\u0dc4\u0dcf\u0dbb\u0dc4\u0dda\u0db1 \u0db4\u0dcf\u0dbb, \u0daf\u0dd9\u0db1\u0dd2\u0dba\u0dcf\u0dba",
    ta: "\u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe\u0baf - \u0bb5\u0bbf\u0bb9\u0bbe\u0bb0\u0bb9\u0bc7\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe\u0baf",
  },
  Deraniyagala: {
    si: "\u0daf\u0dd0\u0dbb\u0dab\u0dd2\u0dba\u0d9c\u0dbd",
    ta: "\u0ba4\u0bc6\u0bb0\u0ba3\u0bbf\u0baf\u0b95\u0bb2",
  },
  "Deraniyagala Bus Station, Deraniyagala, Sri Lanka": {
    si: "\u0daf\u0dd0\u0dbb\u0dab\u0dd2\u0dba\u0d9c\u0dbd \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8\u0dca\u0db4\u0ddc\u0dc5, \u0daf\u0dd0\u0dbb\u0dab\u0dd2\u0dba\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba4\u0bc6\u0bb0\u0ba3\u0bbf\u0baf\u0b95\u0bb2 \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0ba4\u0bc6\u0bb0\u0ba3\u0bbf\u0baf\u0b95\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Devata Junction": {
    si: "\u0daf\u0dd9\u0dc0\u0da7 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba",
    ta: "\u0ba4\u0bc7\u0bb5\u0ba4\u0bbe \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf",
  },
  "Dewata Junction Katugoda, Galle, Sri Lanka": {
    si: "\u0daf\u0dd9\u0dc0\u0da7 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba \u0d9a\u0da7\u0dd4\u0d9c\u0ddc\u0da9, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba4\u0bc7\u0bb5\u0ba4\u0bbe \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0b95\u0bca\u0b9f\u0bbe, \u0b95\u0bbe\u0bb2\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Dickson Moters Rd, Kurunegala": {
    si: "\u0da9\u0dd2\u0d9a\u0dca\u0dc3\u0db1\u0dca \u0db8\u0ddd\u0da7\u0dbb\u0dca\u0dc3\u0dca \u0db4\u0dcf\u0dbb, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd",
    ta: "\u0b9f\u0bbf\u0b95\u0bcd\u0b9a\u0ba9\u0bcd \u0bae\u0bcb\u0b9f\u0bcd\u0b9f\u0bb0\u0bcd\u0bb8\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd",
  },
  Dikowita: {
    si: "\u0daf\u0dd2\u0d9a\u0dca\u0d95\u0dc0\u0dd2\u0da7",
    ta: "\u0b9f\u0bbf\u0b95\u0bcb\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f",
  },
  "Dikwella - Beliatte Rd, Walasgala": {
    si: "\u0daf\u0dd2\u0d9a\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd - \u0db6\u0dd9\u0dbd\u0dd2\u0d85\u0dad\u0dca\u0dad \u0db4\u0dcf\u0dbb, \u0dc0\u0dbd\u0dc3\u0dca\u0d9c\u0dbd",
    ta: "\u0b9f\u0bbf\u0b95\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 - \u0baa\u0bc6\u0bb2\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bb2\u0bb8\u0bcd\u0b95\u0bb2",
  },
  "Diulwewa-galgamuwa": {
    si: "\u0daf\u0dd2\u0dbd\u0dca\u0dc0\u0dd0\u0dc0-\u0d9c\u0dbd\u0dca\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0ba4\u0bbf\u0baf\u0bc1\u0bb2\u0bcd\u0bb5\u0bc6\u0bb5-\u0b95\u0bb2\u0bcd\u0b95\u0bae\u0bc1\u0bb5",
  },
  Divulapitiya: {
    si: "\u0daf\u0dd2\u0dc0\u0dd4\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0ba4\u0bbf\u0bb5\u0bc1\u0bb2\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  Divulkumbura: {
    si: "\u0daf\u0dd2\u0dc0\u0dd4\u0dbd\u0dca\u0d9a\u0dd4\u0db9\u0dd4\u0dbb",
    ta: "\u0ba4\u0bbf\u0bb5\u0bc1\u0bb2\u0bcd\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0bb0",
  },
  "Divurmpitiya,Gatahatta": {
    si: "\u0daf\u0dd2\u0dc0\u0dd4\u0dbb\u0dd4\u0db8\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0d9c\u0dd0\u0da7\u0dc4\u0dad\u0dca\u0dad",
    ta: "\u0ba4\u0bbf\u0bb5\u0bc1\u0bb0\u0bcd\u0bae\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b95\u0b9f\u0bcd\u0b9f\u0bb9\u0b9f\u0bcd\u0b9f",
  },
  Diyasenpura: {
    si: "Diyasenpura",
    ta: "Diyasenpura",
  },
  Diyathalawa: {
    si: "\u0daf\u0dd2\u0dba\u0dad\u0dbd\u0dcf\u0dc0",
    ta: "\u0ba4\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe\u0bb5",
  },
  Dodanduwa: {
    si: "\u0daf\u0ddc\u0da9\u0db1\u0dca\u0daf\u0dd6\u0dc0",
    ta: "\u0ba4\u0bca\u0b9f\u0ba8\u0bcd\u0ba4\u0bc1\u0bb5",
  },
  Dodangaslanda: {
    si: "\u0daf\u0ddc\u0da9\u0d82\u0d9c\u0dc3\u0dca\u0dbd\u0db1\u0dca\u0daf",
    ta: "\u0ba4\u0bca\u0b9f\u0b99\u0bcd\u0b95\u0bb8\u0bcd\u0bb2\u0bbe\u0ba3\u0bcd\u0b9f\u0bbe",
  },
  "Don't Know or Not Sure": {
    si: "\u0daf\u0db1\u0dca\u0db1\u0dda \u0db1\u0dd0\u0dc4\u0dd0 \u0dc4\u0ddd \u0dc0\u0dd2\u0dc1\u0dca\u0dc0\u0dcf\u0dc3 \u0db1\u0dd0\u0dc4\u0dd0",
    ta: "\u0ba4\u0bc6\u0bb0\u0bbf\u0baf\u0bbe\u0ba4\u0bc1 \u0b85\u0bb2\u0bcd\u0bb2\u0ba4\u0bc1 \u0b89\u0bb1\u0bc1\u0ba4\u0bbf\u0baf\u0bbe\u0b95 \u0ba4\u0bc6\u0bb0\u0bbf\u0baf\u0bb5\u0bbf\u0bb2\u0bcd\u0bb2\u0bc8",
  },
  "Dudley Senanayake Mawatha, Colombo -08": {
    si: "\u0da9\u0da9\u0dca\u0dbd\u0dd2 \u0dc3\u0dda\u0db1\u0dcf\u0db1\u0dcf\u0dba\u0d9a \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 -08",
    ta: "\u0b9f\u0b9f\u0bcd\u0bb2\u0bbf \u0b9a\u0bc7\u0ba9\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 -08",
  },
  "Dunkannawa Dialog, Marawila - Udubaddawa Rd, Sri Lanka": {
    si: "\u0daf\u0dd4\u0db1\u0dca\u0d9a\u0db1\u0dca\u0db1\u0dcf\u0dc0 \u0da9\u0dba\u0dbd\u0ddc\u0d9c\u0dca, \u0db8\u0dcf\u0dbb\u0dc0\u0dd2\u0dbd - \u0d8b\u0da9\u0dd4\u0db6\u0daf\u0dca\u0daf\u0dcf\u0dc0 \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba4\u0bc1\u0b99\u0bcd\u0b95\u0ba9\u0bcd\u0ba9\u0bbe\u0bb5 \u0b9f\u0baf\u0bb2\u0bca\u0b95\u0bcd, \u0bae\u0bbe\u0bb0\u0bb5\u0bbf\u0bb2 - \u0b89\u0b9f\u0bc1\u0baa\u0ba4\u0bcd\u0ba4\u0bbe\u0bb5 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "E G P A RUPASINGHE": {
    si: "\u0d8a \u0da2\u0dd3 \u0db4\u0dd3 \u0d92 \u0dbb\u0dd6\u0db4\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b88 \u0b9c\u0bbf \u0baa\u0bbf \u0b8f \u0bb0\u0bc2\u0baa\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "E L Senanayake Veediya, Kandy": {
    si: "\u0d8a \u0d91\u0dbd\u0dca \u0dc3\u0dda\u0db1\u0dcf\u0db1\u0dcf\u0dba\u0d9a \u0dc0\u0dd3\u0daf\u0dd2\u0dba, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb",
    ta: "\u0b87 \u0b8e\u0bb2\u0bcd \u0b9a\u0bc7\u0ba9\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf",
  },
  "E M N EKANAYAKE": {
    si: "\u0d8a \u0d91\u0db8\u0dca \u0d91\u0db1\u0dca \u0d92\u0d9a\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b88 \u0b8e\u0bae\u0bcd \u0b8e\u0ba9\u0bcd \u0b8f\u0b95\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "E P B DE SOYSA & SONS (PVT) LTD": {
    si: "E P B DE SOYSA & SONS (PVT) LTD",
    ta: "E P B DE SOYSA & SONS (PVT) LTD",
  },
  "E. G.WIMALASENA": {
    si: "\u0d8a.\u0da2\u0dd3.\u0dc0\u0dd2\u0db8\u0dbd\u0dc3\u0dda\u0db1",
    ta: "\u0b88.\u0b9c\u0bbf.\u0bb5\u0bbf\u0bae\u0bb2\u0b9a\u0bc7\u0ba9",
  },
  "E.GUNASINGHE": {
    si: "\u0d8a.\u0d9c\u0dd4\u0dab\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b87.\u0b95\u0bc1\u0ba3\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "E.M.GUNERATNE & SON": {
    si: "E.M.GUNERATNE & SON",
    ta: "\u0b88.\u0b8e\u0bae\u0bcd.\u0b95\u0bc1\u0ba3\u0bb0\u0ba4\u0bcd\u0ba9 & \u0bae\u0b95\u0ba9\u0bcd",
  },
  "EBERT SILVA AUTO. ENG.CO.(PVT)LTD": {
    si: "\u0d8a\u0db6\u0da7\u0dca \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf \u0d94\u0da7\u0ddd. ENG.CO.(PVT)LTD",
    ta: "\u0b88\u0baa\u0bb0\u0bcd\u0b9f\u0bcd \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe \u0b86\u0b9f\u0bcd\u0b9f\u0bcb. ENG.CO.(PVT)LTD",
  },
  "EHALIYAGODA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d87\u0dc4\u0dd0\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9 MPCS",
    ta: "\u0b8e\u0bb9\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f MPCS LTD",
  },
  "EHELIYAGODA ASSOCIATES": {
    si: "\u0d87\u0dc4\u0dd0\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9 \u0d87\u0dc3\u0ddd\u0dc3\u0dd2\u0dba\u0dda\u0da7\u0dca\u0dc3\u0dca",
    ta: "\u0b8e\u0bb9\u0bc6\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f \u0b85\u0b9a\u0bcb\u0b9a\u0bbf\u0baf\u0bc7\u0b9f\u0bcd\u0bb8\u0bcd",
  },
  "EHELIYAGODA MPCS LTD": {
    si: "\u0d87\u0dc4\u0dd0\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9 MPCS LTD",
    ta: "\u0b8e\u0bb9\u0bc6\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f MPCS LTD",
  },
  "ELAHERA SCHEME MPCS LTD": {
    si: "\u0d87\u0dbd\u0dc4\u0dd0\u0dbb \u0dba\u0ddd\u0da2\u0db1\u0dcf \u0d9a\u0dca\u200d\u0dbb\u0db8\u0dba MPCS LTD",
    ta: "\u0b8e\u0bb2\u0bb9\u0bc6\u0bb0\u0bbe \u0ba4\u0bbf\u0b9f\u0bcd\u0b9f\u0bae\u0bcd MPCS LTD",
  },
  "ELIYATHAMBI  ANSAR": {
    si: "\u0d91\u0dbd\u0dd2\u0dba\u0dad\u0db8\u0dca\u0db6\u0dd2 \u0d85\u0db1\u0dca\u0dc3\u0dcf\u0dbb\u0dca",
    ta: "\u0b8e\u0bb2\u0bbf\u0baf\u0ba4\u0bae\u0bcd\u0baa\u0bbf \u0b85\u0ba9\u0bcd\u0b9a\u0bbe\u0bb0\u0bcd",
  },
  "ELLAPOLA ENTERPRISES": {
    si: "\u0d87\u0dbd\u0dca\u0dbd\u0db4\u0ddc\u0dbd \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b8e\u0bb2\u0bcd\u0bb2\u0baa\u0bca\u0bb2 \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  ELPITIYA: {
    si: "\u0d87\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0b8e\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0bbe",
  },
  "ELPITIYA MPCS LTD": {
    si: "\u0d87\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba MPCS LTD",
    ta: "\u0b8e\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0bbe MPCS LTD",
  },
  EMBILIPITIYA: {
    si: "\u0d87\u0db9\u0dd2\u0dbd\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0bb2\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "ENZ LAB (PRIVATE) LTD": {
    si: "ENZ LAB (Private) LTD",
    ta: "ENZ \u0bb2\u0bc7\u0baa\u0bcd (\u0baa\u0bbf\u0bb0\u0bc8\u0bb5\u0bc7\u0b9f\u0bcd) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "ERANGA ENTERPRISES (PVT) LTD": {
    si: "\u0d91\u0dbb\u0d82\u0d9c \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b8e\u0bb0\u0b99\u0bcd\u0b95\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "ERAVUR MPCS LTD": {
    si: "ERAVUR MPCS LTD",
    ta: "\u0b8f\u0bb1\u0bbe\u0bb5\u0bc2\u0bb0\u0bcd MPCS LTD",
  },
  "ERAVUR NORTH AND WEST MPCS LTD": {
    si: "\u0d91\u0dbb\u0dcf\u0dc0\u0dd6\u0dbb\u0dca \u0db1\u0ddd\u0dbb\u0dca\u0dad\u0dca \u0d87\u0db1\u0dca\u0da9\u0dca \u0dc0\u0dd9\u0dc3\u0dca\u0da7\u0dca \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b8f\u0bb1\u0bbe\u0bb5\u0bc2\u0bb0\u0bcd \u0bb5\u0b9f\u0b95\u0bcd\u0b95\u0bc1 \u0bae\u0bb1\u0bcd\u0bb1\u0bc1\u0bae\u0bcd \u0bae\u0bc7\u0bb1\u0bcd\u0b95\u0bc1 MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "ESCAYCEE TRAVELS LTD": {
    si: "ESCAYCEE Travels LTD",
    ta: "\u0b8e\u0bb8\u0bcd\u0b95\u0bc7\u0b9a\u0bbf \u0b9f\u0bbf\u0bb0\u0bbe\u0bb5\u0bb2\u0bcd\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "EURO LANKA ENTERPRISES (PVT) LTD": {
    si: "EURO LANKA ENTERPRISES (PVT) LTD",
    ta: "EURO LANKA ENTERPRISES (PVT) LTD",
  },
  "EVER PRAY ENTERPRISES (PVT) LTD": {
    si: "EVER PRAY ENTERPRISES (PVT) LTD",
    ta: "\u0b8e\u0bb5\u0bb0\u0bcd \u0baa\u0bcd\u0bb0\u0bc7 \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "Egoda Uyana, Moratuwa": {
    si: "Egoda Uyana, Moratuwa",
    ta: "Egoda Uyana, Moratuwa",
  },
  Eheliyagoda: {
    si: "\u0d87\u0dc4\u0dd0\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9",
    ta: "\u0b8e\u0bb9\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f",
  },
  "Ekala - Kotadeniyawa Rd, Ballapana": {
    si: "\u0d92\u0d9a\u0dbd - \u0d9a\u0ddc\u0da7\u0daf\u0dd9\u0dab\u0dd2\u0dba\u0dcf\u0dc0 \u0db4\u0dcf\u0dbb, \u0db6\u0dbd\u0dca\u0dbd\u0db4\u0dcf\u0db1",
    ta: "\u0b8f\u0b95\u0bb2 - \u0b95\u0bca\u0b9f\u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bb2\u0bcd\u0bb2\u0baa\u0ba9",
  },
  "Ekala - Kotadeniyawa Rd, Divulapitiya": {
    si: "\u0d92\u0d9a\u0dbd - \u0d9a\u0ddc\u0da7\u0daf\u0dd9\u0dab\u0dd2\u0dba\u0dcf\u0dc0 \u0db4\u0dcf\u0dbb, \u0daf\u0dd2\u0dc0\u0dd4\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0b8f\u0b95\u0bb2 - \u0b95\u0bca\u0b9f\u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bbf\u0bb5\u0bc1\u0bb2\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Ekala - Kotadeniyawa Rd, Kotugoda": {
    si: "\u0d92\u0d9a\u0dbd - \u0d9a\u0ddc\u0da7\u0daf\u0dd9\u0dab\u0dd2\u0dba\u0dcf\u0dc0 \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0da7\u0dd4\u0d9c\u0ddc\u0da9",
    ta: "\u0b8f\u0b95\u0bb2 - \u0b95\u0bca\u0b9f\u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bca\u0b9f\u0bc1\u0b95\u0bca\u0b9f",
  },
  "Ekala, A33, Ja-Ela": {
    si: "\u0d92\u0d9a\u0dbd, A33, \u0da2\u0dcf-\u0d87\u0dbd",
    ta: "\u0b8f\u0b95\u0bb2, \u0b8f33, \u0b9c\u0bbe-\u0b8e\u0bb2",
  },
  Elahara: {
    si: "\u0d91\u0dbd\u0dc4\u0dcf\u0dbb",
    ta: "\u0b8e\u0bb2\u0bb9\u0bbe\u0bb0\u0bbe",
  },
  Elahera: {
    si: "\u0d87\u0dbd\u0dc4\u0dd0\u0dbb",
    ta: "\u0b8e\u0bb2\u0bb9\u0bc6\u0bb0\u0bbe",
  },
  "Ella - Passara Rd, Balleketuwa, Ballekatuwa": {
    si: "\u0d87\u0dbd\u0dca\u0dbd - \u0db4\u0dc3\u0dca\u0dc3\u0dbb \u0db4\u0dcf\u0dbb, \u0db6\u0dd0\u0dbd\u0dca\u0dbd\u0d9a\u0dd0\u0da7\u0dd4\u0dc0, \u0db6\u0dd0\u0dbd\u0dca\u0dbd\u0d9a\u0da7\u0dd4\u0dc0",
    ta: "\u0b8e\u0bb2\u0bcd\u0bb2 - \u0baa\u0b9a\u0bb0 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bb2\u0bcd\u0bb2\u0bc7\u0b95\u0bc6\u0b9f\u0bc1\u0bb5, \u0baa\u0bb2\u0bcd\u0bb2\u0bc7\u0b95\u0b9f\u0bc1\u0bb5",
  },
  Elpitiya: {
    si: "\u0d87\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0b8e\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Elvitigala Mawatha, Colombo - 05": {
    si: "\u0d87\u0dbd\u0dca\u0dc0\u0dd2\u0da7\u0dd2\u0d9c\u0dbd \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 - 05",
    ta: "\u0b8e\u0bb2\u0bcd\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bb2 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - 05",
  },
  Embilipitiya: {
    si: "\u0d87\u0db9\u0dd2\u0dbd\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0bb2\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  English: {
    si: "\u0d89\u0d82\u0d9c\u0dca\u0dbb\u0dd3\u0dc3\u0dd2",
    ta: "\u0b86\u0b99\u0bcd\u0b95\u0bbf\u0bb2\u0bae\u0bcd",
  },
  "Esplanade Rd, Bandarawela": {
    si: "\u0d91\u0dc3\u0dca\u0db4\u0dca\u0dbd\u0dd0\u0db1\u0dda\u0da9\u0dca \u0db4\u0dcf\u0dbb, \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0dc0\u0dd9\u0dbd",
    ta: "Esplanade Rd, \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0bb5\u0bb3\u0bc8",
  },
  "Etiyawala, Sri Lanka": {
    si: "\u0d87\u0da7\u0dd2\u0dba\u0dcf\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0bbe\u0bb5\u0bbe\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Express Way Entrance Road, Godagama, Matara": {
    si: "\u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db4\u0dd2\u0dc0\u0dd2\u0dc3\u0dd4\u0db8\u0dca \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0d9c\u0ddc\u0da9\u0d9c\u0db8, \u0db8\u0dcf\u0dad\u0dbb",
    ta: "\u0b8e\u0b95\u0bcd\u0bb8\u0bcd\u0baa\u0bbf\u0bb0\u0bb8\u0bcd \u0bb5\u0bc7 \u0ba8\u0bc1\u0bb4\u0bc8\u0bb5\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bca\u0b9f\u0b95\u0bae, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8",
  },
  "Express Way Entrance Road, Godagama, XG8C+3G2, Matara, Sri Lanka": {
    si: "\u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db4\u0dd2\u0dc0\u0dd2\u0dc3\u0dd4\u0db8\u0dca \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0d9c\u0ddc\u0da9\u0d9c\u0db8, XG8C+3G2, \u0db8\u0dcf\u0dad\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0b95\u0bcd\u0bb8\u0bcd\u0baa\u0bbf\u0bb0\u0bb8\u0bcd \u0bb5\u0bc7 \u0ba8\u0bc1\u0bb4\u0bc8\u0bb5\u0bc1\u0b9a\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bca\u0b9f\u0b95\u0bae, XG8C+3G2, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "F2F8+VPR, Girandurukotte, Sri Lanka": {
    si: "F2F8+VPR, \u0d9c\u0dd2\u0dbb\u0dcf\u0db3\u0dd4\u0dbb\u0dd4\u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "F2F8+VPR, Girandurukotte, Sri Lanka",
  },
  "F39G+WP Henpita, Sri Lanka": {
    si: "F39G+WP \u0dc4\u0dd9\u0db1\u0dca\u0db4\u0dd2\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "F39G+WP \u0bb9\u0bc6\u0ba9\u0bcd\u0baa\u0bbf\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "F4C7+HG5, Welipenna, Sri Lanka": {
    si: "F4C7+HG5, \u0dc0\u0dd0\u0dbd\u0dd2\u0db4\u0dd0\u0db1\u0dca\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "F4C7+HG5, \u0bb5\u0bc6\u0bb2\u0bbf\u0baa\u0bc6\u0ba9\u0bcd\u0ba9, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "F52G+CH Horombawa, Sri Lanka": {
    si: "F52G+CH \u0dc4\u0ddc\u0dbb\u0ddc\u0db8\u0dca\u0db6\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "F52G+CH \u0bb9\u0bcb\u0bb0\u0bcb\u0bae\u0bcd\u0baa\u0bbe\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "F56, Kalutara-matugama Rd, Katukurunda": {
    si: "F56, \u0d9a\u0dc5\u0dd4\u0dad\u0dbb-\u0db8\u0dad\u0dd4\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0d9a\u0da7\u0dd4\u0d9a\u0dd4\u0dbb\u0dd4\u0db1\u0dca\u0daf",
    ta: "F56, \u0b95\u0bb3\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8-\u0bae\u0ba4\u0bc1\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4",
  },
  "F5PF+Q5F, Kinniya, Sri Lanka": {
    si: "F5PF+Q5F, \u0d9a\u0dd2\u0db1\u0dca\u0db1\u0dd2\u0dba\u0dcf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "F5PF+Q5F, \u0b95\u0bbf\u0ba3\u0bcd\u0ba3\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "F5XR+MJM, Trincomalee Hwy,  , Sri Lanka": {
    si: "F5XR+MJM, Trincomalee Hwy, , \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "F5XR+MJM, Trincomalee Hwy, , \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "F727+28R, Dehikumbura, Sri Lanka": {
    si: "F727+28R, \u0daf\u0dd9\u0dc4\u0dd2\u0d9a\u0dd4\u0db9\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "F727+28R, \u0ba4\u0bc6\u0bb9\u0bbf\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "F778+5W9, Mutur, Sri Lanka": {
    si: "F778+5W9, Mutur, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "F778+5W9, Mutur, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "F8CX+8M5, Kurunegala, Sri Lanka": {
    si: "F8CX+8M5, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "F8CX+8M5, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "F9GC+VRG, Kurunegala, Sri Lanka": {
    si: "F9GC+VRG, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "F9GC+VRG, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "F9M3+5CW, Kurunegala-Narammala-Madampe Rd, Kurunegala, Sri Lanka": {
    si: "F9M3+5CW, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd-\u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd-\u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda \u0db4\u0dcf\u0dbb, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "F9M3+5CW, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd-\u0ba8\u0bbe\u0bb0\u0bae\u0bcd\u0bae\u0bb2-\u0bae\u0b9f\u0bae\u0bcd\u0baa\u0bc7 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "F9M7+F4J, Kurunegala, Sri Lanka": {
    si: "F9M7+F4J, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "F9M7+F4J, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "F9P8+2RH, Kurunegala, Sri Lanka": {
    si: "F9P8+2RH, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "F9P8+2RH, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "F9Q2+H3R, Kurunegala, Sri Lanka": {
    si: "F9Q2+H3R, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "F9Q2+H3R, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "FALAHI GROUP (PVT) LTD": {
    si: "\u0dc6\u0dcf\u0dbd\u0dcf\u0dc4\u0dd2 \u0d9c\u0df2\u0db4\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b83\u0baa\u0bb2\u0bbe\u0bb9\u0bbf \u0b95\u0bc1\u0bb0\u0bc2\u0baa\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "FC64+XV Kurunegala, Sri Lanka": {
    si: "FC64+XV \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "FC64+XV \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "FCWM+3GM, B264, Barandana, Sri Lanka": {
    si: "FCWM+3GM, B264, \u0db6\u0dbb\u0db1\u0dca\u0daf\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "FCWM+3GM, B264, \u0baa\u0bb0\u0ba8\u0bcd\u0ba4\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "FELIX PEREIRA AND SONS": {
    si: "\u0dc6\u0dd3\u0dbd\u0dd2\u0d9a\u0dca\u0dc3\u0dca \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0baa\u0bc6\u0bb2\u0bbf\u0b95\u0bcd\u0bb8\u0bcd \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe \u0bae\u0bb1\u0bcd\u0bb1\u0bc1\u0bae\u0bcd \u0bae\u0b95\u0ba9\u0bcd\u0b95\u0bb3\u0bcd",
  },
  "FISHERIES DEPARTMENT": {
    si: "\u0db0\u0dd3\u0dc0\u0dbb \u0daf\u0dd9\u0db4\u0dcf\u0dbb\u0dca\u0dad\u0db8\u0dda\u0db1\u0dca\u0dad\u0dd4\u0dc0",
    ta: "\u0bae\u0bc0\u0ba9\u0bcd\u0bb5\u0bb3\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  "FISHERY DEPARTMENT": {
    si: "\u0db0\u0dd3\u0dc0\u0dbb \u0daf\u0dd9\u0db4\u0dcf\u0dbb\u0dca\u0dad\u0db8\u0dda\u0db1\u0dca\u0dad\u0dd4\u0dc0",
    ta: "\u0bae\u0bc0\u0ba9\u0bcd\u0bb5\u0bb3\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  "FISHERY HARBOURS CORPORATION": {
    si: "\u0db0\u0dd3\u0dc0\u0dbb \u0dc0\u0dbb\u0dcf\u0dba \u0dc3\u0d82\u0dc3\u0dca\u0dae\u0dcf\u0dc0",
    ta: "\u0bae\u0bc0\u0ba9\u0bcd\u0bb5\u0bb3\u0ba4\u0bcd \u0ba4\u0bc1\u0bb1\u0bc8\u0bae\u0bc1\u0b95\u0b95\u0bcd \u0b95\u0bb4\u0b95\u0bae\u0bcd",
  },
  "FJJF+88R, Matale, Sri Lanka": {
    si: "FJJF+88R, \u0db8\u0dcf\u0dad\u0dbd\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "FJJF+88R, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "FPJ4+GRG, Pallebedda, Sri Lanka": {
    si: "FPJ4+GRG, \u0db4\u0dbd\u0dca\u0dbd\u0dd9\u0db6\u0dd0\u0daf\u0dca\u0daf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "FPJ4+GRG, \u0baa\u0bb2\u0bcd\u0bb2\u0bc7\u0baa\u0bc6\u0b9f\u0bcd\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "FQ92+CW5, Sri Lanka": {
    si: "FQ92+CW5, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "FQ92+CW5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "FQRX+JCM, Thoduwawa, Sri Lanka": {
    si: "FQRX+JCM, \u0dad\u0ddc\u0da9\u0dd4\u0dc0\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "FQRX+JCM, \u0ba4\u0bca\u0b9f\u0bc1\u0bb5\u0bbe\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "FR5G+GCP, Chilaw - Colombo Main Rd, Mahawewa, Sri Lanka": {
    si: "FR5G+GCP, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0dc0\u0dd0\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "FR5G+GCP, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0bb9\u0bbe\u0bb5\u0bc6\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "FRF5+XH7, Periyakallar, Sri Lanka": {
    si: "FRF5+XH7, \u0db4\u0dd9\u0dbb\u0dd2\u0dba\u0d9a\u0dbd\u0dca\u0dbd\u0dbb\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "FRF5+XH7, \u0baa\u0bc6\u0bb0\u0bbf\u0baf\u0b95\u0bb2\u0bcd\u0bb2\u0bbe\u0bb1\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "FRWV+3HP, B247, Madampe, Sri Lanka": {
    si: "FRWV+3HP, B247, \u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "FRWV+3HP, B247, \u0bae\u0bbe\u0ba4\u0bae\u0bcd\u0baa\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "FWPQ+M9 Bunnehepola, Sri Lanka": {
    si: "FWPQ+M9 Bunnehepola, Sri Lanka",
    ta: "FWPQ+M9 Bunnehepola, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "FWV7+CH2, Dummalasuriya, Sri Lanka": {
    si: "FWV7+CH2, \u0daf\u0dd4\u0db8\u0dca\u0db8\u0dbd\u0dc3\u0dd6\u0dbb\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "FWV7+CH2, \u0ba4\u0bc1\u0bae\u0bcd\u0bae\u0bb2\u0b9a\u0bc2\u0bb0\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "FX5G+RQG, Beruwala, Sri Lanka": {
    si: "FX5G+RQG, \u0db6\u0dda\u0dbb\u0dd4\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "FX5G+RQG, \u0baa\u0bc7\u0bb0\u0bc1\u0bb5\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "FX5P+VPH, Hettimulla Railway, Beruwala, Sri Lanka": {
    si: "FX5P+VPH, \u0dc4\u0dd9\u0da7\u0dca\u0da7\u0dd2\u0db8\u0dd4\u0dbd\u0dca\u0dbd \u0daf\u0dd4\u0db8\u0dca\u0dbb\u0dd2\u0dba, \u0db6\u0dda\u0dbb\u0dd4\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "FX5P+VPH, \u0bb9\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe \u0b87\u0bb0\u0baf\u0bbf\u0bb2\u0bcd\u0bb5\u0bc7, \u0baa\u0bc7\u0bb0\u0bc1\u0bb5\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "FXCH+V9V, Beruwala, Sri Lanka": {
    si: "FXCH+V9V, \u0db6\u0dda\u0dbb\u0dd4\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "FXCH+V9V, \u0baa\u0bc7\u0bb0\u0bc1\u0bb5\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "FXM9+V34, Udubaddawa, Sri Lanka": {
    si: "FXM9+V34, \u0d8b\u0da9\u0dd4\u0db6\u0daf\u0dca\u0daf\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "FXM9+V34, \u0b89\u0b9f\u0bc1\u0baa\u0ba4\u0bcd\u0ba4\u0bbe\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Filling Station Ududumbara Entrance, Sri Lanka": {
    si: "\u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd \u0d8b\u0da9\u0dd4\u0daf\u0dd4\u0db8\u0dca\u0db6\u0dbb \u0db4\u0dd2\u0dc0\u0dd2\u0dc3\u0dd4\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd \u0b89\u0b9f\u0bc1\u0ba4\u0bc1\u0bae\u0bcd\u0baa\u0bb0 \u0ba8\u0bc1\u0bb4\u0bc8\u0bb5\u0bbe\u0baf\u0bbf\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Filling Station, A4, Pelmadulla": {
    si: "\u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, A4, \u0db4\u0dd0\u0dbd\u0dca\u0db8\u0da9\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, A4, \u0baa\u0bc6\u0bb2\u0bcd\u0bae\u0ba4\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe",
  },
  "Filling Station, George R. De Silva Rd, Colombo - 13": {
    si: "\u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0da2\u0ddd\u0dbb\u0dca\u0da2\u0dca \u0d86\u0dbb\u0dca \u0daf \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0dc5\u0db9 - 13",
    ta: "\u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b9c\u0bcb\u0bb0\u0bcd\u0b9c\u0bcd \u0b86\u0bb0\u0bcd. \u0b9f\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - 13",
  },
  "Filling Station, Pallimunai Rd, Mannar": {
    si: "\u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db4\u0dbd\u0dca\u0dbd\u0dd2\u0db8\u0dd4\u0db1\u0dd9\u0dba\u0dd2 \u0db4\u0dcf\u0dbb, \u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8",
    ta: "\u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0baa\u0bb3\u0bcd\u0bb3\u0bbf\u0bae\u0bc1\u0ba9\u0bc8 \u0bb0\u0bcb\u0b9f\u0bc1, \u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd",
  },
  "Filling Station, Palugamuwa, Dummalasooriya": {
    si: "\u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db4\u0dbd\u0dd4\u0d9c\u0db8\u0dd4\u0dc0, \u0daf\u0dd4\u0db8\u0dca\u0db8\u0dbd\u0dc3\u0dd6\u0dbb\u0dd2\u0dba",
    ta: "\u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0baa\u0bb2\u0bc1\u0b95\u0bae\u0bc1\u0bb5, \u0ba4\u0bc1\u0bae\u0bcd\u0bae\u0bb2\u0b9a\u0bc2\u0bb0\u0bbf\u0baf",
  },
  "Filling Station, Thalatuoya - Marassana Rd., Thalathuoya, Sri Lanka": {
    si: "\u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0dad\u0dbd\u0dcf\u0dad\u0dd4\u0d94\u0dba - \u0db8\u0dcf\u0dbb\u0dc3\u0dca\u0dc3\u0db1 \u0db4\u0dcf\u0dbb, \u0dad\u0dbd\u0dcf\u0dad\u0dd4\u0d94\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0ba4\u0bb2\u0ba4\u0bcd\u0ba4\u0bc1\u0b93\u0baf\u0bbe - \u0bae\u0bb0\u0bb8\u0bcd\u0b9a\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bb2\u0ba4\u0bcd\u0ba4\u0bc1\u0b93\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Filter by Fuel Type": {
    si: "\u0d89\u0db1\u0dca\u0db0\u0db1 \u0dc0\u0dbb\u0dca\u0d9c\u0dba \u0d85\u0db1\u0dd4\u0dc0 \u0db4\u0dd9\u0dbb\u0dd3\u0db8",
    ta: "\u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0bb5\u0b95\u0bc8 \u0bae\u0bc2\u0bb2\u0bae\u0bcd \u0bb5\u0b9f\u0bbf\u0b95\u0b9f\u0bcd\u0b9f\u0bb5\u0bc1\u0bae\u0bcd",
  },
  "Filter by Time Updated": {
    si: "\u0dba\u0dcf\u0dc0\u0dad\u0dca\u0d9a\u0dcf\u0dbd\u0dd3\u0db1 \u0d9a\u0dc5 \u0d9a\u0dcf\u0dbd\u0dba \u0d85\u0db1\u0dd4\u0dc0 \u0db4\u0dd9\u0dbb\u0db1\u0dca\u0db1",
    ta: "\u0baa\u0bc1\u0ba4\u0bc1\u0baa\u0bcd\u0baa\u0bbf\u0b95\u0bcd\u0b95\u0baa\u0bcd\u0baa\u0b9f\u0bcd\u0b9f \u0ba8\u0bc7\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0bcd\u0baa\u0b9f\u0bbf \u0bb5\u0b9f\u0bbf\u0b95\u0b9f\u0bcd\u0b9f\u0bb5\u0bc1\u0bae\u0bcd",
  },
  "Fishery Harbour, 689P+5GF, Kirinda, Sri Lanka": {
    si: "\u0db0\u0dd3\u0dc0\u0dbb \u0dc0\u0dbb\u0dcf\u0dba, 689P+5GF, \u0d9a\u0dd2\u0dbb\u0dd2\u0db1\u0dca\u0daf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bae\u0bc0\u0ba9\u0bcd\u0baa\u0bbf\u0b9f\u0bbf \u0ba4\u0bc1\u0bb1\u0bc8\u0bae\u0bc1\u0b95\u0bae\u0bcd, 689P+5GF, \u0b95\u0bbf\u0bb0\u0bbf\u0ba8\u0bcd\u0ba4\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Fuel: {
    si: "\u0d89\u0db1\u0dca\u0db0\u0db1",
    ta: "\u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd",
  },
  "Fuel Station Moratuwa, Galle Rd, Moratuwa": {
    si: "\u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd \u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0, \u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0",
    ta: "\u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd \u0bae\u0bca\u0bb0\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bc8, \u0b95\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bca\u0bb0\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bc8",
  },
  "Fuel Station, A12, Anuradhapura": {
    si: "\u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, A12, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb",
    ta: "\u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, A12, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd",
  },
  "Fuel Station, Dehiwela - Maharagama Road, Maharagama": {
    si: "\u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd - \u0db8\u0dc4\u0dbb\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0dbb\u0d9c\u0db8",
    ta: "\u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8 - \u0bae\u0bb9\u0bb0\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bb9\u0bb0\u0b95\u0bae",
  },
  "Fuel Station, Galle": {
    si: "\u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd",
    ta: "\u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0bbe\u0bb2\u0bbf",
  },
  "Fuel Station, Mullipothana, Gantalawa": {
    si: "\u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db8\u0dd4\u0dbd\u0dca\u0dbd\u0dd2\u0db4\u0ddc\u0dad\u0dcf\u0db1, \u0d9c\u0db1\u0dca\u0dad\u0dbd\u0dcf\u0dc0",
    ta: "\u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0bae\u0bc1\u0bb3\u0bcd\u0bb3\u0bbf\u0baa\u0bcd\u0baa\u0bca\u0ba4\u0bcd\u0ba4\u0bbe\u0ba9\u0bc8, \u0b95\u0ba8\u0bcd\u0ba4\u0bb2\u0bbe\u0bb5",
  },
  "Fuel Station, Yala Rd, Kataragama": {
    si: "\u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0dba\u0dcf\u0dbd \u0db4\u0dcf\u0dbb, \u0d9a\u0dad\u0dbb\u0d9c\u0db8",
    ta: "\u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0baf\u0bbe\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0ba4\u0bbf\u0bb0\u0bcd\u0b95\u0bbe\u0bae\u0bae\u0bcd",
  },
  "Fuel in SL": {
    si: "\u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0\u0dda \u0d89\u0db1\u0dca\u0db0\u0db1",
    ta: "SL \u0b87\u0bb2\u0bcd \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd",
  },
  "G B AMAL PRIYANKARA": {
    si: "\u0da2\u0dd3 \u0db6\u0dd3 \u0d85\u0db8\u0dbd\u0dca \u0db4\u0dca\u200d\u0dbb\u0dd2\u0dba\u0d82\u0d9a\u0dbb",
    ta: "\u0b9c\u0bbf \u0baa\u0bbf \u0b85\u0bae\u0bb2\u0bcd \u0baa\u0bbf\u0bb0\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0bb0\u0bbe",
  },
  "G K C K PRASANNA": {
    si: "G K C K PRASANNA",
    ta: "\u0b9c\u0bbf \u0b95\u0bc7 \u0b9a\u0bbf \u0b95\u0bc7 \u0baa\u0bbf\u0bb0\u0b9a\u0ba9\u0bcd\u0ba9\u0bbe",
  },
  "G K SAMARASINGHE": {
    si: "\u0da2\u0dd3 \u0d9a\u0dda \u0dc3\u0db8\u0dbb\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b9c\u0bbf \u0b95\u0bc7 \u0b9a\u0bae\u0bb0\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "G K SAMIE & SONS": {
    si: "\u0da2\u0dd3 \u0d9a\u0dda \u0dc3\u0dcf\u0db8\u0dd2 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b9c\u0bbf \u0b95\u0bc7 \u0b9a\u0bbe\u0bae\u0bbf & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "G M N G C K GAMLATH": {
    si: "G M N G C K GAMLATH",
    ta: "\u0b9c\u0bbf \u0b8e\u0bae\u0bcd \u0b8e\u0ba9\u0bcd \u0b9c\u0bbf \u0b9a\u0bbf \u0b95\u0bc7 \u0b95\u0bae\u0bb2\u0ba4\u0bcd",
  },
  "G P H.JAYAPALAN": {
    si: "\u0da2\u0dd3 \u0db4\u0dd3 \u0d91\u0da0\u0dca \u0da2\u0dba\u0db4\u0dcf\u0dbd\u0db1\u0dca",
    ta: "\u0b9c\u0bbf \u0baa\u0bbf \u0b8e\u0b9a\u0bcd.\u0b9c\u0bc6\u0baf\u0baa\u0bbe\u0bb2\u0ba9\u0bcd",
  },
  "G S N N GUNATHILAKA": {
    si: "\u0da2\u0dd3 \u0d91\u0dc3\u0dca \u0d91\u0db1\u0dca \u0d9c\u0dd4\u0dab\u0dad\u0dd2\u0dbd\u0d9a",
    ta: "\u0b9c\u0bbf \u0b8e\u0bb8\u0bcd \u0b8e\u0ba9\u0bcd \u0b8e\u0ba9\u0bcd \u0b95\u0bc1\u0ba3\u0ba4\u0bbf\u0bb2\u0b95\u0bbe",
  },
  "G.B.SUNIL BANDULA SILVA": {
    si: "\u0da2\u0dd3.\u0db6\u0dd3.\u0dc3\u0dd4\u0db1\u0dd2\u0dbd\u0dca \u0db6\u0db1\u0dca\u0daf\u0dd4\u0dbd \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf",
    ta: "\u0b9c\u0bbf.\u0baa\u0bbf.\u0b9a\u0bc1\u0ba9\u0bbf\u0bb2\u0bcd \u0baa\u0ba8\u0bcd\u0ba4\u0bc1\u0bb2 \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe",
  },
  "G.C.SAMARAWEERA": {
    si: "G.C.\u0dc3\u0db8\u0dbb\u0dc0\u0dd3\u0dbb",
    ta: "\u0b9c\u0bbf.\u0b9a\u0bbf.\u0b9a\u0bae\u0bb0\u0bb5\u0bc0\u0bb0",
  },
  "G.H.A.DE SILVA & COMPANY": {
    si: "G.H.A.DE SILVA \u0dc3\u0dc4 \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "G.H.A.DE SILVA & COMPANY",
  },
  "G.K.J.WIMALANANDA": {
    si: "\u0da2\u0dd3.\u0d9a\u0dda.\u0da2\u0dda.\u0dc0\u0dd2\u0db8\u0dbd\u0dcf\u0db1\u0db1\u0dca\u0daf",
    ta: "\u0b9c\u0bbf.\u0b95\u0bc7.\u0b9c\u0bc7.\u0bb5\u0bbf\u0bae\u0bb2\u0bbe\u0ba9\u0ba8\u0bcd\u0ba4\u0bbe",
  },
  "G.P.H.KANDAMBY &  SONS ( PVT ) LTD": {
    si: "G.P.H.KANDAMBY & SONS (PVT) LTD",
    ta: "G.P.H.KANDAMBY & SONS (PVT) LTD",
  },
  "G.R.P.HETTIHEWA": {
    si: "\u0da2\u0dd3.\u0d86\u0dbb\u0dca.\u0db4\u0dd3.\u0dc4\u0dd9\u0da7\u0dca\u0da7\u0dd2\u0dc4\u0dda\u0dc0\u0dcf",
    ta: "\u0b9c\u0bbf.\u0b86\u0bb0\u0bcd.\u0baa\u0bbf.\u0bb9\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0bb9\u0bc7\u0bb5\u0bbe",
  },
  "G.T.LINGANADAN": {
    si: "\u0da2\u0dd3.\u0da7\u0dd3.\u0dbd\u0dd2\u0d82\u0d9c\u0db1\u0dcf\u0daf\u0db1\u0dca",
    ta: "\u0b9c\u0bbf.\u0b9f\u0bbf.\u0bb2\u0bbf\u0b99\u0bcd\u0b95\u0ba8\u0bbe\u0ba4\u0ba9\u0bcd",
  },
  "G.WIJETUNGE": {
    si: "\u0da2\u0dd3.\u0dc0\u0dd2\u0da2\u0dda\u0dad\u0dd4\u0d82\u0d9c",
    ta: "\u0b9c\u0bbf.\u0bb5\u0bbf\u0b9c\u0bc7\u0ba4\u0bc1\u0b99\u0bcd\u0b95\u0bc7",
  },
  "G3M4+VW munamldeniya, Munamaldeniya, Sri Lanka": {
    si: "G3M4+VW munamldeniya, Munamaldeniya, Sri Lanka",
    ta: "G3M4+VW munamldeniya, Munamaldeniya, Sri Lanka",
  },
  "G4F7+52P, Matugama, Sri Lanka": {
    si: "G4F7+52P, \u0db8\u0dad\u0dd4\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "G4F7+52P, \u0bae\u0b9f\u0bcd\u0b9f\u0bc1\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "G4F8+22V, Horana - Bulathsinhala - Mathugama Road, Matugama, Sri Lanka": {
    si: "G4F8+22V, \u0dc4\u0ddc\u0dbb\u0dab - \u0db6\u0dd4\u0dbd\u0dad\u0dca\u0dc3\u0dd2\u0d82\u0dc4\u0dbd - \u0db8\u0dad\u0dd4\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0db8\u0dad\u0dd4\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "G4F8+22V, \u0bb9\u0bca\u0bb0\u0ba3\u0bc8 - \u0baa\u0bc1\u0bb2\u0ba4\u0bcd\u0b9a\u0bbf\u0b99\u0bcd\u0b95\u0bb3 - \u0bae\u0ba4\u0bcd\u0ba4\u0bc1\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0ba4\u0bcd\u0ba4\u0bc1\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "G4WF+W5 Moragane, Sri Lanka": {
    si: "G4WF+W5 \u0db8\u0ddc\u0dbb\u0d9c\u0db1\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "G4WF+W5 \u0bae\u0bca\u0bb0\u0b95\u0ba9\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "G52Q+RPH, Narammala Road, Siyambalagaskotuwa, Sri Lanka": {
    si: "G52Q+RPH, \u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd \u0db4\u0dcf\u0dbb, \u0dc3\u0dd2\u0dba\u0db9\u0dbd\u0dcf\u0d9c\u0dc3\u0dca\u0d9a\u0ddc\u0da7\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "G52Q+RPH, Narammala Road, Siyambalagaskotuwa, Sri Lanka",
  },
  "G52R+2MR, Kinniya, Sri Lanka": {
    si: "G52R+2MR, \u0d9a\u0dd2\u0db1\u0dca\u0db1\u0dd2\u0dba\u0dcf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "G52R+2MR, \u0b95\u0bbf\u0ba3\u0bcd\u0ba3\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "G52R+WG2, Kinniya, Sri Lanka": {
    si: "G52R+WG2, \u0d9a\u0dd2\u0db1\u0dca\u0db1\u0dd2\u0dba\u0dcf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "G52R+WG2, \u0b95\u0bbf\u0ba3\u0bcd\u0ba3\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "G5GC+J37, Tiruwanaketiya-Agalawatte Rd, Bellana, Sri Lanka": {
    si: "G5GC+J37, \u0dad\u0dd2\u0dbb\u0dd4\u0dc0\u0dcf\u0db1\u0dcf\u0d9a\u0dd0\u0da7\u0dd2\u0dba-\u0d85\u0d9c\u0dbd\u0dc0\u0dad\u0dca\u0dad \u0db4\u0dcf\u0dbb, \u0db6\u0dd9\u0dbd\u0dca\u0dbd\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "G5GC+J37, \u0ba4\u0bbf\u0bb0\u0bc1\u0bb5\u0ba9\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf-\u0b85\u0b95\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "G5MQ+J4Q, Kadahapola-Rambawewa Rd, Katupotha, Sri Lanka": {
    si: "G5MQ+J4Q, \u0d9a\u0da9\u0dc4\u0db4\u0ddc\u0dbd-\u0dbb\u0db9\u0dc0\u0dd0\u0dc0 \u0db4\u0dcf\u0dbb, \u0d9a\u0da7\u0dd4\u0db4\u0ddc\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "G5MQ+J4Q, \u0b95\u0b9f\u0bb9\u0baa\u0bca\u0bb2-\u0bb0\u0bae\u0bcd\u0baa\u0bb5\u0bc6\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0baa\u0bca\u0ba4, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "G645+FWH, Pooneryn, Sri Lanka": {
    si: "G645+FWH, \u0db4\u0dd4\u0db1\u0dbb\u0dd3\u0db1\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "G645+FWH, \u0baa\u0bc2\u0ba9\u0bc7\u0bb0\u0bbf\u0ba9\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "G68J+W88, Baduraliya, Sri Lanka": {
    si: "G68J+W88, \u0db6\u0daf\u0dd4\u0dbb\u0dbd\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "G68J+W88, \u0baa\u0ba4\u0bc1\u0bb0\u0bb2\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "G8M9+RVC, Rathkarawwa, Sri Lanka": {
    si: "G8M9+RVC, \u0dbb\u0dad\u0dca\u0d9a\u0dbb\u0dc0\u0dca\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "G8M9+RVC, \u0bb0\u0ba4\u0bcd\u0b95\u0bb0\u0bb5\u0bcd\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "G9J4+CF, Maha Oya, Sri Lanka": {
    si: "G9J4+CF, \u0db8\u0dc4\u0d94\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "G9J4+CF, \u0bae\u0bb9\u0bbe \u0b93\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "G9JW+5M8, Kalawana, Sri Lanka": {
    si: "G9JW+5M8, \u0d9a\u0dbd\u0dc0\u0dcf\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "G9JW+5M8, \u0b95\u0bb2\u0bb5\u0bbe\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "G9JW+79J, Tiruwanaketiya-Agalawatte Rd, Kalawana, Sri Lanka": {
    si: "G9JW+79J, \u0dad\u0dd2\u0dbb\u0dd4\u0dc0\u0dcf\u0db1\u0dcf\u0d9a\u0dd0\u0da7\u0dd2\u0dba-\u0d85\u0d9c\u0dbd\u0dc0\u0dad\u0dca\u0dad \u0db4\u0dcf\u0dbb, \u0d9a\u0dbd\u0dc0\u0dcf\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "G9JW+79J, \u0ba4\u0bbf\u0bb0\u0bc1\u0bb5\u0ba9\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf-\u0b85\u0b95\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb2\u0bb5\u0bbe\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "GALAGEDERA MPCS LTD": {
    si: "\u0d9c\u0dbd\u0d9c\u0dd9\u0daf\u0dbb MPCS LTD",
    ta: "\u0b95\u0bb2\u0b95\u0bc6\u0ba4\u0bc6\u0bb0\u0bbe MPCS LTD",
  },
  "GALEWELA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9c\u0dbd\u0dda\u0dc0\u0dd9\u0dbd \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0bb2\u0bc7\u0bb5\u0bc6\u0bb2 MPCS LTD",
  },
  "GALGAMUVA MPCS LTD": {
    si: "\u0d9c\u0dbd\u0dca\u0d9c\u0db8\u0dd4\u0dc0 MPCS LTD",
    ta: "\u0b95\u0bb2\u0bcd\u0b95\u0bae\u0bc1\u0bb5 MPCS LTD",
  },
  "GALIGAMUWA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9c\u0dbd\u0dd2\u0d9c\u0db8\u0dd4\u0dc0 \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0bb2\u0bbf\u0b95\u0bae\u0bc1\u0bb5 MPCS LTD",
  },
  "GALKULAMA FUEL MART": {
    si: "\u0d9c\u0dbd\u0dca\u0d9a\u0dd4\u0dbd\u0db8 \u0d89\u0db1\u0dca\u0db0\u0db1 \u0d9c\u0db6\u0da9\u0dcf\u0dc0",
    ta: "\u0b95\u0bb2\u0bcd\u0b95\u0bc1\u0bb2\u0bae\u0bbe \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0b9a\u0ba8\u0bcd\u0ba4\u0bc8",
  },
  GALLE: {
    si: "\u0d9c\u0dcf\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0bbe\u0bb2\u0bbf",
  },
  "GALLE DISTRICT FISHERIES CS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9c\u0dcf\u0dbd\u0dd4 \u0daf\u0dd2\u0dc3\u0dca\u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dca \u0db0\u0dd3\u0dc0\u0dbb \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0b95\u0bbe\u0bb2\u0bbf \u0bae\u0bbe\u0bb5\u0b9f\u0bcd\u0b9f \u0bae\u0bc0\u0ba9\u0bcd\u0bb5\u0bb3\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8 CS LTD",
  },
  "GALLE MPCS LTD": {
    si: "GALLE MPCS LTD",
    ta: "GALLE MPCS LTD",
  },
  "GALNEWA MPCS LTD": {
    si: "GALNEWA MPCS LTD",
    ta: "\u0b95\u0bb2\u0bcd\u0ba9\u0bc7\u0bb5\u0bbe \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0b9a\u0bbf\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "GAMINI MUNASINGHE  A M": {
    si: "\u0d9c\u0dcf\u0db8\u0dd2\u0dab\u0dd3 \u0db8\u0dd4\u0dab\u0dc3\u0dd2\u0d82\u0dc4 \u0d92 \u0d91\u0db8\u0dca",
    ta: "\u0b95\u0bbe\u0bae\u0bbf\u0ba9\u0bbf \u0bae\u0bc1\u0ba9\u0b9a\u0bbf\u0b99\u0bcd\u0b95 \u0b8f.\u0b8e\u0bae\u0bcd",
  },
  "GAMINI SAMARASINGHA": {
    si: "\u0d9c\u0dcf\u0db8\u0dd2\u0dab\u0dd3 \u0dc3\u0db8\u0dbb\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b95\u0bbe\u0bae\u0bbf\u0ba9\u0bbf \u0b9a\u0bae\u0bb0\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "GAMPAHA MPCS LTD": {
    si: "\u0d9c\u0db8\u0dca\u0db4\u0dc4 MPCS LTD",
    ta: "GAMPAHA MPCS LTD",
  },
  "GAMPOLA INDUSTRIES SABARAGAMUWA (PV": {
    si: "\u0d9c\u0db8\u0dca\u0db4\u0ddc\u0dbd \u0d89\u0db1\u0dca\u0da9\u0dc3\u0dca\u0da7\u0dca\u200d\u0dbb\u0dd3\u0dc3\u0dca \u0dc3\u0db6\u0dbb\u0d9c\u0db8\u0dd4\u0dc0 (PV",
    ta: "\u0b95\u0bae\u0bcd\u0baa\u0bb3\u0bc8 \u0b87\u0ba3\u0bcd\u0b9f\u0bb8\u0bcd\u0b9f\u0bcd\u0bb0\u0bc0\u0bb8\u0bcd \u0b9a\u0baa\u0bcd\u0bb0\u0b95\u0bae\u0bc1\u0bb5 (\u0baa\u0bbf.\u0bb5\u0bbf",
  },
  "GAMPOLA MPCS LTD": {
    si: "\u0d9c\u0db8\u0dca\u0db4\u0ddc\u0dbd MPCS LTD",
    ta: "GAMPOLA MPCS LTD",
  },
  "GANGA IHALAKORALE MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9c\u0d82\u0d9c\u0dcf \u0d89\u0dc4\u0dc5\u0d9a\u0ddd\u0dbb\u0dc5 \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0b99\u0bcd\u0b95\u0bbe \u0b87\u0bb9\u0bb2\u0b95\u0bcb\u0bb0\u0bb2\u0bc7 MPCS LTD",
  },
  "GANGE KULARATNE": {
    si: "\u0d9c\u0d82\u0d9c\u0dda \u0d9a\u0dd4\u0dbd\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b95\u0b99\u0bcd\u0b95\u0bc7 \u0b95\u0bc1\u0bb2\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "GANTHERA INDHANA PIRAVUMHALA": {
    si: "\u0d9c\u0db1\u0dca\u0dad\u0dd9\u0dbb \u0d89\u0db1\u0dca\u0daf\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b95\u0bbe\u0ba8\u0bcd\u0ba4\u0bc7\u0bb0 \u0b87\u0ba8\u0bcd\u0ba4\u0ba9\u0bbe \u0baa\u0bbf\u0bb1\u0bb5\u0bc1\u0bae\u0bcd\u0bb9\u0bbe\u0bb2\u0bbe",
  },
  "GAS AUTO LANKA (PVT) LTD": {
    si: "\u0d9c\u0dd1\u0dc3\u0dca \u0d94\u0da7\u0ddd \u0dbd\u0d82\u0d9a\u0dcf (\u0db4\u0dde\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b95\u0bc7\u0bb8\u0bcd \u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0bb2\u0b99\u0bcd\u0b95\u0bbe (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "GC8C+FQ6, Northwayrest, Kurunegala 60000, Sri Lanka": {
    si: "GC8C+FQ6, Northwayrest, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd 60000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "GC8C+FQ6, \u0ba8\u0bbe\u0bb0\u0bcd\u0ba4\u0bcd\u0bb5\u0bc7\u0bb0\u0bc6\u0bb8\u0bcd\u0b9f\u0bcd, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd 60000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "GFXQ+4QR, Ridigama, Sri Lanka": {
    si: "GFXQ+4QR, \u0dbb\u0dd2\u0daf\u0dd3\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "GFXQ+4QR, \u0bb0\u0bbf\u0ba4\u0bbf\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "GFXR+QRX, Ridigama, Sri Lanka": {
    si: "GFXR+QRX, \u0dbb\u0dd2\u0daf\u0dd3\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "GFXR+QRX, \u0bb0\u0bbf\u0ba4\u0bbf\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "GHPV+74H, Kavuduwawa, Sri Lanka": {
    si: "GHPV+74H, Kavuduwawa, Sri Lanka",
    ta: "GHPV+74H, \u0b95\u0bb5\u0bc1\u0b9f\u0bc1\u0bb5\u0bbe\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "GINIGATHENA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9c\u0dd2\u0db1\u0dd2\u0d9c\u0dad\u0dca\u0dc4\u0dda\u0db1 MPCS",
    ta: "\u0b95\u0bbf\u0ba9\u0bbf\u0b95\u0ba4\u0bcd\u0ba4\u0bc7\u0ba9 MPCS LTD",
  },
  "GJ8F+RF5, Matale, Sri Lanka": {
    si: "GJ8F+RF5, \u0db8\u0dcf\u0dad\u0dbd\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "GJ8F+RF5, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "GJPG+MXR, Dambulla Rd,   21000, Sri Lanka": {
    si: "GJPG+MXR, \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, 21000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "GJPG+MXR, \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, 21000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "GM33+H3F, Godakawela, Sri Lanka": {
    si: "GM33+H3F, \u0d9c\u0ddc\u0da9\u0d9a\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "GM33+H3F, \u0b95\u0bca\u0b9f\u0b95\u0bb5\u0bc6\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "GMCG+8XC, Rattota, Sri Lanka": {
    si: "GMCG+8XC, \u0dbb\u0dad\u0dca\u0dad\u0ddc\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "GMCG+8XC, \u0bb0\u0ba4\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "GP7M+33 Mandur, Sri Lanka": {
    si: "GP7M+33 Mandur, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "GP7M+33 \u0bae\u0ba3\u0bcd\u0b9f\u0bc2\u0bb0\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "GQ7Q+V2V, Kaluwanchikudy, Sri Lanka": {
    si: "GQ7Q+V2V, \u0d9a\u0dbd\u0dd4\u0dc0\u0d82\u0da0\u0dd2\u0d9a\u0dd4\u0da9\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "GQ7Q+V2V, \u0b95\u0bb3\u0bc1\u0bb5\u0bbe\u0b9e\u0bcd\u0b9a\u0bbf\u0b95\u0bc1\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "GQF8+W8 Kaluwanchikudy, Sri Lanka": {
    si: "GQF8+W8 \u0d9a\u0dbd\u0dd4\u0dc0\u0d82\u0da0\u0dd2\u0d9a\u0dd4\u0da9\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "GQF8+W8 \u0b95\u0bb3\u0bc1\u0bb5\u0bbe\u0b9e\u0bcd\u0b9a\u0bbf\u0b95\u0bc1\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "GR5H+QMR, Madampe, Sri Lanka": {
    si: "GR5H+QMR, \u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "GR5H+QMR, \u0bae\u0bbe\u0ba4\u0bae\u0bcd\u0baa\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "GRXJ+VWH, Horowupotana, Sri Lanka": {
    si: "GRXJ+VWH, \u0dc4\u0ddc\u0dbb\u0ddc\u0dc0\u0dca\u0db4\u0ddc\u0dad\u0dcf\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "GRXJ+VWH, Horowupotana, Sri Lanka",
  },
  "GUNARATHNE  ENTERPRISES": {
    si: "\u0d9c\u0dd4\u0dab\u0dbb\u0dad\u0dca\u0db1 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b95\u0bc1\u0ba3\u0bb0\u0ba4\u0bcd\u0ba9\u0bc7 \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "GUNASIRI LANKA FILLING STATION": {
    si: "\u0d9c\u0dd4\u0dab\u0dc3\u0dd2\u0dbb\u0dd2 \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b95\u0bc1\u0ba3\u0b9a\u0bbf\u0bb0\u0bbf \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "GVJG+54 Madampe, Sri Lanka": {
    si: "GVJG+54 \u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "GVJG+54 \u0bae\u0bbe\u0ba4\u0bae\u0bcd\u0baa\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "GWM2+X5V, Matale - Illukkumbura - Pallegama - Giradurukotte Road, Hettipola, Sri Lanka":
    {
      si: "GWM2+X5V, \u0db8\u0dcf\u0dad\u0dbd\u0dda - \u0d89\u0dbd\u0dd4\u0d9a\u0dca\u0d9a\u0dd4\u0db9\u0dd4\u0dbb - \u0db4\u0dbd\u0dca\u0dbd\u0dda\u0d9c\u0db8 - \u0d9c\u0dd2\u0dbb\u0dcf\u0daf\u0dd4\u0dbb\u0dd4\u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda \u0db4\u0dcf\u0dbb, \u0dc4\u0dd9\u0da7\u0dca\u0da7\u0dd2\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "GWM2+X5V, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8 - \u0b87\u0bb2\u0bcd\u0bb2\u0bc1\u0b95\u0bcd\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0bb0 - \u0baa\u0bb2\u0bcd\u0bb2\u0bc7\u0b95\u0bae - \u0b95\u0bbf\u0bb0\u0bbe\u0ba4\u0bc1\u0bb0\u0bc1\u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baa\u0bca\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "GX4J+58W, Maggona, Sri Lanka": {
    si: "GX4J+58W, \u0db8\u0d9c\u0dca\u0d9c\u0ddc\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "GX4J+58W, \u0bae\u0b95\u0bcb\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "GX9W+X3V, Ilukhena, Sri Lanka": {
    si: "GX9W+X3V, \u0d89\u0dbd\u0dd4\u0d9a\u0dca\u0dc4\u0dda\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "GX9W+X3V, \u0b87\u0bb2\u0bc1\u0b95\u0bcd\u0b95\u0bc7\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "GXQ3+99 Pokunutenna, Sri Lanka": {
    si: "GXQ3+99 \u0db4\u0ddc\u0d9a\u0dd4\u0dab\u0dd4\u0dad\u0dd0\u0db1\u0dca\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "GXQ3+99 \u0baa\u0bca\u0b95\u0bc1\u0ba9\u0bc1\u0ba4\u0bc6\u0ba9\u0bcd\u0ba9, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "GXRC+FP6, Katukurunda, Sri Lanka": {
    si: "GXRC+FP6, \u0d9a\u0da7\u0dd4\u0d9a\u0dd4\u0dbb\u0dd4\u0db1\u0dca\u0daf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "GXRC+FP6, \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Galagedara: {
    si: "\u0d9c\u0dbd\u0d9c\u0dd9\u0daf\u0dbb",
    ta: "\u0b95\u0bb2\u0b95\u0bc6\u0ba4\u0bb0",
  },
  "Galagedara - Rambukkana Rd": {
    si: "\u0d9c\u0dbd\u0d9c\u0dd9\u0daf\u0dbb - \u0dbb\u0db9\u0dd4\u0d9a\u0dca\u0d9a\u0db1 \u0db4\u0dcf\u0dbb",
    ta: "\u0b95\u0bb2\u0b95\u0bc6\u0ba4\u0bb0 - \u0bb0\u0bae\u0bcd\u0baa\u0bc1\u0b95\u0bcd\u0b95\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  "Galagedera - Horana Rd, Padukka": {
    si: "\u0d9c\u0dbd\u0d9c\u0dd9\u0daf\u0dbb - \u0dc4\u0ddc\u0dbb\u0dab \u0db4\u0dcf\u0dbb, \u0db4\u0dcf\u0daf\u0dd4\u0d9a\u0dca\u0d9a",
    ta: "\u0b95\u0bb2\u0b95\u0bc6\u0ba4\u0bb0 - \u0bb9\u0bca\u0bb0\u0ba3 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bbe\u0ba4\u0bc1\u0b95\u0bcd\u0b95",
  },
  Galaha: {
    si: "\u0d9c\u0dbd\u0dc4",
    ta: "\u0b95\u0bb2\u0bb9\u0bbe",
  },
  Galapitamulla: {
    si: "\u0d9c\u0dbd\u0db4\u0dd2\u0da7\u0db8\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0bb2\u0bbe\u0baa\u0bbf\u0b9f\u0bae\u0bc1\u0bb2\u0bcd\u0bb2",
  },
  Galenbindunuwewa: {
    si: "\u0d9c\u0dbd\u0dd9\u0db1\u0dca\u0db6\u0dd2\u0db3\u0dd4\u0dab\u0dd4\u0dc0\u0dd0\u0dc0",
    ta: "\u0b95\u0bb2\u0bc6\u0ba9\u0bcd\u0baa\u0bbf\u0ba8\u0bcd\u0ba4\u0bc1\u0ba9\u0bc1\u0bb5\u0bc6\u0bb5",
  },
  Galewela: {
    si: "\u0d9c\u0dbd\u0dda\u0dc0\u0dd9\u0dbd",
    ta: "\u0b95\u0bb2\u0bc7\u0bb5\u0bc6\u0bb2",
  },
  "Galgamuwa Rd, Anamaduwa": {
    si: "\u0d9c\u0dbd\u0dca\u0d9c\u0db8\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0d86\u0dab\u0db8\u0da9\u0dd4\u0dc0",
    ta: "\u0b95\u0bb2\u0bcd\u0b95\u0bae\u0bc1\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b86\u0ba9\u0bae\u0b9f\u0bc1\u0bb5",
  },
  "Galgamuwa Rd, Nawagaththegama": {
    si: "\u0d9c\u0dbd\u0dca\u0d9c\u0db8\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0db1\u0dc0\u0d9c\u0dad\u0dca\u0dad\u0dda\u0d9c\u0db8",
    ta: "\u0b95\u0bb2\u0bcd\u0b95\u0bae\u0bc1\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bb5\u0b95\u0ba4\u0bcd\u0ba4\u0bc7\u0b95\u0bae",
  },
  Galkulama: {
    si: "\u0d9c\u0dbd\u0dca\u0d9a\u0dd4\u0dbd\u0db8",
    ta: "\u0b95\u0bb2\u0bcd\u0b95\u0bc1\u0bb2\u0bae\u0bbe",
  },
  Galle: {
    si: "\u0d9c\u0dcf\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0bbe\u0bb2\u0bbf",
  },
  "Galle - Esplanade": {
    si: "\u0d9c\u0dcf\u0dbd\u0dca\u0dbd - Esplanade",
    ta: "\u0b95\u0bbe\u0bb2\u0bbf - \u0b8e\u0bb8\u0bcd\u0baa\u0bbf\u0bb3\u0ba9\u0bc7\u0b9f\u0bcd",
  },
  "Galle - Queen Street": {
    si: "\u0d9c\u0dcf\u0dbd\u0dca\u0dbd - \u0dbb\u0dd0\u0da2\u0dd2\u0db1 \u0dc0\u0dd3\u0daf\u0dd2\u0dba",
    ta: "\u0b95\u0bbe\u0bb2\u0bbf - \u0b95\u0bc1\u0baf\u0bbf\u0ba9\u0bcd \u0ba4\u0bc6\u0bb0\u0bc1",
  },
  "Galle - Udugama Rd, Nakiyadeniya": {
    si: "\u0d9c\u0dcf\u0dbd\u0dca\u0dbd - \u0d8b\u0da9\u0dd4\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0db1\u0dcf\u0d9a\u0dd2\u0dba\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba",
    ta: "\u0b95\u0bbe\u0bb2\u0bbf - \u0b89\u0b9f\u0bc1\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bbe\u0b95\u0bbf\u0baf\u0ba4\u0bc6\u0ba9\u0bbf\u0baf",
  },
  "Galle Rd New Deviation, Moratuwa": {
    si: "\u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb \u0db1\u0dc0 \u0d85\u0db4\u0d9c\u0db8\u0db1\u0dba, \u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0",
    ta: "Galle Rd \u0baa\u0bc1\u0ba4\u0bbf\u0baf \u0bb5\u0bbf\u0bb2\u0b95\u0bb2\u0bcd, \u0bae\u0bca\u0bb0\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bc8",
  },
  "Galle Rd, Colombo - 06": {
    si: "\u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0dc5\u0db9 - 06",
    ta: "\u0b95\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - 06",
  },
  "Galle Road, Panadura": {
    si: "\u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb",
    ta: "\u0b95\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bbe\u0ba3\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  "Galle-udugama Rd, Thalgampala": {
    si: "\u0d9c\u0dcf\u0dbd\u0dca\u0dbd-\u0d8b\u0da9\u0dd4\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0dad\u0dbd\u0dca\u0d9c\u0db8\u0dca\u0db4\u0dbd",
    ta: "\u0b95\u0bbe\u0bb2\u0bbf-\u0b89\u0b9f\u0bc1\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bb2\u0bcd\u0b95\u0bae\u0bcd\u0baa\u0bb2\u0bbe",
  },
  Gampola: {
    si: "\u0d9c\u0db8\u0dca\u0db4\u0ddc\u0dbd",
    ta: "\u0b95\u0bae\u0bcd\u0baa\u0bb3\u0bc8",
  },
  "Gampola - Dolosbage Rd": {
    si: "\u0d9c\u0db8\u0dca\u0db4\u0ddc\u0dbd - \u0daf\u0ddc\u0dc5\u0ddc\u0dc3\u0dca\u0db6\u0dcf\u0d9c\u0dda \u0db4\u0dcf\u0dbb",
    ta: "\u0b95\u0bae\u0bcd\u0baa\u0bb3\u0bc8 - \u0b9f\u0bcb\u0bb2\u0bcb\u0bb8\u0bcd\u0baa\u0bbe\u0b95\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  Gandara: {
    si: "\u0d9c\u0db1\u0dca\u0daf\u0dbb",
    ta: "\u0b95\u0bbe\u0ba8\u0bcd\u0ba4\u0bbe\u0bb0",
  },
  "Ganegama- Pelmadulla": {
    si: "\u0d9c\u0db1\u0dda\u0d9c\u0db8- \u0db4\u0dd0\u0dbd\u0dca\u0db8\u0da9\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0ba9\u0bc7\u0b95\u0bae- \u0baa\u0bc6\u0bb2\u0bcd\u0bae\u0ba4\u0bc1\u0bb2\u0bcd\u0bb2",
  },
  Ganemulla: {
    si: "\u0d9c\u0db1\u0dda\u0db8\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0ba3\u0bc7\u0bae\u0bc1\u0bb2\u0bcd\u0bb2",
  },
  Ganewalpola: {
    si: "\u0d9c\u0db1\u0dda\u0dc0\u0dbd\u0dca\u0db4\u0ddc\u0dbd",
    ta: "\u0b95\u0ba3\u0bc7\u0bb5\u0bb2\u0bcd\u0baa\u0bca\u0bb2",
  },
  "Ganewalpola, Kekirawa": {
    si: "\u0d9c\u0db1\u0dda\u0dc0\u0dbd\u0dca\u0db4\u0ddc\u0dbd, \u0d9a\u0dd0\u0d9a\u0dd2\u0dbb\u0dcf\u0dc0",
    ta: "\u0b95\u0ba9\u0bc7\u0bb5\u0bb2\u0bcd\u0baa\u0bca\u0bb2, \u0b95\u0bc6\u0b95\u0bcd\u0b95\u0bbf\u0bb0\u0bbe\u0bb5",
  },
  "Ganewelpola - Dachchahalmillewa Rd, Galenbindunuwewa": {
    si: "\u0d9c\u0db1\u0dda\u0dc0\u0dd0\u0dbd\u0dca\u0db4\u0ddc\u0dbd - \u0daf\u0da0\u0dca\u0da0\u0dc4\u0dbd\u0dca\u0db8\u0dd2\u0dbd\u0dca\u0dbd\u0dd1\u0dc0 \u0db4\u0dcf\u0dbb, \u0d9c\u0dbd\u0dd9\u0db1\u0dca\u0db6\u0dd2\u0db3\u0dd4\u0dab\u0dd4\u0dc0\u0dd0\u0dc0",
    ta: "\u0b95\u0ba9\u0bc7\u0bb5\u0bc6\u0bb2\u0bcd\u0baa\u0bca\u0bb2 - \u0ba4\u0b9a\u0bcd\u0b9a\u0bb9\u0bb2\u0bcd\u0bae\u0bbf\u0bb2\u0bcd\u0bb2\u0bc7\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb2\u0bc6\u0ba9\u0bcd\u0baa\u0bbf\u0ba8\u0bcd\u0ba4\u0bc1\u0ba9\u0bc1\u0bb5\u0bc6\u0bb5",
  },
  "Gas Station, B27, Dambadeniya": {
    si: "\u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db6\u0dd3 27, \u0daf\u0db9\u0daf\u0dd9\u0dab\u0dd2\u0dba",
    ta: "\u0b8e\u0bb0\u0bbf\u0bb5\u0bbe\u0baf\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, B27, \u0ba4\u0bae\u0bcd\u0baa\u0ba4\u0bc6\u0ba9\u0bbf\u0baf",
  },
  "George R. De Silva Mawatha, Colombo -13": {
    si: "\u0da2\u0ddd\u0dbb\u0dca\u0da2\u0dca \u0d86\u0dbb\u0dca \u0daf \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 -13",
    ta: "\u0b9c\u0bcb\u0bb0\u0bcd\u0b9c\u0bcd \u0b86\u0bb0\u0bcd. \u0b9f\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 -13",
  },
  "Ginigathhena Road, Yatiyanthota": {
    si: "\u0d9c\u0dd2\u0db1\u0dd2\u0d9c\u0dad\u0dca\u0dc4\u0dda\u0db1 \u0db4\u0dcf\u0dbb, \u0dba\u0da7\u0dd2\u0dba\u0db1\u0dca\u0dad\u0ddc\u0da7",
    ta: "\u0b95\u0bbf\u0ba9\u0bbf\u0b95\u0ba4\u0bcd\u0ba4\u0bc7\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8",
  },
  "Giritale Road, Bakamuna": {
    si: "\u0d9c\u0dd2\u0dbb\u0dd2\u0dad\u0dbd\u0dda \u0db4\u0dcf\u0dbb, \u0db6\u0d9a\u0db8\u0dd6\u0dab",
    ta: "\u0b95\u0bbf\u0bb0\u0bbf\u0ba4\u0bb2\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0b95\u0bae\u0bc1\u0ba9",
  },
  Giriulla: {
    si: "\u0d9c\u0dd2\u0dbb\u0dd2\u0d8b\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe",
  },
  "Giriulla 1, Sri Lanka": {
    si: "\u0d9c\u0dd2\u0dbb\u0dd2\u0d8b\u0dbd\u0dca\u0dbd 1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe 1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Godagama: {
    si: "\u0d9c\u0ddc\u0da9\u0d9c\u0db8",
    ta: "\u0b95\u0bca\u0b9f\u0b95\u0bae",
  },
  "Godagama Lanka Fuel Station, A2, Godagama, Thelwatta": {
    si: "\u0d9c\u0ddc\u0da9\u0d9c\u0db8 \u0dbd\u0d82\u0d9a\u0dcf \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, A2, \u0d9c\u0ddc\u0da9\u0d9c\u0db8, \u0dad\u0dd9\u0dbd\u0dca\u0dc0\u0dad\u0dca\u0dad",
    ta: "\u0b95\u0bca\u0b9f\u0b95\u0bae \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, A2, \u0b95\u0bca\u0b9f\u0b95\u0bae, \u0ba4\u0bc6\u0bb2\u0bcd\u0bb5\u0ba4\u0bcd\u0ba4",
  },
  "Godagama Lanka Fuel Station, Godagama Lanka Fuel Station, Godagama, A2, Godagama, Sri Lanka":
    {
      si: "\u0d9c\u0ddc\u0da9\u0d9c\u0db8 \u0dbd\u0d82\u0d9a\u0dcf \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9c\u0ddc\u0da9\u0d9c\u0db8 \u0dbd\u0d82\u0d9a\u0dcf \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9c\u0ddc\u0da9\u0d9c\u0db8, A2, \u0d9c\u0ddc\u0da9\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "\u0b95\u0bca\u0b9f\u0b95\u0bae \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0bca\u0b9f\u0b95\u0bae \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0bca\u0b9f\u0b95\u0bae, A2, \u0b95\u0bca\u0b9f\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  Godakawela: {
    si: "\u0d9c\u0ddc\u0da9\u0d9a\u0dc0\u0dd9\u0dbd",
    ta: "\u0b95\u0bca\u0b9f\u0b95\u0bb5\u0bc6\u0bb2",
  },
  Gomarankadawala: {
    si: "\u0d9c\u0ddd\u0db8\u0dbb\u0db1\u0dca\u0d9a\u0da9\u0dc0\u0dbd",
    ta: "\u0b95\u0bcb\u0bae\u0bb0\u0ba9\u0bcd\u0b95\u0b9f\u0bb5\u0bb2",
  },
  Gonapola: {
    si: "\u0d9c\u0ddd\u0db1\u0db4\u0ddc\u0dbd",
    ta: "\u0b95\u0bcb\u0ba3\u0baa\u0bca\u0bb2",
  },
  Gonawala: {
    si: "\u0d9c\u0ddd\u0db1\u0dc0\u0dbd",
    ta: "\u0b95\u0bcb\u0ba9\u0bbe\u0bb5\u0bbe\u0bb2\u0bbe",
  },
  Gothatuwa: {
    si: "\u0d9c\u0ddc\u0dad\u0da7\u0dd4\u0dc0",
    ta: "\u0b95\u0bcb\u0ba4\u0b9f\u0bc1\u0bb5",
  },
  "Greens Rd, Negombo": {
    si: "\u0d9c\u0dca\u200d\u0dbb\u0dd3\u0db1\u0dca\u0dc3\u0dca \u0db4\u0dcf\u0dbb, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0b95\u0bbf\u0bb0\u0bc0\u0ba9\u0bcd\u0bb8\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "Gunasiri Lanka Filling Station, Potuhera": {
    si: "\u0d9c\u0dd4\u0dab\u0dc3\u0dd2\u0dbb\u0dd2 \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db4\u0ddc\u0dad\u0dd4\u0dc4\u0dd0\u0dbb",
    ta: "\u0b95\u0bc1\u0ba3\u0b9a\u0bbf\u0bb1\u0bbf \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0baa\u0bca\u0b9f\u0bc1\u0bb9\u0bc6\u0bb0",
  },
  "H A L K PERERA": {
    si: "\u0d91\u0da0\u0dca \u0d92 \u0d91\u0dbd\u0dca \u0d9a\u0dda \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b8e\u0b9a\u0bcd \u0b8f \u0b8e\u0bb2\u0bcd \u0b95\u0bc7 \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "H A N JAYARATHNA": {
    si: "\u0d91\u0da0\u0dca \u0d92 \u0d91\u0db1\u0dca \u0da2\u0dba\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b8e\u0b9a\u0bcd \u0b8f \u0b8e\u0ba9\u0bcd \u0b9c\u0bc6\u0baf\u0bb0\u0ba4\u0bcd\u0ba9\u0bbe",
  },
  "H C J PERERA": {
    si: "\u0d91\u0da0\u0dca \u0dc3\u0dd3 \u0da2\u0dda \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b8e\u0b9a\u0bcd \u0b9a\u0bbf \u0b9c\u0bc7 \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "H D BUDDHIPALA INDANA PIRAUMHALA": {
    si: "\u0d91\u0da0\u0dca \u0da9\u0dd3 \u0db6\u0dd4\u0daf\u0dca\u0db0\u0dd2\u0db4\u0dcf\u0dbd \u0d89\u0db1\u0dca\u0daf\u0db1 \u0db4\u0dd2\u0dbb\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b8e\u0b9a\u0bcd \u0b9f\u0bbf \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bbf\u0baa\u0bbe\u0bb2 \u0b87\u0ba8\u0bcd\u0ba4\u0ba9\u0bbe \u0baa\u0bbf\u0bb1\u0bb5\u0bc1\u0bae\u0bcd\u0bb9\u0bbe\u0bb2\u0bbe",
  },
  "H D C HOLDINGS ( PVT ) LTD": {
    si: "H D C HOLDINGS (PVT) LTD",
    ta: "\u0b8e\u0b9a\u0bcd \u0b9f\u0bbf \u0b9a\u0bbf \u0bb9\u0bcb\u0bb2\u0bcd\u0b9f\u0bbf\u0b99\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "H D CHARLIS APPUHAMY & SONS": {
    si: "\u0d91\u0da0\u0dca \u0da9\u0dd3 \u0da0\u0dcf\u0dbd\u0dd2\u0dc3\u0dca \u0d85\u0db4\u0dca\u0db4\u0dd4\u0dc4\u0dcf\u0db8\u0dd2 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b8e\u0b9a\u0bcd \u0b9f\u0bbf \u0b9a\u0bbe\u0bb0\u0bcd\u0bb2\u0bbf\u0bb8\u0bcd \u0b85\u0baa\u0bcd\u0baa\u0bc1\u0bb9\u0bbe\u0bae\u0bbf & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "H D WEERAKOON": {
    si: "\u0d91\u0da0\u0dca \u0da9\u0dd3 \u0dc0\u0dd3\u0dbb\u0d9a\u0ddd\u0db1\u0dca",
    ta: "\u0b8e\u0b9a\u0bcd \u0b9f\u0bbf \u0bb5\u0bc0\u0bb0\u0b95\u0bcb\u0ba9\u0bcd",
  },
  "H G P .GAMINI": {
    si: "H G P .GAMINI",
    ta: "\u0b8e\u0b9a\u0bcd \u0b9c\u0bbf \u0baa\u0bbf .\u0b95\u0bbe\u0bae\u0bbf\u0ba9\u0bbf",
  },
  "H H D E P HERATH": {
    si: "\u0d91\u0da0\u0dca \u0d91\u0da0\u0dca \u0da9\u0dd3 \u0d8a \u0db4\u0dd3 \u0dc4\u0dda\u0dbb\u0dad\u0dca",
    ta: "\u0b8e\u0b9a\u0bcd \u0b8e\u0b9a\u0bcd \u0b9f\u0bbf \u0b87 \u0baa\u0bbf \u0bb9\u0bc6\u0bb0\u0ba4\u0bcd",
  },
  "H J KITHSIRI": {
    si: "\u0d91\u0da0\u0dca \u0da2\u0dda \u0d9a\u0dd2\u0dad\u0dca\u0dc3\u0dd2\u0dbb\u0dd2",
    ta: "\u0b8e\u0b9a\u0bcd \u0b9c\u0bc7 \u0b95\u0bbf\u0ba4\u0bcd\u0b9a\u0bbf\u0bb0\u0bbf",
  },
  "H K S RANASINGHE": {
    si: "\u0d91\u0da0\u0dca \u0d9a\u0dda \u0d91\u0dc3\u0dca \u0dbb\u0dab\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b8e\u0b9a\u0bcd \u0b95\u0bc7 \u0b8e\u0bb8\u0bcd \u0bb0\u0ba3\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "H M K HERATH": {
    si: "\u0d91\u0da0\u0dca \u0d91\u0db8\u0dca \u0d9a\u0dda \u0dc4\u0dda\u0dbb\u0dad\u0dca",
    ta: "\u0b8e\u0b9a\u0bcd \u0b8e\u0bae\u0bcd \u0b95\u0bc7 \u0bb9\u0bc7\u0bb0\u0ba4\u0bcd",
  },
  "H M M K JAYASENA": {
    si: "\u0d91\u0da0\u0dca \u0d91\u0db8\u0dca \u0d91\u0db8\u0dca \u0d9a\u0dda \u0da2\u0dba\u0dc3\u0dda\u0db1",
    ta: "\u0b8e\u0b9a\u0bcd \u0b8e\u0bae\u0bcd \u0b8e\u0bae\u0bcd \u0b95\u0bc7 \u0b9c\u0baf\u0b9a\u0bc7\u0ba9",
  },
  "H M M N HERATH": {
    si: "\u0d91\u0da0\u0dca \u0d91\u0db8\u0dca \u0d91\u0db8\u0dca \u0d91\u0db1\u0dca \u0dc4\u0dda\u0dbb\u0dad\u0dca",
    ta: "\u0b8e\u0b9a\u0bcd \u0b8e\u0bae\u0bcd \u0b8e\u0bae\u0bcd \u0b8e\u0ba9\u0bcd \u0bb9\u0bc6\u0bb0\u0ba4\u0bcd",
  },
  "H M MALLIKA HINDAGODA": {
    si: "\u0d91\u0da0\u0dca \u0d91\u0db8\u0dca \u0db8\u0dbd\u0dca\u0dbd\u0dd2\u0d9a\u0dcf \u0dc4\u0dd2\u0db3\u0d9c\u0ddc\u0da9",
    ta: "\u0b8e\u0b9a\u0bcd \u0b8e\u0bae\u0bcd \u0bae\u0bb2\u0bcd\u0bb2\u0bbf\u0b95\u0bbe \u0bb9\u0bbf\u0ba8\u0bcd\u0ba4\u0b95\u0bcb\u0b9f\u0bbe",
  },
  "H M SUNIL JAYARATHNA": {
    si: "\u0d91\u0da0\u0dca \u0d91\u0db8\u0dca \u0dc3\u0dd4\u0db1\u0dd2\u0dbd\u0dca \u0da2\u0dba\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b8e\u0b9a\u0bcd \u0b8e\u0bae\u0bcd \u0b9a\u0bc1\u0ba9\u0bbf\u0bb2\u0bcd \u0b9c\u0baf\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "H P B S GODIGAMUWA": {
    si: "\u0d91\u0da0\u0dca \u0db4\u0dd3 \u0db6\u0dd3 \u0d91\u0dc3\u0dca \u0d9c\u0ddc\u0da9\u0dd2\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0b8e\u0b9a\u0bcd \u0baa\u0bbf \u0baa\u0bbf \u0b8e\u0bb8\u0bcd \u0b95\u0bca\u0b9f\u0bbf\u0b95\u0bae\u0bc1\u0bb5",
  },
  "H P.PALANSURIYA": {
    si: "\u0d91\u0da0\u0dca.\u0db4\u0dd3.\u0db4\u0dbd\u0db1\u0dca\u0dc3\u0dd6\u0dbb\u0dd2\u0dba",
    ta: "\u0b8e\u0b9a\u0bcd.\u0baa\u0bbf.\u0baa\u0bbe\u0bb2\u0ba9\u0bcd\u0b9a\u0bc2\u0bb0\u0bbf\u0baf\u0bbe",
  },
  "H SRIYANI PATRICIA FONSEKA": {
    si: "\u0d91\u0da0\u0dca \u0dc1\u0dca\u200d\u0dbb\u0dd2\u0dba\u0dcf\u0db1\u0dd2 \u0db4\u0dd0\u0da7\u0dca\u200d\u0dbb\u0dd3\u0dc2\u0dd2\u0dba\u0dcf \u0dc6\u0ddc\u0db1\u0dca\u0dc3\u0dda\u0d9a\u0dcf",
    ta: "\u0b8e\u0b9a\u0bcd \u0bb8\u0bcd\u0bb0\u0bc0\u0baf\u0bbe\u0ba9\u0bbf \u0baa\u0bbe\u0b9f\u0bcd\u0bb0\u0bbf\u0b9a\u0bbf\u0baf\u0bbe \u0baa\u0bca\u0ba9\u0bcd\u0b9a\u0bc7\u0b95\u0bbe",
  },
  "H WICRAMARATHNE": {
    si: "\u0d91\u0da0\u0dca \u0dc0\u0dd2\u0d9a\u0dca\u200d\u0dbb\u0db8\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b8e\u0b9a\u0bcd \u0bb5\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb0\u0bae\u0bb0\u0ba4\u0bcd\u0ba9\u0bc7",
  },
  "H. L. W. ENTERPRISES (PVT) LTD": {
    si: "H. L. W. ENTERPRISES (PVT) LTD",
    ta: "\u0b8e\u0b9a\u0bcd.\u0b8e\u0bb2\u0bcd.\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2. \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "H.A..WIMALAWATHI": {
    si: "\u0d91\u0da0\u0dca.\u0d92.\u0dc0\u0dd2\u0db8\u0dbd\u0dcf\u0dc0\u0dad\u0dd3",
    ta: "\u0b8e\u0b9a\u0bcd.\u0b8f..\u0bb5\u0bbf\u0bae\u0bb2\u0bbe\u0bb5\u0ba4\u0bbf",
  },
  "H.D.PEIRIS & COMPANY": {
    si: "\u0d91\u0da0\u0dca.\u0da9\u0dd3.\u0db4\u0dd3\u0dbb\u0dd2\u0dc3\u0dca \u0dc3\u0dc4 \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0b8e\u0b9a\u0bcd.\u0b9f\u0bbf.\u0baa\u0bc0\u0bb0\u0bbf\u0bb8\u0bcd & \u0ba8\u0bbf\u0bb1\u0bc1\u0bb5\u0ba9\u0bae\u0bcd",
  },
  "H.G.SIRISENA ASSOCIATES": {
    si: "\u0d91\u0da0\u0dca.\u0da2\u0dd3.\u0dc3\u0dd2\u0dbb\u0dd2\u0dc3\u0dda\u0db1 \u0d87\u0dc3\u0ddd\u0dc3\u0dd2\u0dba\u0dda\u0da7\u0dca\u0dc3\u0dca",
    ta: "\u0b8e\u0b9a\u0bcd.\u0b9c\u0bbf.\u0b9a\u0bbf\u0bb1\u0bbf\u0b9a\u0bc7\u0ba9\u0bbe \u0b85\u0b9a\u0bcb\u0b9a\u0bbf\u0baf\u0bc7\u0b9f\u0bcd\u0bb8\u0bcd",
  },
  "H.K.D.R.S.PERERA": {
    si: "\u0d91\u0da0\u0dca.\u0d9a\u0dda.\u0da9\u0dd3.\u0d86\u0dbb\u0dca.\u0d91\u0dc3\u0dca.\u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b8e\u0b9a\u0bcd.\u0b95\u0bc7.\u0b9f\u0bbf.\u0b86\u0bb0\u0bcd.\u0b8e\u0bb8\u0bcd.\u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "H.M. AMEER ALI": {
    si: "\u0d91\u0da0\u0dca.\u0d91\u0db8\u0dca. \u0d85\u0db8\u0dd3\u0dbb\u0dca \u0d85\u0dbd\u0dd2",
    ta: "\u0b8e\u0b9a\u0bcd.\u0b8e\u0bae\u0bcd. \u0b85\u0bae\u0bc0\u0bb0\u0bcd \u0b85\u0bb2\u0bbf",
  },
  "H.M.R.B Hearth Meewellawa Autocare": {
    si: "H.M.R.B Hearth Meewellawa Autocare",
    ta: "H.M.R.B Hearth Meewellawa Autocare",
  },
  "H.M.TILLAKASIRI": {
    si: "\u0d91\u0da0\u0dca.\u0d91\u0db8\u0dca.\u0dad\u0dd2\u0dbd\u0d9a\u0dc3\u0dd2\u0dbb\u0dd2",
    ta: "\u0b8e\u0b9a\u0bcd.\u0b8e\u0bae\u0bcd.\u0ba4\u0bbf\u0bb2\u0b95\u0bbe\u0b9a\u0bbf\u0bb0\u0bbf",
  },
  "H.M.W.BANDARA": {
    si: "\u0d91\u0da0\u0dca.\u0d91\u0db8\u0dca.\u0da9\u0db6\u0dca.\u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb",
    ta: "\u0b8e\u0b9a\u0bcd.\u0b8e\u0bae\u0bcd.\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0",
  },
  "H.N.W.Priyangani De Silva": {
    si: "H.N.W.Priyangani De Silva",
    ta: "\u0b8e\u0b9a\u0bcd.\u0b8e\u0ba9\u0bcd.\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0baa\u0bbf\u0bb0\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0ba9\u0bbf \u0b9f\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe",
  },
  "H.P.D.R.K.WEERASINGHE": {
    si: "\u0d91\u0da0\u0dca.\u0db4\u0dd3.\u0da9\u0dd3.\u0d86\u0dbb\u0dca.\u0d9a\u0dda.\u0dc0\u0dd3\u0dbb\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b8e\u0b9a\u0bcd.\u0baa\u0bbf.\u0b9f\u0bbf.\u0b86\u0bb0\u0bcd.\u0b95\u0bc7.\u0bb5\u0bc0\u0bb0\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "H.R.DHARMAPALA": {
    si: "\u0d91\u0da0\u0dca.\u0d86\u0dbb\u0dca.\u0db0\u0dbb\u0dca\u0db8\u0db4\u0dcf\u0dbd",
    ta: "\u0b8e\u0b9a\u0bcd.\u0b86\u0bb0\u0bcd.\u0ba4\u0bb0\u0bcd\u0bae\u0baa\u0bbe\u0bb2",
  },
  "H.W.PAGNADASA": {
    si: "\u0d91\u0da0\u0dca.\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0db4\u0da4\u0dca\u0da4\u0daf\u0dcf\u0dc3",
    ta: "\u0b8e\u0b9a\u0bcd.\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0baa\u0b9e\u0ba4\u0bbe\u0b9a",
  },
  "H.W.WILLIAM SILVA  ENTERPRISES": {
    si: "\u0d91\u0da0\u0dca.\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0dc0\u0dd2\u0dbd\u0dd2\u0dba\u0db8\u0dca \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b8e\u0b9a\u0bcd.\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0bb5\u0bbf\u0bb2\u0bcd\u0bb2\u0bbf\u0baf\u0bae\u0bcd \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "H239+G75, Kalutara, Sri Lanka": {
    si: "H239+G75, \u0d9a\u0dc5\u0dd4\u0dad\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "H239+G75, \u0b95\u0bb3\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "H25G+6P Divulgasanga, Sri Lanka": {
    si: "H25G+6P \u0daf\u0dd2\u0dc0\u0dd4\u0dbd\u0dca\u0d9c\u0dc3\u0d82\u0d9c, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "H25G+6P \u0ba4\u0bbf\u0bb5\u0bc1\u0bb2\u0bcd\u0b95\u0b9a\u0b99\u0bcd\u0b95\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "H3WR+HCG, Horana - Anguruwatota - Mathugama - Aluthgama Road, Neboda, Sri Lanka":
    {
      si: "H3WR+HCG, \u0dc4\u0ddc\u0dbb\u0dab - \u0d85\u0d9f\u0dd4\u0dbb\u0dd4\u0dc0\u0dcf\u0dad\u0ddc\u0da7 - \u0db8\u0dad\u0dd4\u0d9c\u0db8 - \u0d85\u0dbd\u0dd4\u0dad\u0dca\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0db1\u0dd9\u0db6\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "H3WR+HCG, \u0bb9\u0bca\u0bb0\u0ba3\u0bc8 - \u0b85\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0bc1\u0bb5\u0ba4\u0bca\u0b9f\u0bcd\u0b9f - \u0bae\u0ba4\u0bcd\u0ba4\u0bc1\u0b95\u0bae - \u0b85\u0bb2\u0bc1\u0ba4\u0bcd\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc6\u0baa\u0bcb\u0b9f, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "H4WR+3V Telulla, Sri Lanka": {
    si: "H4WR+3V \u0da7\u0dd9\u0dbd\u0dd4\u0dbd\u0dca\u0dbd\u0dcf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "H4WR+3V \u0ba4\u0bc6\u0bb2\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "H52V+W3F, Neddumkudah, Sri Lanka": {
    si: "H52V+W3F, \u0db1\u0dd9\u0daf\u0dca\u0daf\u0dd4\u0db8\u0dca\u0d9a\u0dd4\u0da9\u0dcf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "H52V+W3F, \u0ba8\u0bc6\u0b9f\u0bc1\u0bae\u0bcd\u0b95\u0bc1\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "H599+5V Sardhapura, Sri Lanka": {
    si: "H599+5V \u0dc3\u0dbb\u0dca\u0db0\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "H599+5V \u0b9a\u0bb0\u0bcd\u0ba4\u0bbe\u0baa\u0bc1\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "H59V+GM Trincomalee, Sri Lanka": {
    si: "H59V+GM \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "H59V+GM \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "H6GM+JM2, Trincomalee, Sri Lanka": {
    si: "H6GM+JM2, \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "H6GM+JM2, \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "H6W2+PM Gorokgasagara, Sri Lanka": {
    si: "H6W2+PM \u0d9c\u0ddc\u0dbb\u0ddc\u0d9a\u0dca\u0d9c\u0dc3\u0dcf\u0d9c\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "H6W2+PM \u0b95\u0bcb\u0bb0\u0bcb\u0b95\u0bcd\u0b95\u0b9a\u0bbe\u0b95\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "H94X+WV Pachchilapalli, Sri Lanka": {
    si: "H94X+WV \u0db4\u0da0\u0dca\u0da0\u0dd2\u0dbd\u0db4\u0dbd\u0dca\u0dbd\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "H94X+WV \u0baa\u0b9a\u0bcd\u0b9a\u0bbf\u0bb2\u0baa\u0bcd\u0baa\u0bb3\u0bcd\u0bb3\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HABARADUWA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dc4\u0db6\u0dbb\u0dcf\u0daf\u0dd4\u0dc0 MPCS",
    ta: "\u0bb9\u0baa\u0bb0\u0ba4\u0bc1\u0bb5\u0bbe MPCS LTD",
  },
  HABARANA: {
    si: "\u0dc4\u0db6\u0dbb\u0dab",
    ta: "\u0bb9\u0baa\u0bb0\u0ba9\u0bbe",
  },
  "HADJI SHL ABDUL CADER & SONS": {
    si: "\u0dc4\u0da9\u0dca\u0da2\u0dd2 \u0d91\u0dc3\u0dca\u0d91\u0da0\u0dca\u0d91\u0dbd\u0dca \u0d85\u0db6\u0dca\u0daf\u0dd4\u0dbd\u0dca \u0d9a\u0dcf\u0daf\u0dbb\u0dca \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0bb9\u0b9f\u0bcd\u0b9c\u0bbf \u0b8e\u0bb8\u0bcd\u0bb9\u0bc6\u0b9a\u0bcd\u0b8e\u0bb2\u0bcd \u0b85\u0baa\u0bcd\u0ba4\u0bc1\u0bb2\u0bcd \u0b95\u0bc7\u0b9f\u0bb0\u0bcd & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "HAFA TRADES": {
    si: "\u0dc4\u0dc6\u0dcf \u0dc0\u0dd9\u0dc5\u0db3\u0dcf\u0db8",
    ta: "HAFA \u0bb5\u0bb0\u0bcd\u0ba4\u0bcd\u0ba4\u0b95\u0b99\u0bcd\u0b95\u0bb3\u0bcd",
  },
  "HAKMANA MPCS LTD": {
    si: "\u0dc4\u0d9a\u0dca\u0db8\u0db1 MPCS LTD",
    ta: "\u0bb9\u0b95\u0bcd\u0bae\u0bbe\u0ba9\u0bbe MPCS LTD",
  },
  "HALI ELA MPCS LTD": {
    si: "\u0dc4\u0dcf\u0dbd\u0dd2 \u0d87\u0dbd MPCS LTD",
    ta: "\u0bb9\u0bbe\u0bb2\u0bbf \u0b8e\u0bb2\u0bbe \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0b9a\u0bbf\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "HAMBANTOTA MPCS LTD": {
    si: "\u0dc4\u0db8\u0dca\u0db6\u0db1\u0dca\u0dad\u0ddc\u0da7 MPCS LTD",
    ta: "\u0bb9\u0bae\u0bcd\u0baa\u0bbe\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 MPCS LTD",
  },
  "HANA LANKA LOGISTICS (PVT) LTD": {
    si: "\u0dc4\u0db1\u0dcf \u0dbd\u0d82\u0d9a\u0dcf \u0dbd\u0ddc\u0da2\u0dd2\u0dc3\u0dca\u0da7\u0dd2\u0d9a\u0dca\u0dc3\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0bb9\u0ba9\u0bbe \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0bb2\u0bbe\u0b9c\u0bbf\u0bb8\u0bcd\u0b9f\u0bbf\u0b95\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "HANGURANKETA MPCS LTD": {
    si: "\u0dc4\u0d9f\u0dd4\u0dbb\u0db1\u0dca\u0d9a\u0dd9\u0da7 MPCS LTD",
    ta: "\u0bb9\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0bbe\u0b99\u0bcd\u0b95\u0bc7\u0b9f\u0bcd\u0b9f\u0bbe MPCS LTD",
  },
  "HAPUTALE MPCS LTD": {
    si: "\u0dc4\u0db4\u0dd4\u0dad\u0dbd\u0dda MPCS LTD",
    ta: "\u0bb9\u0baa\u0bcd\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8 MPCS LTD",
  },
  "HARISCHANDRA MILLS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dc4\u0dbb\u0dd2\u0dc3\u0dca\u0da0\u0db1\u0dca\u0daf\u0dca\u200d\u0dbb \u0db8\u0dd2\u0dbd\u0dca\u0dc3\u0dca",
    ta: "\u0bb9\u0bb0\u0bbf\u0b9a\u0bcd\u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0bbe \u0bae\u0bbf\u0bb2\u0bcd\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "HARISPATTU NORTH MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dc4\u0dcf\u0dbb\u0dd2\u0dc3\u0dca\u0db4\u0dad\u0dca\u0dad\u0dd4 \u0db1\u0ddd\u0dbb\u0dca\u0dad\u0dca \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0bb9\u0bbe\u0bb0\u0bbf\u0bb8\u0bcd\u0baa\u0b9f\u0bcd\u0b9f\u0bc1 \u0bb5\u0b9f\u0b95\u0bcd\u0b95\u0bc1 MPCS LTD",
  },
  "HARISPATTU SOUTH MPCS LTD": {
    si: "\u0dc4\u0dcf\u0dbb\u0dd2\u0dc3\u0dca\u0db4\u0dad\u0dca\u0dad\u0dd4 \u0daf\u0d9a\u0dd4\u0dab\u0dd4 MPCS LTD",
    ta: "\u0bb9\u0bbe\u0bb0\u0bbf\u0bb8\u0bcd\u0baa\u0b9f\u0bcd\u0b9f\u0bc1 \u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1 MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "HARSHA D WEERAKOON": {
    si: "\u0dc4\u0dbb\u0dca\u0dc2 \u0da9\u0dd3 \u0dc0\u0dd3\u0dbb\u0d9a\u0ddd\u0db1\u0dca",
    ta: "\u0bb9\u0bb0\u0bcd\u0bb7\u0bbe \u0b9f\u0bbf \u0bb5\u0bc0\u0bb0\u0b95\u0bcb\u0ba9\u0bcd",
  },
  "HARSHA DUMINDA WEERAKOON": {
    si: "\u0dc4\u0dbb\u0dca\u0dc2 \u0daf\u0dd4\u0db8\u0dd2\u0db1\u0dca\u0daf \u0dc0\u0dd3\u0dbb\u0d9a\u0ddd\u0db1\u0dca",
    ta: "\u0bb9\u0bb0\u0bcd\u0bb7 \u0ba4\u0bc1\u0bae\u0bbf\u0ba8\u0bcd\u0ba4 \u0bb5\u0bc0\u0bb0\u0b95\u0bcb\u0ba9\u0bcd",
  },
  "HARSHA GARDIHEWA": {
    si: "\u0dc4\u0dbb\u0dca\u0dc2 \u0d9c\u0dcf\u0dbb\u0dca\u0daf\u0dd2\u0dc4\u0dda\u0dc0\u0dcf",
    ta: "\u0bb9\u0bb0\u0bcd\u0bb7 \u0b95\u0bbe\u0bb0\u0bcd\u0b9f\u0bbf\u0bb9\u0bc7\u0bb5\u0bbe",
  },
  "HASALAKA MPCS LTD": {
    si: "\u0dc4\u0dc3\u0dbd\u0d9a MPCS LTD",
    ta: "\u0bb9\u0b9a\u0bb2\u0b95\u0bbe MPCS LTD",
  },
  "HATARALIADDE MPCS LTD": {
    si: "\u0dc4\u0dad\u0dbb\u0dbd\u0dd2\u0dba\u0dd0\u0daf\u0dca\u0daf MPCS LTD",
    ta: "\u0bb9\u0b9f\u0bb0\u0bbe\u0bb2\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0bc7 MPCS LTD",
  },
  "HEMA RANJANEE PATHIRANA": {
    si: "\u0dc4\u0dda\u0db8\u0dcf \u0dbb\u0d82\u0da2\u0db1\u0dd3 \u0db4\u0dad\u0dd2\u0dbb\u0dab",
    ta: "\u0bb9\u0bc7\u0bae \u0bb0\u0b9e\u0bcd\u0b9a\u0ba9\u0bbf \u0baa\u0ba4\u0bcd\u0ba4\u0bbf\u0bb0\u0ba9\u0bbe",
  },
  "HETTIGODA ENTERPRISES": {
    si: "\u0dc4\u0dd9\u0da7\u0dca\u0da7\u0dd2\u0d9c\u0ddc\u0da9 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0bb9\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bca\u0b9f \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "HEWAGAM KORALE EAST MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dc4\u0dda\u0dc0\u0dcf\u0d9c\u0db8\u0dca \u0d9a\u0ddd\u0dbb\u0dc5\u0dda \u0d8a\u0dc3\u0dca\u0da7\u0dca \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0bb9\u0bc7\u0bb5\u0b95\u0bae\u0bcd \u0b95\u0bcb\u0bb0\u0bb2\u0bc7 \u0b95\u0bbf\u0bb4\u0b95\u0bcd\u0b95\u0bc1 MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "HEWAGAM KORALE EAST MPCS LTD.": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dc4\u0dda\u0dc0\u0dcf\u0d9c\u0db8\u0dca \u0d9a\u0ddd\u0dbb\u0dc5\u0dda \u0d8a\u0dc3\u0dca\u0da7\u0dca \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca.",
    ta: "\u0bb9\u0bc7\u0bb5\u0b95\u0bae\u0bcd \u0b95\u0bcb\u0bb0\u0bb2\u0bc7 \u0b95\u0bbf\u0bb4\u0b95\u0bcd\u0b95\u0bc1 MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd.",
  },
  "HEWAGAMA - KADUWELA": {
    si: "\u0dc4\u0dda\u0dc0\u0dcf\u0d9c\u0db8 - \u0d9a\u0da9\u0dd4\u0dc0\u0dd9\u0dbd",
    ta: "\u0bb9\u0bc7\u0bb5\u0bbe\u0b95\u0bae - \u0b95\u0b9f\u0bc1\u0bb5\u0bc6\u0bb2",
  },
  "HEWAGAMKORALE WEST MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dc4\u0dda\u0dc0\u0dcf\u0d9c\u0db8\u0dca\u0d9a\u0ddd\u0dbb\u0dbd\u0dda \u0db6\u0da7\u0dc4\u0dd2\u0dbb MPCS",
    ta: "\u0bb9\u0bc6\u0bb5\u0b95\u0bae\u0bcd\u0b95\u0bcb\u0bb0\u0bb2\u0bc7 \u0bae\u0bc7\u0bb1\u0bcd\u0b95\u0bc1 MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "HF3P+VG2, Medawachchiya, Sri Lanka": {
    si: "HF3P+VG2, \u0db8\u0dd0\u0daf\u0dc0\u0da0\u0dca\u0da0\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HF3P+VG2, \u0bae\u0bc7\u0b9f\u0bb5\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HFC8+M66, Ipalawa, Sri Lanka": {
    si: "HFC8+M66, \u0d89\u0db4\u0dbd\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HFC8+M66, \u0b87\u0baa\u0bb2\u0bbe\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HFW5+C84, Tiruwanaketiya-Agalawatte Rd, Nivithigala, Sri Lanka": {
    si: "HFW5+C84, \u0dad\u0dd2\u0dbb\u0dd4\u0dc0\u0dcf\u0db1\u0dcf\u0d9a\u0dd0\u0da7\u0dd2\u0dba-\u0d85\u0d9c\u0dbd\u0dc0\u0dad\u0dca\u0dad \u0db4\u0dcf\u0dbb, \u0db1\u0dd2\u0dc0\u0dd2\u0dad\u0dd2\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HFW5+C84, \u0ba4\u0bbf\u0bb0\u0bc1\u0bb5\u0ba9\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf-\u0b85\u0b95\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bbf\u0bb5\u0bbf\u0ba4\u0bbf\u0b95\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HFXJ+6GH, Kurunegala - Dambulla Rd, Gokarella, Sri Lanka": {
    si: "HFXJ+6GH, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d9c\u0ddc\u0d9a\u0dbb\u0dd0\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HFXJ+6GH, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bca\u0b95\u0bb0\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HG96+3J3, Lihiniwehera, Sri Lanka": {
    si: "HG96+3J3, \u0dbd\u0dd2\u0dc4\u0dd2\u0dab\u0dd2\u0dc0\u0dd9\u0dc4\u0dd9\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HG96+3J3, \u0bb2\u0bbf\u0bb9\u0bbf\u0ba9\u0bbf\u0bb5\u0bc6\u0bb9\u0bc6\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HGCC+WFJ, Dodangaslanda, Sri Lanka": {
    si: "HGCC+WFJ, \u0daf\u0ddc\u0da9\u0d82\u0d9c\u0dc3\u0dca\u0dbd\u0db1\u0dca\u0daf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HGCC+WFJ, Dodangaslanda, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HH5R+X6R, Yatawatta, Sri Lanka": {
    si: "HH5R+X6R, \u0dba\u0da7\u0dc0\u0dad\u0dca\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HH5R+X6R, \u0baf\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HH6R+55G, Yatawatta, Sri Lanka": {
    si: "HH6R+55G, \u0dba\u0da7\u0dc0\u0dad\u0dca\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HH6R+55G, \u0baf\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HHJF+2G3, Kahawatta, Sri Lanka": {
    si: "HHJF+2G3, \u0d9a\u0dc4\u0dc0\u0dad\u0dca\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HHJF+2G3, \u0b95\u0bb9\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HHMF+988, Kahawatta, Sri Lanka": {
    si: "HHMF+988, \u0d9a\u0dc4\u0dc0\u0dad\u0dca\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HHMF+988, \u0b95\u0bb9\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HI TECH CARBON": {
    si: "\u0dc4\u0dba\u0dd2 \u0da7\u0dd9\u0d9a\u0dca \u0d9a\u0dcf\u0db6\u0db1\u0dca",
    ta: "\u0bb9\u0bc8 \u0b9f\u0bc6\u0b95\u0bcd \u0b95\u0bbe\u0bb0\u0bcd\u0baa\u0ba9\u0bcd",
  },
  "HIGHWAY ENTERPRISES": {
    si: "\u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c \u0dc0\u0dca\u0dba\u0dc0\u0dc3\u0dcf\u0dba\u0db1\u0dca",
    ta: "\u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8 \u0ba8\u0bbf\u0bb1\u0bc1\u0bb5\u0ba9\u0b99\u0bcd\u0b95\u0bb3\u0bcd",
  },
  "HINGURAKGODA MPCS LTD": {
    si: "\u0dc4\u0dd2\u0d9f\u0dd4\u0dbb\u0d9a\u0dca\u0d9c\u0ddc\u0da9 MPCS LTD",
    ta: "\u0bb9\u0bbf\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0bbe\u0b95\u0bcd\u0b95\u0bcb\u0b9f\u0bbe MPCS LTD",
  },
  "HINNIAPPUHAMY & SON": {
    si: "\u0dc4\u0dd2\u0db1\u0dca\u0db1\u0dd2\u0dba\u0db4\u0dca\u0db4\u0dd4\u0dc4\u0dcf\u0db8\u0dd2 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dcf",
    ta: "\u0bb9\u0bbf\u0ba9\u0bcd\u0ba9\u0bbf\u0baf\u0baa\u0bcd\u0baa\u0bc1\u0bb9\u0bbe\u0bae\u0bbf & \u0bae\u0b95\u0ba9\u0bcd",
  },
  "HIRAN MOTOR TRADERS": {
    si: "\u0dc4\u0dd2\u0dbb\u0db1\u0dca \u0db8\u0ddd\u0da7\u0dbb\u0dca \u0da7\u0dca\u200d\u0dbb\u0dda\u0da9\u0dbb\u0dca\u0dc3\u0dca",
    ta: "\u0bb9\u0bbf\u0bb0\u0ba9\u0bcd \u0bae\u0bcb\u0b9f\u0bcd\u0b9f\u0bbe\u0bb0\u0bcd \u0b9f\u0bbf\u0bb0\u0bc7\u0b9f\u0bb0\u0bcd\u0bb8\u0bcd",
  },
  "HIRIYALA MPCS LTD": {
    si: "\u0dc4\u0dd2\u0dbb\u0dd2\u0dba\u0dcf\u0dbd MPCS LTD",
    ta: "\u0bb9\u0bbf\u0bb0\u0bbf\u0baf\u0bbe\u0bb2 MPCS LTD",
  },
  "HIRUN ENTERPRIES": {
    si: "\u0dc4\u0dd2\u0dbb\u0dd4\u0db1\u0dca \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dca",
    ta: "\u0bb9\u0bbf\u0bb0\u0bc1\u0ba9\u0bcd \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0bb8\u0bcd",
  },
  "HOMAGAMA MPCS LTD": {
    si: "\u0dc4\u0ddd\u0db8\u0dcf\u0d9c\u0db8 MPCS LTD",
    ta: "\u0bb9\u0bcb\u0bae\u0bbe\u0b95\u0bae\u0bbe MPCS LTD",
  },
  "HONDAHITHA ENTERPRISES": {
    si: "\u0dc4\u0ddc\u0db1\u0dca\u0daf\u0dc4\u0dd2\u0dad \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0bb9\u0bcb\u0ba3\u0bcd\u0b9f\u0bbe\u0bb9\u0bbf\u0ba4\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "HPG3+VXV, Weligepola, Sri Lanka": {
    si: "HPG3+VXV, \u0dc0\u0dd0\u0dbd\u0dd2\u0d9c\u0dd9\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HPG3+VXV, \u0bb5\u0bc6\u0bb2\u0bbf\u0b95\u0bc7\u0baa\u0bca\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HQGV+PXR, Chilaw, Sri Lanka": {
    si: "HQGV+PXR, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HQGV+PXR, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HQMR+PC Chilaw, Sri Lanka": {
    si: "HQMR+PC \u0dc4\u0dbd\u0dcf\u0dc0\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HQMR+PC \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HQQG+P5 Kurukkalmadam, Sri Lanka": {
    si: "HQQG+P5 \u0d9a\u0dd4\u0dbb\u0dd4\u0d9a\u0dca\u0d9a\u0dbd\u0dca\u0db8\u0da9\u0db8\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HQQG+P5 \u0b95\u0bc1\u0bb0\u0bc1\u0b95\u0bcd\u0b95\u0bb3\u0bcd\u0bae\u0b9f\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HR2M+523, Horowupotana, Sri Lanka": {
    si: "HR2M+523, \u0dc4\u0ddc\u0dbb\u0ddc\u0dc0\u0dca\u0db4\u0ddc\u0dad\u0dcf\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HR2M+523, Horowupotana, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HR45+92H, Chilaw, Sri Lanka": {
    si: "HR45+92H, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HR45+92H, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HRP8+88 Kurichchikadu, Sri Lanka": {
    si: "HRP8+88 \u0d9a\u0dd4\u0dbb\u0dd2\u0da0\u0dca\u0da0\u0dd2\u0d9a\u0dcf\u0da9\u0dd4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HRP8+88 \u0b95\u0bc1\u0bb1\u0bbf\u0b9a\u0bcd\u0b9a\u0bbf\u0b95\u0bcd\u0b95\u0bbe\u0b9f\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HUNGAMA MPCS LTD": {
    si: "\u0dc4\u0dd4\u0d82\u0d9c\u0db8 MPCS LTD",
    ta: "\u0bb9\u0b99\u0bcd\u0b95\u0bbe\u0bae\u0bbe MPCS LTD",
  },
  "HUNNASGIRIYA AGENCIES": {
    si: "\u0dc4\u0dd4\u0db1\u0dca\u0db1\u0dc3\u0dca\u0d9c\u0dd2\u0dbb\u0dd2\u0dba \u0d92\u0da2\u0db1\u0dca\u0dc3\u0dd2",
    ta: "\u0bb9\u0bc1\u0ba9\u0bcd\u0ba9\u0bb8\u0bcd\u0b95\u0bbf\u0bb0\u0bbf\u0baf \u0b8f\u0b9c\u0bc6\u0ba9\u0bcd\u0b9a\u0bbf\u0b95\u0bb3\u0bcd",
  },
  "HVQF+PJW, Chilaw, Sri Lanka": {
    si: "HVQF+PJW, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HVQF+PJW, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HVVX+RRG, Sri Lanka": {
    si: "HVVX+RRG, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HVVX+RRG, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HWXR+8P2, Chilaw-Wariyapola Road, Bingiriya, Sri Lanka": {
    si: "HWXR+8P2, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad-\u0dc0\u0dcf\u0dbb\u0dd2\u0dba\u0db4\u0ddc\u0dbd \u0db4\u0dcf\u0dbb, \u0db6\u0dd2\u0d82\u0d9c\u0dd2\u0dbb\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HWXR+8P2, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd-\u0bb5\u0bbe\u0bb0\u0bbf\u0baf\u0baa\u0bca\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bbf\u0b99\u0bcd\u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HX69+VHJ, Kalutara, Sri Lanka": {
    si: "HX69+VHJ, \u0d9a\u0dc5\u0dd4\u0dad\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HX69+VHJ, \u0b95\u0bb3\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HXM6+H8M, Kalutara, Sri Lanka": {
    si: "HXM6+H8M, \u0d9a\u0dc5\u0dd4\u0dad\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HXM6+H8M, \u0b95\u0bb3\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "HXW3+Q52, Bowatta, Sri Lanka": {
    si: "HXW3+Q52, \u0db6\u0ddd\u0dc0\u0dad\u0dca\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "HXW3+Q52, \u0baa\u0bcb\u0bb5\u0b9f\u0bcd\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Habaraduwa: {
    si: "\u0dc4\u0db6\u0dbb\u0dcf\u0daf\u0dd4\u0dc0",
    ta: "\u0bb9\u0baa\u0bb0\u0bbe\u0ba4\u0bc1\u0bb5",
  },
  Hakmana: {
    si: "\u0dc4\u0d9a\u0dca\u0db8\u0db1",
    ta: "\u0bb9\u0b95\u0bcd\u0bae\u0ba9\u0bbe",
  },
  "Hakmana - Beliatte - Tangalle Rd, Beliatta": {
    si: "\u0dc4\u0d9a\u0dca\u0db8\u0db1 - \u0db6\u0dd9\u0dbd\u0dd2\u0d85\u0dad\u0dca\u0dad\u0dda - \u0dad\u0d82\u0d9c\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db6\u0dd9\u0dbd\u0dd2\u0d85\u0dad\u0dca\u0dad",
    ta: "\u0bb9\u0b95\u0bcd\u0bae\u0ba9 - \u0baa\u0bc6\u0bb2\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0bc8 - \u0ba4\u0b99\u0bcd\u0b95\u0bbe\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc6\u0bb2\u0bbf\u0baf\u0ba4\u0bcd\u0ba4",
  },
  "Hakmana - Beliatte - Tangalle Rd, Puwakdandawa": {
    si: "\u0dc4\u0d9a\u0dca\u0db8\u0db1 - \u0db6\u0dd9\u0dbd\u0dd2\u0d85\u0dad\u0dca\u0dad\u0dda - \u0dad\u0d82\u0d9c\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db4\u0dd4\u0dc0\u0d9a\u0dca\u0daf\u0dab\u0dca\u0da9\u0dcf\u0dc0",
    ta: "\u0bb9\u0b95\u0bcd\u0bae\u0bbe\u0ba9 - \u0baa\u0bc6\u0bb2\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0bc7 - \u0ba4\u0b99\u0bcd\u0b95\u0bbe\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc1\u0bb5\u0b95\u0bcd\u0ba4\u0ba3\u0bcd\u0b9f\u0bbe\u0bb5",
  },
  "Hakmana - Beliatte - Tangalle Rd, Tangalle": {
    si: "\u0dc4\u0d9a\u0dca\u0db8\u0db1 - \u0db6\u0dd9\u0dbd\u0dd2\u0d85\u0dad\u0dca\u0dad\u0dda - \u0dad\u0d82\u0d9c\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0dad\u0d82\u0d9c\u0dbd\u0dca\u0dbd",
    ta: "\u0bb9\u0b95\u0bcd\u0bae\u0ba9 - \u0baa\u0bc6\u0bb2\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0bc7 - \u0ba4\u0b99\u0bcd\u0b95\u0bbe\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0b99\u0bcd\u0b95\u0bbe\u0bb2\u0bc8",
  },
  "Hakmana Mulatiyana Rd": {
    si: "\u0dc4\u0d9a\u0dca\u0db8\u0db1 \u0db8\u0dd4\u0dbd\u0da7\u0dd2\u0dba\u0db1 \u0db4\u0dcf\u0dbb",
    ta: "\u0bb9\u0b95\u0bcd\u0bae\u0bbe\u0ba9 \u0bae\u0bc1\u0bb2\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0ba9\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8",
  },
  "Hali-Ela": {
    si: "\u0dc4\u0dcf\u0dbd\u0dd2-\u0d87\u0dbd",
    ta: "\u0bb9\u0bbe\u0bb2\u0bbf-\u0b8e\u0bb2\u0bbe",
  },
  Hambantota: {
    si: "\u0dc4\u0db8\u0dca\u0db6\u0db1\u0dca\u0dad\u0ddc\u0da7",
    ta: "\u0bb9\u0bae\u0bcd\u0baa\u0bbe\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8",
  },
  "Hanwella Road, Attanagalla": {
    si: "\u0dc4\u0d82\u0dc0\u0dd0\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d85\u0dad\u0dca\u0dad\u0db1\u0d9c\u0dbd\u0dca\u0dbd",
    ta: "\u0bb9\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0ba4\u0bcd\u0ba4\u0ba9\u0b95\u0bb2\u0bcd\u0bb2",
  },
  Haputale: {
    si: "\u0dc4\u0db4\u0dd4\u0dad\u0dbd\u0dda",
    ta: "\u0bb9\u0baa\u0bcd\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8",
  },
  Haputhale: {
    si: "\u0dc4\u0db4\u0dd4\u0dad\u0dbd\u0dda",
    ta: "\u0bb9\u0baa\u0bcd\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8",
  },
  "Harbour Rd, Tangalle": {
    si: "\u0dc0\u0dbb\u0dcf\u0dba \u0db4\u0dcf\u0dbb, \u0dad\u0d82\u0d9c\u0dbd\u0dca\u0dbd",
    ta: "\u0ba4\u0bc1\u0bb1\u0bc8\u0bae\u0bc1\u0b95 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0b99\u0bcd\u0b95\u0bbe\u0bb2\u0bc8",
  },
  "Hasalaka New Town": {
    si: "\u0dc4\u0dc3\u0dbd\u0d9a \u0db1\u0dc0 \u0db1\u0d9c\u0dbb\u0dba",
    ta: "\u0bb9\u0b9a\u0bb2\u0b95 \u0baa\u0bc1\u0ba4\u0bbf\u0baf \u0ba8\u0b95\u0bb0\u0bae\u0bcd",
  },
  Hatton: {
    si: "\u0dc4\u0dd0\u0da7\u0db1\u0dca",
    ta: "\u0bb9\u0b9f\u0bcd\u0b9f\u0ba9\u0bcd",
  },
  "Hatton - Maskeliya - Dalhousie Rd, Hatton": {
    si: "\u0dc4\u0dd0\u0da7\u0db1\u0dca - \u0db8\u0dc3\u0dca\u0d9a\u0dd9\u0dc5\u0dd2\u0dba - \u0da9\u0dbd\u0dca\u0dc4\u0dc0\u0dd4\u0dc3\u0dd2 \u0db4\u0dcf\u0dbb, \u0dc4\u0dd0\u0da7\u0db1\u0dca",
    ta: "\u0bb9\u0b9f\u0bcd\u0b9f\u0ba9\u0bcd - \u0bae\u0bb8\u0bcd\u0b95\u0bc6\u0bb2\u0bbf\u0baf\u0bbe - \u0b9f\u0bb2\u0bcd\u0bb9\u0bcc\u0b9a\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0b9f\u0bcd\u0b9f\u0ba9\u0bcd",
  },
  "Help (Twitter Thread)": {
    si: "\u0d8b\u0daf\u0dc0\u0dca (\u0da7\u0dca\u0dc0\u0dd2\u0da7\u0dbb\u0dca \u0db1\u0dd6\u0dbd\u0dca)",
    ta: "\u0b89\u0ba4\u0bb5\u0bbf (\u0b9f\u0bcd\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f\u0bb0\u0bcd \u0ba8\u0bc2\u0bb2\u0bcd)",
  },
  Hemmathagama: {
    si: "\u0dc4\u0dd9\u0db8\u0dca\u0db8\u0dcf\u0dad\u0d9c\u0db8",
    ta: "\u0bb9\u0bc6\u0bae\u0bcd\u0bae\u0bbe\u0ba4\u0b95\u0bae",
  },
  Hettipola: {
    si: "\u0dc4\u0dd9\u0da7\u0dca\u0da7\u0dd2\u0db4\u0ddc\u0dbd",
    ta: "\u0bb9\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baa\u0bca\u0bb2",
  },
  "Hettipola Rd, Kuliyapitiya": {
    si: "\u0dc4\u0dd9\u0da7\u0dca\u0da7\u0dd2\u0db4\u0ddc\u0dbd \u0db4\u0dcf\u0dbb, \u0d9a\u0dd4\u0dbd\u0dd2\u0dba\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0bb9\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baa\u0bca\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bc1\u0bb3\u0bbf\u0baf\u0bbe\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Hidellana - Rathnapura": {
    si: "\u0dc4\u0dd2\u0daf\u0dd0\u0dbd\u0dca\u0dbd\u0db1 - \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb",
    ta: "\u0bb9\u0bbf\u0b9f\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe\u0ba9\u0bbe - \u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf",
  },
  "Hidellana, Ratnapura, Sri Lanka": {
    si: "\u0dc4\u0dd2\u0daf\u0dd0\u0dbd\u0dca\u0dbd\u0db1, \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb9\u0bbf\u0b9f\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe\u0ba9\u0bbe, \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "High Level Rd, Hanwella": {
    si: "\u0dc4\u0dba\u0dd2\u0dbd\u0dd9\u0dc0\u0dbd\u0dca \u0db4\u0dcf\u0dbb, \u0dc4\u0d82\u0dc0\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0b89\u0baf\u0bb0\u0bcd \u0bae\u0b9f\u0bcd\u0b9f \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2",
  },
  "Highway, Siyambalanduwa": {
    si: "\u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0dc3\u0dd2\u0dba\u0db9\u0dbd\u0dcf\u0dab\u0dca\u0da9\u0dd4\u0dc0",
    ta: "\u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0b9a\u0bbf\u0baf\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0ba3\u0bcd\u0b9f\u0bc1\u0bb5",
  },
  "Higurana Fuel Station, Siyambalanduwa - Damana - Ampara Hwy, Hingurana": {
    si: "\u0dc4\u0dd2\u0d9c\u0dd4\u0dbb\u0dab \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0dc3\u0dd2\u0dba\u0db9\u0dbd\u0dcf\u0dab\u0dca\u0da9\u0dd4\u0dc0 - \u0daf\u0db8\u0db1 - \u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb Hwy, \u0dc4\u0dd2\u0d9f\u0dd4\u0dbb\u0dcf\u0db1",
    ta: "\u0bb9\u0bbf\u0b95\u0bc1\u0bb0\u0bbe\u0ba9 \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b9a\u0bbf\u0baf\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0ba3\u0bcd\u0b9f\u0bc1\u0bb5 - \u0ba4\u0bae\u0ba9 - \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8 \u0bb9\u0bc6\u0bb5\u0bbf, \u0bb9\u0bbf\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0bbe\u0ba9",
  },
  "Hikkaduwa Bus Station, Hikkaduwa, Sri Lanka": {
    si: "\u0dc4\u0dd2\u0d9a\u0dca\u0d9a\u0da9\u0dd4\u0dc0 \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8\u0dca\u0db4\u0ddc\u0dc5, \u0dc4\u0dd2\u0d9a\u0dca\u0d9a\u0da9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb9\u0bbf\u0b95\u0bcd\u0b95\u0b9f\u0bc1\u0bb5 \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0bb9\u0bbf\u0b95\u0bcd\u0b95\u0b9f\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Hikkaduwa Harbor, Hikkaduwa": {
    si: "\u0dc4\u0dd2\u0d9a\u0dca\u0d9a\u0da9\u0dd4\u0dc0 \u0dc0\u0dbb\u0dcf\u0dba, \u0dc4\u0dd2\u0d9a\u0dca\u0d9a\u0da9\u0dd4\u0dc0",
    ta: "\u0bb9\u0bbf\u0b95\u0bcd\u0b95\u0b9f\u0bc1\u0bb5\u0bbe \u0ba4\u0bc1\u0bb1\u0bc8\u0bae\u0bc1\u0b95\u0bae\u0bcd, \u0bb9\u0bbf\u0b95\u0bcd\u0b95\u0b9f\u0bc1\u0bb5\u0bbe",
  },
  "Hikkaduwa-baddegama Rd, Gonapinuwala": {
    si: "\u0dc4\u0dd2\u0d9a\u0dca\u0d9a\u0da9\u0dd4\u0dc0-\u0db6\u0daf\u0dca\u0daf\u0dda\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0d9c\u0ddd\u0db1\u0dcf\u0db4\u0dd3\u0db1\u0dd4\u0dc0\u0dbd",
    ta: "\u0bb9\u0bbf\u0b95\u0bcd\u0b95\u0b9f\u0bc1\u0bb5-\u0baa\u0ba4\u0bcd\u0ba4\u0bc7\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bcb\u0ba9\u0bbe\u0baa\u0bbf\u0ba9\u0bc1\u0bb5\u0bb2",
  },
  "Hilevel Rd, Wattaraka,meegoda": {
    si: "\u0dc4\u0dd2\u0dbd\u0dd9\u0dc0\u0dbd\u0dca \u0db4\u0dcf\u0dbb, \u0dc0\u0dad\u0dca\u0dad\u0dbb\u0d9a, \u0db8\u0dd3\u0d9c\u0ddc\u0da9",
    ta: "Hilevel Rd, \u0bb5\u0b9f\u0bcd\u0b9f\u0bb0\u0b95, \u0bae\u0bc0\u0b95\u0bca\u0b9f",
  },
  "Hiripitiya South, Veyangoda": {
    si: "\u0dc4\u0dd2\u0dbb\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0daf\u0d9a\u0dd4\u0dab, \u0dc0\u0dda\u0dba\u0db1\u0dca\u0d9c\u0ddc\u0da9",
    ta: "\u0bb9\u0bbf\u0bb0\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1, \u0bb5\u0bc6\u0baf\u0b99\u0bcd\u0b95\u0bca\u0b9f",
  },
  "Hokandara South": {
    si: "\u0dc4\u0ddd\u0d9a\u0db1\u0dca\u0daf\u0dbb \u0daf\u0d9a\u0dd4\u0dab",
    ta: "\u0bb9\u0bcb\u0b95\u0ba8\u0bcd\u0ba4\u0bb0 \u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1",
  },
  Homagama: {
    si: "Homagama",
    ta: "Homagama",
  },
  "Horagasdeka Junction, Weliweriya - Kirindiwela Rd, Sri Lanka": {
    si: "\u0dc4\u0ddc\u0dbb\u0d9c\u0dc3\u0dca\u0daf\u0dd9\u0d9a \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0dc0\u0dd0\u0dbd\u0dd2\u0dc0\u0dda\u0dbb\u0dd2\u0dba - \u0d9a\u0dd2\u0dbb\u0dd2\u0db3\u0dd2\u0dc0\u0dd0\u0dbd \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb9\u0bca\u0bb0\u0b95\u0bb8\u0bcd\u0ba4\u0bc7\u0b95\u0bbe \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0bb5\u0bc6\u0bb2\u0bbf\u0bb5\u0bc7\u0bb0\u0bbf\u0baf - \u0b95\u0bbf\u0bb0\u0bbf\u0ba8\u0bcd\u0ba4\u0bbf\u0bb5\u0bc6\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Horana: {
    si: "\u0dc4\u0ddc\u0dbb\u0dab",
    ta: "\u0bb9\u0bca\u0bb0\u0ba3\u0bc8",
  },
  "Horewala - Hemmathagama Rd, Hemmathagama": {
    si: "\u0dc4\u0ddc\u0dbb\u0dda\u0dc0\u0dbd - \u0dc4\u0dd9\u0db8\u0dca\u0db8\u0dcf\u0dad\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0dc4\u0dd9\u0db8\u0dca\u0db8\u0dcf\u0dad\u0d9c\u0db8",
    ta: "\u0bb9\u0bca\u0bb0\u0bc7\u0bb5\u0bb2 - \u0bb9\u0bc6\u0bae\u0bcd\u0bae\u0bbe\u0ba4\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0bc6\u0bae\u0bcd\u0bae\u0bbe\u0ba4\u0b95\u0bae",
  },
  Horowpathana: {
    si: "\u0dc4\u0ddc\u0dbb\u0ddc\u0dc0\u0dca\u0db4\u0dad\u0dcf\u0db1",
    ta: "\u0bb9\u0bca\u0bb0\u0bcb\u0bb5\u0bcd\u0baa\u0ba4\u0bcd\u0ba4\u0bbe\u0ba9\u0bbe",
  },
  Horowupotana: {
    si: "\u0dc4\u0ddc\u0dbb\u0ddc\u0dc0\u0dca\u0db4\u0ddc\u0dad\u0dcf\u0db1",
    ta: "\u0bb9\u0bcb\u0bb0\u0bcb\u0bb5\u0bc1\u0baa\u0bca\u0b9f\u0bbe\u0ba9\u0bbe",
  },
  "Horton Pl, Colombo - 07": {
    si: "\u0dc4\u0ddd\u0da7\u0db1\u0dca \u0db4\u0dd3\u0d91\u0dbd\u0dca, \u200b\u200b\u0d9a\u0ddc\u0dc5\u0db9 - 07",
    ta: "Horton Pl, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - 07",
  },
  "Hospital Junction, Kolonna": {
    si: "\u0d89\u0dc3\u0dca\u0db4\u0dd2\u0dbb\u0dd2\u0dad\u0dcf\u0dbd \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0d9a\u0ddc\u0dc5\u0ddc\u0db1\u0dca\u0db1",
    ta: "\u0bae\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb5\u0bae\u0ba9\u0bc8 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0b95\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bbe",
  },
  "How long is the wait now?": {
    si: "\u0daf\u0dd0\u0db1\u0dca \u0d9a\u0ddc\u0db4\u0db8\u0dab \u0d9a\u0dcf\u0dbd\u0dba\u0d9a\u0dca \u0db6\u0dbd\u0dcf \u0dc3\u0dd2\u0da7\u0dd3\u0db8\u0daf?",
    ta: "\u0b87\u0baa\u0bcd\u0baa\u0bcb\u0ba4\u0bc1 \u0b8e\u0bb5\u0bcd\u0bb5\u0bb3\u0bb5\u0bc1 \u0ba8\u0bc7\u0bb0\u0bae\u0bcd \u0b95\u0bbe\u0ba4\u0bcd\u0ba4\u0bbf\u0bb0\u0bc1\u0baa\u0bcd\u0baa\u0bc1?",
  },
  Hunnasgiriya: {
    si: "\u0dc4\u0dd4\u0db1\u0dca\u0db1\u0dc3\u0dca\u0d9c\u0dd2\u0dbb\u0dd2\u0dba",
    ta: "\u0bb9\u0bc1\u0ba9\u0bcd\u0ba9\u0bb8\u0bcd\u0b95\u0bbf\u0bb0\u0bbf\u0baf",
  },
  "Hunnasgiriya Town, Hunnasgiriya, Sri Lanka": {
    si: "\u0dc4\u0dd4\u0db1\u0dca\u0db1\u0dc3\u0dca\u0d9c\u0dd2\u0dbb\u0dd2\u0dba \u0db1\u0d9c\u0dbb\u0dba, \u0dc4\u0dd4\u0db1\u0dca\u0db1\u0dc3\u0dca\u0d9c\u0dd2\u0dbb\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Hunnasgiriya \u0ba8\u0b95\u0bb0\u0bae\u0bcd, Hunnasgiriya, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "I CHARLES  NIRMALANATHAN": {
    si: "\u0db8\u0db8 \u0da0\u0dcf\u0dbd\u0dca\u0dc3\u0dca \u0db1\u0dd2\u0dbb\u0dca\u0db8\u0dbd\u0db1\u0dcf\u0daf\u0db1\u0dca",
    ta: "\u0ba8\u0bbe\u0ba9\u0bcd \u0b9a\u0bbe\u0bb0\u0bcd\u0bb2\u0bb8\u0bcd \u0ba8\u0bbf\u0bb0\u0bcd\u0bae\u0bb2\u0bbe\u0ba8\u0bbe\u0ba4\u0ba9\u0bcd",
  },
  "I HENDAWITHARANA": {
    si: "\u0db8\u0db8 \u0dc4\u0dd9\u0db1\u0dca\u0daf\u0dcf\u0dc0\u0dd2\u0dad\u0dcf\u0dbb\u0dab",
    ta: "\u0ba8\u0bbe\u0ba9\u0bcd \u0bb9\u0bc6\u0ba8\u0bcd\u0ba4\u0bb5\u0bbf\u0ba4\u0bbe\u0bb0\u0ba3",
  },
  "I M.JAYATILLEKE": {
    si: "\u0db8\u0db8 \u0d91\u0db8\u0dca.\u0da2\u0dba\u0dad\u0dd2\u0dbd\u0d9a",
    ta: "\u0ba8\u0bbe\u0ba9\u0bcd \u0b8e\u0bae\u0bcd.\u0b9c\u0bc6\u0baf\u0ba4\u0bbf\u0bb2\u0b95\u0bc7",
  },
  "I RIFAYA": {
    si: "I RIFAYA",
    ta: "I RIFAYA",
  },
  "I U SOMARATNE": {
    si: "\u0d85\u0dba\u0dd2 \u0dba\u0dd6 \u0dc3\u0ddd\u0db8\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b90 \u0baf\u0bc2 \u0b9a\u0bcb\u0bae\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "I.L.M.FAZEEL": {
    si: "I.L.M.FAZEEL",
    ta: "I.L.M.FAZEEL",
  },
  "I.M.M.B.EDIRISINGHE": {
    si: "\u0d85\u0dba\u0dd2.\u0d91\u0db8\u0dca.\u0d91\u0db8\u0dca.\u0db6\u0dd3.\u0d91\u0daf\u0dd2\u0dbb\u0dd2\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b90.\u0b8e\u0bae\u0bcd.\u0b8e\u0bae\u0bcd.\u0baa\u0bbf.\u0b8e\u0ba4\u0bbf\u0bb0\u0bbf\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  IDIGOLLA: {
    si: "\u0d89\u0daf\u0dd2\u0d9c\u0ddc\u0dbd\u0dca\u0dbd",
    ta: "\u0b87\u0b9f\u0bbf\u0b95\u0bca\u0bb2\u0bcd\u0bb2\u0bbe",
  },
  "IMBULPE MPCS LTD": {
    si: "IMBULPE MPCS LTD",
    ta: "IMBULPE MPCS LTD",
  },
  "IMPERIAL AUTO CARE": {
    si: "\u0d89\u0db8\u0dca\u0db4\u0dd3\u0dbb\u0dd2\u0dba\u0dbd\u0dca \u0d94\u0da7\u0ddd \u0d9a\u0dd9\u0dba\u0dcf\u0dbb\u0dca",
    ta: "\u0b87\u0bae\u0bcd\u0baa\u0bc0\u0bb0\u0bbf\u0baf\u0bb2\u0bcd \u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0b95\u0bc7\u0bb0\u0bcd",
  },
  "INDIKA FILLING STATION": {
    si: "\u0d89\u0db1\u0dca\u0daf\u0dd2\u0d9a \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b87\u0ba8\u0bcd\u0ba4\u0bbf\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "INDIKA N SOVIS": {
    si: "\u0d89\u0db1\u0dca\u0daf\u0dd2\u0d9a \u0d91\u0db1\u0dca \u0dc3\u0ddd\u0dc0\u0dd2\u0dc3\u0dca",
    ta: "\u0b87\u0ba8\u0bcd\u0ba4\u0bbf\u0b95\u0bbe \u0b8e\u0ba9\u0bcd \u0b9a\u0bcb\u0bb5\u0bbf\u0bb8\u0bcd",
  },
  "IRESHA FILLING STATION (PVT) LTD": {
    si: "\u0d89\u0dbb\u0dda\u0dc2\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b87\u0bb0\u0bc7\u0bb7\u0bbe \u0baa\u0bbf\u0bb2\u0bcd\u0bb2\u0bbf\u0b99\u0bcd \u0bb8\u0bcd\u0b9f\u0bc7\u0bb7\u0ba9\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "ISHAGI ENTERPRISES ( PRIVATE ) LTD": {
    si: "\u0d89\u0dc2\u0dcf\u0d9c\u0dd2 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca (\u0db4\u0dde\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b87\u0bb7\u0bbe\u0b95\u0bbf \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd (\u0baa\u0bbf\u0bb0\u0bc8\u0bb5\u0bc7\u0b9f\u0bcd) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "ISLAMIC SERVICE SOCIETY": {
    si: "\u0d89\u0dc3\u0dca\u0dbd\u0dcf\u0db8\u0dd3\u0dba \u0dc3\u0dda\u0dc0\u0dcf \u0dc3\u0d82\u0d9c\u0db8\u0dba",
    ta: "\u0b87\u0bb8\u0bcd\u0bb2\u0bbe\u0bae\u0bbf\u0baf \u0b9a\u0bc7\u0bb5\u0bc8 \u0b9a\u0b99\u0bcd\u0b95\u0bae\u0bcd",
  },
  "ISLAMIC SOCIETY": {
    si: "\u0d89\u0dc3\u0dca\u0dbd\u0dcf\u0db8\u0dd3\u0dba \u0dc3\u0db8\u0dcf\u0da2\u0dba",
    ta: "\u0b87\u0bb8\u0bcd\u0bb2\u0bbe\u0bae\u0bbf\u0baf \u0b9a\u0bae\u0bc2\u0b95\u0bae\u0bcd",
  },
  "ISURI MOTORS (PVT) LTD": {
    si: "\u0d89\u0dc3\u0dd4\u0dbb\u0dd2 \u0db8\u0ddd\u0da7\u0dbb\u0dca\u0dc3\u0dca (PVT) LTD",
    ta: "\u0b87\u0b9a\u0bc1\u0bb0\u0bbf \u0bae\u0bcb\u0b9f\u0bcd\u0b9f\u0bbe\u0bb0\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "ITTAPANA-CANCEL": {
    si: "\u0d89\u0dad\u0dca\u0dad\u0db4\u0dcf\u0db1-\u0d85\u0dc0\u0dbd\u0d82\u0d9c\u0dd4 \u0d9a\u0dbb\u0db1\u0dca\u0db1",
    ta: "\u0b87\u0b9f\u0bcd\u0b9f\u0baa\u0ba9\u0bbe-\u0bb0\u0ba4\u0bcd\u0ba4\u0bc1\u0b9a\u0bc6\u0baf\u0bcd",
  },
  "Ibbagamuwa - Kumbukgete - Madagalla Rd, Kumbukgete": {
    si: "\u0d89\u0db6\u0dca\u0db6\u0dcf\u0d9c\u0db8\u0dd4\u0dc0 - \u0d9a\u0dd4\u0db9\u0dd4\u0d9a\u0dca\u0d9c\u0dd0\u0da7\u0dda - \u0db8\u0da9\u0d9c\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d9a\u0dd4\u0db9\u0dd4\u0d9a\u0dca\u0d9c\u0dd0\u0da7\u0dda",
    ta: "\u0b87\u0baa\u0bcd\u0baa\u0b95\u0bae\u0bc1\u0bb5 - \u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0b95\u0bcd\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bc7 - \u0bae\u0b9f\u0b95\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0b95\u0bcd\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bc7",
  },
  "Idangoda, Kiriella": {
    si: "\u0d89\u0daf\u0d82\u0d9c\u0ddc\u0da9, \u0d9a\u0dd2\u0dbb\u0dd2\u0d87\u0dbd\u0dca\u0dbd",
    ta: "\u0b87\u0b9f\u0b99\u0bcd\u0b95\u0bca\u0b9f, \u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bc6\u0bb2\u0bcd\u0bb2",
  },
  "If you have voted multiple times, your latest vote will be selected.": {
    si: "\u0d94\u0db6 \u0d9a\u0dd2\u0dc4\u0dd2\u0db4 \u0dc0\u0dad\u0dcf\u0dc0\u0d9a\u0dca \u0da1\u0db1\u0dca\u0daf\u0dba \u0db4\u0dca\u200d\u0dbb\u0d9a\u0dcf\u0dc1 \u0d9a\u0dbb \u0d87\u0dad\u0dca\u0db1\u0db8\u0dca, \u0d94\u0db6\u0d9c\u0dda \u0db1\u0dc0\u0dad\u0db8 \u0da1\u0db1\u0dca\u0daf\u0dba \u0dad\u0ddd\u0dbb\u0dcf\u0d9c\u0db1\u0dd4 \u0dbd\u0dd0\u0db6\u0dda.",
    ta: "\u0ba8\u0bc0\u0b99\u0bcd\u0b95\u0bb3\u0bcd \u0baa\u0bb2\u0bae\u0bc1\u0bb1\u0bc8 \u0bb5\u0bbe\u0b95\u0bcd\u0b95\u0bb3\u0bbf\u0ba4\u0bcd\u0ba4\u0bbf\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bbe\u0bb2\u0bcd, \u0b89\u0b99\u0bcd\u0b95\u0bb3\u0bbf\u0ba9\u0bcd \u0b9a\u0bae\u0bc0\u0baa\u0ba4\u0bcd\u0ba4\u0bbf\u0baf \u0bb5\u0bbe\u0b95\u0bcd\u0b95\u0bc1 \u0ba4\u0bc7\u0bb0\u0bcd\u0ba8\u0bcd\u0ba4\u0bc6\u0b9f\u0bc1\u0b95\u0bcd\u0b95\u0baa\u0bcd\u0baa\u0b9f\u0bc1\u0bae\u0bcd.",
  },
  "Ihalawewa, Kiralogama": {
    si: "\u0d89\u0dc4\u0dc5\u0dc0\u0dd0\u0dc0, \u0d9a\u0dd2\u0dbb\u0dbd\u0ddd\u0d9c\u0db8",
    ta: "\u0b87\u0bb9\u0bb2\u0bb5\u0bc6\u0bb5, \u0b95\u0bbf\u0bb0\u0bb2\u0bcb\u0b95\u0bae",
  },
  "Ikiriwewa-Nochchiyagama": {
    si: "Ikiriwewa-Nochchiyagama",
    ta: "\u0b87\u0b95\u0bbf\u0bb0\u0bbf\u0bb5\u0bc6\u0bb5-\u0ba8\u0bca\u0b9a\u0bcd\u0b9a\u0bbf\u0baf\u0bbe\u0b95\u0bae",
  },
  "Imam Ghassaly Rd, Maruthamunai": {
    si: "\u0d89\u0db8\u0dcf\u0db8\u0dca \u0d9c\u0dc3\u0dcf\u0dbd\u0dd2 \u0db4\u0dcf\u0dbb, \u0db8\u0dbb\u0dd4\u0dad\u0db8\u0dd4\u0db1\u0dba\u0dd2",
    ta: "\u0b87\u0bae\u0bbe\u0bae\u0bcd \u0b95\u0bb8\u0bcd\u0bb8\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bb0\u0bc1\u0ba4\u0bae\u0bc1\u0ba9\u0bc8",
  },
  "Inginiyagala Road Wavinna,Ampara": {
    si: "\u0d89\u0d9f\u0dd2\u0db1\u0dd2\u0dba\u0dcf\u0d9c\u0dbd \u0db4\u0dcf\u0dbb \u0dc0\u0dcf\u0dc0\u0dd2\u0db1\u0dca\u0db1, \u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb",
    ta: "\u0b87\u0b99\u0bcd\u0b95\u0bbf\u0ba9\u0bbf\u0baf\u0bbe\u0b95\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf \u0bb5\u0bbe\u0bb5\u0bbf\u0ba9\u0bcd\u0ba9, \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8",
  },
  Ingiriya: {
    si: "\u0d89\u0d82\u0d9c\u0dd2\u0dbb\u0dd2\u0dba",
    ta: "\u0b87\u0b99\u0bcd\u0b95\u0bbf\u0bb0\u0bbf\u0baf",
  },
  Inigodawela: {
    si: "\u0d89\u0db1\u0dd2\u0d9c\u0ddc\u0da9\u0dc0\u0dd9\u0dbd",
    ta: "\u0b87\u0ba9\u0bbf\u0b95\u0bca\u0b9f\u0bb5\u0bc6\u0bb2",
  },
  "Inner Circular Rd, Ratnapura": {
    si: "\u0d85\u0db7\u0dca\u200d\u0dba\u0db1\u0dca\u0dad\u0dbb \u0da0\u0d9a\u0dca\u200d\u0dbb\u0dbd\u0dda\u0d9b \u0db4\u0dcf\u0dbb, \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb",
    ta: "\u0b89\u0bb3\u0bcd \u0b9a\u0bc1\u0bb1\u0bcd\u0bb1\u0bb1\u0bbf\u0b95\u0bcd\u0b95\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf",
  },
  "Ioc Filling Station, Warana Rd Nelligahamulla- Atthanagalla": {
    si: "IOC \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0dc0\u0dcf\u0dbb\u0dab \u0db4\u0dcf\u0dbb \u0db1\u0dd9\u0dbd\u0dca\u0dbd\u0dd2\u0d9c\u0dc4\u0db8\u0dd4\u0dbd\u0dca\u0dbd - \u0d85\u0dad\u0dca\u0dad\u0db1\u0d9c\u0dbd\u0dca\u0dbd",
    ta: "IOC \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0bb5\u0bbe\u0bb0\u0ba3\u0bbe \u0bb5\u0bc0\u0ba4\u0bbf \u0ba8\u0bc6\u0bb2\u0bcd\u0bb2\u0bbf\u0b95\u0bb9\u0bae\u0bc1\u0bb2\u0bcd\u0bb2- \u0b85\u0ba4\u0bcd\u0ba4\u0ba9\u0b95\u0bb2\u0bcd\u0bb2",
  },
  "Ioc-payagala, Kuda Payagala South, Payagala": {
    si: "Ioc-payagala, \u0d9a\u0dd4\u0da9\u0dcf \u0db4\u0dba\u0dcf\u0d9c\u0dbd \u0daf\u0d9a\u0dd4\u0dab, \u0db4\u0dba\u0dcf\u0d9c\u0dbd",
    ta: "Ioc-payagala, Kuda Payagala South, Payagala",
  },
  "Ipalawa, Ipalawa, Sri Lanka": {
    si: "\u0d89\u0db4\u0dbd\u0dcf\u0dc0, \u0d89\u0db4\u0dbd\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b87\u0baa\u0bb2\u0bb5\u0bbe, \u0b87\u0baa\u0bb2\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Irakkamam: {
    si: "\u0d89\u0dbb\u0d9a\u0dca\u0d9a\u0dcf\u0db8\u0db8\u0dca",
    ta: "\u0b87\u0bb1\u0b95\u0bcd\u0b95\u0bbe\u0bae\u0bae\u0bcd",
  },
  Irupalai: {
    si: "\u0d89\u0dbb\u0dd4\u0db4\u0dcf\u0dbd\u0dba\u0dd2",
    ta: "\u0b87\u0bb0\u0bc1\u0baa\u0bbe\u0bb2\u0bc8",
  },
  "J A C D JAYAKODY": {
    si: "\u0da2\u0dda \u0d92 \u0dc3\u0dd3 \u0da9\u0dd3 \u0da2\u0dba\u0d9a\u0ddc\u0da9\u0dd2",
    ta: "\u0b9c\u0bc7 \u0b8f \u0b9a\u0bbf \u0b9f\u0bbf \u0b9c\u0bc6\u0baf\u0b95\u0bcd\u0b95\u0bca\u0b9f\u0bbf",
  },
  "J A D D ANTHONY ENTERPRISE": {
    si: "\u0da2\u0dda \u0d92\u0da9\u0dd3 \u0da9\u0dd3 \u0d87\u0db1\u0dca\u0dad\u0db1\u0dd2 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dca",
    ta: "\u0b9c\u0bc7 \u0b8f \u0b9f\u0bbf \u0b9f\u0bbf \u0b85\u0ba8\u0bcd\u0ba4\u0bcb\u0ba9\u0bbf \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0bb8\u0bcd",
  },
  "J A D R JAYALATH": {
    si: "\u0da2\u0dda \u0d92 \u0da9\u0dd3 \u0d86\u0dbb\u0dca \u0da2\u0dba\u0dbd\u0dad\u0dca",
    ta: "\u0b9c\u0bc7 \u0b8f \u0b9f\u0bbf \u0b86\u0bb0\u0bcd \u0b9c\u0bc6\u0baf\u0bb2\u0ba4\u0bcd",
  },
  "J A HEMANTHA": {
    si: "\u0da2\u0dda \u0d92 \u0dc4\u0dda\u0db8\u0db1\u0dca\u0dad",
    ta: "\u0b9c\u0bc7 \u0b8f \u0bb9\u0bc7\u0bae\u0ba8\u0bcd\u0ba4\u0bbe",
  },
  "J A I FILLING STATION": {
    si: "J A I \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "J A I \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "J A YOGANATHAN": {
    si: "\u0da2\u0dda \u0d92 \u0dba\u0ddd\u0d9c\u0db1\u0dcf\u0daf\u0db1\u0dca",
    ta: "\u0b9c\u0bc7 \u0b8f \u0baf\u0bcb\u0b95\u0ba8\u0bbe\u0ba4\u0ba9\u0bcd",
  },
  "J G R P DE SILVA": {
    si: "\u0da2\u0dda \u0da2\u0dd3 \u0d86\u0dbb\u0dca \u0db4\u0dd3 \u0daf \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf",
    ta: "\u0b9c\u0bc7 \u0b9c\u0bbf \u0b86\u0bb0\u0bcd \u0baa\u0bbf \u0b9f\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe",
  },
  "J H S ENTERPRISES PVT LTD": {
    si: "J H S ENTERPRISES PVT LTD",
    ta: "\u0b9c\u0bc7 \u0b8e\u0b9a\u0bcd \u0b8e\u0bb8\u0bcd \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd \u0baa\u0bbf\u0bb0\u0bc8\u0bb5\u0bc7\u0b9f\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "J J D DISSANAYAKE": {
    si: "\u0da2\u0dda \u0da2\u0dda \u0da9\u0dd3 \u0daf\u0dd2\u0dc3\u0dcf\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b9c\u0bc7 \u0b9c\u0bc7 \u0b9f\u0bbf \u0ba4\u0bbf\u0b9a\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "J J S PINIDIYA": {
    si: "\u0da2\u0dda \u0da2\u0dda \u0d91\u0dc3\u0dca \u0db4\u0dd2\u0db1\u0dd2\u0daf\u0dd2\u0dba",
    ta: "\u0b9c\u0bc7 \u0b9c\u0bc7 \u0b8e\u0bb8\u0bcd \u0baa\u0bbf\u0ba3\u0bbf\u0b9f\u0bbf\u0baf\u0bbe",
  },
  "J K A R.PERERA": {
    si: "\u0da2\u0dda \u0d9a\u0dda \u0d92 \u0d86\u0dbb\u0dca \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b9c\u0bc7 \u0b95\u0bc7 \u0b8f \u0b86\u0bb0\u0bcd.\u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "J L S LANKA TRADING COMPANY (PVT) L": {
    si: "J L S \u0dbd\u0d82\u0d9a\u0dcf \u0dc0\u0dd9\u0dc5\u0db3 \u0dc3\u0db8\u0dcf\u0d9c\u0db8 (PVT) L",
    ta: "\u0b9c\u0bc7 \u0b8e\u0bb2\u0bcd \u0b8e\u0bb8\u0bcd \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b9f\u0bbf\u0bb0\u0bc7\u0b9f\u0bbf\u0b99\u0bcd \u0b95\u0bae\u0bcd\u0baa\u0bc6\u0ba9\u0bbf (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0b8e\u0bb2\u0bcd",
  },
  "J M B J JAYASUNDARA": {
    si: "J M B J \u0da2\u0dba\u0dc3\u0dd4\u0db1\u0dca\u0daf\u0dbb",
    ta: "\u0b9c\u0bc7 \u0b8e\u0bae\u0bcd \u0baa\u0bbf \u0b9c\u0bc7 \u0b9c\u0baf\u0b9a\u0bc1\u0ba8\u0bcd\u0ba4\u0bb0",
  },
  "J M T B JAYASINGHA": {
    si: "\u0da2\u0dda \u0d91\u0db8\u0dca \u0da7\u0dd3 \u0db6\u0dd3 \u0da2\u0dba\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b9c\u0bc7 \u0b8e\u0bae\u0bcd \u0b9f\u0bbf \u0baa\u0bbf \u0b9c\u0baf\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "J S MIRANDO": {
    si: "\u0da2\u0dda \u0d91\u0dc3\u0dca \u0db8\u0dd2\u0dbb\u0dd0\u0db1\u0dca\u0da9\u0ddd",
    ta: "\u0b9c\u0bc7 \u0b8e\u0bb8\u0bcd \u0bae\u0bbf\u0bb0\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "J SIVALOGANATHAN": {
    si: "\u0da2\u0dda \u0dc3\u0dd2\u0dc0\u0dbd\u0ddd\u0d9c\u0db1\u0dcf\u0daf\u0db1\u0dca",
    ta: "\u0b9c\u0bc7 \u0b9a\u0bbf\u0bb5\u0bb2\u0bcb\u0b95\u0ba8\u0bbe\u0ba4\u0ba9\u0bcd",
  },
  "J SRISHANKAR": {
    si: "\u0da2\u0dda \u0dc1\u0dca\u200d\u0dbb\u0dd3\u0dc1\u0d82\u0d9a\u0dbb\u0dca",
    ta: "\u0b9c\u0bc7 \u0bb8\u0bcd\u0bb0\u0bc0\u0b9a\u0b99\u0bcd\u0b95\u0bb0\u0bcd",
  },
  "J WANIGASEKARA": {
    si: "J WANIGASEKARA",
    ta: "J WANIGASEKARA",
  },
  "J.A..A.RATHNASINGHE": {
    si: "\u0da2\u0dda.\u0d92.\u0d92.\u0dbb\u0dad\u0dca\u0db1\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b9c\u0bc7.\u0b8f.\u0bb0\u0ba4\u0bcd\u0ba9\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "J.A.ANSAR": {
    si: "\u0da2\u0dda.\u0d92.\u0d85\u0db1\u0dca\u0dc3\u0dcf\u0dbb\u0dca",
    ta: "\u0b9c\u0bc7.\u0b8f.\u0b85\u0ba9\u0bcd\u0b9a\u0bbe\u0bb0\u0bcd",
  },
  "J.A.D.JULIET PERERA": {
    si: "J.A.D.JULIET Perera",
    ta: "\u0b9c\u0bc7.\u0b8f.\u0b9f\u0bbf.\u0b9c\u0bc2\u0bb2\u0bbf\u0baf\u0b9f\u0bcd \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "J.A.WITHARANA": {
    si: "\u0da2\u0dda.\u0d92.\u0dc0\u0dd2\u0dad\u0dcf\u0dbb\u0dab",
    ta: "\u0b9c\u0bc7.\u0b8f.\u0bb5\u0bbf\u0ba4\u0bbe\u0bb0\u0ba3",
  },
  "J.F.A.PINTO": {
    si: "J.F.A.PINTO",
    ta: "J.F.A.PINTO",
  },
  "J.J.DIAS ENTERPRISES": {
    si: "J.J.DIAS \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b9c\u0bc7.\u0b9c\u0bc7.\u0b9f\u0bbf\u0baf\u0bbe\u0bb8\u0bcd \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "J.M.GUNATHILAKA": {
    si: "\u0da2\u0dda.\u0d91\u0db8\u0dca.\u0d9c\u0dd4\u0dab\u0dad\u0dd2\u0dbd\u0d9a",
    ta: "\u0b9c\u0bc7.\u0b8e\u0bae\u0bcd.\u0b95\u0bc1\u0ba3\u0ba4\u0bbf\u0bb2\u0b95",
  },
  "J.NADARAJAH": {
    si: "\u0da2\u0dda.\u0db1\u0da9\u0dbb\u0dcf\u0da2\u0dcf",
    ta: "\u0b9c\u0bc6.\u0ba8\u0b9f\u0bb0\u0bbe\u0b9c\u0bbe",
  },
  "J22H+R2 Divulgasanga, Sri Lanka": {
    si: "J22H+R2 \u0daf\u0dd2\u0dc0\u0dd4\u0dbd\u0dca\u0d9c\u0dc3\u0d82\u0d9c, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "J22H+R2 \u0ba4\u0bbf\u0bb5\u0bc1\u0bb2\u0bcd\u0b95\u0b9a\u0b99\u0bcd\u0b95\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "J2HW+GJX, Sandunpura, Sri Lanka": {
    si: "J2HW+GJX, \u0dc3\u0db3\u0dd4\u0db1\u0dca\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "J2HW+GJX, Sandunpura, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "J2RR+RVQ, B224, Keselhenawa, Sri Lanka": {
    si: "J2RR+RVQ, B224, \u0d9a\u0dd9\u0dc3\u0dd9\u0dbd\u0dca\u0dc4\u0dda\u0db1\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "J2RR+RVQ, B224, Keselhenawa, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "J34G+5QX, Sri Lanka": {
    si: "J34G+5QX, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "J34G+5QX, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "J34P+QQV, Sri Lanka": {
    si: "J34P+QQV, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "J34P+QQV, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "J44W+HC Madige Midiyala, Sri Lanka": {
    si: "J44W+HC \u0db8\u0da9\u0dd2\u0d9c\u0dda \u0db8\u0dd2\u0daf\u0dd2\u0dba\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "J44W+HC \u0bae\u0b9f\u0bbf\u0b95\u0bc7 \u0bae\u0bbf\u0b9f\u0bbf\u0baf\u0bbe\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "J57H+587, Bandara Koswatta, Sri Lanka": {
    si: "J57H+587, \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb \u0d9a\u0ddc\u0dc3\u0dca\u0dc0\u0dad\u0dca\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "J57H+587, \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0 \u0b95\u0bca\u0bb8\u0bcd\u0bb5\u0ba4\u0bcd\u0ba4, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "J697+V6W, Rambawewa, Sri Lanka": {
    si: "J697+V6W, \u0dbb\u0db9\u0dc0\u0dd0\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "J697+V6W, \u0bb0\u0bae\u0bcd\u0baa\u0bbe\u0bb5\u0bc7\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "J69X+45F, Wariyapola, Sri Lanka": {
    si: "J69X+45F, \u0dc0\u0dcf\u0dbb\u0dd2\u0dba\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "J69X+45F, \u0bb5\u0bbe\u0bb0\u0bbf\u0baf\u0baa\u0bca\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "J6GV+44C, Wariyapola, Sri Lanka": {
    si: "J6GV+44C, \u0dc0\u0dcf\u0dbb\u0dd2\u0dba\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "J6GV+44C, \u0bb5\u0bbe\u0bb0\u0bbf\u0baf\u0baa\u0bca\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "J6QJ+X9J, Katugastota-Kurunegala-Puttalam Hwy, Sri Lanka": {
    si: "J6QJ+X9J, \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7-\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd-\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 Hwy, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "J6QJ+X9J, \u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8-\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd-\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd Hwy, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "J84J+VXP, A9, Pachchilapalli, Sri Lanka": {
    si: "J84J+VXP, A9, \u0db4\u0da0\u0dca\u0da0\u0dd2\u0dbd\u0db4\u0dbd\u0dca\u0dbd\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "J84J+VXP, A9, \u0baa\u0b9a\u0bcd\u0b9a\u0bbf\u0bb2\u0baa\u0bcd\u0baa\u0bb3\u0bcd\u0bb3\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "JAELA MPCS LTD": {
    si: "JAELA MPCS LTD",
    ta: "JAELA MPCS LTD",
  },
  "JAFFNA - GURUNAGAR-CANCEL": {
    si: "\u0dba\u0dcf\u0db4\u0db1\u0dba - \u0d9c\u0dd4\u0dbb\u0dd4\u0db1\u0d9c\u0dbb\u0dca-\u0d85\u0dc0\u0dbd\u0d82\u0d9c\u0dd4 \u0d9a\u0dbb\u0db1\u0dca\u0db1",
    ta: "\u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0b95\u0bb0\u0bcd-\u0bb0\u0ba4\u0bcd\u0ba4\u0bc1",
  },
  "JAFFNA MUNICIPALITY MPCS LTD": {
    si: "\u0dba\u0dcf\u0db4\u0db1\u0dba \u0db8\u0dc4 \u0db1\u0d9c\u0dbb \u0dc3\u0db7\u0dcf\u0dc0 MPCS LTD",
    ta: "\u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3 \u0bae\u0bc1\u0ba9\u0bbf\u0b9a\u0bbf\u0baa\u0bbe\u0bb2\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf MPCS LTD",
  },
  "JAFFNA.": {
    si: "\u0dba\u0dcf\u0db4\u0db1\u0dba.",
    ta: "\u0baf\u0bbe\u0bb4\u0bcd.",
  },
  "JAGATHEES & SONS": {
    si: "\u0da2\u0d9c\u0dad\u0dd3\u0dc3\u0dca \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b9c\u0bc6\u0b95\u0ba4\u0bc0\u0bb8\u0bcd & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "JAYALATH ENTERPRISES": {
    si: "\u0da2\u0dba\u0dbd\u0dad\u0dca \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b9c\u0bc6\u0baf\u0bb2\u0ba4\u0bcd \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "JAYAMAL SERVICE AND FILLING STATION": {
    si: "\u0da2\u0dba\u0db8\u0dcf\u0dbd\u0dca \u0dc3\u0dda\u0dc0\u0dba \u0dc3\u0dc4 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b9c\u0bc6\u0baf\u0bae\u0bbe\u0bb2\u0bcd \u0b9a\u0bc7\u0bb5\u0bc8 \u0bae\u0bb1\u0bcd\u0bb1\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "JAYANI ENTERPRISES": {
    si: "\u0da2\u0dba\u0db1\u0dd2 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b9c\u0bc6\u0baf\u0ba9\u0bbf \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "JAYANTHI MARKETING ( PVT ) LTD": {
    si: "\u0da2\u0dba\u0db1\u0dca\u0dad\u0dd2 \u0db8\u0dcf\u0dbb\u0dca\u0d9a\u0da7\u0dd2\u0d82 (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b9c\u0bc6\u0baf\u0ba8\u0bcd\u0ba4\u0bbf \u0bae\u0bbe\u0bb0\u0bcd\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0b99\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "JAYANTHI TRADING & EXPORT (PVT) LTD": {
    si: "\u0da2\u0dba\u0db1\u0dca\u0dad\u0dd2 \u0da7\u0dca\u200d\u0dbb\u0dda\u0da9\u0dd2\u0db1\u0dca \u0dc3\u0dc4 \u0d91\u0d9a\u0dca\u0dc3\u0dca\u0db4\u0ddd\u0da7\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0b9c\u0bc6\u0baf\u0ba8\u0bcd\u0ba4\u0bbf \u0b9f\u0bbf\u0bb0\u0bc7\u0b9f\u0bbf\u0b99\u0bcd & \u0b8e\u0b95\u0bcd\u0bb8\u0bcd\u0baa\u0bcb\u0bb0\u0bcd\u0b9f\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "JAYASIRI AUTO CARE (PVT) LTD": {
    si: "\u0da2\u0dba\u0dc3\u0dd2\u0dbb\u0dd2 \u0d94\u0da7\u0ddd \u0d9a\u0dd9\u0dba\u0dcf\u0dbb\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0b9c\u0bc6\u0baf\u0b9a\u0bbf\u0bb0\u0bbf \u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0b95\u0bc7\u0bb0\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "JAYASURIYA  AUTO SERVICE ( PVT ) LT": {
    si: "\u0da2\u0dba\u0dc3\u0dd6\u0dbb\u0dd2\u0dba \u0d94\u0da7\u0ddd \u0dc3\u0dbb\u0dca\u0dc0\u0dd2\u0dc3\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) LT",
    ta: "\u0b9c\u0bc6\u0baf\u0b9a\u0bc2\u0bb0\u0bcd\u0baf\u0bbe \u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0b9a\u0bb0\u0bcd\u0bb5\u0bc0\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0b8e\u0bb2\u0bcd.\u0b9f\u0bbf",
  },
  "JAYASURIYA ENTERPRISE": {
    si: "\u0da2\u0dba\u0dc3\u0dd6\u0dbb\u0dd2\u0dba \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dca",
    ta: "\u0b9c\u0bc6\u0baf\u0b9a\u0bc2\u0bb0\u0bcd\u0baf\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0bb8\u0bcd",
  },
  "JAYAWARDHANA D M": {
    si: "\u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1 \u0da9\u0dd3 \u0d91\u0db8\u0dca",
    ta: "\u0b9c\u0bc6\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0bcd\u0ba4\u0ba9\u0bbe \u0b9f\u0bbf \u0b8e\u0bae\u0bcd",
  },
  "JCH2+PJ Thalayadi, Sri Lanka": {
    si: "JCH2+PJ \u0dad\u0dbd\u0dba\u0da9\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "JCH2+PJ \u0ba4\u0bbe\u0bb3\u0bc8\u0baf\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "JGFR+MX2, Pelmadulla, Sri Lanka": {
    si: "JGFR+MX2, \u0db4\u0dd0\u0dbd\u0dca\u0db8\u0da9\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "JGFR+MX2, \u0baa\u0bc6\u0bb2\u0bcd\u0bae\u0ba4\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "JGGQ+2WH, Pelmadulla, Sri Lanka": {
    si: "JGGQ+2WH, \u0db4\u0dd0\u0dbd\u0dca\u0db8\u0da9\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "JGGQ+2WH, \u0baa\u0bc6\u0bb2\u0bcd\u0bae\u0ba4\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "JGJG+RPW, Pelmadulla, Sri Lanka": {
    si: "JGJG+RPW, \u0db4\u0dd0\u0dbd\u0dca\u0db8\u0da9\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "JGJG+RPW, \u0baa\u0bc6\u0bb2\u0bcd\u0bae\u0ba4\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "JHC3+CGH, A4, Pelmadulla, Sri Lanka": {
    si: "JHC3+CGH, A4, \u0db4\u0dd0\u0dbd\u0dca\u0db8\u0da9\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "JHC3+CGH, A4, \u0baa\u0bc6\u0bb2\u0bcd\u0bae\u0ba4\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "JJH4+57P, Palapathwela - Galewela Rd, Pallepola, Sri Lanka": {
    si: "JJH4+57P, \u0db4\u0dbd\u0dcf\u0db4\u0dad\u0dca\u0dc0\u0dd9\u0dbd - \u0d9c\u0dbd\u0dda\u0dc0\u0dd9\u0dbd \u0db4\u0dcf\u0dbb, \u0db4\u0dbd\u0dca\u0dbd\u0dd9\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "JJH4+57P, \u0baa\u0bb2\u0baa\u0ba4\u0bcd\u0bb5\u0bc6\u0bb2 - \u0b95\u0bb2\u0bc7\u0bb5\u0bc6\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bb2\u0bcd\u0bb2\u0bc7\u0baa\u0bca\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "JMR9+FWH, Padaviya Rd, Kebitigollewa, Sri Lanka": {
    si: "JMR9+FWH, \u0db4\u0daf\u0dc0\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0d9a\u0dd0\u0db6\u0dd2\u0da7\u0dd2\u0d9c\u0ddc\u0dbd\u0dca\u0dbd\u0dd1\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "JMR9+FWH, Padaviya Rd, Kebitikollewa, Sri Lanka",
  },
  "JOE PERERA AND SONS": {
    si: "\u0da2\u0ddd \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b9c\u0bcb \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe \u0bae\u0bb1\u0bcd\u0bb1\u0bc1\u0bae\u0bcd \u0bae\u0b95\u0ba9\u0bcd\u0b95\u0bb3\u0bcd",
  },
  "JP46+3RX, Thalankudah, Sri Lanka": {
    si: "JP46+3RX, \u0dad\u0dcf\u0dbd\u0db1\u0dca\u0d9a\u0dd4\u0da9\u0dcf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "JP46+3RX, \u0ba4\u0bbe\u0bb2\u0b99\u0bcd\u0b95\u0bc1\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "JPV2+V6W, Balangoda, Sri Lanka": {
    si: "JPV2+V6W, \u0db6\u0dbd\u0db1\u0dca\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "JPV2+V6W, \u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "JQ2Q+7W Kurichchikadu, Sri Lanka": {
    si: "JQ2Q+7W \u0d9a\u0dd4\u0dbb\u0dd2\u0da0\u0dca\u0da0\u0dd2\u0d9a\u0dcf\u0da9\u0dd4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "JQ2Q+7W \u0b95\u0bc1\u0bb1\u0bbf\u0b9a\u0bcd\u0b9a\u0bbf\u0b95\u0bcd\u0b95\u0bbe\u0b9f\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "JQ2Q+9V Kurichchikadu, Sri Lanka": {
    si: "JQ2Q+9V \u0d9a\u0dd4\u0dbb\u0dd2\u0da0\u0dca\u0da0\u0dd2\u0d9a\u0dcf\u0da9\u0dd4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "JQ2Q+9V \u0b95\u0bc1\u0bb1\u0bbf\u0b9a\u0bcd\u0b9a\u0bbf\u0b95\u0bcd\u0b95\u0bbe\u0b9f\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "JQC6+2F Kirankulam, Sri Lanka": {
    si: "JQC6+2F \u0d9a\u0dd2\u0dbb\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "JQC6+2F \u0b95\u0bc0\u0bb0\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "JRF9+QM4, Bangadeniya, Sri Lanka": {
    si: "JRF9+QM4, \u0db6\u0d82\u0d9c\u0daf\u0dd9\u0dab\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "JRF9+QM4, \u0baa\u0b99\u0bcd\u0b95\u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "JWQ2+6V8, Valukkairaru-Punkudutivu-Kurikadduwan Rd, Velanai, Sri Lanka": {
    si: "JWQ2+6V8, \u0dc0\u0dcf\u0dbd\u0dd4\u0d9a\u0dca\u0d9a\u0dba\u0dd2\u0dbb\u0dcf\u0dbb\u0dd4-\u0db4\u0dd4\u0d82\u0d9a\u0dd4\u0da9\u0dd4\u0dad\u0dd2\u0dc0\u0dca-\u0d9a\u0dd4\u0dbb\u0dd2\u0d9a\u0daf\u0dca\u0daf\u0dd4\u0dc0\u0db1\u0dca \u0db4\u0dcf\u0dbb, \u0dc0\u0dda\u0dbd\u0db1\u0dba\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "JWQ2+6V8, \u0bb5\u0bb4\u0bc1\u0b95\u0bcd\u0b95\u0bc8\u0bb0\u0bbe\u0bb1\u0bc1-\u0baa\u0bc1\u0b99\u0bcd\u0b95\u0bc1\u0b9f\u0bc1\u0ba4\u0bc0\u0bb5\u0bc1-\u0b95\u0bc1\u0bb1\u0bbf\u0b95\u0bcd\u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe\u0ba9\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bc7\u0bb2\u0ba3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "JXHG+Q6R, Kaluthara Horana Road, Waskaduwa, Sri Lanka": {
    si: "JXHG+Q6R, \u0d9a\u0dc5\u0dd4\u0dad\u0dbb \u0dc4\u0ddc\u0dbb\u0dab \u0db4\u0dcf\u0dbb, \u0dc0\u0dc3\u0dca\u0d9a\u0da9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "JXHG+Q6R, \u0b95\u0bb3\u0bc1\u0ba4\u0bb0 \u0bb9\u0bca\u0bb0\u0ba3 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bb8\u0bcd\u0b95\u0b9f\u0bc1\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Ja Ela - Ekala - Gampaha - Yakkala Hwy, Ja-Ela": {
    si: "\u0da2\u0dcf \u0d87\u0dbd - \u0d92\u0d9a\u0dbd - \u0d9c\u0db8\u0dca\u0db4\u0dc4 - \u0dba\u0d9a\u0dca\u0d9a\u0dbd Hwy, \u0da2\u0dcf-\u0d87\u0dbd",
    ta: "\u0b9c\u0bbe \u0b8e\u0bb2 - \u0b8f\u0b95\u0bb2 - \u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe - \u0baf\u0b95\u0bcd\u0b95\u0bb2 \u0bb9\u0bc6\u0bb5\u0bbf, \u0b9c\u0bbe-\u0b8e\u0bb2",
  },
  "Ja-ela - Ganemulla Rd, Ja-ela, Ganemulla - Bollatte": {
    si: "\u0da2\u0dcf-\u0d87\u0dbd - \u0d9c\u0dab\u0dda\u0db8\u0dd4\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0da2\u0dcf-\u0d87\u0dbd, \u0d9c\u0db1\u0dda\u0db8\u0dd4\u0dbd\u0dca\u0dbd - \u0db6\u0ddc\u0dbd\u0dca\u0dbd\u0dad\u0dca\u0dad",
    ta: "\u0b9c\u0bbe-\u0b8e\u0bb2 - \u0b95\u0ba3\u0bc7\u0bae\u0bc1\u0bb2\u0bcd\u0bb2 \u0baa\u0bbe\u0ba4\u0bc8, \u0b9c\u0bbe-\u0b8e\u0bb2, \u0b95\u0ba3\u0bc7\u0bae\u0bc1\u0bb2\u0bcd\u0bb2 - \u0baa\u0bca\u0bb2\u0bcd\u0bb2\u0ba4\u0bcd\u0ba4\u0bc7",
  },
  "Jaffna - Manipay - Karainagar Rd, Manipay": {
    si: "\u0dba\u0dcf\u0db4\u0db1\u0dba - \u0db8\u0db1\u0dd2\u0db4\u0dca\u0db4\u0dcf\u0dba\u0dd2 - \u0d9a\u0dbb\u0dd9\u0dba\u0dd2\u0db1\u0d9c\u0dbb\u0dca \u0db4\u0dcf\u0dbb, \u0db8\u0db1\u0dd2\u0db4\u0dcf\u0dba\u0dd2",
    ta: "\u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd - \u0bae\u0bbe\u0ba9\u0bbf\u0baa\u0bcd\u0baa\u0bbe\u0baf\u0bcd - \u0b95\u0bbe\u0bb0\u0bc8\u0ba8\u0b95\u0bb0\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bbe\u0ba9\u0bbf\u0baa\u0bcd\u0baa\u0bbe\u0baf\u0bcd",
  },
  "Jaffna - Point Pedro Road, Kopay": {
    si: "\u0dba\u0dcf\u0db4\u0db1\u0dba - \u0db4\u0dda\u0daf\u0dd4\u0dbb\u0dd4\u0dad\u0dd4\u0da9\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0d9a\u0ddd\u0db4\u0dcf\u0dba\u0dd2",
    ta: "\u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd - \u0baa\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bcb\u0baa\u0bcd\u0baa\u0bbe\u0baf\u0bcd",
  },
  "Jaffna, Jaffna, Sri Lanka": {
    si: "\u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Jaffna-Point Pedro Rd Puttur": {
    si: "\u0dba\u0dcf\u0db4\u0db1\u0dba - \u0db4\u0dda\u0daf\u0dd4\u0dbb\u0dd4\u0dad\u0dd4\u0da9\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dd6\u0dbb\u0dca",
    ta: "\u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd- \u0baa\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bc2\u0bb0\u0bcd",
  },
  "Jaffna-manipay-karainagar Rd, Sandilipay": {
    si: "\u0dba\u0dcf\u0db4\u0db1\u0dba-\u0db8\u0db1\u0dd2\u0db4\u0dcf\u0dba\u0dd2-\u0d9a\u0dbb\u0dd9\u0dba\u0dd2\u0db1\u0d9c\u0dbb\u0dca \u0db4\u0dcf\u0dbb, \u0dc3\u0db1\u0dca\u0daf\u0dd2\u0dbd\u0dd2\u0db4\u0dcf\u0dba\u0dd2",
    ta: "\u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd-\u0bae\u0bbe\u0ba9\u0bbf\u0baa\u0bcd\u0baa\u0bbe\u0baf\u0bcd-\u0b95\u0bbe\u0bb0\u0bc8\u0ba8\u0b95\u0bb0\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0b9a\u0ba3\u0bcd\u0b9f\u0bbf\u0bb2\u0bbf\u0baa\u0bcd\u0baa\u0bbe\u0baf\u0bcd",
  },
  "Jayabodiya Road, Gandara": {
    si: "\u0da2\u0dba\u0db6\u0ddd\u0daf\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0d9c\u0db1\u0dca\u0daf\u0dbb",
    ta: "\u0b9c\u0bc6\u0baf\u0baa\u0bcb\u0ba4\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0ba8\u0bcd\u0ba4\u0bbe\u0bb0\u0bbe",
  },
  "Jayanth Mawatha, Puttalam - Anuradhapura - Trincomalee Hwy, Anuradhapura": {
    si: "\u0da2\u0dba\u0db1\u0dca\u0dad\u0dca \u0db8\u0dcf\u0dc0\u0dad, \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 - \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb - \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb",
    ta: "\u0b9c\u0baf\u0ba8\u0bcd\u0ba4\u0bcd \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd",
  },
  "Jayanthipura, Polonnaruwa": {
    si: "\u0da2\u0dba\u0db1\u0dca\u0dad\u0dd2\u0db4\u0dd4\u0dbb, \u0db4\u0ddc\u0dc5\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0",
    ta: "\u0b9c\u0baf\u0ba8\u0bcd\u0ba4\u0bbf\u0baa\u0bc1\u0bb0, \u0baa\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5\u0bc8",
  },
  "Jaywardana Filling Station, B152, Wattala- Hedala": {
    si: "\u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db6\u0dd3 152, \u0dc0\u0dad\u0dca\u0dad\u0dbd- \u0dc4\u0dd0\u0daf\u0dbd",
    ta: "\u0b9c\u0bc6\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9 \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, B152, \u0bb5\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8- \u0bb9\u0bc6\u0b9f\u0bb2\u0bbe",
  },
  "K  M  LIYAKATH  ALI": {
    si: "\u0d9a\u0dda \u0d91\u0db8\u0dca \u0dbd\u0dd2\u0dba\u0d9a\u0dad\u0dca \u0d85\u0dbd\u0dd2",
    ta: "\u0b95\u0bc7 \u0b8e\u0bae\u0bcd \u0bb2\u0bbf\u0baf\u0bbe\u0b95\u0ba4\u0bcd \u0b85\u0bb2\u0bbf",
  },
  "K A C PRIYADARSHANA": {
    si: "\u0d9a\u0dda \u0d92 \u0dc3\u0dd3 \u0db4\u0dca\u200d\u0dbb\u0dd2\u0dba\u0daf\u0dbb\u0dca\u0dc1\u0db1",
    ta: "\u0b95\u0bc7 \u0b8f \u0b9a\u0bbf \u0baa\u0bbf\u0bb0\u0bbf\u0baf\u0ba4\u0bb0\u0bcd\u0bb7\u0ba9\u0bbe",
  },
  "K A KUSUMSIRI": {
    si: "\u0d9a\u0dda \u0d92 \u0d9a\u0dd4\u0dc3\u0dd4\u0db8\u0dca\u0dc3\u0dd2\u0dbb\u0dd2",
    ta: "\u0b95\u0bc7 \u0b8f \u0b95\u0bc1\u0b9a\u0bc1\u0bae\u0bcd\u0b9a\u0bbf\u0bb0\u0bbf",
  },
  "K A SARATH GUNASEKARA": {
    si: "\u0d9a\u0dda \u0d92 \u0dc3\u0dbb\u0dad\u0dca \u0d9c\u0dd4\u0dab\u0dc3\u0dda\u0d9a\u0dbb",
    ta: "\u0b95\u0bc7 \u0b8f \u0b9a\u0bb0\u0ba4\u0bcd \u0b95\u0bc1\u0ba3\u0b9a\u0bc7\u0b95\u0bb0",
  },
  "K D ANIL": {
    si: "\u0d9a\u0dda \u0da9\u0dd3 \u0d85\u0db1\u0dd2\u0dbd\u0dca",
    ta: "\u0b95\u0bc7 \u0b9f\u0bbf \u0b85\u0ba9\u0bbf\u0bb2\u0bcd",
  },
  "K D M M SIRIWARDHANA": {
    si: "\u0d9a\u0dda \u0da9\u0dd3 \u0d91\u0db8\u0dca \u0d91\u0db8\u0dca \u0dc3\u0dd2\u0dbb\u0dd2\u0dc0\u0dbb\u0dca\u0db0\u0db1",
    ta: "\u0b95\u0bc7 \u0b9f\u0bbf \u0b8e\u0bae\u0bcd \u0b8e\u0bae\u0bcd \u0b9a\u0bbf\u0bb0\u0bbf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0bbe",
  },
  "K D P ARASAKULARATNE &  SONS": {
    si: "\u0d9a\u0dda \u0da9\u0dd3 \u0db4\u0dd3 \u0d85\u0dbb\u0dc3\u0d9a\u0dd4\u0dbd\u0dbb\u0dad\u0dca\u0db1 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b95\u0bc7 \u0b9f\u0bbf \u0baa\u0bbf \u0b85\u0bb0\u0b9a\u0b95\u0bc1\u0bb2\u0bb0\u0ba4\u0bcd\u0ba9 & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "K D U &  SONS FILLING STATION": {
    si: "K D U \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b95\u0bc7 \u0b9f\u0bbf \u0baf\u0bc1 & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "K G DHANASIRI": {
    si: "\u0d9a\u0dda \u0da2\u0dd3 \u0db0\u0db1\u0dc3\u0dd2\u0dbb\u0dd2",
    ta: "\u0b95\u0bc7 \u0b9c\u0bbf \u0ba4\u0ba9\u0b9a\u0bbf\u0bb1\u0bbf",
  },
  "K G P P MUNASINGHE": {
    si: "\u0d9a\u0dda \u0da2\u0dd3 \u0db4\u0dd3 \u0db4\u0dd3 \u0db8\u0dd4\u0dab\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b95\u0bc7 \u0b9c\u0bbf \u0baa\u0bbf \u0baa\u0bbf \u0bae\u0bc1\u0ba9\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "K H JAYASINGHE": {
    si: "\u0d9a\u0dda \u0d91\u0da0\u0dca \u0da2\u0dba\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b95\u0bc7 \u0b8e\u0b9a\u0bcd \u0b9c\u0baf\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "K JAYAPIRANAVAN": {
    si: "\u0d9a\u0dda \u0da2\u0dba\u0db4\u0dd2\u0dbb\u0db1\u0dc0\u0db1\u0dca",
    ta: "\u0b95\u0bc7 \u0b9c\u0bc6\u0baf\u0baa\u0bbf\u0bb0\u0bbe\u0ba3\u0bb5\u0ba9\u0bcd",
  },
  "K K A R KUMARASINGHE & SONS": {
    si: "\u0d9a\u0dda \u0d9a\u0dda \u0d92 \u0d86\u0dbb\u0dca \u0d9a\u0dd4\u0db8\u0dcf\u0dbb\u0dc3\u0dd2\u0d82\u0dc4 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b95\u0bc7 \u0b95\u0bc7 \u0b8f \u0b86\u0bb0\u0bcd \u0b95\u0bc1\u0bae\u0bbe\u0bb0\u0b9a\u0bbf\u0b99\u0bcd\u0b95 & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "K K D SENAVIRATHNA": {
    si: "\u0d9a\u0dda \u0d9a\u0dda \u0da9\u0dd3 \u0dc3\u0dda\u0db1\u0dc0\u0dd2\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b95\u0bc7 \u0b95\u0bc7 \u0b9f\u0bbf \u0b9a\u0bc7\u0ba9\u0bb5\u0bbf\u0bb0\u0ba4\u0bcd\u0ba9\u0bbe",
  },
  "K K I S SARATHCHANDRA": {
    si: "\u0d9a\u0dda \u0d9a\u0dda \u0d85\u0dba\u0dd2 \u0d91\u0dc3\u0dca \u0dc3\u0dbb\u0dad\u0dca\u0da0\u0db1\u0dca\u0daf\u0dca\u200d\u0dbb",
    ta: "\u0b95\u0bc7 \u0b95\u0bc7 \u0b90 \u0b8e\u0bb8\u0bcd \u0b9a\u0bb0\u0ba4\u0bcd\u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0bbe",
  },
  "K K KONES FILLING STATION": {
    si: "K K KONES \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b95\u0bc7 \u0b95\u0bcb \u0b95\u0bcb\u0ba9\u0bcd\u0bb8\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "K K N KARUNASIRI": {
    si: "\u0d9a\u0dda \u0d9a\u0dda \u0d91\u0db1\u0dca \u0d9a\u0dbb\u0dd4\u0dab\u0dcf\u0dc3\u0dd2\u0dbb\u0dd2",
    ta: "\u0b95\u0bc7 \u0b95\u0bc7 \u0b8e\u0ba9\u0bcd \u0b95\u0bb0\u0bc1\u0ba3\u0bbe\u0b9a\u0bbf\u0bb0\u0bbf",
  },
  "K K.SENANAYAKE": {
    si: "\u0d9a\u0dda \u0d9a\u0dda.\u0dc3\u0dda\u0db1\u0dcf\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b95\u0bc7.\u0b95\u0bc7.\u0b9a\u0bc7\u0ba9\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "K MAHENDREN": {
    si: "\u0d9a\u0dda \u0db8\u0dc4\u0dda\u0db1\u0dca\u0daf\u0dca\u200d\u0dbb\u0db1\u0dca",
    ta: "\u0b95\u0bc7 \u0bae\u0b95\u0bc7\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0ba9\u0bcd",
  },
  "K N L PRASANTHA PERERA": {
    si: "\u0d9a\u0dda \u0d91\u0db1\u0dca \u0d91\u0dbd\u0dca \u0db4\u0dca\u200d\u0dbb\u0dc3\u0db1\u0dca\u0dad \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b95\u0bc7 \u0b8e\u0ba9\u0bcd \u0b8e\u0bb2\u0bcd \u0baa\u0bbf\u0bb0\u0b9a\u0bbe\u0ba8\u0bcd\u0ba4 \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "K P A C CHANDRASEELI": {
    si: "\u0d9a\u0dda\u0db4\u0dd3\u0d92 \u0dc3\u0dd3 \u0da0\u0db1\u0dca\u0daf\u0dca\u200d\u0dbb\u0dc3\u0dd3\u0dbd\u0dd2",
    ta: "\u0b95\u0bc7 \u0baa\u0bbf \u0b8f \u0b9a\u0bbf \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0b9a\u0bc0\u0bb2\u0bbf",
  },
  "K S B P FERNANDO": {
    si: "\u0d9a\u0dda \u0d91\u0dc3\u0dca \u0db6\u0dd3 \u0db4\u0dd3 \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0b95\u0bc7 \u0b8e\u0bb8\u0bcd \u0baa\u0bbf \u0baa\u0bbf \u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "K S C S FUEL MART (PVT) LTD": {
    si: "K S C S FUEL MART (PVT) LTD",
    ta: "K S C S FUEL MART (PVT) LTD",
  },
  "K S JAYASINGHE": {
    si: "\u0d9a\u0dda \u0d91\u0dc3\u0dca \u0da2\u0dba\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b95\u0bc7 \u0b8e\u0bb8\u0bcd \u0b9c\u0bc6\u0baf\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "K S KALUPAHANA": {
    si: "\u0d9a\u0dda \u0d91\u0dc3\u0dca \u0d9a\u0dc5\u0dd4\u0db4\u0dc4\u0db1",
    ta: "\u0b95\u0bc7 \u0b8e\u0bb8\u0bcd \u0b95\u0bb2\u0bc1\u0baa\u0bb9\u0bbe\u0ba9\u0bbe",
  },
  "K S PONNAMBALAM & SON": {
    si: "\u0d9a\u0dda \u0d91\u0dc3\u0dca \u0db4\u0ddc\u0db1\u0dca\u0db1\u0db8\u0dca\u0db6\u0dbd\u0db8\u0dca \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dcf",
    ta: "\u0b95\u0bc7 \u0b8e\u0bb8\u0bcd \u0baa\u0bca\u0ba9\u0bcd\u0ba9\u0bae\u0bcd\u0baa\u0bb2\u0bae\u0bcd & \u0bae\u0b95\u0ba9\u0bcd",
  },
  "K T H C L PEIRIS": {
    si: "\u0d9a\u0dda \u0da7\u0dd3 \u0d91\u0da0\u0dca \u0dc3\u0dd3 \u0d91\u0dbd\u0dca \u0db4\u0dd3\u0dbb\u0dd2\u0dc3\u0dca",
    ta: "\u0b95\u0bc7 \u0b9f\u0bbf \u0b8e\u0b9a\u0bcd \u0b9a\u0bbf \u0b8e\u0bb2\u0bcd \u0baa\u0bc0\u0bb0\u0bbf\u0bb8\u0bcd",
  },
  "K THURAINAYAGUM": {
    si: "\u0d9a\u0dda \u0dad\u0dd4\u0dbb\u0dd9\u0dba\u0dd2\u0db1\u0dcf\u0dba\u0d9c\u0dd4\u0db8\u0dca",
    ta: "\u0b95\u0bc7 \u0ba4\u0bc1\u0bb0\u0bc8\u0ba8\u0bbe\u0baf\u0b95\u0bae\u0bcd",
  },
  "K V NIHAL": {
    si: "\u0d9a\u0dda \u0dc0\u0dd3 \u0db1\u0dd2\u0dc4\u0dcf\u0dbd\u0dca",
    ta: "\u0b95\u0bc7 \u0bb5\u0bbf \u0ba8\u0bbf\u0bb9\u0bbe\u0bb2\u0bcd",
  },
  "K W SUSIRIPALA ASSOCIATES": {
    si: "\u0d9a\u0dda \u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0dc3\u0dd4\u0dc3\u0dd2\u0dbb\u0dd2\u0db4\u0dcf\u0dbd \u0d87\u0dc3\u0ddd\u0dc3\u0dd2\u0dba\u0dda\u0da7\u0dca\u0dc3\u0dca",
    ta: "\u0b95\u0bc7 \u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b9a\u0bc1\u0b9a\u0bbf\u0bb0\u0bbf\u0baa\u0bbe\u0bb2\u0bbe \u0b85\u0b9a\u0bcb\u0b9a\u0bbf\u0baf\u0bc7\u0b9f\u0bcd\u0bb8\u0bcd",
  },
  "K YOGARAJAH": {
    si: "\u0d9a\u0dda \u0dba\u0ddd\u0d9c\u0dbb\u0dcf\u0da2\u0dcf",
    ta: "\u0b95\u0bc7 \u0baf\u0bcb\u0b95\u0bb0\u0bbe\u0b9c\u0bbe",
  },
  "K. D. ANIL PRIYANTHA FERNANDO": {
    si: "K. D. \u0d85\u0db1\u0dd2\u0dbd\u0dca \u0db4\u0dca\u200d\u0dbb\u0dd2\u0dba\u0db1\u0dca\u0dad \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0b95\u0bc7.\u0b9f\u0bbf. \u0b85\u0ba9\u0bbf\u0bb2\u0bcd \u0baa\u0bbf\u0bb0\u0bbf\u0baf\u0ba8\u0bcd\u0ba4 \u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "K. P. SUPUN KUMARA PERERA": {
    si: "K. P. \u0dc3\u0dd4\u0db4\u0dd4\u0db1\u0dca \u0d9a\u0dd4\u0db8\u0dcf\u0dbb \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b95\u0bc7.\u0baa\u0bbf.\u0b9a\u0bc1\u0baa\u0bc1\u0ba9\u0bcd \u0b95\u0bc1\u0bae\u0bbe\u0bb0 \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "K.A.A.J.R.KURUPPU": {
    si: "\u0d9a\u0dda.\u0d92.\u0d92.\u0da2\u0dda.\u0d86\u0dbb\u0dca.\u0d9a\u0dd4\u0dbb\u0dd4\u0db4\u0dca\u0db4\u0dd4",
    ta: "\u0b95\u0bc7.\u0b8f.\u0b9c\u0bc7.\u0b86\u0bb0\u0bcd.\u0b95\u0bc1\u0bb0\u0bc1\u0baa\u0bcd\u0baa\u0bc1",
  },
  "K.A.ANURA RAMYALAL": {
    si: "\u0d9a\u0dda.\u0d92.\u0d85\u0db1\u0dd4\u0dbb \u0dbb\u0db8\u0dca\u0dba\u0dbd\u0dcf\u0dbd\u0dca",
    ta: "\u0b95\u0bc7.\u0b8f.\u0b85\u0ba9\u0bc1\u0bb0\u0bbe \u0bb0\u0bae\u0bcd\u0baf\u0bbe\u0bb2\u0bbe\u0bb2\u0bcd",
  },
  "K.A.H.S.PERERA": {
    si: "\u0d9a\u0dda.\u0d92.\u0d91\u0da0\u0dca.\u0d91\u0dc3\u0dca.\u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b95\u0bc7.\u0b8f.\u0b8e\u0b9a\u0bcd.\u0b8e\u0bb8\u0bcd.\u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "K.A.S.B.SIRIWARDENE": {
    si: "\u0d9a\u0dda.\u0d92.\u0d91\u0dc3\u0dca.\u0db6\u0dd3.\u0dc3\u0dd2\u0dbb\u0dd2\u0dc0\u0dbb\u0dca\u0db0\u0db1",
    ta: "\u0b95\u0bc7.\u0b8f.\u0b8e\u0bb8\u0bcd.\u0baa\u0bbf.\u0b9a\u0bbf\u0bb1\u0bbf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9",
  },
  "K.D.M.B.LORA": {
    si: "K.D.M.B.LORA",
    ta: "\u0b95\u0bc7.\u0b9f\u0bbf.\u0b8e\u0bae\u0bcd.\u0baa\u0bbf.\u0bb2\u0bcb\u0bb0\u0bbe",
  },
  "K.D.N.T.UPASENA": {
    si: "\u0d9a\u0dda.\u0da9\u0dd3.\u0d91\u0db1\u0dca.\u0da7\u0dd3.\u0d8b\u0db4\u0dc3\u0dda\u0db1",
    ta: "\u0b95\u0bc7.\u0b9f\u0bbf.\u0b8e\u0ba9\u0bcd.\u0b9f\u0bbf.\u0b89\u0baa\u0b9a\u0bc7\u0ba9\u0bbe",
  },
  "K.D.U.S.PERERA & CO.( PVT )LTD": {
    si: "K.D.U.S.PERERA & CO.(PVT )LTD",
    ta: "K.D.U.S.PERERA & CO.(PVT )LTD",
  },
  "K.K.Vijitha": {
    si: "\u0d9a\u0dda.\u0d9a\u0dda.\u0dc0\u0dd2\u0da2\u0dd2\u0dad",
    ta: "\u0b95\u0bc7.\u0b95\u0bc7.\u0bb5\u0bbf\u0b9c\u0bbf\u0ba4\u0bbe",
  },
  "K.L.G.UDAYANANDA": {
    si: "\u0d9a\u0dda.\u0d91\u0dbd\u0dca.\u0da2\u0dd3.\u0d8b\u0daf\u0dba\u0dcf\u0db1\u0db1\u0dca\u0daf",
    ta: "\u0b95\u0bc7.\u0b8e\u0bb2\u0bcd.\u0b9c\u0bbf.\u0b89\u0ba4\u0baf\u0bbe\u0ba9\u0ba8\u0bcd\u0ba4\u0bbe",
  },
  "K.M.JAINUL ABDEEN": {
    si: "\u0d9a\u0dda.\u0d91\u0db8\u0dca.\u0da2\u0ddb\u0db1\u0dd4\u0dbd\u0dca \u0d86\u0db6\u0dca\u0daf\u0dd3\u0db1\u0dca",
    ta: "\u0b95\u0bc7.\u0b8e\u0bae\u0bcd.\u0b9c\u0bc6\u0baf\u0bbf\u0ba9\u0bc1\u0bb2\u0bcd \u0b86\u0baa\u0bcd\u0ba4\u0bc0\u0ba9\u0bcd",
  },
  "K.N.PERERA & SONS": {
    si: "\u0d9a\u0dda.\u0d91\u0db1\u0dca.\u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b95\u0bc7.\u0b8e\u0ba9\u0bcd.\u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "K.P.P.MUNASINGHE": {
    si: "\u0d9a\u0dda.\u0db4\u0dd3.\u0db4\u0dd3.\u0db8\u0dd4\u0dab\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b95\u0bc7.\u0baa\u0bbf.\u0baa\u0bbf.\u0bae\u0bc1\u0ba9\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "K.P.SIRIWARDENA ENTERPRISES": {
    si: "\u0d9a\u0dda.\u0db4\u0dd3.\u0dc3\u0dd2\u0dbb\u0dd2\u0dc0\u0dbb\u0dca\u0db0\u0db1 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b95\u0bc7.\u0baa\u0bbf.\u0b9a\u0bbf\u0bb1\u0bbf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "K.PIYADASA & SON": {
    si: "\u0d9a\u0dda.\u0db4\u0dd2\u0dba\u0daf\u0dcf\u0dc3 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dcf",
    ta: "\u0b95\u0bc7.\u0baa\u0bbf\u0baf\u0ba4\u0bbe\u0b9a\u0bbe & \u0bae\u0b95\u0ba9\u0bcd",
  },
  "K.PREMATHILAKA": {
    si: "\u0d9a\u0dda.\u0db4\u0dca\u200d\u0dbb\u0dda\u0db8\u0dad\u0dd2\u0dbd\u0d9a",
    ta: "\u0b95\u0bc7.\u0baa\u0bbf\u0bb0\u0bc7\u0bae\u0ba4\u0bbf\u0bb2\u0b95",
  },
  "K.R.SRIYANI JAYASURIYA": {
    si: "\u0d9a\u0dda.\u0d86\u0dbb\u0dca.\u0dc1\u0dca\u200d\u0dbb\u0dd2\u0dba\u0dcf\u0db1\u0dd2 \u0da2\u0dba\u0dc3\u0dd6\u0dbb\u0dd2\u0dba",
    ta: "\u0b95\u0bc7.\u0b86\u0bb0\u0bcd.\u0bb8\u0bcd\u0bb0\u0bbf\u0baf\u0bbe\u0ba9\u0bbf \u0b9c\u0bc6\u0baf\u0b9a\u0bc2\u0bb0\u0bbf\u0baf\u0bbe",
  },
  "K.SHANMUGARATNAM": {
    si: "\u0d9a\u0dda.\u0dc2\u0db1\u0dca\u0db8\u0dd4\u0d9c\u0dbb\u0dad\u0dca\u0db1\u0db8\u0dca",
    ta: "\u0b95.\u0b9a\u0ba3\u0bcd\u0bae\u0bc1\u0b95\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0bae\u0bcd",
  },
  "K.THEVAGURUNATHAN": {
    si: "\u0d9a\u0dda.\u0dad\u0dda\u0dc0\u0d9c\u0dd4\u0dbb\u0dd4\u0db1\u0dcf\u0daf\u0db1\u0dca",
    ta: "\u0b95\u0bc7.\u0ba4\u0bc7\u0bb5\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0ba4\u0ba9\u0bcd",
  },
  "K.U.IBRALEBBE & SONS": {
    si: "K.U.IBRALEBBE & Sons",
    ta: "K.U.IBRALEBBE & SONS",
  },
  "K.V.BANDULA": {
    si: "K.V.BANDULA",
    ta: "\u0b95\u0bc7.\u0bb5\u0bbf.\u0baa\u0ba8\u0bcd\u0ba4\u0bc1\u0bb2\u0bbe",
  },
  "KADDAIVELY NELLIADY MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0da9\u0dba\u0dd2\u0dc0\u0dda\u0dbd\u0dd2 \u0db1\u0dd9\u0dbd\u0dd2\u0dba\u0da9\u0dd2 \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0b9f\u0bc8\u0bb5\u0bc7\u0bb2\u0bbf \u0ba8\u0bc6\u0bb2\u0bcd\u0bb2\u0bbf\u0baf\u0b9f\u0bbf MPCS LTD",
  },
  "KAHATAGASDIGILIYA MPCS LTD": {
    si: "\u0d9a\u0dc4\u0da7\u0d9c\u0dc3\u0dca\u0daf\u0dd2\u0d9c\u0dd2\u0dbd\u0dd2\u0dba MPCS LTD",
    ta: "\u0b95\u0bb9\u0b9f\u0b95\u0bb8\u0bcd\u0b9f\u0bbf\u0b95\u0bbf\u0bb2\u0bbf\u0baf\u0bbe MPCS LTD",
  },
  "KALAWANA MPCS LTD": {
    si: "\u0d9a\u0dbd\u0dc0\u0dcf\u0db1 MPCS LTD",
    ta: "\u0b95\u0bb2\u0bb5\u0bbe\u0ba9\u0bbe MPCS LTD",
  },
  "KALPITIYA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba MPCS",
    ta: "\u0b95\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0bbe MPCS LTD",
  },
  "KALUTARA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0dc5\u0dd4\u0dad\u0dbb \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0bb3\u0bc1\u0ba4\u0bbe\u0bb0\u0bbe MPCS LTD",
  },
  "KAMALADEVI KATHIRASAMPILLAI": {
    si: "\u0d9a\u0db8\u0dbd\u0dcf\u0daf\u0dda\u0dc0\u0dd2 \u0d9a\u0dad\u0dd2\u0dbb\u0dc3\u0db8\u0dca\u0db4\u0dd2\u0dbd\u0dca\u0dbd\u0dd9\u0dba\u0dd2",
    ta: "\u0b95\u0bae\u0bb2\u0bbe\u0ba4\u0bc7\u0bb5\u0bbf \u0b95\u0ba4\u0bbf\u0bb0\u0b9a\u0bae\u0bcd\u0baa\u0bbf\u0bb3\u0bcd\u0bb3\u0bc8",
  },
  "KAMBURUPITIYA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0db9\u0dd4\u0dbb\u0dd4\u0db4\u0dd2\u0da7\u0dd2\u0dba MPCS",
    ta: "\u0b95\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bc1\u0baa\u0bbf\u0b9f\u0bbf\u0baf\u0bbe MPCS LTD",
  },
  "KAMMALTOTA GN. DIVISION FISHERY SO.": {
    si: "\u0d9a\u0db8\u0dca\u0db8\u0dbd\u0dca\u0dad\u0ddc\u0da7 \u0da2\u0dd3.\u0d91\u0db1\u0dca. \u0da9\u0dd2\u0dc0\u0dd2\u0dc2\u0db1\u0dca \u0db0\u0dd3\u0dc0\u0dbb SO.",
    ta: "\u0b95\u0bae\u0bcd\u0bae\u0bb2\u0bcd\u0ba4\u0bca\u0b9f\u0bcd\u0b9f \u0b9c\u0bbf\u0b8e\u0ba9\u0bcd. \u0baa\u0bbf\u0bb0\u0bbf\u0bb5\u0bc1 \u0bae\u0bc0\u0ba9\u0bcd\u0bb5\u0bb3\u0bae\u0bcd \u0b8e\u0bb8\u0bcd.\u0b93.",
  },
  "KANDIAH RAJAGOPAL": {
    si: "\u0d9a\u0db1\u0dca\u0daf\u0dd2\u0dba\u0dcf \u0dbb\u0dcf\u0da2\u0d9c\u0ddd\u0db4\u0dcf\u0dbd\u0dca",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf\u0baf\u0bbe \u0bb0\u0bbe\u0b9c\u0b95\u0bcb\u0baa\u0bbe\u0bb2\u0bcd",
  },
  "KANDY TYRE REBUILDING COMPANY LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0da7\u0dba\u0dbb\u0dca \u0db1\u0dd0\u0dc0\u0dad \u0d9c\u0ddc\u0da9\u0db1\u0dd0\u0d9f\u0dd3\u0db8\u0dda \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0b9f\u0baf\u0bb0\u0bcd \u0bb0\u0bc0\u0baa\u0bbf\u0bb2\u0bcd\u0b9f\u0bbf\u0b99\u0bcd \u0b95\u0bae\u0bcd\u0baa\u0bc6\u0ba9\u0bbf \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "KANTALE A.G.A. DIVISION MPCS LTD": {
    si: "\u0d9a\u0db1\u0dca\u0dad\u0dbd\u0dda \u0d92.\u0da2\u0dd3.\u0d92. \u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0da9\u0dd2\u0dc0\u0dd2\u0dc2\u0db1\u0dca \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0ba8\u0bcd\u0ba4\u0bb3\u0bc7 \u0b8f.\u0b9c\u0bbf.\u0b8f. \u0b9f\u0bbf\u0bb5\u0bbf\u0bb7\u0ba9\u0bcd MPCS LTD",
  },
  "KARACHCHI NORTH MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0dbb\u0da0\u0dca\u0da0\u0dd2 \u0db1\u0ddd\u0dbb\u0dca\u0dad\u0dca \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf \u0bb5\u0b9f\u0b95\u0bcd\u0b95\u0bc1 MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "KARACHCHI SOUTH MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0dbb\u0da0\u0dca\u0da0\u0dd2 \u0daf\u0d9a\u0dd4\u0dab\u0dd4 MPCS",
    ta: "\u0b95\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf \u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1 MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "KARAINAGAR MPCS LTD": {
    si: "\u0d9a\u0dbb\u0dd9\u0dba\u0dd2\u0db1\u0d9c\u0dbb\u0dca MPCS LTD",
    ta: "\u0b95\u0bbe\u0bb0\u0bc8\u0ba8\u0b95\u0bb0\u0bcd MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "KARANDENIYA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0dbb\u0db1\u0dca\u0daf\u0dd9\u0dab\u0dd2\u0dba \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0bb0\u0ba8\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf MPCS LTD",
  },
  "KARUNARATNE FUEL MART": {
    si: "\u0d9a\u0dbb\u0dd4\u0dab\u0dcf\u0dbb\u0dad\u0dca\u0db1 \u0d89\u0db1\u0dca\u0db0\u0db1 \u0d85\u0dbd\u0dd9\u0dc0\u0dd2\u0dc3\u0dd0\u0dbd",
    ta: "\u0b95\u0bb0\u0bc1\u0ba3\u0bbe\u0bb0\u0ba4\u0bcd\u0ba9 \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0b9a\u0ba8\u0bcd\u0ba4\u0bc8",
  },
  "KARUWALAGASWEWA MPCS LTD": {
    si: "\u0d9a\u0dbb\u0dd4\u0dc0\u0dbd\u0d9c\u0dc3\u0dca\u0dc0\u0dd0\u0dc0 MPCS LTD",
    ta: "\u0b95\u0bb0\u0bc1\u0bb5\u0bb2\u0b95\u0bb8\u0bcd\u0bb5\u0bc6\u0bb5 MPCS LTD",
  },
  "KASUN ENTERPRISES": {
    si: "\u0d9a\u0dc3\u0dd4\u0db1\u0dca \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b95\u0b9a\u0bc1\u0ba9\u0bcd \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "KATANA MPCS LTD": {
    si: "\u0d9a\u0da7\u0dcf\u0db1 MPCS LTD",
    ta: "\u0b95\u0b9f\u0bcd\u0b9f\u0ba9\u0bbe MPCS LTD",
  },
  KATTUWA: {
    si: "\u0d9a\u0da7\u0dca\u0da7\u0dd4\u0dc0",
    ta: "\u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe",
  },
  "KATUGAMPOLA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0da7\u0dd4\u0d9c\u0db8\u0dca\u0db4\u0ddc\u0dbd MPCS",
    ta: "\u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0b95\u0bae\u0bcd\u0baa\u0bca\u0bb2 MPCS LTD",
  },
  "KATUWANA ENTERPRISES (PVT) LTD": {
    si: "\u0d9a\u0da7\u0dd4\u0dc0\u0db1 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b95\u0b9f\u0bc1\u0bb5\u0bbe\u0ba9\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "KAVINDA DISSANAYAKE": {
    si: "\u0d9a\u0dcf\u0dc0\u0dd2\u0db1\u0dca\u0daf \u0daf\u0dd2\u0dc3\u0dcf\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b95\u0bbe\u0bb5\u0bbf\u0ba8\u0bcd\u0ba4 \u0ba4\u0bbf\u0b9a\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "KAYTS MPCS LTD": {
    si: "KAYTS MPCS LTD",
    ta: "KAYTS MPCS LTD",
  },
  "KEBITIGOLLAWA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0dd0\u0db6\u0dd2\u0da7\u0dd2\u0d9c\u0ddc\u0dbd\u0dca\u0dbd\u0dd1\u0dc0 MPCS",
    ta: "\u0b95\u0bc6\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bca\u0bb2\u0bcd\u0bb2\u0bbe\u0bb5 MPCS LTD",
  },
  "KEERTHI FUEL MART": {
    si: "\u0d9a\u0dd3\u0dbb\u0dca\u0dad\u0dd2 \u0dc6\u0dd4\u0dc0\u0dd9\u0dbd\u0dca \u0db8\u0dcf\u0dbb\u0dca\u0da7\u0dca",
    ta: "\u0b95\u0bc0\u0bb0\u0bcd\u0ba4\u0bcd\u0ba4\u0bbf \u0b83\u0baa\u0bcd\u0baf\u0bc2\u0bb2\u0bcd \u0bae\u0bbe\u0bb0\u0bcd\u0b9f\u0bcd",
  },
  KEGALLE: {
    si: "\u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8",
  },
  "KEGALLE MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8 MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "KEGALLE MPCS LTD.": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca.",
    ta: "\u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8 MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd.",
  },
  "KEHELELLA MPCS Ltd": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0dd9\u0dc4\u0dd9\u0dbd\u0dca\u0d87\u0dbd\u0dca\u0dbd \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0bc6\u0bb9\u0bc6\u0bb2\u0bb2\u0bcd\u0bb2 \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0b9a\u0bbf\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  KEKIRAWA: {
    si: "\u0d9a\u0dd0\u0d9a\u0dd2\u0dbb\u0dcf\u0dc0",
    ta: "\u0b95\u0bc6\u0b95\u0bcd\u0b95\u0bbf\u0bb0\u0bbe\u0bb5",
  },
  "KILINOCHCHI-CANCEL": {
    si: "\u0d9a\u0dd2\u0dbd\u0dd2\u0db1\u0ddc\u0da0\u0dca\u0da0\u0dd2\u0dba-\u0d85\u0dc0\u0dbd\u0d82\u0d9c\u0dd4 \u0d9a\u0dbb\u0db1\u0dca\u0db1",
    ta: "\u0b95\u0bbf\u0bb3\u0bbf\u0ba8\u0bca\u0b9a\u0bcd\u0b9a\u0bbf-\u0bb0\u0ba4\u0bcd\u0ba4\u0bc1",
  },
  "KIRINDIWELA - KERAGALA MPCS LTD": {
    si: "\u0d9a\u0dd2\u0dbb\u0dd2\u0db3\u0dd2\u0dc0\u0dd0\u0dbd - \u0d9a\u0dda\u0dbb\u0d9c\u0dbd MPCS LTD",
    ta: "\u0b95\u0bbf\u0bb0\u0bbf\u0ba8\u0bcd\u0ba4\u0bbf\u0bb5\u0bc6\u0bb2 - \u0b95\u0bc7\u0bb0\u0b95\u0bb2 MPCS LTD",
  },
  KKS: {
    si: "\u0d9a\u0dda.\u0d9a\u0dda.\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0bc7.\u0b95\u0bc7.\u0b8e\u0bb8\u0bcd",
  },
  "KOBEIGANE MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0ddc\u0db6\u0dd9\u0dba\u0dd2\u0d9c\u0db1\u0dda \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0bcb\u0baa\u0bbf\u0b95\u0bc7\u0ba9\u0bcd \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0b9a\u0bbf\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "KOLONNA KORALE MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0ddc\u0dbd\u0ddc\u0db1\u0dca\u0db1 \u0d9a\u0ddd\u0dbb\u0dbd\u0dda \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0bca\u0bb2\u0bcb\u0ba9\u0bbe \u0b95\u0bcb\u0bb0\u0bb2\u0bc7 MPCS LTD",
  },
  "KOLONNAWA MPCS LTD.": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0ddc\u0dbd\u0ddc\u0db1\u0dca\u0db1\u0dcf\u0dc0 MPCS.",
    ta: "\u0b95\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bbe\u0bb5 MPCS LTD.",
  },
  "KOLONNE KORALE MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0ddc\u0dbd\u0ddc\u0db1\u0dca\u0db1\u0dda \u0d9a\u0ddd\u0dbb\u0dbd\u0dda \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0bca\u0bb2\u0bcb\u0ba9\u0bcd\u0ba9\u0bc7 \u0b95\u0bcb\u0bb0\u0bb2\u0bc7 MPCS LTD",
  },
  "KORALAI CENTRAL MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0ddd\u0dbb\u0dc5\u0dba\u0dd2 \u0dc3\u0dd9\u0db1\u0dca\u0da7\u0dca\u200d\u0dbb\u0dbd\u0dca \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0bcb\u0bb1\u0bb3\u0bc8 \u0b9a\u0bc6\u0ba9\u0bcd\u0b9f\u0bcd\u0bb0\u0bb2\u0bcd \u0b8e\u0bae\u0bcd.\u0baa\u0bbf.\u0b9a\u0bbf.\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "KORALAI MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0ddd\u0dbb\u0dc5\u0dba\u0dd2 \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0bcb\u0bb1\u0bb3\u0bc8 MPCS LTD",
  },
  "KORALAI NORTH MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0ddd\u0dbb\u0dc5\u0dba\u0dd2 \u0db1\u0ddd\u0dbb\u0dca\u0dad\u0dca \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0bcb\u0bb1\u0bb3\u0bc8 \u0bb5\u0b9f\u0b95\u0bcd\u0b95\u0bc1 MPCS LTD",
  },
  "KORALAI SOUTH MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0ddd\u0dbb\u0dc5\u0dba\u0dd2 \u0daf\u0d9a\u0dd4\u0dab\u0dd4 \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0bcb\u0bb1\u0bb3\u0bc8 \u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1 MPCS LTD",
  },
  KOSHENA: {
    si: "\u0d9a\u0ddc\u0dc2\u0dd9\u0db1",
    ta: "\u0b95\u0bcb\u0bb7\u0bc7\u0ba9\u0bbe",
  },
  "KOTADENIYAWA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0ddc\u0da7\u0daf\u0dd9\u0dab\u0dd2\u0dba\u0dcf\u0dc0 MPCS",
    ta: "\u0b95\u0bca\u0b9f\u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe\u0bb5 MPCS LTD",
  },
  "KOTAHENA CEN. LANKA SERV STN.(PVT)L": {
    si: "\u0d9a\u0ddc\u0da7\u0dc4\u0dda\u0db1 \u0dc3\u0dd9\u0db1\u0dca. \u0dbd\u0d82\u0d9a\u0dcf \u0dc3\u0dbb\u0dca\u0dc0\u0dca STN (PVT)L",
    ta: "\u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0bbe\u0bb9\u0bc7\u0ba9\u0bbe \u0b9a\u0bc6\u0ba9\u0bcd. \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b9a\u0bb0\u0bcd\u0bb5\u0bcd STN.(PVT)L",
  },
  "KOTAPOLA MPCS LTD": {
    si: "\u0d9a\u0ddc\u0da7\u0db4\u0ddc\u0dbd MPCS LTD",
    ta: "\u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bbe\u0baa\u0bca\u0bb2 MPCS LTD",
  },
  "KOTTAWA LANKA FILLING STATION": {
    si: "\u0d9a\u0ddc\u0da7\u0dca\u0da7\u0dcf\u0dc0 \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0bbe\u0bb5 \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "KUDAOYA AGENCIES": {
    si: "\u0d9a\u0dd4\u0da9\u0dcf\u0d94\u0dba \u0d92\u0da2\u0db1\u0dca\u0dc3\u0dd2",
    ta: "\u0b95\u0bc1\u0b9f\u0bbe\u0b93\u0baf\u0bbe \u0b8f\u0b9c\u0bc6\u0ba9\u0bcd\u0b9a\u0bbf\u0b95\u0bb3\u0bcd",
  },
  "KULIYAPITIYA DIVISION MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0dd4\u0dbd\u0dd2\u0dba\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0d9a\u0ddc\u0da7\u0dca\u0da8\u0dcf\u0dc3\u0dba MPCS",
    ta: "\u0b95\u0bc1\u0bb3\u0bbf\u0baf\u0bbe\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0baa\u0bbf\u0bb0\u0bbf\u0bb5\u0bc1 MPCS LTD",
  },
  "KUNDASALE MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0dd4\u0dab\u0dca\u0da9\u0dc3\u0dcf\u0dbd\u0dda MPCS",
    ta: "\u0b95\u0bc1\u0ba3\u0bcd\u0b9f\u0b9a\u0bb2\u0bc7 MPCS LTD",
  },
  KURUNEGALA: {
    si: "\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd",
    ta: "\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd",
  },
  "KURUNEGALA MPCS": {
    si: "\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd \u0d91\u0db8\u0dca.\u0db4\u0dd3.\u0dc3\u0dd3.\u0d91\u0dc3\u0dca",
    ta: "\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd \u0b8e\u0bae\u0bcd.\u0baa\u0bbf.\u0b9a\u0bbf.\u0b8e\u0bb8\u0bcd",
  },
  "KURUNEGALA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd MPCS",
    ta: "\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd MPCS LTD",
  },
  "KURUWITA MPCS LTD": {
    si: "\u0d9a\u0dd4\u0dbb\u0dd4\u0dc0\u0dd2\u0da7 MPCS LTD",
    ta: "\u0b95\u0bc1\u0bb0\u0bc1\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "Kachcheri Rd, Hambantota": {
    si: "\u0d9a\u0da0\u0dca\u0da0\u0dda\u0dbb\u0dd2 \u0db4\u0dcf\u0dbb, \u0dc4\u0db8\u0dca\u0db6\u0db1\u0dca\u0dad\u0ddc\u0da7",
    ta: "\u0b95\u0b9a\u0bcd\u0b9a\u0bc7\u0bb0\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8",
  },
  Kadahapola: {
    si: "\u0d9a\u0da9\u0dc4\u0db4\u0ddc\u0dbd",
    ta: "\u0b95\u0b9f\u0bb9\u0baa\u0bca\u0bb2",
  },
  "Kadahapola - Rambawewa Rd, Katupotha": {
    si: "\u0d9a\u0da9\u0dc4\u0db4\u0ddc\u0dbd - \u0dbb\u0db9\u0dc0\u0dd0\u0dc0 \u0db4\u0dcf\u0dbb, \u0d9a\u0da7\u0dd4\u0db4\u0ddc\u0dad",
    ta: "\u0b95\u0b9f\u0bb9\u0baa\u0bca\u0bb2 - \u0bb0\u0bae\u0bcd\u0baa\u0bb5\u0bc6\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0baa\u0bca\u0ba4",
  },
  "Kadawalagedara - Witikuliya Road Kobeigane": {
    si: "\u0d9a\u0da9\u0dc0\u0dbd\u0d9c\u0dd9\u0daf\u0dbb - \u0dc0\u0dd2\u0da7\u0d9a\u0dd4\u0dbd\u0dd2\u0dba \u0db4\u0dcf\u0dbb \u0d9a\u0ddc\u0db6\u0dd9\u0dba\u0dd2\u0d9c\u0db1\u0dda",
    ta: "\u0b95\u0b9f\u0bb5\u0bb2\u0b95\u0bc6\u0ba4\u0bb0 - \u0bb5\u0bbf\u0b9f\u0bbf\u0b95\u0bc1\u0bb2\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf \u0b95\u0bca\u0baa\u0bc7\u0b95\u0ba9\u0bc7",
  },
  "Kadawalagedara-Vitikuliya Rd, Sri Lanka": {
    si: "\u0d9a\u0da9\u0dc0\u0dbd\u0d9c\u0dd9\u0daf\u0dbb-\u0dc0\u0dd2\u0da7\u0dd2\u0d9a\u0dd4\u0dbd\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b95\u0b9f\u0bb5\u0bb2\u0b95\u0bc6\u0ba4\u0bb0-\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bc1\u0bb2\u0bbf\u0baf\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Kadawatha: {
    si: "\u0d9a\u0da9\u0dc0\u0dad",
    ta: "\u0b95\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4",
  },
  "Kadawatha - Ganemulla Rd": {
    si: "\u0d9a\u0da9\u0dc0\u0dad - \u0d9c\u0dab\u0dda\u0db8\u0dd4\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb",
    ta: "\u0b95\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8 - \u0b95\u0ba3\u0bc7\u0bae\u0bc1\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  Kaduwela: {
    si: "\u0d9a\u0da9\u0dd4\u0dc0\u0dd9\u0dbd",
    ta: "\u0b95\u0b9f\u0bc1\u0bb5\u0bc6\u0bb2",
  },
  "Kaduwela Rd, Battaramulla": {
    si: "\u0d9a\u0da9\u0dd4\u0dc0\u0dd9\u0dbd \u0db4\u0dcf\u0dbb, \u0db6\u0dad\u0dca\u0dad\u0dbb\u0db8\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0b9f\u0bc1\u0bb5\u0bc6\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0ba4\u0bcd\u0ba4\u0bb0\u0bae\u0bc1\u0bb2\u0bcd\u0bb2",
  },
  "Kahawa - Batapola Rd, Batapola": {
    si: "\u0d9a\u0dc4\u0dc0 - \u0db6\u0da7\u0db4\u0ddc\u0dbd \u0db4\u0dcf\u0dbb, \u0db6\u0da7\u0db4\u0ddc\u0dbd",
    ta: "\u0b95\u0bb9\u0bbe\u0bb5 - \u0baa\u0b9f\u0baa\u0bca\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0b9f\u0baa\u0bca\u0bb2",
  },
  Kahawatta: {
    si: "\u0d9a\u0dc4\u0dc0\u0dad\u0dca\u0dad",
    ta: "\u0b95\u0bb9\u0bb5\u0ba4\u0bcd\u0ba4",
  },
  Kaithady: {
    si: "\u0d9a\u0dba\u0dd2\u0dad\u0da9\u0dd2",
    ta: "\u0b95\u0bc8\u0ba4\u0b9f\u0bbf",
  },
  Kakkapalliya: {
    si: "\u0d9a\u0dcf\u0d9a\u0dca\u0d9a\u0db4\u0dbd\u0dca\u0dbd\u0dd2\u0dba",
    ta: "\u0b95\u0bbe\u0b95\u0bcd\u0b95\u0baa\u0bcd\u0baa\u0bb3\u0bcd\u0bb3\u0bbf\u0baf\u0bbe",
  },
  "Kalagedihena, Thihariya": {
    si: "\u0d9a\u0dbd\u0d9c\u0dd9\u0da9\u0dd2\u0dc4\u0dda\u0db1, \u0dad\u0dd2\u0dc4\u0dcf\u0dbb\u0dd2\u0dba",
    ta: "\u0b95\u0bb2\u0b95\u0bc6\u0b9f\u0bbf\u0bb9\u0bc7\u0ba9, \u0ba4\u0bbf\u0bb9\u0bbe\u0bb0\u0bbf\u0baf",
  },
  Kalametiya: {
    si: "\u0d9a\u0dbd\u0db8\u0dd0\u0da7\u0dd2\u0dba",
    ta: "\u0b95\u0bb2\u0bae\u0bc7\u0ba4\u0bbf\u0baf\u0bbe",
  },
  Kalawana: {
    si: "\u0d9a\u0dbd\u0dc0\u0dcf\u0db1",
    ta: "\u0b95\u0bb2\u0bb5\u0bbe\u0ba9\u0bbe",
  },
  Kalawanchikudy: {
    si: "\u0d9a\u0dbd\u0dc0\u0d82\u0da0\u0dd2\u0d9a\u0dd4\u0da9\u0dd2",
    ta: "\u0b95\u0bb2\u0bb5\u0bbe\u0b9e\u0bcd\u0b9a\u0bbf\u0b95\u0bc1\u0b9f\u0bbf",
  },
  "Kaleliya - Medagampitiya Rd, Pallewela": {
    si: "\u0d9a\u0dbd\u0dca\u0d91\u0dc5\u0dd2\u0dba - \u0db8\u0dd0\u0daf\u0d9c\u0db8\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db4\u0dbd\u0dca\u0dbd\u0dd9\u0dc0\u0dd9\u0dbd",
    ta: "\u0b95\u0bb2\u0bc7\u0bb2\u0bbf\u0baf - \u0bae\u0bc6\u0ba4\u0b95\u0bae\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bb2\u0bcd\u0bb2\u0bc7\u0bb5\u0bc6\u0bb2",
  },
  "Kalmunai-chavalakadai Rd, Kalmunai": {
    si: "\u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda-\u0da0\u0dc0\u0dbd\u0d9a\u0da9\u0dba\u0dd2 \u0db4\u0dcf\u0dbb, \u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda",
    ta: "\u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8 - \u0b9a\u0bb5\u0bb3\u0b95\u0bcd\u0b95\u0b9f\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8",
  },
  "Kalmunaikudy - 14": {
    si: "\u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0db1\u0dda\u0d9a\u0dd4\u0da9\u0dd2 - 14",
    ta: "\u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8\u0b95\u0bcd\u0b95\u0bc1\u0b9f\u0bbf - 14",
  },
  Kalpitiya: {
    si: "\u0d9a\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0b95\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf",
  },
  "Kalpitiya Road - Mampuriya": {
    si: "\u0d9a\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb - \u0db8\u0dcf\u0db8\u0dca\u0db4\u0dd4\u0dbb\u0dd2\u0dba",
    ta: "\u0b95\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf - \u0bae\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bbf\u0baf",
  },
  Kalthota: {
    si: "\u0d9a\u0dbd\u0dca\u0dad\u0ddc\u0da7",
    ta: "\u0b95\u0bb2\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8",
  },
  Kalubowila: {
    si: "\u0d9a\u0dc5\u0dd4\u0db6\u0ddd\u0dc0\u0dd2\u0dbd",
    ta: "\u0b95\u0bb3\u0bc1\u0baa\u0bcb\u0bb5\u0bbf\u0bb2",
  },
  "Kalugamuwa Junction, Kalugamuwa": {
    si: "\u0d9a\u0dc5\u0dd4\u0d9c\u0db8\u0dd4\u0dc0 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0d9a\u0dc5\u0dd4\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0b95\u0bb3\u0bc1\u0b95\u0bae\u0bc1\u0bb5 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0b95\u0bb3\u0bc1\u0b95\u0bae\u0bc1\u0bb5",
  },
  "Kalutara South, Kalutara": {
    si: "\u0d9a\u0dc5\u0dd4\u0dad\u0dbb \u0daf\u0d9a\u0dd4\u0dab, \u0d9a\u0dc5\u0dd4\u0dad\u0dbb",
    ta: "\u0b95\u0bb3\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8 \u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1, \u0b95\u0bb3\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  "Kalutara-matugama Rd, Kalawana": {
    si: "\u0d9a\u0dc5\u0dd4\u0dad\u0dbb-\u0db8\u0dad\u0dd4\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0d9a\u0dbd\u0dc0\u0dcf\u0db1",
    ta: "\u0b95\u0bb3\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8-\u0bae\u0ba4\u0bc1\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb2\u0bb5\u0bbe\u0ba9",
  },
  Kaluwankarni: {
    si: "\u0d9a\u0dbd\u0dd4\u0dc0\u0d82\u0d9a\u0dbb\u0dca\u0db1\u0dd2",
    ta: "\u0b95\u0bb3\u0bc1\u0bb5\u0ba9\u0bcd\u0b95\u0bb0\u0bcd\u0ba3\u0bbf",
  },
  Kaluwella: {
    si: "\u0d9a\u0dbd\u0dd4\u0dc0\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0bb3\u0bc1\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2",
  },
  "Kamachchode, Negombo": {
    si: "\u0d9a\u0dcf\u0db8\u0da0\u0dca\u0da0\u0ddd\u0da9\u0dda, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0b95\u0bbe\u0bae\u0b9a\u0bcd\u0b9a\u0bcb\u0b9f\u0bc1, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "Kamburapola - Gommugomuwa Rd Kamburupola": {
    si: "\u0d9a\u0db9\u0dd4\u0dbb\u0db4\u0ddc\u0dbd - \u0d9c\u0ddc\u0db8\u0dca\u0db8\u0dd4\u0d9c\u0ddc\u0db8\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb \u0d9a\u0db9\u0dd4\u0dbb\u0dd4\u0db4\u0ddc\u0dbd",
    ta: "\u0b95\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0baa\u0bca\u0bb2 - \u0b95\u0bca\u0bae\u0bcd\u0bae\u0bc1\u0b95\u0bca\u0bae\u0bc1\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf \u0b95\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bc1\u0baa\u0bca\u0bb2",
  },
  Kamburugamuwa: {
    si: "Kamburugamuwa",
    ta: "Kamburugamuwa",
  },
  Kammandaluwa: {
    si: "\u0d9a\u0db8\u0dca\u0db8\u0db1\u0dca\u0daf\u0dc5\u0dd4\u0dc0",
    ta: "\u0b95\u0bae\u0bcd\u0bae\u0ba3\u0bcd\u0b9f\u0bb2\u0bc1\u0bb5",
  },
  Kanagarayamkulam: {
    si: "\u0d9a\u0db1\u0d9c\u0dbb\u0dcf\u0dba\u0db8\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca",
    ta: "\u0b95\u0ba9\u0b95\u0bb0\u0bbe\u0baf\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd",
  },
  "Kandaketiya - Loggaloya Junction": {
    si: "\u0d9a\u0db1\u0dca\u0daf\u0d9a\u0dd0\u0da7\u0dd2\u0dba - \u0dbd\u0ddc\u0d9c\u0dca\u0d9c\u0dbd\u0dca\u0d94\u0dba \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba",
    ta: "\u0b95\u0ba8\u0bcd\u0ba4\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf - \u0bb2\u0bca\u0b95\u0bcd\u0b95\u0bb2\u0bcb\u0baf\u0bbe \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf",
  },
  Kandakudah: {
    si: "\u0d9a\u0db1\u0dca\u0daf\u0d9a\u0dd4\u0da9\u0dcf",
    ta: "\u0b95\u0ba8\u0bcd\u0ba4\u0b95\u0bc1\u0b9f\u0bbe",
  },
  "Kandakuliya,Kalpitiya": {
    si: "\u0d9a\u0db1\u0dca\u0daf\u0d9a\u0dd4\u0dbd\u0dd2\u0dba, \u0d9a\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0b95\u0ba8\u0bcd\u0ba4\u0b95\u0bc1\u0bb2\u0bbf\u0baf, \u0b95\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Kandambi Fuel Station, Matara - Hakmana Rd, Kamburupitiya": {
    si: "\u0d9a\u0dab\u0dca\u0da9\u0db8\u0dca\u0db6\u0dd2 \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db8\u0dcf\u0dad\u0dbb - \u0dc4\u0d9a\u0dca\u0db8\u0db1 \u0db4\u0dcf\u0dbb, \u0d9a\u0db9\u0dd4\u0dbb\u0dd4\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bae\u0bcd\u0baa\u0bbf \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8 - \u0bb9\u0b95\u0bcd\u0bae\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bc1\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  Kandanagedera: {
    si: "\u0d9a\u0db3\u0db1\u0d9c\u0dd9\u0daf\u0dbb",
    ta: "\u0b95\u0ba8\u0bcd\u0ba4\u0ba9\u0b95\u0bc6\u0ba4\u0bc6\u0bb0",
  },
  Kandapola: {
    si: "\u0d9a\u0db3\u0db4\u0ddc\u0dbd",
    ta: "\u0b95\u0ba8\u0bcd\u0ba4\u0baa\u0bca\u0bb2",
  },
  "Kandapola Bus Stand, Kandapola, Sri Lanka": {
    si: "\u0d9a\u0db3\u0db4\u0ddc\u0dbd \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0d9a\u0db3\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b95\u0ba8\u0bcd\u0ba4\u0baa\u0bca\u0bb2 \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0ba8\u0bcd\u0ba4\u0baa\u0bca\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Kandasuridugama Raja Mawatha, Kataragama": {
    si: "\u0d9a\u0db3\u0dc3\u0dd4\u0dbb\u0dd2\u0daf\u0dd4\u0d9c\u0db8 \u0dbb\u0da2 \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0dad\u0dbb\u0d9c\u0db8",
    ta: "\u0b95\u0ba8\u0bcd\u0ba4\u0b9a\u0bc1\u0bb0\u0bbf\u0b9f\u0bc1\u0b95\u0bae \u0bb0\u0bbe\u0b9c\u0bbe \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0ba4\u0bbf\u0bb0\u0bcd\u0b95\u0bbe\u0bae\u0bae\u0bcd",
  },
  Kandy: {
    si: "\u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf",
  },
  "Kandy - Jaffna Highway, Matale": {
    si: "\u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb - \u0dba\u0dcf\u0db4\u0db1\u0dba \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0db8\u0dcf\u0dad\u0dbd\u0dda",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf - \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8",
  },
  "Kandy - Jaffna Hwy, Matale": {
    si: "\u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb - \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0db8\u0dcf\u0dad\u0dbd\u0dda",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf - \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8",
  },
  "Kandy - Jaffna Hwy, Medawachchiya": {
    si: "\u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb - \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0db8\u0dd0\u0daf\u0dc0\u0da0\u0dca\u0da0\u0dd2\u0dba",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf - \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd \u0bb9\u0bc6\u0bb5\u0bbf, \u0bae\u0ba4\u0bb5\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf",
  },
  "Kandy - Mahiyangane - Padiyatalawa Highway, Karalliyadda": {
    si: "\u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb - \u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1\u0dda - \u0db4\u0daf\u0dd2\u0dba\u0dad\u0dbd\u0dcf\u0dc0 \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0d9a\u0dbb\u0dbd\u0dca\u0dbd\u0dd2\u0dba\u0daf\u0dca\u0daf",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf - \u0bae\u0bb9\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0ba9\u0bc8 - \u0baa\u0ba4\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe\u0bb5 \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bb0\u0bb2\u0bcd\u0bb2\u0bbf\u0baf\u0ba4\u0bcd\u0ba4",
  },
  "Kandy Rd, Chavakachcheri": {
    si: "\u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0da0\u0dcf\u0dc0\u0d9a\u0da0\u0dca\u0da0\u0dda\u0dbb\u0dd2",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b9a\u0bbe\u0bb5\u0b95\u0b9a\u0bcd\u0b9a\u0bc7\u0bb0\u0bbf",
  },
  "Kandy Rd, Dambulla": {
    si: "\u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8",
  },
  "Kandy Rd, Kajugama": {
    si: "\u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0da2\u0dd4\u0d9c\u0db8",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0b9c\u0bc1\u0b95\u0bae",
  },
  "Kandy Rd, Kekirawa": {
    si: "\u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0dd0\u0d9a\u0dd2\u0dbb\u0dcf\u0dc0",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bc6\u0b95\u0bcd\u0b95\u0bbf\u0bb0\u0bbe\u0bb5",
  },
  "Kandy Rd, Maradankadawala": {
    si: "\u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0db8\u0dbb\u0daf\u0db1\u0dca\u0d9a\u0da9\u0dc0\u0dbd",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bb0\u0ba4\u0ba9\u0bcd\u0b95\u0b9f\u0bb5\u0bb2",
  },
  "Kandy Rd, Nawalapitiya": {
    si: "\u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0db1\u0dcf\u0dc0\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bbe\u0bb5\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf",
  },
  "Kandy Rd, Pachchilapalli": {
    si: "\u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0db4\u0da0\u0dca\u0da0\u0dd2\u0dbd\u0db4\u0dbd\u0dca\u0dbd\u0dd2",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0baa\u0b9a\u0bcd\u0b9a\u0bbf\u0bb2\u0baa\u0bcd\u0baa\u0bb3\u0bcd\u0bb3\u0bbf",
  },
  "Kandy Rd, Pasyala": {
    si: "\u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0db4\u0dc3\u0dca\u0dba\u0dcf\u0dbd",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0baa\u0bb8\u0bcd\u0baf\u0bbe\u0bb2",
  },
  "Kandy Road Gampola": {
    si: "\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb \u0d9c\u0db8\u0dca\u0db4\u0ddc\u0dbd",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf \u0b95\u0bae\u0bcd\u0baa\u0bb3\u0bc8",
  },
  "Kandy Road, Trincomalee": {
    si: "\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8",
  },
  "Kandy Road, Warakapola": {
    si: "\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dc0\u0dbb\u0d9a\u0dcf\u0db4\u0ddc\u0dbd",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bb0\u0b95\u0bcd\u0b95\u0bbe\u0baa\u0bca\u0bb2",
  },
  "Kandy Road, Weddamulla, Kelaniya": {
    si: "\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dc0\u0dd0\u0daf\u0dca\u0daf\u0db8\u0dd4\u0dbd\u0dca\u0dbd, \u0d9a\u0dd0\u0dbd\u0dab\u0dd2\u0dba",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bc6\u0ba4\u0bcd\u0ba4\u0bae\u0bc1\u0bb2\u0bcd\u0bb2, \u0b95\u0bb3\u0ba9\u0bbf",
  },
  "Kandy-jaffna Highway, Mandandawela": {
    si: "\u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb-\u0dba\u0dcf\u0db4\u0db1\u0dba \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0db8\u0dab\u0dca\u0da9\u0db3\u0dc0\u0dd9\u0dbd",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf-\u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0ba3\u0bcd\u0b9f\u0bbe\u0bb5\u0bc6\u0bb2",
  },
  "Kandy-mahiyangane-padiyatalawa Hwy, Hunnasgiriya": {
    si: "\u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb-\u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1\u0dda-\u0db4\u0daf\u0dd2\u0dba\u0dad\u0dbd\u0dcf\u0dc0 Hwy, \u0dc4\u0dd4\u0db1\u0dca\u0db1\u0dc3\u0dca\u0d9c\u0dd2\u0dbb\u0dd2\u0dba",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf-\u0bae\u0bb9\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0ba9\u0bc7-\u0baa\u0ba4\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe\u0bb5 Hwy, \u0bb9\u0bc1\u0ba9\u0bcd\u0ba9\u0bb8\u0bcd\u0b95\u0bbf\u0bb0\u0bbf\u0baf",
  },
  "Kandy-mahiyangane-padiyatalawa Hwy, Udadumbara": {
    si: "\u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb-\u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1\u0dda-\u0db4\u0daf\u0dd2\u0dba\u0dad\u0dbd\u0dcf\u0dc0 Hwy, \u0d8b\u0da9\u0daf\u0dd4\u0db8\u0dca\u0db6\u0dbb",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf-\u0bae\u0bb9\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0ba9\u0bc7-\u0baa\u0ba4\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe\u0bb5 Hwy, \u0b89\u0b9f\u0ba4\u0bc1\u0bae\u0bcd\u0baa\u0bb0",
  },
  "Kandy-mahiyangane-padiyatalawa Hwy, Udathenna": {
    si: "\u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb-\u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1\u0dda-\u0db4\u0daf\u0dd2\u0dba\u0dad\u0dbd\u0dcf\u0dc0 Hwy, \u0d8b\u0da9\u0dad\u0dd0\u0db1\u0dca\u0db1",
    ta: "\u0b95\u0ba3\u0bcd\u0b9f\u0bbf-\u0bae\u0bb9\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0ba9\u0bc7-\u0baa\u0ba4\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe\u0bb5 Hwy, \u0b89\u0b9f\u0ba4\u0bc6\u0ba9\u0bcd\u0ba9",
  },
  Kantale: {
    si: "\u0d9a\u0db1\u0dca\u0dad\u0dbd\u0dda",
    ta: "\u0b95\u0ba8\u0bcd\u0ba4\u0bb3\u0bc7",
  },
  "Kapuwatha,, 3V7V+X6H, Ja-Ela, Sri Lanka": {
    si: "\u0d9a\u0db4\u0dd4\u0dc0\u0dad,, 3V7V+X6H, \u0da2\u0dcf-\u0d87\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b95\u0baa\u0bc1\u0bb5\u0ba4\u0bcd\u0ba4,, 3V7V+X6H, \u0b9c\u0bbe-\u0b8e\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Karadippokku, Kilinochchi, Sri Lanka": {
    si: "\u0d9a\u0dbb\u0da9\u0dd2\u0db4\u0ddc\u0d9a\u0dca\u0d9a\u0dd4, \u0d9a\u0dd2\u0dbd\u0dd2\u0db1\u0ddc\u0da0\u0dca\u0da0\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b95\u0bb0\u0b9f\u0bbf\u0baa\u0bcd\u0baa\u0bcb\u0b95\u0bcd\u0b95\u0bc1, \u0b95\u0bbf\u0bb3\u0bbf\u0ba8\u0bca\u0b9a\u0bcd\u0b9a\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Karainagar Circular Rd": {
    si: "\u0d9a\u0dbb\u0dd9\u0dba\u0dd2\u0db1\u0d9c\u0dbb\u0dca \u0da0\u0d9a\u0dca\u200d\u0dbb\u0dbd\u0dda\u0d9b \u0db4\u0dcf\u0dbb",
    ta: "\u0b95\u0bbe\u0bb0\u0bc8\u0ba8\u0b95\u0bb0\u0bcd \u0b9a\u0bc1\u0bb1\u0bcd\u0bb1\u0bb1\u0bbf\u0b95\u0bcd\u0b95\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  Karaitivu: {
    si: "\u0d9a\u0dbb\u0dd9\u0dba\u0dd2\u0dad\u0dd2\u0dc0\u0dca",
    ta: "\u0b95\u0bbe\u0bb0\u0bc8\u0ba4\u0bc0\u0bb5\u0bc1",
  },
  "Karandupona - Kegalle": {
    si: "\u0d9a\u0dbb\u0dac\u0dd4\u0db4\u0ddc\u0db1 - \u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0bb0\u0ba3\u0bcd\u0b9f\u0bc1\u0baa\u0bca\u0ba9 - \u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8",
  },
  "Karativu - Ampara Hwy, Sammanthurai": {
    si: "\u0d9a\u0dbb\u0dad\u0dd2\u0dc0\u0dca - \u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb Hwy, \u0dc3\u0db8\u0dca\u0db8\u0db1\u0dca\u0dad\u0dd4\u0dbb\u0dda",
    ta: "\u0b95\u0bbe\u0bb0\u0bc8\u0ba4\u0bc0\u0bb5\u0bc1 - \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8 Hwy, \u0b9a\u0bae\u0bcd\u0bae\u0bbe\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  "Karaveddy, Manmunai West": {
    si: "\u0d9a\u0dbb\u0dc0\u0dd9\u0da9\u0dca\u0da9\u0dd2, \u0db8\u0db1\u0dca\u0db8\u0dd4\u0db1\u0dda \u0db6\u0da7\u0dc4\u0dd2\u0dbb",
    ta: "\u0b95\u0bb0\u0bb5\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf, \u0bae\u0ba3\u0bcd\u0bae\u0bc1\u0ba9\u0bc8 \u0bae\u0bc7\u0bb1\u0bcd\u0b95\u0bc1",
  },
  "Karukupone Rd, Bangadeniya": {
    si: "\u0d9a\u0dbb\u0dd4\u0d9a\u0dd4\u0db4\u0ddc\u0db1\u0dca \u0db4\u0dcf\u0dbb, \u0db6\u0d82\u0d9c\u0daf\u0dd9\u0dab\u0dd2\u0dba",
    ta: "\u0b95\u0bb0\u0bc1\u0b95\u0bcd\u0b95\u0bc1\u0baa\u0bca\u0ba9\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0b99\u0bcd\u0b95\u0ba4\u0bc6\u0ba9\u0bbf\u0baf",
  },
  "Karuwalagaswewa, Karuwalagaswewa, Sri Lanka": {
    si: "\u0d9a\u0dbb\u0dd4\u0dc0\u0dbd\u0d9c\u0dc3\u0dca\u0dc0\u0dd0\u0dc0, \u0d9a\u0dbb\u0dd4\u0dc0\u0dbd\u0d9c\u0dc3\u0dca\u0dc0\u0dd0\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b95\u0bb0\u0bc1\u0bb5\u0bb2\u0b95\u0bb8\u0bcd\u0bb5\u0bc6\u0bb5, \u0b95\u0bb0\u0bc1\u0bb5\u0bb2\u0b95\u0bb8\u0bcd\u0bb5\u0bc6\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Kasthuriyar Rd, Jaffna": {
    si: "\u0d9a\u0dc3\u0dca\u0dad\u0dd4\u0dbb\u0dd2\u0dba\u0dbb\u0dca \u0db4\u0dcf\u0dbb, \u0dba\u0dcf\u0db4\u0db1\u0dba",
    ta: "\u0b95\u0bb8\u0bcd\u0ba4\u0bc2\u0bb0\u0bbf\u0baf\u0bbe\u0bb0\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd",
  },
  Katana: {
    si: "\u0d9a\u0da7\u0dcf\u0db1",
    ta: "\u0b95\u0b9f\u0bcd\u0b9f\u0bbe\u0ba9\u0bbe",
  },
  "Katana Rd,madampella": {
    si: "\u0d9a\u0da7\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0db8\u0da9\u0db8\u0dca\u0db4\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0b9f\u0bcd\u0b9f\u0bbe\u0ba9\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0b9f\u0bae\u0bcd\u0baa\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe",
  },
  Kaththnkudy: {
    si: "\u0d9a\u0dcf\u0dad\u0dca\u0db1\u0dca\u0d9a\u0dd4\u0da9\u0dd2",
    ta: "\u0b95\u0bbe\u0ba4\u0bcd\u0ba4\u0bbe\u0ba9\u0bcd\u0b95\u0bc1\u0b9f\u0bbf",
  },
  Kattankudi: {
    si: "\u0d9a\u0dcf\u0dad\u0dca\u0dad\u0db1\u0dca\u0d9a\u0dd4\u0da9\u0dd2",
    ta: "\u0b95\u0bbe\u0ba4\u0bcd\u0ba4\u0bbe\u0ba9\u0bcd\u0b95\u0bc1\u0b9f\u0bbf",
  },
  "Katugastota - Kurunegala - Puttalam Highway, Mawathagama": {
    si: "\u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0db8\u0dcf\u0dc0\u0dad\u0d9c\u0db8",
    ta: "\u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0b95\u0bae",
  },
  "Katugastota - Kurunegala - Puttalam Hwy, Kurunegala": {
    si: "\u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 Hwy, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd",
    ta: "\u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd Hwy, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd",
  },
  "Katugastota - Kurunegala - Puttalam Hwy, Padeniya": {
    si: "\u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 Hwy, \u0db4\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba",
    ta: "\u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd Hwy, Padeniya",
  },
  "Katugastota - Kurunegala - Puttalam Hwy, Wariyapola": {
    si: "\u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 Hwy, \u0dc0\u0dcf\u0dbb\u0dd2\u0dba\u0db4\u0ddc\u0dbd",
    ta: "\u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd Hwy, \u0bb5\u0bbe\u0bb0\u0bbf\u0baf\u0baa\u0bca\u0bb2",
  },
  "Katugastota - Madawala - Bambarella Road, Panwila": {
    si: "\u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7 - \u0db8\u0da9\u0dc0\u0dbd - \u0db6\u0db9\u0dbb\u0dd0\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db4\u0db1\u0dca\u0dc0\u0dd2\u0dbd",
    ta: "\u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 - \u0bae\u0b9f\u0bb5\u0bb3\u0bc8 - \u0baa\u0bae\u0bcd\u0baa\u0bb0\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0ba9\u0bcd\u0bb5\u0bbf\u0bb2",
  },
  "Katugastota Rd, Kandy": {
    si: "\u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7 \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb",
    ta: "\u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf",
  },
  "Katugastota-kurunegala - Puttalam Highway, Hedeniya": {
    si: "\u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7-\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0dc4\u0dd0\u0daf\u0dd9\u0dab\u0dd2\u0dba",
    ta: "\u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0bb9\u0bc6\u0ba4\u0bc6\u0ba9\u0bbf\u0baf",
  },
  "Katugastota-kurunegala-puttalam Hwy, Katugastota": {
    si: "\u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7-\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd-\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 Hwy, \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7",
    ta: "Katugastota-kurunegala-puttalam Hwy, Katugastota",
  },
  "Katugastota-kurunegala-puttalam Hwy, Paragahadeniya": {
    si: "\u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7-\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd-\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 Hwy, \u0db4\u0dbb\u0d9c\u0dc4\u0daf\u0dd9\u0dab\u0dd2\u0dba",
    ta: "\u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f-\u0b95\u0bc1\u0bb0\u0bc1\u0ba3\u0bbe\u0b95\u0bb2-\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd Hwy, \u0baa\u0bb0\u0b95\u0bb9\u0ba4\u0bc6\u0ba9\u0bbf\u0baf",
  },
  "Katukele, Kandy": {
    si: "\u0d9a\u0da7\u0dd4\u0d9a\u0dd0\u0dbd\u0dda, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb",
    ta: "\u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0b95\u0bc6\u0bb2\u0bc7, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf",
  },
  "Katukurunda Lanka Filing Station, A2, Kalutara": {
    si: "\u0d9a\u0da7\u0dd4\u0d9a\u0dd4\u0dbb\u0dd4\u0db1\u0dca\u0daf \u0dbd\u0d82\u0d9a\u0dcf \u0d9c\u0ddc\u0db1\u0dd4 \u0d9a\u0dd2\u0dbb\u0dd3\u0db8\u0dda \u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba, A2, \u0d9a\u0dc5\u0dd4\u0dad\u0dbb",
    ta: "\u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4 \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba4\u0bbe\u0b95\u0bcd\u0b95\u0bb2\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, A2, \u0b95\u0bb3\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  Katunayake: {
    si: "\u0d9a\u0da7\u0dd4\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95\u0bbe",
  },
  "Katunayake, Negombo, Sri Lanka": {
    si: "\u0d9a\u0da7\u0dd4\u0db1\u0dcf\u0dba\u0d9a, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95\u0bbe, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Katunayake-veyangoda Rd": {
    si: "\u0d9a\u0da7\u0dd4\u0db1\u0dcf\u0dba\u0d9a - \u0dc0\u0dda\u0dba\u0db1\u0dca\u0d9c\u0ddc\u0da9 \u0db4\u0dcf\u0dbb",
    ta: "\u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95-\u0bb5\u0bc7\u0baf\u0b99\u0bcd\u0b95\u0bca\u0b9f \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  Katuwana: {
    si: "\u0d9a\u0da7\u0dd4\u0dc0\u0db1",
    ta: "\u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0ba9",
  },
  Kayts: {
    si: "\u0d9a\u0dba\u0dd2\u0da7\u0dca\u0dc3\u0dca",
    ta: "\u0b8a\u0bb0\u0bcd\u0b95\u0bbe\u0bb5\u0bb1\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  Kebitigollewa: {
    si: "\u0d9a\u0dd0\u0db6\u0dd2\u0da7\u0dd2\u0d9c\u0ddc\u0dbd\u0dca\u0dbd\u0dd1\u0dc0",
    ta: "\u0b95\u0bc6\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bca\u0bb2\u0bcd\u0bb2\u0bc7\u0bb5",
  },
  Keertibandarapura: {
    si: "\u0d9a\u0dd3\u0dbb\u0dca\u0dad\u0dd2\u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0db4\u0dd4\u0dbb",
    ta: "\u0b95\u0bc0\u0bb0\u0bcd\u0ba4\u0bcd\u0ba4\u0bbf\u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0baa\u0bc1\u0bb0",
  },
  Kegalle: {
    si: "\u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8",
  },
  "Kegalle Bypass Rd, Kegalle": {
    si: "\u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd \u0db6\u0dba\u0dd2\u0db4\u0dcf\u0dc3\u0dca \u0db4\u0dcf\u0dbb, \u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8 \u0baa\u0bc8\u0baa\u0bbe\u0bb8\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8",
  },
  "Kegalle Junction, Rambukkana - Katupitiya Rd, Rambukkana": {
    si: "\u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0dbb\u0db9\u0dd4\u0d9a\u0dca\u0d9a\u0db1 - \u0d9a\u0da7\u0dd4\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0dbb\u0db9\u0dd4\u0d9a\u0dca\u0d9a\u0db1",
    ta: "\u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0bb0\u0bae\u0bcd\u0baa\u0bc1\u0b95\u0bcd\u0b95\u0ba9 - \u0b95\u0b9f\u0bc1\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb0\u0bae\u0bcd\u0baa\u0bc1\u0b95\u0bcd\u0b95\u0ba9",
  },
  Kekirawa: {
    si: "\u0d9a\u0dd0\u0d9a\u0dd2\u0dbb\u0dcf\u0dc0",
    ta: "\u0b95\u0bc6\u0b95\u0bcd\u0b95\u0bbf\u0bb0\u0bbe\u0bb5",
  },
  "Kekirawa - Ganewalpola Rd, Kekirawa": {
    si: "\u0d9a\u0dd0\u0d9a\u0dd2\u0dbb\u0dcf\u0dc0 - \u0d9c\u0db1\u0dda\u0dc0\u0dbd\u0dca\u0db4\u0ddc\u0dbd \u0db4\u0dcf\u0dbb, \u0d9a\u0dd0\u0d9a\u0dd2\u0dbb\u0dcf\u0dc0",
    ta: "\u0b95\u0bc6\u0b95\u0bcd\u0b95\u0bbf\u0bb0\u0bbe\u0bb5 - \u0b95\u0ba3\u0bc7\u0bb5\u0bb2\u0bcd\u0baa\u0bca\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bc6\u0b95\u0bcd\u0b95\u0bbf\u0bb0\u0bbe\u0bb5",
  },
  "Kelaniya - Talwatte": {
    si: "\u0d9a\u0dd0\u0dbd\u0dab\u0dd2\u0dba - \u0dad\u0dbd\u0dca\u0dc0\u0dad\u0dca\u0dad",
    ta: "\u0b95\u0bb3\u0ba9\u0bbf - \u0ba4\u0bb2\u0bcd\u0bb5\u0ba4\u0bcd\u0ba4",
  },
  Kerosene: {
    si: "\u0db7\u0dd6\u0db8\u0dd2\u0dad\u0dd9\u0dbd\u0dca",
    ta: "\u0bae\u0ba3\u0bcd\u0ba3\u0bc6\u0ba3\u0bcd\u0ba3\u0bc6\u0baf\u0bcd",
  },
  "Kesbewa East, Piliyandala": {
    si: "\u0d9a\u0dd0\u0dc3\u0dca\u0db6\u0dd1\u0dc0 \u0db1\u0dd0\u0d9c\u0dd9\u0db1\u0dc4\u0dd2\u0dbb, \u0db4\u0dd2\u0dc5\u0dd2\u0dba\u0db1\u0dca\u0daf\u0dbd",
    ta: "\u0b95\u0bc6\u0bb8\u0bcd\u0baa\u0bc7\u0bb5 \u0b95\u0bbf\u0bb4\u0b95\u0bcd\u0b95\u0bc1, \u0baa\u0bbf\u0bb2\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bb2\u0bc8",
  },
  "Ketawalagedara-wewagama": {
    si: "\u0d9a\u0dd0\u0da7\u0dc0\u0dbd\u0d9c\u0dd9\u0daf\u0dbb-\u0dc0\u0dd0\u0dc0\u0d9c\u0db8",
    ta: "\u0b95\u0bc6\u0b9f\u0bb5\u0bb2\u0b95\u0bc6\u0ba4\u0bb0-\u0bb5\u0bc6\u0bb5\u0b95\u0bae",
  },
  "Keyzer Street, Colombo": {
    si: "\u0d9a\u0dd3\u0dc3\u0dbb\u0dca \u0dc0\u0dd3\u0daf\u0dd2\u0dba, \u0d9a\u0ddc\u0dc5\u0db9",
    ta: "\u0b95\u0bc0\u0b9a\u0bb0\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  Kilinochchi: {
    si: "\u0d9a\u0dd2\u0dbd\u0dd2\u0db1\u0ddc\u0da0\u0dca\u0da0\u0dd2",
    ta: "\u0b95\u0bbf\u0bb3\u0bbf\u0ba8\u0bca\u0b9a\u0bcd\u0b9a\u0bbf",
  },
  "Kimbulapitiya Rd, Kimbulapitiya": {
    si: "\u0d9a\u0dd2\u0db9\u0dd4\u0dbd\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0d9a\u0dd2\u0db9\u0dd4\u0dbd\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0b95\u0bbf\u0bae\u0bcd\u0baa\u0bc1\u0bb2\u0bbe\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bbf\u0bae\u0bcd\u0baa\u0bc1\u0bb2\u0bbe\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "King's Street, Badulla": {
    si: "\u0dbb\u0da2 \u0dc0\u0dd3\u0daf\u0dd2\u0dba, \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0bbf\u0b99\u0bcd\u0bb8\u0bcd \u0bb8\u0bcd\u0b9f\u0bcd\u0bb0\u0bc0\u0b9f\u0bcd, \u0baa\u0ba4\u0bc1\u0bb3\u0bc8",
  },
  Kinniya: {
    si: "\u0d9a\u0dd2\u0db1\u0dca\u0db1\u0dd2\u0dba\u0dcf",
    ta: "\u0b95\u0bbf\u0ba3\u0bcd\u0ba3\u0bbf\u0baf\u0bbe",
  },
  Kirama: {
    si: "\u0d9a\u0dd2\u0dbb\u0db8",
    ta: "\u0b95\u0bbf\u0bb0\u0bae",
  },
  Kiridiwela: {
    si: "\u0d9a\u0dd2\u0dbb\u0dd2\u0daf\u0dd2\u0dc0\u0dd0\u0dbd",
    ta: "\u0b95\u0bbf\u0bb0\u0bbf\u0b9f\u0bbf\u0bb5\u0bc6\u0bb2",
  },
  "Kirillawela - Imbulgoda": {
    si: "\u0d9a\u0dd2\u0dbb\u0dd2\u0dbd\u0dca\u0dbd\u0dc0\u0dd9\u0dbd - \u0d89\u0db9\u0dd4\u0dbd\u0dca\u0d9c\u0ddc\u0da9",
    ta: "\u0b95\u0bbf\u0bb0\u0bbf\u0bb2\u0bcd\u0bb2\u0bb5\u0bc6\u0bb2 - \u0b87\u0bae\u0bcd\u0baa\u0bc1\u0bb2\u0bcd\u0b95\u0bca\u0b9f",
  },
  Kirinda: {
    si: "\u0d9a\u0dd2\u0dbb\u0dd2\u0db1\u0dca\u0daf",
    ta: "\u0b95\u0bbf\u0bb0\u0bbf\u0ba8\u0bcd\u0ba4\u0bbe",
  },
  "Kirinda Road, Ettampitiya": {
    si: "\u0d9a\u0dd2\u0dbb\u0dd2\u0db1\u0dca\u0daf \u0db4\u0dcf\u0dbb, \u0d91\u0da7\u0dca\u0da7\u0db8\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0b95\u0bbf\u0bb0\u0bbf\u0ba8\u0bcd\u0ba4 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b8e\u0b9f\u0bcd\u0b9f\u0bae\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  Kirindiwela: {
    si: "\u0d9a\u0dd2\u0dbb\u0dd2\u0db3\u0dd2\u0dc0\u0dd0\u0dbd",
    ta: "\u0b95\u0bbf\u0bb0\u0bbf\u0ba8\u0bcd\u0ba4\u0bbf\u0bb5\u0bc6\u0bb2",
  },
  "Kirindiwela - Urapola Road, Hanwella": {
    si: "\u0d9a\u0dd2\u0dbb\u0dd2\u0db3\u0dd2\u0dc0\u0dd0\u0dbd - \u0d8c\u0dbb\u0dcf\u0db4\u0ddc\u0dbd \u0db4\u0dcf\u0dbb, \u0dc4\u0d82\u0dc0\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0bbf\u0bb0\u0bbf\u0ba8\u0bcd\u0ba4\u0bbf\u0bb5\u0bc6\u0bb2 - \u0b8a\u0bb0\u0bbe\u0baa\u0bca\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2",
  },
  "Kirulapone, Colombo- 05": {
    si: "\u0d9a\u0dd2\u0dbb\u0dd4\u0dc5\u0db4\u0db1, \u0d9a\u0ddc\u0dc5\u0db9 - 05",
    ta: "\u0b95\u0bbf\u0bb0\u0bc1\u0bb2\u0baa\u0bcd\u0baa\u0ba9\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - 05",
  },
  Kithulgala: {
    si: "\u0d9a\u0dd2\u0dad\u0dd4\u0dbd\u0dca\u0d9c\u0dbd",
    ta: "\u0b95\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb2\u0bcd\u0b95\u0bb2",
  },
  "Kobeigane Bus Station, B167, Kobeigane 60410, Sri Lanka": {
    si: "\u0d9a\u0ddc\u0db6\u0dd9\u0dba\u0dd2\u0d9c\u0db1\u0dda \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8\u0dca\u0db4\u0ddc\u0dc5, \u0db6\u0dd3 167, \u0d9a\u0ddc\u0db6\u0dd9\u0dba\u0dd2\u0d9c\u0db1\u0dda 60410, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b95\u0bca\u0baa\u0bc7\u0b95\u0ba9\u0bc7 \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, B167, \u0b95\u0bca\u0baa\u0bc7\u0b95\u0ba9\u0bc7 60410, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Kobeigane Road, Welpothuwewa": {
    si: "\u0d9a\u0ddc\u0db6\u0dd9\u0dba\u0dd2\u0d9c\u0db1\u0dda \u0db4\u0dcf\u0dbb, \u0dc0\u0dd0\u0dbd\u0dca\u0db4\u0ddc\u0dad\u0dd4\u0dc0\u0dd0\u0dc0",
    ta: "\u0b95\u0bca\u0baa\u0bc7\u0b95\u0ba9\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bc6\u0bb2\u0bcd\u0baa\u0bca\u0ba4\u0bcd\u0ba4\u0bc1\u0bb5\u0bc6\u0bb5",
  },
  Kochchikade: {
    si: "\u0d9a\u0ddc\u0da0\u0dca\u0da0\u0dd2\u0d9a\u0da9\u0dda",
    ta: "\u0b95\u0bca\u0b9a\u0bcd\u0b9a\u0bbf\u0b95\u0bcd\u0b95\u0b9f\u0bc8",
  },
  "Kodikamam, Kandy - Jaffna Hwy": {
    si: "\u0d9a\u0ddc\u0da9\u0dd2\u0d9a\u0dcf\u0db8\u0db8\u0dca, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb - \u0dba\u0dcf\u0db4\u0db1\u0dba Hwy",
    ta: "\u0b95\u0bca\u0b9f\u0bbf\u0b95\u0bbe\u0bae\u0bae\u0bcd, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf - \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd Hwy",
  },
  "Kodikamam, Kandy - Jaffna Hwy, Sri Lanka": {
    si: "\u0d9a\u0ddc\u0da9\u0dd2\u0d9a\u0dcf\u0db8\u0db8\u0dca, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb - \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b95\u0bca\u0b9f\u0bbf\u0b95\u0bbe\u0bae\u0bae\u0bcd, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf - \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Kohuwala Bus Stop, Sri Lanka": {
    si: "\u0d9a\u0ddc\u0dc4\u0dd4\u0dc0\u0dbd \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b95\u0bca\u0bb9\u0bc1\u0bb5\u0bbe\u0bb2\u0bbe \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Kokkaddichcholai: {
    si: "\u0d9a\u0ddc\u0d9a\u0dca\u0d9a\u0da9\u0dd2\u0da0\u0dca\u0da0\u0ddd\u0dbd\u0dda",
    ta: "\u0b95\u0bca\u0b95\u0bcd\u0b95\u0b9f\u0bcd\u0b9f\u0bbf\u0b9a\u0bcd\u0b9a\u0bcb\u0bb2\u0bc8",
  },
  "Kokkaddicholai, Batticaloa": {
    si: "\u0d9a\u0ddc\u0d9a\u0dca\u0d9a\u0da9\u0dd2\u0da0\u0ddd\u0dbd\u0dd9\u0dba\u0dd2, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0",
    ta: "\u0b95\u0bca\u0b95\u0bcd\u0b95\u0b9f\u0bcd\u0b9f\u0bbf\u0b9a\u0bcd\u0b9a\u0bcb\u0bb2\u0bc8, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1",
  },
  Kokkavila: {
    si: "\u0d9a\u0ddc\u0d9a\u0dca\u0d9a\u0dcf\u0dc0\u0dd2\u0dbd",
    ta: "\u0b95\u0bca\u0b95\u0bcd\u0b95\u0bb5\u0bbf\u0bb2",
  },
  Kollonnawa: {
    si: "\u0d9a\u0ddc\u0dbd\u0ddc\u0db1\u0dca\u0db1\u0dcf\u0dc0",
    ta: "\u0b95\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bbe\u0bb5",
  },
  "Kopay Bus Stop, AB20, Sri Lanka": {
    si: "\u0d9a\u0ddd\u0db4\u0dcf\u0dba\u0dd2 \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, AB20, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b95\u0bcb\u0baa\u0bcd\u0baa\u0bbe\u0baf\u0bcd \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0b8f\u0baa\u0bbf20, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Koralawella Rd, Moratuwa": {
    si: "\u0d9a\u0ddc\u0dbb\u0dbd\u0dc0\u0dd0\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0",
    ta: "\u0b95\u0bca\u0bb0\u0bb2\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bca\u0bb0\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5",
  },
  Korasagalla: {
    si: "Korasagalla",
    ta: "Korasagalla",
  },
  "Korasagalla, Sri Lanka": {
    si: "Korasagalla, Sri Lanka",
    ta: "Korasagalla, Sri Lanka",
  },
  Kotadeniyawa: {
    si: "Kotadeniyawa",
    ta: "Kotadeniyawa",
  },
  Kotagala: {
    si: "\u0d9a\u0ddc\u0da7\u0d9c\u0dbd",
    ta: "\u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0b95\u0bb2\u0bc8",
  },
  Kotapola: {
    si: "\u0d9a\u0ddc\u0da7\u0db4\u0ddc\u0dbd",
    ta: "\u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0baa\u0bca\u0bb2",
  },
  "Kothalawala -Kaduwela": {
    si: "\u0d9a\u0ddc\u0dad\u0dbd\u0dcf\u0dc0\u0dbd - \u0d9a\u0da9\u0dd4\u0dc0\u0dd9\u0dbd",
    ta: "\u0b95\u0bca\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe\u0bb5\u0bb2 -\u0b95\u0b9f\u0bc1\u0bb5\u0bc6\u0bb2",
  },
  "Kottawa - Talagala Rd": {
    si: "\u0d9a\u0ddc\u0da7\u0dca\u0da7\u0dcf\u0dc0 - \u0dad\u0dbd\u0d9c\u0dbd \u0db4\u0dcf\u0dbb",
    ta: "\u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0bbe\u0bb5 - \u0ba4\u0bb2\u0b95\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  "Kotte - Bope Rd, Battaramulla": {
    si: "\u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda - \u0db6\u0ddd\u0db4\u0dda \u0db4\u0dcf\u0dbb, \u0db6\u0dad\u0dca\u0dad\u0dbb\u0db8\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7 - \u0baa\u0bcb\u0baa\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0ba4\u0bcd\u0ba4\u0bb0\u0bae\u0bc1\u0bb2\u0bcd\u0bb2",
  },
  "Kotte-Bope Road, New Kandy Rd, Sri Lanka": {
    si: "\u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda-\u0db6\u0ddd\u0db4\u0dda \u0db4\u0dcf\u0dbb, \u0db1\u0dc0 \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Kotte-Bope Road, New Kandy Rd, Sri Lanka",
  },
  Kotugoda: {
    si: "\u0d9a\u0ddc\u0da7\u0dd4\u0d9c\u0ddc\u0da9",
    ta: "\u0b95\u0bca\u0b9f\u0bc1\u0b95\u0bca\u0b9f",
  },
  Kovilakanda: {
    si: "\u0d9a\u0ddd\u0dc0\u0dd2\u0dbd\u0d9a\u0db1\u0dca\u0daf",
    ta: "\u0b95\u0bcb\u0bb5\u0bbf\u0bb2\u0b95\u0ba8\u0bcd\u0ba4",
  },
  "Kovilkulam Junction, Thalankudah, Sri Lanka": {
    si: "\u0d9a\u0ddd\u0dc0\u0dd2\u0dbd\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0dad\u0dcf\u0dbd\u0db1\u0dca\u0d9a\u0dd4\u0da9\u0dcf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b95\u0bcb\u0bb5\u0bbf\u0bb2\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0ba4\u0bbe\u0bb4\u0b99\u0bcd\u0b95\u0bc1\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Kuchchaveli: {
    si: "\u0d9a\u0dd4\u0da0\u0dca\u0da0\u0dc0\u0dda\u0dbd\u0dd2",
    ta: "\u0b95\u0bc1\u0b9a\u0bcd\u0b9a\u0bb5\u0bc6\u0bb3\u0bbf",
  },
  "Kuchchaweli, Kuchchaveli, Sri Lanka": {
    si: "\u0d9a\u0dd4\u0da0\u0dca\u0da0\u0dc0\u0dda\u0dbd\u0dd2, \u0d9a\u0dd4\u0da0\u0dca\u0da0\u0dc0\u0dda\u0dbd\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b95\u0bc1\u0b9a\u0bcd\u0b9a\u0bb5\u0bc6\u0bb3\u0bbf, \u0b95\u0bc1\u0b9a\u0bcd\u0b9a\u0bb5\u0bc6\u0bb3\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Kudawella: {
    si: "\u0d9a\u0dd4\u0da9\u0dcf\u0dc0\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0b95\u0bc1\u0b9f\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2",
  },
  Kukkuvil: {
    si: "\u0d9a\u0dd4\u0d9a\u0dca\u0d9a\u0dd4\u0dc0\u0dd2\u0dbd\u0dca",
    ta: "\u0b95\u0bc1\u0b95\u0bcd\u0b95\u0bc1\u0bb5\u0bbf\u0bb2\u0bcd",
  },
  "Kuliyapitiya Gas Station, Kurunegala - Narammala - Madampe Rd, Kuliyapitiya":
    {
      si: "\u0d9a\u0dd4\u0dbd\u0dd2\u0dba\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd - \u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda \u0db4\u0dcf\u0dbb, \u0d9a\u0dd4\u0dbd\u0dd2\u0dba\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba",
      ta: "\u0b95\u0bc1\u0bb3\u0bbf\u0baf\u0bbe\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0b8e\u0bb0\u0bbf\u0bb5\u0bbe\u0baf\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0ba8\u0bbe\u0bb0\u0bae\u0bcd\u0bae\u0bb2 - \u0bae\u0bbe\u0ba4\u0bae\u0bcd\u0baa\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bc1\u0bb3\u0bbf\u0baf\u0bbe\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
    },
  "Kuliyapitiya Rd, Rambukkana": {
    si: "\u0d9a\u0dd4\u0dbd\u0dd2\u0dba\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0dbb\u0db9\u0dd4\u0d9a\u0dca\u0d9a\u0db1",
    ta: "\u0b95\u0bc1\u0bb3\u0bbf\u0baf\u0bbe\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb0\u0bae\u0bcd\u0baa\u0bc1\u0b95\u0bcd\u0b95\u0ba9",
  },
  Kurichchikadu: {
    si: "\u0d9a\u0dd4\u0dbb\u0dd2\u0da0\u0dca\u0da0\u0dd2\u0d9a\u0dcf\u0da9\u0dd4",
    ta: "\u0b95\u0bc1\u0bb1\u0bbf\u0b9a\u0bcd\u0b9a\u0bbf\u0b95\u0bcd\u0b95\u0bbe\u0b9f\u0bc1",
  },
  "Kuruduwatta Junction Bus Stop, A2, Dondra, Sri Lanka": {
    si: "\u0d9a\u0dd4\u0dbb\u0dd4\u0daf\u0dd4\u0dc0\u0dad\u0dca\u0dad \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, A2, \u0daf\u0dd9\u0dc0\u0dd4\u0db1\u0dca\u0daf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b95\u0bc1\u0bb0\u0bc1\u0b9f\u0bc1\u0bb5\u0ba4\u0bcd\u0ba4 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0baa\u0bcd\u0baa\u0bc1 \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, A2, \u0ba4\u0bca\u0ba9\u0bcd\u0b9f\u0bcd\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Kurukkalmadam: {
    si: "\u0d9a\u0dd4\u0dbb\u0dd4\u0d9a\u0dca\u0d9a\u0dbd\u0dca\u0db8\u0da9\u0db8\u0dca",
    ta: "\u0b95\u0bc1\u0bb0\u0bc1\u0b95\u0bcd\u0b95\u0bb3\u0bcd\u0bae\u0b9f\u0bae\u0bcd",
  },
  "Kurundugahahetkma, Kurundugahahetekma, Sri Lanka": {
    si: "\u0d9a\u0dd4\u0dbb\u0dd4\u0db3\u0dd4\u0d9c\u0dc4\u0dc4\u0dd0\u0dad\u0dd0\u0d9a\u0dca\u0db8, \u0d9a\u0dd4\u0dbb\u0dd4\u0db3\u0dd4\u0d9c\u0dc4\u0dc4\u0dd0\u0dad\u0dd0\u0d9a\u0dca\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1\u0b95\u0bb9\u0bbe\u0bb9\u0bc6\u0b9f\u0bcd\u0b95\u0bcd\u0bae\u0bbe, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1\u0b95\u0bb9\u0bbe\u0bb9\u0bc6\u0b9f\u0bc6\u0b95\u0bcd\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Kurunduwatta, Colombo-07": {
    si: "\u0d9a\u0dd4\u0dbb\u0dd4\u0db3\u0dd4\u0dc0\u0dad\u0dca\u0dad, \u0d9a\u0ddc\u0dc5\u0db9-07",
    ta: "\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1-07",
  },
  Kurunegala: {
    si: "\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd",
    ta: "\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd",
  },
  "Kurunegala - Narammala - Madampe Rd, Madampe": {
    si: "\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd - \u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda \u0db4\u0dcf\u0dbb, \u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda",
    ta: "\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0ba8\u0bbe\u0bb0\u0bae\u0bcd\u0bae\u0bb2 - \u0bae\u0bbe\u0ba4\u0bae\u0bcd\u0baa\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bbe\u0ba4\u0bae\u0bcd\u0baa\u0bc7",
  },
  "Kurunegala - Narammala - Madampe Rd, Narammala": {
    si: "\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd - \u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda \u0db4\u0dcf\u0dbb, \u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd",
    ta: "\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0ba8\u0bbe\u0bb0\u0bae\u0bcd\u0bae\u0bb2 - \u0bae\u0bbe\u0ba4\u0bae\u0bcd\u0baa\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bbe\u0bb0\u0bae\u0bcd\u0bae\u0bb2",
  },
  "Kurunegala - Puttalam Rd, Nikaweratiya": {
    si: "\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 \u0db4\u0dcf\u0dbb, \u0db1\u0dd2\u0d9a\u0dc0\u0dd0\u0dbb\u0da7\u0dd2\u0dba",
    ta: "\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bbf\u0b95\u0bcd\u0b95\u0bb5\u0bc6\u0bb0\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Kurunegala Rd, Yatawatta": {
    si: "Kurunegala Rd, Yatawatta",
    ta: "Kurunegala Rd, Yatawatta",
  },
  "Kurunegala Road, Polgahawela": {
    si: "\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd \u0db4\u0dcf\u0dbb, \u0db4\u0ddc\u0dbd\u0dca\u0d9c\u0dc4\u0dc0\u0dd9\u0dbd",
    ta: "\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bca\u0bb2\u0bcd\u0b95\u0bb9\u0bb5\u0bc6\u0bb2",
  },
  Kurunegoda: {
    si: "\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd",
    ta: "\u0b95\u0bc1\u0bb0\u0bc1\u0ba3\u0bc7\u0b95\u0bca\u0b9f",
  },
  Kuruwita: {
    si: "\u0d9a\u0dd4\u0dbb\u0dd4\u0dc0\u0dd2\u0da7",
    ta: "\u0b95\u0bc1\u0bb0\u0bc1\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f",
  },
  "Kuswala Fuel Station, Katunayake": {
    si: "\u0d9a\u0dd4\u0dc3\u0dca\u0dc0\u0dbd \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0da7\u0dd4\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b95\u0bc1\u0bb8\u0bcd\u0bb5\u0bb2 \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "L G SUSANTHA": {
    si: "\u0d91\u0dbd\u0dca \u0da2\u0dd3 \u0dc3\u0dd4\u0dc3\u0db1\u0dca\u0dad\u0dcf",
    ta: "\u0b8e\u0bb2\u0bcd \u0b9c\u0bbf \u0b9a\u0bc1\u0b9a\u0bbe\u0ba8\u0bcd\u0ba4\u0bbe",
  },
  "L K.PERERA": {
    si: "\u0d91\u0dbd\u0dca \u0d9a\u0dda.\u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b8e\u0bb2\u0bcd \u0b95\u0bc7.\u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "L P JAYASURIYA": {
    si: "\u0d91\u0dbd\u0dca \u0db4\u0dd3 \u0da2\u0dba\u0dc3\u0dd6\u0dbb\u0dd2\u0dba",
    ta: "\u0b8e\u0bb2\u0bcd \u0baa\u0bbf \u0b9c\u0bc6\u0baf\u0b9a\u0bc2\u0bb0\u0bbf\u0baf\u0bbe",
  },
  "L P LANKA FILLNGS STATION (PVT) LTD": {
    si: "L P \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd (PVT) LTD",
    ta: "\u0b8e\u0bb2\u0bcd \u0baa\u0bbf \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b83\u0baa\u0bbf\u0bb2\u0bcd\u0b99\u0bcd\u0bb8\u0bcd \u0bb8\u0bcd\u0b9f\u0bc7\u0bb7\u0ba9\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "L P P PATHIRATNE": {
    si: "\u0d91\u0dbd\u0dca \u0db4\u0dd3 \u0db4\u0dd3 \u0db4\u0dad\u0dd2\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b8e\u0bb2\u0bcd \u0baa\u0bbf \u0baa\u0bbf \u0baa\u0ba4\u0bcd\u0ba4\u0bbf\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "L P PATHIRATHNA": {
    si: "\u0d91\u0dbd\u0dca \u0db4\u0dd3 \u0db4\u0dad\u0dd2\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b8e\u0bb2\u0bcd \u0baa\u0bbf \u0baa\u0ba4\u0bcd\u0ba4\u0bbf\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "L RATHNAYAKA": {
    si: "\u0d91\u0dbd\u0dca \u0dbb\u0dad\u0dca\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b8e\u0bb2\u0bcd \u0bb0\u0ba4\u0bcd\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "L T F.FERNANDOPULLE": {
    si: "\u0d91\u0dbd\u0dca \u0da7\u0dd3 \u0d91\u0dc6\u0dca \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4\u0db4\u0dd4\u0dbd\u0dca\u0dbd\u0dda",
    ta: "\u0b8e\u0bb2\u0bcd \u0b9f\u0bbf \u0b8e\u0baa\u0bcd.\u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb\u0baa\u0bc1\u0bb2\u0bcd\u0bb2\u0bc7",
  },
  "L W  SURAGE": {
    si: "L W SURAGE",
    ta: "L W SURAGE",
  },
  "L. I.JAYANTHA DE SILVA": {
    si: "\u0d91\u0dbd\u0dca.\u0d85\u0dba\u0dd2.\u0da2\u0dba\u0db1\u0dca\u0dad \u0daf \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf",
    ta: "\u0b8e\u0bb2\u0bcd.\u0b90.\u0b9c\u0bc6\u0baf\u0ba8\u0bcd\u0ba4 \u0b9f\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe",
  },
  "L.A.I.S.DASSANAYAKA": {
    si: "\u0d91\u0dbd\u0dca.\u0d92.\u0d85\u0dba\u0dd2.\u0d91\u0dc3\u0dca.\u0daf\u0dc3\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b8e\u0bb2\u0bcd.\u0b8f.\u0b90.\u0b8e\u0bb8\u0bcd.\u0ba4\u0b9a\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "L.A.K.GEETHIKA KUMARI": {
    si: "\u0d91\u0dbd\u0dca.\u0d92.\u0d9a\u0dda.\u0d9c\u0dd3\u0dad\u0dd2\u0d9a\u0dcf \u0d9a\u0dd4\u0db8\u0dcf\u0dbb\u0dd2",
    ta: "\u0b8e\u0bb2\u0bcd.\u0b8f.\u0b95\u0bc7.\u0b95\u0bc0\u0ba4\u0bbf\u0b95\u0bbe \u0b95\u0bc1\u0bae\u0bbe\u0bb0\u0bbf",
  },
  "L.H.PIYASIRI SILVA": {
    si: "\u0d91\u0dbd\u0dca.\u0d91\u0da0\u0dca.\u0db4\u0dd2\u0dba\u0dc3\u0dd2\u0dbb\u0dd2 \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf",
    ta: "\u0b8e\u0bb2\u0bcd.\u0b8e\u0b9a\u0bcd.\u0baa\u0bbf\u0baf\u0b9a\u0bbf\u0bb1\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe",
  },
  "L.L.KULATUNGA": {
    si: "\u0d91\u0dbd\u0dca.\u0d91\u0dbd\u0dca.\u0d9a\u0dd4\u0dbd\u0dad\u0dd4\u0d82\u0d9c",
    ta: "\u0b8e\u0bb2\u0bcd.\u0b8e\u0bb2\u0bcd.\u0b95\u0bc1\u0bb2\u0ba4\u0bc1\u0b99\u0bcd\u0b95",
  },
  "L.P.P.PATHIRATNA": {
    si: "\u0d91\u0dbd\u0dca.\u0db4\u0dd3.\u0db4\u0dd3.\u0db4\u0dad\u0dd2\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b8e\u0bb2\u0bcd.\u0baa\u0bbf.\u0baa\u0bbf.\u0baa\u0ba4\u0bcd\u0ba4\u0bbf\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "L.S.U.KARUNATILLEKE": {
    si: "\u0d91\u0dbd\u0dca.\u0d91\u0dc3\u0dca.\u0dba\u0dd6.\u0d9a\u0dbb\u0dd4\u0dab\u0dcf\u0dad\u0dd2\u0dbd\u0d9a",
    ta: "\u0b8e\u0bb2\u0bcd.\u0b8e\u0bb8\u0bcd.\u0baf\u0bc1.\u0b95\u0bb0\u0bc1\u0ba3\u0bbe\u0ba4\u0bbf\u0bb2\u0b95\u0bc7",
  },
  "L.W.CABRAAL": {
    si: "L.W.CABRAAL",
    ta: "L.W.CABRAAL",
  },
  "LAKMINI ENTERPRISES": {
    si: "\u0dbd\u0d9a\u0dca\u0db8\u0dd2\u0dab\u0dd3 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0bb2\u0b95\u0bcd\u0bae\u0bbf\u0ba9\u0bbf \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "LAKPIRI ENTERPRISES": {
    si: "\u0dbd\u0d9a\u0dca\u0db4\u0dd2\u0dbb\u0dd2 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0bb2\u0b95\u0bcd\u0baa\u0bbf\u0bb0\u0bbf \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  LAKRUKA: {
    si: "\u0dbd\u0d9a\u0dca\u0dbb\u0dd4\u0d9a\u0dcf",
    ta: "\u0bb2\u0b95\u0bcd\u0bb0\u0bc1\u0b95\u0bbe",
  },
  "LAKSHMI JAYAWARDENE & SONS": {
    si: "\u0dbd\u0d9a\u0dca\u0dc2\u0dca\u0db8\u0dd2 \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0bb2\u0b95\u0bcd\u0bb7\u0bcd\u0bae\u0bbf \u0b9c\u0bc6\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9 & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "LALITH AUTO SERVICE CENTRE": {
    si: "\u0dbd\u0dbd\u0dd2\u0dad\u0dca \u0d94\u0da7\u0ddd \u0dc3\u0dbb\u0dca\u0dc0\u0dd2\u0dc3\u0dca \u0dc3\u0dd9\u0db1\u0dca\u0da7\u0dbb\u0dca",
    ta: "\u0bb2\u0bb2\u0bbf\u0ba4\u0bcd \u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0b9a\u0bb0\u0bcd\u0bb5\u0bc0\u0bb8\u0bcd \u0b9a\u0bc6\u0ba9\u0bcd\u0b9f\u0bb0\u0bcd",
  },
  "LALITH GAMAGE AND COMPANY (PVT) LIM": {
    si: "\u0dbd\u0dbd\u0dd2\u0dad\u0dca \u0d9c\u0db8\u0d9c\u0dda \u0dc3\u0dc4 \u0dc3\u0db8\u0dcf\u0d9c\u0db8 (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dca",
    ta: "\u0bb2\u0bb2\u0bbf\u0ba4\u0bcd \u0b95\u0bae\u0b95\u0bc7 \u0bae\u0bb1\u0bcd\u0bb1\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb1\u0bc1\u0bb5\u0ba9\u0bae\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bcd",
  },
  "LANKA FILLING STATION KALUBOWILA": {
    si: "\u0d9a\u0dc5\u0dd4\u0db6\u0ddd\u0dc0\u0dd2\u0dbd \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd \u0b95\u0bb3\u0bc1\u0baa\u0bcb\u0bb5\u0bbf\u0bb2",
  },
  "LANKA FILLING STATION YATADOLA": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd \u0dba\u0da7\u0daf\u0ddc\u0dbd",
    ta: "\u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8 \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd \u0baf\u0b9f\u0b9f\u0bcb\u0bb2\u0bbe",
  },
  "LANKA SERVICE MART (PVT) LTD": {
    si: "LANKA SERVICE MART (PVT) LTD",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b9a\u0bb0\u0bcd\u0bb5\u0bc0\u0bb8\u0bcd \u0bae\u0bbe\u0bb0\u0bcd\u0b9f\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "LAUGFS PETROLEUM (PVT) LTD": {
    si: "\u0dbd\u0dcf\u0dc6\u0dca\u0dc3\u0dca \u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0ddd\u0dbd\u0dd2\u0dba\u0db8\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0bb2\u0bbe\u0b83\u0baa\u0bcd\u0bb8\u0bcd \u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bbf\u0baf\u0bae\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "LAUGFS PETRTOLEUM (PVT) LTD": {
    si: "LAUFS PETRTOLEUM (PVT) LTD",
    ta: "\u0bb2\u0bbe\u0b83\u0baa\u0bcd\u0bb8\u0bcd \u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bbf\u0baf\u0bae\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "LAUGFT PETROLEUM (PVT) LTD": {
    si: "\u0dbd\u0dcf\u0dc6\u0dca\u0da7\u0dca \u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0ddd\u0dbd\u0dd2\u0dba\u0db8\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0bb2\u0bbe\u0b83\u0baa\u0bcd\u0b9f\u0bcd \u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bbf\u0baf\u0bae\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "LAVEDDY MALLAKAM MPCS LTD": {
    si: "LAVEDDY MALLAKAM MPCS LTD",
    ta: "\u0bb2\u0bbe\u0bb5\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf \u0bae\u0bb2\u0bcd\u0bb2\u0b95\u0bae\u0bcd MPCS LTD",
  },
  "LEANFIRM (PVT) LIMITED": {
    si: "LEANFIRM (PVT) Limited",
    ta: "\u0bb2\u0bc0\u0ba9\u0bcd\u0b83\u0baa\u0bbf\u0bb0\u0bcd\u0bae\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "LILANI DHARMADASA": {
    si: "\u0dbd\u0dd2\u0dbd\u0dcf\u0db1\u0dd2 \u0db0\u0dbb\u0dca\u0db8\u0daf\u0dcf\u0dc3",
    ta: "\u0bb2\u0bbf\u0bb2\u0bbe\u0ba9\u0bbf \u0ba4\u0bb0\u0bcd\u0bae\u0ba4\u0bbe\u0b9a\u0bbe",
  },
  "LITRO GAS LANKA (PVT) LTD": {
    si: "\u0dbd\u0dd2\u0da7\u0dca\u200d\u0dbb\u0ddd \u0d9c\u0dd1\u0dc3\u0dca \u0dbd\u0d82\u0d9a\u0dcf (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0bb2\u0bbf\u0b9f\u0bcd\u0bb0\u0bcb \u0b95\u0bc7\u0bb8\u0bcd \u0bb2\u0b99\u0bcd\u0b95\u0bbe (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "LIVERPOOLS NAVIGATION (PVT) LTD": {
    si: "LIVERPOOLS NAVIGATION (PVT) LTD",
    ta: "\u0bb2\u0bbf\u0bb5\u0bb0\u0bcd\u0baa\u0bc2\u0bb2\u0bcd\u0bb8\u0bcd \u0ba8\u0bc7\u0bb5\u0bbf\u0b95\u0bc7\u0bb7\u0ba9\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "LIYANAGE ASSOCIATES": {
    si: "\u0dbd\u0dd2\u0dba\u0db1\u0d9c\u0dda \u0d87\u0dc3\u0ddd\u0dc3\u0dd2\u0dba\u0dda\u0da7\u0dca\u0dc3\u0dca",
    ta: "\u0bb2\u0bbf\u0baf\u0ba9\u0b95\u0bc7 \u0b85\u0b9a\u0bcb\u0b9a\u0bbf\u0baf\u0bc7\u0b9f\u0bcd\u0bb8\u0bcd",
  },
  "LOGESPARAN PRIYAPARAN": {
    si: "\u0dbd\u0ddd\u0d9c\u0dda\u0db4\u0dbb\u0db1\u0dca \u0db4\u0dca\u200d\u0dbb\u0dd2\u0dba\u0db4\u0dbb\u0db1\u0dca",
    ta: "\u0bb2\u0bcb\u0b95\u0bc7\u0bb8\u0bcd\u0baa\u0bb0\u0ba9\u0bcd \u0baa\u0bbf\u0bb0\u0bbf\u0baf\u0baa\u0bb0\u0ba9\u0bcd",
  },
  "LOKUGE DANASIRI": {
    si: "\u0dbd\u0ddc\u0d9a\u0dd4\u0d9c\u0dda \u0daf\u0db1\u0dc3\u0dd2\u0dbb\u0dd2",
    ta: "\u0bb2\u0bcb\u0b95\u0bc1\u0b95\u0bc7 \u0ba4\u0ba9\u0b9a\u0bbf\u0bb1\u0bbf",
  },
  "LUMBINI ENTERPRISES": {
    si: "\u0dbd\u0dd4\u0db8\u0dca\u0db6\u0dd2\u0dab\u0dd2 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0bb2\u0bc1\u0bae\u0bcd\u0baa\u0bbf\u0ba9\u0bbf \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "Lake Road, Sedawatta - Ambatale Rd, Sri Lanka": {
    si: "\u0dbd\u0dda\u0d9a\u0dca \u0db4\u0dcf\u0dbb, \u0dc3\u0dda\u0daf\u0dc0\u0dad\u0dca\u0dad - \u0d85\u0db9\u0dad\u0dbd\u0dda \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb2\u0bc7\u0b95\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1, \u0b9a\u0bc7\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4 - \u0b85\u0bae\u0bcd\u0baa\u0ba4\u0bcd\u0ba4\u0bb2\u0bc7 \u0bb0\u0bcb\u0b9f\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Lakruka Filling Station, Naula": {
    si: "\u0dbd\u0d9a\u0dca\u0dbb\u0dd4\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db1\u0dcf\u0d8b\u0dbd",
    ta: "\u0bb2\u0b95\u0bcd\u0bb0\u0bc1\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0ba8\u0bbe\u0bb5\u0bc1\u0bb2\u0bbe",
  },
  "Lakruka filling sation, JJGP+RMR, Madawala Ulpotha, Sri Lanka": {
    si: "\u0dbd\u0d9a\u0dca\u0dbb\u0dd4\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, JJGP+RMR, \u0db8\u0da9\u0dc0\u0dbd \u0d8b\u0dbd\u0dca\u0db4\u0ddc\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb2\u0b95\u0bcd\u0bb0\u0bc1\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, JJGP+RMR, \u0bae\u0b9f\u0bb5\u0bb2 \u0b89\u0bb2\u0bcd\u0baa\u0bcb\u0ba4, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Lakrukruka Filling Station, Koholanwela, Madawala Ulpotha": {
    si: "\u0dbd\u0d9a\u0dca\u0dbb\u0dd4\u0d9a \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0ddc\u0dc4\u0ddc\u0dbd\u0db1\u0dca\u0dc0\u0dd9\u0dbd, \u0db8\u0da9\u0dc0\u0dbd \u0d8b\u0dbd\u0dca\u0db4\u0ddc\u0dad",
    ta: "\u0bb2\u0b95\u0bcd\u0bb0\u0bc1\u0b95\u0bcd\u0bb0\u0bc1\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0bca\u0bb9\u0bca\u0bb2\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2, \u0bae\u0b9f\u0bb5\u0bb2 \u0b89\u0bb2\u0bcd\u0baa\u0bca\u0ba4",
  },
  "Lanka Ceypetco Filling Station, Athurugiriya Rd, Malabe": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0dc3\u0dd2\u0db4\u0dd9\u0da7\u0dca\u0d9a\u0ddd \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d85\u0dad\u0dd4\u0dbb\u0dd4\u0d9c\u0dd2\u0dbb\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db8\u0dcf\u0dbd\u0db6\u0dda",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b9a\u0bbf\u0baa\u0bc6\u0b9f\u0bcd\u0b95\u0bcb \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b85\u0ba4\u0bc1\u0bb0\u0bc1\u0b95\u0bbf\u0bb0\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bbe\u0bb2\u0baa\u0bc7",
  },
  "Lanka Filing Station Aluthwala, Aluthwala": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0d9c\u0ddc\u0db1\u0dd4 \u0d9a\u0dd2\u0dbb\u0dd3\u0db8\u0dda \u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba \u0d85\u0dbd\u0dd4\u0dad\u0dca\u0dc0\u0dbd, \u0d85\u0dbd\u0dd4\u0dad\u0dca\u0dc0\u0dbd",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba4\u0bbe\u0b95\u0bcd\u0b95\u0bb2\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd \u0b85\u0bb2\u0bc1\u0ba4\u0bcd\u0bb5\u0bbe\u0bb2\u0bbe, \u0b85\u0bb2\u0bc1\u0ba4\u0bcd\u0bb5\u0bbe\u0bb2\u0bbe",
  },
  "Lanka Filling Station (Opatha), Kotugoda": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd (\u0d95\u0db4\u0dcf\u0dad), \u0d9a\u0ddc\u0da7\u0dd4\u0d9c\u0ddc\u0da9",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd (\u0b93\u0baa\u0bbe\u0ba4), \u0b95\u0bca\u0b9f\u0bc1\u0b95\u0bca\u0b9f",
  },
  "Lanka Filling Station - A.De S.Jayawardana, Dharmapala Mawatha, Anuradhapura":
    {
      si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd - \u0d92.\u0daf \u0d91\u0dc3\u0dca.\u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1, \u0db0\u0dbb\u0dca\u0db8\u0db4\u0dcf\u0dbd \u0db8\u0dcf\u0dc0\u0dad, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb",
      ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd - \u0b8f.\u0b9f\u0bbf. \u0b8e\u0bb8\u0bcd.\u0b9c\u0bc6\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9, \u0ba4\u0bb0\u0bcd\u0bae\u0baa\u0bbe\u0bb2 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd",
    },
  "Lanka Filling Station - Meegalewa, Meegalewa": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd - \u0db8\u0dd3\u0d9c\u0dbd\u0dd1\u0dc0, \u0db8\u0dd3\u0d9c\u0dbd\u0dd1\u0dc0",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd - \u0bae\u0bc0\u0b95\u0bb2\u0bc7\u0bb5, \u0bae\u0bc0\u0b95\u0bb2\u0bc7\u0bb5",
  },
  "Lanka Filling Station - S.K Carder, Vavuniya - Puliyankulam": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd - \u0d91\u0dc3\u0dca.\u0d9a\u0dda \u0d9a\u0dcf\u0da9\u0dbb\u0dca, \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0 - \u0db4\u0dd4\u0dbd\u0dd2\u0dba\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd - \u0b8e\u0bb8\u0bcd.\u0b95\u0bc7 \u0b95\u0bbe\u0bb0\u0bcd\u0b9f\u0bb0\u0bcd, \u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe - \u0baa\u0bc1\u0bb3\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd",
  },
  "Lanka Filling Station Atchuvely": {
    si: "\u0d85\u0da0\u0dca\u0da0\u0dd4\u0dc0\u0dda\u0dbd\u0dd2 \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b85\u0b9a\u0bcd\u0b9a\u0bc1\u0bb5\u0bc7\u0bb2\u0bbf \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "Lanka Filling Station Koralaima, Korale Ima, Horana": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd \u0d9a\u0ddd\u0dbb\u0dc5\u0dba\u0dd2\u0db8, \u0d9a\u0ddd\u0dbb\u0dbd\u0dda \u0d89\u0db8\u0dcf, \u0dc4\u0ddc\u0dbb\u0dab",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd \u0b95\u0bcb\u0bb0\u0bb2\u0bc8\u0bae, \u0b95\u0bcb\u0bb0\u0bb2\u0bc8 \u0b87\u0bae\u0bbe, \u0bb9\u0bca\u0bb0\u0ba3",
  },
  "Lanka Filling Station, A2, Balapitiya": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, A2, \u0db6\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, A2, \u0baa\u0bb2\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Lanka Filling Station, Ab20, Kalviyankadu": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, Ab20, \u0d9a\u0dbd\u0dca\u0dc0\u0dd2\u0dba\u0db1\u0dca\u0d9a\u0dcf\u0da9\u0dd4",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b8f\u0baa\u0bbf20, \u0b95\u0bb2\u0bcd\u0bb5\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0bbe\u0b9f\u0bc1",
  },
  "Lanka Filling Station, Ab20, Karaveddi": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, Ab20, \u0d9a\u0dbb\u0dc0\u0dd9\u0da9\u0dca\u0da9\u0dd2",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b8f\u0baa\u0bbf20, \u0b95\u0bb0\u0bb5\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf",
  },
  "Lanka Filling Station, Ampara - Uhana - Maha Oya Hwy": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d85\u0db8\u0dca\u0db4\u0dcf\u0dbb - \u0d8b\u0dc4\u0db1 - \u0db8\u0dc4\u0d94\u0dba Hwy",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0bb1\u0bc8 - \u0b89\u0bb9\u0ba9 - \u0bae\u0bb9\u0bbe \u0b93\u0baf\u0bbe \u0bb9\u0bb5\u0bcd",
  },
  "Lanka Filling Station, Avissawella Rd, Pannipitiya": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Lanka Filling Station, B84, Piliyandala": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db6\u0dd3 84, \u0db4\u0dd2\u0dc5\u0dd2\u0dba\u0db1\u0dca\u0daf\u0dbd",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, B84, \u0baa\u0bbf\u0bb2\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bb2\u0bc8",
  },
  "Lanka Filling Station, Canada Friendship Rd, Katunayake": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0dd0\u0db1\u0da9\u0dcf \u0db8\u0dd2\u0dad\u0dca\u200d\u0dbb\u0dad\u0dca\u0dc0 \u0db4\u0dcf\u0dbb, \u0d9a\u0da7\u0dd4\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0ba9\u0b9f\u0bbe \u0ba8\u0b9f\u0bcd\u0baa\u0bc1 \u0baa\u0bbe\u0ba4\u0bc8, \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "Lanka Filling Station, High Level Rd, Nugegoda": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0dc4\u0dba\u0dd2\u0dbd\u0dd9\u0dc0\u0dbd\u0dca \u0db4\u0dcf\u0dbb, \u0db1\u0dd4\u0d9c\u0dda\u0d9c\u0ddc\u0da9",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b89\u0baf\u0bb0\u0bcd \u0bae\u0b9f\u0bcd\u0b9f \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc1\u0b95\u0bc7\u0b95\u0bca\u0b9f",
  },
  "Lanka Filling Station, Kahawa - Batapola Rd, Meetiyagoda": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0dc4\u0dc0 - \u0db6\u0da7\u0db4\u0ddc\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dd3\u0da7\u0dd2\u0dba\u0dcf\u0d9c\u0ddc\u0da9",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0bb9\u0bbe\u0bb5 - \u0baa\u0b9f\u0baa\u0bca\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bc0\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0bbe\u0b95\u0bca\u0b9f",
  },
  "Lanka Filling Station, Kurunegala - Narammala - Madampe Rd, Kuliyapitiya": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd - \u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda \u0db4\u0dcf\u0dbb, \u0d9a\u0dd4\u0dbd\u0dd2\u0dba\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0ba8\u0bbe\u0bb0\u0bae\u0bcd\u0bae\u0bb2 - \u0bae\u0bbe\u0ba4\u0bae\u0bcd\u0baa\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bc1\u0bb3\u0bbf\u0baf\u0bbe\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Lanka Filling Station, Mihintale": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db8\u0dd2\u0dc4\u0dd2\u0db1\u0dca\u0dad\u0dbd\u0dda",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0bae\u0bbf\u0bb9\u0bbf\u0ba8\u0bcd\u0ba4\u0bb2\u0bc8",
  },
  "Lanka Filling Station, Mulattivu": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db8\u0dd4\u0dbd\u0dad\u0dd2\u0dc0\u0dca",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0bae\u0bc1\u0bb2\u0ba4\u0bcd\u0ba4\u0bc0\u0bb5\u0bc1",
  },
  "Lanka Filling Station, Nochchiyagama": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db1\u0ddc\u0da0\u0dca\u0da0\u0dd2\u0dba\u0dcf\u0d9c\u0db8",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0ba8\u0bca\u0b9a\u0bcd\u0b9a\u0bbf\u0baf\u0bbe\u0b95\u0bae",
  },
  "Lanka Filling Station, Pandethiruppu": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db4\u0dab\u0dca\u0da9\u0dd9\u0dad\u0dd2\u0dbb\u0dd4\u0db4\u0dca\u0db4\u0dd4",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0baa\u0bbe\u0ba3\u0bcd\u0b9f\u0bc7\u0ba4\u0bbf\u0bb0\u0bc1\u0baa\u0bcd\u0baa\u0bc1",
  },
  "Lanka Filling Station, Pannala-kuliyapitiya Rd, Pannala": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db4\u0db1\u0dca\u0db1\u0dbd-\u0d9a\u0dd4\u0dbd\u0dd2\u0dba\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db4\u0db1\u0dca\u0db1\u0dbd",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0baa\u0ba9\u0bcd\u0ba9\u0bb2-\u0b95\u0bc1\u0bb2\u0bbf\u0baf\u0bbe\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0ba9\u0bcd\u0ba9\u0bbe\u0bb2\u0bc8",
  },
  "Lanka Filling Station, Puttalam - Colombo Road, Madurankuliya": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0db8\u0daf\u0dd4\u0dbb\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0dd2\u0dba",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0ba4\u0bc1\u0bb0\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bbf\u0baf",
  },
  "Lanka Filling Station, R4, Thelulla Janapadhaya Ethiliwewa Wellawaya,Thelulla":
    {
      si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, R4, \u0dad\u0dd9\u0dbd\u0dd4\u0dbd\u0dca\u0dbd \u0da2\u0db1\u0db4\u0daf\u0dba \u0d87\u0dad\u0dd2\u0dbd\u0dd2\u0dc0\u0dd0\u0dc0 \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba, \u0dad\u0dd9\u0dbd\u0dd4\u0dbd\u0dca\u0dbd",
      ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, R4, \u0ba4\u0bc6\u0bb2\u0bc1\u0bb2\u0bcd\u0bb2 \u0b9c\u0ba9\u0baa\u0ba4\u0baf \u0b8e\u0ba4\u0bbf\u0bb2\u0bbf\u0bb5\u0bc6\u0bb5 \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf, \u0ba4\u0bc6\u0bb2\u0bc1\u0bb2\u0bcd\u0bb2",
    },
  "Lanka Filling Station, Sri Jayawardenepura Kotte": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1\u0db4\u0dd4\u0dbb \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0bb8\u0bcd\u0bb0\u0bc0 \u0b9c\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0baa\u0bc1\u0bb0 \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7",
  },
  "Lanka Filling Station, Vauniyawa Mpcs Limited, Omanthai": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0 \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca, \u0d95\u0db8\u0db1\u0dca\u0dad\u0dda",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe\u0bb5 \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0b9a\u0bbf\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd, \u0b93\u0bae\u0ba8\u0bcd\u0ba4\u0bc8",
  },
  "Lanka Fuel Station, Akkaraipattu - Warapathanchenai": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0db4\u0dad\u0dca\u0dad\u0dd4\u0dc0 - \u0dc0\u0dbb\u0dcf\u0db4\u0dad\u0db1\u0dca\u0da0\u0dda\u0db1\u0dba\u0dd2",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bc8\u0baa\u0bcd\u0baa\u0bb1\u0bcd\u0bb1\u0bc1 - \u0bb5\u0bbe\u0bb0\u0baa\u0ba4\u0bcd\u0ba4\u0bbe\u0b9e\u0bcd\u0b9a\u0bc7\u0ba9\u0bc8",
  },
  "Lanka Ioc Station, Hirimbura Rd, Galle": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf IOC \u0daf\u0dd4\u0db8\u0dca\u0dbb\u0dd2\u0dba \u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba, \u0dc4\u0dd2\u0dbb\u0dd2\u0db9\u0dd4\u0dbb \u0db4\u0dcf\u0dbb, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b90\u0b93\u0b9a\u0bbf \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0bb9\u0bbf\u0bb0\u0bbf\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bbe \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bbe\u0bb2\u0bbf",
  },
  "Lanka Oil Center, Thoranagoda,Eheliyagoda": {
    si: "\u0dbd\u0d82\u0d9a\u0dcf \u0d94\u0dba\u0dd2\u0dbd\u0dca \u0dc3\u0dd9\u0db1\u0dca\u0da7\u0dbb\u0dca, \u0dad\u0ddc\u0dbb\u0dab\u0d9c\u0ddc\u0da9, \u0d87\u0dc4\u0dd0\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b86\u0baf\u0bbf\u0bb2\u0bcd \u0bae\u0bc8\u0baf\u0bae\u0bcd, \u0ba4\u0bcb\u0bb0\u0ba3\u0b95\u0bca\u0b9f, \u0b8e\u0bb9\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f",
  },
  "Last 1 Hour": {
    si: "\u0db4\u0dc3\u0dd4\u0d9c\u0dd2\u0dba \u0db4\u0dd0\u0dba 1",
    ta: "\u0b95\u0b9f\u0ba8\u0bcd\u0ba4 1 \u0bae\u0ba3\u0bbf\u0ba8\u0bc7\u0bb0\u0bae\u0bcd",
  },
  "Last 12 Hours": {
    si: "\u0db4\u0dc3\u0dd4\u0d9c\u0dd2\u0dba \u0db4\u0dd0\u0dba 12",
    ta: "\u0b95\u0b9f\u0ba8\u0bcd\u0ba4 12 \u0bae\u0ba3\u0bbf\u0ba8\u0bc7\u0bb0\u0bae\u0bcd",
  },
  "Last 24 Hours": {
    si: "\u0db4\u0dc3\u0dd4\u0d9c\u0dd2\u0dba \u0db4\u0dd0\u0dba 24",
    ta: "\u0b95\u0b9f\u0ba8\u0bcd\u0ba4 24 \u0bae\u0ba3\u0bbf\u0ba8\u0bc7\u0bb0\u0bae\u0bcd",
  },
  "Last 3 Hours": {
    si: "\u0db4\u0dc3\u0dd4\u0d9c\u0dd2\u0dba \u0db4\u0dd0\u0dba 3",
    ta: "\u0b95\u0b9f\u0ba8\u0bcd\u0ba4 3 \u0bae\u0ba3\u0bbf\u0ba8\u0bc7\u0bb0\u0bae\u0bcd",
  },
  "Last 6 Hours": {
    si: "\u0db4\u0dc3\u0dd4\u0d9c\u0dd2\u0dba \u0db4\u0dd0\u0dba 6",
    ta: "\u0b95\u0b9f\u0ba8\u0bcd\u0ba4 6 \u0bae\u0ba3\u0bbf\u0ba8\u0bc7\u0bb0\u0bae\u0bcd",
  },
  "Last Updated by Shed": {
    si: "\u0d85\u0dc0\u0dc3\u0db1\u0dca \u0dc0\u0dbb\u0da7 \u0dba\u0dcf\u0dc0\u0dad\u0dca\u0d9a\u0dcf\u0dbd\u0dd3\u0db1 \u0d9a\u0dbb\u0db1 \u0dbd\u0daf\u0dca\u0daf\u0dda Shed \u0dc0\u0dd2\u0dc3\u0dd2\u0db1\u0dd2",
    ta: "\u0b95\u0b9f\u0bc8\u0b9a\u0bbf\u0baf\u0bbe\u0b95 \u0bb7\u0bc6\u0b9f\u0bcd \u0bae\u0bc2\u0bb2\u0bae\u0bcd \u0baa\u0bc1\u0ba4\u0bc1\u0baa\u0bcd\u0baa\u0bbf\u0b95\u0bcd\u0b95\u0baa\u0bcd\u0baa\u0b9f\u0bcd\u0b9f\u0ba4\u0bc1",
  },
  "Last Week": {
    si: "\u0d9c\u0dd2\u0dba \u0dc3\u0dad\u0dd2\u0dba",
    ta: "\u0b95\u0b9f\u0ba8\u0bcd\u0ba4 \u0bb5\u0bbe\u0bb0\u0bae\u0bcd",
  },
  "Laugfs Filling Station, Puttalam - Colombo Rd, Negombo": {
    si: "\u0dbd\u0dcf\u0dc6\u0dca\u0dc3\u0dca \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0bb2\u0bbe\u0b83\u0baa\u0bcd\u0bb8\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "Lenadora - Dambulla": {
    si: "\u0dbd\u0dd9\u0db1\u0daf\u0ddc\u0dbb - \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0bb2\u0bc6\u0ba9\u0b9f\u0bcb\u0bb0\u0bbe - \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8",
  },
  "Lenadora Bus Stop, Lendora, Sri Lanka": {
    si: "\u0dbd\u0dd9\u0db1\u0daf\u0ddc\u0dbb \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0dbd\u0dd9\u0db1\u0dca\u0da9\u0ddd\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb2\u0bc6\u0ba9\u0b9f\u0bcb\u0bb0\u0bbe \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0bb2\u0bc6\u0ba9\u0bcd\u0b9f\u0bcb\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Less than 30 minutes": {
    si: "\u0dc0\u0dd2\u0db1\u0dcf\u0da9\u0dd2 30\u0d9a\u0da7 \u0d85\u0da9\u0dd4\u0dba\u0dd2",
    ta: "30 \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0b99\u0bcd\u0b95\u0bb3\u0bc1\u0b95\u0bcd\u0b95\u0bc1\u0bae\u0bcd \u0b95\u0bc1\u0bb1\u0bc8\u0bb5\u0bbe\u0ba9\u0ba4\u0bc1",
  },
  "Liyanwela-brook Side Road, Padiyapelella": {
    si: "\u0dbd\u0dd2\u0dba\u0db1\u0dc0\u0dbd - \u0d94\u0dba \u0db4\u0dd0\u0dad\u0dca\u0dad\u0dda \u0db4\u0dcf\u0dbb, \u0db4\u0daf\u0dd2\u0dba\u0db4\u0dd0\u0dbd\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0bb2\u0bbf\u0baf\u0bbe\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2-\u0baa\u0bc1\u0bb0\u0bc2\u0b95\u0bcd \u0baa\u0b95\u0bcd\u0b95 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0ba4\u0bbf\u0baf\u0baa\u0bc6\u0bb2\u0bb2\u0bcd\u0bb2",
  },
  "Loc Fuel Station, Tangalle Rd, Koattagoda": {
    si: "\u0dbd\u0ddc\u0d9a\u0dca \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0dad\u0d82\u0d9c\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0d9c\u0ddc\u0da9",
    ta: "Loc \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0ba4\u0b99\u0bcd\u0b95\u0bbe\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0b95\u0bca\u0b9f",
  },
  Loluwagoda: {
    si: "\u0dbd\u0ddd\u0dbd\u0dd4\u0dc0\u0dcf\u0d9c\u0ddc\u0da9",
    ta: "\u0bb2\u0bca\u0bb2\u0bc1\u0bb5\u0bbe\u0b95\u0bca\u0b9f",
  },
  Lunugamvehera: {
    si: "\u0dbd\u0dd4\u0dab\u0dd4\u0d9c\u0db8\u0dca\u0dc0\u0dd9\u0dc4\u0dd9\u0dbb",
    ta: "\u0bb2\u0bc1\u0ba9\u0bc1\u0b95\u0bae\u0bcd\u0bb5\u0bc6\u0bb9\u0bc6\u0bb0",
  },
  Lunuwila: {
    si: "\u0dbd\u0dd4\u0dab\u0dd4\u0dc0\u0dd2\u0dbd",
    ta: "\u0bb2\u0bc1\u0ba9\u0bc1\u0bb5\u0bbf\u0bb2",
  },
  "M A I P KUMARA MANASINGHE": {
    si: "\u0d91\u0db8\u0dca \u0d92 \u0d85\u0dba\u0dd2 \u0db4\u0dd3 \u0d9a\u0dd4\u0db8\u0dcf\u0dbb \u0db8\u0dcf\u0db1\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b8e\u0bae\u0bcd \u0b8f \u0b90 \u0baa\u0bbf \u0b95\u0bc1\u0bae\u0bbe\u0bb0 \u0bae\u0ba9\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "M A J P MALLAWA ARACHCHI": {
    si: "\u0d91\u0db8\u0dca \u0d92 \u0da2\u0dda \u0db4\u0dd3 \u0db8\u0dbd\u0dca\u0dbd\u0dc0 \u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2",
    ta: "\u0b8e\u0bae\u0bcd \u0b8f \u0b9c\u0bc7 \u0baa\u0bbf \u0bae\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe \u0b86\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf",
  },
  "M A M ABDUL HASSEN & SONS": {
    si: "\u0d91\u0db8\u0dca \u0d92 \u0d91\u0db8\u0dca \u0d85\u0db6\u0dca\u0daf\u0dd4\u0dbd\u0dca \u0dc4\u0dc3\u0db1\u0dca \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b8e\u0bae\u0bcd \u0b8f \u0b8e\u0bae\u0bcd \u0b85\u0baa\u0bcd\u0ba4\u0bc1\u0bb2\u0bcd \u0bb9\u0bbe\u0b9a\u0ba9\u0bcd & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "M A N JANITHA FERNANDO": {
    si: "\u0d91\u0db8\u0dca \u0d92 \u0d91\u0db1\u0dca \u0da2\u0db1\u0dd2\u0dad\u0dcf \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0b8e\u0bae\u0bcd \u0b8f \u0b8e\u0ba9\u0bcd \u0b9c\u0ba9\u0bbf\u0ba4\u0bbe \u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "M A N RUWANTHA FERNANDO": {
    si: "\u0d91\u0db8\u0dca \u0d92 \u0d91\u0db1\u0dca \u0dbb\u0dd4\u0dc0\u0db1\u0dca\u0dad\u0dcf \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0b8e\u0bae\u0bcd \u0b8f \u0b8e\u0ba9\u0bcd \u0bb0\u0bc1\u0bb5\u0ba8\u0bcd\u0ba4 \u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "M C S PERERA": {
    si: "\u0d91\u0db8\u0dca \u0dc3\u0dd3 \u0d91\u0dc3\u0dca \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b8e\u0bae\u0bcd \u0b9a\u0bbf \u0b8e\u0bb8\u0bcd \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "M D S NISHANTHI": {
    si: "\u0d91\u0db8\u0dca \u0da9\u0dd3 \u0d91\u0dc3\u0dca \u0db1\u0dd2\u0dc1\u0dcf\u0db1\u0dca\u0dad\u0dd2",
    ta: "\u0b8e\u0bae\u0bcd \u0b9f\u0bbf \u0b8e\u0bb8\u0bcd \u0ba8\u0bbf\u0bb7\u0bbe\u0ba8\u0bcd\u0ba4\u0bbf",
  },
  "M D W UPUL KUMARA": {
    si: "\u0d91\u0db8\u0dca \u0da9\u0dd3 \u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0d8b\u0db4\u0dd4\u0dbd\u0dca \u0d9a\u0dd4\u0db8\u0dcf\u0dbb",
    ta: "\u0b8e\u0bae\u0bcd \u0b9f\u0bbf \u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b89\u0baa\u0bc1\u0bb2\u0bcd \u0b95\u0bc1\u0bae\u0bbe\u0bb0",
  },
  "M G S M DASANAYAKA": {
    si: "\u0d91\u0db8\u0dca \u0da2\u0dd3 \u0d91\u0dc3\u0dca \u0d91\u0db8\u0dca \u0daf\u0dc3\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b8e\u0bae\u0bcd \u0b9c\u0bbf \u0b8e\u0bb8\u0bcd \u0b8e\u0bae\u0bcd \u0ba4\u0b9a\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "M G SAMSON AND SONS": {
    si: "\u0d91\u0db8\u0dca \u0da2\u0dd3 \u0dc3\u0dd0\u0db8\u0dca\u0dc3\u0db1\u0dca \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b8e\u0bae\u0bcd \u0b9c\u0bbf \u0b9a\u0bbe\u0bae\u0bcd\u0b9a\u0ba9\u0bcd \u0bae\u0bb1\u0bcd\u0bb1\u0bc1\u0bae\u0bcd \u0bae\u0b95\u0ba9\u0bcd\u0b95\u0bb3\u0bcd",
  },
  "M H M  MOHIDEEN": {
    si: "\u0d91\u0db8\u0dca \u0d91\u0da0\u0dca \u0d91\u0db8\u0dca \u0db8\u0ddc\u0dc4\u0dd2\u0daf\u0dd3\u0db1\u0dca",
    ta: "\u0b8e\u0bae\u0bcd \u0b8e\u0b9a\u0bcd \u0b8e\u0bae\u0bcd \u0bae\u0bca\u0bb9\u0bbf\u0ba4\u0bc0\u0ba9\u0bcd",
  },
  "M H M MOHIDEEN": {
    si: "\u0d91\u0db8\u0dca \u0d91\u0da0\u0dca \u0d91\u0db8\u0dca \u0db8\u0ddc\u0dc4\u0dd2\u0daf\u0dd3\u0db1\u0dca",
    ta: "\u0b8e\u0bae\u0bcd \u0b8e\u0b9a\u0bcd \u0b8e\u0bae\u0bcd \u0bae\u0bca\u0bb9\u0bbf\u0ba4\u0bc0\u0ba9\u0bcd",
  },
  "M H M.MOHIDEEN": {
    si: "\u0d91\u0db8\u0dca \u0d91\u0da0\u0dca \u0d91\u0db8\u0dca \u0db8\u0ddc\u0dc4\u0dd2\u0daf\u0dd3\u0db1\u0dca",
    ta: "\u0b8e\u0bae\u0bcd.\u0b8e\u0b9a\u0bcd.\u0b8e\u0bae\u0bcd.\u0bae\u0bca\u0bb9\u0bbf\u0ba4\u0bc0\u0ba9\u0bcd",
  },
  "M H SAMAYADASA & SONS": {
    si: "\u0d91\u0db8\u0dca \u0d91\u0da0\u0dca \u0dc3\u0db8\u0dba\u0daf\u0dcf\u0dc3 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b8e\u0bae\u0bcd \u0b8e\u0b9a\u0bcd \u0b9a\u0bae\u0baf\u0ba4\u0bbe\u0b9a\u0bbe & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "M J M ASLAM": {
    si: "\u0d91\u0db8\u0dca \u0da2\u0dda \u0d91\u0db8\u0dca \u0d85\u0dc3\u0dca\u0dbd\u0db8\u0dca",
    ta: "\u0b8e\u0bae\u0bcd \u0b9c\u0bc7 \u0b8e\u0bae\u0bcd \u0b85\u0bb8\u0bcd\u0bb2\u0bbe\u0bae\u0bcd",
  },
  "M K N DAMMIKA": {
    si: "\u0d91\u0db8\u0dca \u0d9a\u0dda \u0d91\u0db1\u0dca \u0daf\u0db8\u0dca\u0db8\u0dd2\u0d9a",
    ta: "\u0b8e\u0bae\u0bcd \u0b95\u0bc7 \u0b8e\u0ba9\u0bcd \u0ba4\u0bae\u0bcd\u0bae\u0bbf\u0b95\u0bbe",
  },
  "M K WANNIARACHCHI": {
    si: "\u0d91\u0db8\u0dca \u0d9a\u0dda \u0dc0\u0db1\u0dca\u0db1\u0dd2\u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2",
    ta: "\u0b8e\u0bae\u0bcd \u0b95\u0bc7 \u0bb5\u0ba9\u0bcd\u0ba9\u0bbf\u0baf\u0bbe\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf",
  },
  "M KANAGARATNAM": {
    si: "\u0d91\u0db8\u0dca \u0d9a\u0db1\u0d9c\u0dbb\u0dad\u0dca\u0db1\u0db8\u0dca",
    ta: "\u0b8e\u0bae\u0bcd \u0b95\u0ba9\u0b95\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0bae\u0bcd",
  },
  "M L B FERNANDO": {
    si: "\u0d91\u0db8\u0dca \u0d91\u0dbd\u0dca \u0db6\u0dd3 \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0b8e\u0bae\u0bcd \u0b8e\u0bb2\u0bcd \u0baa\u0bbf \u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "M M Noohu Marikar": {
    si: "\u0d91\u0db8\u0dca \u0d91\u0db8\u0dca \u0db1\u0dd6\u0dc4\u0dd4 \u0db8\u0dbb\u0dd2\u0d9a\u0dcf\u0dbb\u0dca",
    ta: "\u0b8e\u0bae\u0bcd \u0b8e\u0bae\u0bcd \u0ba8\u0bc2\u0bb9\u0bc1 \u0bae\u0bb0\u0bbf\u0b95\u0bcd\u0b95\u0bbe\u0bb0\u0bcd",
  },
  "M M P G D BANDARA": {
    si: "\u0d91\u0db8\u0dca \u0d91\u0db8\u0dca \u0db4\u0dd3 \u0da2\u0dd3 \u0da9\u0dd3 \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb",
    ta: "\u0b8e\u0bae\u0bcd \u0b8e\u0bae\u0bcd \u0baa\u0bbf \u0b9c\u0bbf \u0b9f\u0bbf \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0",
  },
  "M M WIMALARATHNA": {
    si: "\u0d91\u0db8\u0dca \u0d91\u0db8\u0dca \u0dc0\u0dd2\u0db8\u0dbd\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b8e\u0bae\u0bcd \u0b8e\u0bae\u0bcd \u0bb5\u0bbf\u0bae\u0bb2\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "M N.WICKREMASINGHE": {
    si: "\u0d91\u0db8\u0dca \u0d91\u0db1\u0dca \u0dc0\u0dd2\u0d9a\u0dca\u200d\u0dbb\u0db8\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b8e\u0bae\u0bcd.\u0b8e\u0ba9\u0bcd.\u0bb5\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb0\u0bae\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "M P BORALUGODA": {
    si: "\u0d91\u0db8\u0dca \u0db4\u0dd3 \u0db6\u0ddc\u0dbb\u0dc5\u0dd4\u0d9c\u0ddc\u0da9",
    ta: "\u0b8e\u0bae\u0bcd \u0baa\u0bbf \u0baa\u0bca\u0bb0\u0bb2\u0bc1\u0b95\u0bca\u0b9f",
  },
  "M P M L GUNAWARDHANA": {
    si: "\u0d91\u0db8\u0dca \u0db4\u0dd3 \u0d91\u0db8\u0dca \u0d91\u0dbd\u0dca \u0d9c\u0dd4\u0dab\u0dc0\u0dbb\u0dca\u0db0\u0db1",
    ta: "\u0b8e\u0bae\u0bcd \u0baa\u0bbf \u0b8e\u0bae\u0bcd \u0b8e\u0bb2\u0bcd \u0b95\u0bc1\u0ba3\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9",
  },
  "M P SARATH KUMARA": {
    si: "\u0d91\u0db8\u0dca \u0db4\u0dd3 \u0dc3\u0dbb\u0dad\u0dca \u0d9a\u0dd4\u0db8\u0dcf\u0dbb",
    ta: "\u0b8e\u0bae\u0bcd \u0baa\u0bbf \u0b9a\u0bb0\u0ba4\u0bcd \u0b95\u0bc1\u0bae\u0bbe\u0bb0",
  },
  "M R HENRY": {
    si: "\u0d91\u0db8\u0dca \u0d86\u0dbb\u0dca \u0dc4\u0dd9\u0db1\u0dca\u0dbb\u0dd2",
    ta: "\u0b8e\u0bae\u0bcd \u0b86\u0bb0\u0bcd \u0bb9\u0bc6\u0ba9\u0bcd\u0bb1\u0bbf",
  },
  "M S K JAYAWEERA": {
    si: "\u0d91\u0db8\u0dca \u0d91\u0dc3\u0dca \u0d9a\u0dda \u0da2\u0dba\u0dc0\u0dd3\u0dbb",
    ta: "\u0b8e\u0bae\u0bcd \u0b8e\u0bb8\u0bcd \u0b95\u0bc7 \u0b9c\u0bc6\u0baf\u0bb5\u0bc0\u0bb0",
  },
  "M S M.IQBAL": {
    si: "M S M.IQBAL",
    ta: "\u0b8e\u0bae\u0bcd \u0b8e\u0bb8\u0bcd \u0b8e\u0bae\u0bcd.\u0b87\u0b95\u0bcd\u0baa\u0bbe\u0bb2\u0bcd",
  },
  "M T FERNANDO": {
    si: "\u0d91\u0db8\u0dca \u0da7\u0dd3 \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0b8e\u0bae\u0bcd \u0b9f\u0bbf \u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "M U C SILVA": {
    si: "\u0d91\u0db8\u0dca \u0dba\u0dd6 \u0dc3\u0dd3 \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf",
    ta: "\u0b8e\u0bae\u0bcd \u0baf\u0bc2 \u0b9a\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe",
  },
  "M UDAYAKUMAR": {
    si: "\u0d91\u0db8\u0dca \u0d8b\u0daf\u0dba\u0d9a\u0dd4\u0db8\u0dcf\u0dbb\u0dca",
    ta: "\u0b8e\u0bae\u0bcd \u0b89\u0ba4\u0baf\u0b95\u0bc1\u0bae\u0bbe\u0bb0\u0bcd",
  },
  "M V M D MARINA JUNE THUSHARI": {
    si: "M V M D \u0db8\u0dbb\u0dd3\u0db1\u0dcf \u0da2\u0dd4\u0db1\u0dd2 \u0dad\u0dd4\u0dc2\u0dcf\u0dbb\u0dd2",
    ta: "\u0b8e\u0bae\u0bcd \u0bb5\u0bbf \u0b8e\u0bae\u0bcd \u0b9f\u0bbf \u0bae\u0bc6\u0bb0\u0bbf\u0ba9\u0bbe \u0b9c\u0bc2\u0ba9\u0bcd \u0ba4\u0bc1\u0bb7\u0bbe\u0bb0\u0bbf",
  },
  "M W J KARUNARATHNE": {
    si: "\u0d91\u0db8\u0dca \u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0da2\u0dda \u0d9a\u0dbb\u0dd4\u0dab\u0dcf\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b8e\u0bae\u0bcd \u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b9c\u0bc7 \u0b95\u0bb0\u0bc1\u0ba3\u0bbe\u0bb0\u0ba4\u0bcd\u0ba9\u0bc7",
  },
  "M. SENAVIRATHNA (PVT) LTD": {
    si: "\u0d91\u0db8\u0dca. \u0dc3\u0dd9\u0db1\u0dc0\u0dd2\u0dbb\u0dad\u0dca\u0db1 (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b8e\u0bae\u0bcd. \u0b9a\u0bc7\u0ba9\u0bb5\u0bbf\u0bb0\u0ba4\u0bcd\u0ba9\u0bbe (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "M.A.ABDUL MAJEED": {
    si: "\u0d91\u0db8\u0dca.\u0d92.\u0d85\u0db6\u0dca\u0daf\u0dd4\u0dbd\u0dca \u0db8\u0da2\u0dd3\u0da9\u0dca",
    ta: "\u0b8e\u0bae\u0bcd.\u0b8f.\u0b85\u0baa\u0bcd\u0ba4\u0bc1\u0bb2\u0bcd \u0bae\u0b9c\u0bc0\u0ba4\u0bcd",
  },
  "M.A.ABDUL RAZEEN": {
    si: "\u0d91\u0db8\u0dca.\u0d92.\u0d85\u0db6\u0dca\u0daf\u0dd4\u0dbd\u0dca \u0dbb\u0dc3\u0dd3\u0db1\u0dca",
    ta: "\u0b8e\u0bae\u0bcd.\u0b8f.\u0b85\u0baa\u0bcd\u0ba4\u0bc1\u0bb2\u0bcd \u0bb0\u0b9a\u0bc0\u0ba9\u0bcd",
  },
  "M.A.MOHAMED THAHIR": {
    si: "\u0d91\u0db8\u0dca.\u0d92.\u0db8\u0ddc\u0dc4\u0ddc\u0db8\u0da9\u0dca \u0dad\u0dcf\u0dc4\u0dd2\u0dbb\u0dca",
    ta: "\u0b8e\u0bae\u0bcd.\u0b8f.\u0bae\u0bc1\u0b95\u0bae\u0ba4\u0bc1 \u0ba4\u0bbe\u0bb9\u0bbf\u0bb0\u0bcd",
  },
  "M.ARIYADASA": {
    si: "\u0d91\u0db8\u0dca.\u0d86\u0dbb\u0dd2\u0dba\u0daf\u0dcf\u0dc3",
    ta: "\u0b8e\u0bae\u0bcd.\u0b85\u0bb0\u0bbf\u0baf\u0ba4\u0bbe\u0b9a",
  },
  "M.C.KALDEEN": {
    si: "\u0d91\u0db8\u0dca.\u0dc3\u0dd3.\u0d9a\u0dbd\u0dca\u0da9\u0dd3\u0db1\u0dca",
    ta: "\u0b8e\u0bae\u0bcd.\u0b9a\u0bbf.\u0b95\u0bb2\u0bcd\u0ba4\u0bc0\u0ba9\u0bcd",
  },
  "M.C.S.PERERA": {
    si: "\u0d91\u0db8\u0dca.\u0dc3\u0dd3.\u0d91\u0dc3\u0dca.\u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b8e\u0bae\u0bcd.\u0b9a\u0bbf.\u0b8e\u0bb8\u0bcd.\u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "M.G.M.IMTIYAZ": {
    si: "M.G.M.IMTIYAZ",
    ta: "\u0b8e\u0bae\u0bcd.\u0b9c\u0bbf.\u0b8e\u0bae\u0bcd.\u0b87\u0bae\u0bcd\u0ba4\u0bbf\u0baf\u0bbe\u0bb8\u0bcd",
  },
  "M.H.M.FAZLUL HAQ": {
    si: "\u0d91\u0db8\u0dca.\u0d91\u0da0\u0dca.\u0d91\u0db8\u0dca.\u0dc6\u0dc3\u0dca\u0dbd\u0dd4\u0dbd\u0dca \u0dc4\u0d9a\u0dca",
    ta: "M.H.M.FAZLUL HAQ",
  },
  "M.H.NAZEEMDEEN": {
    si: "\u0d91\u0db8\u0dca.\u0d91\u0da0\u0dca.\u0db1\u0dc3\u0dd3\u0db8\u0dca\u0da9\u0dd3\u0db1\u0dca",
    ta: "\u0b8e\u0bae\u0bcd.\u0b8e\u0b9a\u0bcd.\u0ba8\u0b9a\u0bc0\u0bae\u0bcd\u0ba4\u0bc0\u0ba9\u0bcd",
  },
  "M.H.S.D.PIYASENA": {
    si: "\u0d91\u0db8\u0dca.\u0d91\u0da0\u0dca.\u0d91\u0dc3\u0dca.\u0da9\u0dd3.\u0db4\u0dd2\u0dba\u0dc3\u0dda\u0db1",
    ta: "\u0b8e\u0bae\u0bcd.\u0b8e\u0b9a\u0bcd.\u0b8e\u0bb8\u0bcd.\u0b9f\u0bbf.\u0baa\u0bbf\u0baf\u0b9a\u0bc7\u0ba9",
  },
  "M.H.SARATH CHANDRASIRI": {
    si: "\u0d91\u0db8\u0dca.\u0d91\u0da0\u0dca.\u0dc3\u0dbb\u0dad\u0dca \u0da0\u0db1\u0dca\u0daf\u0dca\u200d\u0dbb\u0dc3\u0dd2\u0dbb\u0dd2",
    ta: "\u0b8e\u0bae\u0bcd.\u0b8e\u0b9a\u0bcd.\u0b9a\u0bb0\u0ba4\u0bcd \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0b9a\u0bbf\u0bb1\u0bbf",
  },
  "M.H.W.& R.L.FERNANDO": {
    si: "M.H.W.& R.L.FERNANDO",
    ta: "M.H.W. & R.L.Fernando",
  },
  "M.I.BADURDEEN": {
    si: "\u0d91\u0db8\u0dca.\u0d85\u0dba\u0dd2.\u0db6\u0daf\u0dd4\u0dbb\u0dca\u0daf\u0dd3\u0db1\u0dca",
    ta: "\u0b8e\u0bae\u0bcd.\u0b90.\u0baa\u0ba4\u0bc1\u0bb0\u0bcd\u0ba4\u0bc0\u0ba9\u0bcd",
  },
  "M.I.D.D.S.DARMARATHNA": {
    si: "M.I.D.D.S.DARMARATHNA",
    ta: "\u0b8e\u0bae\u0bcd.\u0b90.\u0b9f\u0bbf.\u0b9f\u0bbf.\u0b8e\u0bb8\u0bcd.\u0ba4\u0bb0\u0bcd\u0bae\u0bb0\u0ba4\u0bcd\u0ba9\u0bbe",
  },
  "M.I.DEEPAL DE SILVA DHARMARATHNE": {
    si: "\u0d91\u0db8\u0dca.\u0d85\u0dba\u0dd2.\u0daf\u0dd3\u0db4\u0dcf\u0dbd\u0dca \u0daf \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf \u0db0\u0dbb\u0dca\u0db8\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b8e\u0bae\u0bcd.\u0b90.\u0ba4\u0bc0\u0baa\u0bbe\u0bb2\u0bcd \u0b9f\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe \u0ba4\u0bb0\u0bcd\u0bae\u0bb0\u0ba4\u0bcd\u0ba9\u0bc7",
  },
  "M.I.M.FAIROOS": {
    si: "M.I.M.FAIROOS",
    ta: "M.I.M.FAIROOS",
  },
  "M.I.M.SHERIFF & SONS": {
    si: "\u0d91\u0db8\u0dca.\u0d85\u0dba\u0dd2.\u0d91\u0db8\u0dca.\u0dc2\u0dd9\u0dbb\u0dd2\u0dc6\u0dca \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b8e\u0bae\u0bcd.\u0b90.\u0b8e\u0bae\u0bcd.\u0bb7\u0bc6\u0bb0\u0bbf\u0b83\u0baa\u0bcd & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "M.I.M.UWAIS": {
    si: "M.I.M.UWAIS",
    ta: "\u0b8e\u0bae\u0bcd.\u0b90.\u0b8e\u0bae\u0bcd.\u0b89\u0bb5\u0bc8\u0bb8\u0bcd",
  },
  "M.K.M.AHAMED MOHIDEEN (PVT) LTD": {
    si: "M.K.M.Ahamed Mohideen (PVT) LTD",
    ta: "\u0b8e\u0bae\u0bcd.\u0b95\u0bc7.\u0b8e\u0bae\u0bcd.\u0b85\u0bb9\u0bae\u0ba4\u0bcd \u0bae\u0bca\u0bb9\u0bbf\u0ba4\u0bc0\u0ba9\u0bcd (\u0baa\u0bbf.\u0bb5\u0bbf.\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "M.K.SIRISENA": {
    si: "\u0d91\u0db8\u0dca.\u0d9a\u0dda.\u0dc3\u0dd2\u0dbb\u0dd2\u0dc3\u0dda\u0db1",
    ta: "\u0b8e\u0bae\u0bcd.\u0b95\u0bc7.\u0b9a\u0bbf\u0bb1\u0bbf\u0b9a\u0bc7\u0ba9\u0bbe",
  },
  "M.K.T.C.KARUNARATNE": {
    si: "M.K.T.C.\u0d9a\u0dbb\u0dd4\u0dab\u0dcf\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b8e\u0bae\u0bcd.\u0b95\u0bc7.\u0b9f\u0bbf.\u0b9a\u0bbf.\u0b95\u0bb0\u0bc1\u0ba3\u0bbe\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "M.L.M. FILLING STATION": {
    si: "\u0d91\u0db8\u0dca.\u0d91\u0dbd\u0dca.\u0d91\u0db8\u0dca. \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca \u0dc4\u0dbd",
    ta: "\u0b8e\u0bae\u0bcd.\u0b8e\u0bb2\u0bcd.\u0b8e\u0bae\u0bcd. \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "M.M.WALGAMAGE": {
    si: "\u0d91\u0db8\u0dca.\u0d91\u0db8\u0dca.\u0dc0\u0dbd\u0dca\u0d9c\u0db8\u0d9c\u0dda",
    ta: "\u0b8e\u0bae\u0bcd.\u0b8e\u0bae\u0bcd.\u0bb5\u0bb2\u0bcd\u0b95\u0bae\u0b95\u0bc7",
  },
  "M.MOHAMED YEKEEM": {
    si: "\u0d91\u0db8\u0dca.\u0db8\u0ddc\u0dc4\u0ddc\u0db8\u0da9\u0dca \u0dba\u0dd9\u0d9a\u0dd3\u0db8\u0dca",
    ta: "\u0b8e\u0bae\u0bcd.\u0bae\u0bc1\u0b95\u0bae\u0ba4\u0bc1 \u0baf\u0bc6\u0b95\u0bc0\u0bae\u0bcd",
  },
  "M.NILANTHA AMRALAL FERNANDO": {
    si: "\u0d91\u0db8\u0dca.\u0db1\u0dd2\u0dbd\u0db1\u0dca\u0dad \u0d85\u0db8\u0dca\u0dbb\u0dbd\u0dcf\u0dbd\u0dca \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0b8e\u0bae\u0bcd.\u0ba8\u0bbf\u0bb2\u0bbe\u0ba8\u0bcd\u0ba4 \u0b85\u0bae\u0bcd\u0bb0\u0bb2\u0bbe\u0bb2\u0bcd \u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "M.R.TENNAKOON": {
    si: "\u0d91\u0db8\u0dca.\u0d86\u0dbb\u0dca.\u0dad\u0dd9\u0db1\u0dca\u0db1\u0d9a\u0ddd\u0db1\u0dca",
    ta: "\u0b8e\u0bae\u0bcd.\u0b86\u0bb0\u0bcd.\u0ba4\u0bc6\u0ba9\u0bcd\u0ba9\u0b95\u0bcb\u0ba9\u0bcd",
  },
  "M.S.DIAS": {
    si: "M.S.DIAS",
    ta: "\u0b8e\u0bae\u0bcd.\u0b8e\u0bb8\u0bcd.\u0b9f\u0bbf\u0baf\u0bbe\u0bb8\u0bcd",
  },
  "M.S.M.FALULULLAH": {
    si: "M.S.M.Falulullah",
    ta: "M.S.M.Falulullah",
  },
  "M.S.M.IQBAL": {
    si: "M.S.M.IQBAL",
    ta: "\u0b8e\u0bae\u0bcd.\u0b8e\u0bb8\u0bcd.\u0b8e\u0bae\u0bcd.\u0b87\u0b95\u0bcd\u0baa\u0bbe\u0bb2\u0bcd",
  },
  "M.U.M.SUHOODI": {
    si: "M.U.M.SUHOODI",
    ta: "M.U.M.SUHOODI",
  },
  "M.W.PETER SINGHO": {
    si: "\u0d91\u0db8\u0dca.\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0db4\u0dd3\u0da7\u0dbb\u0dca \u0dc3\u0dd2\u0d82\u0dc4\u0ddd",
    ta: "\u0b8e\u0bae\u0bcd.\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0baa\u0bc0\u0b9f\u0bcd\u0b9f\u0bb0\u0bcd \u0b9a\u0bbf\u0b99\u0bcd\u0b95\u0bcb",
  },
  "M.WEERASINGHE ARACHCHI": {
    si: "\u0d91\u0db8\u0dca.\u0dc0\u0dd3\u0dbb\u0dc3\u0dd2\u0d82\u0dc4 \u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2",
    ta: "\u0b8e\u0bae\u0bcd.\u0bb5\u0bc0\u0bb0\u0b9a\u0bbf\u0b99\u0bcd\u0b95 \u0b86\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf",
  },
  "M.Y.MOHAMAD FAROOK": {
    si: "\u0d91\u0db8\u0dca.\u0dc0\u0dba\u0dd2.\u0db8\u0ddc\u0dc4\u0ddc\u0db8\u0da9\u0dca \u0dc6\u0dcf\u0dbb\u0dd4\u0d9a\u0dca",
    ta: "\u0b8e\u0bae\u0bcd.\u0b92\u0baf\u0bcd.\u0bae\u0bc1\u0b95\u0bae\u0ba4\u0bc1 \u0baa\u0bbe\u0bb0\u0bc2\u0b95\u0bcd",
  },
  "M248+G4J, Jaffna, Sri Lanka": {
    si: "M248+G4J, \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M248+G4J, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M26G+6V5, A9, Jaffna, Sri Lanka": {
    si: "M26G+6V5, A9, \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M26G+6V5, A9, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M296+MFR, 153 Kasthuriyar Rd, Jaffna 40000, Sri Lanka": {
    si: "M296+MFR, 153 \u0d9a\u0dc3\u0dca\u0dad\u0dd4\u0dbb\u0dd2\u0dba\u0dbb\u0dca \u0db4\u0dcf\u0dbb, \u0dba\u0dcf\u0db4\u0db1\u0dba 40000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M296+MFR, 153 \u0b95\u0bb8\u0bcd\u0ba4\u0bc2\u0bb0\u0bbf\u0baf\u0bbe\u0bb0\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd 40000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M2CR+CG2, Dehiattakandiya, Sri Lanka": {
    si: "M2CR+CG2, \u0daf\u0dd9\u0dc4\u0dd2\u0d85\u0dad\u0dca\u0dad\u0d9a\u0dab\u0dca\u0da9\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M2CR+CG2, \u0ba4\u0bc6\u0bb9\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0b95\u0ba3\u0bcd\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M2JQ+8GC, Jaffna, Sri Lanka": {
    si: "M2JQ+8GC, \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M2JQ+8GC, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M2JQ+GGQ, Adiyapatham Rd, Jaffna, Sri Lanka": {
    si: "M2JQ+GGQ, Adiyapatham Rd, \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M2JQ+GGQ, Adiyapatham Rd, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M2MF+3X6, Palali Rd, Jaffna, Sri Lanka": {
    si: "M2MF+3X6, \u0db4\u0dbd\u0dcf\u0dbd\u0dd2 \u0db4\u0dcf\u0dbb, \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M2MF+3X6, \u0baa\u0bb2\u0bbe\u0bb2\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M2PX+R7Q, Jaffna, Sri Lanka": {
    si: "M2PX+R7Q, \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M2PX+R7Q, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M2QH+V4H, Jaffna, Sri Lanka": {
    si: "M2QH+V4H, \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M2QH+V4H, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M2R9+HP5, Welpothuwewa, Sri Lanka": {
    si: "M2R9+HP5, \u0dc0\u0dd0\u0dbd\u0dca\u0db4\u0ddc\u0dad\u0dd4\u0dc0\u0dd0\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M2R9+HP5, \u0bb5\u0bc6\u0bb2\u0bcd\u0baa\u0bca\u0ba4\u0bc1\u0bb5\u0bc6\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M36H+XJH, Chavakachcheri, Sri Lanka": {
    si: "M36H+XJH, \u0da0\u0dcf\u0dc0\u0d9a\u0da0\u0dca\u0da0\u0dda\u0dbb\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M36H+XJH, \u0b9a\u0bbe\u0bb5\u0b95\u0b9a\u0bcd\u0b9a\u0bc7\u0bb0\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M3CW+6JW, Chavakachcheri, Sri Lanka": {
    si: "M3CW+6JW, \u0da0\u0dcf\u0dc0\u0d9a\u0da0\u0dca\u0da0\u0dda\u0dbb\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M3CW+6JW, \u0b9a\u0bbe\u0bb5\u0b95\u0b9a\u0bcd\u0b9a\u0bc7\u0bb0\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M3CX+HFJ, Chavakachcheri, Sri Lanka": {
    si: "M3CX+HFJ, \u0da0\u0dcf\u0dc0\u0d9a\u0da0\u0dca\u0da0\u0dda\u0dbb\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M3CX+HFJ, \u0b9a\u0bbe\u0bb5\u0b95\u0b9a\u0bcd\u0b9a\u0bc7\u0bb0\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M3VG+R77, Horana - Anguruwatota - Mathugama - Aluthgama Road, Ballapitiya, Sri Lanka":
    {
      si: "M3VG+R77, \u0dc4\u0ddc\u0dbb\u0dab - \u0d85\u0d9f\u0dd4\u0dbb\u0dd4\u0dc0\u0dcf\u0dad\u0ddc\u0da7 - \u0db8\u0dad\u0dd4\u0d9c\u0db8 - \u0d85\u0dbd\u0dd4\u0dad\u0dca\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0db6\u0dd0\u0dbd\u0dca\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "M3VG+R77, \u0bb9\u0bca\u0bb0\u0ba3\u0bc8 - \u0b85\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0bc1\u0bb5\u0ba4\u0bca\u0b9f\u0bcd\u0b9f - \u0bae\u0ba4\u0bcd\u0ba4\u0bc1\u0b95\u0bae - \u0b85\u0bb2\u0bc1\u0ba4\u0bcd\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bb2\u0bcd\u0bb2\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "M47R+P8F, Chavakachcheri, Sri Lanka": {
    si: "M47R+P8F, \u0da0\u0dcf\u0dc0\u0d9a\u0da0\u0dca\u0da0\u0dda\u0dbb\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M47R+P8F, \u0b9a\u0bbe\u0bb5\u0b95\u0b9a\u0bcd\u0b9a\u0bc7\u0bb0\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M52H+83F, Nagoda - Kalawellawa - Bellapitiya Rd, Bulathsinhala, Sri Lanka": {
    si: "M52H+83F, \u0db1\u0dcf\u0d9c\u0ddc\u0da9 - \u0d9a\u0dbd\u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dcf\u0dc0 - \u0db6\u0dd0\u0dbd\u0dca\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db6\u0dd4\u0dbd\u0dad\u0dca\u0dc3\u0dd2\u0d82\u0dc4\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M52H+83F, \u0ba8\u0bbe\u0b95\u0bca\u0b9f - \u0b95\u0bb2\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5 - \u0baa\u0bc6\u0bb2\u0bcd\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc1\u0bb2\u0ba4\u0bcd\u0b9a\u0bbf\u0b99\u0bcd\u0b95\u0bb3, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M53G+V6W, Bulathsinhala, Sri Lanka": {
    si: "M53G+V6W, \u0db6\u0dd4\u0dbd\u0dad\u0dca\u0dc3\u0dd2\u0d82\u0dc4\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M53G+V6W, \u0baa\u0bc1\u0bb2\u0ba4\u0bcd\u0b9a\u0bbf\u0b99\u0bcd\u0b95\u0bb3, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M557+RXQ, Chavakachcheri, Sri Lanka": {
    si: "M557+RXQ, \u0da0\u0dcf\u0dc0\u0d9a\u0da0\u0dca\u0da0\u0dda\u0dbb\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M557+RXQ, \u0b9a\u0bbe\u0bb5\u0b95\u0b9a\u0bcd\u0b9a\u0bc7\u0bb0\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M72M+Q3 Pachchilapalli, Sri Lanka": {
    si: "M72M+Q3 \u0db4\u0da0\u0dca\u0da0\u0dd2\u0dbd\u0db4\u0dbd\u0dca\u0dbd\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M72M+Q3 \u0baa\u0b9a\u0bcd\u0b9a\u0bbf\u0bb2\u0baa\u0bcd\u0baa\u0bb3\u0bcd\u0bb3\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M857+M56, Sri Lanka": {
    si: "M857+M56, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M857+M56, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M94C+GF7, Sri Lanka": {
    si: "M94C+GF7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M94C+GF7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "M9PW+F9Q, Ratnapura, Sri Lanka": {
    si: "M9PW+F9Q, \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "M9PW+F9Q, \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MACO LANKA FILLING STATION": {
    si: "\u0db8\u0dd0\u0d9a\u0ddd \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0bae\u0bc7\u0b95\u0bcb \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "MADAMPE MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda MPCS",
    ta: "\u0bae\u0b9f\u0bae\u0bcd\u0baa\u0bc7 MPCS LTD",
  },
  "MADAWALA ENTERPRISES": {
    si: "\u0db8\u0da9\u0dc0\u0dbd \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0bae\u0b9f\u0bb5\u0bb2 \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "MADHU CHURCH": {
    si: "\u0db8\u0da9\u0dd4 \u0db4\u0dbd\u0dca\u0dbd\u0dd2\u0dba",
    ta: "\u0bae\u0ba4\u0bc1 \u0b9a\u0bb0\u0bcd\u0b9a\u0bcd",
  },
  "MAGNET GROUP (PVT) LTD": {
    si: "\u0db8\u0dd0\u0d9c\u0dca\u0db1\u0da7\u0dca \u0d9c\u0df2\u0db4\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0bae\u0bc7\u0b95\u0bcd\u0ba9\u0bc6\u0b9f\u0bcd \u0b95\u0bc1\u0bb0\u0bc2\u0baa\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "MAHAMALAGE  BERNARD SURANGA FERNAND": {
    si: "\u0db8\u0dc4\u0dcf\u0db8\u0dbd\u0d9c\u0dda \u0db6\u0dbb\u0dca\u0db1\u0dcf\u0da9\u0dca \u0dc3\u0dd4\u0dbb\u0d82\u0d9c \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0bae\u0bb9\u0bbe\u0bae\u0bbe\u0bb2\u0bbe\u0b95\u0bc7 \u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd\u0b9f\u0bcd \u0b9a\u0bc1\u0bb0\u0b99\u0bcd\u0b95\u0bbe \u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcd",
  },
  "MAHANUWARA MPCS LTD": {
    si: "\u0db8\u0dc4\u0dcf\u0db1\u0dd4\u0dc0\u0dbb MPCS LTD",
    ta: "\u0bae\u0bb9\u0ba9\u0bc1\u0bb5\u0bbe\u0bb0\u0bbe MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "MAHARA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db8\u0dc4\u0dbb \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0bae\u0bb9\u0bbe\u0bb0\u0bbe MPCS LTD",
  },
  "MAHARAGAMA AUTO CARE CENTRE": {
    si: "\u0db8\u0dc4\u0dbb\u0d9c\u0db8 \u0d94\u0da7\u0ddd \u0d9a\u0dd9\u0dba\u0dcf\u0dbb\u0dca \u0dc3\u0dd9\u0db1\u0dca\u0da7\u0dbb\u0dca",
    ta: "\u0bae\u0bb9\u0bb0\u0b95\u0bae \u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0b95\u0bc7\u0bb0\u0bcd \u0b9a\u0bc6\u0ba9\u0bcd\u0b9f\u0bb0\u0bcd",
  },
  "MAHARAGAMA MPCS LTD": {
    si: "\u0db8\u0dc4\u0dbb\u0d9c\u0db8 MPCS LTD",
    ta: "\u0bae\u0bb9\u0bb0\u0b95\u0bae\u0bbe MPCS LTD",
  },
  "MAHAROOF HAJIYAR  M I": {
    si: "\u0db8\u0dc4\u0dbb\u0dd4\u0dc6\u0dca \u0dc4\u0dcf\u0da2\u0dd2\u0dba\u0dcf\u0dbb\u0dca \u0d91\u0db8\u0dca.\u0d85\u0dba\u0dd2",
    ta: "\u0bae\u0bb9\u0bb0\u0bc2\u0b83\u0baa\u0bcd \u0bb9\u0bbe\u0b9c\u0bbf\u0baf\u0bbe\u0bb0\u0bcd \u0b8e\u0bae\u0bcd.\u0b90",
  },
  "MAHIYANGANE MPCS LTD": {
    si: "\u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1\u0dda MPCS LTD",
    ta: "\u0bae\u0bb9\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0ba9\u0bc7 MPCS LTD",
  },
  "MAHO MPCS": {
    si: "\u0db8\u0dc4\u0ddd \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0bae\u0bb9\u0bcb \u0b8e\u0bae\u0bcd.\u0baa\u0bbf.\u0b9a\u0bbf.\u0b8e\u0bb8\u0bcd",
  },
  "MAHO MPCS LTD": {
    si: "MAHO MPCS LTD",
    ta: "\u0bae\u0bb9\u0bcb \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0b9a\u0bbf\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "MAIN STREET NAGOLLAGAMA, Sri Lanka": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc0\u0dd3\u0daf\u0dd2\u0dba \u0db1\u0dcf\u0d9c\u0ddc\u0dbd\u0dca\u0dbd\u0dcf\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bae\u0bc6\u0baf\u0bbf\u0ba9\u0bcd \u0bb8\u0bcd\u0b9f\u0bcd\u0bb0\u0bc0\u0b9f\u0bcd \u0ba8\u0bbe\u0b95\u0bca\u0bb2\u0bcd\u0bb2\u0b95\u0bbe\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MAKUMBURA, PANNIPITIYA.": {
    si: "MAKUMBURA, PANNIPITIYA.",
    ta: "MAKUMBURA, PANNIPITIYA.",
  },
  "MAL ENTERPRISES": {
    si: "MAL \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "MAL \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "MALALATHUNGA CONSTRUCTION (PVT)LTD": {
    si: "\u0db8\u0dbd\u0dbd\u0dad\u0dd4\u0d82\u0d9c \u0d9a\u0db1\u0dca\u0dc3\u0dca\u0da7\u0dca\u200d\u0dbb\u0d9a\u0dca\u0dc2\u0db1\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0bae\u0bb2\u0bb2\u0ba4\u0bc1\u0b99\u0bcd\u0b95\u0bbe \u0b95\u0ba9\u0bcd\u0bb8\u0bcd\u0b9f\u0bcd\u0bb0\u0b95\u0bcd\u0bb7\u0ba9\u0bcd (\u0baa\u0bbf.\u0bb5\u0bbf.\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "MALLIKA ENTERPRICESS": {
    si: "\u0db8\u0dbd\u0dca\u0dbd\u0dd2\u0d9a\u0dcf \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0bae\u0bb2\u0bcd\u0bb2\u0bbf\u0b95\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "MALLIKA SILVA": {
    si: "\u0db8\u0dbd\u0dca\u0dbd\u0dd2\u0d9a\u0dcf \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf",
    ta: "\u0bae\u0bb2\u0bcd\u0bb2\u0bbf\u0b95\u0bbe \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe",
  },
  "MALWADAMGE PRIYANTHA": {
    si: "\u0db8\u0dbd\u0dca\u0dc0\u0da9\u0db8\u0dca\u0d9c\u0dda \u0db4\u0dca\u200d\u0dbb\u0dd2\u0dba\u0db1\u0dca\u0dad",
    ta: "\u0bae\u0bbe\u0bb2\u0bcd\u0bb5\u0b9f\u0bae\u0bcd\u0b95\u0bc7 \u0baa\u0bbf\u0bb0\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bbe",
  },
  "MANCHANAYAKE PIRAVUMHALA": {
    si: "\u0db8\u0d82\u0da0\u0db1\u0dcf\u0dba\u0d9a \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0bae\u0b9e\u0bcd\u0b9a\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95\u0bc7 \u0baa\u0bbf\u0bb1\u0bb5\u0bc1\u0bae\u0bcd\u0bb9\u0bb2\u0bbe",
  },
  "MANGO TREE LANKA IOC FILLING": {
    si: "\u0d85\u0db9 \u0d9c\u0dc3 \u0dbd\u0d82\u0d9a\u0dcf IOC \u0db4\u0dd2\u0dbb\u0dc0\u0dd3\u0db8",
    ta: "\u0bae\u0bbe\u0bae\u0bcd\u0baa\u0bb4 \u0bae\u0bb0\u0bae\u0bcd \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b90\u0b93\u0b9a\u0bbf \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0ba4\u0bb2\u0bcd",
  },
  "MANIKKARAJA FUEL FILLING STATION": {
    si: "\u0db8\u0dcf\u0db1\u0dd2\u0d9a\u0dca\u0d9a\u0dbb\u0da2\u0dcf \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0bae\u0bbe\u0ba3\u0bbf\u0b95\u0bcd\u0b95\u0bb0\u0bbe\u0b9c\u0bbe \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "MANIPAY PARISH MPCS LTD": {
    si: "\u0db8\u0db1\u0dd2\u0db4\u0dcf\u0dba\u0dd2 \u0db4\u0dd0\u0dbb\u0dd2\u0dc2\u0dca MPCS LTD",
    ta: "\u0bae\u0bbe\u0ba9\u0bbf\u0baa\u0bcd\u0baa\u0bbe\u0baf\u0bcd \u0baa\u0bbe\u0bb0\u0bbf\u0bb7\u0bcd MPCS LTD",
  },
  "MANMUNAI SOUTH WEST MPCS LTD": {
    si: "\u0db8\u0db1\u0dca\u0db8\u0dd4\u0db1\u0dba\u0dd2 \u0daf\u0d9a\u0dd4\u0dab\u0dd4 \u0db6\u0da7\u0dc4\u0dd2\u0dbb MPCS LTD",
    ta: "\u0bae\u0ba3\u0bcd\u0bae\u0bc1\u0ba9\u0bc8 \u0ba4\u0bc6\u0ba9\u0bcd \u0bae\u0bc7\u0bb1\u0bcd\u0b95\u0bc1 MPCS LTD",
  },
  "MANMUNAIPATTU MPCS LTD": {
    si: "\u0db8\u0db1\u0dca\u0db8\u0dd4\u0db1\u0dba\u0dd2\u0db4\u0dad\u0dca\u0dad\u0dd4 MPCS LTD",
    ta: "\u0bae\u0ba3\u0bcd\u0bae\u0bc1\u0ba9\u0bc8\u0baa\u0bcd\u0baa\u0bb1\u0bcd\u0bb1\u0bc1 MPCS LTD",
  },
  "MANNAR MPCS LIMITED": {
    si: "\u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8 MPCS \u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad",
    ta: "\u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd \u0b8e\u0bae\u0bcd.\u0baa\u0bbf.\u0b9a\u0bbf.\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "MANNAR MPCS LTD": {
    si: "\u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8 MPCS LTD",
    ta: "\u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd \u0b8e\u0bae\u0bcd.\u0baa\u0bbf.\u0b9a\u0bbf.\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "MANTAI  SOUTH MPCS LTD": {
    si: "\u0db8\u0dcf\u0db1\u0dca\u0dad\u0dcf\u0dba\u0dd2 \u0daf\u0d9a\u0dd4\u0dab\u0dd4 MPCS LTD",
    ta: "\u0bae\u0bbe\u0ba8\u0bcd\u0ba4\u0bc8 \u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1 MPCS LTD",
  },
  "MANTHAI WEST MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad Manthai WEST MPCS",
    ta: "\u0bae\u0bbe\u0ba8\u0bcd\u0ba4\u0bc8 \u0bae\u0bc7\u0bb1\u0bcd\u0b95\u0bc1 MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  MARADAGAHAMULLA: {
    si: "\u0db8\u0dbb\u0daf\u0d9c\u0dc4\u0db8\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0bae\u0bb0\u0ba4\u0b95\u0bb9\u0bae\u0bc1\u0bb2\u0bcd\u0bb2",
  },
  "MARINE FUEL CENTRE": {
    si: "\u0dc3\u0db8\u0dd4\u0daf\u0dca\u200d\u0dbb \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db8\u0db0\u0dca\u200d\u0dba\u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba",
    ta: "\u0b95\u0b9f\u0bb2\u0bcd \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0bae\u0bc8\u0baf\u0bae\u0bcd",
  },
  "MARITIMEPATTU MPCS LTD": {
    si: "MARITIMEPATTU MPCS LTD",
    ta: "\u0bae\u0bb0\u0bbf\u0b9f\u0bc8\u0bae\u0bcd\u0baa\u0b9f\u0bcd\u0b9f\u0bc1 MPCS LTD",
  },
  "MASKELIYA MPCS LTD": {
    si: "\u0db8\u0dc3\u0dca\u0d9a\u0dd9\u0dc5\u0dd2\u0dba MPCS LTD",
    ta: "\u0bae\u0bb8\u0bcd\u0b95\u0bc6\u0bb2\u0bbf\u0baf\u0bbe MPCS LTD",
  },
  "MASTHAN   TRADERS": {
    si: "\u0db8\u0dc3\u0dca\u0dad\u0dcf\u0db1\u0dca \u0dc0\u0dd9\u0dc5\u0db3\u0dd4\u0db1\u0dca",
    ta: "\u0bae\u0bb8\u0bcd\u0ba4\u0bbe\u0ba9\u0bcd \u0bb5\u0bb0\u0bcd\u0ba4\u0bcd\u0ba4\u0b95\u0bb0\u0bcd\u0b95\u0bb3\u0bcd",
  },
  "MATALE MPCS LTD": {
    si: "\u0db8\u0dcf\u0dad\u0dbd\u0dda MPCS LTD",
    ta: "\u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8 MPCS LTD",
  },
  "MATHUGAMA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db8\u0dad\u0dd4\u0d9c\u0db8 MPCS",
    ta: "\u0bae\u0ba4\u0bc1\u0b95\u0bae MPCS LTD",
  },
  "MATUGAMA AGENCY (PVT) LTD": {
    si: "\u0db8\u0dad\u0dd4\u0d9c\u0db8 \u0d92\u0da2\u0db1\u0dca\u0dc3\u0dd2 (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0bae\u0b9f\u0bcd\u0b9f\u0bc1\u0b95\u0bae \u0b8f\u0b9c\u0bc6\u0ba9\u0bcd\u0b9a\u0bbf (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "MAWANELLA HEMMATAGAMA MPCS LTD": {
    si: "\u0db8\u0dcf\u0dc0\u0db1\u0dd0\u0dbd\u0dca\u0dbd \u0dc4\u0dd9\u0db8\u0dca\u0db8\u0dcf\u0dad\u0d9c\u0db8 MPCS LTD",
    ta: "\u0bae\u0bbe\u0bb5\u0ba9\u0bb2\u0bcd\u0bb2 \u0bb9\u0bc6\u0bae\u0bcd\u0bae\u0bbe\u0ba4\u0b95\u0bae\u0bbe MPCS LTD",
  },
  "MAWATHAGAMA MPCS LTD": {
    si: "\u0db8\u0dcf\u0dc0\u0dad\u0d9c\u0db8 MPCS LTD",
    ta: "\u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0b95\u0bae MPCS LTD",
  },
  "MAX HOLDINGS  KANDY (PVT) LTD": {
    si: "MAX Holdings KANDY (PVT) LTD",
    ta: "\u0bae\u0bc7\u0b95\u0bcd\u0bb8\u0bcd \u0bb9\u0bcb\u0bb2\u0bcd\u0b9f\u0bbf\u0b99\u0bcd\u0bb8\u0bcd \u0b95\u0ba3\u0bcd\u0b9f\u0bbf (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "MAYADUNNE FILLING CENTER": {
    si: "\u0db8\u0dcf\u0dba\u0dcf\u0daf\u0dd4\u0db1\u0dca\u0db1\u0dda \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca \u0db8\u0db0\u0dca\u200d\u0dba\u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba",
    ta: "\u0bae\u0bbe\u0baf\u0bbe\u0ba4\u0bc1\u0ba9\u0bcd\u0ba9\u0bc7 \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0bae\u0bc8\u0baf\u0bae\u0bcd",
  },
  "MAYADUNNE SERVICE STATION": {
    si: "\u0db8\u0dcf\u0dba\u0dcf\u0daf\u0dd4\u0db1\u0dca\u0db1\u0dda \u0dc3\u0dda\u0dc0\u0dcf \u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba",
    ta: "\u0bae\u0bbe\u0baf\u0bbe\u0ba4\u0bc1\u0ba9\u0bcd\u0ba9\u0bc7 \u0b9a\u0bc7\u0bb5\u0bc8 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "MBI Building, Colombo - Batticaloa Hwy, Akkaraipattu 32400, Sri Lanka": {
    si: "MBI \u0d9c\u0ddc\u0da9\u0db1\u0dd0\u0d9c\u0dd2\u0dbd\u0dca\u0dbd, \u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 Hwy, \u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0dd9\u0dba\u0dd2\u0db4\u0dad\u0dca\u0dad\u0dd4 32400, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MBI \u0b95\u0b9f\u0bcd\u0b9f\u0bbf\u0b9f\u0bae\u0bcd, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bc8\u0baa\u0bcd\u0baa\u0bb1\u0bcd\u0bb1\u0bc1 32400, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MCH2+MR4, Ratnapura, Sri Lanka": {
    si: "MCH2+MR4, \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MCH2+MR4, \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MCHF+7P5, Ibbagamuwa-Kumbukgete-Madagalla Rd, Kumbukgete, Sri Lanka": {
    si: "MCHF+7P5, \u0d89\u0db6\u0dca\u0db6\u0dcf\u0d9c\u0db8\u0dd4\u0dc0-\u0d9a\u0dd4\u0db9\u0dd4\u0d9a\u0dca\u0d9c\u0dd0\u0da7\u0dda-\u0db8\u0da9\u0d9c\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d9a\u0dd4\u0db9\u0dd4\u0d9a\u0dca\u0d9c\u0dd0\u0da7\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MCHF+7P5, \u0b87\u0baa\u0bcd\u0baa\u0bbe\u0b95\u0bae\u0bc1\u0bb5\u0bbe-\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0b95\u0bcd\u0b95\u0bc7\u0ba4\u0bcd\u0ba4\u0bc7-\u0bae\u0ba4\u0b95\u0bb2\u0bcd\u0bb2\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0b95\u0bcd\u0b95\u0bc7\u0b9f\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MCJ2+JJC, Ratnapura, Sri Lanka": {
    si: "MCJ2+JJC, \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MCJ2+JJC, \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MEDAWACHCHIYA MPCS LTD": {
    si: "\u0db8\u0dd0\u0daf\u0dc0\u0da0\u0dca\u0da0\u0dd2\u0dba MPCS LTD",
    ta: "\u0bae\u0bc7\u0b9f\u0bb5\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf\u0baf\u0bbe MPCS LTD",
  },
  MEDIRIGIRIYA: {
    si: "\u0db8\u0dd0\u0daf\u0dd2\u0dbb\u0dd2\u0d9c\u0dd2\u0dbb\u0dd2\u0dba",
    ta: "\u0bae\u0bc6\u0ba4\u0bbf\u0bb0\u0bbf\u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bbe",
  },
  "MEDIRIGIRIYA MPCS LTD": {
    si: "\u0db8\u0dd0\u0daf\u0dd2\u0dbb\u0dd2\u0d9c\u0dd2\u0dbb\u0dd2\u0dba MPCS LTD",
    ta: "\u0bae\u0bc6\u0ba4\u0bbf\u0bb0\u0bbf\u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bbe MPCS LTD",
  },
  MELSIRIPURA: {
    si: "\u0db8\u0dd0\u0dbd\u0dca\u0dc3\u0dd2\u0dbb\u0dd2\u0db4\u0dd4\u0dbb",
    ta: "\u0bae\u0bc6\u0bb2\u0bcd\u0b9a\u0bbf\u0bb0\u0bbf\u0baa\u0bc1\u0bb0\u0bbe",
  },
  "MG28+QQ5, A6, Melsiripura, Sri Lanka": {
    si: "MG28+QQ5, A6, \u0db8\u0dd0\u0dbd\u0dca\u0dc3\u0dd2\u0dbb\u0dd2\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MG28+QQ5, A6, \u0bae\u0bc6\u0bb2\u0bcd\u0b9a\u0bbf\u0bb0\u0bbf\u0baa\u0bc1\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MIDDLE EAST PETROLEUM DELEAR'S (PVT": {
    si: "\u0db8\u0dd0\u0daf \u0db4\u0dd9\u0dbb\u0daf\u0dd2\u0d9c \u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0ddd\u0dbd\u0dd2\u0dba\u0db8\u0dca \u0da9\u0dd2\u0dbd\u0dd2\u0dba\u0dbb\u0dca\u0dc3\u0dca (PVT",
    ta: "\u0bae\u0bbf\u0b9f\u0bbf\u0bb2\u0bcd \u0b88\u0bb8\u0bcd\u0b9f\u0bcd \u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bbf\u0baf\u0bae\u0bcd \u0b9f\u0bbf\u0bb2\u0bc7\u0baf\u0bb0\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf",
  },
  "MINERAL SPRINGS (PVT) LTD": {
    si: "MINERAL SPRINGS (PVT) LTD",
    ta: "\u0bae\u0bbf\u0ba9\u0bb0\u0bb2\u0bcd \u0bb8\u0bcd\u0baa\u0bbf\u0bb0\u0bbf\u0b99\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "MINUWANGODA MPCS LTD": {
    si: "\u0db8\u0dd2\u0db1\u0dd4\u0dc0\u0db1\u0dca\u0d9c\u0ddc\u0da9 MPCS LTD",
    ta: "\u0bae\u0bbf\u0ba9\u0bc1\u0bb5\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f MPCS LTD",
  },
  MIRIGAMA: {
    si: "\u0db8\u0dd3\u0dbb\u0dd2\u0d9c\u0db8",
    ta: "\u0bae\u0bbf\u0bb0\u0bbf\u0b95\u0bbe\u0bae\u0bbe",
  },
  "MIRIGAMA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db8\u0dd3\u0dbb\u0dd2\u0d9c\u0db8 MPCS",
    ta: "\u0bae\u0bbf\u0bb0\u0bbf\u0b95\u0bbe\u0bae\u0bbe MPCS LTD",
  },
  "MM3X+74H, A4, Balangoda, Sri Lanka": {
    si: "MM3X+74H, A4, \u0db6\u0dbd\u0db1\u0dca\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MM3X+74H, A4, \u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MM66+PWG, Batticaloa, Sri Lanka": {
    si: "MM66+PWG, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MM66+PWG, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MMW3+PQM, Batticaloa, Sri Lanka": {
    si: "MMW3+PQM, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MMW3+PQM, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MMX3+X8H, Naula, Sri Lanka": {
    si: "MMX3+X8H, \u0db1\u0dcf\u0d8b\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MMX3+X8H, \u0ba8\u0bcc\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MMXF+44G, Batticaloa, Sri Lanka": {
    si: "MMXF+44G, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MMXF+44G, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MONERAGALA KANDUKARA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db8\u0ddc\u0db1\u0dbb\u0dcf\u0d9c\u0dbd \u0d9a\u0db3\u0dd4\u0d9a\u0dbb MPCS",
    ta: "\u0bae\u0bca\u0ba9\u0bb0\u0bbe\u0b95\u0bb2\u0bbe \u0b95\u0ba3\u0bcd\u0b9f\u0bc1\u0b95\u0bb0\u0bbe MPCS LTD",
  },
  "MORATUWA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0 MPCS",
    ta: "\u0bae\u0bca\u0bb0\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe MPCS LTD",
  },
  "MORAWAKAKORALA TEA PRO.CO-OP.SO.LTD": {
    si: "\u0db8\u0ddc\u0dbb\u0dc0\u0d9a\u0d9a\u0ddd\u0dbb\u0dc5 \u0dad\u0dda PRO.CO-OP.SO.LTD",
    ta: "\u0bae\u0bca\u0bb0\u0bb5\u0b95\u0b95\u0bcb\u0bb0\u0bb3 \u0b9f\u0bc0 \u0baa\u0bcd\u0bb0\u0bcb.\u0b95\u0bcb-\u0b93.\u0baa\u0bbf.\u0b8e\u0bb8\u0bcd.\u0b93. \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  MORAWEWA: {
    si: "\u0db8\u0ddc\u0dbb\u0dc0\u0dd0\u0dc0",
    ta: "\u0bae\u0bca\u0bb0\u0bb5\u0bc6\u0bb5",
  },
  "MOTOR SERVICE STATION (PVT) LTD": {
    si: "\u0db8\u0ddd\u0da7\u0dbb\u0dca \u0dc3\u0dbb\u0dca\u0dc0\u0dd2\u0dc3\u0dca \u0dc3\u0dca\u0da7\u0dda\u0dc2\u0db1\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0bae\u0bcb\u0b9f\u0bcd\u0b9f\u0bbe\u0bb0\u0bcd \u0b9a\u0bb0\u0bcd\u0bb5\u0bc0\u0bb8\u0bcd \u0bb8\u0bcd\u0b9f\u0bc7\u0bb7\u0ba9\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "MP2W+34G, Colombo - Ratnapura - Wellawaya - Batticaloa Road, Kattankudy, Sri Lanka":
    {
      si: "MP2W+34G, \u0d9a\u0ddc\u0dc5\u0db9 - \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb - \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0d9a\u0dcf\u0dad\u0dca\u0dad\u0db1\u0dca\u0d9a\u0dd4\u0da9\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "MP2W+34G, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf - \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bbe\u0ba4\u0bcd\u0ba4\u0bbe\u0ba9\u0bcd\u0b95\u0bc1\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "MP43+R29,   -      , Balangoda, Sri Lanka": {
    si: "MP43+R29, - , \u0db6\u0dbd\u0db1\u0dca\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MP43+R29, - , \u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MPFJ+XQ7, Batticaloa, Sri Lanka": {
    si: "MPFJ+XQ7, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MPFJ+XQ7, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MPFM+78Q, New Kalmunai Rd, Batticaloa, Sri Lanka": {
    si: "MPFM+78Q, New Kalmunai Rd, Batticaloa, Sri Lanka",
    ta: "MPFM+78Q, \u0baa\u0bc1\u0ba4\u0bbf\u0baf \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MPQF+GMV, Kattankudy, Sri Lanka": {
    si: "MPQF+GMV, \u0d9a\u0dcf\u0dad\u0dca\u0dad\u0db1\u0dca\u0d9a\u0dd4\u0da9\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MPQF+GMV, \u0b95\u0bbe\u0ba4\u0bcd\u0ba4\u0bbe\u0ba9\u0bcd\u0b95\u0bc1\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MR.  K.E.LEONARD PEIRIS": {
    si: "\u0db8\u0dc4\u0dad\u0dcf. \u0d9a\u0dda.\u0d8a.\u0dbd\u0dd9\u0db1\u0dcf\u0da9\u0dca \u0db4\u0dd3\u0dbb\u0dd2\u0dc3\u0dca",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1. \u0b95\u0bc7.\u0b87.\u0bb2\u0bbf\u0baf\u0bcb\u0ba9\u0bbe\u0bb0\u0bcd\u0b9f\u0bcd \u0baa\u0bc0\u0bb0\u0bbf\u0bb8\u0bcd",
  },
  "MR.  K.P. A.WAHID": {
    si: "\u0db8\u0dc4\u0dad\u0dcf. \u0d9a\u0dda.\u0db4\u0dd3. A.WAHID",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1. \u0b95\u0bc7.\u0baa\u0bbf. \u0b8f.\u0bb5\u0bbe\u0bb9\u0bbf\u0ba4\u0bcd",
  },
  "MR.  T.RATNAVADIVEL": {
    si: "\u0db8\u0dc4\u0dad\u0dcf. \u0da7\u0dd3.\u0dbb\u0dad\u0dca\u0db1\u0dc0\u0da9\u0dd2\u0dc0\u0dd9\u0dbd\u0dca",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1. \u0ba4.\u0bb0\u0ba4\u0bcd\u0ba9\u0bbe\u0bb5\u0b9f\u0bbf\u0bb5\u0bc7\u0bb2\u0bcd",
  },
  "MR.  W W A K J.FERNANDO": {
    si: "\u0db8\u0dc4\u0dad\u0dcf. \u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0d92 \u0d9a\u0dda \u0da2\u0dda. \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1. \u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b8f \u0b95\u0bc7 \u0b9c\u0bc7.\u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "MR. MC PERERA/ MRS. CA WANNIARACHCH": {
    si: "\u0db8\u0dc4\u0dad\u0dcf. \u0d91\u0db8\u0dca.\u0dc3\u0dd3.\u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf/ \u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba. \u0dc3\u0dd3.\u0d92 \u0dc0\u0db1\u0dca\u0db1\u0dd2\u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1. \u0b8e\u0bae\u0bcd.\u0b9a\u0bbf. \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe/ \u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf. \u0b9a\u0bbf\u0b8f \u0bb5\u0ba9\u0bcd\u0ba9\u0bbf\u0baf\u0bbe\u0bb0\u0bbe\u0b9a\u0bcd",
  },
  "MR. R.A.GAYAN": {
    si: "\u0db8\u0dc4\u0dad\u0dcf. \u0d86\u0dbb\u0dca.\u0d92.\u0d9c\u0dba\u0dcf\u0db1\u0dca",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1. \u0b86\u0bb0\u0bcd.\u0b8f.\u0b95\u0baf\u0ba9\u0bcd",
  },
  "MR. VA.SUSANTHA / MRS. HRP MGUNARAT": {
    si: "\u0db8\u0dc4\u0dad\u0dcf. \u0dc0\u0dcf.\u0dc3\u0dd4\u0dc3\u0db1\u0dca\u0dad\u0dcf / \u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba. HRP MGUNARAT",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1. \u0bb5\u0bbe.\u0b9a\u0bc1\u0b9a\u0bbe\u0ba8\u0bcd\u0ba4\u0bbe / \u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf. HRP MGUNARAT",
  },
  "MR.S. PRIYA AMARASINGHE": {
    si: "\u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba. \u0db4\u0dca\u200d\u0dbb\u0dd2\u0dba\u0dcf \u0d85\u0db8\u0dbb\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf. \u0baa\u0bbf\u0bb0\u0bbf\u0baf\u0bbe \u0b85\u0bae\u0bb0\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "MR8P+V7H, Nalladarankattuwa, Sri Lanka": {
    si: "MR8P+V7H, \u0db1\u0dbd\u0dca\u0dbd\u0daf\u0dbb\u0db1\u0dca\u0d9a\u0da7\u0dca\u0da7\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MR8P+V7H, \u0ba8\u0bb2\u0bcd\u0bb2\u0ba4\u0bb0\u0ba9\u0bcd\u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MRS C R SAMARASINGHE": {
    si: "\u0dc3\u0dd3 \u0d86\u0dbb\u0dca \u0dc3\u0db8\u0dbb\u0dc3\u0dd2\u0d82\u0dc4 \u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf \u0b9a\u0bbf \u0b86\u0bb0\u0bcd \u0b9a\u0bae\u0bb0\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "MRS K A A H DE SILVA": {
    si: "KA AH DE \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf \u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf \u0b95\u0bc7 \u0b8f \u0b8e \u0b8e\u0b9a\u0bcd \u0b9f\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe",
  },
  "MRS M D PATHMA NILMINI": {
    si: "\u0d91\u0db8\u0dca \u0da9\u0dd3 \u0db4\u0dad\u0dca\u0db8\u0dcf \u0db1\u0dd2\u0dbd\u0dca\u0db8\u0dd2\u0dab\u0dd2 \u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf \u0b8e\u0bae\u0bcd \u0b9f\u0bbf \u0baa\u0ba4\u0bcd\u0bae\u0bbe \u0ba8\u0bbf\u0bb2\u0bcd\u0bae\u0bbf\u0ba9\u0bbf",
  },
  "MRS R P JAYASINGHE": {
    si: "\u0d86\u0dbb\u0dca \u0db4\u0dd3 \u0da2\u0dba\u0dc3\u0dd2\u0d82\u0dc4 \u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf \u0b86\u0bb0\u0bcd \u0baa\u0bbf \u0b9c\u0baf\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "MRS SOMA ABHAYAWARDHANA": {
    si: "\u0dc3\u0ddd\u0db8\u0dcf \u0d85\u0db7\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1 \u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf \u0b9a\u0bcb\u0bae \u0b85\u0baa\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9",
  },
  "MRS WIMALA SIRISENA": {
    si: "\u0dc0\u0dd2\u0db8\u0dbd\u0dcf \u0dc3\u0dd2\u0dbb\u0dd2\u0dc3\u0dda\u0db1 \u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf \u0bb5\u0bbf\u0bae\u0bb2 \u0b9a\u0bbf\u0bb0\u0bbf\u0b9a\u0bc7\u0ba9\u0bbe",
  },
  "MRS.  L.PADUMASHEELA NANDANEE DE SI": {
    si: "\u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba. \u0d91\u0dbd\u0dca.\u0db4\u0daf\u0dd4\u0db8\u0dc1\u0dd3\u0dbd\u0dcf \u0db1\u0db1\u0dca\u0daf\u0db1\u0dd3 \u0daf \u0d91\u0dc3\u0dca.\u0d85\u0dba\u0dd2",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf. \u0b8e\u0bb2\u0bcd.\u0baa\u0ba4\u0bc1\u0bae\u0bb7\u0bc0\u0bb2\u0bbe \u0ba8\u0ba8\u0bcd\u0ba4\u0ba9\u0bc0 \u0b9f\u0bbf \u0b8e\u0bb8\u0bcd\u0b90",
  },
  "MRS.  R.RAJALEDCHUMY": {
    si: "\u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba. \u0d86\u0dbb\u0dca.\u0dbb\u0dcf\u0da2\u0dbd\u0dd9\u0da9\u0dca\u0da0\u0dd4\u0db8\u0dd2",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf. \u0b86\u0bb0\u0bcd.\u0bb0\u0bbe\u0b9c\u0bb2\u0bc6\u0b9f\u0bcd\u0b9a\u0bc1\u0bae\u0bbf",
  },
  "MRS.  WIMALA WERAGODA": {
    si: "\u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba. \u0dc0\u0dd2\u0db8\u0dbd\u0dcf \u0dc0\u0dda\u0dbb\u0d9c\u0ddc\u0da9",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf. \u0bb5\u0bbf\u0bae\u0bb2\u0bbe \u0bb5\u0bc7\u0bb0\u0b95\u0bca\u0b9f",
  },
  "MRS. A. L. G..GONAKUMBURA": {
    si: "\u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba. \u0d92.\u0d91\u0dbd\u0dca.\u0da2\u0dd3..\u0d9c\u0ddd\u0db1\u0d9a\u0dd4\u0db9\u0dd4\u0dbb",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf. \u0b8f.\u0b8e\u0bb2\u0bcd.\u0b9c\u0bbf..\u0b95\u0bcb\u0ba9\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bbe",
  },
  "MRS. J KANAGARASAN & SISTER": {
    si: "\u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba. \u0da2\u0dda \u0d9a\u0db1\u0d9c\u0dbb\u0dcf\u0dc3\u0db1\u0dca \u0dc3\u0dc4 \u0dc3\u0dc4\u0ddd\u0daf\u0dbb\u0dd2\u0dba",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf. \u0b9c\u0bc7 \u0b95\u0ba9\u0b95\u0bb0\u0bbe\u0b9a\u0ba9\u0bcd & \u0b9a\u0b95\u0bcb\u0ba4\u0bb0\u0bbf",
  },
  "MRS. L S K.DISSANAYAKE": {
    si: "\u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba. \u0d91\u0dbd\u0dca \u0d91\u0dc3\u0dca \u0d9a\u0dda \u0daf\u0dd2\u0dc3\u0dcf\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf. \u0b8e\u0bb2\u0bcd \u0b8e\u0bb8\u0bcd \u0b95\u0bc7.\u0ba4\u0bbf\u0b9a\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "MRS. S.L.HETTIARACHCHI & SONS": {
    si: "\u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba. \u0d91\u0dc3\u0dca.\u0d91\u0dbd\u0dca.\u0dc4\u0dd9\u0da7\u0dca\u0da7\u0dd2\u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf. \u0b8e\u0bb8\u0bcd.\u0b8e\u0bb2\u0bcd.\u0bb9\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0bbe\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "MRS. SUGANTHI KISHORE": {
    si: "\u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba. \u0dc3\u0dd4\u0d9c\u0db1\u0dca\u0dad\u0dd2 \u0d9a\u0dd2\u0dc2\u0ddd\u0dbb\u0dca",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf. \u0b9a\u0bc1\u0b95\u0ba8\u0bcd\u0ba4\u0bbf \u0b95\u0bbf\u0bb7\u0bcb\u0bb0\u0bcd",
  },
  "MRS. W.M.M.FERNENDO & SON": {
    si: "\u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba. W.M.M.FERNENDO & SON",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf. W.M.M.FERNENDO & SON",
  },
  "MS.  BALANGODA MPCS LTD": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. \u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db6\u0dbd\u0d82\u0d9c\u0ddc\u0da9 MPCS",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f MPCS LTD",
  },
  "MS.  BIYANWILA SONS": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. \u0db6\u0dd2\u0dba\u0db1\u0dca\u0dc0\u0dd2\u0dbd \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0baa\u0bc8\u0baf\u0ba9\u0bcd\u0bb5\u0bbf\u0bb2 \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "MS.  CEYLON FISHERY HARBOURS CORPOR": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. \u0dbd\u0d82\u0d9a\u0dcf \u0db0\u0dd3\u0dc0\u0dbb \u0dc0\u0dbb\u0dcf\u0dba \u0dc3\u0d82\u0dc3\u0dca\u0dae\u0dcf\u0dc0",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0b9a\u0bbf\u0bb2\u0bcb\u0ba9\u0bcd \u0b83\u0baa\u0bbf\u0bb7\u0bb0\u0bbf \u0bb9\u0bbe\u0bb0\u0bcd\u0baa\u0bb0\u0bcd\u0bb8\u0bcd \u0b95\u0bbe\u0bb0\u0bcd\u0baa\u0bcd\u0baa\u0bb0\u0bc7\u0bb7\u0ba9\u0bcd",
  },
  "MS.  DELFT MPCS LTD": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. DELFT MPCS LTD",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. DELFT MPCS LTD",
  },
  "MS.  ECHANTIVU KANNANKUDAH MPCS LTD": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. \u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d91\u0da0\u0db1\u0dca\u0dad\u0dd2\u0dc0\u0dd4 \u0d9a\u0db1\u0dca\u0db1\u0db1\u0dca\u0d9a\u0dd4\u0da9\u0dcf MPCS",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0b8e\u0b9a\u0bcd\u0b9a\u0ba3\u0bcd\u0b9f\u0bbf\u0bb5\u0bc1 \u0b95\u0ba3\u0bcd\u0ba3\u0ba9\u0bcd\u0b95\u0bc1\u0b9f\u0bbe MPCS LTD",
  },
  "MS.  GOMARANKADAWELA MORAWEWA MPCS": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. \u0d9c\u0ddd\u0db8\u0dbb\u0db1\u0dca\u0d9a\u0da9\u0dc0\u0dd9\u0dbd \u0db8\u0ddc\u0dbb\u0dc0\u0dd0\u0dc0 \u0d91\u0db8\u0dca.\u0db4\u0dd3.\u0dc3\u0dd3.\u0d91\u0dc3\u0dca",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0b95\u0bcb\u0bae\u0bb0\u0b99\u0bcd\u0b95\u0b9f\u0bb5\u0bc6\u0bb2 \u0bae\u0bca\u0bb0\u0bb5\u0bc6\u0bb5 \u0b8e\u0bae\u0bcd.\u0baa\u0bbf.\u0b9a\u0bbf.\u0b8e\u0bb8\u0bcd",
  },
  "MS.  HITECH CARBONS (PVT) LTD": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. HITECH \u0d9a\u0dcf\u0db6\u0db1\u0dca (PVT) LTD",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0bb9\u0bc8\u0b9f\u0bc6\u0b95\u0bcd \u0b95\u0bbe\u0bb0\u0bcd\u0baa\u0ba9\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "MS.  IHALA LELWALA MPCS LTD": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. \u0d89\u0dc4\u0dc5 \u0dbd\u0dda\u0dbd\u0dca\u0dc0\u0dbd MPCS LTD",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0b87\u0bb9\u0bb2 \u0bb2\u0bc6\u0bb2\u0bcd\u0bb5\u0bbe\u0bb2\u0bbe MPCS LTD",
  },
  "MS.  KAUDULLA MPCS LTD": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. \u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0d9a\u0dc0\u0dd4\u0da9\u0dd4\u0dbd\u0dca\u0dbd \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0b95\u0bcc\u0ba4\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe MPCS LTD",
  },
  "MS.  MEDAMAWATHA HOLDINGS (PVT) LTD": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. \u0db8\u0dd0\u0daf\u0db8\u0dcf\u0dc0\u0dad \u0dc4\u0ddd\u0dbd\u0dca\u0da9\u0dd2\u0db1\u0dca\u0d9c\u0dca\u0dc3\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0bae\u0bc6\u0b9f\u0bae\u0bbe\u0bb5\u0ba4\u0bbe \u0bb9\u0bcb\u0bb2\u0bcd\u0b9f\u0bbf\u0b99\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "MS.  N P G APPUSINGHO & SONS": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. \u0d91\u0db1\u0dca \u0db4\u0dd3 \u0da2\u0dd3 \u0d85\u0db4\u0dca\u0db4\u0dd4\u0dc3\u0dd2\u0d82\u0dc4 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0b8e\u0ba9\u0bcd \u0baa\u0bbf \u0b9c\u0bbf \u0b85\u0baa\u0bcd\u0baa\u0bc1\u0b9a\u0bbf\u0b99\u0bcd\u0bb9\u0bcb & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "MS.  NEGOMBO SOUTH FISHERMENS CS LT": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 \u0daf\u0d9a\u0dd4\u0dab\u0dd4 \u0db0\u0dd3\u0dc0\u0dbb\u0dba\u0dd2\u0db1\u0dca CS LT",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1 \u0bae\u0bc0\u0ba9\u0bb5\u0bb0\u0bcd\u0b95\u0bb3\u0bcd CS LT",
  },
  "MS.  NIM LANKA (PVT) LTD": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. NIM LANKA (PVT) LTD",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. NIM LANKA (PVT) LTD",
  },
  "MS.  PALUGASDAMANA MPCS LTD": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. \u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db4\u0dbd\u0dd4\u0d9c\u0dc3\u0dca\u0da9\u0db8\u0db1 MPCS",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0baa\u0bb2\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bae\u0ba9\u0bbe MPCS LTD",
  },
  "MS.  PULOLY MPCS LTD": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. \u0db4\u0dd4\u0dbd\u0ddd\u0dbd\u0dd2 \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0baa\u0bc1\u0bb2\u0bcb\u0bb2\u0bbf \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0b9a\u0bbf\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "MS.  RATGAMA MPCS LTD": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. \u0dbb\u0dad\u0dca\u0d9c\u0db8 MPCS LTD",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0bb0\u0ba4\u0bcd\u0b95\u0bbe\u0bae\u0bbe MPCS LTD",
  },
  "MS.  S.A.R.ROSA ENTERPRISES": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. S.A.R.ROSA \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0b8e\u0bb8\u0bcd.\u0b8f.\u0b86\u0bb0\u0bcd.\u0bb0\u0bcb\u0b9a\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "MS.  SIRIPURA LANKA PIRAVUM HALA": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. \u0dc3\u0dd2\u0dbb\u0dd2\u0db4\u0dd4\u0dbb \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca \u0dc4\u0dbd\u0dcf",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0b9a\u0bbf\u0bb1\u0bbf\u0baa\u0bc1\u0bb0 \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0baa\u0bbf\u0bb1\u0bb5\u0bc1\u0bae\u0bcd \u0bb9\u0bb2\u0bbe",
  },
  "MS. RELIANCE CHEMICALS COMPANY (PVT": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. RELIANCE chemicals company (PVT",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0bb0\u0bbf\u0bb2\u0bc8\u0baf\u0ba9\u0bcd\u0bb8\u0bcd \u0b95\u0bc6\u0bae\u0bbf\u0b95\u0bcd\u0b95\u0bb2\u0bcd\u0bb8\u0bcd \u0ba8\u0bbf\u0bb1\u0bc1\u0bb5\u0ba9\u0bae\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf",
  },
  "MS. SURANGI SENARATH": {
    si: "\u0db8\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dba. \u0dc3\u0dd4\u0dbb\u0d82\u0d9c\u0dd2 \u0dc3\u0dd9\u0db1\u0dbb\u0dad\u0dca",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bbf. \u0b9a\u0bc1\u0bb0\u0b99\u0bcd\u0b95\u0bbf \u0b9a\u0bc6\u0ba9\u0bb0\u0ba4\u0bcd",
  },
  "MS.M.Y.HEMACHANDRA & CO. (TRANS.) L": {
    si: "MS.M.Y.\u0dc4\u0dda\u0db8\u0da0\u0db1\u0dca\u0daf\u0dca\u200d\u0dbb \u0dc3\u0dc4 \u0dc3\u0db8\u0dcf\u0d9c\u0db8 (Trans.) L",
    ta: "\u0b8e\u0bae\u0bcd.\u0b8e\u0bb8\u0bcd.\u0b8e\u0bae\u0bcd.\u0b92\u0baf\u0bcd.\u0bb9\u0bc7\u0bae\u0b9a\u0bcd\u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0bbe & \u0b95\u0bcb. (\u0b9f\u0bbf\u0bb0\u0bbe\u0ba9\u0bcd\u0bb8\u0bcd.) \u0b8e\u0bb2\u0bcd",
  },
  "MULLAITIVU FISHERMENS' CS LTD": {
    si: "\u0db8\u0dd4\u0dbd\u0dad\u0dd2\u0dc0\u0dca \u0db0\u0dd3\u0dc0\u0dbb\u0dba\u0dd2\u0db1\u0dca\u0d9c\u0dda CS LTD",
    ta: "\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bc8\u0ba4\u0bcd\u0ba4\u0bc0\u0bb5\u0bc1 \u0bae\u0bc0\u0ba9\u0bb5\u0bb0\u0bcd\u0b95\u0bb3\u0bcd \u0b9a\u0bbf\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  MULLIYAWALI: {
    si: "\u0db8\u0dd4\u0dbd\u0dca\u0dbd\u0dd2\u0dba\u0dcf\u0dc0\u0dbd\u0dd2",
    ta: "\u0bae\u0bc1\u0bb3\u0bcd\u0bb3\u0bbf\u0baf\u0bb5\u0bbe\u0bb2\u0bbf",
  },
  "MUNDALAMA MADURANKULIYA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db8\u0dd4\u0db1\u0dca\u0daf\u0dbd\u0db8 \u0db8\u0daf\u0dd4\u0dbb\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0dd2\u0dba MPCS",
    ta: "\u0bae\u0bc1\u0ba3\u0bcd\u0b9f\u0bb2\u0bae\u0bbe \u0bae\u0ba4\u0bc1\u0bb0\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bbf\u0baf MPCS LTD",
  },
  "MURUGESU GUNARATNAM": {
    si: "\u0db8\u0dd4\u0dbb\u0dd4\u0d9c\u0dda\u0dc3\u0dd4 \u0d9c\u0dd4\u0dab\u0dbb\u0dad\u0dca\u0db1\u0db8\u0dca",
    ta: "\u0bae\u0bc1\u0bb0\u0bc1\u0b95\u0bc7\u0b9a\u0bc1 \u0b95\u0bc1\u0ba3\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0bae\u0bcd",
  },
  "MUTHUIANKADDU MPCS LTD": {
    si: "\u0db8\u0dd4\u0dad\u0dd4\u0dba\u0db1\u0dca\u0d9a\u0da9\u0dd4 MPCS LTD",
    ta: "\u0bae\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0baf\u0ba9\u0bcd\u0b95\u0b9f\u0bcd\u0b9f\u0bc1 MPCS LTD",
  },
  "MUTHUR AGA DIVISION MPCS LTD,": {
    si: "\u0db8\u0dd4\u0dad\u0dd4\u0dbb\u0dca \u0d85\u0d9c \u0d85\u0d82\u0dc1\u0dba MPCS LTD,",
    ta: "\u0bae\u0bc1\u0ba4\u0bcd\u0ba4\u0bc2\u0bb0\u0bcd \u0b86\u0b95\u0bbe \u0baa\u0bbf\u0bb0\u0bbf\u0bb5\u0bc1 MPCS LTD,",
  },
  "MUTTUR A G A DIVISION MPCS LTD": {
    si: "\u0db8\u0dd4\u0dad\u0dd6\u0dbb\u0dca \u0d92 \u0da2\u0dd3 \u0d92 \u0da9\u0dd2\u0dc0\u0dd2\u0dc2\u0db1\u0dca \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0bae\u0bc2\u0ba4\u0bc2\u0bb0\u0bcd \u0b8f \u0b9c\u0bbf \u0b8f \u0b9f\u0bbf\u0bb5\u0bbf\u0bb7\u0ba9\u0bcd \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0b9a\u0bbf\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "MUTTUR A.G.A.DIVISION MPCS LTD": {
    si: "\u0db8\u0dd4\u0dad\u0dd6\u0dbb\u0dca A.G.A.\u0da9\u0dd2\u0dc0\u0dd2\u0dc2\u0db1\u0dca MPCS LTD",
    ta: "\u0bae\u0bc2\u0ba4\u0bc2\u0bb0\u0bcd \u0b8f.\u0b9c\u0bbf.\u0b8f.\u0b9f\u0bbf\u0bb5\u0bbf\u0bb7\u0ba9\u0bcd \u0b8e\u0bae\u0bcd.\u0baa\u0bbf.\u0b9a\u0bbf.\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "MV6P+6GG, Kalthota, Sri Lanka": {
    si: "MV6P+6GG, \u0d9a\u0dbd\u0dca\u0dad\u0ddc\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MV6P+6GG, \u0b95\u0bb2\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MVV9+X6M, Kayts, Sri Lanka": {
    si: "MVV9+X6M, \u0d9a\u0dba\u0dd2\u0da7\u0dca\u0dc3\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MVV9+X6M, \u0b8a\u0bb0\u0bcd\u0b95\u0bbe\u0bb5\u0bb1\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MW4M+3RX, Wadduwa, Sri Lanka": {
    si: "MW4M+3RX, \u0dc0\u0dcf\u0daf\u0dca\u0daf\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MW4M+3RX, \u0bb5\u0bbe\u0ba4\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MW8H+JJ3, A2, Wadduwa, Sri Lanka": {
    si: "MW8H+JJ3, A2, \u0dc0\u0dcf\u0daf\u0dca\u0daf\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MW8H+JJ3, A2, Wadduwa, Sri Lanka",
  },
  "MWP9+MF4, Panadura, Sri Lanka": {
    si: "MWP9+MF4, \u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MWP9+MF4, \u0baa\u0bbe\u0ba3\u0ba8\u0bcd\u0ba4\u0bc1\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MX2Q+HJF, Weerapokuna, Sri Lanka": {
    si: "MX2Q+HJF, \u0dc0\u0dd3\u0dbb\u0db4\u0ddc\u0d9a\u0dd4\u0dab, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MX2Q+HJF, \u0bb5\u0bc0\u0bb0\u0baa\u0bca\u0b95\u0bc1\u0ba3, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MX7C+8VC, Moronthuduwa, Sri Lanka": {
    si: "MX7C+8VC, \u0db8\u0ddc\u0dbb\u0ddc\u0db1\u0dca\u0dad\u0dd4\u0da9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MX7C+8VC, \u0bae\u0bca\u0bb0\u0bcb\u0ba8\u0bcd\u0ba4\u0bc1\u0b9f\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "MXF4+PG6, Gomarankadawala, Sri Lanka": {
    si: "MXF4+PG6, \u0d9c\u0ddd\u0db8\u0dbb\u0db1\u0dca\u0d9a\u0da9\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "MXF4+PG6, \u0b95\u0bcb\u0bae\u0bb0\u0ba9\u0bcd\u0b95\u0b9f\u0bb5\u0bbe\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Mabima West, Welivita": {
    si: "\u0db8\u0dcf\u0db6\u0dd2\u0db8 \u0db6\u0da7\u0dc4\u0dd2\u0dbb, \u0dc0\u0dd0\u0dbd\u0dd2\u0dc0\u0dd2\u0da7",
    ta: "\u0bae\u0baa\u0bbf\u0bae \u0bae\u0bc7\u0bb1\u0bcd\u0b95\u0bc1, \u0bb5\u0bc6\u0bb2\u0bbf\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f",
  },
  "Maco Filling Station, Hirimbura Cross Rd, Galle ,Hiribura": {
    si: "\u0db8\u0dd0\u0d9a\u0ddd \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0dc4\u0dd2\u0dbb\u0dd2\u0db9\u0dd4\u0dbb \u0dc4\u0dbb\u0dc3\u0dca \u0db4\u0dcf\u0dbb, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd, \u0dc4\u0dd2\u0dbb\u0dd2\u0db6\u0dd4\u0dbb",
    ta: "\u0bae\u0bbe\u0b95\u0bcb \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0bb9\u0bbf\u0bb0\u0bbf\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bbe \u0b95\u0bbf\u0bb0\u0bbe\u0bb8\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1, \u0b95\u0bbe\u0bb2\u0bbf, \u0bb9\u0bbf\u0bb0\u0bbf\u0baa\u0bc1\u0bb0\u0bbe",
  },
  "Madagalla Road, Alutwegedara": {
    si: "\u0db8\u0da9\u0d9c\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d85\u0dbd\u0dd4\u0dad\u0dca\u0dc0\u0dda\u0d9c\u0dd9\u0daf\u0dbb",
    ta: "\u0bae\u0b9f\u0b95\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0bb2\u0bc1\u0ba4\u0bcd\u0bb5\u0bc7\u0b95\u0bc6\u0ba4\u0bb0",
  },
  "Madapatha, Piliyandala": {
    si: "\u0db8\u0da9\u0db4\u0dcf\u0dad, \u0db4\u0dd2\u0dc5\u0dd2\u0dba\u0db1\u0dca\u0daf\u0dbd",
    ta: "\u0bae\u0b9f\u0baa\u0bbe\u0ba4, \u0baa\u0bbf\u0bb2\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bb2\u0bc8",
  },
  "Madawala - Rajawella Rd, Menikhinna": {
    si: "\u0db8\u0da9\u0dc0\u0dbd - \u0dbb\u0da2\u0dc0\u0dd0\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dd0\u0dab\u0dd2\u0d9a\u0dca\u0dc4\u0dd2\u0db1\u0dca\u0db1",
    ta: "\u0bae\u0b9f\u0bb5\u0bb3\u0bc8 - \u0bb0\u0bbe\u0b9c\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bc6\u0ba9\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0ba9\u0bcd\u0ba9",
  },
  "Madawala Road, Digana": {
    si: "\u0db8\u0da9\u0dc0\u0dbd \u0db4\u0dcf\u0dbb, \u0daf\u0dd2\u0d9c\u0db1",
    ta: "\u0bae\u0b9f\u0bb5\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bbf\u0b95\u0ba9",
  },
  "Madmpe Junction, Madampe, Sri Lanka": {
    si: "Madmpe Junction, Madmpe, Sri Lanka",
    ta: "Madmpe Junction, Madampe, Sri Lanka",
  },
  Madurankuliya: {
    si: "\u0db8\u0daf\u0dd4\u0dbb\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0dd2\u0dba",
    ta: "\u0bae\u0ba4\u0bc1\u0bb0\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bbf\u0baf",
  },
  "Maha Oya": {
    si: "\u0db8\u0dc4\u0d94\u0dba",
    ta: "\u0bae\u0bb9\u0bbe \u0b93\u0baf\u0bbe",
  },
  "Maha Vilachchiya": {
    si: "\u0db8\u0dc4 \u0dc0\u0dd2\u0dbd\u0da0\u0dca\u0da0\u0dd2\u0dba",
    ta: "\u0bae\u0b95\u0bbe \u0bb5\u0bbf\u0bb3\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf\u0baf\u0bbe",
  },
  Mahabage: {
    si: "\u0db8\u0dc4\u0db6\u0dcf\u0d9c\u0dda",
    ta: "\u0bae\u0bb9\u0bbe\u0baa\u0bbe\u0b95\u0bc7",
  },
  "Mahabage, Welisara": {
    si: "\u0db8\u0dc4\u0db6\u0dcf\u0d9c\u0dda, \u0dc0\u0dd0\u0dbd\u0dd2\u0dc3\u0dbb",
    ta: "\u0bae\u0bb9\u0bbe\u0baa\u0bbe\u0b95\u0bc7, \u0bb5\u0bc6\u0bb2\u0bbf\u0b9a\u0bb1\u0bc8",
  },
  Mahagalkadawala: {
    si: "\u0db8\u0dc4\u0d9c\u0dbd\u0dca\u0d9a\u0da9\u0dc0\u0dbd",
    ta: "\u0bae\u0bb9\u0b95\u0bb2\u0bcd\u0b95\u0b9f\u0bb5\u0bb2",
  },
  Mahara: {
    si: "\u0db8\u0dc4\u0dbb",
    ta: "\u0bae\u0bb9\u0bbe\u0bb0\u0bbe",
  },
  "Mahathma Gandhi Rd, Jaffna": {
    si: "\u0db8\u0dc4\u0dad\u0dca\u0db8\u0dcf \u0d9c\u0dcf\u0db1\u0dca\u0db0\u0dd2 \u0db4\u0dcf\u0dbb, \u0dba\u0dcf\u0db4\u0db1\u0dba",
    ta: "\u0bae\u0b95\u0bbe\u0ba4\u0bcd\u0bae\u0bbe \u0b95\u0bbe\u0ba8\u0bcd\u0ba4\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd",
  },
  "Mahawela, Nakulugama": {
    si: "\u0db8\u0dc4\u0dc0\u0dd9\u0dbd, \u0db1\u0dcf\u0d9a\u0dd4\u0dc5\u0dd4\u0d9c\u0db8",
    ta: "\u0bae\u0bb9\u0bb5\u0bc6\u0bb2, \u0ba8\u0b95\u0bc1\u0bb2\u0bc1\u0b95\u0bae",
  },
  "Mahawewa - Thoduwawa": {
    si: "\u0db8\u0dc4\u0dc0\u0dd0\u0dc0 - \u0dad\u0ddc\u0da9\u0dd4\u0dc0\u0dcf\u0dc0",
    ta: "\u0bae\u0bb9\u0bbe\u0bb5\u0bc6\u0bb5 - \u0ba4\u0bca\u0b9f\u0bc1\u0bb5\u0bbe\u0bb5",
  },
  Mahiyanganaya: {
    si: "\u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1\u0dba",
    ta: "\u0bae\u0bb9\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0ba8\u0bbe\u0baf",
  },
  "Mahiyangane - Dimbulagala - Dalukkane Hwy": {
    si: "\u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1\u0dda - \u0daf\u0dd2\u0db9\u0dd4\u0dbd\u0dcf\u0d9c\u0dbd - \u0daf\u0dbd\u0dd4\u0d9a\u0dca\u0d9a\u0db1\u0dda Hwy",
    ta: "\u0bae\u0bb9\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0ba9\u0bc7 - \u0ba4\u0bbf\u0bae\u0bcd\u0baa\u0bc1\u0bb2\u0bbe\u0b95\u0bb2 - \u0b9f\u0bb2\u0bc1\u0b95\u0bcd\u0b95\u0ba9\u0bc7 Hwy",
  },
  "Maho-nagollagama Road": {
    si: "\u0db8\u0dc4\u0ddd-\u0db1\u0dcf\u0d9c\u0ddc\u0dbd\u0dca\u0dbd\u0dcf\u0d9c\u0db8 \u0db4\u0dcf\u0dbb",
    ta: "\u0bae\u0bb9\u0bcb-\u0ba8\u0bbe\u0b95\u0bca\u0bb2\u0bcd\u0bb2\u0bbe\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  Mailawalana: {
    si: "\u0db8\u0dba\u0dd2\u0dbd\u0dc0\u0dbd\u0dcf\u0db1",
    ta: "\u0bae\u0bc8\u0bb2\u0bb5\u0bb2\u0ba9",
  },
  "Main Road, Thambiluvil": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0dad\u0db8\u0dca\u0db6\u0dd2\u0dbd\u0dd4\u0dc0\u0dd2\u0dbd\u0dca",
    ta: "\u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bae\u0bcd\u0baa\u0bbf\u0bb2\u0bc1\u0bb5\u0bbf\u0bb2\u0bcd",
  },
  "Main St, Buttala": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc1\u0dcf\u0db1\u0dca\u0dad, \u0db6\u0dd4\u0dad\u0dca\u0dad\u0dbd",
    ta: "\u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe",
  },
  "Main St, Hambantota": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc1\u0dcf\u0db1\u0dca\u0dad, \u0dc4\u0db8\u0dca\u0db6\u0db1\u0dca\u0dad\u0ddc\u0da7",
    ta: "\u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd, \u0b85\u0bae\u0bcd\u0baa\u0bbe\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8",
  },
  "Main St, Kalpitiya": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc1\u0dcf\u0db1\u0dca\u0dad, \u0d9a\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd, \u0b95\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf",
  },
  "Main St, Passara": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc1\u0dcf\u0db1\u0dca\u0dad, \u0db4\u0dc3\u0dca\u0dc3\u0dbb",
    ta: "\u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd, \u0baa\u0b9a\u0bb0\u0bbe",
  },
  "Main St, Tissamaharama": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc1\u0dcf\u0db1\u0dca\u0dad, \u0dad\u0dd2\u0dc3\u0dca\u0dc3\u0db8\u0dc4\u0dcf\u0dbb\u0dcf\u0db8",
    ta: "\u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd, \u0ba4\u0bbf\u0bb8\u0bcd\u0bb8\u0bae\u0bb9\u0bbe\u0bb0\u0bbe\u0bae",
  },
  "Main St, Trincomalee": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc1\u0dcf\u0db1\u0dca\u0dad, \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba",
    ta: "\u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd, \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8",
  },
  "Main Stree, 7RQX+WGH, Oluvil, Sri Lanka": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc0\u0dd3\u0daf\u0dd2\u0dba, 7RQX+WGH, \u0d94\u0dbd\u0dd4\u0dc0\u0dd2\u0dbd\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, 7RQX+WGH, \u0b92\u0bb2\u0bc1\u0bb5\u0bbf\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Main Street, 2PXP+8WC, Kalpitiya Rd, Norochcholai, Sri Lanka": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc0\u0dd3\u0daf\u0dd2\u0dba, 2PXP+8WC, \u0d9a\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db1\u0ddc\u0dbb\u0ddc\u0da0\u0dca\u0da0\u0ddd\u0dbd\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, 2PXP+8WC, \u0b95\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bca\u0bb0\u0bcb\u0b9a\u0bcd\u0b9a\u0bcb\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Main Street, Eravur": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc0\u0dd3\u0daf\u0dd2\u0dba, \u0d91\u0dbb\u0dcf\u0dc0\u0dd4\u0dbb\u0dca",
    ta: "\u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b8f\u0bb1\u0bbe\u0bb5\u0bc2\u0bb0\u0bcd",
  },
  "Main Street, Madaththadi, M25C+G45, Jaffna, Sri Lanka": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc0\u0dd3\u0daf\u0dd2\u0dba, \u0db8\u0da9\u0dad\u0dca\u0dad\u0da9\u0dd2, M25C+G45, \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0b9f\u0ba4\u0bcd\u0ba4\u0b9f\u0bbf, M25C+G45, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Main street, 55000, Polonnaruwa, Sri Lanka": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc0\u0dd3\u0daf\u0dd2\u0dba, 55000, \u0db4\u0ddc\u0dc5\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, 55000, \u0baa\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Makola Rd, Peliyagoda": {
    si: "\u0db8\u0dcf\u0d9a\u0ddc\u0dc5 \u0db4\u0dcf\u0dbb, \u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9",
    ta: "\u0bae\u0bbe\u0b95\u0bca\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc7\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f",
  },
  "Makulla Town,Dambagalla, X9HF+M8H, Madulla, Sri Lanka": {
    si: "\u0db8\u0d9a\u0dd4\u0dbd\u0dca\u0dbd \u0db1\u0d9c\u0dbb\u0dba, \u0daf\u0db9\u0d9c\u0dbd\u0dca\u0dbd, X9HF+M8H, \u0db8\u0da9\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bae\u0b95\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe \u0ba8\u0b95\u0bb0\u0bae\u0bcd, \u0ba4\u0bae\u0bcd\u0baa\u0b95\u0bb2\u0bcd\u0bb2\u0bbe, X9HF+M8H, \u0bae\u0b9f\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Makura, 6985+42C, Hettimulla, Sri Lanka": {
    si: "\u0db8\u0d9a\u0dd4\u0dbb, 6985+42C, \u0dc4\u0dd9\u0da7\u0dca\u0da7\u0dd2\u0db8\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bae\u0b95\u0bc1\u0bb0\u0bbe, 6985+42C, \u0bb9\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Makura, Hettimulla": {
    si: "\u0db8\u0dcf\u0d9a\u0dd4\u0dbb, \u0dc4\u0dd9\u0da7\u0dca\u0da7\u0dd2\u0db8\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0bae\u0b95\u0bc1\u0bb0\u0bbe, \u0bb9\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0bae\u0bc1\u0bb2\u0bcd\u0bb2",
  },
  "Malabe, WXGJ+J2P, Kaduwela Rd, Kaduwela, Sri Lanka": {
    si: "\u0db8\u0dcf\u0dbd\u0db6\u0dda, WXGJ+J2P, \u0d9a\u0da9\u0dd4\u0dc0\u0dd9\u0dbd \u0db4\u0dcf\u0dbb, \u0d9a\u0da9\u0dd4\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bae\u0bbe\u0bb2\u0baa\u0bc7, WXGJ+J2P, Kaduwela Rd, Kaduwela, Sri Lanka",
  },
  "Maligawatte, Colombo -10": {
    si: "\u0db8\u0dcf\u0dbd\u0dd2\u0d9c\u0dcf\u0dc0\u0dad\u0dca\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 -10",
    ta: "\u0bae\u0bbe\u0bb3\u0bbf\u0b95\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 -10",
  },
  Mallakam: {
    si: "\u0db8\u0dbd\u0dca\u0dbd\u0dcf\u0d9a\u0db8\u0dca",
    ta: "\u0bae\u0bb2\u0bcd\u0bb2\u0bbe\u0b95\u0bae\u0bcd",
  },
  Mallavi: {
    si: "\u0db8\u0dbd\u0dca\u0dbd\u0dcf\u0dc0\u0dd2",
    ta: "\u0bae\u0bb2\u0bcd\u0bb2\u0bbe\u0bb5\u0bbf",
  },
  "Mallawapitiya - Rambodagalla - Keppetigala Rd, Ridigama": {
    si: "\u0db8\u0dbd\u0dca\u0dbd\u0dc0\u0db4\u0dd2\u0da7\u0dd2\u0dba - \u0dbb\u0db8\u0dca\u0db6\u0ddc\u0da9\u0d9c\u0dbd\u0dca\u0dbd - \u0d9a\u0dd0\u0db4\u0dca\u0db4\u0dd9\u0da7\u0dd2\u0d9c\u0dbd \u0db4\u0dcf\u0dbb, \u0dbb\u0dd2\u0daf\u0dd3\u0d9c\u0db8",
    ta: "\u0bae\u0bb2\u0bcd\u0bb2\u0bb5\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf - \u0bb0\u0bae\u0bcd\u0baa\u0bca\u0b9f\u0b95\u0bb2\u0bcd\u0bb2 - \u0b95\u0bc6\u0baa\u0bcd\u0baa\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb0\u0bbf\u0ba4\u0bbf\u0b95\u0bae",
  },
  "Mallehewa, Pasyala - Giriulla Rd": {
    si: "\u0db8\u0dbd\u0dca\u0dbd\u0dd9\u0dc4\u0dd9\u0dc0, \u0db4\u0dc3\u0dca\u0dba\u0dcf\u0dbd - \u0d9c\u0dd2\u0dbb\u0dd2\u0d8b\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb",
    ta: "\u0bae\u0bb2\u0bcd\u0bb2\u0bc7\u0bb9\u0bc7\u0bb5, \u0baa\u0bb8\u0bcd\u0baf\u0bbe\u0bb2 - \u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bc1\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  Mampuriya: {
    si: "\u0db8\u0dcf\u0db8\u0dca\u0db4\u0dd4\u0dbb\u0dd2\u0dba",
    ta: "\u0bae\u0bbe\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bbf\u0baf\u0bbe",
  },
  "Mamunuwa Fuel Station, Katugastota - Kurunegala - Puttalam Hwy Road Wariyapola":
    {
      si: "\u0db8\u0dcf\u0db8\u0dd4\u0dab\u0dd4\u0dc0 \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba \u0dc0\u0dcf\u0dbb\u0dd2\u0dba\u0db4\u0ddc\u0dbd",
      ta: "\u0bae\u0bbe\u0bae\u0bc1\u0ba9\u0bc1\u0bb5 \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd Hwy \u0bb5\u0bc0\u0ba4\u0bbf \u0bb5\u0bbe\u0bb0\u0bbf\u0baf\u0baa\u0bca\u0bb2",
    },
  "Mamunuwa, Sri Lanka": {
    si: "\u0db8\u0dcf\u0db8\u0dd4\u0dab\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bae\u0bbe\u0bae\u0bc1\u0ba9\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Manalembuwa Rd, Weerapokuna": {
    si: "\u0db8\u0db1\u0dbd\u0dd9\u0db8\u0dca\u0db6\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0dc0\u0dd3\u0dbb\u0db4\u0ddc\u0d9a\u0dd4\u0dab",
    ta: "\u0bae\u0ba3\u0bb2\u0bc6\u0bae\u0bcd\u0baa\u0bc1\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bc0\u0bb0\u0baa\u0bca\u0b95\u0bc1\u0ba9",
  },
  Manampitiya: {
    si: "\u0db8\u0db1\u0db8\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0bae\u0ba9\u0bae\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  Mandur: {
    si: "\u0db8\u0dd0\u0db1\u0dca\u0da9\u0dd6\u0dbb\u0dca",
    ta: "\u0bae\u0ba3\u0bcd\u0b9f\u0bc2\u0bb0\u0bcd",
  },
  "Mangala Road, Gampaha": {
    si: "\u0db8\u0d82\u0d9c\u0dbd \u0db4\u0dcf\u0dbb, \u0d9c\u0db8\u0dca\u0db4\u0dc4",
    ta: "\u0bae\u0b99\u0bcd\u0b95\u0bb3 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe",
  },
  "Mankulam - Vellankulam Rd, Mallavi": {
    si: "\u0db8\u0dcf\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca - \u0dc0\u0dd9\u0dbd\u0dca\u0dbd\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca \u0db4\u0dcf\u0dbb, \u0db8\u0dbd\u0dca\u0dbd\u0dcf\u0dc0\u0dd2",
    ta: "\u0bae\u0bbe\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd - \u0bb5\u0bc6\u0bb3\u0bcd\u0bb3\u0bbe\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bb2\u0bcd\u0bb2\u0bbe\u0bb5\u0bbf",
  },
  "Mannar Road, Murungan": {
    si: "\u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8 \u0db4\u0dcf\u0dbb, \u0db8\u0dd4\u0dbb\u0dd4\u0d82\u0d9c\u0db1\u0dca",
    ta: "\u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bc1\u0bb0\u0bc1\u0b99\u0bcd\u0b95\u0ba9\u0bcd",
  },
  "Mapalagama Road, New Town Rd, Thalgaswala, Sri Lanka": {
    si: "\u0db8\u0dcf\u0db4\u0dbd\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0db1\u0dc0 \u0db1\u0d9c\u0dbb \u0db4\u0dcf\u0dbb, \u0dad\u0dbd\u0dca\u0d9c\u0dc3\u0dca\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bae\u0bbe\u0baa\u0bb2\u0b95\u0bae \u0b9a\u0bbe\u0bb2\u0bc8, \u0ba8\u0bbf\u0baf\u0bc2 \u0b9f\u0bb5\u0bc1\u0ba9\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1, \u0ba4\u0bb2\u0bcd\u0b95\u0bb8\u0bcd\u0bb5\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Maradana - Beruwala": {
    si: "\u0db8\u0dbb\u0daf\u0dcf\u0db1 - \u0db6\u0dda\u0dbb\u0dd4\u0dc0\u0dbd",
    ta: "\u0bae\u0bb0\u0bc1\u0ba4\u0bbe\u0ba9\u0bc8 - \u0baa\u0bc7\u0bb0\u0bc1\u0bb5\u0bb3\u0bc8",
  },
  "Maradankadawala - Habarana - Thirukkondaiadimadu Hwy, Polonnaruwa": {
    si: "\u0db8\u0dbb\u0daf\u0db1\u0dca\u0d9a\u0da9\u0dc0\u0dbd - \u0dc4\u0db6\u0dbb\u0dab - \u0dad\u0dd2\u0dbb\u0dd4\u0d9a\u0dca\u0d9a\u0ddc\u0dab\u0dca\u0da9\u0dd2\u0dba\u0dcf\u0da9\u0dd2\u0db8\u0da9\u0dd4 Hwy, \u0db4\u0ddc\u0dc5\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0",
    ta: "\u0bae\u0bb0\u0ba4\u0ba9\u0bcd\u0b95\u0b9f\u0bb5\u0bb2 - \u0bb9\u0baa\u0bb0\u0ba3\u0bc8 - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcd\u0b95\u0bca\u0ba3\u0bcd\u0b9f\u0bc8\u0baf\u0bbe\u0b9f\u0bbf\u0bae\u0b9f\u0bc1 Hwy, \u0baa\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5\u0bc8",
  },
  "Maradankadawala-Habarana-Thirukkondaiadimadu Hwy, Manampitiya  , Sri Lanka":
    {
      si: "\u0db8\u0dbb\u0daf\u0db1\u0dca\u0d9a\u0da9\u0dc0\u0dbd-\u0dc4\u0db6\u0dbb\u0dab-\u0dad\u0dd2\u0dbb\u0dd4\u0d9a\u0dca\u0d9a\u0ddc\u0db1\u0dca\u0daf\u0d85\u0da9\u0dd2\u0db8\u0da9\u0dd4 Hwy, \u0db8\u0db1\u0db8\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "\u0bae\u0bb0\u0ba4\u0ba9\u0bcd\u0b95\u0b9f\u0bb5\u0bb2-\u0bb9\u0baa\u0bb0\u0ba9-\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcd\u0b95\u0bca\u0ba3\u0bcd\u0b9f\u0bc8\u0baf\u0bbe\u0b9f\u0bbf\u0bae\u0b9f\u0bc1 Hwy, Manampitiya, Sri Lanka",
    },
  "Maradankadawala-habarana-thirukkondaiadimadu Hwy, Minneriya": {
    si: "\u0db8\u0dbb\u0daf\u0db1\u0dca\u0d9a\u0da9\u0dc0\u0dbd-\u0dc4\u0db6\u0dbb\u0dab-\u0dad\u0dd2\u0dbb\u0dd4\u0d9a\u0dca\u0d9a\u0ddc\u0db1\u0dca\u0daf\u0d85\u0da9\u0dd2\u0db8\u0da9\u0dd4 Hwy, \u0db8\u0dd2\u0db1\u0dca\u0db1\u0dda\u0dbb\u0dd2\u0dba",
    ta: "\u0bae\u0bb0\u0ba4\u0ba9\u0bcd\u0b95\u0b9f\u0bb5\u0bb2-\u0bb9\u0baa\u0bb0\u0ba9-\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcd\u0b95\u0bca\u0ba3\u0bcd\u0b9f\u0bc8\u0baf\u0bbe\u0b9f\u0bbf\u0bae\u0b9f\u0bc1 Hwy, \u0bae\u0bbf\u0ba9\u0bcd\u0ba9\u0bc7\u0bb0\u0bbf\u0baf\u0bbe",
  },
  "Marassana Rd, Thalathuoya": {
    si: "\u0db8\u0dcf\u0dbb\u0dc3\u0dca\u0dc3\u0db1 \u0db4\u0dcf\u0dbb, \u0dad\u0dbd\u0dcf\u0dad\u0dd4\u0d94\u0dba",
    ta: "\u0bae\u0bb0\u0bb8\u0bcd\u0b9a\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bb2\u0ba4\u0bcd\u0ba4\u0bc1\u0b93\u0baf\u0bbe",
  },
  "Marawila-udubaddawa Rd, Ilippugamuwa": {
    si: "\u0db8\u0dcf\u0dbb\u0dc0\u0dd2\u0dbd-\u0d8b\u0da9\u0dd4\u0db6\u0daf\u0dca\u0daf\u0dcf\u0dc0 \u0db4\u0dcf\u0dbb, \u0d89\u0dbd\u0dd2\u0db4\u0dca\u0db4\u0dd4\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0bae\u0bbe\u0bb0\u0bb5\u0bbf\u0bb2-\u0b89\u0b9f\u0bc1\u0baa\u0ba4\u0bcd\u0ba4\u0bbe\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b87\u0bb2\u0bbf\u0baa\u0bcd\u0baa\u0bc1\u0b95\u0bae\u0bc1\u0bb5",
  },
  "Marawila-udubaddawa Rd, Nattandiya": {
    si: "\u0db8\u0dcf\u0dbb\u0dc0\u0dd2\u0dbd - \u0d8b\u0da9\u0dd4\u0db6\u0daf\u0dca\u0daf\u0dcf\u0dc0 \u0db4\u0dcf\u0dbb, \u0db1\u0dcf\u0dad\u0dca\u0dad\u0db1\u0dca\u0da9\u0dd2\u0dba",
    ta: "\u0bae\u0bbe\u0bb0\u0bb5\u0bbf\u0bb2-\u0b89\u0b9f\u0bc1\u0baa\u0ba4\u0bcd\u0ba4\u0bbe\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bbe\u0ba4\u0bcd\u0ba4\u0bbe\u0ba3\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Mariarawa Rd, Dambagalla, Monaragala": {
    si: "\u0db8\u0dbb\u0dd2\u0dba\u0dbb\u0dcf\u0dc0 \u0db4\u0dcf\u0dbb, \u0daf\u0db9\u0d9c\u0dbd\u0dca\u0dbd, \u0db8\u0ddc\u0db1\u0dbb\u0dcf\u0d9c\u0dbd",
    ta: "\u0bae\u0bb0\u0bbf\u0baf\u0bb0\u0bbe\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bae\u0bcd\u0baa\u0b95\u0bb2\u0bcd\u0bb2, \u0bae\u0bca\u0ba9\u0bb0\u0bbe\u0b95\u0bb2\u0bc8",
  },
  "Market, 1010 Jaffna-Point Pedro Rd, Jaffna": {
    si: "\u0dc0\u0dd9\u0dc5\u0db3\u0db4\u0dbd, 1010 \u0dba\u0dcf\u0db4\u0db1\u0dba-\u0db4\u0dda\u0daf\u0dd4\u0dbb\u0dd4\u0dad\u0dd4\u0da9\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0dba\u0dcf\u0db4\u0db1\u0dba",
    ta: "\u0b9a\u0ba8\u0bcd\u0ba4\u0bc8, 1010 \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd - \u0baa\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd",
  },
  Maruthanarmadam: {
    si: "\u0db8\u0dbb\u0dd4\u0dad\u0db1\u0dbb\u0dca\u0db8\u0da9\u0db8\u0dca",
    ta: "\u0bae\u0bb0\u0bc1\u0ba4\u0ba9\u0bbe\u0bb0\u0bcd\u0bae\u0b9f\u0bae\u0bcd",
  },
  Maskeliya: {
    si: "\u0db8\u0dc3\u0dca\u0d9a\u0dd9\u0dc5\u0dd2\u0dba",
    ta: "\u0bae\u0bb8\u0bcd\u0b95\u0bc6\u0bb2\u0bbf\u0baf\u0bbe",
  },
  Maspotha: {
    si: "\u0db8\u0dcf\u0dc3\u0dca\u0db4\u0ddc\u0dad",
    ta: "\u0bae\u0bb8\u0bcd\u0baa\u0bcb\u0ba4\u0bbe",
  },
  "Matale - Illukkumbura - Pallegama - Giradurukotte Road, Rattota": {
    si: "\u0db8\u0dcf\u0dad\u0dbd\u0dda - \u0d89\u0dbd\u0dd4\u0d9a\u0dca\u0d9a\u0dd4\u0db9\u0dd4\u0dbb - \u0db4\u0dbd\u0dca\u0dbd\u0dda\u0d9c\u0db8 - \u0d9c\u0dd2\u0dbb\u0dcf\u0daf\u0dd4\u0dbb\u0dd4\u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda \u0db4\u0dcf\u0dbb, \u0dbb\u0dad\u0dca\u0dad\u0ddc\u0da7",
    ta: "\u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8 - \u0b87\u0bb2\u0bcd\u0bb2\u0bc1\u0b95\u0bcd\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0bb0 - \u0baa\u0bb2\u0bcd\u0bb2\u0bc7\u0b95\u0bae - \u0b95\u0bbf\u0bb0\u0bbe\u0ba4\u0bc1\u0bb0\u0bc1\u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb0\u0ba4\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8",
  },
  Matara: {
    si: "\u0db8\u0dcf\u0dad\u0dbb",
    ta: "\u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8",
  },
  "Matara - Hakmana Rd": {
    si: "\u0db8\u0dcf\u0dad\u0dbb - \u0dc4\u0d9a\u0dca\u0db8\u0db1 \u0db4\u0dcf\u0dbb",
    ta: "\u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8 - \u0bb9\u0b95\u0bcd\u0bae\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  Mathagal: {
    si: "\u0db8\u0dcf\u0dad\u0d9c\u0dbd\u0dca",
    ta: "\u0bae\u0bbe\u0ba4\u0b95\u0bb2\u0bcd",
  },
  Mathugama: {
    si: "\u0db8\u0dad\u0dd4\u0d9c\u0db8",
    ta: "\u0bae\u0ba4\u0bcd\u0ba4\u0bc1\u0b95\u0bae",
  },
  "Mathugama, Matugama, Sri Lanka": {
    si: "\u0db8\u0dad\u0dd4\u0d9c\u0db8, \u0db8\u0dad\u0dd4\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bae\u0ba4\u0bcd\u0ba4\u0bc1\u0b95\u0bae, \u0bae\u0ba4\u0bcd\u0ba4\u0bc1\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Mattakkuliya - Colombo -15": {
    si: "\u0db8\u0da7\u0dca\u0da7\u0d9a\u0dca\u0d9a\u0dd4\u0dbd\u0dd2\u0dba - \u0d9a\u0ddc\u0dc5\u0db9 -15",
    ta: "\u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bc1\u0bb3\u0bbf - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 -15",
  },
  Mattegoda: {
    si: "\u0db8\u0dad\u0dca\u0dad\u0dda\u0d9c\u0ddc\u0da9",
    ta: "\u0bae\u0ba4\u0bcd\u0ba4\u0bc7\u0b95\u0bca\u0b9f",
  },
  Matugama: {
    si: "\u0db8\u0dad\u0dd4\u0d9c\u0db8",
    ta: "\u0bae\u0ba4\u0bcd\u0ba4\u0bc1\u0b95\u0bae",
  },
  Mawanella: {
    si: "\u0db8\u0dcf\u0dc0\u0db1\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0bae\u0bbe\u0bb5\u0ba9\u0bb2\u0bcd\u0bb2",
  },
  "Mawathagama West, Mawathagama": {
    si: "\u0db8\u0dcf\u0dc0\u0dad\u0d9c\u0db8 \u0db6\u0da7\u0dc4\u0dd2\u0dbb, \u0db8\u0dcf\u0dc0\u0dad\u0d9c\u0db8",
    ta: "\u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0b95\u0bae \u0bae\u0bc7\u0bb1\u0bcd\u0b95\u0bc1, \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0b95\u0bae",
  },
  "Mawathagama West, Mawathagama, Sri Lanka": {
    si: "\u0db8\u0dcf\u0dc0\u0dad\u0d9c\u0db8 \u0db6\u0da7\u0dc4\u0dd2\u0dbb, \u0db8\u0dcf\u0dc0\u0dad\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bae\u0bb5\u0ba4\u0b95\u0bae \u0bae\u0bc7\u0bb1\u0bcd\u0b95\u0bc1, \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Maya Ave, Colombo": {
    si: "\u0db8\u0dcf\u0dba\u0dcf \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9",
    ta: "\u0bae\u0bbe\u0baf\u0bbe \u0b8f\u0bb5\u0bcd, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "Mbi Building, Colombo - Batticaloa Hwy, Akkaraipattu": {
    si: "Mbi \u0d9c\u0ddc\u0da9\u0db1\u0dd0\u0d9c\u0dd2\u0dbd\u0dca\u0dbd, \u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 Hwy, \u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0dd9\u0dba\u0dd2\u0db4\u0dad\u0dca\u0dad\u0dd4\u0dc0",
    ta: "Mbi \u0b95\u0b9f\u0bcd\u0b9f\u0bbf\u0b9f\u0bae\u0bcd, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bc8\u0baa\u0bcd\u0baa\u0bb1\u0bcd\u0bb1\u0bc1",
  },
  "Medagama Handiya - Panirendawa": {
    si: "\u0db8\u0dd0\u0daf\u0d9c\u0db8 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba - \u0db4\u0db1\u0dd2\u0dbb\u0dd9\u0db1\u0dca\u0daf\u0dcf\u0dc0",
    ta: "\u0bae\u0bc6\u0ba4\u0b95\u0bae \u0bb9\u0ba3\u0bcd\u0b9f\u0bbf\u0baf\u0bbe - \u0baa\u0ba9\u0bbf\u0bb0\u0bc6\u0ba3\u0bcd\u0b9f\u0bbe\u0bb5",
  },
  Medagampola: {
    si: "\u0db8\u0dd0\u0daf\u0d9c\u0db8\u0dca\u0db4\u0ddc\u0dbd",
    ta: "\u0bae\u0bc6\u0ba4\u0b95\u0bae\u0bcd\u0baa\u0bca\u0bb2",
  },
  "Medamawatha Filling Station, Wariyapola Road, BandaraKoswatta": {
    si: "\u0db8\u0dd0\u0daf\u0db8\u0dcf\u0dc0\u0dad \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0dc0\u0dcf\u0dbb\u0dd2\u0dba\u0db4\u0ddc\u0dbd \u0db4\u0dcf\u0dbb, \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0d9a\u0ddc\u0dc3\u0dca\u0dc0\u0dad\u0dca\u0dad",
    ta: "\u0bae\u0bc6\u0ba4\u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8 \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0bb5\u0bbe\u0bb0\u0bbf\u0baf\u0baa\u0bca\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0 \u0b95\u0bca\u0bb8\u0bcd\u0bb5\u0ba4\u0bcd\u0ba4",
  },
  "Meddawatta, Matara": {
    si: "Meddawatta, Matara",
    ta: "\u0bae\u0bc6\u0ba4\u0bcd\u0ba4\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8",
  },
  "Meddawatta, WHRF+F5X, Matara, Sri Lanka": {
    si: "\u0db8\u0dd0\u0daf\u0dca\u0daf\u0dc0\u0dad\u0dca\u0dad, WHRF+F5X, \u0db8\u0dcf\u0dad\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bae\u0bc6\u0ba4\u0bcd\u0ba4\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, WHRF+F5X, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Medirigiriya Rd, Medirigiriya": {
    si: "Medirigiriya Rd, Medirigiriya",
    ta: "\u0bae\u0bc6\u0ba4\u0bbf\u0bb0\u0bbf\u0b95\u0bbf\u0bb0\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bc6\u0ba4\u0bbf\u0bb0\u0bbf\u0b95\u0bbf\u0bb0\u0bbf\u0baf",
  },
  "Meegahakotuwa Bus Stop, Kurunegala-Narammala-Madampe Rd, Sri Lanka": {
    si: "\u0db8\u0dd3\u0d9c\u0dc4\u0d9a\u0ddc\u0da7\u0dd4\u0dc0 \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd-\u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd-\u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bae\u0bc0\u0b95\u0bb9\u0b95\u0bca\u0b9f\u0bc1\u0bb5 \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd-\u0ba8\u0bbe\u0bb0\u0bae\u0bcd\u0bae\u0bb2-\u0bae\u0b9f\u0bae\u0bcd\u0baa\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Meegalewa, Meegalewa, Sri Lanka": {
    si: "\u0db8\u0dd3\u0d9c\u0dbd\u0dd1\u0dc0, \u0db8\u0dd3\u0d9c\u0dbd\u0dd1\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bae\u0bc0\u0b95\u0bb2\u0bc7\u0bb5\u0bbe, \u0bae\u0bc0\u0b95\u0bb2\u0bc7\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Meegoda: {
    si: "\u0db8\u0dd3\u0d9c\u0ddc\u0da9",
    ta: "\u0bae\u0bc0\u0b95\u0bca\u0b9f",
  },
  "Meepe - Ingiriya Rd, Handapangoda": {
    si: "\u0db8\u0dd3\u0db4\u0dda - \u0d89\u0d82\u0d9c\u0dd2\u0dbb\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0dc4\u0db3\u0db4\u0dcf\u0db1\u0dca\u0d9c\u0ddc\u0da9",
    ta: "\u0bae\u0bc0\u0baa\u0bc7 - \u0b87\u0b99\u0bcd\u0b95\u0bbf\u0bb0\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0ba8\u0bcd\u0ba4\u0baa\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f",
  },
  "Melfort Estate Rd, Pussellawa": {
    si: "\u0db8\u0dd9\u0dbd\u0dca\u0dc6\u0ddd\u0dbb\u0dca\u0da7\u0dca \u0dc0\u0dad\u0dca\u0dad \u0db4\u0dcf\u0dbb, \u0db4\u0dd4\u0dc3\u0dca\u0dc3\u0dd0\u0dbd\u0dca\u0dbd\u0dcf\u0dc0",
    ta: "\u0bae\u0bc6\u0bb2\u0bcd\u0baa\u0bcb\u0bb0\u0bcd\u0b9f\u0bcd \u0ba4\u0bcb\u0b9f\u0bcd\u0b9f \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc1\u0bb8\u0bcd\u0bb8\u0bb2\u0bcd\u0bb2\u0bbe\u0bb5",
  },
  Middeniya: {
    si: "\u0db8\u0dd2\u0daf\u0dca\u0daf\u0dd9\u0db1\u0dd2\u0dba",
    ta: "\u0bae\u0bbf\u0ba4\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf",
  },
  "Middeniya - Panamure Road, Middeniya": {
    si: "\u0db8\u0dd2\u0daf\u0dca\u0daf\u0dd9\u0dab\u0dd2\u0dba - \u0db4\u0db1\u0dcf\u0db8\u0dd4\u0dbb\u0dda \u0db4\u0dcf\u0dbb, \u0db8\u0dd2\u0daf\u0dca\u0daf\u0dd9\u0dab\u0dd2\u0dba",
    ta: "\u0bae\u0bbf\u0ba4\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf - \u0baa\u0ba9\u0bae\u0bc1\u0bb0\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bbf\u0ba4\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf",
  },
  "Minneriya-Hingurakgoda Rd": {
    si: "\u0db8\u0dd2\u0db1\u0dca\u0db1\u0dda\u0dbb\u0dd2\u0dba - \u0dc4\u0dd2\u0d9f\u0dd4\u0dbb\u0d9a\u0dca\u0d9c\u0ddc\u0da9 \u0db4\u0dcf\u0dbb",
    ta: "\u0bae\u0bbf\u0ba9\u0bcd\u0ba9\u0bc7\u0bb0\u0bbf\u0baf\u0bbe-\u0bb9\u0bbf\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0bbe\u0b95\u0bcd\u0b95\u0bca\u0b9f \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  Minuwangate: {
    si: "\u0db8\u0dd2\u0db1\u0dd4\u0dc0\u0db1\u0dca\u0d9c\u0dd0\u0da7\u0dda",
    ta: "\u0bae\u0bbf\u0ba9\u0bc1\u0bb5\u0bbe\u0b99\u0bcd\u0b95\u0bc7\u0b9f\u0bcd",
  },
  Minuwangoda: {
    si: "\u0db8\u0dd2\u0db1\u0dd4\u0dc0\u0db1\u0dca\u0d9c\u0ddc\u0da9",
    ta: "\u0bae\u0bbf\u0ba9\u0bc1\u0bb5\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f",
  },
  Mirihana: {
    si: "\u0db8\u0dd2\u0dbb\u0dd2\u0dc4\u0dcf\u0db1",
    ta: "\u0bae\u0bbf\u0bb0\u0bbf\u0bb9\u0bbe\u0ba9\u0bbe",
  },
  "Mirisgoniyawa Junction, Dambulla, Sri Lanka": {
    si: "\u0db8\u0dd2\u0dbb\u0dd2\u0dc3\u0dca\u0d9c\u0ddd\u0db1\u0dd2\u0dba\u0dcf\u0dc0 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bae\u0bbf\u0bb0\u0bbf\u0bb8\u0bcd\u0b95\u0bcb\u0ba9\u0bbf\u0baf\u0bbe\u0bb5 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Mirissa: {
    si: "\u0db8\u0dd2\u0dbb\u0dd2\u0dc3\u0dca\u0dc3",
    ta: "\u0bae\u0bbf\u0bb0\u0bbf\u0bb8\u0bcd\u0bb8\u0bbe",
  },
  "Miriswatta Junction Bus Stop, A1, Gampaha, Sri Lanka": {
    si: "\u0db8\u0dd2\u0dbb\u0dd2\u0dc3\u0dca\u0dc0\u0dad\u0dca\u0dad \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, A1, \u0d9c\u0db8\u0dca\u0db4\u0dc4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bae\u0bbf\u0bb0\u0bbf\u0bb8\u0bcd\u0bb5\u0ba4\u0bcd\u0ba4 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0baa\u0bcd\u0baa\u0bc1 \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, A1, \u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Miriswatte Junction, QWWJ+PCQ, Piliyandala, Sri Lanka": {
    si: "\u0db8\u0dd2\u0dbb\u0dd2\u0dc3\u0dca\u0dc0\u0dad\u0dca\u0dad \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, QWWJ+PCQ, \u0db4\u0dd2\u0dc5\u0dd2\u0dba\u0db1\u0dca\u0daf\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bae\u0bbf\u0bb0\u0bbf\u0bb8\u0bcd\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, QWWJ+PCQ, \u0baa\u0bbf\u0bb2\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Miyami Clothing Pitigala, Pitigala, Sri Lanka": {
    si: "Miyami Clothing Pitigala, Pitigala, Sri Lanka",
    ta: "\u0bae\u0bbf\u0baf\u0bbe\u0bae\u0bbf \u0b86\u0b9f\u0bc8 \u0baa\u0bbf\u0b9f\u0bbf\u0b95\u0bb2, \u0baa\u0bbf\u0b9f\u0bbf\u0b95\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Mobitel network tower, Telekom Rd, Eravur, Sri Lanka": {
    si: "\u0db8\u0ddc\u0db6\u0dd2\u0da7\u0dd9\u0dbd\u0dca \u0da2\u0dcf\u0dbd \u0d9a\u0dd4\u0dc5\u0dd4\u0dab, \u0da7\u0dd9\u0dbd\u0dd2\u0d9a\u0ddc\u0db8\u0dca \u0db4\u0dcf\u0dbb, \u0d91\u0dbb\u0dcf\u0dc0\u0dd4\u0dbb\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bae\u0bca\u0baa\u0bbf\u0b9f\u0bc6\u0bb2\u0bcd \u0ba8\u0bc6\u0b9f\u0bcd\u0bb5\u0bca\u0bb0\u0bcd\u0b95\u0bcd \u0b95\u0bcb\u0baa\u0bc1\u0bb0\u0bae\u0bcd, Telekom Rd, \u0b8f\u0bb1\u0bbe\u0bb5\u0bc2\u0bb0\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Modara Port Rd, Moratuwa": {
    si: "\u0db8\u0ddd\u0daf\u0dbb \u0dc0\u0dbb\u0dcf\u0dba \u0db4\u0dcf\u0dbb, \u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0",
    ta: "\u0bae\u0bcb\u0ba4\u0bb0 \u0ba4\u0bc1\u0bb1\u0bc8\u0bae\u0bc1\u0b95 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bca\u0bb0\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bc8",
  },
  Moragahahena: {
    si: "\u0db8\u0ddc\u0dbb\u0d9c\u0dc4\u0dc4\u0dda\u0db1",
    ta: "\u0bae\u0bca\u0bb0\u0b95\u0bb9\u0bb9\u0bc7\u0ba9",
  },
  Moragaswewa: {
    si: "\u0db8\u0ddc\u0dbb\u0d9c\u0dc3\u0dca\u0dc0\u0dd0\u0dc0",
    ta: "\u0bae\u0bca\u0bb0\u0b95\u0bb8\u0bcd\u0bb5\u0bc6\u0bb5",
  },
  Moratuwa: {
    si: "\u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0",
    ta: "\u0bae\u0bca\u0bb0\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5",
  },
  Morawaka: {
    si: "Morawaka",
    ta: "Morawaka",
  },
  "Morawalapitiya Junction, Narammala": {
    si: "\u0db8\u0ddc\u0dbb\u0dc0\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd",
    ta: "\u0bae\u0bca\u0bb0\u0bb5\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0ba8\u0bbe\u0bb0\u0bae\u0bcd\u0bae\u0bb2",
  },
  "More than 3 hours": {
    si: "\u0db4\u0dd0\u0dba 3 \u0d9a\u0da7 \u0dc0\u0da9\u0dcf",
    ta: "3 \u0bae\u0ba3\u0bbf \u0ba8\u0bc7\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0bb1\u0bcd\u0b95\u0bc1\u0bae\u0bcd \u0bae\u0bc7\u0bb2\u0bbe\u0b95",
  },
  Moronthuduwa: {
    si: "\u0db8\u0ddc\u0dbb\u0ddc\u0db1\u0dca\u0dad\u0dd4\u0da9\u0dd4\u0dc0",
    ta: "\u0bae\u0bca\u0bb0\u0bcb\u0ba8\u0bcd\u0ba4\u0bc1\u0b9f\u0bc1\u0bb5",
  },
  "Mpcs Keppetipola, Peradeniya-Badulla-Chenkaladi Hwy": {
    si: "Mpcs \u0d9a\u0dd0\u0db4\u0dca\u0db4\u0dd9\u0da7\u0dd2\u0db4\u0ddc\u0dbd, \u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba-\u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd-\u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2 Hwy",
    ta: "Mpcs \u0b95\u0bc6\u0baa\u0bcd\u0baa\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baa\u0bca\u0bb2, \u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8-\u0baa\u0ba4\u0bc1\u0bb3\u0bc8-\u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf Hwy",
  },
  "Mpcs Rd, Oddamavadi": {
    si: "Mpcs \u0db4\u0dcf\u0dbb, \u0d94\u0da9\u0dca\u0da9\u0db8\u0dcf\u0dc0\u0da9\u0dd2",
    ta: "Mpcs Rd, \u0b93\u0b9f\u0bcd\u0b9f\u0bae\u0bbe\u0bb5\u0b9f\u0bbf",
  },
  "Mr. K SURESH.": {
    si: "\u0d9a\u0dda \u0dc3\u0dd4\u0dbb\u0dda\u0dc2\u0dca \u0db8\u0dc4\u0dad\u0dcf.",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1. \u0b95\u0bc7 \u0b9a\u0bc1\u0bb0\u0bc7\u0bb7\u0bcd.",
  },
  "Mrs. D.P.Nanayakkara": {
    si: "\u0da9\u0dd3.\u0db4\u0dd3.\u0db1\u0dcf\u0db1\u0dcf\u0dba\u0d9a\u0dca\u0d9a\u0dcf\u0dbb \u0db8\u0dd2\u0dba",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf \u0b9f\u0bbf.\u0baa\u0bbf.\u0ba8\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95\u0bb0\u0bbe",
  },
  "Ms. H A K PRIYANGI KUMARI,": {
    si: "\u0d91\u0da0\u0dca \u0d92 \u0d9a\u0dda \u0db4\u0dca\u200d\u0dbb\u0dd2\u0dba\u0d82\u0d9c\u0dd2 \u0d9a\u0dd4\u0db8\u0dcf\u0dbb\u0dd2 \u0db8\u0dd9\u0db1\u0dc0\u0dd2\u0dba,",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf. \u0b8e\u0b9a\u0bcd \u0b8f \u0b95\u0bc7 \u0baa\u0bbf\u0bb0\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0bbf \u0b95\u0bc1\u0bae\u0bbe\u0bb0\u0bbf,",
  },
  Mudukatuwa: {
    si: "\u0db8\u0dd6\u0daf\u0dd4\u0d9a\u0da7\u0dd4\u0dc0",
    ta: "\u0bae\u0bc1\u0ba4\u0bc1\u0b95\u0b9f\u0bc1\u0bb5",
  },
  Mudungoda: {
    si: "\u0db8\u0dd4\u0daf\u0dd4\u0db1\u0dca\u0d9c\u0ddc\u0da9",
    ta: "\u0bae\u0bc1\u0b9f\u0bc1\u0b99\u0bcd\u0b95\u0bcb\u0b9f\u0bbe",
  },
  "Mulaitivu-kokkilai Rd, Nayaru": {
    si: "\u0db8\u0dd4\u0dbd\u0dad\u0dd2\u0dc0\u0dca-\u0d9a\u0ddc\u0d9a\u0dca\u0d9a\u0dd2\u0dbd\u0dcf\u0dba\u0dd2 \u0db4\u0dcf\u0dbb, \u0db1\u0dba\u0dcf\u0dbb\u0dd4",
    ta: "\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bc8\u0ba4\u0bcd\u0ba4\u0bc0\u0bb5\u0bc1-\u0b95\u0bca\u0b95\u0bcd\u0b95\u0bbf\u0bb3\u0bbe\u0baf\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bbe\u0baf\u0bbe\u0bb1\u0bc1",
  },
  Mulankavil: {
    si: "\u0db8\u0dd4\u0dbd\u0d82\u0d9a\u0dcf\u0dc0\u0dd2\u0dbd\u0dca",
    ta: "\u0bae\u0bc1\u0bb4\u0b99\u0bcd\u0b95\u0bbe\u0bb5\u0bbf\u0bb2\u0bcd",
  },
  "Mulatiyana Rd,Bengamuwe": {
    si: "\u0db8\u0dd4\u0dbd\u0da7\u0dd2\u0dba\u0db1 \u0db4\u0dcf\u0dbb, \u0db6\u0dd9\u0d82\u0d9c\u0db8\u0dd4\u0dc0\u0dda",
    ta: "\u0bae\u0bc1\u0bb2\u0b9f\u0bbf\u0baf\u0bbe\u0ba9\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0bc6\u0b99\u0bcd\u0b95\u0bae\u0bc1\u0bb5\u0bc7",
  },
  "Mulatiyana Road, Urubokka": {
    si: "\u0db8\u0dd4\u0dbd\u0da7\u0dd2\u0dba\u0db1 \u0db4\u0dcf\u0dbb, \u0d8c\u0dbb\u0dd4\u0db6\u0ddc\u0d9a\u0dca\u0d9a",
    ta: "\u0bae\u0bc1\u0bb2\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b8a\u0bb0\u0bcd\u0baa\u0bca\u0b95\u0bcd\u0b95",
  },
  Mulkadakanda: {
    si: "\u0db8\u0dd4\u0dbd\u0dca\u0d9a\u0da9\u0d9a\u0db1\u0dca\u0daf",
    ta: "\u0bae\u0bc1\u0bb2\u0bcd\u0b95\u0b9f\u0b95\u0ba8\u0bcd\u0ba4\u0bbe",
  },
  Mulliyawalai: {
    si: "\u0db8\u0dd4\u0dbd\u0dca\u0dbd\u0dd2\u0dba\u0dcf\u0dc0\u0dbd\u0dba\u0dd2",
    ta: "\u0bae\u0bc1\u0bb3\u0bcd\u0bb3\u0bbf\u0baf\u0bb5\u0bb3\u0bc8",
  },
  "Munamaldeniya-katupotha Rd": {
    si: "\u0db8\u0dd4\u0dab\u0db8\u0dbd\u0dca\u0daf\u0dd9\u0dab\u0dd2\u0dba-\u0d9a\u0da7\u0dd4\u0db4\u0ddc\u0dad \u0db4\u0dcf\u0dbb",
    ta: "\u0bae\u0bc1\u0ba9\u0bae\u0bb2\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf-\u0b95\u0b9f\u0bc1\u0baa\u0bca\u0ba4 \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  "Munnakkara, Negombo": {
    si: "\u0db8\u0dd4\u0db1\u0dca\u0db1\u0d9a\u0dca\u0d9a\u0dcf\u0dbb, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0bae\u0bc1\u0ba9\u0bcd\u0ba9\u0b95\u0bcd\u0b95\u0bb0\u0bc8, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "Murungasyaya Junction": {
    si: "\u0db8\u0dd4\u0dbb\u0dd4\u0d82\u0d9c\u0dc3\u0dca\u0dba\u0dcf\u0dba \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba",
    ta: "\u0bae\u0bc1\u0bb0\u0bc1\u0b99\u0bcd\u0b95\u0bb8\u0bcd\u0baf\u0bbe\u0baf \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf",
  },
  "Murunkan - Silavatturai Rd": {
    si: "\u0db8\u0dd4\u0dbb\u0dd4\u0db1\u0dca\u0d9a\u0db1\u0dca - \u0dc3\u0dd2\u0dbd\u0dc0\u0dad\u0dca\u0dad\u0dd4\u0dbb\u0dda \u0db4\u0dcf\u0dbb",
    ta: "\u0bae\u0bc1\u0bb0\u0bc1\u0b99\u0bcd\u0b95\u0ba9\u0bcd - \u0b9a\u0bbf\u0bb2\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8 \u0bb0\u0bcb\u0b9f\u0bc1",
  },
  "Murunkan Railway Station, Medawachchiya-Talaimannar Highway, Sri Lanka": {
    si: "\u0db8\u0dd4\u0dbb\u0dd4\u0db1\u0dca\u0d9a\u0db1\u0dca \u0daf\u0dd4\u0db8\u0dca\u0dbb\u0dd2\u0dba \u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba, \u0db8\u0dd0\u0daf\u0dc0\u0da0\u0dca\u0da0\u0dd2\u0dba-\u0dad\u0dbd\u0dd9\u0dba\u0dd2\u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8 \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bae\u0bc1\u0bb0\u0bc1\u0b99\u0bcd\u0b95\u0ba9\u0bcd \u0bb0\u0baf\u0bbf\u0bb2\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0bae\u0bc7\u0b9f\u0bb5\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf\u0baf\u0bbe-\u0ba4\u0bb2\u0bc8\u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Muthurajawela: {
    si: "\u0db8\u0dd4\u0dad\u0dd4\u0dbb\u0dcf\u0da2\u0dc0\u0dd9\u0dbd",
    ta: "\u0bae\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb0\u0bbe\u0b9c\u0bb5\u0bc6\u0bb2",
  },
  Muttur: {
    si: "\u0db8\u0dd6\u0dad\u0dd6\u0dbb\u0dca",
    ta: "\u0bae\u0bc2\u0ba4\u0bc2\u0bb0\u0bcd",
  },
  "Mutuwal Road Kalpitiya, Kalpitiya": {
    si: "\u0db8\u0dd4\u0dad\u0dd4\u0dc0\u0dbd\u0dca \u0db4\u0dcf\u0dbb \u0d9a\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0d9a\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0bae\u0bc1\u0ba4\u0bc1\u0bb5\u0bbe\u0bb2\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf \u0b95\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b95\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  Myliddy: {
    si: "\u0db8\u0dba\u0dd2\u0dbd\u0dd2\u0da9\u0dca\u0da9\u0dd2",
    ta: "\u0bae\u0bc8\u0bb2\u0bbf\u0b9f\u0bbf",
  },
  "N K B T D JAYASINGHE": {
    si: "\u0d91\u0db1\u0dca \u0d9a\u0dda \u0db6\u0dd3 \u0da7\u0dd3 \u0da9\u0dd3 \u0da2\u0dba\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b8e\u0ba9\u0bcd \u0b95\u0bc7 \u0baa\u0bbf \u0b9f\u0bbf \u0b9f\u0bbf \u0b9c\u0baf\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "N K B.ANIL JAYASINGHE": {
    si: "\u0d91\u0db1\u0dca \u0d9a\u0dda \u0db6\u0dd3.\u0d85\u0db1\u0dd2\u0dbd\u0dca \u0da2\u0dba\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b8e\u0ba9\u0bcd \u0b95\u0bc7 \u0baa\u0bbf.\u0b85\u0ba9\u0bbf\u0bb2\u0bcd \u0b9c\u0bc6\u0baf\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "N M C Y NAGASENA": {
    si: "\u0d91\u0db1\u0dca \u0d91\u0db8\u0dca \u0dc3\u0dd3 \u0dc0\u0dba\u0dd2 \u0db1\u0dcf\u0d9c\u0dc3\u0dda\u0db1",
    ta: "\u0b8e\u0ba9\u0bcd \u0b8e\u0bae\u0bcd \u0b9a\u0bbf \u0b92\u0baf\u0bcd \u0ba8\u0bbe\u0b95\u0b9a\u0bc7\u0ba9\u0bbe",
  },
  "N M M Faiz": {
    si: "\u0d91\u0db1\u0dca \u0d91\u0db8\u0dca \u0d91\u0db8\u0dca \u0dc6\u0dba\u0dd2\u0dc3\u0dca",
    ta: "\u0b8e\u0ba9\u0bcd \u0b8e\u0bae\u0bcd \u0b8e\u0bae\u0bcd \u0b83\u0baa\u0bc8\u0bb8\u0bcd",
  },
  "N P G APPUSINGHO & SONS": {
    si: "\u0d91\u0db1\u0dca \u0db4\u0dd3 \u0da2\u0dd3 \u0d85\u0db4\u0dca\u0db4\u0dd4\u0dc3\u0dd2\u0d82\u0dc4 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b8e\u0ba9\u0bcd \u0baa\u0bbf \u0b9c\u0bbf \u0b85\u0baa\u0bcd\u0baa\u0bc1\u0b9a\u0bbf\u0b99\u0bcd\u0bb9\u0bcb & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "N SHANMUKAKUMARAN": {
    si: "\u0d91\u0db1\u0dca \u0dc2\u0db1\u0dca\u0db8\u0dd4\u0d9a\u0d9a\u0dd4\u0db8\u0dcf\u0dbb\u0db1\u0dca",
    ta: "\u0b8e\u0ba9\u0bcd \u0b9a\u0ba3\u0bcd\u0bae\u0bc1\u0b95\u0b95\u0bc1\u0bae\u0bbe\u0bb0\u0ba9\u0bcd",
  },
  "N SHANTHARATNAM": {
    si: "\u0d91\u0db1\u0dca \u0dc1\u0dcf\u0db1\u0dca\u0dad\u0dbb\u0dad\u0dca\u0db1\u0db8\u0dca",
    ta: "\u0b8e\u0ba9\u0bcd \u0b9a\u0bbe\u0ba8\u0bcd\u0ba4\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0bae\u0bcd",
  },
  "N T K A  ADIKARAM": {
    si: "\u0d91\u0db1\u0dca \u0da7\u0dd3 \u0d9a\u0dda \u0d92 \u0d85\u0daf\u0dd2\u0d9a\u0dcf\u0dbb\u0db8\u0dca",
    ta: "\u0b8e\u0ba9\u0bcd.\u0b9f\u0bbf.\u0b95\u0bc7.\u0b85\u0ba4\u0bbf\u0b95\u0bbe\u0bb0\u0bae\u0bcd",
  },
  "N T K WIJESEKARA & SON": {
    si: "\u0d91\u0db1\u0dca \u0da7\u0dd3 \u0d9a\u0dda \u0dc0\u0dd2\u0da2\u0dda\u0dc3\u0dda\u0d9a\u0dbb \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0dcf",
    ta: "\u0b8e\u0ba9\u0bcd \u0b9f\u0bbf \u0b95\u0bc7 \u0bb5\u0bbf\u0b9c\u0bc7\u0b9a\u0bc7\u0b95\u0bb0 & \u0bae\u0b95\u0ba9\u0bcd",
  },
  "N U DISSANAYAKE": {
    si: "\u0d91\u0db1\u0dca \u0dba\u0dd6 \u0daf\u0dd2\u0dc3\u0dcf\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b8e\u0ba9\u0bcd \u0baf\u0bc1 \u0ba4\u0bbf\u0b9a\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "N W A K JAYATHILAKE": {
    si: "\u0d91\u0db1\u0dca \u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0d92 \u0d9a\u0dda \u0da2\u0dba\u0dad\u0dd2\u0dbd\u0d9a",
    ta: "\u0b8e\u0ba9\u0bcd \u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b8f \u0b95\u0bc7 \u0b9c\u0bc6\u0baf\u0ba4\u0bbf\u0bb2\u0b95\u0bc7",
  },
  "N W C K GAJAWEERA": {
    si: "\u0d91\u0db1\u0dca \u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0dc3\u0dd3 \u0d9a\u0dda \u0d9c\u0da2\u0dc0\u0dd3\u0dbb",
    ta: "NW C K GAJAWEERA",
  },
  "N. D. SILVA & SONS": {
    si: "N. D. \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b8e\u0ba9\u0bcd.\u0b9f\u0bbf.\u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "N.D.K.ENTERPRISE": {
    si: "\u0d91\u0db1\u0dca.\u0da9\u0dd3.\u0d9a\u0dda.\u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dca",
    ta: "\u0b8e\u0ba9\u0bcd.\u0b9f\u0bbf.\u0b95\u0bc7.\u0b8e\u0ba9\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0bb8\u0bcd",
  },
  "N.G.H.WIJEYARATHNE": {
    si: "\u0d91\u0db1\u0dca.\u0da2\u0dd3.\u0d91\u0da0\u0dca.\u0dc0\u0dd2\u0da2\u0dba\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b8e\u0ba9\u0bcd.\u0b9c\u0bbf.\u0b8e\u0b9a\u0bcd.\u0bb5\u0bbf\u0b9c\u0bc7\u0baf\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "N.M.A.RAZAAK & SONS": {
    si: "\u0d91\u0db1\u0dca.\u0d91\u0db8\u0dca.\u0d92.\u0dbb\u0dcf\u0dc3\u0dcf\u0d9a\u0dca \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b8e\u0ba9\u0bcd.\u0b8e\u0bae\u0bcd.\u0b8f.\u0bb0\u0b9a\u0bbe\u0b95\u0bcd & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "N.P.G.WIJAYARATNE": {
    si: "\u0d91\u0db1\u0dca.\u0db4\u0dd3.\u0da2\u0dd3.\u0dc0\u0dd2\u0da2\u0dba\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b8e\u0ba9\u0bcd.\u0baa\u0bbf.\u0b9c\u0bbf.\u0bb5\u0bbf\u0b9c\u0baf\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "N.S.A.P.NANAYAKKARA": {
    si: "\u0d91\u0db1\u0dca.\u0d91\u0dc3\u0dca.\u0d92.\u0db4\u0dd3.\u0db1\u0dcf\u0db1\u0dcf\u0dba\u0d9a\u0dca\u0d9a\u0dcf\u0dbb",
    ta: "\u0b8e\u0ba9\u0bcd.\u0b8e\u0bb8\u0bcd.\u0b8f.\u0baa\u0bbf.\u0ba8\u0bbe\u0ba3\u0baf\u0b95\u0bcd\u0b95\u0bbe\u0bb0",
  },
  "N.S.N.ENTERPRISES": {
    si: "\u0d91\u0db1\u0dca.\u0d91\u0dc3\u0dca.\u0d91\u0db1\u0dca.\u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b8e\u0ba9\u0bcd.\u0b8e\u0bb8\u0bcd.\u0b8e\u0ba9\u0bcd.\u0b8e\u0ba9\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "N.S.NAGALINGAM & SONS": {
    si: "\u0d91\u0db1\u0dca.\u0d91\u0dc3\u0dca.\u0db1\u0dcf\u0d9c\u0dbd\u0dd2\u0d82\u0d9c\u0db8\u0dca \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b8e\u0ba9\u0bcd.\u0b8e\u0bb8\u0bcd.\u0ba8\u0bbe\u0b95\u0bb2\u0bbf\u0b99\u0bcd\u0b95\u0bae\u0bcd & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "N.VISVALINGAM": {
    si: "\u0d91\u0db1\u0dca.\u0dc0\u0dd2\u0dc3\u0dca\u0dc0\u0dbd\u0dd2\u0d82\u0d9c\u0db8\u0dca",
    ta: "\u0b8e\u0ba9\u0bcd.\u0bb5\u0bbf\u0bb8\u0bcd\u0bb5\u0bb2\u0bbf\u0b99\u0bcd\u0b95\u0bae\u0bcd",
  },
  "NADEESHA TOURS & TRAVELS PVT LTD": {
    si: "\u0db1\u0daf\u0dd3\u0dc2\u0dcf \u0da7\u0dd4\u0dc0\u0dbb\u0dca\u0dc3\u0dca \u0dc3\u0dc4 \u0da7\u0dca\u200d\u0dbb\u0dd0\u0dc0\u0dbd\u0dca\u0dc3\u0dca \u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0ba8\u0ba4\u0bc0\u0bb7\u0bbe \u0b9f\u0bc2\u0bb0\u0bcd\u0bb8\u0bcd & \u0b9f\u0bbf\u0bb0\u0bbe\u0bb5\u0bb2\u0bcd\u0bb8\u0bcd \u0baa\u0bbf\u0bb0\u0bc8\u0bb5\u0bc7\u0b9f\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  NAFT: {
    si: "NAFT",
    ta: "NAFT",
  },
  "NAJEEM STORES": {
    si: "\u0db1\u0da2\u0dd3\u0db8\u0dca \u0dc3\u0dca\u0da7\u0ddd\u0dbb\u0dca\u0dc3\u0dca",
    ta: "\u0ba8\u0b9c\u0bc0\u0bae\u0bcd \u0bb8\u0bcd\u0b9f\u0bcb\u0bb0\u0bcd\u0bb8\u0bcd",
  },
  NALLA: {
    si: "\u0db1\u0dbd\u0dca\u0dbd",
    ta: "\u0ba8\u0bb2\u0bcd\u0bb2\u0bbe",
  },
  "NALLUR MPCS LTD": {
    si: "\u0db1\u0dbd\u0dca\u0dbd\u0dd6\u0dbb\u0dca \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0ba8\u0bb2\u0bcd\u0bb2\u0bc2\u0bb0\u0bcd MPCS LTD",
  },
  "NAMAL GAMAGE": {
    si: "\u0db1\u0dcf\u0db8\u0dbd\u0dca \u0d9c\u0db8\u0d9c\u0dda",
    ta: "\u0ba8\u0bbe\u0bae\u0bb2\u0bcd \u0b95\u0bae\u0b95\u0bc7",
  },
  "NANATTAN  DIVISION MPCS  LTD": {
    si: "NANATTAN DIVISION MPCS LTD",
    ta: "\u0ba8\u0bbe\u0ba9\u0bbe\u0b9f\u0bcd\u0b9f\u0bbe\u0ba9\u0bcd \u0b9f\u0bbf\u0bb5\u0bbf\u0bb7\u0ba9\u0bcd MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "NANDANA GAMAGE": {
    si: "\u0db1\u0db1\u0dca\u0daf\u0db1 \u0d9c\u0db8\u0d9c\u0dda",
    ta: "\u0ba8\u0ba8\u0bcd\u0ba4\u0ba9 \u0b95\u0bae\u0b95\u0bc7",
  },
  "NATTANDIYA COCONUT PRODUCERS CS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db1\u0dcf\u0dad\u0dca\u0dad\u0db1\u0dca\u0da9\u0dd2\u0dba \u0db4\u0ddc\u0dbd\u0dca \u0db1\u0dd2\u0dc2\u0dca\u0db4\u0dcf\u0daf\u0d9a CS",
    ta: "\u0ba8\u0bbe\u0b9f\u0bcd\u0b9f\u0bbe\u0ba3\u0bcd\u0b9f\u0bbf\u0baf\u0bbe \u0ba4\u0bc7\u0b99\u0bcd\u0b95\u0bbe\u0baf\u0bcd \u0b89\u0bb1\u0bcd\u0baa\u0ba4\u0bcd\u0ba4\u0bbf\u0baf\u0bbe\u0bb3\u0bb0\u0bcd\u0b95\u0bb3\u0bcd CS LTD",
  },
  "NATTANDIYA NAWA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db1\u0dcf\u0dad\u0dca\u0dad\u0db1\u0dca\u0da9\u0dd2\u0dba \u0db1\u0dc0\u0dcf MPCS",
    ta: "\u0ba8\u0bbe\u0b9f\u0bcd\u0b9f\u0bbe\u0ba3\u0bcd\u0b9f\u0bbf\u0baf\u0bbe \u0ba8\u0bbe\u0bb5\u0bbe \u0b8e\u0bae\u0bcd.\u0baa\u0bbf.\u0b9a\u0bbf.\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "NAULA MPCS LTD": {
    si: "NAULA MPCS LTD",
    ta: "NAULA MPCS LTD",
  },
  "NAWA LANKA GROUP": {
    si: "\u0db1\u0dc0 \u0dbd\u0d82\u0d9a\u0dcf \u0d9a\u0dab\u0dca\u0da9\u0dcf\u0dba\u0db8",
    ta: "\u0ba8\u0bbe\u0bb5\u0bbe \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b95\u0bc1\u0bb4\u0bc1",
  },
  "NAWA PANDUWASNUWARA INDHANA PIRAVUM": {
    si: "\u0db1\u0dc0 \u0db4\u0dac\u0dd4\u0dc0\u0dc3\u0dca\u0db1\u0dd4\u0dc0\u0dbb \u0d89\u0db1\u0dca\u0daf\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca",
    ta: "\u0ba8\u0bb5\u0bbe \u0baa\u0bbe\u0ba3\u0bcd\u0b9f\u0bc1\u0bb5\u0bb8\u0bcd\u0ba8\u0bc1\u0bb5\u0bb0 \u0b87\u0ba8\u0bcd\u0ba4\u0ba9\u0bbe \u0baa\u0bbf\u0bb1\u0bb5\u0bc1\u0bae\u0bcd",
  },
  "NAWA PANDUWASNUWARA MPCS LTD": {
    si: "\u0db1\u0dc0 \u0db4\u0dac\u0dd4\u0dc0\u0dc3\u0dca\u0db1\u0dd4\u0dc0\u0dbb MPCS LTD",
    ta: "\u0ba8\u0bb5\u0bbe \u0baa\u0bbe\u0ba3\u0bcd\u0b9f\u0bc1\u0bb5\u0bb8\u0bcd\u0ba9\u0bc1\u0bb5\u0bbe\u0bb0\u0bbe MPCS LTD",
  },
  "NAWA WALAPONE MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad NAWA WALAPONE MPCS",
    ta: "\u0ba8\u0bb5\u0bbe \u0bb5\u0bbe\u0bb2\u0baa\u0bcb\u0ba9\u0bcd MPCS LTD",
  },
  "NAWAGATHTHEGAMA MPCS LTD": {
    si: "\u0db1\u0dc0\u0d9c\u0dad\u0dca\u0dad\u0dda\u0d9c\u0db8 MPCS LTD",
    ta: "\u0ba8\u0bb5\u0b95\u0ba4\u0bcd\u0ba4\u0bc7\u0b95\u0bae MPCS LTD",
  },
  "NAWALAPITIYA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db1\u0dcf\u0dc0\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba MPCS",
    ta: "\u0ba8\u0bbe\u0bb5\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf MPCS LTD",
  },
  "NC PROVINCE CONSUMERS CO-OP SO LTD": {
    si: "NC ProVINCE CONSUMERS CO-OP SO LTD",
    ta: "NC \u0bae\u0bbe\u0b95\u0bbe\u0ba3 \u0ba8\u0bc1\u0b95\u0bb0\u0bcd\u0bb5\u0bcb\u0bb0\u0bcd \u0b95\u0bc2\u0b9f\u0bcd\u0b9f\u0bc1\u0bb1\u0bb5\u0bc1 SO LTD",
  },
  NEGOMBO: {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0ba8\u0bc6\u0b95\u0bcb\u0bae\u0bcd\u0baa\u0bcb",
  },
  "NEGOMBO MPCS LTD": {
    si: "NEGOMBO MPCS LTD",
    ta: "NEGOMBO MPCS LTD",
  },
  "NELUKA ENTERPRISES": {
    si: "\u0db1\u0dd9\u0dbd\u0dd6\u0d9a\u0dcf \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0ba8\u0bc6\u0bb2\u0bc1\u0b95\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "NIHAL GUNASEKARA & COMPANY (PVT) LT": {
    si: "\u0db1\u0dd2\u0dc4\u0dcf\u0dbd\u0dca \u0d9c\u0dd4\u0dab\u0dc3\u0dda\u0d9a\u0dbb \u0dc3\u0dc4 \u0dc3\u0db8\u0dcf\u0d9c\u0db8 (PVT) LT",
    ta: "\u0ba8\u0bbf\u0bb9\u0bbe\u0bb2\u0bcd \u0b95\u0bc1\u0ba3\u0b9a\u0bc7\u0b95\u0bb0 & \u0b95\u0bae\u0bcd\u0baa\u0bc6\u0ba9\u0bbf (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0b8e\u0bb2\u0bcd.\u0b9f\u0bbf",
  },
  "NIKEWERATIYA MPCS LTD": {
    si: "\u0db1\u0dd2\u0d9a\u0dd9\u0dc0\u0dd0\u0dbb\u0da7\u0dd2\u0dba MPCS LTD",
    ta: "\u0ba8\u0bbf\u0b95\u0bc7\u0bb5\u0bb0\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0b9a\u0bbf\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "NIROSHANA ENTERPRISES (PVT) LTD": {
    si: "\u0db1\u0dd2\u0dbb\u0ddd\u0dc2\u0dab \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0ba8\u0bbf\u0bb0\u0bcb\u0bb7\u0ba9\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "NISALKI ENTRPRISE": {
    si: "\u0db1\u0dd2\u0dc3\u0dbd\u0dca\u0d9a\u0dd2 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dca",
    ta: "\u0ba8\u0bbf\u0b9a\u0bb2\u0bcd\u0b95\u0bbf \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0bb8\u0bcd",
  },
  "NIYAGAMA PITIGALA MPCS LTD": {
    si: "\u0db1\u0dd2\u0dba\u0dcf\u0d9c\u0db8 \u0db4\u0dd2\u0da7\u0dd2\u0d9c\u0dbd MPCS LTD",
    ta: "\u0ba8\u0bbf\u0baf\u0b95\u0bae \u0baa\u0bbf\u0b9f\u0bbf\u0b95\u0bb2 MPCS LTD",
  },
  "NO.05 athulathmudali shopping complex,main road, Polonnaruwa, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 05 \u0d87\u0dad\u0dd4\u0dbd\u0dad\u0dca\u0db8\u0dd4\u0daf\u0dbd\u0dd2 \u0dc3\u0dcf\u0db4\u0dca\u0db4\u0dd4 \u0dc3\u0d82\u0d9a\u0dd3\u0dbb\u0dca\u0dab\u0dba, \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0db4\u0ddc\u0dc5\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd.05 \u0b85\u0ba4\u0bc1\u0bb2\u0ba4\u0bcd\u0bae\u0bc1\u0ba4\u0bb2\u0bbf \u0bb5\u0ba3\u0bbf\u0b95 \u0bb5\u0bb3\u0bbe\u0b95\u0bae\u0bcd, \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "NO.75 Puttalam - Colombo Rd, Chilaw, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 75 \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd.75 \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb0\u0bcb\u0b9f\u0bc1, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "NORTHERN  REGN  LORRY  OWNERS CO-OP": {
    si: "\u0d8b\u0dad\u0dd4\u0dbb\u0dd4 REGN \u0dbd\u0ddc\u0dbb\u0dd2 \u0dc4\u0dd2\u0db8\u0dd2\u0dba\u0db1\u0dca\u0d9c\u0dda \u0dc3\u0db8\u0dd4\u0db4\u0d9a\u0dcf\u0dbb\u0dba",
    ta: "\u0bb5\u0b9f\u0b95\u0bcd\u0b95\u0bc1 REGN \u0bb2\u0bbe\u0bb0\u0bbf \u0b89\u0bb0\u0bbf\u0bae\u0bc8\u0baf\u0bbe\u0bb3\u0bb0\u0bcd\u0b95\u0bb3\u0bcd \u0b95\u0bc2\u0b9f\u0bcd\u0b9f\u0bc1\u0bb1\u0bb5\u0bc1",
  },
  "Nagoda - Kalawellawa - Bellapitiya Rd, Bulathsinhala": {
    si: "\u0db1\u0dcf\u0d9c\u0ddc\u0da9 - \u0d9a\u0dbd\u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dcf\u0dc0 - \u0db6\u0dd9\u0dbd\u0dca\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db6\u0dd4\u0dbd\u0dad\u0dca\u0dc3\u0dd2\u0d82\u0dc4\u0dbd",
    ta: "\u0ba8\u0bbe\u0b95\u0bca\u0b9f - \u0b95\u0bb2\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5 - \u0baa\u0bc6\u0bb2\u0bcd\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc1\u0bb3\u0ba4\u0bcd\u0b9a\u0bbf\u0b99\u0bcd\u0b95\u0bb3",
  },
  "Nagoda Junction Bus Stop, 57XG+W47, Nagoda Rd, Nagoda, Sri Lanka": {
    si: "\u0db1\u0dcf\u0d9c\u0ddc\u0da9 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, 57XG+W47, Nagoda Rd, Nagoda, Sri Lanka",
    ta: "\u0ba8\u0bbe\u0b95\u0bca\u0b9f\u0bbe \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0baa\u0bcd\u0baa\u0bc1 \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, 57XG+W47, \u0ba8\u0bbe\u0b95\u0bca\u0b9f\u0bbe \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bbe\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Nagoda Junction Bus Stop, Nagoda Rd, Nagoda": {
    si: "\u0db1\u0dcf\u0d9c\u0ddc\u0da9 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0db1\u0dcf\u0d9c\u0ddc\u0da9 \u0db4\u0dcf\u0dbb, \u0db1\u0dcf\u0d9c\u0ddc\u0da9",
    ta: "\u0ba8\u0bbe\u0b95\u0bca\u0b9f \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0baa\u0bcd\u0baa\u0bc1 \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0ba8\u0bbe\u0b95\u0bca\u0b9f \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bbe\u0b95\u0bca\u0b9f\u0bbe",
  },
  "Najath Filling Station, Katugastota - Kurunegala - Puttalam Hwy, Puttalam": {
    si: "\u0db1\u0da2\u0dcf\u0dad\u0dca \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd - \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 Hwy, \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8",
    ta: "\u0ba8\u0b9c\u0bbe\u0ba4\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd - \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd Hwy, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd",
  },
  "Nakiyadeniya Thel Pirahumhala, Sri Lanka": {
    si: "\u0db1\u0dcf\u0d9a\u0dd2\u0dba\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba \u0dad\u0dd9\u0dbd\u0dca \u0db4\u0dd2\u0dbb\u0dc4\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba8\u0bbe\u0b95\u0bbf\u0baf\u0ba4\u0bc6\u0ba9\u0bbf\u0baf \u0ba4\u0bc6\u0bb2\u0bcd \u0baa\u0bbf\u0bb0\u0bb9\u0bc1\u0bae\u0bcd\u0bb9\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Namal Uyana Road, Pubbogama": {
    si: "\u0db1\u0dcf\u0db8\u0dbd\u0dca \u0d8b\u0dba\u0db1 \u0db4\u0dcf\u0dbb, \u0db4\u0dd4\u0db6\u0dca\u0db6\u0ddd\u0d9c\u0db8",
    ta: "\u0ba8\u0bbe\u0bae\u0bb2\u0bcd \u0b89\u0baf\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc1\u0baa\u0bcd\u0baa\u0bcb\u0b95\u0bae",
  },
  "Nambapana, Ingiriya": {
    si: "\u0db1\u0db8\u0dca\u0db6\u0db4\u0dcf\u0db1, \u0d89\u0d82\u0d9c\u0dd2\u0dbb\u0dd2\u0dba",
    ta: "\u0ba8\u0bae\u0bcd\u0baa\u0baa\u0bcd\u0baa\u0ba9, \u0b87\u0b99\u0bcd\u0b95\u0bbf\u0bb0\u0bbf\u0baf",
  },
  Namunukula: {
    si: "\u0db1\u0db8\u0dd4\u0dab\u0dd4\u0d9a\u0dd4\u0dbd",
    ta: "\u0ba8\u0bae\u0bc1\u0ba9\u0bc1\u0b95\u0bc1\u0bb2",
  },
  Nanattan: {
    si: "Nanattan",
    ta: "Nanattan",
  },
  "Nanhatan MPCS Ltd.": {
    si: "\u0db1\u0dd0\u0db1\u0dca\u0dc4\u0dd0\u0da7\u0db1\u0dca \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0ba8\u0ba9\u0bcd\u0bb9\u0bbe\u0b9f\u0ba9\u0bcd MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd.",
  },
  "Narammala - Kuliyapitiya Rd, Horambawa": {
    si: "\u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd - \u0d9a\u0dd4\u0dbd\u0dd2\u0dba\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0dc4\u0ddc\u0dbb\u0db9\u0dcf\u0dc0",
    ta: "\u0ba8\u0bbe\u0bb0\u0bae\u0bcd\u0bae\u0bb2 - \u0b95\u0bc1\u0bb3\u0bbf\u0baf\u0bbe\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0bca\u0bb0\u0bae\u0bcd\u0baa\u0bbe\u0bb5",
  },
  Narangoda: {
    si: "\u0db1\u0dcf\u0dbb\u0d82\u0d9c\u0ddc\u0da9",
    ta: "\u0ba8\u0bbe\u0bb0\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe",
  },
  Naranwala: {
    si: "\u0db1\u0dcf\u0dbb\u0d82\u0dc0\u0dbd",
    ta: "\u0ba8\u0bbe\u0bb0\u0ba9\u0bcd\u0bb5\u0bbe\u0bb2\u0bbe",
  },
  "Nattandiya - Koswatta": {
    si: "Nattandiya - Koswatta",
    ta: "\u0ba8\u0bbe\u0ba4\u0bcd\u0ba4\u0bbe\u0ba3\u0bcd\u0b9f\u0bbf\u0baf - \u0b95\u0bca\u0bb8\u0bcd\u0bb5\u0ba4\u0bcd\u0ba4",
  },
  Naula: {
    si: "\u0db1\u0dcf\u0d8b\u0dbd",
    ta: "\u0ba8\u0bbe\u0bb5\u0bc1\u0bb2\u0bbe",
  },
  "Naula Clock Tower, The clock tower at the Center of Naula Town, PM53+4FX, A9, Naula, Sri Lanka":
    {
      si: "\u0db1\u0dcf\u0d8b\u0dbd \u0d94\u0dbb\u0dbd\u0ddd\u0dc3\u0dd4 \u0d9a\u0dab\u0dd4\u0dc0, \u0db1\u0dcf\u0d8b\u0dbd \u0db1\u0d9c\u0dbb \u0db8\u0db0\u0dca\u200d\u0dba\u0dba\u0dda \u0d87\u0dad\u0dd2 \u0d94\u0dbb\u0dbd\u0ddd\u0dc3\u0dd4 \u0d9a\u0dab\u0dd4\u0dc0, PM53+4FX, A9, Naula, Sri Lanka",
      ta: "\u0ba8\u0bcc\u0bb2\u0bbe \u0b95\u0b9f\u0bbf\u0b95\u0bbe\u0bb0 \u0b95\u0bcb\u0baa\u0bc1\u0bb0\u0bae\u0bcd, \u0ba8\u0bcc\u0bb2\u0bbe \u0ba8\u0b95\u0bb0\u0bbf\u0ba9\u0bcd \u0bae\u0bc8\u0baf\u0ba4\u0bcd\u0ba4\u0bbf\u0bb2\u0bcd \u0b89\u0bb3\u0bcd\u0bb3 \u0bae\u0ba3\u0bbf\u0b95\u0bcd\u0b95\u0bc2\u0ba3\u0bcd\u0b9f\u0bc1, PM53+4FX, A9, Naula, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "Nawa Walapone Mpcs, Thennekumbura - Rikillagaskada - Ragala": {
    si: "Nawa Walapone Mpcs, \u0dad\u0dd0\u0db1\u0dca\u0db1\u0dda\u0d9a\u0dd4\u0db9\u0dd4\u0dbb - \u0dbb\u0dd2\u0d9a\u0dd2\u0dbd\u0dca\u0dbd\u0d9c\u0dc3\u0dca\u0d9a\u0da9 - \u0dbb\u0dcf\u0d9c\u0dbd",
    ta: "\u0ba8\u0bb5\u0bbe \u0bb5\u0bb2\u0baa\u0bcb\u0ba9\u0bcd \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0b9a\u0bbf\u0b8e\u0bb8\u0bcd, \u0ba4\u0bc6\u0ba9\u0bcd\u0ba9\u0bc7\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0bb0 - \u0bb0\u0bbf\u0b95\u0bbf\u0bb2\u0bcd\u0bb2\u0b95\u0bb8\u0bcd\u0b95\u0b9f - \u0bb0\u0bbe\u0b95\u0bb2\u0bbe",
  },
  "Nawagamuva, Sri Lanka": {
    si: "\u0db1\u0dc0\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba8\u0bb5\u0b95\u0bae\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Nawalapitiya: {
    si: "\u0db1\u0dcf\u0dc0\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0ba8\u0bbe\u0bb5\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf",
  },
  "Near The Harbour Duwa,Negambo": {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 \u0daf\u0dd6\u0dc0 \u0dc0\u0dbb\u0dcf\u0dba \u0d85\u0dc3\u0dbd",
    ta: "\u0ba4\u0bc1\u0bb5\u0bbe \u0ba4\u0bc1\u0bb1\u0bc8\u0bae\u0bc1\u0b95\u0ba4\u0bcd\u0ba4\u0bbf\u0bb1\u0bcd\u0b95\u0bc1 \u0b85\u0bb0\u0bc1\u0b95\u0bbf\u0bb2\u0bcd, \u0ba8\u0bc6\u0b95\u0bae\u0bcd\u0baa\u0bcb",
  },
  Nearby: {
    si: "\u0dc5\u0d9f",
    ta: "\u0b85\u0bb0\u0bc1\u0b95\u0bbf\u0bb2\u0bcd",
  },
  Nedunkeni: {
    si: "\u0db1\u0dd0\u0daf\u0dd4\u0db1\u0dca\u0d9a\u0dda\u0db1\u0dd2",
    ta: "\u0ba8\u0bc6\u0b9f\u0bc1\u0b99\u0bcd\u0b95\u0bc7\u0ba3\u0bbf",
  },
  "Need more feedback": {
    si: "\u0dad\u0dc0\u0dad\u0dca \u0db4\u0dca\u200d\u0dbb\u0dad\u0dd2\u0db4\u0ddd\u0dc2\u0dab \u0d85\u0dc0\u0dc1\u0dca\u200d\u0dba\u0dba\u0dd2",
    ta: "\u0bae\u0bc7\u0bb2\u0bc1\u0bae\u0bcd \u0b95\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1 \u0ba4\u0bc7\u0bb5\u0bc8",
  },
  "Need more responses": {
    si: "\u0dad\u0dc0\u0dad\u0dca \u0db4\u0dca\u200d\u0dbb\u0dad\u0dd2\u0da0\u0dcf\u0dbb \u0d85\u0dc0\u0dc1\u0dca\u200d\u0dba\u0dba\u0dd2",
    ta: "\u0bae\u0bc7\u0bb2\u0bc1\u0bae\u0bcd \u0baa\u0ba4\u0bbf\u0bb2\u0bcd\u0b95\u0bb3\u0bcd \u0ba4\u0bc7\u0bb5\u0bc8",
  },
  Neelagama: {
    si: "\u0db1\u0dd3\u0dbd\u0d9c\u0db8",
    ta: "\u0ba8\u0bc0\u0bb2\u0b95\u0bae",
  },
  Negambo: {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0ba8\u0bc6\u0b95\u0bae\u0bcd\u0baa\u0bcb",
  },
  "Negambo - Colombo Main Road, Katunayaka": {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0d9a\u0da7\u0dd4\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  Negombo: {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "Negombo - Giriulla Rd, Badalgama": {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 - \u0d9c\u0dd2\u0dbb\u0dd2\u0d8b\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db6\u0da9\u0dbd\u0dca\u0d9c\u0db8",
    ta: "\u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bc1\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0b9f\u0bb2\u0bcd\u0b95\u0bae",
  },
  "Negombo - Giriulla Rd,Godigamuwa": {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 - \u0d9c\u0dd2\u0dbb\u0dd2\u0d8b\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d9c\u0ddc\u0da9\u0dd2\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bc1\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bca\u0b9f\u0bbf\u0b95\u0bae\u0bc1\u0bb5",
  },
  "Negombo - Kurana Junction": {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 - \u0d9a\u0dd4\u0dbb\u0dab \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba",
    ta: "\u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bc1\u0bb0\u0bbe\u0ba9\u0bc8 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf",
  },
  "Negombo - Kurunegala Rd, Giriulla": {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd \u0db4\u0dcf\u0dbb, \u0d9c\u0dd2\u0dbb\u0dd2\u0d8b\u0dbd\u0dca\u0dbd",
    ta: "\u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bbf\u0bb0\u0bbf\u0b89\u0bb2\u0bcd\u0bb2",
  },
  "Negombo - Kurunegala Road, Dankotuwa": {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 - \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd \u0db4\u0dcf\u0dbb, \u0daf\u0d82\u0d9a\u0ddc\u0da7\u0dd4\u0dc0",
    ta: "\u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bc1\u0bb5",
  },
  "Negombo - Mirigama Rd, Marandagahamula": {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 - \u0db8\u0dd3\u0dbb\u0dd2\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0db8\u0dbb\u0db3\u0d9c\u0dc4\u0db8\u0dd4\u0dbd",
    ta: "\u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0bc0\u0bb0\u0bbf\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bb0\u0ba8\u0bcd\u0ba4\u0b95\u0bb9\u0bae\u0bc1\u0bb2",
  },
  "Negombo - Mirigama Rd, Mirigama": {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 - \u0db8\u0dd3\u0dbb\u0dd2\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0db8\u0dd3\u0dbb\u0dd2\u0d9c\u0db8",
    ta: "\u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0bc0\u0bb0\u0bbf\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bc0\u0bb0\u0bbf\u0b95\u0bae",
  },
  "Negombo - Telwatta Juntion": {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 - \u0dad\u0dd9\u0dbd\u0dca\u0dc0\u0dad\u0dca\u0dad \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba",
    ta: "\u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0ba4\u0bc6\u0bb2\u0bcd\u0bb5\u0ba4\u0bcd\u0ba4 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf",
  },
  "Negombo Road, Dambadeniya": {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0daf\u0db9\u0daf\u0dd9\u0dab\u0dd2\u0dba",
    ta: "\u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bae\u0bcd\u0baa\u0ba4\u0bc6\u0ba9\u0bbf\u0baf",
  },
  "Negombo-colombo Main Rd, Ja-ela": {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0-\u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0da2\u0dcf-\u0d87\u0dbd",
    ta: "\u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1-\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b9c\u0bbe-\u0b8e\u0bb2",
  },
  "Negombo-giriulla Rd, Madampella": {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0-\u0d9c\u0dd2\u0dbb\u0dd2\u0d8b\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0da9\u0db8\u0dca\u0db4\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1-\u0b95\u0bbf\u0bb0\u0bbf\u0b89\u0bb2\u0bcd\u0bb2\u0bbe \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0b9f\u0bae\u0bcd\u0baa\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe",
  },
  "Negombo-giriulla Rd, Nalla": {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0-\u0d9c\u0dd2\u0dbb\u0dd2\u0d8b\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db1\u0dbd\u0dca\u0dbd",
    ta: "\u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1-\u0b95\u0bbf\u0bb0\u0bbf\u0b89\u0bb2\u0bcd\u0bb2\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0ba8\u0bb2\u0bcd\u0bb2\u0bbe",
  },
  "Negombo-kurunegala Rd": {
    si: "\u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0-\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd \u0db4\u0dcf\u0dbb",
    ta: "\u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1-\u0b95\u0bc1\u0bb0\u0bc1\u0ba3\u0bbe\u0b95\u0bb2\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  Nelliady: {
    si: "\u0db1\u0dd9\u0dbd\u0dca\u0dbd\u0dd2\u0dba\u0da9\u0dd2",
    ta: "\u0ba8\u0bc6\u0bb2\u0bcd\u0bb2\u0bbf\u0baf\u0b9f\u0bbf",
  },
  "Nelligahamula Bus Stop, Yakkala - Radawana Rd, Sri Lanka": {
    si: "\u0db1\u0dd9\u0dbd\u0dca\u0dbd\u0dd2\u0d9c\u0dc4\u0db8\u0dd4\u0dbd \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0dba\u0d9a\u0dca\u0d9a\u0dbd - \u0dbb\u0daf\u0dcf\u0dc0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba8\u0bc6\u0bb2\u0bcd\u0bb2\u0bbf\u0b95\u0bb9\u0bae\u0bc1\u0bb2\u0bbe \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0baf\u0b95\u0bcd\u0b95\u0bb2 - \u0bb0\u0ba4\u0bbe\u0bb5\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Nelluwa Filling Station, B411, Neluwa": {
    si: "\u0db1\u0dd9\u0dc5\u0dd4\u0dc0 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, B411, \u0db1\u0dd9\u0dc5\u0dd4\u0dc0",
    ta: "\u0ba8\u0bc6\u0bb2\u0bcd\u0bb2\u0bc1\u0bb5\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, B411, \u0ba8\u0bc6\u0bb2\u0bc1\u0bb5\u0bbe",
  },
  "Nelundeniya - Alawwa Rd, Nelundeniya": {
    si: "\u0db1\u0dd9\u0dc5\u0dd4\u0db1\u0dca\u0daf\u0dd9\u0db1\u0dd2\u0dba - \u0d85\u0dbd\u0dc0\u0dca\u0dc0 \u0db4\u0dcf\u0dbb, \u0db1\u0dd9\u0dc5\u0dd4\u0db1\u0dca\u0daf\u0dd9\u0db1\u0dd2\u0dba",
    ta: "\u0ba8\u0bc6\u0bb2\u0bc1\u0ba8\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf - \u0b85\u0bb2\u0bb5\u0bcd\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc6\u0bb2\u0bc1\u0ba8\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf",
  },
  "Neluwa Bus Stop, 99H6+3G9, B411, Neluwa, Sri Lanka": {
    si: "\u0db1\u0dd9\u0dc5\u0dd4\u0dc0 \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, 99H6+3G9, B411, \u0db1\u0dd9\u0dc5\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba8\u0bc6\u0bb2\u0bc1\u0bb5\u0bbe \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, 99H6+3G9, B411, \u0ba8\u0bc6\u0bb2\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Nettipolagedara: {
    si: "\u0db1\u0dd9\u0da7\u0dca\u0da7\u0dd2\u0db4\u0ddc\u0dbd\u0d9c\u0dd9\u0daf\u0dbb",
    ta: "\u0ba8\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baa\u0bca\u0bb2\u0b95\u0bc6\u0ba4\u0bb0",
  },
  Never: {
    si: "\u0d9a\u0dc0\u0daf\u0dcf\u0dc0\u0dad\u0dca \u0db1\u0dd0\u0dc4\u0dd0",
    ta: "\u0b92\u0bb0\u0bc1\u0baa\u0bcb\u0ba4\u0bc1\u0bae\u0bcd \u0b87\u0bb2\u0bcd\u0bb2\u0bc8",
  },
  "New Kalmunai Rd, Batticaloa": {
    si: "\u0db1\u0dc0 \u0d9a\u0dbd\u0dca\u0db8\u0dd4\u0dab\u0dda \u0db4\u0dcf\u0dbb, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0",
    ta: "\u0baa\u0bc1\u0ba4\u0bbf\u0baf \u0b95\u0bb2\u0bcd\u0bae\u0bc1\u0ba9\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1",
  },
  "New Kandy Rd, Weliweriya": {
    si: "\u0db1\u0dc0 \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dc0\u0dd0\u0dbd\u0dd2\u0dc0\u0dda\u0dbb\u0dd2\u0dba",
    ta: "\u0baa\u0bc1\u0ba4\u0bbf\u0baf \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bc6\u0bb2\u0bbf\u0bb5\u0bc7\u0bb0\u0bbf\u0baf",
  },
  "New Lanka Filling Station, Hiripokuna": {
    si: "\u0db1\u0dc0 \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0dc4\u0dd2\u0dbb\u0dd2\u0db4\u0ddc\u0d9a\u0dd4\u0dab",
    ta: "\u0baa\u0bc1\u0ba4\u0bbf\u0baf \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0bb9\u0bbf\u0bb0\u0bbf\u0baa\u0bca\u0b95\u0bc1\u0ba3",
  },
  "New Town, Anuradhapura": {
    si: "\u0db1\u0dc0 \u0db1\u0d9c\u0dbb\u0dba, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb",
    ta: "\u0baa\u0bc1\u0ba4\u0bbf\u0baf \u0ba8\u0b95\u0bb0\u0bae\u0bcd, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd",
  },
  "New Town, Road, Thalgaswala": {
    si: "\u0db1\u0dc0 \u0db1\u0d9c\u0dbb\u0dba, \u0db4\u0dcf\u0dbb, \u0dad\u0dbd\u0dca\u0d9c\u0dc3\u0dca\u0dc0\u0dbd",
    ta: "\u0baa\u0bc1\u0ba4\u0bbf\u0baf \u0ba8\u0b95\u0bb0\u0bae\u0bcd, \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bb2\u0bcd\u0b95\u0bb8\u0bcd\u0bb5\u0bb2",
  },
  "Nikadalupotha, Hiripitiya": {
    si: "\u0db1\u0dd2\u0d9a\u0daf\u0dc5\u0dd4\u0db4\u0ddc\u0dad, \u0dc4\u0dd2\u0dbb\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0ba8\u0bbf\u0b95\u0b9f\u0bb2\u0bc1\u0baa\u0bca\u0ba4, \u0bb9\u0bbf\u0bb0\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  Nikaweratiya: {
    si: "\u0db1\u0dd2\u0d9a\u0dc0\u0dd0\u0dbb\u0da7\u0dd2\u0dba",
    ta: "\u0ba8\u0bbf\u0b95\u0bcd\u0b95\u0bb5\u0bc6\u0bb0\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  Nilaveli: {
    si: "\u0db1\u0dd2\u0dbd\u0dcf\u0dc0\u0dda\u0dbd\u0dd2",
    ta: "\u0ba8\u0bbf\u0bb2\u0bbe\u0bb5\u0bc6\u0bb3\u0bbf",
  },
  "Nilaveli - Irrakkandy": {
    si: "\u0db1\u0dd2\u0dbd\u0dcf\u0dc0\u0dda\u0dbd\u0dd2 - \u0d89\u0dbb\u0d9a\u0dca\u0d9a\u0db1\u0dca\u0da9\u0dd2",
    ta: "\u0ba8\u0bbf\u0bb2\u0bbe\u0bb5\u0bc6\u0bb3\u0bbf - \u0b87\u0bb1\u0b95\u0bcd\u0b95\u0b95\u0bcd\u0b95\u0ba3\u0bcd\u0b9f\u0bbf",
  },
  "Nilpanagoda, Minuwangoda": {
    si: "\u0db1\u0dd2\u0dbd\u0dca\u0db4\u0db1\u0dcf\u0d9c\u0ddc\u0da9, \u0db8\u0dd2\u0db1\u0dd4\u0dc0\u0db1\u0dca\u0d9c\u0ddc\u0da9",
    ta: "\u0ba8\u0bbf\u0bb2\u0bcd\u0baa\u0ba9\u0b95\u0bca\u0b9f, \u0bae\u0bbf\u0ba9\u0bc1\u0bb5\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f",
  },
  "Nilwala By Pass, Matara": {
    si: "\u0db1\u0dd2\u0dbd\u0dca\u0dc0\u0dbd\u0dcf \u0db6\u0dba\u0dd2\u0db4\u0dcf\u0dc3\u0dca, \u0db8\u0dcf\u0dad\u0dbb",
    ta: "\u0ba8\u0bbf\u0bb2\u0bcd\u0bb5\u0bb2\u0bbe \u0baa\u0bc8 \u0baa\u0bbe\u0bb8\u0bcd, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8",
  },
  Nilwella: {
    si: "\u0db1\u0dd2\u0dbd\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0ba8\u0bbf\u0bb2\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2",
  },
  Nintavur: {
    si: "\u0db1\u0dd2\u0db1\u0dca\u0daf\u0dc0\u0dd6\u0dbb\u0dca",
    ta: "\u0ba8\u0bbf\u0ba8\u0bcd\u0ba4\u0bb5\u0bc2\u0bb0\u0bcd",
  },
  Nittambuwa: {
    si: "\u0db1\u0dd2\u0da7\u0dca\u0da7\u0db9\u0dd4\u0dc0",
    ta: "\u0ba8\u0bbf\u0b9f\u0bcd\u0b9f\u0bae\u0bcd\u0baa\u0bc1\u0bb5",
  },
  "Nittambuwa - Nambadaluwa": {
    si: "\u0db1\u0dd2\u0da7\u0dca\u0da7\u0db9\u0dd4\u0dc0 - \u0db1\u0dcf\u0db8\u0dca\u0db6\u0da9\u0dc5\u0dd4\u0dc0",
    ta: "\u0ba8\u0bbf\u0b9f\u0bcd\u0b9f\u0bae\u0bcd\u0baa\u0bc1\u0bb5 - \u0ba8\u0bae\u0bcd\u0baa\u0b9f\u0bb2\u0bc1\u0bb5",
  },
  "No 108/1, Tiruwanaketiya - Agalawatte Rd, Lathpandura": {
    si: "\u0d85\u0d82\u0d9a 108/1, \u0dad\u0dd2\u0dbb\u0dd4\u0dc0\u0dcf\u0db1\u0dcf\u0d9a\u0dd0\u0da7\u0dd2\u0dba - \u0d85\u0d9c\u0dbd\u0dc0\u0dad\u0dca\u0dad \u0db4\u0dcf\u0dbb, \u0dbd\u0dad\u0dca\u0db4\u0db3\u0dd4\u0dbb",
    ta: "\u0b87\u0bb2\u0b95\u0bcd\u0b95\u0bae\u0bcd 108/1, \u0ba4\u0bbf\u0bb0\u0bc1\u0bb5\u0ba9\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf - \u0b85\u0b95\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb2\u0ba4\u0bcd\u0baa\u0ba8\u0bcd\u0ba4\u0bc1\u0bb0",
  },
  "No 117, Ambalangoda Rd, Elpitiya, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 117, \u0d85\u0db8\u0dca\u0db6\u0dbd\u0db1\u0dca\u0d9c\u0ddc\u0da9 \u0db4\u0dcf\u0dbb, \u0d87\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd 117, \u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0b8e\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No 128 Main Street, Dummalasuriya": {
    si: "\u0d85\u0d82\u0d9a 128 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc0\u0dd3\u0daf\u0dd2\u0dba, \u0daf\u0dd4\u0db8\u0dca\u0db8\u0dbd\u0dc3\u0dd6\u0dbb\u0dd2\u0dba",
    ta: "\u0b87\u0bb2 128 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bc1\u0bae\u0bcd\u0bae\u0bb2\u0b9a\u0bc2\u0bb0\u0bbf\u0baf",
  },
  "No 237 60100, Kurunegala -Narammala - Madampe Rd, Narammala": {
    si: "\u0d85\u0d82\u0d9a 237 60100, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd -\u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd - \u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda \u0db4\u0dcf\u0dbb, \u0db1\u0dcf\u0dbb\u0db8\u0dca\u0db8\u0dbd",
    ta: "\u0b87\u0bb2\u0b95\u0bcd\u0b95\u0bae\u0bcd 237 60100, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd -\u0ba8\u0bbe\u0bb0\u0bae\u0bcd\u0bae\u0bb2 - \u0bae\u0bbe\u0ba4\u0bae\u0bcd\u0baa\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bbe\u0bb0\u0bae\u0bcd\u0bae\u0bb2",
  },
  "No 27, Thanayama Road, Inner Circular Rd, Ratnapura, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 27, \u0dad\u0dcf\u0db1\u0dcf\u0dba\u0db8 \u0db4\u0dcf\u0dbb, \u0d87\u0dad\u0dd4\u0dbd\u0dca \u0dc0\u0da7\u0dbb\u0dc0\u0dd4\u0db8\u0dca \u0db4\u0dcf\u0dbb, \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd 27, \u0ba4\u0ba9\u0baf\u0bbe\u0bae\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0b89\u0bb3\u0bcd \u0b9a\u0bc1\u0bb1\u0bcd\u0bb1\u0bc1 \u0bb5\u0b9f\u0bcd\u0b9f\u0bae\u0bcd, \u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No 278, Moragahayata, Colombo Rd, Ratnapura": {
    si: "\u0d85\u0d82\u0d9a 278, \u0db8\u0ddc\u0dbb\u0d9c\u0dc4\u0dba\u0da7, \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb",
    ta: "\u0b87\u0bb2\u0b95\u0bcd\u0b95\u0bae\u0bcd 278, \u0bae\u0bca\u0bb0\u0b95\u0bb9\u0baf\u0ba4\u0bcd\u0ba4, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf",
  },
  "No 295 Nuwara Eliya Road, Pussellawa, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 295 \u0db1\u0dd4\u0dc0\u0dbb\u0d91\u0dc5\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db4\u0dd4\u0dc3\u0dca\u0dc3\u0dd0\u0dbd\u0dca\u0dbd\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd 295 \u0ba8\u0bc1\u0bb5\u0bb0\u0bc6\u0bb2\u0bbf\u0baf\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0bc1\u0bb8\u0bcd\u0bb8\u0bb2\u0bcd\u0bb2\u0bbe\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No 3, 2/1 Yakkala Rd, Gampaha, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 3, 2/1 \u0dba\u0d9a\u0dca\u0d9a\u0dbd \u0db4\u0dcf\u0dbb, \u0d9c\u0db8\u0dca\u0db4\u0dc4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd 3, 2/1 \u0baf\u0b95\u0bcd\u0b95\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No 331, Kosgama": {
    si: "No 331, Kosgama",
    ta: "No 331, Kosgama",
  },
  "No 362 Katugastota Rd, Kandy": {
    si: "\u0d85\u0d82\u0d9a 362 \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7 \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb",
    ta: "\u0b8e\u0ba3\u0bcd 362 \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bbe \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf",
  },
  "No 37-39, Colombo Road, Haputale, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 37-39, \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0dc4\u0db4\u0dd4\u0dad\u0dbd\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd 37-39, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb9\u0baa\u0bcd\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No 50, Waikkal": {
    si: "\u0d85\u0d82\u0d9a 50, \u0dc0\u0dba\u0dd2\u0d9a\u0dca\u0d9a\u0dcf\u0dbd\u0dca",
    ta: "\u0b8e\u0ba3\u0bcd 50, \u0bb5\u0bbe\u0baf\u0bcd\u0b95\u0bcd\u0b95\u0bbe\u0bb2\u0bcd",
  },
  "No 54 Avissawella Rd, Hanwella": {
    si: "\u0d85\u0d82\u0d9a 54 \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0dc4\u0d82\u0dc0\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0b8e\u0ba3\u0bcd 54 \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2",
  },
  "No 54 Sir Ernest de Silva Mawatha, Colombo 00700, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 54 \u0dc1\u0dca\u200d\u0dbb\u0dd3\u0db8\u0dad\u0dca \u0d85\u0dbb\u0dca\u0db1\u0dc3\u0dca\u0da7\u0dca \u0daf \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 00700, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd 54 \u0b9a\u0bb0\u0bcd \u0b8e\u0bb0\u0bcd\u0ba9\u0bb8\u0bcd\u0b9f\u0bcd \u0b9f\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00700, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No 84 A Dickson Moters Rd, Polgahawela, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 84 \u0d92 \u0da9\u0dd2\u0d9a\u0dca\u0dc3\u0db1\u0dca \u0db8\u0ddd\u0da7\u0dbb\u0dca\u0dc3\u0dca \u0db4\u0dcf\u0dbb, \u0db4\u0ddc\u0dbd\u0dca\u0d9c\u0dc4\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd 84 A Dickson Moters Rd, Polgahawela, Sri Lanka",
  },
  "No 87 Raja Complex, Jaffna-kankesanturai Rd, Chunnakam": {
    si: "\u0d85\u0d82\u0d9a 87 \u0dbb\u0dcf\u0da2\u0dcf \u0dc3\u0d82\u0d9a\u0dd3\u0dbb\u0dca\u0dab\u0dba, \u0dba\u0dcf\u0db4\u0db1\u0dba-\u0d9a\u0db1\u0dca\u0d9a\u0dc3\u0db1\u0dca\u0dad\u0dd4\u0dbb\u0dda \u0db4\u0dcf\u0dbb, \u0da0\u0dd4\u0db1\u0dca\u0db1\u0dcf\u0d9a\u0db8\u0dca",
    ta: "\u0b87\u0bb2 87 \u0bb0\u0bbe\u0b9c\u0bbe \u0bb5\u0bb3\u0bbe\u0b95\u0bae\u0bcd, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd-\u0b95\u0bbe\u0b99\u0bcd\u0b95\u0bc7\u0b9a\u0ba9\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b9a\u0bc1\u0ba9\u0bcd\u0ba9\u0bbe\u0b95\u0bae\u0bcd",
  },
  "No 87 Raja complex, Jaffna-Kankesanturai Rd, Chunnakam, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 87 \u0dbb\u0dcf\u0da2\u0dcf \u0dc3\u0d82\u0d9a\u0dd3\u0dbb\u0dca\u0dab\u0dba, \u0dba\u0dcf\u0db4\u0db1\u0dba-\u0d9a\u0db1\u0dca\u0d9a\u0dc3\u0db1\u0dca\u0dad\u0dd4\u0dbb\u0dda \u0db4\u0dcf\u0dbb, \u0da0\u0dd4\u0db1\u0dca\u0db1\u0dcf\u0d9a\u0db8\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd 87 \u0bb0\u0bbe\u0b9c\u0bbe \u0bb5\u0bb3\u0bbe\u0b95\u0bae\u0bcd, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd-\u0b95\u0bbe\u0b99\u0bcd\u0b95\u0bc7\u0b9a\u0ba9\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8 \u0bb0\u0bcb\u0b9f\u0bc1, \u0b9a\u0bc1\u0ba9\u0bcd\u0ba9\u0bbe\u0b95\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No Fuel": {
    si: "\u0d89\u0db1\u0dca\u0db0\u0db1 \u0db1\u0dd0\u0dad",
    ta: "\u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0b87\u0bb2\u0bcd\u0bb2\u0bc8",
  },
  "No, 243, Main Street, Haldummulla Haldummulla": {
    si: "\u0d85\u0d82\u0d9a 243, \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc0\u0dd3\u0daf\u0dd2\u0dba, \u0dc4\u0dbd\u0dca\u0daf\u0dd4\u0db8\u0dca\u0db8\u0dd4\u0dbd\u0dca\u0dbd \u0dc4\u0dbd\u0dca\u0daf\u0dd4\u0db8\u0dca\u0db8\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0b8e\u0ba3\u0bcd, 243, \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0bb2\u0bcd\u0ba4\u0bc1\u0bae\u0bc1\u0bb2\u0bcd\u0bb2 \u0bb9\u0bb2\u0bcd\u0ba4\u0bc1\u0bae\u0bc1\u0bb2\u0bcd\u0bb2",
  },
  "No, 76, Main Street, Panwila, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a, 76, \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc0\u0dd3\u0daf\u0dd2\u0dba, \u0db4\u0db1\u0dca\u0dc0\u0dd2\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd, 76, \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0ba9\u0bcd\u0bb5\u0bbf\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No. 08, Baddegama Road, Wanduramba, Wanduramba, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 08, \u0db6\u0daf\u0dca\u0daf\u0dda\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0dc0\u0db3\u0dd4\u0dbb\u0db9, \u0dc0\u0db3\u0dd4\u0dbb\u0db9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd. 08, \u0baa\u0ba4\u0bcd\u0ba4\u0bc7\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0ba8\u0bcd\u0ba4\u0bc1\u0bb0\u0bae\u0bcd\u0baa\u0bbe, \u0bb5\u0ba8\u0bcd\u0ba4\u0bc1\u0bb0\u0bae\u0bcd\u0baa\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No. 182/G, Divulapitiya Road, Minuwangoda, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 182/\u0da2\u0dd3, \u0daf\u0dd2\u0dc0\u0dd4\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db8\u0dd2\u0db1\u0dd4\u0dc0\u0db1\u0dca\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b87\u0bb2. 182/G, \u0ba4\u0bbf\u0bb5\u0bc1\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bbf\u0ba9\u0bc1\u0bb5\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No. 21/8, Buthgamuwa Road, Kalapaluwawa, Rajagiriya": {
    si: "\u0d85\u0d82\u0d9a 21/8, \u0db6\u0dd4\u0dad\u0dca\u0d9c\u0db8\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0d9a\u0dbd\u0db4\u0dc5\u0dd4\u0dc0\u0dcf\u0dc0, \u0dbb\u0dcf\u0da2\u0d9c\u0dd2\u0dbb\u0dd2\u0dba",
    ta: "\u0b87\u0bb2. 21/8, \u0baa\u0bc1\u0ba4\u0bcd\u0b95\u0bae\u0bc1\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb2\u0baa\u0bb2\u0bc1\u0bb5\u0bbe\u0bb5, \u0bb0\u0bbe\u0b9c\u0b95\u0bbf\u0bb0\u0bbf\u0baf",
  },
  "No. 258 Sri Sambuddhathva Jayanthi Mawatha, Colombo 00500, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 258 \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dc3\u0db8\u0dca\u0db6\u0dd4\u0daf\u0dca\u0db0\u0dad\u0dca\u0dc0 \u0da2\u0dba\u0db1\u0dca\u0dad\u0dd2 \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 00500, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd. 258 \u0bb8\u0bcd\u0bb0\u0bc0 \u0b9a\u0bae\u0bcd\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0ba4\u0bcd\u0bb5 \u0b9c\u0bc6\u0baf\u0ba8\u0bcd\u0ba4\u0bbf \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00500, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No. 260 H, B240, Battaramulla, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 260 H, B240, \u0db6\u0dad\u0dca\u0dad\u0dbb\u0db8\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd. 260 H, B240, \u0baa\u0ba4\u0bcd\u0ba4\u0bb0\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No. 360/A, Jaffna Junction, Anuradhapura, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 360/A, \u0dba\u0dcf\u0db4\u0db1\u0dba \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b87\u0bb2\u0b95\u0bcd\u0b95\u0bae\u0bcd 360/A, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No. 362 4 Way Junction, Sooriyawewa": {
    si: "\u0d85\u0d82\u0d9a 362 4 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0dc3\u0dd6\u0dbb\u0dd2\u0dba\u0dc0\u0dd0\u0dc0",
    ta: "\u0b87\u0bb2\u0b95\u0bcd\u0b95\u0bae\u0bcd 362 4 \u0bb5\u0bb4\u0bbf \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0baa\u0bcd\u0baa\u0bc1, \u0b9a\u0bc2\u0bb0\u0bbf\u0baf\u0bb5\u0bc6\u0bb5",
  },
  "No. 609a, Trinco Road, Urani,Batticaloa": {
    si: "\u0d85\u0d82\u0d9a 609a, \u0da7\u0dca\u200d\u0dbb\u0dd2\u0db1\u0dca\u0d9a\u0ddd \u0db4\u0dcf\u0dbb, \u0d8c\u0dbb\u0db1\u0dd2, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0",
    ta: "\u0b87\u0bb2. 609a, \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b8a\u0bb1\u0ba3\u0bbf, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1",
  },
  "No. 63 & 67, Mawanella Road, Rambukkana, Rambukkana, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 63 \u0dc3\u0dc4 67, \u0db8\u0dcf\u0dc0\u0db1\u0dd0\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0dbb\u0db9\u0dd4\u0d9a\u0dca\u0d9a\u0db1, \u0dbb\u0db9\u0dd4\u0d9a\u0dca\u0d9a\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b87\u0bb2. 63 & 67, \u0bae\u0bbe\u0bb5\u0ba9\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb0\u0bae\u0bcd\u0baa\u0bc1\u0b95\u0bcd\u0b95\u0ba9\u0bc8, \u0bb0\u0bae\u0bcd\u0baa\u0bc1\u0b95\u0bcd\u0b95\u0ba9\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No. 70 Kalutara-Matugama Rd, Kalawana, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 70 \u0d9a\u0dc5\u0dd4\u0dad\u0dbb-\u0db8\u0dad\u0dd4\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0d9a\u0dbd\u0dc0\u0dcf\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b87\u0bb2\u0b95\u0bcd\u0b95\u0bae\u0bcd 70 \u0b95\u0bb3\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8-\u0bae\u0ba4\u0bc1\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb2\u0bb5\u0bbe\u0ba9, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No.13, deniyaya road, rakwana, Rakwana, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 13, \u0daf\u0dd9\u0db1\u0dd2\u0dba\u0dcf\u0dba \u0db4\u0dcf\u0dbb, \u0dbb\u0d9a\u0dca\u0dc0\u0dcf\u0db1, \u0dbb\u0d9a\u0dca\u0dc0\u0dcf\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd.13, \u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe\u0baf \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb0\u0b95\u0bcd\u0bb5\u0bbe\u0ba9\u0bbe, \u0bb0\u0b95\u0bcd\u0bb5\u0bbe\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No.19 Colombo Main Rd, Avissawella, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 19 \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd.19 \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No.34, Mirisgoniyawa Trinco Road, Dambulla": {
    si: "\u0d85\u0d82\u0d9a 34, \u0db8\u0dd2\u0dbb\u0dd2\u0dc3\u0dca\u0d9c\u0ddd\u0db1\u0dd2\u0dba\u0dcf\u0dc0 \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0b87\u0bb2.34, \u0bae\u0bbf\u0bb0\u0bbf\u0bb8\u0bcd\u0b95\u0bca\u0ba9\u0bbf\u0baf\u0bbe\u0bb5 \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8",
  },
  "No2A, Petrol Shed junction, Ragama, Sri Lanka": {
    si: "No2A, \u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0dbd\u0dca \u0dc2\u0dd9\u0da9\u0dca \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0dbb\u0dcf\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "No2A, \u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bcd \u0bb7\u0bc6\u0b9f\u0bcd \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0baa\u0bcd\u0baa\u0bc1, \u0bb0\u0bbe\u0b95\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No: 195/2, Main Street, Akkaraipattu, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a: 195/2, \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc0\u0dd3\u0daf\u0dd2\u0dba, \u0d85\u0d9a\u0dca\u0d9a\u0dbb\u0db4\u0dad\u0dca\u0dad\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b87\u0bb2: 195/2, \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0b95\u0bcd\u0b95\u0bb0\u0bc8\u0baa\u0bcd\u0baa\u0bb1\u0bcd\u0bb1\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No: 296, Waththala, Enderamulla- Wattala": {
    si: "\u0d85\u0d82\u0d9a\u0dba: 296, \u0dc0\u0dad\u0dca\u0dad\u0dbd, \u0d91\u0dac\u0dda\u0dbb\u0db8\u0dd4\u0dbd\u0dca\u0dbd- \u0dc0\u0dad\u0dca\u0dad\u0dbd",
    ta: "\u0b87\u0bb2\u0b95\u0bcd\u0b95\u0bae\u0bcd: 296, \u0bb5\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8, \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bae\u0bc1\u0bb2\u0bcd\u0bb2- \u0bb5\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8",
  },
  "No:02,3rd Floor,Nawinna Junction, Kurunegala, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a: 02, 3 \u0dc0\u0db1 \u0db8\u0dc4\u0dbd, \u0db1\u0dcf\u0dc0\u0dd2\u0db1\u0dca\u0db1 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd: 02, 3\u0bb5\u0ba4\u0bc1 \u0ba4\u0bb3\u0bae\u0bcd, \u0ba8\u0bbe\u0bb5\u0bbf\u0ba9\u0bcd\u0ba9\u0bbe \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "No:82 Pasyala - Giriulla Rd, Mirigama": {
    si: "\u0d85\u0d82\u0d9a 82 \u0db4\u0dc3\u0dca\u0dba\u0dcf\u0dbd - \u0d9c\u0dd2\u0dbb\u0dd2\u0d8b\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dd3\u0dbb\u0dd2\u0d9c\u0db8",
    ta: "\u0b87\u0bb2:82 \u0baa\u0bb8\u0bcd\u0baf\u0bbe\u0bb2 - \u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bc1\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bc0\u0bb0\u0bbf\u0b95\u0bae",
  },
  Nochchiyagama: {
    si: "\u0db1\u0ddc\u0da0\u0dca\u0da0\u0dd2\u0dba\u0dcf\u0d9c\u0db8",
    ta: "\u0ba8\u0bca\u0b9a\u0bcd\u0b9a\u0bbf\u0baf\u0bbe\u0b95\u0bae",
  },
  "Noor, Main Street, Sainthamaruthu 32300, Sri Lanka": {
    si: "\u0db1\u0dd6\u0dbb\u0dca, \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc0\u0dd3\u0daf\u0dd2\u0dba, \u0dc3\u0dba\u0dd2\u0db1\u0dca\u0daf\u0db8\u0dbb\u0dd4\u0daf\u0dd4 32300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba8\u0bc2\u0bb0\u0bcd, \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b9a\u0bbe\u0baf\u0bcd\u0ba8\u0bcd\u0ba4\u0bae\u0bb0\u0bc1\u0ba4\u0bc1 32300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Norochcholai: {
    si: "\u0db1\u0ddc\u0dbb\u0ddc\u0da0\u0dca\u0da0\u0ddd\u0dbd\u0dda",
    ta: "\u0ba8\u0bca\u0bb0\u0bcb\u0b9a\u0bcd\u0b9a\u0bcb\u0bb2\u0bc8",
  },
  Nortonbridge: {
    si: "\u0db1\u0ddd\u0da7\u0db1\u0dca\u0db6\u0dca\u200d\u0dbb\u0dd2\u0da2\u0dca",
    ta: "\u0ba8\u0bbe\u0bb0\u0bcd\u0b9f\u0ba9\u0bcd\u0baa\u0bbf\u0bb0\u0bbf\u0b9f\u0bcd\u0b9c\u0bcd",
  },
  "Not Sure or Don't Know": {
    si: "\u0dc0\u0dd2\u0dc1\u0dca\u0dc0\u0dcf\u0dc3 \u0db1\u0dd0\u0dad \u0dc4\u0ddd \u0db1\u0ddc\u0daf\u0db1\u0dd3",
    ta: "\u0b89\u0bb1\u0bc1\u0ba4\u0bbf\u0baf\u0bbe\u0b95 \u0ba4\u0bc6\u0bb0\u0bbf\u0baf\u0bb5\u0bbf\u0bb2\u0bcd\u0bb2\u0bc8 \u0b85\u0bb2\u0bcd\u0bb2\u0ba4\u0bc1 \u0ba4\u0bc6\u0bb0\u0bbf\u0baf\u0bbe\u0ba4\u0bc1",
  },
  "Not Sure/Don't Know": {
    si: "\u0dc0\u0dd2\u0dc1\u0dca\u0dc0\u0dcf\u0dc3 \u0db1\u0dd0\u0dad/\u0db1\u0ddc\u0daf\u0db1\u0dd3",
    ta: "\u0b89\u0bb1\u0bc1\u0ba4\u0bbf\u0baf\u0bbe\u0b95 \u0ba4\u0bc6\u0bb0\u0bbf\u0baf\u0bb5\u0bbf\u0bb2\u0bcd\u0bb2\u0bc8/\u0ba4\u0bc6\u0bb0\u0bbf\u0baf\u0bb5\u0bbf\u0bb2\u0bcd\u0bb2\u0bc8",
  },
  Nugawela: {
    si: "\u0db1\u0dd4\u0d9c\u0dc0\u0dd9\u0dbd",
    ta: "\u0ba8\u0bc1\u0b95\u0bb5\u0bc6\u0bb2",
  },
  "Nuwara Eliya, Kandy - Nawalapitya, Weligalla": {
    si: "\u0db1\u0dd4\u0dc0\u0dbb\u0d91\u0dc5\u0dd2\u0dba, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb - \u0db1\u0dcf\u0dc0\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc0\u0dd0\u0dbd\u0dd2\u0d9c\u0dbd\u0dca\u0dbd",
    ta: "\u0ba8\u0bc1\u0bb5\u0bb0\u0bc6\u0bb2\u0bbf\u0baf\u0bbe, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf - \u0ba8\u0bbe\u0bb5\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf, \u0bb5\u0bc6\u0bb2\u0bbf\u0b95\u0bb2\u0bcd\u0bb2",
  },
  "O.M.ALIYAR SONS": {
    si: "\u0d95.\u0d91\u0db8\u0dca.\u0d85\u0dbd\u0dd2\u0dba\u0dcf\u0dbb\u0dca \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b93.\u0b8e\u0bae\u0bcd.\u0b85\u0bb2\u0bbf\u0baf\u0bbe\u0bb0\u0bcd \u0bae\u0b95\u0ba9\u0bcd\u0b95\u0bb3\u0bcd",
  },
  "OASIS PIRAVUMHALA": {
    si: "OASIS Piravumhala",
    ta: "\u0b92\u0baf\u0bbe\u0b9a\u0bbf\u0bb8\u0bcd \u0baa\u0bbf\u0bb1\u0bb5\u0bc1\u0bae\u0bcd\u0bb9\u0bbe\u0bb2\u0bbe",
  },
  "ODDAMAWADI MPCS LTD": {
    si: "\u0d94\u0daf\u0dca\u0daf\u0db8\u0dcf\u0dc0\u0dcf\u0da9\u0dd2 MPCS LTD",
    ta: "\u0b93\u0b9f\u0bcd\u0b9f\u0bae\u0bbe\u0bb5\u0b9f\u0bbf MPCS LTD",
  },
  "OKEMCO INDUSTRIAL CHEMICAL (PVT) LT": {
    si: "OKEMCO INDUSTRIAL chemical (PVT) LT",
    ta: "OKEMCO \u0b87\u0ba3\u0bcd\u0b9f\u0bb8\u0bcd\u0b9f\u0bcd\u0bb0\u0bbf\u0baf\u0bb2\u0bcd \u0b95\u0bc6\u0bae\u0bbf\u0b95\u0bcd\u0b95\u0bb2\u0bcd (PVT) LT",
  },
  "OKMART HOLDING (PVT) LTD": {
    si: "OKMART Holding (PVT) LTD",
    ta: "\u0b93\u0b95\u0bcd\u0bae\u0bbe\u0bb0\u0bcd\u0b9f\u0bcd \u0bb9\u0bcb\u0bb2\u0bcd\u0b9f\u0bbf\u0b99\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "OPAL LANKA (PVT) LTD": {
    si: "OPAL LANKA (PVT) LTD",
    ta: "OPAL LANKA (PVT) LTD",
  },
  "ORIENT PETROLEUM  (PVT) LTD.": {
    si: "ORIENT PETROLEUM (PVT) LTD.",
    ta: "\u0b93\u0bb0\u0bbf\u0baf\u0ba3\u0bcd\u0b9f\u0bcd \u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bbf\u0baf\u0bae\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd.",
  },
  "ORIYANTAL INTERNATIONAL (PVT)LTD": {
    si: "ORIYANTAL INTERNATIONAL (PVT)LTD",
    ta: "\u0b93\u0bb0\u0bbf\u0baf\u0ba3\u0bcd\u0b9f\u0bb2\u0bcd \u0b87\u0ba9\u0bcd\u0b9f\u0bb0\u0bcd\u0ba8\u0bc7\u0bb7\u0ba9\u0bb2\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  ORUGODAWATTA: {
    si: "ORUGODAWATTA",
    ta: "ORUGODAWATTA",
  },
  "OSAKA LANKA IOC FILLING STATION": {
    si: "OSAKA LANKA IOC \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "OSAKA LANKA IOC \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "OUFF ENTERPRISES (PVT) LTD": {
    si: "OUFF ENTERPRISES (PVT) LTD",
    ta: "OUFF Enterprises (PVT) LTD",
  },
  Oddamavadi: {
    si: "\u0d94\u0da9\u0dca\u0da9\u0db8\u0dcf\u0dc0\u0da9\u0dd2",
    ta: "\u0b93\u0b9f\u0bcd\u0b9f\u0bae\u0bbe\u0bb5\u0b9f\u0bbf",
  },
  Oddusuddan: {
    si: "\u0d94\u0da9\u0dca\u0da9\u0dd4\u0dc3\u0dd4\u0da9\u0dcf\u0db1\u0dca",
    ta: "\u0b92\u0b9f\u0bcd\u0b9f\u0bc1\u0b9a\u0bc1\u0b9f\u0bcd\u0b9f\u0bbe\u0ba9\u0bcd",
  },
  "Old Batticaloa Rd, Mutur": {
    si: "\u0db4\u0dd0\u0dbb\u0dab\u0dd2 \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0db8\u0dd4\u0dad\u0dd6\u0dbb\u0dca",
    ta: "\u0baa\u0bb4\u0bc8\u0baf \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bc2\u0ba4\u0bc2\u0bb0\u0bcd",
  },
  Oluvil: {
    si: "\u0d94\u0dbd\u0dd4\u0dc0\u0dd2\u0dbd\u0dca",
    ta: "\u0b92\u0bb2\u0bc1\u0bb5\u0bbf\u0bb2\u0bcd",
  },
  "Opening Stock": {
    si: "\u0d9a\u0ddc\u0da7\u0dc3\u0dca \u0dc0\u0dd2\u0dc0\u0dd8\u0dad \u0d9a\u0dd2\u0dbb\u0dd3\u0db8",
    ta: "\u0ba4\u0bbf\u0bb1\u0baa\u0bcd\u0baa\u0bc1 \u0baa\u0b99\u0bcd\u0b95\u0bc1",
  },
  "Outtalam-colombo Rd, Madampe": {
    si: "Outtalam-colombo Rd, Madampe",
    ta: "\u0b85\u0bb5\u0bc1\u0b9f\u0bcd\u0b9f\u0bbe\u0bb2\u0bae\u0bcd-\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bbe\u0ba4\u0bae\u0bcd\u0baa\u0bc7",
  },
  "Oyamaduwa, Thanthirimale Road Oyamaduwa": {
    si: "\u0d94\u0dba\u0dcf\u0db8\u0da9\u0dd4\u0dc0, \u0dad\u0db1\u0dca\u0dad\u0dd2\u0dbb\u0dd2\u0db8\u0dbd\u0dda \u0db4\u0dcf\u0dbb \u0d94\u0dba\u0dcf\u0db8\u0da9\u0dd4\u0dc0",
    ta: "\u0b93\u0baf\u0bae\u0b9f\u0bc1\u0bb5, \u0ba4\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0bbf\u0bae\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf \u0b93\u0baf\u0bae\u0b9f\u0bc1\u0bb5",
  },
  "Oyamduwa Junction, Sri Lanka": {
    si: "\u0d94\u0dba\u0dcf\u0db8\u0dca\u0daf\u0dd6\u0dc0 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b93\u0baf\u0bae\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P & P ENTERPRISE": {
    si: "P & P \u0dc0\u0dca\u0dba\u0dc0\u0dc3\u0dcf\u0dba",
    ta: "\u0baa\u0bbf & \u0baa\u0bbf \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0bb8\u0bcd",
  },
  "P A JAYANTHA UDAYA KUMARA": {
    si: "\u0db4\u0dd3 \u0d92 \u0da2\u0dba\u0db1\u0dca\u0dad \u0d8b\u0daf\u0dba \u0d9a\u0dd4\u0db8\u0dcf\u0dbb",
    ta: "\u0baa\u0bbf \u0b8f \u0b9c\u0bc6\u0baf\u0ba8\u0bcd\u0ba4 \u0b89\u0ba4\u0baf \u0b95\u0bc1\u0bae\u0bbe\u0bb0",
  },
  "P A K D JEEWANTHI": {
    si: "\u0db4\u0dd3 \u0d92 \u0d9a\u0dda \u0da9\u0dd3 \u0da2\u0dd3\u0dc0\u0db1\u0dca\u0dad\u0dd2",
    ta: "\u0baa\u0bbf \u0b8f \u0b95\u0bc7 \u0b9f\u0bbf \u0b9c\u0bc0\u0bb5\u0ba8\u0bcd\u0ba4\u0bbf",
  },
  "P A THILAKAWARDANA": {
    si: "\u0db4\u0dd3 \u0d92 \u0dad\u0dd2\u0dbd\u0d9a\u0dc0\u0dbb\u0dca\u0db0\u0db1",
    ta: "\u0baa\u0bbf \u0b8f \u0ba4\u0bbf\u0bb2\u0b95\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9",
  },
  "P A.INDRASENA": {
    si: "\u0db4\u0dd3 \u0d92 \u0d89\u0db1\u0dca\u0daf\u0dca\u200d\u0dbb\u0dc3\u0dda\u0db1",
    ta: "\u0baa\u0bbf \u0b8f.\u0b87\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0b9a\u0bc7\u0ba9\u0bbe",
  },
  "P ABEYSEKERA": {
    si: "\u0db4\u0dd3 \u0d85\u0db6\u0dda\u0dc3\u0dda\u0d9a\u0dbb",
    ta: "\u0baa\u0bbf \u0b85\u0baa\u0bc7\u0b9a\u0bc7\u0b95\u0bb0",
  },
  "P ANOMA  NILAMANI": {
    si: "\u0db4\u0dd3 \u0d85\u0db1\u0ddd\u0db8\u0dcf \u0db1\u0dd2\u0dbd\u0db8\u0dcf\u0db1\u0dd2",
    ta: "\u0baa\u0bbf \u0b85\u0ba9\u0bcb\u0bae\u0bbe \u0ba8\u0bbf\u0bb2\u0bbe\u0bae\u0ba3\u0bbf",
  },
  "P C K GALLAGE": {
    si: "\u0db4\u0dd3 \u0dc3\u0dd3 \u0d9a\u0dda \u0d9c\u0dcf\u0dbd\u0dca\u0dbd\u0d9c\u0dda",
    ta: "\u0baa\u0bbf \u0b9a\u0bbf \u0b95\u0bc7 \u0b95\u0bc7\u0bb2\u0b9c\u0bcd",
  },
  "P D E SENAVIRATNA": {
    si: "\u0db4\u0dd3 \u0da9\u0dd3 \u0d8a \u0dc3\u0dd9\u0db1\u0dc0\u0dd2\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0baa\u0bbf \u0b9f\u0bbf \u0b88 \u0b9a\u0bc7\u0ba9\u0bb5\u0bbf\u0bb0\u0ba4\u0bcd\u0ba9\u0bbe",
  },
  "P D H P KARUNARATNE": {
    si: "\u0db4\u0dd3 \u0da9\u0dd3 \u0d91\u0da0\u0dca \u0db4\u0dd3 \u0d9a\u0dbb\u0dd4\u0dab\u0dcf\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0baa\u0bbf \u0b9f\u0bbf \u0b8e\u0b9a\u0bcd \u0baa\u0bbf \u0b95\u0bb0\u0bc1\u0ba3\u0bbe\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "P D PRASAD JAYAWARDENA": {
    si: "\u0db4\u0dd3 \u0da9\u0dd3 \u0db4\u0dca\u200d\u0dbb\u0dc3\u0dcf\u0daf\u0dca \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1",
    ta: "\u0baa\u0bbf \u0b9f\u0bbf \u0baa\u0bbf\u0bb0\u0b9a\u0bbe\u0ba4\u0bcd \u0b9c\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9",
  },
  "P G  NIHAL KULASENA": {
    si: "\u0db4\u0dd3 \u0da2\u0dd3 \u0db1\u0dd2\u0dc4\u0dcf\u0dbd\u0dca \u0d9a\u0dd4\u0dbd\u0dc3\u0dda\u0db1",
    ta: "\u0baa\u0bbf \u0b9c\u0bbf \u0ba8\u0bbf\u0bb9\u0bbe\u0bb2\u0bcd \u0b95\u0bc1\u0bb2\u0b9a\u0bc7\u0ba9\u0bbe",
  },
  "P G W SAMARASEKARA": {
    si: "\u0db4\u0dd3 \u0da2\u0dd3 \u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0dc3\u0db8\u0dbb\u0dc3\u0dda\u0d9a\u0dbb",
    ta: "\u0baa\u0bbf \u0b9c\u0bbf \u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b9a\u0bae\u0bb0\u0b9a\u0bc7\u0b95\u0bb0",
  },
  "P G.SIRISENA": {
    si: "\u0db4\u0dd3 \u0da2\u0dd3.\u0dc3\u0dd2\u0dbb\u0dd2\u0dc3\u0dda\u0db1",
    ta: "\u0baa\u0bbf \u0b9c\u0bbf.\u0b9a\u0bbf\u0bb1\u0bbf\u0b9a\u0bc7\u0ba9\u0bbe",
  },
  "P H R DE SILVA": {
    si: "\u0db4\u0dd3 \u0d91\u0da0\u0dca \u0d86\u0dbb\u0dca \u0daf \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf",
    ta: "\u0baa\u0bbf \u0b8e\u0b9a\u0bcd \u0b86\u0bb0\u0bcd \u0b9f\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe",
  },
  "P J MUTUKUMARANA": {
    si: "\u0db4\u0dd3 \u0da2\u0dda \u0db8\u0dd4\u0dad\u0dd4\u0d9a\u0dd4\u0db8\u0dcf\u0dbb\u0db1",
    ta: "\u0baa\u0bbf \u0b9c\u0bc7 \u0bae\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0b95\u0bcd\u0b95\u0bc1\u0bae\u0bbe\u0bb0\u0ba9\u0bcd",
  },
  "P K B  N BANDARA": {
    si: "\u0db4\u0dd3 \u0d9a\u0dda \u0db6\u0dd3 \u0d91\u0db1\u0dca \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb",
    ta: "\u0baa\u0bbf \u0b95\u0bc7 \u0baa\u0bbf \u0b8e\u0ba9\u0bcd \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0",
  },
  "P K CHITHRA DAMAYANTHI": {
    si: "\u0db4\u0dd3 \u0d9a\u0dda \u0da0\u0dd2\u0dad\u0dca\u200d\u0dbb\u0dcf \u0daf\u0db8\u0dba\u0db1\u0dca\u0dad\u0dd2",
    ta: "\u0baa\u0bbf \u0b95\u0bc7 \u0b9a\u0bbf\u0ba4\u0bcd\u0bb0\u0bbe \u0ba4\u0bae\u0baf\u0ba8\u0bcd\u0ba4\u0bbf",
  },
  "P K SUBASINGHE": {
    si: "\u0db4\u0dd3 \u0d9a\u0dda \u0dc3\u0dd4\u0db6\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0baa\u0bbf \u0b95\u0bc7 \u0b9a\u0bc1\u0baa\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "P L C ALWIS ENTERPRISES": {
    si: "\u0db4\u0dd3 \u0d91\u0dbd\u0dca \u0dc3\u0dd3 \u0d85\u0dbd\u0dca\u0dc0\u0dd2\u0dc3\u0dca \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0baa\u0bbf \u0b8e\u0bb2\u0bcd \u0b9a\u0bbf \u0b85\u0bb2\u0bcd\u0bb5\u0bbf\u0bb8\u0bcd \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "P M NEVIL APPUHAME": {
    si: "\u0db4\u0dd3 \u0d91\u0db8\u0dca \u0db1\u0dd9\u0dc0\u0dd2\u0dbd\u0dca \u0d85\u0db4\u0dca\u0db4\u0dd4\u0dc4\u0dcf\u0db8\u0dda",
    ta: "\u0baa\u0bbf \u0b8e\u0bae\u0bcd \u0ba8\u0bc6\u0bb5\u0bbf\u0bb2\u0bcd \u0b85\u0baa\u0bcd\u0baa\u0bc1\u0bb9\u0bbe\u0bae\u0bc7",
  },
  "P M WIMALASIRI": {
    si: "\u0db4\u0dd3 \u0d91\u0db8\u0dca \u0dc0\u0dd2\u0db8\u0dbd\u0dc3\u0dd2\u0dbb\u0dd2",
    ta: "\u0baa\u0bbf \u0b8e\u0bae\u0bcd \u0bb5\u0bbf\u0bae\u0bb2\u0b9a\u0bbf\u0bb1\u0bbf",
  },
  "P P ABEYSINGHE": {
    si: "\u0db4\u0dd3 \u0db4\u0dd3 \u0d85\u0db6\u0dda\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0baa\u0bbf \u0baa\u0bbf \u0b85\u0baa\u0bc7\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "P P SAMARASINGHE": {
    si: "\u0db4\u0dd3 \u0db4\u0dd3 \u0dc3\u0db8\u0dbb\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0baa\u0bbf \u0baa\u0bbf \u0b9a\u0bae\u0bb0\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "P RAJANIKANTH": {
    si: "\u0db4\u0dd3 \u0dbb\u0dcf\u0da2\u0db1\u0dd2\u0d9a\u0dcf\u0db1\u0dca\u0dad\u0dca",
    ta: "\u0baa\u0bbf \u0bb0\u0b9c\u0ba9\u0bbf\u0b95\u0bbe\u0ba8\u0bcd\u0ba4\u0bcd",
  },
  "P RAMADAS": {
    si: "\u0db4\u0dd3 \u0dbb\u0dcf\u0db8\u0daf\u0dcf\u0dc3\u0dca",
    ta: "\u0baa\u0bbf \u0bb0\u0bbe\u0bae\u0ba4\u0bbe\u0bb8\u0bcd",
  },
  "P S  ABDULLA  &  SON": {
    si: "\u0db4\u0dd3 \u0d91\u0dc3\u0dca \u0d85\u0db6\u0dca\u0daf\u0dd4\u0dbd\u0dca\u0dbd\u0dcf \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0dcf",
    ta: "\u0baa\u0bbf \u0b8e\u0bb8\u0bcd \u0b85\u0baa\u0bcd\u0ba4\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe & \u0bae\u0b95\u0ba9\u0bcd",
  },
  "P S PIYATHILAKE & SONS PVT LTD": {
    si: "\u0db4\u0dd3 \u0d91\u0dc3\u0dca \u0db4\u0dd2\u0dba\u0dad\u0dd2\u0dbd\u0d9a \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd \u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0baa\u0bbf \u0b8e\u0bb8\u0bcd \u0baa\u0bbf\u0baf\u0ba4\u0bbf\u0bb2\u0b95\u0bc7 & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd \u0baa\u0bbf\u0bb0\u0bc8\u0bb5\u0bc7\u0b9f\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "P SUNIMAL": {
    si: "\u0db4\u0dd3 \u0dc3\u0dd4\u0db1\u0dd2\u0db8\u0dbd\u0dca",
    ta: "\u0baa\u0bbf \u0b9a\u0bc1\u0ba9\u0bbf\u0bae\u0bb2\u0bcd",
  },
  "P THAMBIPILLAI": {
    si: "\u0db4\u0dd3 \u0dad\u0db8\u0dca\u0db6\u0dd2\u0db4\u0dd2\u0dbd\u0dca\u0dbd\u0dda",
    ta: "\u0baa\u0bbf \u0ba4\u0bae\u0bcd\u0baa\u0bbf\u0baa\u0bcd\u0baa\u0bbf\u0bb3\u0bcd\u0bb3\u0bc8",
  },
  "P U WEERAWARDHANA": {
    si: "\u0db4\u0dd3 \u0dba\u0dd6 \u0dc0\u0dd3\u0dbb\u0dc0\u0dbb\u0dca\u0db0\u0db1",
    ta: "\u0baa\u0bbf \u0baf\u0bc1 \u0bb5\u0bc0\u0bb0\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9",
  },
  "P W RODRIGO": {
    si: "\u0db4\u0dd3 \u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0dbb\u0ddc\u0daf\u0dca\u0dbb\u0dd2\u0d9c\u0ddd",
    ta: "\u0baa\u0bbf \u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0bb0\u0bcb\u0b9f\u0bcd\u0bb0\u0bbf\u0b95\u0bcb",
  },
  "P.A.ARIYADASA & SON": {
    si: "\u0db4\u0dd3.\u0d92.\u0d86\u0dbb\u0dd2\u0dba\u0daf\u0dcf\u0dc3 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dcf",
    ta: "\u0baa\u0bbf.\u0b8f.\u0b85\u0bb0\u0bbf\u0baf\u0ba4\u0bbe\u0b9a\u0bbe & \u0bae\u0b95\u0ba9\u0bcd",
  },
  "P.A.C.KULATILLEKE": {
    si: "\u0db4\u0dd3.\u0d92.\u0dc3\u0dd3.\u0d9a\u0dd4\u0dbd\u0dad\u0dd2\u0dbd\u0d9a",
    ta: "\u0baa\u0bbf.\u0b8f.\u0b9a\u0bbf.\u0b95\u0bc1\u0bb2\u0ba4\u0bcd\u0ba4\u0bbf\u0bb2\u0bc7\u0b95\u0bc7",
  },
  "P.K.JAYATILLEKE": {
    si: "\u0db4\u0dd3.\u0d9a\u0dda.\u0da2\u0dba\u0dad\u0dd2\u0dbd\u0d9a",
    ta: "\u0baa\u0bbf.\u0b95\u0bc7.\u0b9c\u0bc6\u0baf\u0ba4\u0bbf\u0bb2\u0b95\u0bc7",
  },
  "P.K.KUMARASIRI PANDUWAWALA": {
    si: "\u0db4\u0dd3.\u0d9a\u0dda.\u0d9a\u0dd4\u0db8\u0dcf\u0dbb\u0dc3\u0dd2\u0dbb\u0dd2 \u0db4\u0dac\u0dd4\u0dc0\u0dcf\u0dc0\u0dbd",
    ta: "\u0baa\u0bbf.\u0b95\u0bc7.\u0b95\u0bc1\u0bae\u0bbe\u0bb0\u0b9a\u0bbf\u0bb1\u0bbf \u0baa\u0bbe\u0ba3\u0bcd\u0b9f\u0bc1\u0bb5\u0bb5\u0bb2",
  },
  "P.K.L.H.FERNANDO": {
    si: "P.K.L.H.Fernando",
    ta: "\u0baa\u0bbf.\u0b95\u0bc7.\u0b8e\u0bb2\u0bcd.\u0b8e\u0b9a\u0bcd.\u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "P.K.LIYANAGE": {
    si: "\u0db4\u0dd3.\u0d9a\u0dda.\u0dbd\u0dd2\u0dba\u0db1\u0d9c\u0dda",
    ta: "\u0baa\u0bbf.\u0b95\u0bc7.\u0bb2\u0bbf\u0baf\u0ba9\u0b95\u0bc7",
  },
  "P.KARUNARATNE": {
    si: "\u0db4\u0dd3.\u0d9a\u0dbb\u0dd4\u0dab\u0dcf\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0baa\u0bbf.\u0b95\u0bb0\u0bc1\u0ba3\u0bbe\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "P.L.R..C.COORAY": {
    si: "\u0db4\u0dd3.\u0d91\u0dbd\u0dca.\u0d86\u0dbb\u0dca.\u0dc3\u0dd3.\u0d9a\u0dd4\u0dbb\u0dda",
    ta: "\u0baa\u0bbf.\u0b8e\u0bb2\u0bcd.\u0b86\u0bb0\u0bcd..\u0b9a\u0bbf.\u0b95\u0bc2\u0bb0\u0bc7",
  },
  "P.M.K.RAHUMAN": {
    si: "P.M.K.Rahuman",
    ta: "\u0baa\u0bbf.\u0b8e\u0bae\u0bcd.\u0b95\u0bc7.\u0bb0\u0b95\u0bc1\u0bae\u0bbe\u0ba9\u0bcd",
  },
  "P.PRADEEP MIHINATH FERNANDO": {
    si: "P.PRADEEP Mihinath Fernando",
    ta: "\u0baa\u0bbf.\u0baa\u0bbf\u0bb0\u0ba4\u0bc0\u0baa\u0bcd \u0bae\u0bbf\u0bb9\u0bbf\u0ba9\u0bbe\u0ba4\u0bcd \u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "P.T.ARASAN & SON": {
    si: "P.T.ARASAN & SON",
    ta: "P.T.ARASAN & SON",
  },
  "P228+8CC, Jaffna, Sri Lanka": {
    si: "P228+8CC, \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P228+8CC, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P238+CWW, Jaffna, Sri Lanka": {
    si: "P238+CWW, \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P238+CWW, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P28V+RM3, Urumpirai West, Sri Lanka": {
    si: "P28V+RM3, \u0d8b\u0dbb\u0dd4\u0db8\u0dca\u0db4\u0dd2\u0dbb\u0dcf\u0dba\u0dd2 \u0db6\u0da7\u0dc4\u0dd2\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P28V+RM3, \u0b89\u0bb0\u0bc1\u0bae\u0bcd\u0baa\u0bbf\u0bb0\u0bbe\u0baf\u0bcd \u0bae\u0bc7\u0bb1\u0bcd\u0b95\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P2G8+MQ4, AB44, Siripura, Sri Lanka": {
    si: "P2G8+MQ4, AB44, \u0dc3\u0dd2\u0dbb\u0dd2\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P2G8+MQ4, AB44, \u0b9a\u0bbf\u0bb0\u0bbf\u0baa\u0bc1\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P2GM+CJW,   -   -      , Pokunuwita, Sri Lanka": {
    si: "P2GM+CJW, - - , \u0db4\u0ddc\u0d9a\u0dd4\u0dab\u0dd4\u0dc0\u0dd2\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P2GM+CJW, - - , \u0baa\u0bca\u0b95\u0bcd\u0b95\u0bc1\u0ba9\u0bc1\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P2HF+WMJ, Jaffna, Sri Lanka": {
    si: "P2HF+WMJ, \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P2HF+WMJ, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P2RG+66Q, Chunnakam, Sri Lanka": {
    si: "P2RG+66Q, \u0da0\u0dd4\u0db1\u0dca\u0db1\u0dcf\u0d9a\u0db8\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P2RG+66Q, \u0b9a\u0bc1\u0ba9\u0bcd\u0ba9\u0bbe\u0b95\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P2RG+G9Q, Chunnakam, Sri Lanka": {
    si: "P2RG+G9Q, \u0da0\u0dd4\u0db1\u0dca\u0db1\u0dcf\u0d9a\u0db8\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P2RG+G9Q, \u0b9a\u0bc1\u0ba9\u0bcd\u0ba9\u0bbe\u0b95\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P2V9+M8G, Koslanda, Sri Lanka": {
    si: "P2V9+M8G, \u0d9a\u0ddc\u0dc3\u0dca\u0dbd\u0db1\u0dca\u0daf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P2V9+M8G, \u0b95\u0bca\u0bb8\u0bcd\u0bb2\u0bbe\u0ba3\u0bcd\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P2WH+VJV, Chunnakam, Sri Lanka": {
    si: "P2WH+VJV, \u0da0\u0dd4\u0db1\u0dca\u0db1\u0dcf\u0d9a\u0db8\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P2WH+VJV, \u0b9a\u0bc1\u0ba9\u0bcd\u0ba9\u0bbe\u0b95\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P2XF+9CM, Gonapola, Sri Lanka": {
    si: "P2XF+9CM, \u0d9c\u0ddd\u0db1\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P2XF+9CM, \u0b95\u0bcb\u0ba9\u0bbe\u0baa\u0bcb\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P395+5JC, A8, Horana, Sri Lanka": {
    si: "P395+5JC, A8, \u0dc4\u0ddc\u0dbb\u0dab, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P395+5JC, A8, \u0bb9\u0bca\u0bb0\u0ba3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P395+CVJ Ceypetco Fuel Stations, Horana, Sri Lanka": {
    si: "P395+CVJ Ceypetco \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd\u0dca, \u0dc4\u0ddc\u0dbb\u0dab, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P395+CVJ Ceypetco \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0b99\u0bcd\u0b95\u0bb3\u0bcd, \u0bb9\u0bca\u0bb0\u0ba3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P3PX+P64, Siruppiddy, Sri Lanka": {
    si: "P3PX+P64, \u0dc3\u0dd2\u0dbb\u0dd4\u0db4\u0dca\u0db4\u0dd2\u0da9\u0dca\u0da9\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P3PX+P64, \u0b9a\u0bbf\u0bb1\u0bc1\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P48X+H2R, Katugastota-Kurunegala-Puttalam Hwy, Nikaweratiya, Sri Lanka": {
    si: "P48X+H2R, \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7-\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd-\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 Hwy, \u0db1\u0dd2\u0d9a\u0dc0\u0dd0\u0dbb\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P48X+H2R, \u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8-\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd-\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd Hwy, \u0ba8\u0bbf\u0b95\u0bcd\u0b95\u0bb5\u0bc6\u0bb0\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P4J2+9RG, Horana, Sri Lanka": {
    si: "P4J2+9RG, \u0dc4\u0ddc\u0dbb\u0dab, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P4J2+9RG, \u0bb9\u0bca\u0bb0\u0ba3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P4J3+R56, Wellawaya, Sri Lanka": {
    si: "P4J3+R56, \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P4J3+R56, \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P4M3+3XH, Wellawaya, Sri Lanka": {
    si: "P4M3+3XH, \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P4M3+3XH, \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P4PH+64Q, Katugastota-Kurunegala-Puttalam Hwy, Nikaweratiya, Sri Lanka": {
    si: "P4PH+64Q, \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7-\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd-\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 Hwy, \u0db1\u0dd2\u0d9a\u0dc0\u0dd0\u0dbb\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P4PH+64Q, \u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8-\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd-\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd Hwy, \u0ba8\u0bbf\u0b95\u0bcd\u0b95\u0bb5\u0bc6\u0bb0\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P4X8+7WC, Nikaweratiya, Sri Lanka": {
    si: "P4X8+7WC, \u0db1\u0dd2\u0d9a\u0dc0\u0dd0\u0dbb\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P4X8+7WC, \u0ba8\u0bbf\u0b95\u0bcd\u0b95\u0bb5\u0bc6\u0bb0\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P5CF+4Q6, Irrakkakandi, Sri Lanka": {
    si: "P5CF+4Q6, \u0d89\u0dbb\u0d9a\u0dca\u0d9a\u0d9a\u0db1\u0dca\u0da9\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P5CF+4Q6, \u0b87\u0bb0\u0b95\u0bcd\u0b95\u0b95\u0ba3\u0bcd\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P5PP+V3, Ingiriya, Sri Lanka": {
    si: "P5PP+V3, \u0d89\u0d82\u0d9c\u0dd2\u0dbb\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P5PP+V3, \u0b87\u0b99\u0bcd\u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P5VG+HW Ingiriya, Sri Lanka": {
    si: "P5VG+HW \u0d89\u0d82\u0d9c\u0dd2\u0dbb\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P5VG+HW \u0b87\u0b99\u0bcd\u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P743+698, Nelumkulama, Sri Lanka": {
    si: "P743+698, \u0db1\u0dd9\u0dc5\u0dd4\u0db8\u0dca\u0d9a\u0dd4\u0dbd\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P743+698, \u0ba8\u0bc6\u0bb2\u0bc1\u0bae\u0bcd\u0b95\u0bc1\u0bb3\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "P7JH+9Q6, A8, Idangoda, Sri Lanka": {
    si: "P7JH+9Q6, A8, \u0d89\u0daf\u0d82\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "P7JH+9Q6, A8, \u0b87\u0b9f\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PADAVI PARAKRAMAPURA MPCS LTD": {
    si: "\u0db4\u0daf\u0dc0\u0dd2 \u0db4\u0dbb\u0dcf\u0d9a\u0dca\u200d\u0dbb\u0db8\u0db4\u0dd4\u0dbb MPCS LTD",
    ta: "\u0baa\u0ba4\u0bb5\u0bbf \u0baa\u0bb0\u0bbe\u0b95\u0bcd\u0b95\u0bbf\u0bb0\u0bae\u0baa\u0bc1\u0bb0\u0bbe MPCS LTD",
  },
  "PADAVI SIRIPURA SEVA JANAPADA MPCS": {
    si: "\u0db4\u0daf\u0dc0\u0dd2 \u0dc3\u0dd2\u0dbb\u0dd2\u0db4\u0dd4\u0dbb \u0dc3\u0dda\u0dc0\u0dcf \u0da2\u0dcf\u0db1\u0db4\u0daf \u0d91\u0db8\u0dca.\u0db4\u0dd3.\u0dc3\u0dd3.\u0d91\u0dc3\u0dca",
    ta: "\u0baa\u0ba4\u0bb5\u0bbf \u0b9a\u0bbf\u0bb0\u0bbf\u0baa\u0bc1\u0bb0 \u0b9a\u0bc7\u0bb5\u0bbe \u0b9c\u0ba9\u0baa\u0ba4\u0bbe \u0b8e\u0bae\u0bcd.\u0baa\u0bbf.\u0b9a\u0bbf.\u0b8e\u0bb8\u0bcd",
  },
  "PALLEPOLA MPCS LTD": {
    si: "\u0db4\u0dbd\u0dca\u0dbd\u0dd9\u0db4\u0ddc\u0dbd MPCS LTD",
    ta: "\u0baa\u0bb2\u0bcd\u0bb2\u0bc7\u0baa\u0bca\u0bb2 MPCS LTD",
  },
  "PANADURA AUTO SERVICE & FILLING STN": {
    si: "\u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb \u0d94\u0da7\u0ddd \u0dc3\u0dbb\u0dca\u0dc0\u0dd2\u0dc3\u0dca \u0dc3\u0dc4 \u0dc6\u0dd2\u0dbd\u0dd2\u0d82 STN",
    ta: "\u0baa\u0bbe\u0ba3\u0b9f\u0bc1\u0bb0\u0bbe \u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0b9a\u0bb0\u0bcd\u0bb5\u0bc0\u0bb8\u0bcd & \u0b83\u0baa\u0bbf\u0bb2\u0bcd\u0bb2\u0bbf\u0b99\u0bcd STN",
  },
  "PANADURA MPCS LTD": {
    si: "\u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb MPCS LTD",
    ta: "\u0baa\u0bbe\u0ba3\u0b9f\u0bc1\u0bb0\u0bbe MPCS LTD",
  },
  "PANDETHIRUPPU MPCS LTD": {
    si: "\u0db4\u0dab\u0dca\u0da9\u0dd9\u0dad\u0dd2\u0dbb\u0dd4\u0db4\u0dca\u0db4\u0dd4 MPCS LTD",
    ta: "\u0baa\u0bbe\u0ba3\u0bcd\u0b9f\u0bc7\u0ba4\u0bbf\u0bb0\u0bc1\u0baa\u0bcd\u0baa\u0bc1 MPCS LTD",
  },
  "PANDETHIRUPPU PARISH MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db4\u0dab\u0dca\u0da9\u0dd9\u0dad\u0dd2\u0dbb\u0dd4\u0db4\u0dca\u0db4\u0dd4 \u0db4\u0dcf\u0dbb\u0dca\u0dc1\u0dca\u0dc0 MPCS",
    ta: "\u0baa\u0bbe\u0ba3\u0bcd\u0b9f\u0bc7\u0ba4\u0bbf\u0bb0\u0bc1\u0baa\u0bcd\u0baa\u0bc1 \u0baa\u0bb0\u0bbf\u0bb7\u0bcd MPCS LTD",
  },
  "PANIL PATTU MPCS LTD": {
    si: "PANIL PATTU MPCS LTD",
    ta: "\u0baa\u0ba9\u0bbf\u0bb2\u0bcd \u0baa\u0b9f\u0bcd\u0b9f\u0bc1 MPCS LTD",
  },
  "PANNALA.": {
    si: "\u0db4\u0db1\u0dca\u0db1\u0dbd.",
    ta: "\u0baa\u0ba9\u0bcd\u0ba9\u0bbe\u0bb2\u0bbe.",
  },
  PANNIPITIYA: {
    si: "\u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bbf\u0baf\u0bbe",
  },
  "PANNIPITIYA, (BORELLA ROAD)": {
    si: "\u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba, (\u0db6\u0ddc\u0dbb\u0dd0\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb)",
    ta: "\u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, (\u0baa\u0bca\u0bb0\u0bb2\u0bcd\u0bb2\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8)",
  },
  "PARANAGAMA DUDLEY": {
    si: "\u0db4\u0dbb\u0dab\u0d9c\u0db8 \u0da9\u0da9\u0dca\u0dbd\u0dd2",
    ta: "\u0baa\u0bb0\u0ba3\u0b95\u0bae \u0b9f\u0b9f\u0bcd\u0bb2\u0bbf",
  },
  "PASSARA MPCS LTD": {
    si: "PASSARA MPCS LTD",
    ta: "PASSARA MPCS LTD",
  },
  "PATHMANATHAN MRS. A": {
    si: "\u0db4\u0daf\u0dca\u0db8\u0db1\u0dcf\u0daf\u0db1\u0dca \u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba. \u0d92",
    ta: "\u0baa\u0ba4\u0bcd\u0bae\u0ba8\u0bbe\u0ba4\u0ba9\u0bcd \u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf. \u0b8f",
  },
  "PEARL HOLDINGS ( PVT ) LTD": {
    si: "\u0db4\u0dbb\u0dca\u0dbd\u0dca \u0dc4\u0ddd\u0dbd\u0dca\u0da9\u0dd2\u0d82\u0d9c\u0dca\u0dc3\u0dca (\u0db4\u0dde\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0baa\u0bc7\u0bb0\u0bcd\u0bb2\u0bcd \u0bb9\u0bcb\u0bb2\u0bcd\u0b9f\u0bbf\u0b99\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "PELMADULLA MPCS LTD": {
    si: "\u0db4\u0dd0\u0dbd\u0dca\u0db8\u0da9\u0dd4\u0dbd\u0dca\u0dbd MPCS LTD",
    ta: "\u0baa\u0bc6\u0bb2\u0bcd\u0bae\u0b9f\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe MPCS LTD",
  },
  "PERERA & SONS  & CO.": {
    si: "\u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd \u0dc3\u0dc4 \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd & \u0b95\u0bcb.",
  },
  "PETRO GAS (PVT) LTD": {
    si: "PETRO GAS (PVT) LTD",
    ta: "PETRO GAS (PVT) LTD",
  },
  "PFFQ+328, A9, Vavuniya, Sri Lanka": {
    si: "PFFQ+328, A9, \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PFFQ+328, A9, \u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PGRAS WIJEWARDANA & BAM RANJITH BAN": {
    si: "PGRAS \u0dc0\u0dd2\u0da2\u0dda\u0dc0\u0dbb\u0dca\u0db0\u0db1 \u0dc3\u0dc4 \u0db6\u0dcf\u0db8\u0dca \u0dbb\u0d82\u0da2\u0dd2\u0dad\u0dca \u0db6\u0dd1\u0db1\u0dca",
    ta: "PGRAS \u0bb5\u0bbf\u0b9c\u0bc7\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0bbe & \u0baa\u0bbe\u0bae\u0bcd \u0bb0\u0b9e\u0bcd\u0b9a\u0bbf\u0ba4\u0bcd \u0ba4\u0b9f\u0bc8",
  },
  "PILIYANDALA - BOKUNDARA MPCS LTD": {
    si: "\u0db4\u0dd2\u0dc5\u0dd2\u0dba\u0db1\u0dca\u0daf\u0dbd - \u0db6\u0ddd\u0d9a\u0dd4\u0db1\u0dca\u0daf\u0dbb MPCS LTD",
    ta: "\u0baa\u0bbf\u0bb2\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bb2\u0bc8 - \u0baa\u0bcb\u0b95\u0bc1\u0ba8\u0bcd\u0ba4\u0bb0 MPCS LTD",
  },
  "PINGHANE-KOTTAWA": {
    si: "\u0db4\u0dd2\u0d82\u0d9c\u0db1\u0dda-\u0d9a\u0ddc\u0da7\u0dca\u0da7\u0dcf\u0dc0",
    ta: "\u0baa\u0bbf\u0b99\u0bcd\u0b95\u0ba9\u0bc7-\u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0bbe\u0bb5\u0bbe",
  },
  "PM8X+VMH, Trinco Rd, Batticaloa, Sri Lanka": {
    si: "PM8X+VMH, Trinco Rd, Batticaloa, Sri Lanka",
    ta: "PM8X+VMH, Trinco Rd, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PM9W+RX6, Batticaloa, Sri Lanka": {
    si: "PM9W+RX6, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PM9W+RX6, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PM9X+7W6, Batticaloa, Sri Lanka": {
    si: "PM9X+7W6, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PM9X+7W6, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PMHF+W95, Trincomalee Hwy, Batticaloa, Sri Lanka": {
    si: "PMHF+W95, Trincomalee Hwy, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PMHF+W95, Trincomalee Hwy, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PMV4+2GM, Trincomalee Hwy, Batticaloa, Sri Lanka": {
    si: "PMV4+2GM, \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba Hwy, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PMV4+2GM, Trincomalee Hwy, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "POINT PEDRO MPCS LTD": {
    si: "\u0db4\u0dda\u0daf\u0dd4\u0dbb\u0dd4\u0dad\u0dd4\u0da9\u0dd4\u0dc0 MPCS LTD",
    ta: "\u0baa\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8 MPCS LTD",
  },
  "POLGAHAWELA MPCS LTD": {
    si: "\u0db4\u0ddc\u0dbd\u0dca\u0d9c\u0dc4\u0dc0\u0dd9\u0dbd MPCS LTD",
    ta: "\u0baa\u0bca\u0bb2\u0bcd\u0b95\u0bb9\u0bb5\u0bc6\u0bb2 MPCS LTD",
  },
  "POLONNARUWA MPCS LTD": {
    si: "\u0db4\u0ddc\u0dc5\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0 MPCS LTD",
    ta: "\u0baa\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5\u0bc8 MPCS LTD",
  },
  "POLPITHIGAMA SANASA UNION (PVT) LTD": {
    si: "\u0db4\u0ddc\u0dbd\u0dca\u0db4\u0dd2\u0dad\u0dd2\u0d9c\u0db8 \u0dc3\u0dab\u0dc3 \u0dba\u0dd4\u0db1\u0dd2\u0dba\u0db1\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0baa\u0bca\u0bb2\u0bcd\u0baa\u0bbf\u0ba4\u0bbf\u0b95\u0bae \u0b9a\u0ba9\u0b9a \u0baf\u0bc2\u0ba9\u0bbf\u0baf\u0ba9\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "POLPITIGAMA MPCS LTD": {
    si: "\u0db4\u0ddc\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0d9c\u0db8 MPCS LTD",
    ta: "\u0baa\u0bca\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bae MPCS LTD",
  },
  "POONAKARI MPCS LTD": {
    si: "\u0db4\u0dd6\u0db1\u0d9a\u0dbb\u0dd2 MPCS LTD",
    ta: "\u0baa\u0bc2\u0ba8\u0b95\u0bb0\u0bbf MPCS LTD",
  },
  "POONAKARY MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db4\u0dd6\u0db1\u0d9a\u0dbb\u0dd2 MPCS",
    ta: "\u0baa\u0bc2\u0ba8\u0b95\u0bb0\u0bbf MPCS LTD",
  },
  "POTTUVIL MPCS LTD": {
    si: "\u0db4\u0ddc\u0dad\u0dd4\u0dc0\u0dd2\u0dbd\u0dca MPCS LTD",
    ta: "\u0baa\u0bca\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbf\u0bb2\u0bcd MPCS LTD",
  },
  "PPF2+Q7H, Bailey 3rd Cross St, Batticaloa, Sri Lanka": {
    si: "PPF2+Q7H, Bailey 3rd Cross St, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PPF2+Q7H, \u0baa\u0bc6\u0baf\u0bcd\u0bb2\u0bbf 3\u0bb5\u0ba4\u0bc1 \u0b95\u0bc1\u0bb1\u0bc1\u0b95\u0bcd\u0b95\u0bc1, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PQCP+98W, Sri Lanka": {
    si: "PQCP+98W, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PQCP+98W, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PQJR+GC4, Elahara, Sri Lanka": {
    si: "PQJR+GC4, \u0d91\u0dbd\u0dc4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PQJR+GC4, \u0b8e\u0bb2\u0bb9\u0bbe\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PR2H+4J9, Daluwa, Sri Lanka": {
    si: "PR2H+4J9, \u0daf\u0dc5\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PR2H+4J9, \u0ba4\u0bb2\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PREMACHANDRA  FILLING & SERVICES ST": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0dda\u0db8\u0da0\u0db1\u0dca\u0daf\u0dca\u200d\u0dbb \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca \u0dc3\u0dc4 \u0dc3\u0dda\u0dc0\u0dcf \u0dc1\u0dcf\u0db1\u0dca\u0dad",
    ta: "\u0baa\u0bbf\u0bb0\u0bc7\u0bae\u0b9a\u0bcd\u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0bbe \u0b83\u0baa\u0bbf\u0bb2\u0bcd\u0bb2\u0bbf\u0b99\u0bcd & \u0b9a\u0bb0\u0bcd\u0bb5\u0bc0\u0b9a\u0bb8\u0bcd \u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd",
  },
  "PREMACHANDRA FILLING STN": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0dda\u0db8\u0da0\u0db1\u0dca\u0daf\u0dca\u200d\u0dbb \u0dc6\u0dd2\u0dbd\u0dd2\u0d82 STN",
    ta: "\u0baa\u0bbf\u0bb0\u0bc7\u0bae\u0b9a\u0bcd\u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0bbe \u0baa\u0bbf\u0bb2\u0bcd\u0bb2\u0bbf\u0b99\u0bcd STN",
  },
  "PREMARATNE  H M": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0dda\u0db8\u0dbb\u0dad\u0dca\u0db1 \u0d91\u0da0\u0dca \u0d91\u0db8\u0dca",
    ta: "\u0baa\u0bbf\u0bb0\u0bc7\u0bae\u0bb0\u0ba4\u0bcd\u0ba9 \u0b8e\u0b9a\u0bcd.\u0b8e\u0bae\u0bcd",
  },
  "PRESIDENT SERVICE INSTITUTE FUND": {
    si: "\u0da2\u0db1\u0dcf\u0db0\u0dd2\u0db4\u0dad\u0dd2 \u0dc3\u0dda\u0dc0\u0dcf \u0d86\u0dba\u0dad\u0db1 \u0d85\u0dbb\u0db8\u0dd4\u0daf\u0dbd",
    ta: "\u0baa\u0bbf\u0bb0\u0b9a\u0bbf\u0b9f\u0bc6\u0ba9\u0bcd\u0b9f\u0bcd \u0b9a\u0bb0\u0bcd\u0bb5\u0bc0\u0bb8\u0bcd \u0b87\u0ba9\u0bcd\u0bb8\u0bcd\u0b9f\u0bbf\u0b9f\u0bcd\u0baf\u0bc2\u0b9f\u0bcd \u0b83\u0baa\u0ba3\u0bcd\u0b9f\u0bcd",
  },
  "PRF3+JP Belihuloya, Sri Lanka": {
    si: "PRF3+JP \u0db6\u0dd9\u0dbd\u0dd2\u0dc4\u0dd4\u0dbd\u0dca\u0d94\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PRF3+JP \u0baa\u0bc6\u0bb2\u0bbf\u0bb9\u0bc1\u0bb2\u0bcb\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PRIYANKARA CONSTRUCTION": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0dd2\u0dba\u0d82\u0d9a\u0dbb \u0d89\u0daf\u0dd2\u0d9a\u0dd2\u0dbb\u0dd3\u0db8\u0dca",
    ta: "\u0baa\u0bbf\u0bb0\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0bbe\u0bb0\u0bbe \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0bae\u0bbe\u0ba9\u0bae\u0bcd",
  },
  "PRODUCERS & MANUFACTURERS LTD": {
    si: "\u0db1\u0dd2\u0dc2\u0dca\u0db4\u0dcf\u0daf\u0d9a\u0dba\u0dd2\u0db1\u0dca \u0dc3\u0dc4 \u0db1\u0dd2\u0dc2\u0dca\u0db4\u0dcf\u0daf\u0d9a\u0dba\u0dd2\u0db1\u0dca LTD",
    ta: "\u0ba4\u0baf\u0bbe\u0bb0\u0bbf\u0baa\u0bcd\u0baa\u0bbe\u0bb3\u0bb0\u0bcd\u0b95\u0bb3\u0bcd \u0bae\u0bb1\u0bcd\u0bb1\u0bc1\u0bae\u0bcd \u0b89\u0bb1\u0bcd\u0baa\u0ba4\u0bcd\u0ba4\u0bbf\u0baf\u0bbe\u0bb3\u0bb0\u0bcd\u0b95\u0bb3\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "PS Junction Bus Stop, Nagoda - Kalawellawa - Bellapitiya Road, Mahagama, Sri Lanka":
    {
      si: "PS \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0db1\u0dcf\u0d9c\u0ddc\u0da9 - \u0d9a\u0dbd\u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dcf\u0dc0 - \u0db6\u0dd9\u0dbd\u0dca\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "PS \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0ba8\u0bbe\u0b95\u0bca\u0b9f - \u0b95\u0bb2\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5 - \u0baa\u0bc6\u0bb2\u0bcd\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0bb9\u0bbe\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "PULIYAMKULAM.": {
    si: "\u0db4\u0dd4\u0dbd\u0dd2\u0dba\u0db8\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca.",
    ta: "\u0baa\u0bc1\u0bb3\u0bbf\u0baf\u0bae\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd.",
  },
  "PULOLY MPCS LTD": {
    si: "\u0db4\u0dd4\u0dbd\u0ddd\u0dbd\u0dd2 \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0baa\u0bc1\u0bb2\u0bcb\u0bb2\u0bbf \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0b9a\u0bbf\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "PUNDALU OYA MPCS LTD": {
    si: "\u0db4\u0dd4\u0dab\u0dca\u0da9\u0dbd\u0dd4 \u0d94\u0dba MPCS LTD",
    ta: "\u0baa\u0bc2\u0ba3\u0bcd\u0b9f\u0bb2\u0bc1 \u0b93\u0baf\u0bbe MPCS LTD",
  },
  "PUNGUDUTIVU MPCS LTD": {
    si: "\u0db4\u0dd4\u0d82\u0d9c\u0dd4\u0da9\u0dd4\u0dad\u0dd2\u0dc0\u0dca MPCS LTD",
    ta: "\u0baa\u0bc1\u0b99\u0bcd\u0b95\u0bc1\u0b9f\u0bc1\u0ba4\u0bc0\u0bb5\u0bc1 MPCS LTD",
  },
  "PUTHUKUDIYIRUPPU MPCS LTD": {
    si: "\u0db4\u0dd4\u0daf\u0dd4\u0d9a\u0dd4\u0da9\u0dd2\u0d89\u0dbb\u0dd4\u0db4\u0dca\u0db4\u0dd4 MPCS LTD",
    ta: "\u0baa\u0bc1\u0ba4\u0bc1\u0b95\u0bcd\u0b95\u0bc1\u0b9f\u0bbf\u0baf\u0bbf\u0bb0\u0bc1\u0baa\u0bcd\u0baa\u0bc1 MPCS LTD",
  },
  "PUTTALAM MPCS LTD": {
    si: "\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 MPCS LTD",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd MPCS LTD",
  },
  "PV58+PH Kayts, Sri Lanka": {
    si: "PV58+PH \u0d9a\u0dba\u0dd2\u0da7\u0dca\u0dc3\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PV58+PH \u0b8a\u0bb0\u0bcd\u0b95\u0bbe\u0bb5\u0bb2\u0bcd\u0baa\u0b9f\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PVJW+7P6, Moratuwa, Sri Lanka": {
    si: "PVJW+7P6, \u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PVJW+7P6, \u0bae\u0bca\u0bb0\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PVQQ+QR6, Karainagar, Sri Lanka": {
    si: "PVQQ+QR6, \u0d9a\u0dbb\u0dd9\u0dba\u0dd2\u0db1\u0d9c\u0dbb\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PVQQ+QR6, \u0b95\u0bbe\u0bb0\u0bc8\u0ba8\u0b95\u0bb0\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PW74+3X7, Panadura, Sri Lanka": {
    si: "PW74+3X7, \u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PW74+3X7, \u0baa\u0bbe\u0ba3\u0ba8\u0bcd\u0ba4\u0bc1\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PW75+VQX, Panadura, Sri Lanka": {
    si: "PW75+VQX, \u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PW75+VQX, \u0baa\u0bbe\u0ba3\u0ba8\u0bcd\u0ba4\u0bc1\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PW82+HPJ, Panadura, Sri Lanka": {
    si: "PW82+HPJ, \u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PW82+HPJ, \u0baa\u0bbe\u0ba3\u0ba8\u0bcd\u0ba4\u0bc1\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PWQ3+99R, Panadura 12500, Sri Lanka": {
    si: "PWQ3+99R, \u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb 12500, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PWQ3+99R, \u0baa\u0bbe\u0ba3\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8 12500, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PX5H+RQ6, Bandaragama, Sri Lanka": {
    si: "PX5H+RQ6, \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PX5H+RQ6, \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0b95\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PX7Q+JG7, A8, Bandaragama, Sri Lanka": {
    si: "PX7Q+JG7, A8, \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PX7Q+JG7, A8, \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0b95\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PX9W+CJP, Manipay, Sri Lanka": {
    si: "PX9W+CJP, Manipay, Sri Lanka",
    ta: "PX9W+CJP, \u0bae\u0bbe\u0ba9\u0bbf\u0baa\u0bcd\u0baa\u0bbe\u0baf\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "PXRP+5H3, Sandilipay, Sri Lanka": {
    si: "PXRP+5H3, Sandilipay, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "PXRP+5H3, \u0b9a\u0ba3\u0bcd\u0b9f\u0bbf\u0bb2\u0bbf\u0baa\u0bcd\u0baa\u0bbe\u0baf\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Pachchilapalli: {
    si: "\u0db4\u0da0\u0dca\u0da0\u0dd2\u0dbd\u0db4\u0dbd\u0dca\u0dbd\u0dd2",
    ta: "\u0baa\u0b9a\u0bcd\u0b9a\u0bbf\u0bb2\u0baa\u0bcd\u0baa\u0bb3\u0bcd\u0bb3\u0bbf",
  },
  "Pachchilapalli,Pallai": {
    si: "\u0db4\u0da0\u0dca\u0da0\u0dd2\u0dbd\u0db4\u0dbd\u0dca\u0dbd\u0dd2, \u0db4\u0dbd\u0dd9\u0dba\u0dd2",
    ta: "\u0baa\u0b9a\u0bcd\u0b9a\u0bbf\u0bb2\u0baa\u0bcd\u0baa\u0bb3\u0bcd\u0bb3\u0bbf, \u0baa\u0bbe\u0bb3\u0bc8",
  },
  "Padavi Sripura, Welioya": {
    si: "\u0db4\u0daf\u0dc0\u0dd2 \u0dc1\u0dca\u200d\u0dbb\u0dd3\u0db4\u0dd4\u0dbb, \u0dc0\u0dd0\u0dbd\u0dd2\u0d94\u0dba",
    ta: "\u0baa\u0ba4\u0bb5\u0bbf \u0bb8\u0bcd\u0bb0\u0bc0\u0baa\u0bc1\u0bb0, \u0bb5\u0bc6\u0bb2\u0bbf\u0b93\u0baf\u0bbe",
  },
  "Padaviya Rd, Padaviya": {
    si: "\u0db4\u0daf\u0dc0\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db4\u0daf\u0dc0\u0dd2\u0dba",
    ta: "\u0baa\u0ba4\u0bb5\u0bbf\u0baf\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0ba4\u0bb5\u0bbf\u0baf\u0bbe",
  },
  "Padeniya - Anuradhapura Highway, Daladagama": {
    si: "\u0db4\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba - \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0daf\u0dc5\u0daf\u0dcf\u0d9c\u0db8",
    ta: "\u0baa\u0ba4\u0bc6\u0ba9\u0bbf\u0baf - \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0ba4\u0bb2\u0ba4\u0bbe\u0b95\u0bae",
  },
  "Padiyanthalawa Road, Mahiyanganaya": {
    si: "\u0db4\u0daf\u0dd2\u0dba\u0db1\u0dca\u0dad\u0dbd\u0dcf\u0dc0 \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1\u0dba",
    ta: "\u0baa\u0ba4\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bb2\u0bbe\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bb9\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0ba9\u0bc8",
  },
  "Padukka - Meepe Junction": {
    si: "\u0db4\u0dcf\u0daf\u0dd4\u0d9a\u0dca\u0d9a - \u0db8\u0dd3\u0db4\u0dda \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba",
    ta: "\u0baa\u0bbe\u0ba4\u0bc1\u0b95\u0bcd\u0b95 - \u0bae\u0bc0\u0baa\u0bcd\u0baa\u0bc7 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf",
  },
  "Padukka Rd, Padukka": {
    si: "\u0db4\u0dcf\u0daf\u0dd4\u0d9a\u0dca\u0d9a \u0db4\u0dcf\u0dbb, \u0db4\u0dcf\u0daf\u0dd4\u0d9a\u0dca\u0d9a",
    ta: "\u0baa\u0b9f\u0bc1\u0b95\u0bcd\u0b95\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0b9f\u0bc1\u0b95\u0bcd\u0b95\u0bbe",
  },
  "Pahathagama, Hanwella, Sri Lanka": {
    si: "\u0db4\u0dc4\u0dad\u0d9c\u0db8, \u0dc4\u0d82\u0dc0\u0dd0\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bb9\u0ba4\u0b95\u0bae, \u0bb9\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Pahathgama Gas Station, High Level Rd, Hanwella": {
    si: "\u0db4\u0dc4\u0dad\u0dca\u0d9c\u0db8 \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0dc4\u0dba\u0dd2\u0dbd\u0dd9\u0dc0\u0dbd\u0dca \u0db4\u0dcf\u0dbb, \u0dc4\u0d82\u0dc0\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0baa\u0bb9\u0ba4\u0bcd\u0b95\u0bae \u0b8e\u0bb0\u0bbf\u0bb5\u0bbe\u0baf\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b89\u0baf\u0bb0\u0bcd \u0bae\u0b9f\u0bcd\u0b9f \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2",
  },
  "Palali Rd, Jaffna": {
    si: "\u0db4\u0dbd\u0dcf\u0dbd\u0dd2 \u0db4\u0dcf\u0dbb, \u0dba\u0dcf\u0db4\u0db1\u0dba",
    ta: "\u0baa\u0bb2\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd",
  },
  "Palali Rd,jaffna": {
    si: "\u0db4\u0dbd\u0dcf\u0dbd\u0dd2 \u0db4\u0dcf\u0dbb, \u0dba\u0dcf\u0db4\u0db1\u0dba",
    ta: "\u0baa\u0bb2\u0bbe\u0bb2\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0baf\u0bbe\u0bb4\u0bcd",
  },
  Palameenmadhu: {
    si: "\u0db4\u0dcf\u0dbd\u0db8\u0dd3\u0db1\u0dca\u0db8\u0da9\u0dd4",
    ta: "\u0baa\u0bbe\u0bb2\u0bae\u0bc0\u0ba9\u0bcd\u0bae\u0ba4\u0bc1",
  },
  "Palapathwela - Galewela Rd, Pallepola": {
    si: "\u0db4\u0dbd\u0dcf\u0db4\u0dad\u0dca\u0dc0\u0dd9\u0dbd - \u0d9c\u0dbd\u0dda\u0dc0\u0dd9\u0dbd \u0db4\u0dcf\u0dbb, \u0db4\u0dbd\u0dca\u0dbd\u0dd9\u0db4\u0ddc\u0dbd",
    ta: "\u0baa\u0bb2\u0baa\u0ba4\u0bcd\u0bb5\u0bc6\u0bb2 - \u0b95\u0bb2\u0bc7\u0bb5\u0bc6\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bb2\u0bcd\u0bb2\u0bc7\u0baa\u0bca\u0bb2",
  },
  "Palavi - Kalpitiya Rd Etalai": {
    si: "\u0db4\u0dcf\u0dbd\u0dc0\u0dd2 - \u0d9a\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb \u0d8a\u0da7\u0dcf\u0dbd\u0dd9\u0dba\u0dd2",
    ta: "\u0baa\u0bbe\u0bb2\u0bbe\u0bb5\u0bbf - \u0b95\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf \u0b8e\u0ba4\u0bcd\u0ba4\u0bb2\u0bc8",
  },
  "Pallekanda junc, GJ3V+V5W, Godakawela, Sri Lanka": {
    si: "\u0db4\u0dbd\u0dca\u0dbd\u0dd9\u0d9a\u0db1\u0dca\u0daf \u0da2\u0dd4\u0db1\u0dca\u0d9a\u0dca, GJ3V+V5W, \u0d9c\u0ddc\u0da9\u0d9a\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bb2\u0bcd\u0bb2\u0bc7\u0b95\u0ba8\u0bcd\u0ba4 \u0b9c\u0b99\u0bcd\u0b95\u0bcd, GJ3V+V5W, \u0b95\u0bca\u0b9f\u0b95\u0bb5\u0bc6\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Pallimunai Rd, Mannar": {
    si: "\u0db4\u0dbd\u0dca\u0dbd\u0dd2\u0db8\u0dd4\u0db1\u0dd9\u0dba\u0dd2 \u0db4\u0dcf\u0dbb, \u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8",
    ta: "\u0baa\u0bb3\u0bcd\u0bb3\u0bbf\u0bae\u0bc1\u0ba9\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd",
  },
  "Palugasdamana South, W2PH+579, Polonnaruwa, Sri Lanka": {
    si: "\u0db4\u0dbd\u0dd4\u0d9c\u0dc3\u0dca\u0daf\u0db8\u0db1 \u0daf\u0d9a\u0dd4\u0dab, W2PH+579, \u0db4\u0ddc\u0dc5\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bb2\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bae\u0ba9 \u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1, W2PH+579, \u0baa\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Pamunugama: {
    si: "\u0db4\u0db8\u0dd4\u0dab\u0dd4\u0d9c\u0db8",
    ta: "\u0baa\u0bae\u0bc1\u0ba9\u0bc1\u0b95\u0bae",
  },
  Panadura: {
    si: "\u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb",
    ta: "\u0baa\u0bbe\u0ba3\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  "Panama Rd, Pottuvil": {
    si: "\u0db4\u0dcf\u0db1\u0db8 \u0db4\u0dcf\u0dbb, \u0db4\u0ddc\u0dad\u0dd4\u0dc0\u0dd2\u0dbd\u0dca",
    ta: "\u0baa\u0ba9\u0bbe\u0bae\u0bbe \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bca\u0ba4\u0bcd\u0ba4\u0bc1\u0bb5\u0bbf\u0bb2\u0bcd",
  },
  "Panapitiya ,Kaluthara": {
    si: "\u0db4\u0db1\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0d9a\u0dc5\u0dd4\u0dad\u0dbb",
    ta: "\u0baa\u0ba9\u0bbe\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b95\u0bb3\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  Pandatharippu: {
    si: "\u0db4\u0dab\u0dca\u0da9\u0dad\u0dbb\u0dd2\u0db4\u0dca\u0db4\u0dd4",
    ta: "\u0baa\u0ba3\u0bcd\u0b9f\u0ba4\u0bb0\u0bbf\u0baa\u0bcd\u0baa\u0bc1",
  },
  "Pannala Police Station Rd, Pannala": {
    si: "\u0db4\u0db1\u0dca\u0db1\u0dbd \u0db4\u0ddc\u0dbd\u0dd2\u0dc3\u0dca \u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba \u0db4\u0dcf\u0dbb, \u0db4\u0db1\u0dca\u0db1\u0dbd",
    ta: "\u0baa\u0ba9\u0bcd\u0ba9\u0bbe\u0bb2\u0bbe \u0b95\u0bbe\u0bb5\u0bb2\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1, \u0baa\u0ba9\u0bcd\u0ba9\u0bbe\u0bb2\u0bbe",
  },
  "Pannala Rd, Kuliyapitiya": {
    si: "\u0db4\u0db1\u0dca\u0db1\u0dbd \u0db4\u0dcf\u0dbb, \u0d9a\u0dd4\u0dbd\u0dd2\u0dba\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0baa\u0ba9\u0bcd\u0ba9\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bc1\u0bb3\u0bbf\u0baf\u0bbe\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Pannala, Udawela, Sri Lanka": {
    si: "\u0db4\u0db1\u0dca\u0db1\u0dbd, \u0d8b\u0da9\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0ba9\u0bcd\u0ba9\u0bbe\u0bb2, \u0b89\u0b9f\u0bb5\u0bc6\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Pannala-kuliyapitiya Rd": {
    si: "\u0db4\u0db1\u0dca\u0db1\u0dbd - \u0d9a\u0dd4\u0dbd\u0dd2\u0dba\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb",
    ta: "\u0baa\u0ba9\u0bcd\u0ba9\u0bb2-\u0b95\u0bc1\u0bb2\u0bbf\u0baf\u0bbe\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  Pannipitiya: {
    si: "\u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Pansal Godella,polonnaruwa": {
    si: "\u0db4\u0db1\u0dca\u0dc3\u0dbd\u0dca \u0d9c\u0ddc\u0da9\u0dd0\u0dbd\u0dca\u0dbd, \u0db4\u0ddc\u0dc5\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0",
    ta: "\u0baa\u0ba9\u0bcd\u0b9a\u0bb2\u0bcd \u0b95\u0bca\u0b9f\u0bb2\u0bcd\u0bb2, \u0baa\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5\u0bc8",
  },
  "Parantan - Mullaitivu Hwy, Parantan": {
    si: "\u0db4\u0dbb\u0db1\u0dca\u0dad\u0db1\u0dca - \u0db8\u0dd4\u0dbd\u0dad\u0dd2\u0dc0\u0dca Hwy, \u0db4\u0dbb\u0db1\u0dca\u0dad\u0db1\u0dca",
    ta: "\u0baa\u0bb0\u0ba8\u0bcd\u0ba4\u0ba9\u0bcd - \u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bc8\u0ba4\u0bcd\u0ba4\u0bc0\u0bb5\u0bc1 Hwy, \u0baa\u0bb0\u0ba8\u0bcd\u0ba4\u0ba9\u0bcd",
  },
  "Parantan- Mullaitivu Hwy, Visuvamadu": {
    si: "\u0db4\u0dbb\u0db1\u0dca\u0dad\u0db1\u0dca - \u0db8\u0dd4\u0dbd\u0dad\u0dd2\u0dc0\u0dca \u0dc4\u0dc0\u0dd2, \u0dc0\u0dd2\u0dc1\u0dca\u0dc0\u0db8\u0da9\u0dd4",
    ta: "\u0baa\u0bb0\u0ba8\u0bcd\u0ba4\u0ba9\u0bcd- \u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bc8\u0ba4\u0bcd\u0ba4\u0bc0\u0bb5\u0bc1 Hwy, \u0bb5\u0bbf\u0b9a\u0bc1\u0bb5\u0bae\u0b9f\u0bc1",
  },
  "Parantan-Mullaitivu Hwy, Puthukkudiyiruppu, Sri Lanka": {
    si: "\u0db4\u0dbb\u0db1\u0dca\u0dad\u0db1\u0dca-\u0db8\u0dd4\u0dbd\u0dad\u0dd2\u0dc0\u0dca Hwy, \u0db4\u0dd4\u0dad\u0dd4\u0d9a\u0dd4\u0da9\u0dd2\u0d89\u0dbb\u0dd2\u0db4\u0dca\u0db4\u0dd4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bb0\u0ba8\u0bcd\u0ba4\u0ba9\u0bcd-\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bc8\u0ba4\u0bcd\u0ba4\u0bc0\u0bb5\u0bc1 Hwy, \u0baa\u0bc1\u0ba4\u0bc1\u0b95\u0bcd\u0b95\u0bc1\u0b9f\u0bbf\u0baf\u0bbf\u0bb0\u0bc1\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Passara - Madulsima - Metigahatenna Rd, Madulsima": {
    si: "\u0db4\u0dc3\u0dca\u0dc3\u0dbb - \u0db8\u0da9\u0dd4\u0dbd\u0dca\u0dc3\u0dd2\u0db8 - \u0db8\u0dd0\u0da7\u0dd2\u0d9c\u0dc4\u0dad\u0dd0\u0db1\u0dca\u0db1 \u0db4\u0dcf\u0dbb, \u0db8\u0da9\u0dd4\u0dbd\u0dca\u0dc3\u0dd2\u0db8",
    ta: "\u0baa\u0b9a\u0bb0\u0bbe - \u0bae\u0b9f\u0bc1\u0bb2\u0bcd\u0b9a\u0bbf\u0bae - \u0bae\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bb9\u0ba4\u0bc6\u0ba9\u0bcd\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0b9f\u0bc1\u0bb2\u0bcd\u0b9a\u0bbf\u0bae",
  },
  "Pasyala-giriulla Rd, Mirigama": {
    si: "\u0db4\u0dc3\u0dca\u0dba\u0dcf\u0dbd-\u0d9c\u0dd2\u0dbb\u0dd2\u0d8b\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dd3\u0dbb\u0dd2\u0d9c\u0db8",
    ta: "\u0baa\u0bb8\u0bcd\u0baf\u0bbe\u0bb2-\u0b95\u0bbf\u0bb0\u0bbf\u0b89\u0bb2\u0bcd\u0bb2\u0bbe \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bc0\u0bb0\u0bbf\u0b95\u0bae",
  },
  Payagala: {
    si: "\u0db4\u0dba\u0dcf\u0d9c\u0dbd",
    ta: "\u0baa\u0baf\u0bbe\u0b95\u0bb2\u0bbe",
  },
  "Payagala Station Road, Katukurunda, Sri Lanka": {
    si: "\u0db4\u0dba\u0dcf\u0d9c\u0dbd \u0daf\u0dd4\u0db8\u0dca\u0dbb\u0dd2\u0dba \u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba \u0db4\u0dcf\u0dbb, \u0d9a\u0da7\u0dd4\u0d9a\u0dd4\u0dbb\u0dd4\u0db1\u0dca\u0daf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0baf\u0bbe\u0b95\u0bb2\u0bbe \u0bb8\u0bcd\u0b9f\u0bc7\u0bb7\u0ba9\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1, \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Pbc Hwy, Nuwara Eliya 22200": {
    si: "Pbc Hwy, \u0db1\u0dd4\u0dc0\u0dbb\u0d91\u0dc5\u0dd2\u0dba 22200",
    ta: "Pbc Hwy, \u0ba8\u0bc1\u0bb5\u0bb0\u0bc6\u0bb2\u0bbf\u0baf\u0bbe 22200",
  },
  Pelawatte: {
    si: "\u0db4\u0dd0\u0dbd\u0dc0\u0dad\u0dca\u0dad",
    ta: "\u0baa\u0bc6\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8",
  },
  Peliyagoda: {
    si: "\u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9",
    ta: "\u0baa\u0bc7\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f",
  },
  "Peliyagoda - Negombo Road": {
    si: "\u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9 - \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb",
    ta: "\u0baa\u0bc7\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f - \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  "Peliyagoda - Puttalam Highway, Ja-Ela": {
    si: "\u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9 - \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0da2\u0dcf-\u0d87\u0dbd",
    ta: "\u0baa\u0bc7\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f - \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0b9c\u0bbe-\u0b8e\u0bb2",
  },
  Pelmadulla: {
    si: "\u0db4\u0dd0\u0dbd\u0dca\u0db8\u0da9\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0baa\u0bc6\u0bb2\u0bcd\u0bae\u0ba4\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe",
  },
  "Pelmadulla - Embilipitiya Hwy, Pallebedda": {
    si: "\u0db4\u0dd0\u0dbd\u0dca\u0db8\u0da9\u0dd4\u0dbd\u0dca\u0dbd - \u0d87\u0db9\u0dd2\u0dbd\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba Hwy, \u0db4\u0dbd\u0dca\u0dbd\u0dd9\u0db6\u0dd0\u0daf\u0dca\u0daf",
    ta: "\u0baa\u0bc6\u0bb2\u0bcd\u0bae\u0b9f\u0bc1\u0bb2\u0bcd\u0bb2 - \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0bb2\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf Hwy, \u0baa\u0bb2\u0bcd\u0bb2\u0bc7\u0baa\u0bc6\u0ba4\u0bcd\u0ba4",
  },
  "Pemaduwa Mahawilachchiya, Mahawilachchiya, Sri Lanka": {
    si: "\u0db4\u0dda\u0db8\u0da9\u0dd4\u0dc0 \u0db8\u0dc4\u0dc0\u0dd2\u0dbd\u0da0\u0dca\u0da0\u0dd2\u0dba, \u0db8\u0dc4\u0dc0\u0dd2\u0dbd\u0da0\u0dca\u0da0\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bc7\u0bae\u0ba4\u0bc1\u0bb5 \u0bae\u0bb9\u0bbe\u0bb5\u0bbf\u0bb2\u0b9a\u0bcd\u0b9a\u0bbf\u0baf\u0bbe, \u0bae\u0bb9\u0bbe\u0bb5\u0bbf\u0bb2\u0b9a\u0bcd\u0b9a\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Peradeniya: {
    si: "\u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba",
    ta: "\u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8",
  },
  "Peradeniya - Badulla - Chenkaladi Hwy, Badulla": {
    si: "\u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba - \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd - \u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2 Hwy, \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8 - \u0baa\u0ba4\u0bc1\u0bb3\u0bc8 - \u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf Hwy, \u0baa\u0ba4\u0bc1\u0bb3\u0bc8",
  },
  "Peradeniya - Badulla - Chenkaladi Hwy, Bibile": {
    si: "\u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba - \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd - \u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2 Hwy, Bibile",
    ta: "\u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8 - \u0baa\u0ba4\u0bc1\u0bb3\u0bc8 - \u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf Hwy, \u0baa\u0bbf\u0baa\u0bbf\u0bb2\u0bc8",
  },
  "Peradeniya - Badulla - Chenkaladi Hwy, Gampola": {
    si: "\u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba - \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd - \u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2 Hwy, \u0d9c\u0db8\u0dca\u0db4\u0ddc\u0dbd",
    ta: "\u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8 - \u0baa\u0ba4\u0bc1\u0bb3\u0bc8 - \u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf Hwy, \u0b95\u0bae\u0bcd\u0baa\u0bb3\u0bc8",
  },
  "Peradeniya - Badulla - Chenkaladi Hwy, Keppetipola": {
    si: "\u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba - \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd - \u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2 Hwy, \u0d9a\u0dd0\u0db4\u0dca\u0db4\u0dd9\u0da7\u0dd2\u0db4\u0ddc\u0dbd",
    ta: "\u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8 - \u0baa\u0ba4\u0bc1\u0bb3\u0bc8 - \u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf Hwy, \u0b95\u0bc6\u0baa\u0bcd\u0baa\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baa\u0bca\u0bb2",
  },
  "Peradeniya - Badulla - Chenkaladi Hwy, Lunugala": {
    si: "\u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba - \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd - \u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2 Hwy, \u0dbd\u0dd4\u0dab\u0dd4\u0d9c\u0dbd",
    ta: "\u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8 - \u0baa\u0ba4\u0bc1\u0bb3\u0bc8 - \u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf Hwy, \u0bb2\u0bc1\u0ba3\u0bc1\u0b95\u0bb2",
  },
  "Peradeniya - Badulla - Chenkaladi Hwy, Welimada": {
    si: "\u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba - \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd - \u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2 Hwy, \u0dc0\u0dd0\u0dbd\u0dd2\u0db8\u0da9",
    ta: "\u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8 - \u0baa\u0ba4\u0bc1\u0bb3\u0bc8 - \u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf Hwy, \u0bb5\u0bc6\u0bb2\u0bbf\u0bae\u0b9f\u0bc8",
  },
  "Peradeniya, Gannoruwa Rd": {
    si: "\u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba, \u0d9c\u0db1\u0dca\u0db1\u0ddd\u0dbb\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb",
    ta: "Peradeniya, Gannoruwa Rd",
  },
  "Peradeniya, Sri Lanka": {
    si: "\u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Peradeniya-badulla-chenkaladi Hwy, Padiyatalawa": {
    si: "\u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba-\u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd-\u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2 Hwy, \u0db4\u0daf\u0dd2\u0dba\u0dad\u0dbd\u0dcf\u0dc0",
    ta: "\u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8-\u0baa\u0ba4\u0bc1\u0bb3\u0bc8-\u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf Hwy, \u0baa\u0b9f\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe\u0bb5",
  },
  Periyakallar: {
    si: "\u0db4\u0dd9\u0dbb\u0dd2\u0dba\u0d9a\u0dbd\u0dca\u0dbd\u0dbb\u0dca",
    ta: "\u0baa\u0bc6\u0bb0\u0bbf\u0baf\u0b95\u0bb2\u0bcd\u0bb2\u0bbe\u0bb1\u0bc1",
  },
  "Periyakamam Bus Stop, Periyakamam, Medawachchiya-Talaimannar Highway, Mannar 41000, Sri Lanka":
    {
      si: "\u0db4\u0dd9\u0dbb\u0dd2\u0dba\u0d9a\u0dcf\u0db8\u0db8\u0dca \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0db4\u0dd9\u0dbb\u0dd2\u0dba\u0d9a\u0dcf\u0db8\u0db8\u0dca, \u0db8\u0dd0\u0daf\u0dc0\u0da0\u0dca\u0da0\u0dd2\u0dba-\u0dad\u0dbd\u0dd9\u0dba\u0dd2\u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8 \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8 41000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "\u0baa\u0bc6\u0bb0\u0bbf\u0baf\u0b95\u0bbe\u0bae\u0bae\u0bcd \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0baa\u0bc6\u0bb0\u0bbf\u0baf\u0b95\u0bbe\u0bae\u0bae\u0bcd, \u0bae\u0bc7\u0b9f\u0bb5\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf-\u0ba4\u0bb2\u0bc8\u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd 41000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  Periyaporathvu: {
    si: "\u0db4\u0dd9\u0dbb\u0dd2\u0dba\u0db4\u0ddc\u0dbb\u0dad\u0dca\u0dc0\u0dd4",
    ta: "\u0baa\u0bc6\u0bb0\u0bbf\u0baf\u0baa\u0bcb\u0bb0\u0ba4\u0bcd\u0bb5\u0bc1",
  },
  "Petrogas Lanka Ltd, Avissawella Rd, Maharagama": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0ddc\u0d9c\u0dc3\u0dca \u0dbd\u0d82\u0d9a\u0dcf, \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0dbb\u0d9c\u0db8",
    ta: "\u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0b95\u0bbe\u0bb8\u0bcd \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd, \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bb9\u0bb0\u0b95\u0bae",
  },
  "Petrol Pump, Kandy Rd, Trincomalee": {
    si: "\u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0dbd\u0dca \u0db4\u0ddc\u0db8\u0dca\u0db4\u0dba, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba",
    ta: "\u0baa\u0bc6\u0bb1\u0bcd\u0bb1\u0bcb\u0bb2\u0bcd \u0baa\u0bae\u0bcd\u0baa\u0bcd, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8",
  },
  "Petrol Pump, Trincomalee": {
    si: "\u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0dbd\u0dca \u0db4\u0ddc\u0db8\u0dca\u0db4\u0dba, \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba",
    ta: "\u0baa\u0bc6\u0bb1\u0bcd\u0bb1\u0bcb\u0bb2\u0bcd \u0baa\u0bae\u0bcd\u0baa\u0bcd, \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8",
  },
  "Petrol Shead, Colombo - Batticaloa Hwy, Balangoda, Sri Lanka": {
    si: "\u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0dbd\u0dca \u0dc2\u0dd9\u0da9\u0dca, \u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0db6\u0dbd\u0d82\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bcd \u0bb7\u0bc6\u0b9f\u0bcd, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Petrol Shed Junction, Ragama": {
    si: "\u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0dbd\u0dca \u0dc2\u0dd9\u0da9\u0dca \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0dbb\u0dcf\u0d9c\u0db8",
    ta: "\u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bcd \u0bb7\u0bc6\u0b9f\u0bcd \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0bb0\u0bbe\u0b95\u0bae",
  },
  "Petrol Station, Puthukudiyiruppu": {
    si: "\u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db4\u0dd4\u0daf\u0dd4\u0d9a\u0dd4\u0da9\u0dd2\u0d89\u0dbb\u0dd2\u0db4\u0dca\u0db4\u0dd4",
    ta: "\u0baa\u0bc6\u0bb1\u0bcd\u0bb1\u0bcb\u0bb2\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0baa\u0bc1\u0ba4\u0bc1\u0b95\u0bcd\u0b95\u0bc1\u0b9f\u0bbf\u0baf\u0bbf\u0bb0\u0bc1\u0baa\u0bcd\u0baa\u0bc1",
  },
  "Petrol-92": {
    si: "\u0db4\u0dd9\u0da7\u0dca\u0dbb\u0dbd\u0dca-92",
    ta: "\u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bcd-92",
  },
  "Petrol-92 only": {
    si: "\u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0dbd\u0dca-92 \u0db4\u0db8\u0dab\u0dd2",
    ta: "\u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bcd-92 \u0bae\u0b9f\u0bcd\u0b9f\u0bc1\u0bae\u0bc7",
  },
  "Petrol-95": {
    si: "\u0db4\u0dd9\u0da7\u0dca\u0dbb\u0dbd\u0dca-95",
    ta: "\u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bcd-95",
  },
  "Petrol-95 only": {
    si: "\u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0dbd\u0dca-95 \u0db4\u0db8\u0dab\u0dd2",
    ta: "\u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bcd-95 \u0bae\u0b9f\u0bcd\u0b9f\u0bc1\u0bae\u0bc7",
  },
  "Pettigalawatta Fuel Station, 105 D Old Matara Rd, Galle 80000, Sri Lanka": {
    si: "\u0db4\u0dd9\u0da7\u0dca\u0da7\u0dd2\u0d9c\u0dbd\u0dc0\u0dad\u0dca\u0dad \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, 105 D \u0db4\u0dd0\u0dbb\u0dab\u0dd2 \u0db8\u0dcf\u0dad\u0dbb \u0db4\u0dcf\u0dbb, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd 80000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4 \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, 105 D \u0baa\u0bb4\u0bc8\u0baf \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bbe\u0bb2\u0bbf 80000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Pilessa: {
    si: "\u0db4\u0dd2\u0dbd\u0dd0\u0dc3\u0dca\u0dc3",
    ta: "\u0baa\u0bbf\u0bb2\u0bc7\u0b9a\u0bbe",
  },
  Pilimathalawa: {
    si: "\u0db4\u0dd2\u0dc5\u0dd2\u0db8\u0dad\u0dbd\u0dcf\u0dc0",
    ta: "\u0baa\u0bbf\u0bb2\u0bbf\u0bae\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe\u0bb5",
  },
  Pilimathalawwa: {
    si: "\u0db4\u0dd2\u0dc5\u0dd2\u0db8\u0dad\u0dbd\u0dc0\u0dca\u0dc0",
    ta: "\u0baa\u0bbf\u0bb2\u0bbf\u0bae\u0ba4\u0bcd\u0ba4\u0bb2\u0bb5\u0bcd\u0bb5",
  },
  Piliyandala: {
    si: "\u0db4\u0dd2\u0dc5\u0dd2\u0dba\u0db1\u0dca\u0daf\u0dbd",
    ta: "\u0baa\u0bbf\u0bb2\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bb2\u0bc8",
  },
  "Pinnaduwa-akmeemana": {
    si: "\u0db4\u0dd2\u0db1\u0dca\u0db1\u0daf\u0dd6\u0dc0-\u0d85\u0d9a\u0dca\u0db8\u0dd3\u0db8\u0db1",
    ta: "\u0baa\u0bbf\u0ba9\u0bcd\u0ba9\u0ba4\u0bc1\u0bb5-\u0b85\u0b95\u0bcd\u0bae\u0bc0\u0bae\u0ba9",
  },
  "Pinwatta Gas Station, A2, Panadura": {
    si: "\u0db4\u0dd2\u0db1\u0dca\u0dc0\u0dad\u0dca\u0dad \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, A2, \u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb",
    ta: "\u0baa\u0bbf\u0ba9\u0bcd\u0bb5\u0ba4\u0bcd\u0ba4 \u0b8e\u0bb0\u0bbf\u0bb5\u0bbe\u0baf\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, A2, \u0baa\u0bbe\u0ba3\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  "Pitabadda Rd, Thawalama": {
    si: "\u0db4\u0dd2\u0da7\u0db6\u0daf\u0dca\u0daf \u0db4\u0dcf\u0dbb, \u0dad\u0dc0\u0dbd\u0db8",
    ta: "\u0baa\u0bbf\u0b9f\u0baa\u0b9f\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0ba4\u0bb5\u0bb2\u0bae\u0bbe",
  },
  "Pitabaddara School, Pitabeddara, Sri Lanka": {
    si: "\u0db4\u0dd2\u0da7\u0db6\u0daf\u0dca\u0daf\u0dbb \u0db4\u0dcf\u0dc3\u0dbd, \u0db4\u0dd2\u0da7\u0db6\u0dd0\u0daf\u0dca\u0daf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Pitabaddara \u0baa\u0bb3\u0bcd\u0bb3\u0bbf, Pitabeddara, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Pitipana - South": {
    si: "\u0db4\u0dd2\u0da7\u0dd2\u0db4\u0db1 - \u0daf\u0d9a\u0dd4\u0dab",
    ta: "\u0baa\u0bbf\u0b9f\u0bbf\u0baa\u0ba9\u0bbe - \u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1",
  },
  "Pohonnaruwa - Meerigama": {
    si: "\u0db4\u0ddc\u0dc4\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0 - \u0db8\u0dd3\u0dbb\u0dd2\u0d9c\u0db8",
    ta: "\u0baa\u0bca\u0bb9\u0bca\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5 - \u0bae\u0bc0\u0bb0\u0bbf\u0b95\u0bae",
  },
  "Point Pedro": {
    si: "\u0db4\u0dda\u0daf\u0dd4\u0dbb\u0dd4\u0dad\u0dd4\u0da9\u0dd4\u0dc0",
    ta: "\u0baa\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  Pokunuwita: {
    si: "Pokunuwita",
    ta: "Pokunuwita",
  },
  Polegoda: {
    si: "\u0db4\u0ddc\u0dbd\u0dda\u0d9c\u0ddc\u0da9",
    ta: "\u0baa\u0bca\u0bb2\u0bc7\u0b95\u0bca\u0b9f",
  },
  Polgahawela: {
    si: "\u0db4\u0ddc\u0dbd\u0dca\u0d9c\u0dc4\u0dc0\u0dd9\u0dbd",
    ta: "\u0baa\u0bca\u0bb2\u0bcd\u0b95\u0bb9\u0bb5\u0bc6\u0bb2",
  },
  Polgasowita: {
    si: "\u0db4\u0ddc\u0dbd\u0dca\u0d9c\u0dc3\u0dca\u0d95\u0dc0\u0dd2\u0da7",
    ta: "\u0baa\u0bca\u0bb2\u0bcd\u0b95\u0b9a\u0bcb\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f",
  },
  "Police Station, Middeniya, Sri Lanka": {
    si: "\u0db4\u0ddc\u0dbd\u0dd2\u0dc3\u0dca \u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba, \u0db8\u0dd2\u0daf\u0dca\u0daf\u0dd9\u0dab\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bca\u0bb2\u0bbf\u0bb8\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0bae\u0bbf\u0ba4\u0bcd\u0ba4\u0bc7\u0ba9\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Polonnaruwa: {
    si: "\u0db4\u0ddc\u0dc5\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0",
    ta: "\u0baa\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5\u0bc8",
  },
  "Polonnaruwa - Kaduruwela": {
    si: "\u0db4\u0ddc\u0dc5\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0 - \u0d9a\u0daf\u0dd4\u0dbb\u0dd4\u0dc0\u0dd9\u0dbd",
    ta: "\u0baa\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5\u0bc8 - \u0b95\u0ba4\u0bc1\u0bb0\u0bc1\u0bb5\u0bc6\u0bb2",
  },
  "Polonnaruwa Junction Bus Stop, Maradankadawala-Habarana-Thirukkondaiadimadu Hwy, Polonnaruwa, Sri Lanka":
    {
      si: "\u0db4\u0ddc\u0dc5\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0db8\u0dbb\u0daf\u0db1\u0dca\u0d9a\u0da9\u0dc0\u0dbd-\u0dc4\u0db6\u0dbb\u0dab-\u0dad\u0dd2\u0dbb\u0dd4\u0d9a\u0dca\u0d9a\u0ddc\u0db1\u0dca\u0daf\u0d85\u0da9\u0dd2\u0db8\u0da9\u0dd4 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0db4\u0ddc\u0dc5\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "\u0baa\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5\u0bc8 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0bae\u0bb0\u0ba4\u0ba9\u0bcd\u0b95\u0b9f\u0bb5\u0bb2-\u0bb9\u0baa\u0bb0\u0ba3\u0bc8-\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcd\u0b95\u0bca\u0ba3\u0bcd\u0b9f\u0bc8\u0baf\u0bbe\u0b9f\u0bbf\u0bae\u0b9f\u0bc1 \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "Poruthota Road, Negombo, Sri Lanka": {
    si: "\u0db4\u0ddd\u0dbb\u0dd4\u0dad\u0ddc\u0da7 \u0db4\u0dcf\u0dbb, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bca\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f \u0b9a\u0bbe\u0bb2\u0bc8, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Porutota, Kochchikade": {
    si: "Porutota, Kochchikade",
    ta: "Porutota, Kochchikade",
  },
  Poruwadanda: {
    si: "Poruwadanda",
    ta: "\u0baa\u0bca\u0bb0\u0bc1\u0bb5\u0b9f\u0ba3\u0bcd\u0b9f\u0bbe",
  },
  Pothanegama: {
    si: "\u0db4\u0ddc\u0dad\u0dcf\u0db1\u0dda\u0d9c\u0db8",
    ta: "\u0baa\u0bca\u0ba4\u0ba9\u0bc7\u0b95\u0bae",
  },
  Pottuvil: {
    si: "\u0db4\u0ddc\u0dad\u0dd4\u0dc0\u0dd2\u0dbd\u0dca",
    ta: "\u0baa\u0bca\u0ba4\u0bcd\u0ba4\u0bc1\u0bb5\u0bbf\u0bb2\u0bcd",
  },
  "Pradeshiya Sabha Pinnaduwa, Sri Lanka": {
    si: "\u0db4\u0dd2\u0db1\u0dca\u0db1\u0daf\u0dd6\u0dc0 \u0db4\u0dca\u200d\u0dbb\u0dcf\u0daf\u0dda\u0dc1\u0dd3\u0dba \u0dc3\u0db7\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bbf\u0bb0\u0ba4\u0bc7\u0b9a \u0b9a\u0baa\u0bc8 \u0baa\u0bbf\u0ba9\u0bcd\u0ba9\u0ba4\u0bc1\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Prassana Filling Station, Baduragoda": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0dc3\u0db1\u0dca\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db6\u0daf\u0dd4\u0dbb\u0dcf\u0d9c\u0ddc\u0da9",
    ta: "\u0baa\u0bbf\u0bb0\u0bb8\u0bcd\u0b9a\u0ba9 \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0baa\u0ba4\u0bc1\u0bb0\u0bbe\u0b95\u0bca\u0b9f",
  },
  Pugoda: {
    si: "Pugoda",
    ta: "\u0baa\u0bc2\u0b95\u0bcb\u0b9f\u0bbe",
  },
  Pujapitiya: {
    si: "\u0db4\u0dd4\u0da2\u0dcf\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0baa\u0bc1\u0b9c\u0bbe\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Puliyankulam Filling Station, Puliyankulam, Sri Lanka": {
    si: "\u0db4\u0dd4\u0dbd\u0dd2\u0dba\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db4\u0dd4\u0dbd\u0dd2\u0dba\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bc1\u0bb3\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0baa\u0bc1\u0bb3\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Puliyankulama Temple, Sri Lanka": {
    si: "\u0db4\u0dd4\u0dbd\u0dd2\u0dba\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8 \u0dc0\u0dd2\u0dc4\u0dcf\u0dbb\u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bc1\u0bb3\u0bbf\u0baf\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd \u0b95\u0bcb\u0bb5\u0bbf\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Pulmoddai: {
    si: "\u0db4\u0dd4\u0dbd\u0dca\u0db8\u0ddc\u0da9\u0dd9\u0dba\u0dd2",
    ta: "\u0baa\u0bc1\u0bb2\u0bcd\u0bae\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8",
  },
  Puloli: {
    si: "\u0db4\u0dd4\u0dbd\u0ddd\u0dbd\u0dd2",
    ta: "\u0baa\u0bc1\u0bb2\u0bcb\u0bb2\u0bbf",
  },
  "Pungudutivu West, Kurichchikadu": {
    si: "\u0db4\u0dd4\u0d82\u0d9c\u0dd4\u0da9\u0dd4\u0dad\u0dd2\u0dc0\u0dca \u0db6\u0da7\u0dc4\u0dd2\u0dbb, \u0d9a\u0dd4\u0dbb\u0dd2\u0da0\u0dca\u0da0\u0dd2\u0d9a\u0dcf\u0da9\u0dd4",
    ta: "\u0baa\u0bc1\u0b99\u0bcd\u0b95\u0bc1\u0b9f\u0bc1\u0ba4\u0bc0\u0bb5\u0bc1 \u0bae\u0bc7\u0bb1\u0bcd\u0b95\u0bc1, \u0b95\u0bc1\u0bb1\u0bbf\u0b9a\u0bcd\u0b9a\u0bbf\u0b95\u0bcd\u0b95\u0bbe\u0b9f\u0bc1",
  },
  Punkudutivu: {
    si: "\u0db4\u0dd4\u0d82\u0d9a\u0dd4\u0da9\u0dd4\u0dad\u0dd2\u0dc0\u0dca",
    ta: "\u0baa\u0bc1\u0b99\u0bcd\u0b95\u0bc1\u0b9f\u0bc1\u0ba4\u0bc0\u0bb5\u0bc1",
  },
  "Punnalaikadduvan North Junction Bus Stop, AB18, Jaffna, Sri Lanka": {
    si: "\u0db4\u0dd4\u0db1\u0dca\u0db1\u0dbd\u0dba\u0dd2\u0d9a\u0da9\u0dca\u0da9\u0dd4\u0dc0\u0dcf\u0db1\u0dca \u0d8b\u0dad\u0dd4\u0dbb \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, AB18, \u0dba\u0dcf\u0db4\u0db1\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bc1\u0ba9\u0bcd\u0ba9\u0bbe\u0bb2\u0bc8\u0b95\u0bcd\u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0ba9\u0bcd \u0bb5\u0b9f\u0b95\u0bcd\u0b95\u0bc1 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0baa\u0bcd\u0baa\u0bc1 \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0b8f\u0baa\u0bbf18, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Punnalaikaduvan: {
    si: "\u0db4\u0dd4\u0db1\u0dca\u0db1\u0dbd\u0dba\u0dd2\u0d9a\u0da9\u0dd4\u0dc0\u0db1\u0dca",
    ta: "\u0baa\u0bc1\u0ba9\u0bcd\u0ba9\u0bbe\u0bb2\u0bc8\u0b95\u0bcd\u0b95\u0b9f\u0bc1\u0bb5\u0bbe\u0ba9\u0bcd",
  },
  Puranawella: {
    si: "\u0db4\u0dd4\u0dbb\u0dcf\u0dab\u0dc0\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0baa\u0bc2\u0bb0\u0ba3\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2",
  },
  Pussella: {
    si: "\u0db4\u0dd4\u0dc3\u0dca\u0dc3\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0baa\u0bc1\u0bb8\u0bcd\u0bb8\u0bb2\u0bcd\u0bb2\u0bbe",
  },
  Puttalam: {
    si: "\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd",
  },
  "Puttalam - Anuradhapura - Trincomalee Hwy": {
    si: "\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 - \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb - \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8",
  },
  "Puttalam - Anuradhapura - Trincomalee Hwy, Nochchiyagama, Sri Lanka": {
    si: "\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 - \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb - \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0db1\u0ddc\u0da0\u0dca\u0da0\u0dd2\u0dba\u0dcf\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 Hwy, Nochchiyagama, Sri Lanka",
  },
  "Puttalam - Colombo Rd": {
    si: "\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  "Puttalam - Colombo Rd, Arachchikattuwa": {
    si: "\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2\u0d9a\u0da7\u0dca\u0da7\u0dd4\u0dc0",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b86\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf\u0b95\u0bcd\u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5",
  },
  "Puttalam - Colombo Rd, Dandugama": {
    si: "\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0daf\u0dac\u0dd4\u0d9c\u0db8",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0ba3\u0bcd\u0b9f\u0bc1\u0b95\u0bae",
  },
  "Puttalam - Colombo Rd, Mundelama": {
    si: "\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0db8\u0dd4\u0db1\u0dca\u0daf\u0dbd\u0db8",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bc1\u0ba8\u0bcd\u0ba4\u0bc6\u0bb2\u0bae",
  },
  "Puttalam - Colombo Rd, Puttalam": {
    si: "\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd",
  },
  "Puttalam - Colombo Rd, Ragama": {
    si: "\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0dbb\u0dcf\u0d9c\u0db8",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb0\u0bbe\u0b95\u0bae",
  },
  "Puttalam - Colombo Rd., Madurankuliya": {
    si: "\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0db8\u0daf\u0dd4\u0dbb\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0dd2\u0dba",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0ba4\u0bc1\u0bb0\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bbf\u0baf",
  },
  "Puttalam Road, Katuneriya": {
    si: "\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 \u0db4\u0dcf\u0dbb, \u0d9a\u0da7\u0dd4\u0db1\u0dda\u0dbb\u0dd2\u0dba",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0ba9\u0bc7\u0bb0\u0bbf\u0baf",
  },
  "Puttalam Road, Nainamadama": {
    si: "\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 \u0db4\u0dcf\u0dbb, \u0db1\u0dba\u0dd2\u0db1\u0db8\u0da9\u0db8",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc8\u0ba9\u0bbe\u0bae\u0b9f\u0bae",
  },
  "Puttalam Road, Waikkal": {
    si: "\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 \u0db4\u0dcf\u0dbb, \u0dc0\u0dba\u0dd2\u0d9a\u0dca\u0d9a\u0dcf\u0dbd\u0dca",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bbe\u0baf\u0bcd\u0b95\u0bcd\u0b95\u0bbe\u0bb2\u0bcd",
  },
  "Puttalam-anuradhapura-trincomalee Main Road, Kahatagasdigiliya": {
    si: "\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8-\u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb-\u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0d9a\u0dc4\u0da7\u0d9c\u0dc3\u0dca\u0daf\u0dd2\u0d9c\u0dd2\u0dbd\u0dd2\u0dba",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd - \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb9\u0b9f\u0bcd\u0b9f\u0b95\u0bb8\u0bcd\u0ba4\u0bbf\u0b95\u0bbf\u0bb2\u0bbf\u0baf",
  },
  "Puttalam-colombo Rd, Negombo": {
    si: "\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8-\u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0db8\u0dd3\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd-\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bc0\u0bb0\u0bcd\u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "Puwakgahawela Belihuloya, Balangoda": {
    si: "\u0db4\u0dd4\u0dc0\u0d9a\u0dca\u0d9c\u0dc4\u0dc0\u0dd9\u0dbd \u0db6\u0dd9\u0dbd\u0dd2\u0dc4\u0dd4\u0dbd\u0dca\u0d94\u0dba, \u0db6\u0dbd\u0d82\u0d9c\u0ddc\u0da9",
    ta: "\u0baa\u0bc1\u0bb5\u0b95\u0bcd\u0b95\u0bb9\u0bb5\u0bc6\u0bb2 \u0baa\u0bc6\u0bb2\u0bbf\u0bb9\u0bc1\u0bb2\u0bcb\u0baf\u0bbe, \u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bc8",
  },
  "Q & R ENTERPRISES": {
    si: "Q & R \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b95\u0bc7 & \u0b86\u0bb0\u0bcd \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "Q27H+8P4, Earlalai, Sri Lanka": {
    si: "Q27H+8P4, \u0d85\u0dbb\u0dca\u0dbd\u0dcf\u0dbd\u0dba\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q27H+8P4, \u0b8f\u0bb0\u0bcd\u0bb2\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q2C3+2WP, Polgasowita, Sri Lanka": {
    si: "Q2C3+2WP, \u0db4\u0ddc\u0dbd\u0dca\u0d9c\u0dc3\u0dca\u0d95\u0dc0\u0dd2\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q2C3+2WP, \u0baa\u0bca\u0bb2\u0bcd\u0b95\u0b9a\u0bcb\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q2FH+WX4, Thurkkapuram, Sri Lanka": {
    si: "Q2FH+WX4, \u0dad\u0dd4\u0dbb\u0dca\u0d9a\u0db4\u0dd4\u0dbb\u0db8\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q2FH+WX4, \u0ba4\u0bc1\u0bb0\u0bcd\u0b95\u0bcd\u0b95\u0baa\u0bc1\u0bb0\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q2H7+C9 Tellippalai South West, Sri Lanka": {
    si: "Q2H7+C9 \u0dad\u0dd9\u0dbd\u0dd2\u0db4\u0dca\u0db4\u0dbd\u0dd9\u0dba\u0dd2 \u0db1\u0dd2\u0dbb\u0dd2\u0dad\u0daf\u0dd2\u0d9c, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q2H7+C9 \u0ba4\u0bc6\u0bb2\u0bcd\u0bb2\u0bbf\u0baa\u0bcd\u0baa\u0bb3\u0bc8 \u0ba4\u0bc6\u0ba9\u0bcd\u0bae\u0bc7\u0bb1\u0bcd\u0b95\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q2MM+P67, AB16, Kankesanturai, Sri Lanka": {
    si: "Q2MM+P67, AB16, \u0d9a\u0db1\u0dca\u0d9a\u0dc3\u0db1\u0dca\u0dad\u0dd4\u0dbb\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q2MM+P67, AB16, \u0b95\u0bbe\u0b99\u0bcd\u0b95\u0bc7\u0b9a\u0ba9\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q2QM+3HH, Tellippalai, Sri Lanka": {
    si: "Q2QM+3HH, \u0dad\u0dd9\u0dbd\u0dd2\u0db4\u0dca\u0db4\u0dbd\u0dd9\u0dba\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q2QM+3HH, \u0ba4\u0bc6\u0bb2\u0bcd\u0bb2\u0bbf\u0baa\u0bcd\u0baa\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q3W2+8VV, Talagala, Sri Lanka": {
    si: "Q3W2+8VV, \u0dad\u0dbd\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q3W2+8VV, \u0ba4\u0bb2\u0b95\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q3XP+C5 Nikaweratiya, Sri Lanka": {
    si: "Q3XP+C5 \u0db1\u0dd2\u0d9a\u0dc0\u0dd0\u0dbb\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q3XP+C5 \u0ba8\u0bbf\u0b95\u0bcd\u0b95\u0bb5\u0bc6\u0bb0\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q458+77 Siruppiddy, Sri Lanka": {
    si: "Q458+77 \u0dc3\u0dd2\u0dbb\u0dd4\u0db4\u0dca\u0db4\u0dd2\u0da9\u0dca\u0da9\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q458+77 \u0b9a\u0bbf\u0bb1\u0bc1\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q4H7+3R3, Vallai-Tellippalai-Araly Rd, Jaffna 40000, Sri Lanka": {
    si: "Q4H7+3R3, Vallai-Tellippalai-Araly Rd, \u0dba\u0dcf\u0db4\u0db1\u0dba 40000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q4H7+3R3, \u0bb5\u0bb2\u0bcd\u0bb2\u0bc8-\u0ba4\u0bc6\u0bb2\u0bcd\u0bb2\u0bbf\u0baa\u0bcd\u0baa\u0bb3\u0bc8-\u0b85\u0bb0\u0bbe\u0bb2\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd 40000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q4PV+FPH, Meepe - Ingiriya Rd, Handapangoda, Sri Lanka": {
    si: "Q4PV+FPH, \u0db8\u0dd3\u0db4\u0dda - \u0d89\u0d82\u0d9c\u0dd2\u0dbb\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0dc4\u0db3\u0db4\u0dcf\u0db1\u0dca\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q4PV+FPH, \u0bae\u0bc0\u0baa\u0bc7 - \u0b87\u0b99\u0bcd\u0b95\u0bbf\u0bb0\u0bbf\u0baf\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb9\u0ba3\u0bcd\u0b9f\u0baa\u0bbe\u0b99\u0bcd\u0b95\u0bcb\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q594+8Q Paraiyanalankulam, Sri Lanka": {
    si: "Q594+8Q \u0db4\u0dbb\u0dba\u0db1\u0dcf\u0dbd\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q594+8Q \u0baa\u0bb1\u0bc8\u0baf\u0ba9\u0bbe\u0bb2\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q5JM+5RM, Aralaganwila, Sri Lanka": {
    si: "Q5JM+5RM, \u0d85\u0dbb\u0dbd\u0d9c\u0d82\u0dc0\u0dd2\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q5JM+5RM, \u0b85\u0bb0\u0bb2\u0b95\u0b99\u0bcd\u0bb5\u0bbf\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q5W9+MF9, Jaffna-Point Pedro Rd, Nelliady, Sri Lanka": {
    si: "Q5W9+MF9, \u0dba\u0dcf\u0db4\u0db1\u0dba-\u0db4\u0dda\u0daf\u0dd4\u0dbb\u0dd4\u0dad\u0dd4\u0da9\u0dd4\u0dc0 \u0db4\u0dcf\u0dbb, \u0db1\u0dd9\u0dbd\u0dca\u0dbd\u0dd2\u0dba\u0da9\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q5W9+MF9, \u0baf\u0bbe\u0bb4\u0bcd\u0baa\u0bcd\u0baa\u0bbe\u0ba3\u0bae\u0bcd- \u0baa\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0ba8\u0bc6\u0bb2\u0bcd\u0bb2\u0bbf\u0baf\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q629+X6F,   -      , Buttala, Sri Lanka": {
    si: "Q629+X6F, - , \u0db6\u0dd4\u0dad\u0dca\u0dad\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q629+X6F, - , \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q64P+MJW, Buttala, Sri Lanka": {
    si: "Q64P+MJW, \u0db6\u0dd4\u0dad\u0dca\u0dad\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q64P+MJW, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q64Q+W2C, Buttala, Sri Lanka": {
    si: "Q64Q+W2C, \u0db6\u0dd4\u0dad\u0dca\u0dad\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q64Q+W2C, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q66X+89W, Main St, Buttala, Sri Lanka": {
    si: "Q66X+89W, \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc1\u0dcf\u0db1\u0dca\u0dad, \u0db6\u0dd4\u0dad\u0dca\u0dad\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q66X+89W, \u0bae\u0bc6\u0baf\u0bbf\u0ba9\u0bcd \u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q762+M3M, Main St, Buttala, Sri Lanka": {
    si: "Q762+M3M, \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0dc1\u0dcf\u0db1\u0dca\u0dad, \u0db6\u0dd4\u0dad\u0dca\u0dad\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q762+M3M, \u0bae\u0bc6\u0baf\u0bbf\u0ba9\u0bcd \u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q9H7+P8G, Kuruwita, Sri Lanka": {
    si: "Q9H7+P8G, \u0d9a\u0dd4\u0dbb\u0dd4\u0dc0\u0dd2\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q9H7+P8G, \u0b95\u0bc1\u0bb0\u0bc1\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Q9MX+45C, Ibbagamuwa-Kumbukgete-Madagalla Rd, Alutwegedara, Sri Lanka": {
    si: "Q9MX+45C, \u0d89\u0db6\u0dca\u0db6\u0dcf\u0d9c\u0db8\u0dd4\u0dc0-\u0d9a\u0dd4\u0db9\u0dd4\u0d9a\u0dca\u0d9c\u0dd0\u0da7\u0dda-\u0db8\u0da9\u0d9c\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d85\u0dbd\u0dd4\u0dad\u0dca\u0dc0\u0dda\u0d9c\u0dd9\u0daf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Q9MX+45C, \u0b87\u0baa\u0bcd\u0baa\u0bbe\u0b95\u0bae\u0bc1\u0bb5-\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0b95\u0bcd\u0b95\u0bc7\u0ba4\u0bcd\u0ba4\u0bc7-\u0bae\u0ba4\u0b95\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0bb2\u0bc1\u0ba4\u0bcd\u0bb5\u0bc7\u0b95\u0bc6\u0ba4\u0bb0, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QF3V+645, Vavuniya, Sri Lanka": {
    si: "QF3V+645, \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QF3V+645, \u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QF64+Q7R, Vavuniya-Parayanalankulam Hwy, Vavuniya, Sri Lanka": {
    si: "QF64+Q7R, \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0-\u0db4\u0dbb\u0dba\u0db1\u0dbd\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca Hwy, \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QF64+Q7R, \u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe-\u0baa\u0bb0\u0bbe\u0baf\u0ba9\u0bbe\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd Hwy, \u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QG25+4CQ, Vavuniya, Sri Lanka": {
    si: "QG25+4CQ, \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QG25+4CQ, \u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QG42+76J, Tharmalingam Rd, Vavuniya, Sri Lanka": {
    si: "QG42+76J, \u0dad\u0dbb\u0dca\u0db8\u0dbd\u0dd2\u0d82\u0d9c\u0db8\u0dca \u0db4\u0dcf\u0dbb, \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QG42+76J, \u0ba4\u0bb0\u0bcd\u0bae\u0bb2\u0bbf\u0b99\u0bcd\u0b95\u0bae\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QGGQ+88 Bambaragaswewa, Sri Lanka": {
    si: "QGGQ+88 \u0db6\u0db9\u0dbb\u0d9c\u0dc3\u0dca\u0dc0\u0dd0\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QGGQ+88 \u0baa\u0bae\u0bcd\u0baa\u0bb0\u0b95\u0bb8\u0bcd\u0bb5\u0bc6\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QH28+JWP, Kayankudah, Sri Lanka": {
    si: "QH28+JWP, \u0d9a\u0dcf\u0dba\u0db1\u0dca\u0d9a\u0dd4\u0da9\u0dcf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QH28+JWP, \u0b95\u0bbe\u0baf\u0ba9\u0bcd\u0b95\u0bc1\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QH38+854, Galewela, Sri Lanka": {
    si: "QH38+854, \u0d9c\u0dbd\u0dda\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QH38+854, \u0b95\u0bb2\u0bc7\u0bb5\u0bc6\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QHMR+PWJ, Trincomalee Hwy, Chenkaladi, Sri Lanka": {
    si: "QHMR+PWJ, Trincomalee Hwy, Chenkaladi, Sri Lanka",
    ta: "QHMR+PWJ, \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 Hwy, \u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QHMR+RQP, Trincomalee Hwy, Chenkaladi, Sri Lanka": {
    si: "QHMR+RQP, Trincomalee Hwy, Chenkaladi, Sri Lanka",
    ta: "QHMR+RQP, \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 Hwy, \u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QJC6+CGH, Eravur 30300, Sri Lanka": {
    si: "QJC6+CGH, \u0d91\u0dbb\u0dcf\u0dc0\u0dd4\u0dbb\u0dca 30300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QJC6+CGH, \u0b8f\u0bb1\u0bbe\u0bb5\u0bc2\u0bb0\u0bcd 30300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QJG3+GR9, Trincomalee Hwy, Eravur, Sri Lanka": {
    si: "QJG3+GR9, \u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba Hwy, \u0d91\u0dbb\u0dcf\u0dc0\u0dd4\u0dbb\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QJG3+GR9, \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 Hwy, \u0b8f\u0bb1\u0bbe\u0bb5\u0bc2\u0bb0\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QM3P+F75, Batticaloa, Sri Lanka": {
    si: "QM3P+F75, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QM3P+F75, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QRH8+55X, Bakamuna, Sri Lanka": {
    si: "QRH8+55X, \u0db6\u0d9a\u0db8\u0dd6\u0dab, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QRH8+55X, \u0baa\u0b95\u0bae\u0bc1\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QRQ5+FM Bakamuna, Sri Lanka": {
    si: "QRQ5+FM \u0db6\u0d9a\u0db8\u0dd6\u0dab, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QRQ5+FM \u0baa\u0b95\u0bae\u0bc1\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QV6Q+X7P, Beragala, Sri Lanka": {
    si: "QV6Q+X7P, \u0db6\u0dd9\u0dbb\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QV6Q+X7P, \u0baa\u0bc6\u0bb0\u0b95\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QVCP+G7M, B235, Moratuwa 10400, Sri Lanka": {
    si: "QVCP+G7M, B235, \u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0 10400, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QVCP+G7M, B235, \u0bae\u0bca\u0bb0\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe 10400, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QVCQ+PR4, Panadura 10400, Sri Lanka": {
    si: "QVCQ+PR4, \u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb 10400, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QVCQ+PR4, \u0baa\u0bbe\u0ba3\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8 10400, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QVGJ+RRC, Galle Rd, Moratuwa 10400, Sri Lanka": {
    si: "QVGJ+RRC, \u0d9c\u0dcf\u0dbd\u0dd4 \u0db4\u0dcf\u0dbb, \u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0 10400, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QVGJ+RRC, Galle Rd, Moratuwa 10400, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QVPM+GQ8, Moratuwa 10400, Sri Lanka": {
    si: "QVPM+GQ8, \u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0 10400, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QVPM+GQ8, \u0bae\u0bca\u0bb0\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe 10400, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QW9J+774, Piliyandala, Sri Lanka": {
    si: "QW9J+774, \u0db4\u0dd2\u0dc5\u0dd2\u0dba\u0db1\u0dca\u0daf\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QW9J+774, \u0baa\u0bbf\u0bb2\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QWJX+6CJ, Andigama, Sri Lanka": {
    si: "QWJX+6CJ, \u0d86\u0dab\u0dca\u0da9\u0dd2\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QWJX+6CJ, \u0b86\u0ba3\u0bcd\u0b9f\u0bbf\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QWWR+383, Piliyandala, Sri Lanka": {
    si: "QWWR+383, \u0db4\u0dd2\u0dc5\u0dd2\u0dba\u0db1\u0dca\u0daf\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QWWR+383, \u0baa\u0bbf\u0bb2\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QX22+J33, Silavathurai, Sri Lanka": {
    si: "QX22+J33, \u0dc3\u0dd2\u0dbd\u0dcf\u0dc0\u0dad\u0dd4\u0dbb\u0dd9\u0dba\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QX22+J33, \u0b9a\u0bbf\u0bb2\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QX37+2R Kalaiyadi, Sri Lanka": {
    si: "QX37+2R \u0d9a\u0dbd\u0dba\u0dd2\u0dba\u0dcf\u0da9\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QX37+2R \u0b95\u0bb2\u0bc8\u0baf\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QX6H+95 Mudalakkuliya, Sri Lanka": {
    si: "QX6H+95 \u0db8\u0dd4\u0daf\u0dbd\u0d9a\u0dca\u0d9a\u0dd4\u0dbd\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QX6H+95 \u0bae\u0bc1\u0ba4\u0bb2\u0b95\u0bcd\u0b95\u0bc1\u0bb2\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QXF9+9QQ, Mathagal Rd, Pandatharippu, Sri Lanka": {
    si: "QXF9+9QQ, \u0db8\u0dad\u0d9c\u0dbd\u0dca \u0db4\u0dcf\u0dbb, \u0db4\u0dab\u0dca\u0da9\u0dad\u0dbb\u0dd2\u0db4\u0dca\u0db4\u0dd4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QXF9+9QQ, \u0bae\u0bbe\u0ba4\u0b95\u0bb2\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0ba3\u0bcd\u0b9f\u0ba4\u0bb0\u0bbf\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QXF9+CCG, Sillalai Main Road, Pandatharippu, Sri Lanka": {
    si: "QXF9+CCG, \u0dc3\u0dd2\u0dbd\u0dca\u0dbd\u0dcf\u0dbd\u0dba\u0dd2 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0db4\u0dab\u0dca\u0da9\u0dad\u0dbb\u0dd2\u0db4\u0dca\u0db4\u0dd4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QXF9+CCG, \u0b9a\u0bbf\u0bb2\u0bcd\u0bb2\u0bbe\u0bb2\u0bc8 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0ba3\u0bcd\u0b9f\u0ba4\u0bb0\u0bbf\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "QXP7+XWV, Polgasowita Rd, Polgasowita, Sri Lanka": {
    si: "QXP7+XWV, \u0db4\u0ddc\u0dbd\u0dca\u0d9c\u0dc3\u0dca\u0d95\u0dc0\u0dd2\u0da7 \u0db4\u0dcf\u0dbb, \u0db4\u0ddc\u0dbd\u0dca\u0d9c\u0dc3\u0dca\u0d95\u0dc0\u0dd2\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QXP7+XWV, Polgasowita Rd, Polgasowita, Sri Lanka",
  },
  "QXR7+W8 Pandatharippu, Sri Lanka": {
    si: "QXR7+W8 \u0db4\u0dab\u0dca\u0da9\u0dad\u0dbb\u0dd2\u0db4\u0dca\u0db4\u0dd4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "QXR7+W8 \u0baa\u0ba3\u0bcd\u0b9f\u0ba4\u0bb0\u0bbf\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "R A PREMADASA": {
    si: "\u0d86\u0dbb\u0dca \u0d92 \u0db4\u0dca\u200d\u0dbb\u0dda\u0db8\u0daf\u0dcf\u0dc3",
    ta: "\u0b86\u0bb0\u0bcd \u0b8f \u0baa\u0bbf\u0bb0\u0bc7\u0bae\u0ba4\u0bbe\u0b9a\u0bbe",
  },
  "R A T A .MEDAGAMA": {
    si: "R A T A .\u0db8\u0dd0\u0daf\u0d9c\u0db8",
    ta: "\u0b86\u0bb0\u0bcd \u0b8f \u0b9f\u0bbf \u0b8f .\u0bae\u0bc6\u0b9f\u0b95\u0bae",
  },
  "R A U G JAYATISSA": {
    si: "\u0d86\u0dbb\u0dca \u0d92 \u0dba\u0dd6 \u0da2\u0dd3 \u0da2\u0dba\u0dad\u0dd2\u0dc3\u0dca\u0dc3",
    ta: "\u0b86\u0bb0\u0bcd \u0b8f \u0baf\u0bc1 \u0b9c\u0bbf \u0b9c\u0bc6\u0baf\u0ba4\u0bbf\u0bb8\u0bcd\u0bb8",
  },
  "R A.GNANAWATHIE": {
    si: "\u0d86\u0dbb\u0dca \u0d92.\u0da5\u0dcf\u0db1\u0dc0\u0dad\u0dd3",
    ta: "\u0b86\u0bb0\u0bcd \u0b8f.\u0b9e\u0bbe\u0ba9\u0bb5\u0ba4\u0bbf",
  },
  "R A.MAHINDA RANASINGHE": {
    si: "\u0d86\u0dbb\u0dca.\u0d92.\u0db8\u0dc4\u0dd2\u0db1\u0dca\u0daf \u0dbb\u0dab\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b86\u0bb0\u0bcd.\u0b8f.\u0bae\u0bb9\u0bbf\u0ba8\u0bcd\u0ba4 \u0bb0\u0ba3\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "R B ATHULA PRABATH": {
    si: "\u0d86\u0dbb\u0dca \u0db6\u0dd3 \u0d85\u0dad\u0dd4\u0dbd \u0db4\u0dca\u200d\u0dbb\u0db7\u0dcf\u0dad\u0dca",
    ta: "\u0b86\u0bb0\u0bcd \u0baa\u0bbf \u0b85\u0ba4\u0bc1\u0bb2 \u0baa\u0bbf\u0bb0\u0baa\u0bbe\u0ba4\u0bcd",
  },
  "R G C WIJESIRI": {
    si: "\u0d86\u0dbb\u0dca \u0da2\u0dd3 \u0dc3\u0dd3 \u0dc0\u0dd2\u0da2\u0dda\u0dc3\u0dd2\u0dbb\u0dd2",
    ta: "\u0b86\u0bb0\u0bcd \u0b9c\u0bbf \u0b9a\u0bbf \u0bb5\u0bbf\u0b9c\u0bc7\u0b9a\u0bbf\u0bb0\u0bbf",
  },
  "R H M S K RAJAKARUNA": {
    si: "\u0d86\u0dbb\u0dca \u0d91\u0da0\u0dca \u0d91\u0db8\u0dca \u0d91\u0dc3\u0dca \u0d9a\u0dda \u0dbb\u0dcf\u0da2\u0d9a\u0dbb\u0dd4\u0dab\u0dcf",
    ta: "\u0b86\u0bb0\u0bcd \u0b8e\u0b9a\u0bcd \u0b8e\u0bae\u0bcd \u0b8e\u0bb8\u0bcd \u0b95\u0bc7 \u0bb0\u0bbe\u0b9c\u0b95\u0bb0\u0bc1\u0ba3\u0bbe",
  },
  "R K  HEMAKUMARA": {
    si: "\u0d86\u0dbb\u0dca \u0d9a\u0dda \u0dc4\u0dda\u0db8\u0d9a\u0dd4\u0db8\u0dcf\u0dbb",
    ta: "\u0b86\u0bb0\u0bcd \u0b95\u0bc7 \u0bb9\u0bc7\u0bae\u0b95\u0bc1\u0bae\u0bbe\u0bb0",
  },
  "R K BANDUJITH": {
    si: "\u0d86\u0dbb\u0dca \u0d9a\u0dda \u0db6\u0db1\u0dca\u0daf\u0dd4\u0da2\u0dd2\u0dad\u0dca",
    ta: "\u0b86\u0bb0\u0bcd \u0b95\u0bc7 \u0baa\u0ba8\u0bcd\u0ba4\u0bc1\u0b9c\u0bbf\u0ba4\u0bcd",
  },
  "R M ARIYADASA FILLING STATION": {
    si: "\u0d86\u0dbb\u0dca \u0d91\u0db8\u0dca \u0d86\u0dbb\u0dd2\u0dba\u0daf\u0dcf\u0dc3 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b86\u0bb0\u0bcd \u0b8e\u0bae\u0bcd \u0b86\u0bb0\u0bbf\u0baf\u0ba4\u0bbe\u0b9a\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "R M G K B RATHNAYAKA": {
    si: "\u0d86\u0dbb\u0dca \u0d91\u0db8\u0dca \u0da2\u0dd3 \u0d9a\u0dda \u0db6\u0dd3 \u0dbb\u0dad\u0dca\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b86\u0bb0\u0bcd \u0b8e\u0bae\u0bcd \u0b9c\u0bbf \u0b95\u0bc7 \u0baa\u0bbf \u0bb0\u0ba4\u0bcd\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "R M J C  RATHNAYAKE": {
    si: "\u0d86\u0dbb\u0dca \u0d91\u0db8\u0dca \u0da2\u0dda \u0dc3\u0dd3 \u0dbb\u0dad\u0dca\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b86\u0bb0\u0bcd \u0b8e\u0bae\u0bcd \u0b9c\u0bc7 \u0b9a\u0bbf \u0bb0\u0ba4\u0bcd\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "R M S K RATHNAYAKE": {
    si: "\u0d86\u0dbb\u0dca \u0d91\u0db8\u0dca \u0d91\u0dc3\u0dca \u0d9a\u0dda \u0dbb\u0dad\u0dca\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b86\u0bb0\u0bcd \u0b8e\u0bae\u0bcd \u0b8e\u0bb8\u0bcd \u0b95\u0bc7 \u0bb0\u0ba4\u0bcd\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "R M SENEVIRATNE": {
    si: "\u0d86\u0dbb\u0dca \u0d91\u0db8\u0dca \u0dc3\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b86\u0bb0\u0bcd \u0b8e\u0bae\u0bcd \u0b9a\u0bc6\u0ba9\u0bb5\u0bbf\u0bb0\u0ba4\u0bcd\u0ba9\u0bc7",
  },
  "R M.ABEYKOON BANDA": {
    si: "\u0d86\u0dbb\u0dca \u0d91\u0db8\u0dca \u0d85\u0db6\u0dda\u0d9a\u0ddd\u0db1\u0dca \u0db6\u0dab\u0dca\u0da9\u0dcf",
    ta: "\u0b86\u0bb0\u0bcd \u0b8e\u0bae\u0bcd.\u0b85\u0baa\u0bc7\u0b95\u0bcb\u0ba9\u0bcd \u0baa\u0ba3\u0bcd\u0b9f\u0bbe",
  },
  "R N P R .FERNANDO": {
    si: "\u0d86\u0dbb\u0dca \u0d91\u0db1\u0dca \u0db4\u0dd3 \u0d86\u0dbb\u0dca .\u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0b86\u0bb0\u0bcd \u0b8e\u0ba9\u0bcd \u0baa\u0bbf \u0b86\u0bb0\u0bcd .\u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "R P DMMIKA": {
    si: "R P DMMIKA",
    ta: "\u0b86\u0bb0\u0bcd \u0baa\u0bbf \u0ba4\u0bbf\u0bae\u0bc1\u0b95",
  },
  "R P LUXMAN WIJESIRI & SONS PVT LTD": {
    si: "R P LUXMAN WiJESRI & SONS PVT LTD",
    ta: "\u0b86\u0bb0\u0bcd \u0baa\u0bbf \u0bb2\u0b95\u0bcd\u0bb8\u0bcd\u0bae\u0ba9\u0bcd \u0bb5\u0bbf\u0b9c\u0bc7\u0b9a\u0bbf\u0bb0\u0bbf & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd \u0baa\u0bbf\u0bb0\u0bc8\u0bb5\u0bc7\u0b9f\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "R R R SIRIWANSA": {
    si: "\u0d86\u0dbb\u0dca \u0d86\u0dbb\u0dca \u0d86\u0dbb\u0dca \u0dc3\u0dd2\u0dbb\u0dd2\u0dc0\u0d82\u0dc1",
    ta: "\u0b86\u0bb0\u0bcd \u0b86\u0bb0\u0bcd \u0b86\u0bb0\u0bcd \u0b9a\u0bbf\u0bb0\u0bbf\u0bb5\u0ba9\u0bcd\u0b9a\u0bbe",
  },
  "R RAJANATHAN": {
    si: "\u0d86\u0dbb\u0dca \u0dbb\u0dcf\u0da2\u0db1\u0dcf\u0daf\u0db1\u0dca",
    ta: "\u0b86\u0bb0\u0bcd \u0bb0\u0bbe\u0b9c\u0ba8\u0bbe\u0ba4\u0ba9\u0bcd",
  },
  "R S B FERNANDO LANKA SERVICE ST": {
    si: "\u0d86\u0dbb\u0dca \u0d91\u0dc3\u0dca \u0db6\u0dd3 \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4 \u0dbd\u0d82\u0d9a\u0dcf \u0dc3\u0dda\u0dc0\u0dba \u0dc1\u0dcf\u0db1\u0dca\u0dad",
    ta: "\u0b86\u0bb0\u0bcd \u0b8e\u0bb8\u0bcd \u0baa\u0bbf \u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b9a\u0bb0\u0bcd\u0bb5\u0bc0\u0bb8\u0bcd \u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd",
  },
  "R S PINIDIYA": {
    si: "\u0d86\u0dbb\u0dca \u0d91\u0dc3\u0dca \u0db4\u0dd2\u0db1\u0dd2\u0daf\u0dd2\u0dba",
    ta: "\u0b86\u0bb0\u0bcd \u0b8e\u0bb8\u0bcd \u0baa\u0bbf\u0ba3\u0bbf\u0b9f\u0bbf\u0baf\u0bbe",
  },
  "R T S PETROLEUM (PVT) LTD": {
    si: "R T S \u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0ddd\u0dbd\u0dd2\u0dba\u0db8\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0b86\u0bb0\u0bcd \u0b9f\u0bbf \u0b8e\u0bb8\u0bcd \u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bbf\u0baf\u0bae\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "R W H M U S B RAJAGURU": {
    si: "\u0d86\u0dbb\u0dca \u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0d91\u0da0\u0dca \u0d91\u0db8\u0dca \u0dba\u0dd6 \u0d91\u0dc3\u0dca \u0db6\u0dd3 \u0dbb\u0dcf\u0da2\u0d9c\u0dd4\u0dbb\u0dd4",
    ta: "\u0b86\u0bb0\u0bcd \u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b8e\u0b9a\u0bcd \u0b8e\u0bae\u0bcd \u0baf\u0bc1 \u0b8e\u0bb8\u0bcd \u0baa\u0bbf \u0bb0\u0bbe\u0b9c\u0b95\u0bc1\u0bb0\u0bc1",
  },
  "R. RANAWEERA ARACHCHI": {
    si: "\u0d86\u0dbb\u0dca \u0dbb\u0dab\u0dc0\u0dd3\u0dbb \u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2",
    ta: "\u0b86\u0bb0\u0bcd.\u0bb0\u0ba3\u0bb5\u0bc0\u0bb0 \u0b86\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf",
  },
  "R.A.D.J.RANASINGHE": {
    si: "\u0d86\u0dbb\u0dca.\u0d92.\u0da9\u0dd3.\u0da2\u0dda.\u0dbb\u0dab\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b86\u0bb0\u0bcd.\u0b8f.\u0b9f\u0bbf.\u0b9c\u0bc7.\u0bb0\u0ba3\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "R.ARANGALLAGE": {
    si: "\u0d86\u0dbb\u0dca.\u0d85\u0dbb\u0d82\u0d9c\u0dbd\u0dca\u0dbd\u0d9c\u0dda",
    ta: "\u0b86\u0bb0\u0bcd.\u0b85\u0bb0\u0b99\u0bcd\u0b95\u0bb2\u0bcd\u0bb2\u0bbe\u0b95\u0bc7",
  },
  "R.K.THEEKSHANAPALA": {
    si: "\u0d86\u0dbb\u0dca.\u0d9a\u0dda.\u0dad\u0dd3\u0d9a\u0dca\u0dc2\u0dab\u0db4\u0dcf\u0dbd",
    ta: "\u0b86\u0bb0\u0bcd.\u0b95\u0bc7.\u0ba4\u0bc0\u0b95\u0bcd\u0bb7\u0ba3\u0baa\u0bbe\u0bb2\u0bbe",
  },
  "R.L.PINIDIYA": {
    si: "\u0d86\u0dbb\u0dca.\u0d91\u0dbd\u0dca.\u0db4\u0dd2\u0db1\u0dd2\u0daf\u0dd2\u0dba",
    ta: "\u0b86\u0bb0\u0bcd.\u0b8e\u0bb2\u0bcd.\u0baa\u0bbf\u0ba9\u0bbf\u0b9f\u0bbf\u0baf\u0bbe",
  },
  "R.M. M. J.NAWINNA": {
    si: "\u0d86\u0dbb\u0dca.\u0d91\u0db8\u0dca. \u0d91\u0db8\u0dca.\u0da2\u0dda.\u0db1\u0dcf\u0dc0\u0dd2\u0db1\u0dca\u0db1",
    ta: "\u0b86\u0bb0\u0bcd.\u0b8e\u0bae\u0bcd. \u0b8e\u0bae\u0bcd.\u0b9c\u0bc7.\u0ba8\u0bbe\u0bb5\u0bbf\u0ba9\u0bcd\u0ba9\u0bbe",
  },
  "R.M. RAJAPAKSHA BANDA": {
    si: "\u0d86\u0dbb\u0dca.\u0d91\u0db8\u0dca. \u0dbb\u0dcf\u0da2\u0db4\u0d9a\u0dca\u0dc2 \u0db6\u0dab\u0dca\u0da9\u0dcf",
    ta: "\u0b86\u0bb0\u0bcd.\u0b8e\u0bae\u0bcd. \u0bb0\u0bbe\u0b9c\u0baa\u0b95\u0bcd\u0bb7 \u0baa\u0ba3\u0bcd\u0b9f\u0bbe",
  },
  "R.M.C.M.A.RATHNAYAKE": {
    si: "\u0d86\u0dbb\u0dca.\u0d91\u0db8\u0dca.\u0dc3\u0dd3.\u0d91\u0db8\u0dca.\u0d92.\u0dbb\u0dad\u0dca\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b86\u0bb0\u0bcd.\u0b8e\u0bae\u0bcd.\u0b9a\u0bbf.\u0b8e\u0bae\u0bcd.\u0b8f.\u0bb0\u0ba4\u0bcd\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "R.M.D.S.HEMANTHI PERERA": {
    si: "\u0d86\u0dbb\u0dca.\u0d91\u0db8\u0dca.\u0da9\u0dd3.\u0d91\u0dc3\u0dca.\u0dc4\u0dda\u0db8\u0db1\u0dca\u0dad\u0dd2 \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b86\u0bb0\u0bcd.\u0b8e\u0bae\u0bcd.\u0b9f\u0bbf.\u0b8e\u0bb8\u0bcd.\u0bb9\u0bc7\u0bae\u0ba8\u0bcd\u0ba4\u0bbf \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "R.M.INDRANI": {
    si: "\u0d86\u0dbb\u0dca.\u0d91\u0db8\u0dca.\u0d89\u0db1\u0dca\u0daf\u0dca\u200d\u0dbb\u0dcf\u0db1\u0dd2",
    ta: "\u0b86\u0bb0\u0bcd.\u0b8e\u0bae\u0bcd.\u0b87\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0bbe\u0ba3\u0bbf",
  },
  "R.M.N.RANASINGHE": {
    si: "\u0d86\u0dbb\u0dca.\u0d91\u0db8\u0dca.\u0d91\u0db1\u0dca.\u0dbb\u0dab\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b86\u0bb0\u0bcd.\u0b8e\u0bae\u0bcd.\u0b8e\u0ba9\u0bcd.\u0bb0\u0ba3\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "R.M.S.UPATISSA": {
    si: "\u0d86\u0dbb\u0dca.\u0d91\u0db8\u0dca.\u0d91\u0dc3\u0dca.\u0d8b\u0db4\u0dad\u0dd2\u0dc3\u0dca\u0dc3",
    ta: "R.M.S.UPATISSA",
  },
  "R.N.D.A.SENAVIRATHNA": {
    si: "\u0d86\u0dbb\u0dca.\u0d91\u0db1\u0dca.\u0da9\u0dd3.\u0d92.\u0dc3\u0dda\u0db1\u0dc0\u0dd2\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b86\u0bb0\u0bcd.\u0b8e\u0ba9\u0bcd.\u0b9f\u0bbf.\u0b8f.\u0b9a\u0bc7\u0ba9\u0bb5\u0bbf\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "R.N.D.ALWIS SENEVIRATNE": {
    si: "\u0d86\u0dbb\u0dca.\u0d91\u0db1\u0dca.\u0da9\u0dd3.\u0d85\u0dbd\u0dca\u0dc0\u0dd2\u0dc3\u0dca \u0dc3\u0dd9\u0db1\u0dd9\u0dc0\u0dd2\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b86\u0bb0\u0bcd.\u0b8e\u0ba9\u0bcd.\u0b9f\u0bbf.\u0b85\u0bb2\u0bcd\u0bb5\u0bbf\u0bb8\u0bcd \u0b9a\u0bc6\u0ba9\u0bb5\u0bbf\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "R.N.KARUNANAYAKE": {
    si: "\u0d86\u0dbb\u0dca.\u0d91\u0db1\u0dca.\u0d9a\u0dbb\u0dd4\u0dab\u0dcf\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b86\u0bb0\u0bcd.\u0b8e\u0ba9\u0bcd.\u0b95\u0bb0\u0bc1\u0ba3\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "R.R.WEDISINGHE": {
    si: "\u0d86\u0dbb\u0dca.\u0d86\u0dbb\u0dca.\u0dc0\u0dd9\u0da9\u0dd2\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b86\u0bb0\u0bcd.\u0b86\u0bb0\u0bcd.\u0bb5\u0bc6\u0b9f\u0bbf\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "R.RUWAN ASIRI DE SILVA": {
    si: "\u0d86\u0dbb\u0dca.\u0dbb\u0dd4\u0dc0\u0db1\u0dca \u0d86\u0dc3\u0dd2\u0dbb\u0dd2 \u0daf \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf",
    ta: "\u0b86\u0bb0\u0bcd.\u0bb0\u0bc1\u0bb5\u0ba9\u0bcd \u0b86\u0b9a\u0bbf\u0bb0\u0bbf \u0b9f\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe",
  },
  "R.S.WIJESOORIYA": {
    si: "R.S.WIJESOORiya",
    ta: "\u0b86\u0bb0\u0bcd.\u0b8e\u0bb8\u0bcd.\u0bb5\u0bbf\u0b9c\u0bc7\u0b9a\u0bc2\u0bb0\u0bbf\u0baf",
  },
  "R.SHIVANARULSOTHY": {
    si: "\u0d86\u0dbb\u0dca.\u0dc1\u0dd2\u0dc0\u0db1\u0dbb\u0dd4\u0dbd\u0dca\u0dc3\u0ddd\u0dad\u0dd2",
    ta: "\u0b86\u0bb0\u0bcd.\u0b9a\u0bbf\u0bb5\u0ba9\u0bb0\u0bc1\u0bb3\u0bcd\u0b9a\u0bcb\u0ba4\u0bbf",
  },
  "R.W.M.SUDHARSHANI WIJERATNE": {
    si: "R.W.M.Sudharshani Wijeratne",
    ta: "\u0b86\u0bb0\u0bcd.\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0b8e\u0bae\u0bcd.\u0b9a\u0bc1\u0ba4\u0bb0\u0bcd\u0bb7\u0ba9\u0bbf \u0bb5\u0bbf\u0b9c\u0bc7\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "R2WV+49 Godagama, Sri Lanka": {
    si: "R2WV+49 \u0d9c\u0ddc\u0da9\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "R2WV+49 \u0b95\u0bca\u0b9f\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "R36C+HC6, Myliddy, Sri Lanka": {
    si: "R36C+HC6, \u0db8\u0dba\u0dd2\u0dbd\u0dd2\u0da9\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "R36C+HC6, \u0bae\u0bc8\u0bb2\u0bbf\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "R3M2+M8H, Sri Lanka": {
    si: "R3M2+M8H, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "R3M2+M8H, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "R3RV+387, Galagedera - Horana Rd, Padukka, Sri Lanka": {
    si: "R3RV+387, \u0d9c\u0dbd\u0d9c\u0dd9\u0daf\u0dbb - \u0dc4\u0ddc\u0dbb\u0dab \u0db4\u0dcf\u0dbb, \u0db4\u0dcf\u0daf\u0dd4\u0d9a\u0dca\u0d9a, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "R3RV+387, \u0b95\u0bb2\u0b95\u0bc6\u0ba4\u0bc7\u0bb0\u0bbe - \u0bb9\u0bca\u0bb0\u0ba3 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bbe\u0ba4\u0bc1\u0b95\u0bcd\u0b95, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "R3RV+X35, Padukka, Sri Lanka": {
    si: "R3RV+X35, \u0db4\u0dcf\u0daf\u0dd4\u0d9a\u0dca\u0d9a, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "R3RV+X35, \u0baa\u0bbe\u0ba4\u0bc1\u0b95\u0bcd\u0b95, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "R5F9+9R7, Valvettithurai, Sri Lanka": {
    si: "R5F9+9R7, \u0dc0\u0dd0\u0dbd\u0dca\u0dc0\u0dd0\u0da7\u0dd2\u0dad\u0dd4\u0dbb\u0dd9\u0dba\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "R5F9+9R7, \u0bb5\u0bb2\u0bcd\u0bb5\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "R5FC+G7W, Valvettithurai, Sri Lanka": {
    si: "R5FC+G7W, \u0dc0\u0dd0\u0dbd\u0dca\u0dc0\u0dd0\u0da7\u0dd2\u0dad\u0dd4\u0dbb\u0dd9\u0dba\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "R5FC+G7W, \u0bb5\u0bb2\u0bcd\u0bb5\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "R5FG+R2C, Valvettithurai, Sri Lanka": {
    si: "R5FG+R2C, \u0dc0\u0dd0\u0dbd\u0dca\u0dc0\u0dd0\u0da7\u0dd2\u0dad\u0dd4\u0dbb\u0dd9\u0dba\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "R5FG+R2C, \u0bb5\u0bb2\u0bcd\u0bb5\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "R65G+5QC, Point Pedro, Sri Lanka": {
    si: "R65G+5QC, \u0db4\u0dda\u0daf\u0dd4\u0dbb\u0dd4\u0dad\u0dd4\u0da9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "R65G+5QC, \u0baa\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "R67J+MJH, Point Pedro, Sri Lanka": {
    si: "R67J+MJH, \u0db4\u0dda\u0daf\u0dd4\u0dbb\u0dd4\u0dad\u0dd4\u0da9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "R67J+MJH, \u0baa\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "R67J+PHF, Point Pedro, Sri Lanka": {
    si: "R67J+PHF, \u0db4\u0dda\u0daf\u0dd4\u0dbb\u0dd4\u0dad\u0dd4\u0da9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "R67J+PHF, \u0baa\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "R6FX+3VJ, Daladagama, Sri Lanka": {
    si: "R6FX+3VJ, \u0daf\u0dc5\u0daf\u0dcf\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "R6FX+3VJ, \u0ba4\u0bb2\u0ba4\u0bbe\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "R6GX+PHF, Padeniya - Anuradhapura Highway, Daladagama 60600, Sri Lanka": {
    si: "R6GX+PHF, \u0db4\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba - \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0daf\u0dc5\u0daf\u0dcf\u0d9c\u0db8 60600, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "R6GX+PHF, \u0baa\u0b9f\u0bc6\u0ba9\u0bbf\u0baf - \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0 \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0ba4\u0bb2\u0ba4\u0bbe\u0b95\u0bae 60600, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "R83M+P9F, Sri Lanka": {
    si: "R83M+P9F, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "R83M+P9F, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "R8F5+J3H, Maduruketiya, Sri Lanka": {
    si: "R8F5+J3H, \u0db8\u0daf\u0dd4\u0dbb\u0dd4\u0d9a\u0dd0\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "R8F5+J3H, \u0bae\u0ba4\u0bc1\u0bb0\u0bc1\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RAFFEEK STORES": {
    si: "\u0dbb\u0dc6\u0dd3\u0d9a\u0dca \u0dc0\u0dd9\u0dc5\u0db3\u0dc3\u0dd0\u0dbd\u0dca",
    ta: "\u0bb0\u0b83\u0baa\u0bc0\u0b95\u0bcd \u0b95\u0b9f\u0bc8\u0b95\u0bb3\u0bcd",
  },
  "RAIGAM UDAGAHAPATTU MPCS LTD": {
    si: "\u0dbb\u0dba\u0dd2\u0d9c\u0db8\u0dca \u0d8b\u0da9\u0d9c\u0dc4\u0db4\u0dad\u0dca\u0dad\u0dd4 MPCS LTD",
    ta: "\u0bb0\u0bc8\u0b95\u0bae\u0bcd \u0b89\u0b9f\u0b95\u0bb9\u0baa\u0b9f\u0bcd\u0b9f\u0bc1 MPCS LTD",
  },
  "RAJAN UMAYAL (PVT) LTD": {
    si: "\u0dbb\u0dcf\u0da2\u0db1\u0dca \u0d8b\u0db8\u0dcf\u0dba\u0dcf\u0dbd\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0bb0\u0bbe\u0b9c\u0ba9\u0bcd \u0b89\u0bae\u0bc8\u0baf\u0bbe\u0bb3\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "RAMANAYAKE VIYAPARA": {
    si: "\u0dbb\u0dcf\u0db8\u0db1\u0dcf\u0dba\u0d9a \u0dc0\u0dd2\u0dba\u0db4\u0dbb\u0dcf",
    ta: "\u0bb0\u0bbe\u0bae\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0bb5\u0bbf\u0baf\u0bbe\u0baa\u0bb0\u0bbe",
  },
  "RAMBEWA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dbb\u0db9\u0dd1\u0dc0 \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0bb0\u0bbe\u0bae\u0bcd\u0baa\u0bc7\u0bb5\u0bbe MPCS LTD",
  },
  "RAMBUKKANA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dbb\u0db9\u0dd4\u0d9a\u0dca\u0d9a\u0db1 \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0bb0\u0bae\u0bcd\u0baa\u0bc1\u0b95\u0bcd\u0b95\u0ba9\u0bbe MPCS LTD",
  },
  "RAMEES  M S M": {
    si: "\u0dbb\u0db8\u0dd3\u0dc3\u0dca \u0d91\u0db8\u0dca \u0d91\u0dc3\u0dca \u0d91\u0db8\u0dca",
    ta: "\u0bb0\u0bae\u0bc0\u0bb8\u0bcd \u0b8e\u0bae\u0bcd \u0b8e\u0bb8\u0bcd \u0b8e\u0bae\u0bcd",
  },
  "RAMYA CHANDRASEELI WICKREMARACHCHI": {
    si: "\u0dbb\u0db8\u0dca\u200d\u0dba\u0dcf \u0da0\u0db1\u0dca\u0daf\u0dca\u200d\u0dbb\u0dc3\u0dd3\u0dbd\u0dd2 \u0dc0\u0dd2\u0d9a\u0dca\u200d\u0dbb\u0db8\u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2",
    ta: "\u0bb0\u0bae\u0bcd\u0baf\u0bbe \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0b9a\u0bc0\u0bb2\u0bbf \u0bb5\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb0\u0bae\u0bbe\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf",
  },
  "RANAWEERA ENTERPRISES": {
    si: "\u0dbb\u0dab\u0dc0\u0dd3\u0dbb \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0bb0\u0ba3\u0bb5\u0bc0\u0bb0 \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "RANDIMA HOLDINGS (PVT) LTD": {
    si: "RANDIMA Holdings (PVT) LTD",
    ta: "\u0bb0\u0bbe\u0ba3\u0bcd\u0b9f\u0bbf\u0bae\u0bbe \u0bb9\u0bcb\u0bb2\u0bcd\u0b9f\u0bbf\u0b99\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "RANGIRI DAMBULLA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dbb\u0d82\u0d9c\u0dd2\u0dbb\u0dd2 \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd MPCS",
    ta: "\u0bb0\u0bbe\u0b99\u0bcd\u0b95\u0bbf\u0bb0\u0bbf \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe MPCS LTD",
  },
  "RANJITH ATTALE SAHA SAMAGAMA": {
    si: "\u0dbb\u0d82\u0da2\u0dd2\u0dad\u0dca \u0d85\u0dad\u0dca\u0dad\u0dda \u0dc3\u0dc4 \u0dc3\u0db8\u0d9c\u0db8",
    ta: "\u0bb0\u0b9e\u0bcd\u0b9a\u0bbf\u0ba4\u0bcd \u0b85\u0b9f\u0bcd\u0b9f\u0bbe\u0bb2\u0bc7 \u0b9a\u0bb9\u0bbe \u0b9a\u0bae\u0b95\u0bae",
  },
  "RANMEER HOLDINGS (PVT) LTD": {
    si: "RANMEER Holdings (PVT) LTD",
    ta: "\u0bb0\u0ba9\u0bcd\u0bae\u0bc0\u0bb0\u0bcd \u0bb9\u0bcb\u0bb2\u0bcd\u0b9f\u0bbf\u0b99\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "RANMUTHU ENTERPRISES": {
    si: "\u0dbb\u0db1\u0dca\u0db8\u0dd4\u0dad\u0dd4 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0bb0\u0ba9\u0bcd\u0bae\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1 \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "RATHNA FILLING STATION": {
    si: "\u0dbb\u0dad\u0dca\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0bb0\u0ba4\u0bcd\u0ba9\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "RATNAM FILLING STATION": {
    si: "\u0dbb\u0dad\u0dca\u0db1\u0db8\u0dca \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0bb0\u0ba4\u0bcd\u0ba9\u0bae\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "RATNAPURA MPCS LTD": {
    si: "\u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb MPCS LTD",
    ta: "\u0bb0\u0ba4\u0bcd\u0ba9\u0baa\u0bc1\u0bb0\u0bbe MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "RCF3+HPM, Kumbukulawa, Sri Lanka": {
    si: "RCF3+HPM, \u0d9a\u0dd4\u0db9\u0dd4\u0d9a\u0dd4\u0dbd\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RCF3+HPM, \u0b95\u0bc1\u0bae\u0bcd\u0baa\u0b95\u0bc1\u0bb2\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "REAL LANKA FILLING STATION": {
    si: "\u0dbb\u0dd2\u0dba\u0dbd\u0dca \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0bb0\u0bbf\u0baf\u0bb2\u0bcd \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "REGAL FILLING STATION (PVT) LTD": {
    si: "REGAL Filling Station (PVT) LTD",
    ta: "\u0bb0\u0bc0\u0b95\u0bb2\u0bcd \u0b83\u0baa\u0bbf\u0bb2\u0bcd\u0bb2\u0bbf\u0b99\u0bcd \u0bb8\u0bcd\u0b9f\u0bc7\u0bb7\u0ba9\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "RFRW+RX Mamaduwa, Sri Lanka": {
    si: "RFRW+RX \u0db8\u0dcf\u0db8\u0da9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RFRW+RX \u0bae\u0bbe\u0bae\u0ba4\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RHPC+HQG, Maskeliya, Sri Lanka": {
    si: "RHPC+HQG, \u0db8\u0dc3\u0dca\u0d9a\u0dd9\u0dbd\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RHPC+HQG, \u0bae\u0bb8\u0bcd\u0b95\u0bc6\u0bb2\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RHWH+5C4, Thoniyagala - Kalawewa - Galewela Rd, Makulugaswewa, Sri Lanka": {
    si: "RHWH+5C4, \u0dad\u0ddd\u0db1\u0dd2\u0dba\u0dcf\u0d9c\u0dbd - \u0d9a\u0dbd\u0dcf\u0dc0\u0dd0\u0dc0 - \u0d9c\u0dbd\u0dda\u0dc0\u0dd9\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0d9a\u0dd4\u0dc5\u0dd4\u0d9c\u0dc3\u0dca\u0dc0\u0dd0\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RHWH+5C4, \u0ba4\u0bcb\u0ba9\u0bbf\u0baf\u0bbe\u0b95\u0bb2 - \u0b95\u0bb2\u0bb5\u0bc6\u0bb5 - \u0b95\u0bb2\u0bc7\u0bb5\u0bc6\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0b95\u0bc1\u0bb2\u0bc1\u0b95\u0bb8\u0bcd\u0bb5\u0bc6\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RIDIGAMA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dbb\u0dd2\u0daf\u0dd2\u0d9c\u0db8 \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0bb0\u0bbf\u0b9f\u0bbf\u0b95\u0bbe\u0bae\u0bbe MPCS LTD",
  },
  "RIKILLAGASKADA MPCS LTD": {
    si: "\u0dbb\u0dd2\u0d9a\u0dd2\u0dbd\u0dca\u0dbd\u0d9c\u0dc3\u0dca\u0d9a\u0da9 MPCS LTD",
    ta: "\u0bb0\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb2\u0bcd\u0bb2\u0b95\u0bb8\u0bcd\u0b95\u0b9f\u0bbe MPCS LTD",
  },
  "RISIKI LANKA PIRAVUMHALA": {
    si: "\u0dbb\u0dd2\u0dc3\u0dd2\u0d9a\u0dd2 \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0bb0\u0bbf\u0b9a\u0bbf\u0b95\u0bbf \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0baa\u0bbf\u0bb1\u0bb5\u0bc1\u0bae\u0bcd\u0bb9\u0bbe\u0bb2\u0bbe",
  },
  "RITIGALA FILLING STATION": {
    si: "\u0dbb\u0dd2\u0da7\u0dd2\u0d9c\u0dbd \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0bb0\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bbe\u0bb2\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "RJ67+729, Dambulla, Sri Lanka": {
    si: "RJ67+729, \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RJ67+729, \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RJQ6+WRW, Norwood, Sri Lanka": {
    si: "RJQ6+WRW, \u0db1\u0ddd\u0dbb\u0dca\u0dc0\u0dd4\u0da9\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RJQ6+WRW, \u0ba8\u0bcb\u0bb0\u0bcd\u0bb5\u0bc2\u0b9f\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "ROHANA ENTERPRISES": {
    si: "\u0dbb\u0ddd\u0dc4\u0dab \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0bb0\u0bcb\u0bb9\u0ba9\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "ROMICO GROUP ( PVT) LTD": {
    si: "ROMICO GROUP (PVT) LTD",
    ta: "\u0bb0\u0bcb\u0bae\u0bbf\u0b95\u0bcb \u0b95\u0bc1\u0bb0\u0bc2\u0baa\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "RQM9+C7H, Padaviya, Sri Lanka": {
    si: "RQM9+C7H, \u0db4\u0daf\u0dc0\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RQM9+C7H, \u0baa\u0ba4\u0bb5\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RR4G+G38, Colombo Road, Puttalam, Sri Lanka": {
    si: "RR4G+G38, \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RR4G+G38, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RUHUNU LANKA IOC FILLING STATION": {
    si: "\u0dbb\u0dd4\u0dc4\u0dd4\u0dab\u0dd4 \u0dbd\u0d82\u0d9a\u0dcf IOC \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0bb0\u0bc1\u0bb9\u0bc1\u0ba9\u0bc1 \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b90\u0b93\u0b9a\u0bbf \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "RUHUNUPUTHA FILLING STATION": {
    si: "\u0dbb\u0dd4\u0dc4\u0dd4\u0dab\u0dd4\u0db4\u0dd4\u0dad \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0bb0\u0bc1\u0bb9\u0bc1\u0ba9\u0bc1\u0baa\u0bc1\u0ba4 \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "RUWAN SISIL DISSANAYAKE": {
    si: "\u0dbb\u0dd4\u0dc0\u0db1\u0dca \u0dc3\u0dd2\u0dc3\u0dd2\u0dbd\u0dca \u0daf\u0dd2\u0dc3\u0dcf\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0bb0\u0bc1\u0bb5\u0bbe\u0ba9\u0bcd \u0b9a\u0bbf\u0b9a\u0bbf\u0bb2\u0bcd \u0ba4\u0bbf\u0b9a\u0bbe\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  RUWANWELLA: {
    si: "\u0dbb\u0dd4\u0dc0\u0db1\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0bb0\u0bc1\u0bb5\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2",
  },
  "RUWANWELLA MPCS LTD": {
    si: "\u0dbb\u0dd4\u0dc0\u0db1\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd MPCS LTD",
    ta: "\u0bb0\u0bc1\u0bb5\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 MPCS LTD",
  },
  "RVJP+J2H, Dehiwala-Mount Lavinia, Sri Lanka": {
    si: "RVJP+J2H, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd-\u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RVJP+J2H, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8-\u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RVXX+68C, Boralesgamuwa, Sri Lanka": {
    si: "RVXX+68C, \u0db6\u0ddc\u0dbb\u0dbd\u0dd0\u0dc3\u0dca\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RVXX+68C, \u0baa\u0bca\u0bb0\u0bb2\u0bb8\u0bcd\u0b95\u0bae\u0bc1\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RW2F+V24, Piliyandala, Sri Lanka": {
    si: "RW2F+V24, \u0db4\u0dd2\u0dc5\u0dd2\u0dba\u0db1\u0dca\u0daf\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RW2F+V24, \u0baa\u0bbf\u0bb2\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RW98+MV8,   -    , Piliyandala, Sri Lanka": {
    si: "RW98+MV8, - , \u0db4\u0dd2\u0dc5\u0dd2\u0dba\u0db1\u0dca\u0daf\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RW98+MV8, - , \u0baa\u0bbf\u0bb2\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RWJM+9X9, B367, Pannipitiya, Sri Lanka": {
    si: "RWJM+9X9, B367, \u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RWJM+9X9, B367, \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RWVF+973, Maharagama 10280, Sri Lanka": {
    si: "RWVF+973, \u0db8\u0dc4\u0dbb\u0d9c\u0db8 10280, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RWVF+973, \u0bae\u0bb9\u0bb0\u0b95\u0bae 10280, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RX79+6V Diyatalawa, Sri Lanka": {
    si: "RX79+6V \u0daf\u0dd2\u0dba\u0dad\u0dbd\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RX79+6V \u0ba4\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RXF6+G6R, Pannipitiya, Sri Lanka": {
    si: "RXF6+G6R, \u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RXF6+G6R, \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RXG9+F3R, Sampath Uyana, Polgasowita, Sri Lanka": {
    si: "RXG9+F3R, \u0dc3\u0db8\u0dca\u0db4\u0dad\u0dca \u0d8b\u0dba\u0db1, \u0db4\u0ddc\u0dbd\u0dca\u0d9c\u0dc3\u0dca\u0d95\u0dc0\u0dd2\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RXG9+F3R, \u0b9a\u0bae\u0bcd\u0baa\u0ba4\u0bcd \u0b89\u0baf\u0ba9, \u0baa\u0bca\u0bb2\u0bcd\u0b95\u0b9a\u0bcb\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RXJ7+Q94, Pannipitiya 10230, Sri Lanka": {
    si: "RXJ7+Q94, \u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba 10230, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RXJ7+Q94, \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf 10230, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RXJW+2H6, Bandarawela, Sri Lanka": {
    si: "RXJW+2H6, \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RXJW+2H6, \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0bb5\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RXMP+462, Bandarawela, Sri Lanka": {
    si: "RXMP+462, \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RXMP+462, \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0bb5\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RXP8+GMH, Moddaikadai, Sri Lanka": {
    si: "RXP8+GMH, Moddaikadai, Sri Lanka",
    ta: "RXP8+GMH, \u0bae\u0bca\u0b9f\u0bcd\u0b9f\u0bc8\u0b95\u0bcd\u0b95\u0b9f\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RXQC+VJF, Pannipitiya, Sri Lanka": {
    si: "RXQC+VJF, \u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RXQC+VJF, \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RXR8+FC7, Avissawella Rd, Pannipitiya 10230, Sri Lanka": {
    si: "RXR8+FC7, \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba 10230, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RXR8+FC7, \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf 10230, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RXV6+6G8, Pannipitiya 10230, Sri Lanka": {
    si: "RXV6+6G8, \u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba 10230, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RXV6+6G8, \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf 10230, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "RXV9+QH9, Athurugiriya Rd, Pannipitiya 10230, Sri Lanka": {
    si: "RXV9+QH9, \u0d85\u0dad\u0dd4\u0dbb\u0dd4\u0d9c\u0dd2\u0dbb\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba 10230, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "RXV9+QH9, \u0b85\u0ba4\u0bc1\u0bb0\u0bc1\u0b95\u0bbf\u0bb0\u0bbf\u0baf \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf 10230, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Ragama Batuwatta Road, Narangoda Paluwa": {
    si: "\u0dbb\u0dcf\u0d9c\u0db8 \u0db6\u0da7\u0dd4\u0dc0\u0dad\u0dca\u0dad \u0db4\u0dcf\u0dbb, \u0db1\u0dcf\u0dbb\u0d82\u0d9c\u0ddc\u0da9 \u0db4\u0dcf\u0dc5\u0dd4\u0dc0",
    ta: "\u0bb0\u0bbe\u0b95\u0bae \u0baa\u0b9f\u0bc1\u0bb5\u0ba4\u0bcd\u0ba4 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bbe\u0bb0\u0b99\u0bcd\u0b95\u0bca\u0b9f \u0baa\u0bb2\u0bc1\u0bb5",
  },
  "Raigam Udagahapattu MPCS LTD-B": {
    si: "\u0dbb\u0dba\u0dd2\u0d9c\u0db8\u0dca \u0d8b\u0da9\u0d9c\u0dc4\u0db4\u0dad\u0dca\u0dad\u0dd4 MPCS LTD-B",
    ta: "\u0bb0\u0bc8\u0b95\u0bae\u0bcd \u0b89\u0ba4\u0b95\u0bb9\u0bbe\u0baa\u0b9f\u0bcd\u0b9f\u0bc1 MPCS LTD-B",
  },
  "Rajanganaya Road, Rajanganaya": {
    si: "\u0dbb\u0dcf\u0da2\u0dcf\u0d82\u0d9c\u0db1\u0dba \u0db4\u0dcf\u0dbb, \u0dbb\u0dcf\u0da2\u0dcf\u0d82\u0d9c\u0db1\u0dba",
    ta: "\u0bb0\u0bbe\u0b9c\u0bbe\u0b99\u0bcd\u0b95\u0ba9\u0bc8\u0baf\u0bbe \u0bb0\u0bcb\u0b9f\u0bcd, \u0bb0\u0bbe\u0b9c\u0bbe\u0b99\u0bcd\u0b95\u0ba9\u0bc8\u0baf\u0bbe",
  },
  Rajawella: {
    si: "\u0dbb\u0da2\u0dc0\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0bb0\u0bbe\u0b9c\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2",
  },
  Rambawewa: {
    si: "\u0dbb\u0db9\u0dcf\u0dc0\u0dd0\u0dc0",
    ta: "\u0bb0\u0bae\u0bcd\u0baa\u0bbe\u0bb5\u0bc6\u0bb5",
  },
  Rambewa: {
    si: "\u0dbb\u0db9\u0dd1\u0dc0",
    ta: "\u0bb0\u0bae\u0bcd\u0baa\u0bc7\u0bb5\u0bbe",
  },
  "Rangama, H977+QVV, Sri Lanka": {
    si: "\u0dbb\u0d82\u0d9c\u0db8, H977+QVV, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb0\u0b99\u0bcd\u0b95\u0bae\u0bbe, H977+QVV, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Ranna: {
    si: "\u0dbb\u0db1\u0dca\u0db1",
    ta: "\u0bb0\u0ba9\u0bcd\u0ba9\u0bbe",
  },
  "Ranna - Ebilipitiya Rd, Agunukolapelessa": {
    si: "\u0dbb\u0db1\u0dca\u0db1 - \u0d87\u0db6\u0dd2\u0dbd\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0d85\u0d9c\u0dd4\u0dab\u0dd4\u0d9a\u0ddc\u0dc5\u0db4\u0dd0\u0dbd\u0dd0\u0dc3\u0dca\u0dc3",
    ta: "\u0bb0\u0ba9\u0bcd\u0ba9 - \u0b8e\u0baa\u0bbf\u0bb2\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0b95\u0bc1\u0ba9\u0bc1\u0b95\u0bca\u0bb2\u0baa\u0bc6\u0bb2\u0bb8\u0bcd\u0bb8",
  },
  Ranpokunugama: {
    si: "Ranpokunugama",
    ta: "Ranpokunugama",
  },
  "Ranpokunugama Bus Stand, B445, Nittambuwa, Sri Lanka": {
    si: "\u0dbb\u0db1\u0dca\u0db4\u0ddc\u0d9a\u0dd4\u0dab\u0dd4\u0d9c\u0db8 \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, B445, \u0db1\u0dd2\u0da7\u0dca\u0da7\u0db9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb0\u0ba9\u0bcd\u0baa\u0bca\u0b95\u0bc1\u0ba9\u0bc1\u0b95\u0bae \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, B445, \u0ba8\u0bbf\u0b9f\u0bcd\u0b9f\u0bae\u0bcd\u0baa\u0bc1\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Rathgama: {
    si: "\u0dbb\u0dad\u0dca\u0d9c\u0db8",
    ta: "\u0bb0\u0ba4\u0bcd\u0b95\u0bae",
  },
  "Rathkarawwa Bus Stop, Katugastota-kurunegala-puttalam Hwy": {
    si: "\u0dbb\u0dad\u0dca\u0d9a\u0dbb\u0dc0\u0dca\u0dc0 \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7-\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd-\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 Hwy",
    ta: "\u0bb0\u0ba4\u0bcd\u0b95\u0bb0\u0bb5\u0bcd\u0bb5 \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8-\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd-\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd Hwy",
  },
  Rathmalana: {
    si: "\u0dbb\u0dad\u0dca\u0db8\u0dbd\u0dcf\u0db1",
    ta: "\u0b87\u0bb0\u0ba4\u0bcd\u0bae\u0bb2\u0bbe\u0ba9\u0bc8",
  },
  Rathnapura: {
    si: "\u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb\u0dba",
    ta: "\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf",
  },
  "Ratmalana Road, Dehiwala - Mount Lavinia": {
    si: "\u0dbb\u0dad\u0dca\u0db8\u0dbd\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd - \u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3",
    ta: "\u0b87\u0bb0\u0ba4\u0bcd\u0bae\u0bb2\u0bbe\u0ba9\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8 - \u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8",
  },
  Ratnapura: {
    si: "\u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb\u0dba",
    ta: "\u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf",
  },
  "Recent Community Feedback": {
    si: "\u0db8\u0dd1\u0dad \u0db4\u0dca\u200d\u0dbb\u0da2\u0dcf \u0db4\u0dca\u200d\u0dbb\u0dad\u0dd2\u0db4\u0ddd\u0dc2\u0dab",
    ta: "\u0b9a\u0bae\u0bc0\u0baa\u0ba4\u0bcd\u0ba4\u0bbf\u0baf \u0b9a\u0bae\u0bc2\u0b95 \u0b95\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1",
  },
  "Recent Dispatch": {
    si: "\u0db8\u0dd1\u0dad \u0dba\u0dd0\u0dc0\u0dd3\u0db8",
    ta: "\u0b9a\u0bae\u0bc0\u0baa\u0ba4\u0bcd\u0ba4\u0bbf\u0baf \u0b85\u0ba9\u0bc1\u0baa\u0bcd\u0baa\u0bc1\u0ba4\u0bb2\u0bcd",
  },
  "Refresh App": {
    si: "\u0dba\u0dd9\u0daf\u0dd4\u0db8 \u0db1\u0dd0\u0dc0\u0dd4\u0db8\u0dca \u0d9a\u0dbb\u0db1\u0dca\u0db1",
    ta: "\u0baa\u0baf\u0ba9\u0bcd\u0baa\u0bbe\u0b9f\u0bcd\u0b9f\u0bc8\u0baa\u0bcd \u0baa\u0bc1\u0ba4\u0bc1\u0baa\u0bcd\u0baa\u0bbf\u0b95\u0bcd\u0b95\u0bb5\u0bc1\u0bae\u0bcd",
  },
  "Regular Diesel": {
    si: "\u0dc3\u0dcf\u0db8\u0dcf\u0db1\u0dca\u200d\u0dba \u0da9\u0dd3\u0dc3\u0dbd\u0dca",
    ta: "\u0bb5\u0bb4\u0b95\u0bcd\u0b95\u0bae\u0bbe\u0ba9 \u0b9f\u0bc0\u0b9a\u0bb2\u0bcd",
  },
  "Regular Diesel only": {
    si: "\u0dc3\u0dcf\u0db8\u0dcf\u0db1\u0dca\u200d\u0dba \u0da9\u0dd3\u0dc3\u0dbd\u0dca \u0db4\u0db8\u0dab\u0dd2",
    ta: "\u0bb5\u0bb4\u0b95\u0bcd\u0b95\u0bae\u0bbe\u0ba9 \u0b9f\u0bc0\u0b9a\u0bb2\u0bcd \u0bae\u0b9f\u0bcd\u0b9f\u0bc1\u0bae\u0bc7",
  },
  "Rest-stop Area, Southern Expy, Welipenna": {
    si: "\u0dc0\u0dd2\u0dc0\u0dda\u0d9a \u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba, \u0daf\u0d9a\u0dd4\u0dab\u0dd4 \u0d91\u0d9a\u0dca\u0dc3\u0dca\u0db4\u0dd3, \u0dc0\u0dd0\u0dbd\u0dd2\u0db4\u0dd0\u0db1\u0dca\u0db1",
    ta: "\u0b93\u0baf\u0bcd\u0bb5\u0bc1-\u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0baa\u0bcd \u0baa\u0b95\u0bc1\u0ba4\u0bbf, \u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1 \u0b8e\u0b95\u0bcd\u0bb8\u0bcd\u0baa\u0bbf, \u0bb5\u0bc6\u0bb2\u0bbf\u0baa\u0bc6\u0ba9\u0bcd\u0ba9",
  },
  Rideegama: {
    si: "\u0dbb\u0dd2\u0daf\u0dd3\u0d9c\u0db8",
    ta: "\u0bb0\u0bbf\u0ba4\u0bc0\u0b95\u0bae",
  },
  Rideethenna: {
    si: "\u0dbb\u0dd2\u0daf\u0dd3\u0dad\u0dd0\u0db1\u0dca\u0db1",
    ta: "\u0bb0\u0bbf\u0ba4\u0bc0\u0ba4\u0bc6\u0ba9\u0bcd\u0ba9",
  },
  Rikillagaskada: {
    si: "\u0dbb\u0dd2\u0d9a\u0dd2\u0dbd\u0dca\u0dbd\u0d9c\u0dc3\u0dca\u0d9a\u0da9",
    ta: "\u0bb0\u0bbf\u0b95\u0bbf\u0bb2\u0bcd\u0bb2\u0b95\u0bb8\u0bcd\u0b95\u0b9f",
  },
  "Riverside Rd, Ratnapura": {
    si: "\u0dbb\u0dd2\u0dc0\u0dbb\u0dca\u0dc3\u0dba\u0dd2\u0da9\u0dca \u0db4\u0dcf\u0dbb, \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb",
    ta: "\u0bb0\u0bbf\u0bb5\u0bb0\u0bcd\u0b9a\u0bc8\u0b9f\u0bc1 \u0bb0\u0bcb\u0b9f\u0bc1, \u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf",
  },
  "Road, Yatiyanthota": {
    si: "\u0db4\u0dcf\u0dbb, \u0dba\u0da7\u0dd2\u0dba\u0db1\u0dca\u0dad\u0ddc\u0da7",
    ta: "\u0bb5\u0bc0\u0ba4\u0bbf, \u0baf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8",
  },
  "S & D ENTERPRISES": {
    si: "S & D \u0dc0\u0dca\u0dba\u0dc0\u0dc3\u0dcf\u0dba\u0db1\u0dca",
    ta: "\u0b8e\u0bb8\u0bcd & \u0b9f\u0bbf \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "S & J FUEL DISTRIBUTORS": {
    si: "S & J \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db6\u0dd9\u0daf\u0dcf\u0dc4\u0dbb\u0dd2\u0db1\u0dca\u0db1\u0db1\u0dca",
    ta: "S & J \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0bb5\u0bbf\u0ba8\u0bbf\u0baf\u0bcb\u0b95\u0bb8\u0bcd\u0ba4\u0bb0\u0bcd\u0b95\u0bb3\u0bcd",
  },
  "S A C P SURAWEERA": {
    si: "\u0d91\u0dc3\u0dca \u0d92 \u0dc3\u0dd3 \u0db4\u0dd3 \u0dc3\u0dd4\u0dbb\u0dc0\u0dd3\u0dbb",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8f \u0b9a\u0bbf \u0baa\u0bbf \u0b9a\u0bc1\u0bb0\u0bb5\u0bc0\u0bb0",
  },
  "S A KULAWARDANA": {
    si: "\u0d91\u0dc3\u0dca \u0d92 \u0d9a\u0dd4\u0dbd\u0dc0\u0dbb\u0dca\u0db0\u0db1",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8f \u0b95\u0bc1\u0bb2\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0bbe",
  },
  "S A L SOLANGAARACHCHI": {
    si: "\u0d91\u0dc3\u0dca \u0d92 \u0d91\u0dbd\u0dca \u0dc3\u0ddd\u0dbd\u0d82\u0d9c\u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8f \u0b8e\u0bb2\u0bcd \u0b9a\u0bcb\u0bb2\u0b99\u0bcd\u0b95\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf",
  },
  "S A M A JAYAWANSA": {
    si: "S A M A JAYAWANSA",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8f \u0b8e\u0bae\u0bcd \u0b8f \u0b9c\u0bc6\u0baf\u0bb5\u0ba9\u0bcd\u0b9a",
  },
  "S A P H SUBASINGHA": {
    si: "\u0d91\u0dc3\u0dca \u0d92 \u0db4\u0dd3 \u0d91\u0da0\u0dca \u0dc3\u0dd4\u0db6\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8f \u0baa\u0bbf \u0b8e\u0b9a\u0bcd \u0b9a\u0bc1\u0baa\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "S A P.PREMADASA": {
    si: "\u0d91\u0dc3\u0dca \u0d92 \u0db4\u0dd3 \u0db4\u0dca\u200d\u0dbb\u0dda\u0db8\u0daf\u0dcf\u0dc3",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8f \u0baa\u0bbf.\u0baa\u0bbf\u0bb0\u0bc7\u0bae\u0ba4\u0bbe\u0b9a\u0bbe",
  },
  "S A SAMANTHA": {
    si: "\u0d91\u0dc3\u0dca \u0d92 \u0dc3\u0db8\u0db1\u0dca\u0dad",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8f \u0b9a\u0bae\u0ba8\u0bcd\u0ba4\u0bbe",
  },
  "S A SOMARATHNE & SONS (PVT) LTD": {
    si: "S A \u0dc3\u0ddd\u0db8\u0dbb\u0dad\u0dca\u0db1 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd (PVT) LTD",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8f \u0b9a\u0bcb\u0bae\u0bb0\u0ba4\u0bcd\u0ba9\u0bc7 & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "S A SOORIYARACHI": {
    si: "\u0d91\u0dc3\u0dca \u0d92 \u0dc3\u0dd6\u0dbb\u0dd2\u0dba\u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8f \u0b9a\u0bc2\u0bb0\u0bbf\u0baf\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf",
  },
  "S A.NIJAM": {
    si: "S A.NIJAM",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8f.\u0ba8\u0bbf\u0b9c\u0bbe\u0bae\u0bcd",
  },
  "S B M A BANDARANAYAKE": {
    si: "\u0d91\u0dc3\u0dca \u0db6\u0dd3 \u0d91\u0db8\u0dca \u0d92 \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b8e\u0bb8\u0bcd \u0baa\u0bbf \u0b8e\u0bae\u0bcd \u0b8f \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "S D P HOLDINGS (PVT) LTD": {
    si: "S D P HOLDINGS (PVT) LTD",
    ta: "\u0b8e\u0bb8\u0bcd \u0b9f\u0bbf \u0baa\u0bbf \u0bb9\u0bcb\u0bb2\u0bcd\u0b9f\u0bbf\u0b99\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "S D P N JEYASUNDARA": {
    si: "\u0d91\u0dc3\u0dca \u0da9\u0dd3 \u0db4\u0dd3 \u0d91\u0db1\u0dca \u0da2\u0dd9\u0dba\u0dc3\u0dd4\u0db1\u0dca\u0daf\u0dbb",
    ta: "\u0b8e\u0bb8\u0bcd \u0b9f\u0bbf \u0baa\u0bbf \u0b8e\u0ba9\u0bcd \u0b9c\u0bc6\u0baf\u0b9a\u0bc1\u0ba8\u0bcd\u0ba4\u0bb0\u0bbe",
  },
  "S DHEERASEKARA": {
    si: "\u0d91\u0dc3\u0dca \u0db0\u0dd3\u0dbb\u0dc3\u0dda\u0d9a\u0dbb",
    ta: "\u0b8e\u0bb8\u0bcd \u0ba4\u0bc0\u0bb0\u0b9a\u0bc7\u0b95\u0bb0",
  },
  "S GOBIKRISHNA": {
    si: "\u0d91\u0dc3\u0dca \u0d9c\u0ddd\u0db6\u0dd2\u0d9a\u0dca\u200d\u0dbb\u0dd2\u0dc2\u0dca\u0dab",
    ta: "\u0b8e\u0bb8\u0bcd \u0b95\u0bcb\u0baa\u0bbf\u0b95\u0bbf\u0bb0\u0bc1\u0bb7\u0bcd\u0ba3\u0bbe",
  },
  "S H ANUSHKA SAMARANAYAKE": {
    si: "\u0d91\u0dc3\u0dca \u0d91\u0da0\u0dca \u0d85\u0db1\u0dd4\u0dc2\u0dca\u0d9a\u0dcf \u0dc3\u0db8\u0dbb\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8e\u0b9a\u0bcd \u0b85\u0ba9\u0bc1\u0bb7\u0bcd\u0b95\u0bbe \u0b9a\u0bae\u0bb0\u0ba8\u0bbe\u0baf\u0b95\u0bc7",
  },
  "S H KANDAMBI": {
    si: "\u0d91\u0dc3\u0dca \u0d91\u0da0\u0dca \u0d9a\u0dab\u0dca\u0da9\u0db8\u0dca\u0db6\u0dd2",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8e\u0b9a\u0bcd \u0b95\u0ba3\u0bcd\u0b9f\u0bae\u0bcd\u0baa\u0bbf",
  },
  "S H M JAFRIS": {
    si: "\u0d91\u0dc3\u0dca \u0d91\u0da0\u0dca \u0d91\u0db8\u0dca \u0da2\u0dc6\u0dca\u0dbb\u0dd2\u0dc3\u0dca",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8e\u0b9a\u0bcd \u0b8e\u0bae\u0bcd \u0b9c\u0bbe\u0b83\u0baa\u0bcd\u0bb0\u0bbf\u0bb8\u0bcd",
  },
  "S H M.JAFRIS": {
    si: "\u0d91\u0dc3\u0dca \u0d91\u0da0\u0dca \u0d91\u0db8\u0dca.\u0da2\u0dc6\u0dca\u0dbb\u0dd2\u0dc3\u0dca",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8e\u0b9a\u0bcd \u0b8e\u0bae\u0bcd.\u0b9c\u0bbe\u0b83\u0baa\u0bcd\u0bb0\u0bbf\u0bb8\u0bcd",
  },
  "S K G K  GUNARATHNA": {
    si: "\u0d91\u0dc3\u0dca \u0d9a\u0dda \u0da2\u0dd3 \u0d9a\u0dda \u0d9c\u0dd4\u0dab\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b8e\u0bb8\u0bcd \u0b95\u0bc7 \u0b9c\u0bbf \u0b95\u0bc7 \u0b95\u0bc1\u0ba3\u0bb0\u0ba4\u0bcd\u0ba9\u0bbe",
  },
  "S K.CHANDRALAL JAYAKUMARA": {
    si: "\u0d91\u0dc3\u0dca \u0d9a\u0dda \u0da0\u0db1\u0dca\u0daf\u0dca\u200d\u0dbb\u0dbd\u0dcf\u0dbd\u0dca \u0da2\u0dba\u0d9a\u0dd4\u0db8\u0dcf\u0dbb",
    ta: "\u0b8e\u0bb8\u0bcd \u0b95\u0bc7.\u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0bb2\u0bbe\u0bb2\u0bcd \u0b9c\u0baf\u0b95\u0bc1\u0bae\u0bbe\u0bb0",
  },
  "S L C M FEDERATION LTD": {
    si: "S L C M FEDERATION LTD",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8e\u0bb2\u0bcd \u0b9a\u0bbf \u0b8e\u0bae\u0bcd \u0b83\u0baa\u0bc6\u0b9f\u0bb0\u0bc7\u0bb7\u0ba9\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "S L WASANTHA": {
    si: "\u0d91\u0dc3\u0dca \u0d91\u0dbd\u0dca \u0dc0\u0dc3\u0db1\u0dca\u0dad",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8e\u0bb2\u0bcd \u0bb5\u0b9a\u0ba8\u0bcd\u0ba4\u0bbe",
  },
  "S LALITH PERERA": {
    si: "\u0d91\u0dc3\u0dca \u0dbd\u0dbd\u0dd2\u0dad\u0dca \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b8e\u0bb8\u0bcd \u0bb2\u0bb2\u0bbf\u0ba4\u0bcd \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "S M D M SAMARAKOON & SONS": {
    si: "\u0d91\u0dc3\u0dca \u0d91\u0db8\u0dca \u0da9\u0dd3 \u0d91\u0db8\u0dca \u0dc3\u0db8\u0dbb\u0d9a\u0ddd\u0db1\u0dca \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8e\u0bae\u0bcd \u0b9f\u0bbf \u0b8e\u0bae\u0bcd \u0b9a\u0bae\u0bb0\u0b95\u0bcb\u0ba9\u0bcd & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "S M J B KULARATHNA": {
    si: "\u0d91\u0dc3\u0dca \u0d91\u0db8\u0dca \u0da2\u0dda \u0db6\u0dd3 \u0d9a\u0dd4\u0dbd\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8e\u0bae\u0bcd \u0b9c\u0bc7 \u0baa\u0bbf \u0b95\u0bc1\u0bb2\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "S M R SENAVIRATNE": {
    si: "\u0d91\u0dc3\u0dca \u0d91\u0db8\u0dca \u0d86\u0dbb\u0dca \u0dc3\u0dd9\u0db1\u0dc0\u0dd2\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8e\u0bae\u0bcd \u0b86\u0bb0\u0bcd \u0b9a\u0bc7\u0ba9\u0bb5\u0bbf\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "S M WASANTHA PUSHPA KUMARA": {
    si: "\u0d91\u0dc3\u0dca \u0d91\u0db8\u0dca \u0dc0\u0dc3\u0db1\u0dca\u0dad \u0db4\u0dd4\u0dc2\u0dca\u0db4 \u0d9a\u0dd4\u0db8\u0dcf\u0dbb",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8e\u0bae\u0bcd \u0bb5\u0b9a\u0ba8\u0bcd\u0ba4 \u0baa\u0bc1\u0bb7\u0bcd\u0baa \u0b95\u0bc1\u0bae\u0bbe\u0bb0",
  },
  "S N JAYASINGHE": {
    si: "\u0d91\u0dc3\u0dca \u0d91\u0db1\u0dca \u0da2\u0dba\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8e\u0ba9\u0bcd \u0b9c\u0bc6\u0baf\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "S N KANDANAARACHCHI": {
    si: "\u0d91\u0dc3\u0dca \u0d91\u0db1\u0dca \u0d9a\u0db3\u0db1\u0dcf\u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8e\u0ba9\u0bcd \u0b95\u0ba8\u0bcd\u0ba4\u0ba9\u0bbe\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf",
  },
  "S P GUNASINGHE": {
    si: "\u0d91\u0dc3\u0dca \u0db4\u0dd3 \u0d9c\u0dd4\u0dab\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b8e\u0bb8\u0bcd \u0baa\u0bbf \u0b95\u0bc1\u0ba3\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "S P INDHANA PIRAUMHALA": {
    si: "\u0d91\u0dc3\u0dca \u0db4\u0dd3 \u0d89\u0db1\u0dca\u0daf\u0db1 \u0db4\u0dd2\u0dbb\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b8e\u0bb8\u0bcd \u0baa\u0bbf \u0b87\u0ba8\u0bcd\u0ba4\u0ba9\u0bbe \u0baa\u0bbf\u0bb1\u0bb5\u0bc1\u0bae\u0bcd\u0bb9\u0bbe\u0bb2\u0bbe",
  },
  "S P M  S PATHIRAJA": {
    si: "\u0d91\u0dc3\u0dca \u0db4\u0dd3 \u0d91\u0db8\u0dca \u0d91\u0dc3\u0dca \u0db4\u0dad\u0dd2\u0dbb\u0dcf\u0da2",
    ta: "\u0b8e\u0bb8\u0bcd.\u0baa\u0bbf.\u0b8e\u0bae\u0bcd.\u0b8e\u0bb8\u0bcd.\u0baa\u0ba4\u0bbf\u0bb0\u0bbe\u0b9c\u0bbe",
  },
  "S R B ENTERPRISES": {
    si: "\u0d91\u0dc3\u0dca \u0d86\u0dbb\u0dca \u0db6\u0dd3 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b8e\u0bb8\u0bcd \u0b86\u0bb0\u0bcd \u0baa\u0bbf \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "S S BANDARA": {
    si: "\u0d91\u0dc3\u0dca \u0d91\u0dc3\u0dca \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8e\u0bb8\u0bcd \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0",
  },
  "S S FILLING STATION": {
    si: "S S \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8e\u0bb8\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "S S FILLING STATIONS (PVT) LTD": {
    si: "S S \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd\u0dca (PVT) LTD",
    ta: "S S \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0b99\u0bcd\u0b95\u0bb3\u0bcd (PVT) LTD",
  },
  "S S N DE SILVA": {
    si: "\u0d91\u0dc3\u0dca \u0d91\u0dc3\u0dca \u0d91\u0db1\u0dca \u0daf \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf",
    ta: "\u0b8e\u0bb8\u0bcd \u0b8e\u0bb8\u0bcd \u0b8e\u0ba9\u0bcd \u0b9f\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe",
  },
  "S S W FILLING STATION": {
    si: "S S W \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "S S W \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "S SAHA S PETROLEUM TRADERS": {
    si: "\u0d91\u0dc3\u0dca \u0dc3\u0dc4\u0dcf \u0d91\u0dc3\u0dca \u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0ddd\u0dbd\u0dd2\u0dba\u0db8\u0dca \u0da7\u0dca\u200d\u0dbb\u0dda\u0da9\u0dbb\u0dca\u0dc3\u0dca",
    ta: "\u0b8e\u0bb8\u0bcd \u0b9a\u0bb9\u0bbe \u0b8e\u0bb8\u0bcd \u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bbf\u0baf\u0bae\u0bcd \u0b9f\u0bbf\u0bb0\u0bc7\u0b9f\u0bb0\u0bcd\u0bb8\u0bcd",
  },
  "S SEPALA": {
    si: "\u0d91\u0dc3\u0dca \u0dc3\u0dda\u0db4\u0dcf\u0dbd",
    ta: "\u0b8e\u0bb8\u0bcd \u0b9a\u0bc6\u0baa\u0bbe\u0bb2\u0bbe",
  },
  "S SUTHERSHAN": {
    si: "\u0d91\u0dc3\u0dca \u0dc3\u0dd4\u0daf\u0dbb\u0dca\u0dc2\u0db1\u0dca",
    ta: "\u0b8e\u0bb8\u0bcd \u0b9a\u0bc1\u0ba4\u0bb0\u0bcd\u0bb7\u0ba9\u0bcd",
  },
  "S T S RANASINGHA": {
    si: "\u0d91\u0dc3\u0dca \u0da7\u0dd3 \u0d91\u0dc3\u0dca \u0dbb\u0dab\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b8e\u0bb8\u0bcd \u0b9f\u0bbf \u0b8e\u0bb8\u0bcd \u0bb0\u0ba3\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "S THARMAVARATHAN": {
    si: "\u0d91\u0dc3\u0dca \u0dad\u0dbb\u0dca\u0db8\u0dc0\u0dbb\u0dad\u0db1\u0dca",
    ta: "\u0b8e\u0bb8\u0bcd \u0ba4\u0bb0\u0bcd\u0bae\u0bb5\u0bb0\u0ba4\u0ba9\u0bcd",
  },
  "S. ANTON": {
    si: "\u0d91\u0dc3\u0dca \u0d87\u0db1\u0dca\u0da7\u0db1\u0dca",
    ta: "\u0b8e\u0bb8\u0bcd. \u0b86\u0ba3\u0bcd\u0b9f\u0ba9\u0bcd",
  },
  "S.A. M.BADURDEEN": {
    si: "\u0d91\u0dc3\u0dca.\u0d92.\u0d91\u0db8\u0dca.\u0db6\u0daf\u0dd4\u0dbb\u0dca\u0daf\u0dd3\u0db1\u0dca",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b8f.\u0b8e\u0bae\u0bcd.\u0baa\u0ba4\u0bc1\u0bb0\u0bcd\u0ba4\u0bc0\u0ba9\u0bcd",
  },
  "S.A.A.N.PERERA": {
    si: "S.A.A.N.\u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b8f.\u0b8e\u0ba9\u0bcd.\u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "S.A.D.C.SAMANTHA": {
    si: "S.A.D.C.\u0dc3\u0db8\u0db1\u0dca\u0dad",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b8f.\u0b9f\u0bbf.\u0b9a\u0bbf.\u0b9a\u0bae\u0ba8\u0bcd\u0ba4\u0bbe",
  },
  "S.A.NUSRATH ALI": {
    si: "\u0d91\u0dc3\u0dca.\u0d92.\u0db1\u0dd4\u0dc3\u0dca\u0dbb\u0dad\u0dca \u0d85\u0dbd\u0dd2",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b8f.\u0ba8\u0bc1\u0bb8\u0bcd\u0bb0\u0ba4\u0bcd \u0b85\u0bb2\u0bbf",
  },
  "S.A.P.PERERA & SON": {
    si: "\u0d91\u0dc3\u0dca.\u0d92.\u0db4\u0dd3.\u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dcf",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b8f.\u0baa\u0bbf.\u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe & \u0bae\u0b95\u0ba9\u0bcd",
  },
  "S.A.SAMANTHA": {
    si: "\u0d91\u0dc3\u0dca.\u0d92.\u0dc3\u0db8\u0db1\u0dca\u0dad",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b8f.\u0b9a\u0bae\u0ba8\u0bcd\u0ba4\u0bbe",
  },
  "S.A.SAREENA & S.A.SAMEENA  MRS.": {
    si: "S.A.SREENA \u0dc3\u0dc4 S.A.SAMEENA \u0db8\u0dc4\u0dad\u0dca\u0db8\u0dd2\u0dba.",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b8f.\u0b9a\u0bb0\u0bc0\u0ba9\u0bbe & \u0b8e\u0bb8\u0bcd.\u0b8f.\u0b9a\u0bae\u0bc0\u0ba9\u0bbe \u0ba4\u0bbf\u0bb0\u0bc1\u0bae\u0ba4\u0bbf.",
  },
  "S.A.SIRIPALA TEL PIRAWUMHALA": {
    si: "S.A.\u0dc3\u0dd2\u0dbb\u0dd2\u0db4\u0dcf\u0dbd TEL \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b8f.\u0b9a\u0bbf\u0bb1\u0bbf\u0baa\u0bbe\u0bb2 \u0b9f\u0bc6\u0bb2\u0bcd \u0baa\u0bbf\u0bb1\u0bb5\u0bc1\u0bae\u0bcd\u0bb9\u0bbe\u0bb2\u0bbe",
  },
  "S.ABESOORIYA": {
    si: "\u0d91\u0dc3\u0dca.\u0d85\u0db6\u0dda\u0dc3\u0dd6\u0dbb\u0dd2\u0dba",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b85\u0baa\u0bc7\u0b9a\u0bc2\u0bb0\u0bbf\u0baf",
  },
  "S.ABEYSEKERA": {
    si: "\u0d91\u0dc3\u0dca.\u0d85\u0db6\u0dda\u0dc3\u0dda\u0d9a\u0dbb",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b85\u0baa\u0bc7\u0b9a\u0bc7\u0b95\u0bb0",
  },
  "S.BALASINGHE & COMPANY": {
    si: "\u0d91\u0dc3\u0dca.\u0db6\u0dcf\u0dbd\u0dc3\u0dd2\u0d82\u0dc4 \u0dc3\u0dc4 \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0b8e\u0bb8\u0bcd.\u0baa\u0bbe\u0bb2\u0b9a\u0bbf\u0b99\u0bcd\u0b95 & \u0ba8\u0bbf\u0bb1\u0bc1\u0bb5\u0ba9\u0bae\u0bcd",
  },
  "S.BATAGODA": {
    si: "S.BATAGODA",
    ta: "S.BATAGODA",
  },
  "S.BENJAMIN SILVA PULLE & SONS": {
    si: "S.BENJAMIN SILVA PULLE & Sons",
    ta: "\u0b8e\u0bb8\u0bcd.\u0baa\u0bc6\u0b9e\u0bcd\u0b9a\u0bae\u0bbf\u0ba9\u0bcd \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe \u0baa\u0bc1\u0bb2\u0bcd\u0bb2\u0bc7 & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "S.C.SIRIWARDENE": {
    si: "\u0d91\u0dc3\u0dca.\u0dc3\u0dd3.\u0dc3\u0dd2\u0dbb\u0dd2\u0dc0\u0dbb\u0dca\u0db0\u0db1",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b9a\u0bbf.\u0b9a\u0bbf\u0bb1\u0bbf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9",
  },
  "S.D.A.K.S.DASANAYAKA": {
    si: "\u0d91\u0dc3\u0dca.\u0da9\u0dd3.\u0d92.\u0d9a\u0dda.\u0d91\u0dc3\u0dca.\u0daf\u0dc3\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b9f\u0bbf.\u0b8f.\u0b95\u0bc7.\u0b8e\u0bb8\u0bcd.\u0ba4\u0bbe\u0b9a\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95",
  },
  "S.J K.PERERA": {
    si: "\u0d91\u0dc3\u0dca.\u0da2\u0dda.\u0d9a\u0dda.\u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b9c\u0bc7.\u0b95\u0bc7.\u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "S.JAGATH SAMARAWICKRAMA": {
    si: "\u0d91\u0dc3\u0dca.\u0da2\u0d9c\u0dad\u0dca \u0dc3\u0db8\u0dbb\u0dc0\u0dd2\u0d9a\u0dca\u200d\u0dbb\u0db8",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b9c\u0b95\u0ba4\u0bcd \u0b9a\u0bae\u0bb0\u0bb5\u0bbf\u0b95\u0bcd\u0bb0\u0bae",
  },
  "S.K.CADER": {
    si: "\u0d91\u0dc3\u0dca.\u0d9a\u0dda.\u0d9a\u0dda\u0da9\u0dbb\u0dca",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b95\u0bc7.\u0b95\u0bc7\u0b9f\u0bb0\u0bcd",
  },
  "S.K.GANESHANATHAN & SON": {
    si: "S.K.\u0d9c\u0dab\u0dda\u0dc2\u0db1\u0dcf\u0daf\u0db1\u0dca \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0dcf",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b95\u0bc7.\u0b95\u0ba3\u0bc7\u0b9a\u0ba8\u0bbe\u0ba4\u0ba9\u0bcd & \u0bae\u0b95\u0ba9\u0bcd",
  },
  "S.K.RAJAPAKSE": {
    si: "\u0d91\u0dc3\u0dca.\u0d9a\u0dda.\u0dbb\u0dcf\u0da2\u0db4\u0d9a\u0dca\u0dc2",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b95\u0bc7.\u0bb0\u0bbe\u0b9c\u0baa\u0b95\u0bcd\u0b9a\u0bc7",
  },
  "S.L.AHAMED LEBBE": {
    si: "\u0d91\u0dc3\u0dca.\u0d91\u0dbd\u0dca.\u0d85\u0dc4\u0db8\u0da9\u0dca \u0dbd\u0dd9\u0db6\u0dca\u0db6\u0dda",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b8e\u0bb2\u0bcd.\u0b85\u0bb9\u0bae\u0b9f\u0bcd \u0bb2\u0bc6\u0baa\u0bcd\u0baa\u0bc8",
  },
  "S.M.ANWAR": {
    si: "\u0d91\u0dc3\u0dca.\u0d91\u0db8\u0dca.\u0d85\u0db1\u0dca\u0dc0\u0dbb\u0dca",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b8e\u0bae\u0bcd.\u0b85\u0ba9\u0bcd\u0bb5\u0bb0\u0bcd",
  },
  "S.M.D.C.D.SENARATNE AND COMPANY": {
    si: "S.M.D.C.D.\u0dc3\u0dda\u0db1\u0dcf\u0dbb\u0dad\u0dca\u0db1 \u0dc3\u0dc4 \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b8e\u0bae\u0bcd.\u0b9f\u0bbf.\u0b9a\u0bbf.\u0b9f\u0bbf.\u0b9a\u0bc7\u0ba9\u0bbe\u0bb0\u0ba4\u0bcd\u0ba9 \u0bae\u0bb1\u0bcd\u0bb1\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb1\u0bc1\u0bb5\u0ba9\u0bae\u0bcd",
  },
  "S.M.FAROOK": {
    si: "\u0d91\u0dc3\u0dca.\u0d91\u0db8\u0dca.\u0dc6\u0dcf\u0dbb\u0dd4\u0d9a\u0dca",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b8e\u0bae\u0bcd.\u0b83\u0baa\u0bbe\u0bb0\u0bc2\u0b95\u0bcd",
  },
  "S.M.V.D.SAMARAKOON": {
    si: "\u0d91\u0dc3\u0dca.\u0d91\u0db8\u0dca.\u0dc0\u0dd3.\u0da9\u0dd3 \u0dc3\u0db8\u0dbb\u0d9a\u0ddd\u0db1\u0dca",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b8e\u0bae\u0bcd.\u0bb5\u0bbf.\u0b9f\u0bbf.\u0b9a\u0bae\u0bb0\u0b95\u0bcb\u0ba9\u0bcd",
  },
  "S.MANICKARAJAH": {
    si: "\u0d91\u0dc3\u0dca.\u0db8\u0dab\u0dd2\u0d9a\u0dca\u0d9a\u0dbb\u0dcf\u0da2\u0dcf",
    ta: "\u0b8e\u0bb8\u0bcd.\u0bae\u0bbe\u0ba3\u0bbf\u0b95\u0bcd\u0b95\u0bb0\u0bbe\u0b9c\u0bbe",
  },
  "S.NAGENDRAN": {
    si: "\u0d91\u0dc3\u0dca.\u0db1\u0dcf\u0d9c\u0dda\u0db1\u0dca\u0daf\u0dca\u200d\u0dbb\u0db1\u0dca",
    ta: "\u0b8e\u0bb8\u0bcd.\u0ba8\u0bbe\u0b95\u0bc7\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0ba9\u0bcd",
  },
  "S.P.L.HETTIARACHCHI": {
    si: "\u0d91\u0dc3\u0dca.\u0db4\u0dd3.\u0d91\u0dbd\u0dca.\u0dc4\u0dd9\u0da7\u0dca\u0da7\u0dd2\u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2",
    ta: "\u0b8e\u0bb8\u0bcd.\u0baa\u0bbf.\u0b8e\u0bb2\u0bcd.\u0bb9\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0bbe\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf",
  },
  "S.P.LANKA PETROLEUM (PVT) LTD": {
    si: "S.P.LANKA PETROLEUM (PVT) LTD",
    ta: "\u0b8e\u0bb8\u0bcd.\u0baa\u0bbf.\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bbf\u0baf\u0bae\u0bcd (\u0baa\u0bbf.\u0bb5\u0bbf.\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "S.P.PERAMUNAGAMA": {
    si: "\u0d91\u0dc3\u0dca.\u0db4\u0dd3.\u0db4\u0dd9\u0dbb\u0db8\u0dd4\u0dab\u0d9c\u0db8",
    ta: "\u0b8e\u0bb8\u0bcd.\u0baa\u0bbf.\u0baa\u0bc6\u0bb0\u0bae\u0bc1\u0ba9\u0b95\u0bae",
  },
  "S.R.B.TRADES": {
    si: "S.R.B.TRADES",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b86\u0bb0\u0bcd.\u0baa\u0bbf.\u0b9f\u0bbf\u0bb0\u0bc7\u0b9f\u0bcd\u0bb8\u0bcd",
  },
  "S.R.DINAMITHRA": {
    si: "\u0d91\u0dc3\u0dca.\u0d86\u0dbb\u0dca.\u0daf\u0dd2\u0db1\u0db8\u0dd2\u0dad\u0dca\u200d\u0dbb",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b86\u0bb0\u0bcd.\u0ba4\u0bbf\u0ba9\u0bae\u0bbf\u0ba4\u0bcd\u0bb0\u0bbe",
  },
  "S.S.FILLING STATION ( PVT ) LTD": {
    si: "S.S.\u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca \u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) LTD",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b8e\u0bb8\u0bcd. \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd (\u0baa\u0bbf.\u0bb5\u0bbf.\u0b9f\u0bbf.) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "S.S.P.FENANDO": {
    si: "S.S.P.FENANDO",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b8e\u0bb8\u0bcd.\u0baa\u0bbf.\u0baa\u0bc6\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "S.SARAVANAPAVAN": {
    si: "\u0d91\u0dc3\u0dca.\u0dc3\u0dbb\u0dc0\u0db1\u0db4\u0dc0\u0db1\u0dca",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b9a\u0bb0\u0bb5\u0ba3\u0baa\u0bb5\u0ba9\u0bcd",
  },
  "S.T.P.R.DHARMALATHA": {
    si: "S.T.P.R.\u0db0\u0dbb\u0dca\u0db8\u0dbd\u0dad\u0dcf",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b9f\u0bbf.\u0baa\u0bbf.\u0b86\u0bb0\u0bcd.\u0ba4\u0bb0\u0bcd\u0bae\u0bb2\u0ba4\u0bbe",
  },
  "S.W.MOHOTTI": {
    si: "\u0d91\u0dc3\u0dca.\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0db8\u0ddc\u0dc4\u0ddc\u0da7\u0dca\u0da7\u0dd2",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0bae\u0bca\u0bb9\u0bca\u0b9f\u0bcd\u0b9f\u0bbf",
  },
  "SAGANA ENTERPRISES (PVT) LTD": {
    si: "SAGANA ENTERPRISES (PVT) LTD",
    ta: "\u0b9a\u0b95\u0bbe\u0ba9\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "SAHANA SEVA PETROLEUM (PVT) LTD": {
    si: "\u0dc3\u0dc4\u0db1 \u0dc3\u0dda\u0dc0\u0dcf \u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0ddd\u0dbd\u0dd2\u0dba\u0db8\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0b9a\u0bb9\u0bbe\u0ba9\u0bbe \u0b9a\u0bc7\u0bb5\u0bbe \u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bbf\u0baf\u0bae\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "SALAM &  SONS": {
    si: "\u0dc3\u0dbd\u0dcf\u0db8\u0dca \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b9a\u0bb2\u0bbe\u0bae\u0bcd & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "SAMAN ENTERPRISES": {
    si: "\u0dc3\u0db8\u0db1\u0dca \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b9a\u0bae\u0ba9\u0bcd \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "SAMANTHURAI PATTU MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dc3\u0db8\u0db1\u0dca\u0dad\u0dd4\u0dbb\u0dd9\u0dba\u0dd2 \u0db4\u0dad\u0dca\u0dad\u0dd4 MPCS",
    ta: "\u0b9a\u0bae\u0bcd\u0bae\u0bbe\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8 \u0baa\u0b9f\u0bcd\u0b9f\u0bc1 MPCS LTD",
  },
  "SAMARANAYAKA SAHA SAMARANAYAKA": {
    si: "\u0dc3\u0db8\u0dbb\u0db1\u0dcf\u0dba\u0d9a \u0dc3\u0dc4 \u0dc3\u0db8\u0dbb\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b9a\u0bae\u0bb0\u0ba8\u0bbe\u0baf\u0b95 \u0b9a\u0bb9\u0bbe \u0b9a\u0bae\u0bb0\u0ba8\u0bbe\u0baf\u0b95",
  },
  "SAMPATH ENTERPRISES": {
    si: "\u0dc3\u0db8\u0dca\u0db4\u0dad\u0dca \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b9a\u0bae\u0bcd\u0baa\u0ba4\u0bcd \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "SAMSE AUTO MART (PVT) LTD": {
    si: "SAMSE AUTO MART (PVT) LTD",
    ta: "SAMSE \u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0bae\u0bbe\u0bb0\u0bcd\u0b9f\u0bcd (PVT) LTD",
  },
  "SANDALANKAWA NEW MPCS LTD": {
    si: "Sandalankawa NEW MPCS LTD",
    ta: "\u0b9a\u0ba3\u0bcd\u0b9f\u0bb2\u0b99\u0bcd\u0b95\u0bbe\u0bb5 \u0baa\u0bc1\u0ba4\u0bbf\u0baf MPCS LTD",
  },
  "SANEK ENTERPRISES (PVT) LTD": {
    si: "SANEK ENTERPRISES (PVT) LTD",
    ta: "\u0b9a\u0ba9\u0bc7\u0b95\u0bcd \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "SAPTARA ENTERPRISES": {
    si: "\u0dc3\u0db4\u0dca\u0dad\u0dbb\u0dcf \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b9a\u0baa\u0bcd\u0ba4\u0bbe\u0bb0\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "SARADA ENTERPRISES": {
    si: "\u0dc3\u0dbb\u0daf\u0dcf \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b9a\u0bbe\u0bb0\u0ba4\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "SARANI ENTERPRISE PVT LTD": {
    si: "\u0dc3\u0dbb\u0db1\u0dd2 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dca \u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc0\u0da7\u0dca \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b9a\u0bb0\u0bbe\u0ba3\u0bbf \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0bb8\u0bcd \u0baa\u0bbf\u0bb0\u0bc8\u0bb5\u0bc7\u0b9f\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "SARATH MUNASINGHE FUEL MART": {
    si: "\u0dc3\u0dbb\u0dad\u0dca \u0db8\u0dd4\u0dab\u0dc3\u0dd2\u0d82\u0dc4 \u0d89\u0db1\u0dca\u0db0\u0db1 \u0dc0\u0dd9\u0dc5\u0db3 \u0dc3\u0d82\u0d9a\u0dd3\u0dbb\u0dca\u0dab\u0dba",
    ta: "\u0b9a\u0bb0\u0ba4\u0bcd \u200b\u200b\u0bae\u0bc1\u0ba9\u0b9a\u0bbf\u0b99\u0bcd\u0b95 \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0b9a\u0ba8\u0bcd\u0ba4\u0bc8",
  },
  "SAVINRO ENTERPRISES": {
    si: "\u0dc3\u0dc0\u0dd2\u0db1\u0dca\u0dbb\u0ddd \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b9a\u0bb5\u0bbf\u0ba9\u0bcd\u0bb0\u0bcb \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "SCAN LANKA": {
    si: "LANKA \u0dc3\u0dca\u0d9a\u0dd1\u0db1\u0dca \u0d9a\u0dbb\u0db1\u0dca\u0db1",
    ta: "\u0bb2\u0b99\u0bcd\u0b95\u0bbe\u0bb5\u0bc8 \u0bb8\u0bcd\u0b95\u0bc7\u0ba9\u0bcd \u0b9a\u0bc6\u0baf\u0bcd\u0baf\u0bb5\u0bc1\u0bae\u0bcd",
  },
  "SEALINE HOLDINGS LANKA FILLING STAT": {
    si: "\u0dc3\u0dd3\u0dbd\u0dba\u0dd2\u0db1\u0dca \u0dc4\u0ddd\u0dbd\u0dca\u0da9\u0dd2\u0d82\u0d9c\u0dca\u0dc3\u0dca \u0dbd\u0d82\u0d9a\u0dcf \u0dc6\u0dd2\u0dbd\u0dd2\u0db1\u0dca \u0dc3\u0dca\u0da7\u0dd0\u0da7\u0dca",
    ta: "\u0b9a\u0bc0\u0bb2\u0bc8\u0ba9\u0bcd \u0bb9\u0bcb\u0bb2\u0bcd\u0b9f\u0bbf\u0b99\u0bcd\u0bb8\u0bcd \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b83\u0baa\u0bbf\u0bb2\u0bcd\u0bb2\u0bbf\u0b99\u0bcd \u0bb8\u0bcd\u0b9f\u0bc7\u0b9f\u0bcd",
  },
  "SEETHA HOLDINGS ( PVT) LTD": {
    si: "\u0dc3\u0dd3\u0dad\u0dcf \u0dc4\u0ddd\u0dbd\u0dca\u0da9\u0dd2\u0db1\u0dca\u0d9c\u0dca\u0dc3\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0b9a\u0bc0\u0ba4\u0bbe \u0bb9\u0bcb\u0bb2\u0bcd\u0b9f\u0bbf\u0b99\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "SELLATHAMBY DILAXSHAN": {
    si: "\u0dc3\u0dd9\u0dbd\u0dca\u0dbd\u0dad\u0db8\u0dca\u0db6\u0dd2 \u0da9\u0dd2\u0dbd\u0d9a\u0dca\u0dc2\u0db1\u0dca",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb2\u0ba4\u0bcd\u0ba4\u0bae\u0bcd\u0baa\u0bbf \u0b9f\u0bbf\u0bb2\u0b95\u0bcd\u0bb7\u0ba9\u0bcd",
  },
  "SELLIAH UTHAYAKUMAR": {
    si: "\u0dc3\u0dd9\u0dbd\u0dca\u0dbd\u0dd2\u0dba\u0dcf \u0d8b\u0daf\u0dba\u0d9a\u0dd4\u0db8\u0dbb\u0dca",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb2\u0bc8\u0baf\u0bbe \u0b89\u0ba4\u0baf\u0b95\u0bc1\u0bae\u0bbe\u0bb0\u0bcd",
  },
  SELVARAJA: {
    si: "\u0dc3\u0dd9\u0dbd\u0dca\u0dc0\u0dbb\u0dcf\u0da2\u0dcf",
    ta: "\u0b9a\u0bc6\u0bb2\u0bcd\u0bb5\u0bb0\u0bbe\u0b9c\u0bbe",
  },
  "SENANAYAKE PIRAVUMPOLA": {
    si: "\u0dc3\u0dda\u0db1\u0dcf\u0db1\u0dcf\u0dba\u0d9a \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0db4\u0ddc\u0dbd",
    ta: "\u0b9a\u0bc7\u0ba9\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0baa\u0bbf\u0bb1\u0bb5\u0bc1\u0bae\u0bcd\u0baa\u0bca\u0bb2",
  },
  "SENAVIRATNA & SONS": {
    si: "\u0dc3\u0dda\u0db1\u0dcf\u0dc0\u0dd2\u0dbb\u0dad\u0dca\u0db1 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b9a\u0bc7\u0ba9\u0bb5\u0bbf\u0bb0\u0ba4\u0bcd\u0ba9\u0bbe & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "SERUWILA MPCS LTD": {
    si: "\u0dc3\u0dda\u0dbb\u0dd4\u0dc0\u0dd2\u0dbd MPCS LTD",
    ta: "\u0b9a\u0bc6\u0bb0\u0bc1\u0bb5\u0bbf\u0bb2 MPCS LTD",
  },
  "SEWANA LANKA FILLING STATION": {
    si: "\u0dc3\u0dd9\u0dc0\u0dab \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b9a\u0bc6\u0bb5\u0ba9 \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "SHAKTHI LANKA ENTERPRISES": {
    si: "\u0dc1\u0d9a\u0dca\u0dad\u0dd2 \u0dbd\u0d82\u0d9a\u0dcf \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b9a\u0b95\u0bcd\u0ba4\u0bbf \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "SHAKTHI LANKA OIL AND GAS (PVT) LTD": {
    si: "\u0dc1\u0d9a\u0dca\u0dad\u0dd2 \u0dbd\u0d82\u0d9a\u0dcf \u0d94\u0dba\u0dd2\u0dbd\u0dca \u0d87\u0db1\u0dca\u0da9\u0dca \u0d9c\u0dd1\u0dc3\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0b9a\u0b95\u0bcd\u0ba4\u0bbf \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b8e\u0ba3\u0bcd\u0ba3\u0bc6\u0baf\u0bcd \u0bae\u0bb1\u0bcd\u0bb1\u0bc1\u0bae\u0bcd \u0b8e\u0bb0\u0bbf\u0bb5\u0bbe\u0baf\u0bc1 (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "SHANMUGAM   ANANDARAJAH": {
    si: "\u0dc2\u0db1\u0dca\u0db8\u0dd4\u0d9c\u0db8\u0dca \u0d86\u0db1\u0db1\u0dca\u0daf\u0dbb\u0dcf\u0da2\u0dcf",
    ta: "\u0b9a\u0ba3\u0bcd\u0bae\u0bc1\u0b95\u0bae\u0bcd \u0b86\u0ba9\u0ba8\u0bcd\u0ba4\u0bb0\u0bbe\u0b9c\u0bbe",
  },
  "SHANTHA & COMPANY": {
    si: "\u0dc1\u0dcf\u0db1\u0dca\u0dad \u0dc3\u0dc4 \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0b9a\u0bbe\u0ba8\u0bcd\u0ba4\u0bbe & \u0ba8\u0bbf\u0bb1\u0bc1\u0bb5\u0ba9\u0bae\u0bcd",
  },
  "SHANTHI JAYAKODI (PVT) LTD": {
    si: "\u0dc1\u0dcf\u0db1\u0dca\u0dad\u0dd2 \u0da2\u0dba\u0d9a\u0ddc\u0da9\u0dd2 (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b9a\u0bbe\u0ba8\u0bcd\u0ba4\u0bbf \u0b9c\u0bc6\u0baf\u0b95\u0bcd\u0b95\u0bca\u0b9f\u0bbf (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "SHEHARA AUTO CARE CENTRE": {
    si: "\u0dc2\u0dd9\u0dc4\u0dcf\u0dbb\u0dcf \u0d94\u0da7\u0ddd \u0d9a\u0dd9\u0dba\u0dcf\u0dbb\u0dca \u0dc3\u0dd9\u0db1\u0dca\u0da7\u0dbb\u0dca",
    ta: "\u0bb7\u0bc6\u0bb9\u0bbe\u0bb0\u0bbe \u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0b95\u0bc7\u0bb0\u0bcd \u0b9a\u0bc6\u0ba9\u0bcd\u0b9f\u0bb0\u0bcd",
  },
  "SINDRATHI PIRAUMPOLA": {
    si: "\u0dc3\u0dd2\u0db1\u0dca\u0daf\u0dca\u200d\u0dbb\u0dad\u0dd2 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0db4\u0ddc\u0dbd",
    ta: "\u0b9a\u0bbf\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0bbe\u0ba4\u0bbf \u0baa\u0bbf\u0bb1\u0bb5\u0bc1\u0bae\u0bcd\u0baa\u0bca\u0bb2",
  },
  "SINGHE ASSCOCIATE": {
    si: "\u0dc3\u0dd2\u0d82\u0dc4 \u0d86\u0dc1\u0dca\u200d\u0dbb\u0dd2\u0dad",
    ta: "\u0b9a\u0bbf\u0b99\u0bcd\u0b95\u0bc7 \u0b85\u0b9a\u0bcb\u0b9a\u0bbf\u0baf\u0bc7\u0b9f\u0bcd",
  },
  "SINHA AUTO SERVICE (PVT) LTD.": {
    si: "\u0dc3\u0dd2\u0d82\u0dc4 \u0d94\u0da7\u0ddd \u0dc3\u0dbb\u0dca\u0dc0\u0dd2\u0dc3\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca.",
    ta: "\u0b9a\u0bbf\u0ba9\u0bcd\u0bb9\u0bbe \u200b\u200b\u0b86\u0b9f\u0bcd\u0b9f\u0bcb \u0b9a\u0bb0\u0bcd\u0bb5\u0bc0\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd.",
  },
  "SISIRA KODIKARA": {
    si: "\u0dc3\u0dd2\u0dc3\u0dd2\u0dbb \u0d9a\u0ddc\u0da9\u0dd2\u0d9a\u0dcf\u0dbb",
    ta: "\u0b9a\u0bbf\u0b9a\u0bbf\u0bb0 \u0b95\u0bca\u0b9f\u0bbf\u0b95\u0bbe\u0bb0",
  },
  "SISIRA TRADING COMPANY (PVT) LTD": {
    si: "SISIRA TRADING COMPANY (PVT) LTD",
    ta: "\u0b9a\u0bbf\u0b9a\u0bbf\u0bb0\u0bbe \u0b9f\u0bbf\u0bb0\u0bc7\u0b9f\u0bbf\u0b99\u0bcd \u0b95\u0bae\u0bcd\u0baa\u0bc6\u0ba9\u0bbf (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "SISIRI ENTERPRISES": {
    si: "\u0dc3\u0dd2\u0dbb\u0dd2 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b9a\u0bbf\u0b9a\u0bbf\u0bb0\u0bbf \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "SITHY LAILA AND  SONS": {
    si: "\u0dc3\u0dd2\u0dad\u0dd2 \u0dbd\u0dba\u0dd2\u0dbd\u0dcf \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b9a\u0bbf\u0ba4\u0bcd\u0ba4\u0bbf \u0bb2\u0bc8\u0bb2\u0bbe \u0bae\u0bb1\u0bcd\u0bb1\u0bc1\u0bae\u0bcd \u0bae\u0b95\u0ba9\u0bcd\u0b95\u0bb3\u0bcd",
  },
  "SIVA FILLING STATION": {
    si: "\u0dc3\u0dd2\u0dc0\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b9a\u0bbf\u0bb5\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "SIYAMBALANDUWA ETHIMALE MPCS LTD": {
    si: "\u0dc3\u0dd2\u0dba\u0db9\u0dbd\u0dcf\u0dab\u0dca\u0da9\u0dd4\u0dc0 \u0d87\u0dad\u0dd2\u0db8\u0dbd\u0dda MPCS LTD",
    ta: "\u0b9a\u0bbf\u0baf\u0bbe\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0ba3\u0bcd\u0b9f\u0bc1\u0bb5 \u0b8e\u0ba4\u0bbf\u0bae\u0bb2\u0bc7 MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "SKYLINE INTERNATIONAL (PVT) LTD": {
    si: "SKYLINE INTERNATIONAL (PVT) LTD",
    ta: "\u0bb8\u0bcd\u0b95\u0bc8\u0bb2\u0bc8\u0ba9\u0bcd \u0b87\u0ba9\u0bcd\u0b9f\u0bb0\u0bcd\u0ba8\u0bc7\u0bb7\u0ba9\u0bb2\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "SLIPTO AGENCIES": {
    si: "\u0dc3\u0dca\u0dbd\u0dd2\u0db4\u0dca\u0da7\u0ddd \u0d92\u0da2\u0db1\u0dca\u0dc3\u0dd2",
    ta: "\u0bb8\u0bcd\u0bb2\u0bbf\u0baa\u0bcd\u0b9f\u0bcb \u0b8f\u0b9c\u0bc6\u0ba9\u0bcd\u0b9a\u0bbf\u0b95\u0bb3\u0bcd",
  },
  "SLIPTO AGENCIES - SH": {
    si: "\u0dc3\u0dca\u0dbd\u0dd2\u0db4\u0dca\u0da7\u0ddd \u0d92\u0da2\u0db1\u0dca\u0dc3\u0dd2 - \u0d91\u0dc3\u0dca.\u0d91\u0da0\u0dca",
    ta: "SLIPTO \u0b8f\u0b9c\u0bc6\u0ba9\u0bcd\u0b9a\u0bbf\u0b95\u0bb3\u0bcd - SH",
  },
  "SLIPTO AGENCIES PVT LTD": {
    si: "SLIPTO AGENCIES PVT LTD",
    ta: "\u0bb8\u0bcd\u0bb2\u0bbf\u0baa\u0bcd\u0b9f\u0bcb \u0b8f\u0b9c\u0bc6\u0ba9\u0bcd\u0b9a\u0bbf\u0bb8\u0bcd \u0baa\u0bbf\u0bb0\u0bc8\u0bb5\u0bc7\u0b9f\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "SOMA EDIRISINGHE": {
    si: "\u0dc3\u0ddd\u0db8\u0dcf \u0d91\u0daf\u0dd2\u0dbb\u0dd2\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b9a\u0bcb\u0bae \u0b8e\u0ba4\u0bbf\u0bb0\u0bbf\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "SOORAYA LANKA PIRAVUMHALA": {
    si: "\u0dc3\u0dd6\u0dbb\u0dd2\u0dba \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b9a\u0bc2\u0bb0\u0baf \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0baa\u0bbf\u0bb1\u0bb5\u0bc1\u0bae\u0bcd\u0bb9\u0bbe\u0bb2\u0bbe",
  },
  "SOUTHERN PETROLEUM (PVT) LTD - 7": {
    si: "\u0dc3\u0daf\u0dbb\u0dca\u0db1\u0dca \u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0ddd\u0dbd\u0dd2\u0dba\u0db8\u0dca (\u0db4\u0dde\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca - 7",
    ta: "\u0b9a\u0ba4\u0bb0\u0bcd\u0ba9\u0bcd \u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bbf\u0baf\u0bae\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd - 7",
  },
  "SOUTHERN PETROLEUM (PVT) LTD -3": {
    si: "\u0dc3\u0daf\u0dbb\u0dca\u0db1\u0dca \u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0ddd\u0dbd\u0dd2\u0dba\u0db8\u0dca (\u0db4\u0dde\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca -3",
    ta: "\u0b9a\u0ba4\u0bb0\u0bcd\u0ba9\u0bcd \u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bbf\u0baf\u0bae\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd -3",
  },
  "SOUTHERN PETROLEUM (PVT) LTD-2": {
    si: "\u0dc3\u0daf\u0dbb\u0dca\u0db1\u0dca \u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0ddd\u0dbd\u0dd2\u0dba\u0db8\u0dca (\u0db4\u0dde\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca-2",
    ta: "\u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1 \u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bbf\u0baf\u0bae\u0bcd (PVT) LTD-2",
  },
  "SRI JAYEWARDENEPURA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1\u0db4\u0dd4\u0dbb MPCS",
    ta: "\u0bb8\u0bcd\u0bb0\u0bc0 \u0b9c\u0bc6\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0bc7\u0baa\u0bc1\u0bb0\u0bbe \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0b9a\u0bbf\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "SRI LANKA AIR FORCE SERVICE INSTITU": {
    si: "\u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf \u0d9c\u0dd4\u0dc0\u0db1\u0dca \u0dc4\u0db8\u0dd4\u0daf\u0dcf \u0dc3\u0dda\u0dc0\u0dcf \u0d86\u0dba\u0dad\u0db1\u0dba",
    ta: "\u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8 \u0bb5\u0bbf\u0bae\u0bbe\u0ba9\u0baa\u0bcd\u0baa\u0b9f\u0bc8 \u0b9a\u0bc7\u0bb5\u0bc8 \u0ba8\u0bbf\u0bb1\u0bc1\u0bb5\u0ba9\u0bae\u0bcd",
  },
  "SRI LANKA CO-OP MKTG. FEDERATION LT": {
    si: "\u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf \u0dc3\u0db8\u0dd4\u0db4\u0d9a\u0dcf\u0dbb \u0d91\u0db8\u0dca.\u0d9a\u0dda.\u0da7\u0dd3.\u0da2\u0dd3. \u0dc6\u0dd9\u0da9\u0dbb\u0dda\u0dc2\u0db1\u0dca LT",
    ta: "\u0bb8\u0bcd\u0bb0\u0bc0\u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b95\u0bc2\u0b9f\u0bcd\u0b9f\u0bc1\u0bb1\u0bb5\u0bc1 \u0b8e\u0bae\u0bcd.\u0b95\u0bc7.\u0b9f\u0bbf.\u0b9c\u0bbf. \u0b95\u0bc2\u0b9f\u0bcd\u0b9f\u0bae\u0bc8\u0baa\u0bcd\u0baa\u0bc1 \u0b8e\u0bb2\u0bcd.\u0b9f\u0bbf",
  },
  "SRI LANKA FISHERY HARBOURS CORP.": {
    si: "\u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf \u0db0\u0dd3\u0dc0\u0dbb \u0dc0\u0dbb\u0dcf\u0dba \u0dc3\u0d82\u0dc3\u0dca\u0dae\u0dcf\u0dc0.",
    ta: "\u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8 \u0bae\u0bc0\u0ba9\u0bcd\u0baa\u0bbf\u0b9f\u0bbf\u0ba4\u0bcd \u0ba4\u0bc1\u0bb1\u0bc8\u0bae\u0bc1\u0b95\u0b95\u0bcd \u0b95\u0bb4\u0b95\u0bae\u0bcd.",
  },
  "SRI LANKA NAVY WELFARE DIVISION": {
    si: "\u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf \u0db1\u0dcf\u0dc0\u0dd2\u0d9a \u0dc4\u0db8\u0dd4\u0daf\u0dcf\u0dc0\u0dda \u0dc3\u0dd4\u0db7\u0dc3\u0dcf\u0db0\u0db1 \u0d85\u0d82\u0dc1\u0dba",
    ta: "\u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8 \u0b95\u0b9f\u0bb1\u0bcd\u0baa\u0b9f\u0bc8\u0baf\u0bbf\u0ba9\u0bcd \u0ba8\u0bb2\u0ba9\u0bcd\u0baa\u0bc1\u0bb0\u0bbf \u0baa\u0bbf\u0bb0\u0bbf\u0bb5\u0bc1",
  },
  "SRI LANKA RED CROSS SOCIETY": {
    si: "\u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf \u0dbb\u0dad\u0dd4 \u0d9a\u0dd4\u0dbb\u0dd4\u0dc3 \u0dc3\u0d82\u0d9c\u0db8\u0dba",
    ta: "\u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8 \u0b9a\u0bc6\u0b9e\u0bcd\u0b9a\u0bbf\u0bb2\u0bc1\u0bb5\u0bc8 \u0b9a\u0b99\u0bcd\u0b95\u0bae\u0bcd",
  },
  "SRI LUXMI NARAYANA PERUMAL FOUNDATI": {
    si: "\u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d9a\u0dca\u0dc3\u0dca\u0db8\u0dd2 \u0db1\u0dcf\u0dbb\u0dcf\u0dba\u0db1 \u0db4\u0dd9\u0dbb\u0dd4\u0db8\u0dcf\u0dbd\u0dca \u0db4\u0daf\u0db1\u0db8",
    ta: "\u0bb8\u0bcd\u0bb0\u0bc0 \u0bb2\u0b95\u0bcd\u0bb7\u0bcd\u0bae\u0bbf \u0ba8\u0bbe\u0bb0\u0bbe\u0baf\u0ba3 \u0baa\u0bc6\u0bb0\u0bc1\u0bae\u0bbe\u0bb3\u0bcd \u0baa\u0bb5\u0bc1\u0ba3\u0bcd\u0b9f\u0b9f\u0bbf",
  },
  "SRITHARAN CONSTRUCTION": {
    si: "\u0dc1\u0dca\u200d\u0dbb\u0dd3\u0daf\u0dbb\u0db1\u0dca \u0d89\u0daf\u0dd2\u0d9a\u0dd2\u0dbb\u0dd3\u0db8",
    ta: "\u0bb8\u0bcd\u0bb0\u0bc0\u0ba4\u0bb0\u0ba9\u0bcd \u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0bae\u0bbe\u0ba9\u0bae\u0bcd",
  },
  "SS KOTALAWALA P LTD": {
    si: "\u0d91\u0dc3\u0dca\u0d91\u0dc3\u0dca \u0d9a\u0ddc\u0dad\u0dbd\u0dcf\u0dc0\u0dbd \u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a \u0dc3\u0db8\u0dcf\u0d9c\u0db8",
    ta: "\u0b8e\u0bb8\u0bcd\u0b8e\u0bb8\u0bcd \u0b95\u0bca\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe\u0bb5\u0bb2 \u0baa\u0bbf\u0bb0\u0bc8\u0bb5\u0bc7\u0b9f\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "ST. ANTHONY'S LANKA PIRAVEEMPOLA": {
    si: "ST. \u0d87\u0db1\u0dca\u0dad\u0db1\u0dd3\u0d9c\u0dda \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd3\u0db8\u0dca\u0db4\u0ddc\u0dbd",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b9f\u0bbf. \u0b85\u0ba8\u0bcd\u0ba4\u0bcb\u0ba9\u0bbf\u0bb8\u0bcd \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0baa\u0bbf\u0bb1\u0bb5\u0bc0\u0bae\u0bcd\u0baa\u0bca\u0bb2",
  },
  "ST. JUDE'S FILLING STATION": {
    si: "ST. \u0da2\u0dd6\u0da9\u0dca\u0dc3\u0dca \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b8e\u0bb8\u0bcd.\u0b9f\u0bbf. \u0b9c\u0bc2\u0b9f\u0bcd\u0bb8\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "ST.ANTHONY'S FILLING AND SERVICE ST": {
    si: "ST.Antony's Filling and Service ST",
    ta: "\u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd \u0b85\u0ba8\u0bcd\u0ba4\u0bcb\u0ba9\u0bbf\u0bb8\u0bcd \u0b83\u0baa\u0bbf\u0bb2\u0bcd\u0bb2\u0bbf\u0b99\u0bcd \u0bae\u0bb1\u0bcd\u0bb1\u0bc1\u0bae\u0bcd \u0b9a\u0bb0\u0bcd\u0bb5\u0bc0\u0bb8\u0bcd \u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd",
  },
  "STEPHEN'S FILLING STATION (PVT ) LT": {
    si: "\u0dc3\u0dca\u0da7\u0dd3\u0dc0\u0db1\u0dca\u0dc3\u0dca \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) LT",
    ta: "\u0bb8\u0bcd\u0b9f\u0bc0\u0baa\u0ba9\u0bcd\u0bb8\u0bcd \u0b83\u0baa\u0bbf\u0bb2\u0bcd\u0bb2\u0bbf\u0b99\u0bcd \u0bb8\u0bcd\u0b9f\u0bc7\u0bb7\u0ba9\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) LT",
  },
  "SUBHASINGHE LANKA PIRAVUMHALA": {
    si: "\u0dc3\u0dd4\u0db7\u0dc3\u0dd2\u0d82\u0dc4 \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0b9a\u0bc1\u0baa\u0b9a\u0bbf\u0b99\u0bcd\u0b95\u0bc7 \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0baa\u0bbf\u0bb1\u0bb5\u0bc1\u0bae\u0bcd\u0bb9\u0bb2",
  },
  "SUNRAY ENGINEERING": {
    si: "\u0dc3\u0db1\u0dca\u0dbb\u0dda \u0d89\u0d82\u0da2\u0dd2\u0db1\u0dda\u0dbb\u0dd4",
    ta: "\u0b9a\u0ba9\u0bcd\u0bb0\u0bc7 \u0b87\u0ba9\u0bcd\u0b9c\u0bbf\u0ba9\u0bbf\u0baf\u0bb0\u0bbf\u0b99\u0bcd",
  },
  "SUPER SERVICE STATION (PVT) LTD": {
    si: "\u0dc3\u0dd4\u0db4\u0dbb\u0dca \u0dc3\u0dbb\u0dca\u0dc0\u0dd2\u0dc3\u0dca \u0dc3\u0dca\u0da7\u0dda\u0dc2\u0db1\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b9a\u0bc2\u0baa\u0bcd\u0baa\u0bb0\u0bcd \u0b9a\u0bb0\u0bcd\u0bb5\u0bc0\u0bb8\u0bcd \u0bb8\u0bcd\u0b9f\u0bc7\u0bb7\u0ba9\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "SUPPIAH YOGESWARAM": {
    si: "\u0dc3\u0dd4\u0db4\u0dca\u0db4\u0dd2\u0dba\u0dcf \u0dba\u0ddd\u0d9c\u0dda\u0dc1\u0dca\u0dc0\u0dbb\u0db8\u0dca",
    ta: "\u0b9a\u0bc1\u0baa\u0bcd\u0baa\u0bc8\u0baf\u0bbe \u0baf\u0bcb\u0b95\u0bc7\u0bb8\u0bcd\u0bb5\u0bb0\u0bae\u0bcd",
  },
  "SWASTHIKA MILLS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dc3\u0dca\u0dc0\u0dc3\u0dca\u0dad\u0dd2\u0d9a \u0db8\u0dd2\u0dbd\u0dca\u0dc3\u0dca",
    ta: "\u0bb8\u0bcd\u0bb5\u0bb8\u0bcd\u0ba4\u0bbf\u0b95\u0bbe \u0bae\u0bbf\u0bb2\u0bcd\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "Salamanage Watta, Bandaramulla, WFV6+HM2, Mirissa, Sri Lanka": {
    si: "Salamanage Watta, Bandaramulla, WFV6+HM2, Mirissa, Sri Lanka",
    ta: "\u0b9a\u0bb2\u0bae\u0ba9\u0b95\u0bc7 \u0bb5\u0ba4\u0bcd\u0ba4, \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0bae\u0bc1\u0bb2\u0bcd\u0bb2, WFV6+HM2, \u0bae\u0bbf\u0bb0\u0bbf\u0bb8\u0bcd\u0bb8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Salawa, Sri Lanka": {
    si: "\u0dc3\u0dcf\u0dbd\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b9a\u0bbe\u0bb2\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Saliya Ashokapura": {
    si: "\u0dc3\u0dcf\u0dbd\u0dd2\u0dba \u0d85\u0dc1\u0ddd\u0d9a\u0db4\u0dd4\u0dbb",
    ta: "\u0b9a\u0bbe\u0bb2\u0bbf\u0baf \u0b85\u0b9a\u0bcb\u0b95\u0baa\u0bc1\u0bb0",
  },
  Saliyawewa: {
    si: "\u0dc3\u0dcf\u0dbd\u0dd2\u0dba\u0dc0\u0dd0\u0dc0",
    ta: "\u0b9a\u0bbe\u0bb2\u0bbf\u0baf\u0bb5\u0bc6\u0bb5",
  },
  "Samagi Mawatha, Kamburupitiya": {
    si: "\u0dc3\u0db8\u0d9c\u0dd2 \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0db9\u0dd4\u0dbb\u0dd4\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0b9a\u0bae\u0b95\u0bbf \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bc1\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  Samanthurai: {
    si: "\u0dc3\u0db8\u0db1\u0dca\u0dad\u0dd4\u0dbb\u0dda",
    ta: "\u0b9a\u0bae\u0bcd\u0bae\u0bbe\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  "Sammanthurai, Sammanthurai, Sri Lanka": {
    si: "\u0dc3\u0db8\u0dca\u0db8\u0db1\u0dca\u0dad\u0dd4\u0dbb\u0dda, \u0dc3\u0db8\u0dca\u0db8\u0db1\u0dca\u0dad\u0dd4\u0dbb\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b9a\u0bae\u0bcd\u0bae\u0bbe\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b9a\u0bae\u0bcd\u0bae\u0bbe\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Sandalankawa: {
    si: "\u0dc3\u0db3\u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "Sandalankawa",
  },
  Sapugaskhanda: {
    si: "\u0dc3\u0db4\u0dd4\u0d9c\u0dc3\u0dca\u0d9b\u0db1\u0dca\u0daf",
    ta: "\u0b9a\u0baa\u0bc1\u0b95\u0bb8\u0bcd\u0b95\u0ba8\u0bcd\u0ba4\u0bbe",
  },
  "Saranga Holiday Inn,Old Ella Road, Wellawaya-Ella-Kumbalwela Hwy, Wellawaya, Sri Lanka":
    {
      si: "\u0dc3\u0dcf\u0dbb\u0d82\u0d9c \u0dc4\u0ddc\u0dbd\u0dd2\u0da9\u0dda \u0dad\u0dcf\u0db1\u0dcf\u0dba\u0db8, \u0db4\u0dd0\u0dbb\u0dab\u0dd2 \u0d87\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba-\u0d87\u0dbd\u0dca\u0dbd-\u0d9a\u0dd4\u0db9\u0dbd\u0dca\u0dc0\u0dd9\u0dbd \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "\u0b9a\u0bbe\u0bb0\u0b99\u0bcd\u0b95\u0bbe \u0bb5\u0bbf\u0b9f\u0bc1\u0bae\u0bc1\u0bb1\u0bc8 \u0bb5\u0bbf\u0b9f\u0bc1\u0ba4\u0bbf, \u0baa\u0bb4\u0bc8\u0baf \u0b8e\u0bb2\u0bcd\u0bb2\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf-\u0b8e\u0bb2\u0bcd\u0bb2\u0bbe-\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bb2\u0bcd\u0bb5\u0bc6\u0bb2 Hwy, \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  Sarasaviuyana: {
    si: "\u0dc3\u0dbb\u0dc3\u0dc0\u0dd2\u0d8b\u0dba\u0db1",
    ta: "\u0b9a\u0bb0\u0b9a\u0bb5\u0bbf\u0baf\u0bc1\u0baf\u0ba9",
  },
  "Sathurukkondan, Batticaloa": {
    si: "\u0dc3\u0dad\u0dd4\u0dbb\u0dd4\u0d9a\u0dca\u0d9a\u0ddc\u0db1\u0dca\u0daf\u0db1\u0dca, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0",
    ta: "\u0b9a\u0ba4\u0bcd\u0ba4\u0bc1\u0bb0\u0bc1\u0b95\u0bcd\u0b95\u0bca\u0ba3\u0bcd\u0b9f\u0bbe\u0ba9\u0bcd, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1",
  },
  "School Rd, Sooriyawewa": {
    si: "\u0db4\u0dcf\u0dc3\u0dbd\u0dca \u0db4\u0dcf\u0dbb, \u0dc3\u0dd6\u0dbb\u0dd2\u0dba\u0dc0\u0dd0\u0dc0",
    ta: "\u0baa\u0bb3\u0bcd\u0bb3\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, \u0b9a\u0bc2\u0bb0\u0bbf\u0baf\u0bb5\u0bc6\u0bb5",
  },
  Seeduwa: {
    si: "\u0dc3\u0dd3\u0daf\u0dd4\u0dc0",
    ta: "\u0b9a\u0bc0\u0ba4\u0bc1\u0bb5\u0bbe",
  },
  "Seenigama - Aluthwala Rd, Warallana , Hikkaduwa": {
    si: "\u0dc3\u0dd3\u0db1\u0dd2\u0d9c\u0db8 - \u0d85\u0dbd\u0dd4\u0dad\u0dca\u0dc0\u0dbd \u0db4\u0dcf\u0dbb, \u0dc0\u0dbb\u0dbd\u0dca\u0dbd\u0dcf\u0db1, \u0dc4\u0dd2\u0d9a\u0dca\u0d9a\u0da9\u0dd4\u0dc0",
    ta: "\u0b9a\u0bc0\u0ba9\u0bbf\u0b95\u0bae - \u0b85\u0bb2\u0bc1\u0ba4\u0bcd\u0bb5\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bb0\u0bb2\u0bcd\u0bb2\u0ba9, \u0bb9\u0bbf\u0b95\u0bcd\u0b95\u0b9f\u0bc1\u0bb5",
  },
  "Seerani Junction, Sandilipay": {
    si: "\u0dc3\u0dd3\u0dbb\u0dcf\u0db1\u0dd2 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0dc3\u0db1\u0dca\u0daf\u0dd2\u0dbd\u0dd2\u0db4\u0dcf\u0dba\u0dd2",
    ta: "\u0b9a\u0bc0\u0bb0\u0ba3\u0bbf \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0b9a\u0ba3\u0bcd\u0b9f\u0bbf\u0bb2\u0bbf\u0baa\u0bcd\u0baa\u0bbe\u0baf\u0bcd",
  },
  Serakuliya: {
    si: "\u0dc3\u0dda\u0dbb\u0d9a\u0dd4\u0dbd\u0dd2\u0dba",
    ta: "\u0b9a\u0bc7\u0bb0\u0b95\u0bc1\u0bb2\u0bbf\u0baf\u0bbe",
  },
  Sewanagala: {
    si: "\u0dc3\u0dd9\u0dc0\u0db1\u0d9c\u0dbd",
    ta: "\u0b9a\u0bc6\u0bb5\u0ba9\u0b95\u0bb2",
  },
  "Share your feedback!": {
    si: "\u0d94\u0db6\u0dda \u0db4\u0dca\u200d\u0dbb\u0dad\u0dd2\u0db4\u0ddd\u0dc2\u0dab\u0dba \u0db6\u0dd9\u0daf\u0dcf \u0d9c\u0db1\u0dca\u0db1!",
    ta: "\u0b89\u0b99\u0bcd\u0b95\u0bb3\u0bcd \u0b95\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bc8\u0baa\u0bcd \u0baa\u0b95\u0bbf\u0bb0\u0bb5\u0bc1\u0bae\u0bcd!",
  },
  "Sinna Kinniya": {
    si: "\u0dc3\u0dd2\u0db1\u0dca\u0db1 \u0d9a\u0dd2\u0db1\u0dca\u0db1\u0dd2\u0dba\u0dcf",
    ta: "\u0b9a\u0bbf\u0ba9\u0bcd\u0ba9 \u0b95\u0bbf\u0ba3\u0bcd\u0ba3\u0bbf\u0baf\u0bbe",
  },
  "Sir Jayathilake Mawatha, Nuwara Eliya": {
    si: "\u0dc1\u0dca\u200d\u0dbb\u0dd3\u0db8\u0dad\u0dca \u0da2\u0dba\u0dad\u0dd2\u0dbd\u0d9a \u0db8\u0dcf\u0dc0\u0dad, \u0db1\u0dd4\u0dc0\u0dbb\u0d91\u0dc5\u0dd2\u0dba",
    ta: "\u0b9a\u0bc7\u0bb0\u0bcd \u0b9c\u0baf\u0ba4\u0bbf\u0bb2\u0b95\u0bcd\u0b95 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0ba8\u0bc1\u0bb5\u0bb0\u0bc6\u0bb2\u0bbf\u0baf\u0bbe",
  },
  "Sirimalwatta - Amunugama - Madawala Rd, Madawala": {
    si: "\u0dc3\u0dd2\u0dbb\u0dd2\u0db8\u0dbd\u0dca\u0dc0\u0dad\u0dca\u0dad - \u0d85\u0db8\u0dd4\u0dab\u0dd4\u0d9c\u0db8 - \u0db8\u0da9\u0dc0\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0da9\u0dc0\u0dbd",
    ta: "\u0b9a\u0bbf\u0bb1\u0bbf\u0bae\u0bb2\u0bcd\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8 - \u0b85\u0bae\u0bc1\u0ba9\u0bc1\u0b95\u0bae - \u0bae\u0b9f\u0bb5\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0b9f\u0bb5\u0bb3\u0bc8",
  },
  "Siripura - Dehiattakandiya": {
    si: "\u0dc3\u0dd2\u0dbb\u0dd2\u0db4\u0dd4\u0dbb - \u0daf\u0dd9\u0dc4\u0dd2\u0d85\u0dad\u0dca\u0dad\u0d9a\u0dab\u0dca\u0da9\u0dd2\u0dba",
    ta: "\u0b9a\u0bbf\u0bb1\u0bbf\u0baa\u0bc1\u0bb0 - \u0ba4\u0bc6\u0bb9\u0bbf\u0baf\u0ba4\u0bcd\u0ba4\u0b95\u0ba3\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Sirupiddy East": {
    si: "\u0dc3\u0dd2\u0dbb\u0dd4\u0db4\u0dd2\u0da9\u0dca\u0da9\u0dd2 \u0db1\u0dd0\u0d9c\u0dd9\u0db1\u0dc4\u0dd2\u0dbb",
    ta: "\u0b9a\u0bbf\u0bb1\u0bc1\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf \u0b95\u0bbf\u0bb4\u0b95\u0bcd\u0b95\u0bc1",
  },
  "Siruththoppu, Sri Lanka": {
    si: "\u0dc3\u0dd2\u0dbb\u0dd4\u0dad\u0dca\u0dad\u0ddc\u0db4\u0dca\u0db4\u0dd4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b9a\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bcb\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Siyambalanduwa: {
    si: "\u0dc3\u0dd2\u0dba\u0db9\u0dbd\u0dcf\u0dab\u0dca\u0da9\u0dd4\u0dc0",
    ta: "\u0b9a\u0bbf\u0baf\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0ba3\u0bcd\u0b9f\u0bc1\u0bb5",
  },
  Siyambalape: {
    si: "\u0dc3\u0dd2\u0dba\u0db9\u0dbd\u0dcf\u0db4\u0dda",
    ta: "\u0b9a\u0bbf\u0baf\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0baa\u0bc7",
  },
  "Skinners's Rd, Colombo - 13": {
    si: "\u0dc3\u0dca\u0d9a\u0dd2\u0db1\u0dbb\u0dca\u0dc3\u0dca \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0dc5\u0db9 - 13",
    ta: "\u0bb8\u0bcd\u0b95\u0bbf\u0ba9\u0bcd\u0ba9\u0bb0\u0bcd\u0bb8\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - 13",
  },
  "Somawathiya - Hingurakgoda Rd": {
    si: "\u0dc3\u0ddd\u0db8\u0dcf\u0dc0\u0dad\u0dd2\u0dba - \u0dc4\u0dd2\u0d9f\u0dd4\u0dbb\u0d9a\u0dca\u0d9c\u0ddc\u0da9 \u0db4\u0dcf\u0dbb",
    ta: "\u0b9a\u0bcb\u0bae\u0bbe\u0bb5\u0ba4\u0bbf\u0baf\u0bbe - \u0bb9\u0bbf\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0bbe\u0b95\u0bcd\u0b95\u0bca\u0b9f \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  "Somawathiya Rd, Polonnaruwa": {
    si: "\u0dc3\u0ddd\u0db8\u0dcf\u0dc0\u0dad\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0db4\u0ddc\u0dc5\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0",
    ta: "\u0b9a\u0bcb\u0bae\u0bbe\u0bb5\u0ba4\u0bbf\u0baf\u0bbe \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5\u0bc8",
  },
  "Songster S.N. Centre, Bandaragama, Sri Lanka": {
    si: "\u0d9c\u0dd3\u0dad \u0dbb\u0da0\u0d9a \u0d91\u0dc3\u0dca.\u0d91\u0db1\u0dca. \u0db8\u0db0\u0dca\u200d\u0dba\u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba, \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bbe\u0b9f\u0bb2\u0bbe\u0b9a\u0bbf\u0bb0\u0bbf\u0baf\u0bb0\u0bcd \u0b8e\u0bb8\u0bcd.\u0b8e\u0ba9\u0bcd. \u0bae\u0bc8\u0baf\u0bae\u0bcd, \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0b95\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "South-coast Rd, Silavathurai": {
    si: "\u0daf\u0d9a\u0dd4\u0dab\u0dd4 \u0dc0\u0dd9\u0dbb\u0dc5 \u0db4\u0dcf\u0dbb, \u0dc3\u0dd2\u0dbd\u0dcf\u0dc0\u0dad\u0dd4\u0dbb\u0dd9\u0dba\u0dd2",
    ta: "\u0ba4\u0bc6\u0ba9\u0bcd \u0b95\u0b9f\u0bb1\u0bcd\u0b95\u0bb0\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b9a\u0bbf\u0bb2\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  "Southern Petroleum (Pvt) Ltd - 06": {
    si: "\u0dc3\u0daf\u0dbb\u0dca\u0db1\u0dca \u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0ddd\u0dbd\u0dd2\u0dba\u0db8\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dc3\u0db8\u0dcf\u0d9c\u0db8 - 06",
    ta: "\u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1 \u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bbf\u0baf\u0bae\u0bcd (\u0baa\u0bbf\u0bb0\u0bc8\u0bb5\u0bc7\u0b9f\u0bcd) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd - 06",
  },
  "Southern Petroleum (Pvt) Ltd -1": {
    si: "\u0dc3\u0daf\u0dbb\u0dca\u0db1\u0dca \u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0ddd\u0dbd\u0dd2\u0dba\u0db8\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dc3\u0db8\u0dcf\u0d9c\u0db8 -1",
    ta: "\u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1 \u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bbf\u0baf\u0bae\u0bcd (\u0baa\u0bbf\u0bb0\u0bc8\u0bb5\u0bc7\u0b9f\u0bcd) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd -1",
  },
  "Spc Petrol Shed, Wattala": {
    si: "Spc \u0db4\u0dd9\u0da7\u0dca\u200d\u0dbb\u0dbd\u0dca \u0dc2\u0dd9\u0da9\u0dca, \u0dc0\u0dad\u0dca\u0dad\u0dbd",
    ta: "Spc \u0baa\u0bc6\u0b9f\u0bcd\u0bb0\u0bcb\u0bb2\u0bcd \u0bb7\u0bc6\u0b9f\u0bcd, \u0bb5\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8",
  },
  "Sri Bodhi Road, Gampaha": {
    si: "\u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0db6\u0ddd\u0db0\u0dd2 \u0db4\u0dcf\u0dbb, \u0d9c\u0db8\u0dca\u0db4\u0dc4",
    ta: "\u0bb8\u0bcd\u0bb0\u0bc0 \u0baa\u0bcb\u0ba4\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bae\u0bcd\u0baa\u0bb9\u0bbe",
  },
  "Sri Jayawardenepura Kotte": {
    si: "\u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1\u0db4\u0dd4\u0dbb \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda",
    ta: "\u0bb8\u0bcd\u0bb0\u0bc0 \u0b9c\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0baa\u0bc1\u0bb0 \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7",
  },
  "Sri Sambuddhathva Jayanthi Mawatha, Colombo": {
    si: "\u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dc3\u0db8\u0dca\u0db6\u0dd4\u0daf\u0dca\u0db0\u0dad\u0dca\u0dc0 \u0da2\u0dba\u0db1\u0dca\u0dad\u0dd2 \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9",
    ta: "\u0bb8\u0bcd\u0bb0\u0bc0 \u0b9a\u0bae\u0bcd\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0ba4\u0bcd\u0bb5 \u0b9c\u0bc6\u0baf\u0ba8\u0bcd\u0ba4\u0bbf \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "Sri Sambuddhathva Jayanthi Mawatha, Colombo 05": {
    si: "\u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dc3\u0db8\u0dca\u0db6\u0dd4\u0daf\u0dca\u0db0\u0dad\u0dca\u0dc0 \u0da2\u0dba\u0db1\u0dca\u0dad\u0dd2 \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 05",
    ta: "\u0bb8\u0bcd\u0bb0\u0bc0 \u0b9a\u0bae\u0bcd\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0ba4\u0bcd\u0bb5 \u0b9c\u0bc6\u0baf\u0ba8\u0bcd\u0ba4\u0bbf \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 05",
  },
  "St. Peter's Rd, Moratuwa": {
    si: "\u0dc1\u0dcf\u0db1\u0dca\u0dad \u0db4\u0dd3\u0dad\u0dbb \u0db4\u0dcf\u0dbb, \u0db8\u0ddc\u0dbb\u0da7\u0dd4\u0dc0",
    ta: "\u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd \u0baa\u0bc0\u0b9f\u0bcd\u0b9f\u0bb0\u0bcd\u0bb8\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bca\u0bb0\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bc8",
  },
  "Station Rd, Vavuniya": {
    si: "\u0daf\u0dd4\u0db8\u0dca\u0dbb\u0dd2\u0dba \u0dc3\u0dca\u0dae\u0dcf\u0db1\u0dba, \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0",
    ta: "\u0bb8\u0bcd\u0b9f\u0bc7\u0bb7\u0ba9\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1, \u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe",
  },
  "Suduwelipelessa Kirinda": {
    si: "\u0dc3\u0dd4\u0daf\u0dd4\u0dc0\u0dd0\u0dbd\u0dd2\u0db4\u0dd0\u0dbd\u0dd0\u0dc3\u0dca\u0dc3 \u0d9a\u0dd2\u0dbb\u0dd2\u0db1\u0dca\u0daf",
    ta: "\u0b9a\u0bc1\u0ba4\u0bc1\u0bb5\u0bc6\u0bb2\u0bbf\u0baa\u0bc6\u0bb2\u0bb8\u0bcd\u0bb8 \u0b95\u0bbf\u0bb0\u0bbf\u0ba8\u0bcd\u0ba4",
  },
  Suduwella: {
    si: "\u0dc3\u0dd4\u0daf\u0dd4\u0dc0\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0b9a\u0bc1\u0ba4\u0bc1\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2",
  },
  "Super-Diesel": {
    si: "\u0dc3\u0dd4\u0db4\u0dd2\u0dbb\u0dd2 \u0da9\u0dd3\u0dc3\u0dbd\u0dca",
    ta: "\u0b9a\u0bc2\u0baa\u0bcd\u0baa\u0bb0\u0bcd \u0b9f\u0bc0\u0b9a\u0bb2\u0bcd",
  },
  "Super-Diesel only": {
    si: "\u0dc3\u0dd4\u0db4\u0dd2\u0dbb\u0dd2 \u0da9\u0dd3\u0dc3\u0dbd\u0dca \u0db4\u0db8\u0dab\u0dd2",
    ta: "\u0b9a\u0bc2\u0baa\u0bcd\u0baa\u0bb0\u0bcd \u0b9f\u0bc0\u0b9a\u0bb2\u0bcd \u0bae\u0b9f\u0bcd\u0b9f\u0bc1\u0bae\u0bc7",
  },
  Suriyakanda: {
    si: "\u0dc3\u0dd6\u0dbb\u0dd2\u0dba\u0d9a\u0db1\u0dca\u0daf",
    ta: "\u0b9a\u0bc2\u0bb0\u0bbf\u0baf\u0b95\u0ba8\u0bcd\u0ba4\u0bbe",
  },
  "T & S FUEL MART": {
    si: "T & S FUEL MART",
    ta: "\u0b9f\u0bbf & \u0b8e\u0bb8\u0bcd \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0bae\u0bbe\u0bb0\u0bcd\u0b9f\u0bcd",
  },
  "T C KULARATNE": {
    si: "\u0da7\u0dd3 \u0dc3\u0dd3 \u0d9a\u0dd4\u0dbd\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b9f\u0bbf \u0b9a\u0bbf \u0b95\u0bc1\u0bb2\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "T H DAYARATHNE": {
    si: "\u0da7\u0dd3 \u0d91\u0da0\u0dca \u0daf\u0dba\u0dcf\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b9f\u0bbf \u0b8e\u0b9a\u0bcd \u0ba4\u0baf\u0bbe\u0bb0\u0ba4\u0bcd\u0ba9\u0bc7",
  },
  "T H JAYALATH": {
    si: "\u0da7\u0dd3 \u0d91\u0da0\u0dca \u0da2\u0dba\u0dbd\u0dad\u0dca",
    ta: "\u0b9f\u0bbf \u0b8e\u0b9a\u0bcd \u0b9c\u0bc6\u0baf\u0bb2\u0ba4\u0bcd",
  },
  "T M ALAHAKOON ENTERPRISES": {
    si: "\u0da7\u0dd3 \u0d91\u0db8\u0dca \u0d85\u0dbd\u0dc4\u0d9a\u0ddd\u0db1\u0dca \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b9f\u0bbf \u0b8e\u0bae\u0bcd \u0b85\u0bb4\u0b95\u0b95\u0bcb\u0ba9\u0bcd \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "T M SENARATH PARANAYAPA": {
    si: "\u0da7\u0dd3 \u0d91\u0db8\u0dca \u0dc3\u0dd9\u0db1\u0dbb\u0dad\u0dca \u0db4\u0dbb\u0dab\u0dcf\u0dba\u0db4",
    ta: "\u0b9f\u0bbf \u0b8e\u0bae\u0bcd \u0b9a\u0bc6\u0ba9\u0bb0\u0ba4\u0bcd \u0baa\u0bb0\u0ba3\u0baf\u0baa",
  },
  "T S CHAINS (PVT) LTD": {
    si: "T S CHAINS (PVT) LTD",
    ta: "\u0b9f\u0bbf \u0b8e\u0bb8\u0bcd \u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "T S JAYALATH": {
    si: "\u0da7\u0dd3 \u0d91\u0dc3\u0dca \u0da2\u0dba\u0dbd\u0dad\u0dca",
    ta: "\u0b9f\u0bbf \u0b8e\u0bb8\u0bcd \u0b9c\u0bc6\u0baf\u0bb2\u0ba4\u0bcd",
  },
  "T. AMILA INDIKA GUNAPALA": {
    si: "\u0da7\u0dd3.\u0d85\u0db8\u0dd2\u0dbd \u0d89\u0db1\u0dca\u0daf\u0dd2\u0d9a \u0d9c\u0dd4\u0dab\u0db4\u0dcf\u0dbd",
    ta: "\u0b9f\u0bbf. \u0b85\u0bae\u0bbf\u0bb2 \u0b87\u0ba8\u0bcd\u0ba4\u0bbf\u0b95 \u0b95\u0bc1\u0ba3\u0baa\u0bbe\u0bb2",
  },
  "T.AMPALAM": {
    si: "\u0da7\u0dd3.\u0d85\u0db8\u0dca\u0db4\u0dbd\u0db8\u0dca",
    ta: "\u0ba4.\u0b85\u0bae\u0bcd\u0baa\u0bb2\u0bae\u0bcd",
  },
  "T.C.S.PERERA": {
    si: "\u0da7\u0dd3.\u0dc3\u0dd3.\u0d91\u0dc3\u0dca.\u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b9f\u0bbf.\u0b9a\u0bbf.\u0b8e\u0bb8\u0bcd.\u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "T.E.A. KARIM (GOLDEN FAMILY ENTERPR": {
    si: "\u0dad\u0dda. \u0d9a\u0dbb\u0dd3\u0db8\u0dca (\u0d9c\u0ddd\u0dbd\u0dca\u0da9\u0db1\u0dca \u0dc6\u0dd0\u0db8\u0dd2\u0dbd\u0dd2 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dbb\u0dca",
    ta: "\u0b9f\u0bbf.\u0b87.\u0b8f. \u0b95\u0bb0\u0bc0\u0bae\u0bcd (\u0b95\u0bcb\u0bb2\u0bcd\u0b9f\u0ba9\u0bcd \u0b83\u0baa\u0bc7\u0bae\u0bbf\u0bb2\u0bbf \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0b86\u0bb0\u0bcd",
  },
  "T.G.MALA MALKANTHI": {
    si: "\u0da7\u0dd3.\u0da2\u0dd3.\u0db8\u0dcf\u0dbd\u0dcf \u0db8\u0dbd\u0dca\u0d9a\u0dcf\u0db1\u0dca\u0dad\u0dd2",
    ta: "\u0b9f\u0bbf.\u0b9c\u0bbf.\u0bae\u0bbe\u0bb2\u0bbe \u0bae\u0bb2\u0bcd\u0b95\u0bbe\u0ba8\u0bcd\u0ba4\u0bbf",
  },
  "TALAIMANNAR PIER-CANCEL": {
    si: "\u0dad\u0dbd\u0dd9\u0dba\u0dd2\u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8 \u0db4\u0dd2\u0dba\u0dbb\u0dca-\u0d85\u0dc0\u0dbd\u0d82\u0d9c\u0dd4 \u0d9a\u0dd2\u0dbb\u0dd3\u0db8",
    ta: "\u0ba4\u0bb2\u0bc8\u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd \u0baa\u0bc8\u0baf\u0bb0\u0bcd-\u0bb0\u0ba4\u0bcd\u0ba4\u0bc1",
  },
  "TALATUOYA - MARASSANA MPCS LTD": {
    si: "\u0dad\u0dbd\u0dcf\u0dad\u0dd4\u0d94\u0dba - \u0db8\u0dcf\u0dbb\u0dc3\u0dca\u0dc3\u0db1 \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0ba4\u0bb2\u0ba4\u0bc1\u0b93\u0baf\u0bbe - \u0bae\u0bb0\u0bbe\u0bb8\u0bcd\u0bb8\u0ba9\u0bbe MPCS LTD",
  },
  "TALATUOYA MARASSANA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dad\u0dbd\u0dcf\u0dad\u0dd4\u0d94\u0dba \u0db8\u0dcf\u0dbb\u0dc3\u0dca\u0dc3\u0db1 MPCS",
    ta: "\u0ba4\u0bb2\u0ba4\u0bc1\u0b93\u0baf\u0bbe \u0bae\u0bbe\u0bb0\u0b9a\u0ba9\u0bbe MPCS LTD",
  },
  "TALAWAKELLE CENTRAL BUS STAND, Avissawella - Hatton - Nuwara Eliya Hwy, Talawakelle 22100, Sri Lanka":
    {
      si: "\u0dad\u0dbd\u0dc0\u0dcf\u0d9a\u0dd0\u0dbd\u0dda \u0db8\u0db0\u0dca\u200d\u0dba\u0db8 \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8\u0dca\u0db4\u0ddc\u0dc5, \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd - \u0dc4\u0dd0\u0da7\u0db1\u0dca - \u0db1\u0dd4\u0dc0\u0dbb\u0d91\u0dc5\u0dd2\u0dba Hwy, \u0dad\u0dbd\u0dc0\u0dcf\u0d9a\u0dd0\u0dbd\u0dda 22100, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "\u0ba4\u0bb2\u0bb5\u0bbe\u0b95\u0bcd\u0b95\u0bc6\u0bb2\u0bcd\u0bb2\u0bc8 \u0bae\u0ba4\u0bcd\u0ba4\u0bbf\u0baf \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bb3\u0bc8 - \u0bb9\u0b9f\u0bcd\u0b9f\u0ba9\u0bcd - \u0ba8\u0bc1\u0bb5\u0bb0\u0bc6\u0bb2\u0bbf\u0baf\u0bbe Hwy, \u0ba4\u0bb2\u0bb5\u0bbe\u0b95\u0bcd\u0b95\u0bb2\u0bc8 22100, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "TANGALLE MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dad\u0d82\u0d9c\u0dbd\u0dca\u0dbd MPCS",
    ta: "\u0ba4\u0b99\u0bcd\u0b95\u0bbe\u0bb2\u0bc7 MPCS LTD",
  },
  "TASMA INTERNATIONAL MANPOWER SPLS (": {
    si: "\u0dad\u0dc3\u0dca\u0db8\u0dcf \u0da2\u0dcf\u0dad\u0dca\u200d\u0dba\u0db1\u0dca\u0dad\u0dbb \u0db8\u0dd2\u0db1\u0dd2\u0dc3\u0dca\u0db6\u0dbd \u0d91\u0dc3\u0dca\u0db4\u0dd3\u0d91\u0dbd\u0dca\u0d91\u0dc3\u0dca (",
    ta: "\u0b9f\u0bbe\u0bb8\u0bcd\u0bae\u0bbe \u0b87\u0ba9\u0bcd\u0b9f\u0bb0\u0bcd\u0ba8\u0bc7\u0bb7\u0ba9\u0bb2\u0bcd \u0bae\u0bc7\u0ba9\u0bcd\u0baa\u0bb5\u0bb0\u0bcd \u0b8e\u0bb8\u0bcd\u0baa\u0bbf\u0b8e\u0bb2\u0bcd\u0b8e\u0bb8\u0bcd (",
  },
  "TELDENIYA MPCS LTD": {
    si: "\u0dad\u0dd9\u0dbd\u0dca\u0daf\u0dd9\u0dab\u0dd2\u0dba MPCS LTD",
    ta: "\u0ba4\u0bc6\u0bb2\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe MPCS LTD",
  },
  "TELIKADA MAJUWANA MPCS LTD": {
    si: "\u0dad\u0dd9\u0dbd\u0dd2\u0d9a\u0da9 \u0db8\u0da2\u0dd4\u0dc0\u0db1 \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b9f\u0bc6\u0bb2\u0bbf\u0b95\u0b9f \u0bae\u0b9c\u0bc1\u0bb5\u0bbe\u0ba9\u0bbe MPCS LTD",
  },
  "TELLIPALLAI MPCS LTD": {
    si: "\u0dad\u0dd9\u0dbd\u0dd2\u0db4\u0dbd\u0dca\u0dbd\u0dba\u0dd2 MPCS LTD",
    ta: "\u0ba4\u0bc6\u0bb2\u0bcd\u0bb2\u0bbf\u0baa\u0bcd\u0baa\u0bb3\u0bc8 MPCS LTD",
  },
  "THARANGA FILLING STATION": {
    si: "\u0dad\u0dbb\u0d82\u0d9c \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0ba4\u0bb0\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "THARSHINI KANNATHASAN": {
    si: "\u0dad\u0dbb\u0dca\u0dc2\u0dd2\u0dab\u0dd2 \u0d9a\u0db1\u0dca\u0db1\u0dad\u0dcf\u0dc3\u0db1\u0dca",
    ta: "\u0ba4\u0bb0\u0bcd\u0bb7\u0bbf\u0ba9\u0bbf \u0b95\u0ba3\u0bcd\u0ba3\u0ba4\u0bbe\u0b9a\u0ba9\u0bcd",
  },
  "THAWAMANI VADIVEL": {
    si: "\u0dad\u0dc0\u0db8\u0db1\u0dd2 \u0dc0\u0da9\u0dd2\u0dc0\u0dd9\u0dbd\u0dca",
    ta: "\u0ba4\u0bb5\u0bae\u0ba3\u0bbf \u0bb5\u0b9f\u0bbf\u0bb5\u0bc7\u0bb2\u0bcd",
  },
  "THELLAMBURA & SON": {
    si: "\u0dad\u0dd9\u0dbd\u0dca\u0dbd\u0db9\u0dd4\u0dbb \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dcf",
    ta: "\u0ba4\u0bc6\u0bb3\u0bcd\u0bb3\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bbe & \u0bae\u0b95\u0ba9\u0bcd",
  },
  "THENMARATCHY EAST MPCS LTD": {
    si: "\u0dad\u0dd9\u0db1\u0dca\u0db8\u0dcf\u0dbb\u0da0\u0dca\u0da0\u0dd2 \u0d8a\u0dc3\u0dca\u0da7\u0dca \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0ba4\u0bc6\u0ba9\u0bcd\u0bae\u0bb0\u0bbe\u0b9f\u0bcd\u0b9a\u0bbf \u0b95\u0bbf\u0bb4\u0b95\u0bcd\u0b95\u0bc1 MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "THENMARATCHY WEST MPCS LTD": {
    si: "\u0dad\u0dd9\u0db1\u0dca\u0db8\u0dcf\u0dbb\u0da0\u0dca\u0da0\u0dd2 \u0db6\u0da7\u0dc4\u0dd2\u0dbb MPCS LTD",
    ta: "\u0ba4\u0bc6\u0ba9\u0bcd\u0bae\u0bb0\u0bbe\u0b9f\u0bcd\u0b9a\u0bbf \u0bae\u0bc7\u0bb1\u0bcd\u0b95\u0bc1 MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "THILAK SUDATH DE SILVA": {
    si: "\u0dad\u0dd2\u0dbd\u0d9a\u0dca \u0dc3\u0dd4\u0daf\u0dad\u0dca \u0daf \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf",
    ta: "\u0ba4\u0bbf\u0bb2\u0b95\u0bcd \u0b9a\u0bc1\u0ba4\u0ba4\u0bcd \u0b9f\u0bbf \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe",
  },
  "THINARA FILLING STATION": {
    si: "\u0dad\u0dd2\u0db1\u0dcf\u0dbb \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0ba4\u0bbf\u0ba9\u0bbe\u0bb0\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "THUNUKKAI DIVISION MPCS LTD": {
    si: "\u0dad\u0dd4\u0db1\u0dd4\u0d9a\u0dca\u0d9a\u0dcf\u0dba\u0dd2 \u0da9\u0dd2\u0dc0\u0dd2\u0dc2\u0db1\u0dca \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0ba4\u0bc1\u0ba3\u0bc1\u0b95\u0bcd\u0b95\u0bc8 \u0baa\u0bbf\u0bb0\u0bbf\u0bb5\u0bc1 MPCS LTD",
  },
  "THUSARI & SON": {
    si: "\u0dad\u0dd4\u0dc3\u0dcf\u0dbb\u0dd2 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dcf",
    ta: "\u0ba4\u0bc1\u0b9a\u0bbe\u0bb0\u0bbf & \u0bae\u0b95\u0ba9\u0bcd",
  },
  "TILAKA FILLING STATION": {
    si: "\u0dad\u0dd2\u0dbd\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0ba4\u0bbf\u0bb2\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "TISSAMAHARAMA MPCS LTD": {
    si: "\u0dad\u0dd2\u0dc3\u0dca\u0dc3\u0db8\u0dc4\u0dcf\u0dbb\u0dcf\u0db8 MPCS LTD",
    ta: "\u0ba4\u0bbf\u0bb8\u0bcd\u0bb8\u0bae\u0bb9\u0bbe\u0bb0\u0bbe\u0bae MPCS LTD",
  },
  "TOPPUWA JUNCTION": {
    si: "\u0dad\u0ddc\u0db4\u0dca\u0db4\u0dd4\u0dc0 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba",
    ta: "\u0ba4\u0bca\u0baa\u0bcd\u0baa\u0bc1\u0bb5\u0bbe \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0baa\u0bcd\u0baa\u0bc1",
  },
  "TRANS LANKA ENTERPRISES (PVT) LTD": {
    si: "\u0da7\u0dca\u200d\u0dbb\u0dcf\u0db1\u0dca\u0dc3\u0dca \u0dbd\u0d82\u0d9a\u0dcf \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0b9f\u0bbf\u0bb0\u0bbe\u0ba9\u0bcd\u0bb8\u0bcd \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "TRINCOMALEE MPCS LTD": {
    si: "\u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba MPCS LTD",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 MPCS LTD",
  },
  "Tabo Trasport": {
    si: "\u0da7\u0dd0\u0db6\u0ddd \u0da7\u0dca\u200d\u0dbb\u0dcf\u0dc3\u0dca\u0db4\u0ddd\u0da7\u0dca",
    ta: "\u0b9f\u0bc7\u0baa\u0bcb \u0b9f\u0bbf\u0bb0\u0bbe\u0bb8\u0bcd\u0baa\u0bcb\u0bb0\u0bcd\u0b9f\u0bcd",
  },
  "Talagaha Fuel Station": {
    si: "\u0dad\u0dbd\u0d9c\u0dc4 \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0ba4\u0bb2\u0b95\u0bbe\u0bb9\u0bbe \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "Talai Mannar Road, Mannar": {
    si: "\u0dad\u0dbd\u0dd9\u0dba\u0dd2 \u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8 \u0db4\u0dcf\u0dbb, \u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8",
    ta: "\u0ba4\u0bb2\u0bc8 \u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd",
  },
  Talaimannar: {
    si: "\u0dad\u0dbd\u0dd9\u0dba\u0dd2\u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8",
    ta: "\u0ba4\u0bb2\u0bc8\u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd",
  },
  Talawakele: {
    si: "Talawakele",
    ta: "Talawakele",
  },
  Talayadi: {
    si: "\u0dad\u0dbd\u0dba\u0dcf\u0da9\u0dd2",
    ta: "\u0ba4\u0bb2\u0bc8\u0baf\u0b9f\u0bbf",
  },
  Tambuttegama: {
    si: "\u0dad\u0db9\u0dd4\u0dad\u0dca\u0dad\u0dda\u0d9c\u0db8",
    ta: "\u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bc7\u0b95\u0bae",
  },
  "Tangalle Rd": {
    si: "\u0dad\u0d82\u0d9c\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb",
    ta: "\u0ba4\u0b99\u0bcd\u0b95\u0bbe\u0bb2\u0bc8 \u0bb0\u0bcb\u0b9f\u0bc1",
  },
  "Tangalle Rd, Dikwella": {
    si: "\u0dad\u0d82\u0d9c\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0daf\u0dd2\u0d9a\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd",
    ta: "\u0ba4\u0b99\u0bcd\u0b95\u0bbe\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bbf\u0b95\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2",
  },
  "Tangalle Rd, Koattagoda": {
    si: "\u0dad\u0d82\u0d9c\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0d9c\u0ddc\u0da9",
    ta: "\u0ba4\u0b99\u0bcd\u0b95\u0bbe\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0b95\u0bca\u0b9f",
  },
  "Tangalle Rd, Tangalle": {
    si: "\u0dad\u0d82\u0d9c\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0dad\u0d82\u0d9c\u0dbd\u0dca\u0dbd",
    ta: "\u0ba4\u0b99\u0bcd\u0b95\u0bb2\u0bcd\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0b99\u0bcd\u0b95\u0bbe\u0bb2\u0bc8",
  },
  "Tannekumbura Fuel Station, A26, Tennekumbura": {
    si: "\u0dad\u0dd0\u0db1\u0dca\u0db1\u0d9a\u0dd4\u0db9\u0dd4\u0dbb \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, A26, \u0dad\u0dd0\u0db1\u0dca\u0db1\u0d9a\u0dd4\u0db9\u0dd4\u0dbb",
    ta: "\u0ba4\u0ba9\u0bcd\u0ba9\u0bc7\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0bb0 \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, A26, \u0ba4\u0bc6\u0ba9\u0bcd\u0ba9\u0bc7\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0bb0",
  },
  "Tawalantenne - Talawakele Rd, Pundaluoya": {
    si: "\u0dad\u0dc0\u0dbd\u0db1\u0dca\u0dad\u0dd0\u0db1\u0dca\u0db1\u0dda - \u0dad\u0dbd\u0dc0\u0dcf\u0d9a\u0dd0\u0dbd\u0dda \u0db4\u0dcf\u0dbb, \u0db4\u0dd4\u0dab\u0dca\u0da9\u0dc5\u0dd4\u0d94\u0dba",
    ta: "\u0ba4\u0bb5\u0bb2\u0ba8\u0bcd\u0ba4\u0bc6\u0ba9\u0bcd\u0ba9 - \u0ba4\u0bb2\u0bb5\u0bbe\u0b95\u0bcd\u0b95\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc2\u0ba3\u0bcd\u0b9f\u0bb2\u0bc1\u0b93\u0baf\u0bbe",
  },
  Tellippalai: {
    si: "\u0dad\u0dd9\u0dbd\u0dd2\u0db4\u0dca\u0db4\u0dbd\u0dd9\u0dba\u0dd2",
    ta: "\u0ba4\u0bc6\u0bb2\u0bcd\u0bb2\u0bbf\u0baa\u0bcd\u0baa\u0bb3\u0bc8",
  },
  "Tennakoon Filling Station, Katugastota-kurunegala-puttalam Hwy,Nikaweratiya":
    {
      si: "\u0dad\u0dd9\u0db1\u0dca\u0db1\u0d9a\u0ddd\u0db1\u0dca \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7-\u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd-\u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 Hwy, \u0db1\u0dd2\u0d9a\u0dc0\u0dd0\u0dbb\u0da7\u0dd2\u0dba",
      ta: "\u0ba4\u0bc6\u0ba9\u0bcd\u0ba9\u0b95\u0bcb\u0ba9\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8-\u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd-\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd Hwy, \u0ba8\u0bbf\u0b95\u0bcd\u0b95\u0bb5\u0bc6\u0bb0\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
    },
  "Tennekumbura - Rikillagaskada - Ragala Highway, Hanguranketa": {
    si: "\u0dad\u0dd0\u0db1\u0dca\u0db1\u0d9a\u0dd4\u0db9\u0dd4\u0dbb - \u0dbb\u0dd2\u0d9a\u0dd2\u0dbd\u0dca\u0dbd\u0d9c\u0dc3\u0dca\u0d9a\u0da9 - \u0dbb\u0dcf\u0d9c\u0dbd \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0dc4\u0d9f\u0dd4\u0dbb\u0db1\u0dca\u0d9a\u0dd9\u0da7",
    ta: "\u0ba4\u0bc6\u0ba9\u0bcd\u0ba9\u0bc7\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0bb0 - \u0bb0\u0bbf\u0b95\u0bbf\u0bb2\u0bcd\u0bb2\u0b95\u0bb8\u0bcd\u0b95\u0b9f - \u0bb0\u0bbe\u0b95\u0bb2 \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0bb9\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0ba9\u0bcd\u0b95\u0bc6\u0b9f\u0bcd\u0b9f",
  },
  "Thalahena Gas Station, B240,Thalahena": {
    si: "\u0dad\u0dbd\u0dcf\u0dc4\u0dda\u0db1 \u0d9c\u0dd1\u0dc3\u0dca \u0dc4\u0dbd, \u0db6\u0dd3 240, \u0dad\u0dbd\u0dcf\u0dc4\u0dda\u0db1",
    ta: "\u0ba4\u0bb2\u0bb9\u0bc7\u0ba9 \u0b8e\u0bb0\u0bbf\u0bb5\u0bbe\u0baf\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, B240, \u0ba4\u0bb2\u0bb9\u0bc7\u0ba9\u0bbe",
  },
  Thalaimannar: {
    si: "\u0dad\u0dbd\u0dd9\u0dba\u0dd2\u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8",
    ta: "\u0ba4\u0bb2\u0bc8\u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd",
  },
  Thalangamuwa: {
    si: "\u0dad\u0dbd\u0d82\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0ba4\u0bb2\u0b99\u0bcd\u0b95\u0bae\u0bc1\u0bb5",
  },
  "Thalatuoya - Marassana Rd., Mailapitiya": {
    si: "\u0dad\u0dbd\u0dcf\u0dad\u0dd4\u0d94\u0dba - \u0db8\u0dcf\u0dbb\u0dc3\u0dca\u0dc3\u0db1 \u0db4\u0dcf\u0dbb, \u0db8\u0dba\u0dd2\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0ba4\u0bb2\u0ba4\u0bcd\u0ba4\u0bc1\u0b93\u0baf\u0bbe - \u0bae\u0bb0\u0bb8\u0bcd\u0b9a\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bc8\u0bb2\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Thalawila Rd, Sri Lanka": {
    si: "\u0dad\u0dbd\u0dc0\u0dd2\u0dbd \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba4\u0bb2\u0bb5\u0bbf\u0bb2\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Thalei Mannar Road, Madhu, Paraiyanalankulam": {
    si: "\u0dad\u0dbd\u0dd9\u0dba\u0dd2 \u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8 \u0db4\u0dcf\u0dbb, \u0db8\u0da9\u0dd4, \u0db4\u0dbb\u0dba\u0db1\u0dcf\u0dbd\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca",
    ta: "\u0ba4\u0bb3\u0bbf \u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0b9f\u0bc1, \u0baa\u0bb1\u0bc8\u0baf\u0ba9\u0bbe\u0bb2\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd",
  },
  Thalgaswala: {
    si: "\u0dad\u0dbd\u0dca\u0d9c\u0dc3\u0dca\u0dc0\u0dbd",
    ta: "\u0ba4\u0bb2\u0bcd\u0b95\u0bb8\u0bcd\u0bb5\u0bb2",
  },
  "Thalowita Junction, Sri Lanka": {
    si: "\u0dad\u0dbd\u0ddd\u0dc0\u0dd2\u0da7 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba4\u0bb2\u0bcb\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0baa\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Thambarawila: {
    si: "\u0dad\u0db9\u0dbb\u0dc0\u0dd2\u0dbd",
    ta: "\u0ba4\u0bae\u0bcd\u0baa\u0bb0\u0bb5\u0bbf\u0bb2",
  },
  "Thampalakama Kinniya Road, Kinniya": {
    si: "\u0dad\u0db8\u0dca\u0db4\u0dbd\u0d9a\u0dcf\u0db8 \u0d9a\u0dd2\u0db1\u0dca\u0db1\u0dd2\u0dba\u0dcf \u0db4\u0dcf\u0dbb, \u0d9a\u0dd2\u0db1\u0dca\u0db1\u0dd2\u0dba\u0dcf",
    ta: "\u0ba4\u0bae\u0bcd\u0baa\u0bb2\u0b95\u0bbe\u0bae \u0b95\u0bbf\u0ba3\u0bcd\u0ba3\u0bbf\u0baf\u0bbe \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bbf\u0ba3\u0bcd\u0ba3\u0bbf\u0baf\u0bbe",
  },
  Thanamalwila: {
    si: "\u0dad\u0dab\u0db8\u0dbd\u0dca\u0dc0\u0dd2\u0dbd",
    ta: "\u0ba4\u0ba9\u0bae\u0bb2\u0bcd\u0bb5\u0bbf\u0bb2",
  },
  "Thannahena Rd, Ankumbura": {
    si: "\u0dad\u0db1\u0dca\u0db1\u0dc4\u0dda\u0db1 \u0db4\u0dcf\u0dbb, \u0d85\u0d82\u0d9a\u0dd4\u0db9\u0dd4\u0dbb",
    ta: "\u0ba4\u0ba9\u0bcd\u0ba9\u0bb9\u0bc7\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0b99\u0bcd\u0b95\u0bc1\u0bae\u0bcd\u0baa\u0bc1\u0bb0",
  },
  "Thawalama Junction, Udugama - Hiniduma Rd, Thawalama, Sri Lanka": {
    si: "\u0dad\u0dc0\u0dbd\u0db8 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0d8b\u0da9\u0dd4\u0d9c\u0db8 - \u0dc4\u0dd2\u0db1\u0dd2\u0daf\u0dd4\u0db8 \u0db4\u0dcf\u0dbb, \u0dad\u0dc0\u0dbd\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba4\u0bb5\u0bb2\u0bae \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0b89\u0b9f\u0bc1\u0b95\u0bae - \u0bb9\u0bbf\u0ba9\u0bbf\u0b9f\u0bc1\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bb5\u0bb2\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Thawalanthenna No.05 Kothai Nagar Thawalanthenna New Town Kotmale": {
    si: "\u0dad\u0dc0\u0dbd\u0db1\u0dca\u0dad\u0dd0\u0db1\u0dca\u0db1 \u0d85\u0d82\u0d9a 05 \u0d9a\u0ddc\u0dad\u0dba\u0dd2 \u0db1\u0d9c\u0dbb\u0dca \u0dad\u0dc0\u0dbd\u0db1\u0dca\u0dad\u0dd0\u0db1\u0dca\u0db1 \u0db1\u0dc0 \u0db1\u0d9c\u0dbb\u0dba \u0d9a\u0ddc\u0dad\u0dca\u0db8\u0dbd\u0dda",
    ta: "\u0ba4\u0bb5\u0bb3\u0ba8\u0bcd\u0ba4\u0bc6\u0ba9\u0bcd\u0ba9 \u0b87\u0bb2.05 \u0b95\u0bcb\u0ba4\u0bc8 \u0ba8\u0b95\u0bb0\u0bcd \u0ba4\u0bb5\u0bb2\u0ba8\u0bcd\u0ba4\u0bc6\u0ba9\u0bcd\u0ba9 \u0baa\u0bc1\u0ba4\u0bbf\u0baf \u0ba8\u0b95\u0bb0\u0bae\u0bcd \u0b95\u0bca\u0ba4\u0bcd\u0bae\u0bb2\u0bc8",
  },
  "Thiavaddavan,Oddamavadi": {
    si: "\u0dad\u0dd2\u0dba\u0dc0\u0daf\u0dca\u0daf\u0dc0\u0db1\u0dca, \u0d94\u0da9\u0dca\u0da9\u0db8\u0dcf\u0dc0\u0da9\u0dd2",
    ta: "\u0ba4\u0bbf\u0baf\u0bbe\u0bb5\u0b9f\u0bcd\u0b9f\u0bb5\u0ba9\u0bcd, \u0b93\u0b9f\u0bcd\u0b9f\u0bae\u0bbe\u0bb5\u0b9f\u0bbf",
  },
  Thibirigaskatuwa: {
    si: "\u0dad\u0dd2\u0db6\u0dd2\u0dbb\u0dd2\u0d9c\u0dc3\u0dca\u0d9a\u0da7\u0dd4\u0dc0",
    ta: "\u0ba4\u0bbf\u0baa\u0bbf\u0bb0\u0bbf\u0b95\u0bb8\u0bcd\u0b95\u0b9f\u0bc1\u0bb5",
  },
  "Thihagoda - Kamburupitiya - Mawarala - Kotapola Rd, Mawarala": {
    si: "\u0dad\u0dd2\u0dc4\u0d9c\u0ddc\u0da9 - \u0d9a\u0db9\u0dd4\u0dbb\u0dd4\u0db4\u0dd2\u0da7\u0dd2\u0dba - \u0db8\u0dcf\u0dc0\u0dbb\u0dbd - \u0d9a\u0ddc\u0da7\u0db4\u0ddc\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0dcf\u0dc0\u0dbb\u0dbd",
    ta: "\u0ba4\u0bbf\u0bb9\u0b95\u0bca\u0b9f - \u0b95\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bc1\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf - \u0bae\u0bbe\u0bb5\u0bb0\u0bb2 - \u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0baa\u0bca\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bbe\u0bb5\u0bb0\u0bb2",
  },
  "Thihagoda Fuel Station, Matara - Hakmana Rd, Thihagoda": {
    si: "\u0dad\u0dd2\u0dc4\u0d9c\u0ddc\u0da9 \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db8\u0dcf\u0dad\u0dbb - \u0dc4\u0d9a\u0dca\u0db8\u0db1 \u0db4\u0dcf\u0dbb, \u0dad\u0dd2\u0dc4\u0d9c\u0ddc\u0da9",
    ta: "\u0ba4\u0bbf\u0bb9\u0b95\u0bca\u0b9f \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8 - \u0bb9\u0b95\u0bcd\u0bae\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bbf\u0bb9\u0b95\u0bca\u0b9f",
  },
  "Thiriyaya Junction, Sri Lanka": {
    si: "\u0dad\u0dd2\u0dbb\u0dd2\u0dba\u0dcf\u0dba \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba4\u0bbf\u0bb0\u0bbf\u0baf\u0baf\u0bbe \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Thirukatheeswaram - Mannar": {
    si: "\u0dad\u0dd2\u0dbb\u0dd4\u0d9a\u0dad\u0dd3\u0dc3\u0dca\u0dc0\u0dbb\u0db8\u0dca - \u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcd\u0b95\u0ba4\u0bc0\u0bb8\u0bcd\u0bb5\u0bb0\u0bae\u0bcd - \u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd",
  },
  "Thirukkondaiadimadu Hwy, Girithale": {
    si: "\u0dad\u0dd2\u0dbb\u0dd4\u0d9a\u0dca\u0d9a\u0ddc\u0dab\u0dca\u0da9\u0dd2\u0dba\u0dcf\u0da9\u0dd2\u0db8\u0da9\u0dd4 Hwy, \u0d9c\u0dd2\u0dbb\u0dd2\u0dad\u0dbd\u0dda",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcd\u0b95\u0bca\u0ba3\u0bcd\u0b9f\u0bc8\u0baf\u0bbe\u0b9f\u0bbf\u0bae\u0b9f\u0bc1 Hwy, \u0b95\u0bbf\u0bb0\u0bbf\u0ba4\u0bcd\u0ba4\u0bb2\u0bc7",
  },
  "Thirukkondaiadimadu Hwy, Welikanda": {
    si: "\u0dad\u0dd2\u0dbb\u0dd4\u0d9a\u0dca\u0d9a\u0ddc\u0dab\u0dca\u0da9\u0dd2\u0dba\u0dcf\u0da9\u0dd2\u0db8\u0da9\u0dd4 Hwy, \u0dc0\u0dd0\u0dbd\u0dd2\u0d9a\u0db1\u0dca\u0daf",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcd\u0b95\u0bca\u0ba3\u0bcd\u0b9f\u0bc8\u0baf\u0b9f\u0bbf\u0bae\u0b9f\u0bc1 Hwy, \u0bb5\u0bc6\u0bb2\u0bbf\u0b95\u0ba8\u0bcd\u0ba4",
  },
  Thissamaharamaya: {
    si: "\u0dad\u0dd2\u0dc3\u0dca\u0dc3\u0db8\u0dc4\u0dcf\u0dbb\u0dcf\u0db8\u0dba",
    ta: "\u0ba4\u0bbf\u0bb8\u0bae\u0bb9\u0bbe\u0bb0\u0bbe\u0bae\u0bbe\u0baf",
  },
  "Thoduwawa Road, Madurankuli, Kandathoduwawa": {
    si: "\u0dad\u0ddc\u0da9\u0dd4\u0dc0\u0dcf\u0dc0 \u0db4\u0dcf\u0dbb, \u0db8\u0daf\u0dd4\u0dbb\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0dd2\u0dba, \u0d9a\u0db1\u0dca\u0daf\u0dad\u0ddc\u0da9\u0dd4\u0dc0\u0dcf\u0dc0",
    ta: "\u0ba4\u0bca\u0b9f\u0bc1\u0bb5\u0bbe\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0ba4\u0bc1\u0bb0\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bbf, \u0b95\u0ba8\u0bcd\u0ba4\u0ba4\u0bca\u0b9f\u0bc1\u0bb5\u0bbe\u0bb5",
  },
  "Thoniyagala - Kalawewa - Galewela Rd, Makulugaswewa": {
    si: "\u0dad\u0ddd\u0db1\u0dd2\u0dba\u0dcf\u0d9c\u0dbd - \u0d9a\u0dbd\u0dcf\u0dc0\u0dd0\u0dc0 - \u0d9c\u0dbd\u0dda\u0dc0\u0dd9\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0d9a\u0dd4\u0dc5\u0dd4\u0d9c\u0dc3\u0dca\u0dc0\u0dd0\u0dc0",
    ta: "\u0ba4\u0bcb\u0ba9\u0bbf\u0baf\u0bbe\u0b95\u0bb2 - \u0b95\u0bb2\u0bb5\u0bc6\u0bb5 - \u0b95\u0bb2\u0bc7\u0bb5\u0bc6\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0b95\u0bc1\u0bb2\u0bc1\u0b95\u0bb8\u0bcd\u0bb5\u0bc6\u0bb5",
  },
  "Thopputota, Waikkal": {
    si: "\u0dad\u0ddc\u0db4\u0dca\u0db4\u0dd4\u0dad\u0ddc\u0da7, \u0dc0\u0dba\u0dd2\u0d9a\u0dca\u0d9a\u0dcf\u0dbd\u0dca",
    ta: "\u0ba4\u0bcb\u0baa\u0bcd\u0baa\u0bc1\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8, \u0bb5\u0bbe\u0baf\u0bcd\u0b95\u0bcd\u0b95\u0bbe\u0bb2\u0bcd",
  },
  "Thoppuwa Juction Clock Tower, Puttalam Road, Sri Lanka": {
    si: "\u0dad\u0ddd\u0db4\u0dca\u0db4\u0dd4\u0dc0 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba \u0d94\u0dbb\u0dbd\u0ddd\u0dc3\u0dd4 \u0d9a\u0dab\u0dd4\u0dc0, \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba4\u0bcb\u0baa\u0bcd\u0baa\u0bc1\u0bb5 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf \u0bae\u0ba3\u0bbf\u0b95\u0bcd\u0b95\u0bc2\u0ba3\u0bcd\u0b9f\u0bc1, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Thulhiriya: {
    si: "\u0dad\u0dd4\u0dbd\u0dca\u0dc4\u0dd2\u0dbb\u0dd2\u0dba",
    ta: "\u0ba4\u0bc1\u0bb2\u0bcd\u0bb9\u0bbf\u0bb0\u0bbf\u0baf\u0bbe",
  },
  "Thumpane, Galagedara": {
    si: "\u0dad\u0dd4\u0db8\u0dca\u0db4\u0db1\u0dda, \u0d9c\u0dbd\u0d9c\u0dd9\u0daf\u0dbb",
    ta: "\u0ba4\u0bc1\u0bae\u0bcd\u0baa\u0ba9\u0bc7, \u0b95\u0bb2\u0b95\u0bc6\u0ba4\u0bb0",
  },
  "Thunkama Filling Station, A18 Embilipitiya - Nonagama Hwy, Road Thunkama-Embilipitiya":
    {
      si: "\u0dad\u0dd4\u0db1\u0dca\u0d9a\u0db8 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, A18 \u0d87\u0db9\u0dd2\u0dbd\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba - \u0db1\u0ddd\u0db1\u0dcf\u0d9c\u0db8 Hwy, \u0db4\u0dcf\u0dbb \u0dad\u0dd4\u0db1\u0dca\u0d9a\u0db8-\u0d87\u0db9\u0dd2\u0dbd\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba",
      ta: "\u0ba4\u0bc1\u0b99\u0bcd\u0b95\u0bae \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, A18 \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0bb2\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf - \u0ba8\u0bcb\u0ba9\u0bbe\u0b95\u0bae Hwy, \u0bb5\u0bc0\u0ba4\u0bbf \u0ba4\u0bc1\u0b99\u0bcd\u0b95\u0bae-\u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0bb2\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
    },
  "Tiruwanaketiya - Agalawatte Rd, Nivithigala": {
    si: "\u0dad\u0dd2\u0dbb\u0dd4\u0dc0\u0dcf\u0db1\u0dcf\u0d9a\u0dd0\u0da7\u0dd2\u0dba - \u0d85\u0d9c\u0dbd\u0dc0\u0dad\u0dca\u0dad \u0db4\u0dcf\u0dbb, \u0db1\u0dd2\u0dc0\u0dd2\u0dad\u0dd2\u0d9c\u0dbd",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bb5\u0ba9\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf - \u0b85\u0b95\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bbf\u0bb5\u0bbf\u0ba4\u0bcd\u0ba4\u0bbf\u0b95\u0bb2",
  },
  "Tiruwanaketiya-agalawatte Rd, Bellana": {
    si: "\u0dad\u0dd2\u0dbb\u0dd4\u0dc0\u0dcf\u0db1\u0dcf\u0d9a\u0dd0\u0da7\u0dd2\u0dba-\u0d85\u0d9c\u0dbd\u0dc0\u0dad\u0dca\u0dad \u0db4\u0dcf\u0dbb, \u0db6\u0dd9\u0dbd\u0dca\u0dbd\u0db1",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bb5\u0ba9\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf-\u0b85\u0b95\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe\u0ba9",
  },
  "Tiruwanaketiya-agalawatte Rd, Kalawana": {
    si: "\u0dad\u0dd2\u0dbb\u0dd4\u0dc0\u0dcf\u0db1\u0dcf\u0d9a\u0dd0\u0da7\u0dd2\u0dba-\u0d85\u0d9c\u0dbd\u0dc0\u0dad\u0dca\u0dad \u0db4\u0dcf\u0dbb, \u0d9a\u0dbd\u0dc0\u0dcf\u0db1",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0bb5\u0ba9\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf-\u0b85\u0b95\u0bb2\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb2\u0bb5\u0bbe\u0ba9",
  },
  Tissamaharama: {
    si: "\u0dad\u0dd2\u0dc3\u0dca\u0dc3\u0db8\u0dc4\u0dcf\u0dbb\u0dcf\u0db8",
    ta: "\u0ba4\u0bbf\u0bb8\u0bcd\u0bb8\u0bae\u0bb9\u0bbe\u0bb0\u0bbe\u0bae",
  },
  "Tissamaharama - Yodakandiya": {
    si: "\u0dad\u0dd2\u0dc3\u0dca\u0dc3\u0db8\u0dc4\u0dcf\u0dbb\u0dcf\u0db8 - \u0dba\u0ddd\u0daf\u0d9a\u0dab\u0dca\u0da9\u0dd2\u0dba",
    ta: "\u0ba4\u0bbf\u0bb8\u0bcd\u0bb8\u0bae\u0bb9\u0bbe\u0bb0\u0bbe\u0bae - \u0baf\u0bcb\u0ba4\u0b95\u0ba3\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Tissamaharama Rd, Debarawewa": {
    si: "Tissamaharama Rd, Debarawewa",
    ta: "Tissamaharama Rd, Debarawewa",
  },
  "Tittawella-gonagama Rd, Kurunegala": {
    si: "\u0dad\u0dd2\u0dad\u0dca\u0dad\u0dc0\u0dd0\u0dbd\u0dca\u0dbd-\u0d9c\u0ddd\u0db1\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd",
    ta: "\u0ba4\u0bbf\u0b9f\u0bcd\u0b9f\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2-\u0b95\u0bcb\u0ba9\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd",
  },
  "Toppuwa - Madampe Rd": {
    si: "Toppuwa - Madampe Rd",
    ta: "\u0ba4\u0bcb\u0baa\u0bcd\u0baa\u0bc1\u0bb5 - \u0bae\u0bbe\u0ba4\u0bae\u0bcd\u0baa\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  "Toppuwa - Madampe Rd, Dankotuwa": {
    si: "\u0dad\u0ddc\u0db4\u0dca\u0db4\u0dd4\u0dc0 - \u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda \u0db4\u0dcf\u0dbb, \u0daf\u0d82\u0d9a\u0ddc\u0da7\u0dd4\u0dc0",
    ta: "\u0ba4\u0bcb\u0baa\u0bcd\u0baa\u0bc1\u0bb5 - \u0bae\u0bbe\u0ba4\u0bae\u0bcd\u0baa\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0b99\u0bcd\u0b95\u0bca\u0b9f\u0bc1\u0bb5",
  },
  "Toppuwa - Madampe Rd, Nattandiya": {
    si: "Toppuwa - Madampe Rd, Nattandiya",
    ta: "\u0ba4\u0bcb\u0baa\u0bcd\u0baa\u0bc1\u0bb5 - \u0bae\u0bbe\u0ba4\u0bae\u0bcd\u0baa\u0bc7 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba8\u0bbe\u0ba4\u0bcd\u0ba4\u0bbe\u0ba3\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Tricomalee Chinabay Terminal": {
    si: "\u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba \u0da0\u0dd3\u0db1 \u0dc0\u0dbb\u0dcf\u0dba \u0db4\u0dbb\u0dca\u0dba\u0db1\u0dca\u0dad\u0dba",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 \u0b9a\u0bc0\u0ba9\u0b95\u0bcd\u0b95\u0bc1\u0b9f\u0bbe \u0bae\u0bc1\u0ba9\u0bc8\u0baf\u0bae\u0bcd",
  },
  "Trinco Rd, Batticaloa": {
    si: "\u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd \u0db4\u0dcf\u0dbb, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1",
  },
  Trincomalee: {
    si: "\u0dad\u0dca\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8",
  },
  "Trincomalee - Codbay": {
    si: "\u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba - \u0d9a\u0ddd\u0da9\u0dca\u0db6\u0dda",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 - \u0b95\u0bcb\u0b9f\u0bcd\u0baa\u0bc7",
  },
  "Trincomalee Hwy Road Kiran": {
    si: "\u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba Hwy \u0db4\u0dcf\u0dbb \u0d9a\u0dd2\u0dbb\u0db1\u0dca",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 Hwy \u0bb5\u0bc0\u0ba4\u0bbf \u0b95\u0bbf\u0bb0\u0ba3\u0bcd",
  },
  "Trincomalee Hwy, Batticaloa": {
    si: "\u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 Hwy, \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1",
  },
  "Trincomalee Hwy, Chenkaladi": {
    si: "\u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf",
  },
  "Trincomalee Hwy, Eravur": {
    si: "\u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0d91\u0dbb\u0dcf\u0dc0\u0dd4\u0dbb\u0dca",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 Hwy, \u0b8f\u0bb1\u0bbe\u0bb5\u0bc2\u0bb0\u0bcd",
  },
  "Trincomalee Hwy, Mutur": {
    si: "\u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0db8\u0dd4\u0dad\u0dd6\u0dbb\u0dca",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 Hwy, \u0bae\u0bc2\u0ba4\u0bc2\u0bb0\u0bcd",
  },
  "Trincomalee Hwy,Vakarai": {
    si: "\u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba, \u0dc0\u0dcf\u0d9a\u0dbb\u0dda",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0bb5\u0bbe\u0b95\u0bb0\u0bc8",
  },
  "Trincomalee Rd, Anuradhapura": {
    si: "\u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba \u0db4\u0dcf\u0dbb, \u0d85\u0db1\u0dd4\u0dbb\u0dcf\u0db0\u0db4\u0dd4\u0dbb",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0ba9\u0bc1\u0bb0\u0bbe\u0ba4\u0baa\u0bc1\u0bb0\u0bae\u0bcd",
  },
  "Trincomalee Rd, Karuwalagaswewa, Tabbowa": {
    si: "\u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba \u0db4\u0dcf\u0dbb, \u0d9a\u0dbb\u0dd4\u0dc0\u0dbd\u0d9c\u0dc3\u0dca\u0dc0\u0dd0\u0dc0, \u0dad\u0db6\u0dca\u0db6\u0ddd\u0dc0",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb0\u0bc1\u0bb5\u0bb2\u0b95\u0bb8\u0bcd\u0bb5\u0bc6\u0bb5, \u0ba4\u0baa\u0bcd\u0baa\u0bcb\u0bb5",
  },
  "Trincomalee Road, Kahatagasdigiliya": {
    si: "\u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd\u0dba \u0db4\u0dcf\u0dbb, \u0d9a\u0dc4\u0da7\u0d9c\u0dc3\u0dca\u0daf\u0dd2\u0d9c\u0dd2\u0dbd\u0dd2\u0dba",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bb9\u0b9f\u0b95\u0bb8\u0bcd\u0ba4\u0bbf\u0b95\u0bbf\u0bb2\u0bbf\u0baf",
  },
  "Trincomalee Street, Matale": {
    si: "\u0dad\u0dca\u200d\u0dbb\u0dd2\u0d9a\u0dd4\u0dab\u0dcf\u0db8\u0dbd \u0dc0\u0dd3\u0daf\u0dd2\u0dba, \u0db8\u0dcf\u0dad\u0dbd\u0dda",
    ta: "\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcb\u0ba3\u0bae\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8",
  },
  "U D T N SOMARATNA": {
    si: "\u0dba\u0dd6 \u0da9\u0dd3 \u0da7\u0dd3 \u0d91\u0db1\u0dca \u0dc3\u0ddd\u0db8\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0baf\u0bc1 \u0b9f\u0bbf \u0b9f\u0bbf \u0b8e\u0ba9\u0bcd \u0b9a\u0bcb\u0bae\u0bb0\u0ba4\u0bcd\u0ba9\u0bbe",
  },
  "U L A.HAMEED": {
    si: "\u0dba\u0dd6 \u0d91\u0dbd\u0dca \u0d92 \u0dc4\u0db8\u0dd3\u0da9\u0dca",
    ta: "\u0baf\u0bc1 \u0b8e\u0bb2\u0bcd \u0b8f.\u0bb9\u0bae\u0bc0\u0ba4\u0bcd",
  },
  "U L CHANDANA MITHSEN": {
    si: "\u0dba\u0dd6 \u0d91\u0dbd\u0dca \u0da0\u0db1\u0dca\u0daf\u0db1 \u0db8\u0dd2\u0dad\u0dca\u0dc3\u0dd9\u0db1\u0dca",
    ta: "\u0baf\u0bc1 \u0b8e\u0bb2\u0bcd \u0b9a\u0ba8\u0bcd\u0ba4\u0ba9\u0bbe \u0bae\u0bbf\u0ba4\u0bcd\u0b9a\u0bc6\u0ba9\u0bcd",
  },
  "U L U SHANTHA": {
    si: "\u0dba\u0dd6 \u0d91\u0dbd\u0dca \u0dba\u0dd6 \u0dc1\u0dcf\u0db1\u0dca\u0dad",
    ta: "\u0baf\u0bc1 \u0b8e\u0bb2\u0bcd \u0baf\u0bc1 \u0b9a\u0bbe\u0ba8\u0bcd\u0ba4\u0bbe",
  },
  "U S Y AJITH KUMAR": {
    si: "\u0dba\u0dd6 \u0d91\u0dc3\u0dca \u0dc0\u0dba\u0dd2 \u0d85\u0da2\u0dd2\u0dad\u0dca \u0d9a\u0dd4\u0db8\u0dcf\u0dbb",
    ta: "\u0baf\u0bc1 \u0b8e\u0bb8\u0bcd \u0b92\u0baf\u0bcd \u0b85\u0b9c\u0bbf\u0ba4\u0bcd \u0b95\u0bc1\u0bae\u0bbe\u0bb0\u0bcd",
  },
  "U.A.KURUPPUARACHCHI": {
    si: "\u0dba\u0dd6.\u0d92.\u0d9a\u0dd4\u0dbb\u0dd4\u0db4\u0dca\u0db4\u0dd4\u0d86\u0dbb\u0da0\u0dca\u0da0\u0dd2",
    ta: "\u0b89.\u0b86.\u0b95\u0bc1\u0bb0\u0bc1\u0baa\u0bcd\u0baa\u0bc1\u0b86\u0bb0\u0bbe\u0b9a\u0bcd\u0b9a\u0bbf",
  },
  "U.B.ABEYSUNDERA": {
    si: "\u0dba\u0dd6.\u0db6\u0dd3.\u0d85\u0db6\u0dda\u0dc3\u0dd4\u0db1\u0dca\u0daf\u0dbb",
    ta: "\u0baf\u0bc2.\u0baa\u0bbf.\u0b85\u0baa\u0bc7\u0baf\u0b9a\u0bc1\u0ba8\u0bcd\u0ba4\u0bb0",
  },
  "U.D. GAMAGE": {
    si: "\u0dba\u0dd6.\u0da9\u0dd3. \u0d9c\u0db8\u0d9c\u0dda",
    ta: "\u0baf\u0bc1.\u0b9f\u0bbf. GAMAGE",
  },
  "U.G.M.SAMAN KUMARA": {
    si: "\u0dba\u0dd6.\u0da2\u0dd3.\u0d91\u0db8\u0dca.\u0dc3\u0db8\u0db1\u0dca \u0d9a\u0dd4\u0db8\u0dcf\u0dbb",
    ta: "\u0baf\u0bc1.\u0b9c\u0bbf.\u0b8e\u0bae\u0bcd.\u0b9a\u0bae\u0ba9\u0bcd \u0b95\u0bc1\u0bae\u0bbe\u0bb0",
  },
  "U.K.BUDDHADASA SILVA": {
    si: "\u0dba\u0dd6.\u0d9a\u0dda.\u0db6\u0dd4\u0daf\u0dca\u0db0\u0daf\u0dcf\u0dc3 \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf",
    ta: "\u0baf\u0bc1.\u0b95\u0bc7.\u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0ba4\u0bbe\u0b9a \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe",
  },
  "U.S.G. TRADING (PVT) LTD": {
    si: "\u0dba\u0dd6.\u0d91\u0dc3\u0dca.\u0da2\u0dd3. TRADING (PVT) LTD",
    ta: "\u0baf\u0bc1.\u0b8e\u0bb8\u0bcd.\u0b9c\u0bbf. \u0b9f\u0bbf\u0bb0\u0bc7\u0b9f\u0bbf\u0b99\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "UDAPALATHA MPCS LTD": {
    si: "\u0d8b\u0da9\u0db4\u0dbd\u0dcf\u0dad MPCS LTD",
    ta: "\u0b89\u0b9f\u0baa\u0bb2\u0ba4\u0bbe MPCS LTD",
  },
  "UDAYANTHA JAGATH MANCHANAYAKE": {
    si: "\u0d8b\u0daf\u0dba\u0db1\u0dca\u0dad \u0da2\u0d9c\u0dad\u0dca \u0db8\u0d82\u0da0\u0db1\u0dcf\u0dba\u0d9a",
    ta: "\u0b89\u0ba4\u0baf\u0ba8\u0bcd\u0ba4 \u0b9c\u0b95\u0ba4\u0bcd \u0bae\u0b9e\u0bcd\u0b9a\u0ba8\u0bbe\u0baf\u0b95\u0bc7",
  },
  "UDUBADDAWA MPCS LTD": {
    si: "UDUBADDAWA MPCS LTD",
    ta: "\u0b89\u0b9f\u0bc1\u0baa\u0ba4\u0bcd\u0ba4\u0bbe\u0bb5\u0bbe MPCS LTD",
  },
  "UDUMAN  FAROOK": {
    si: "\u0d8b\u0daf\u0dd4\u0db8\u0db1\u0dca \u0dc6\u0dcf\u0dbb\u0dd4\u0d9a\u0dca",
    ta: "\u0b89\u0ba4\u0bc1\u0bae\u0bbe\u0ba9\u0bcd \u0baa\u0bbe\u0bb0\u0bc2\u0b95\u0bcd",
  },
  "UDUPIDDY MPCS LTD": {
    si: "UDUPIDDY MPCS LTD",
    ta: "\u0b89\u0b9f\u0bc1\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf MPCS LTD",
  },
  "UNITED BOLTS &ACCESSORIES(PVT)LTD": {
    si: "UNITED BOLTS & Accessories(PVT)LTD",
    ta: "\u0baf\u0bc1\u0ba9\u0bc8\u0b9f\u0bc6\u0b9f\u0bcd \u0baa\u0bcb\u0bb2\u0bcd\u0b9f\u0bcd\u0bb8\u0bcd & \u0b85\u0b95\u0bcd\u0b9a\u0bb8\u0bb0\u0bc0\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "UNITED FUEL MART  (PVT) LTD": {
    si: "UNITED FUEL MART (PVT) LTD",
    ta: "\u0baf\u0bc1\u0ba9\u0bc8\u0b9f\u0bc6\u0b9f\u0bcd \u0b83\u0baa\u0bcd\u0baf\u0bc2\u0bb2\u0bcd \u0bae\u0bbe\u0bb0\u0bcd\u0b9f\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "UPUL MUDALIGE": {
    si: "\u0d8b\u0db4\u0dd4\u0dbd\u0dca \u0db8\u0dd4\u0daf\u0dbd\u0dd2\u0d9c\u0dda",
    ta: "\u0b89\u0baa\u0bc1\u0bb2\u0bcd \u0bae\u0bc1\u0ba4\u0bb2\u0bbf\u0b95\u0bc7",
  },
  "UVA PARANAGAMA SOUTH MPCS LTD": {
    si: "\u0d8c\u0dc0 \u0db4\u0dbb\u0dab\u0d9c\u0db8 \u0daf\u0d9a\u0dd4\u0dab\u0dd4 MPCS LTD",
    ta: "\u0b8a\u0bb5\u0bbe \u0baa\u0bb0\u0ba3\u0b95\u0bae \u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1 MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "Udaganawa Junction,Buttala": {
    si: "\u0d8b\u0da9\u0d9c\u0db1\u0dcf\u0dc0 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0db6\u0dd4\u0dad\u0dca\u0dad\u0dbd",
    ta: "\u0b89\u0b9f\u0b95\u0ba9\u0bbe\u0bb5 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3",
  },
  "Udapussellawa - Welimada Road, Udupussellawa": {
    si: "\u0d8b\u0da9\u0db4\u0dd4\u0dc3\u0dca\u0dc3\u0dd0\u0dbd\u0dca\u0dbd\u0dcf\u0dc0 - \u0dc0\u0dd0\u0dbd\u0dd2\u0db8\u0da9 \u0db4\u0dcf\u0dbb, \u0d8b\u0da9\u0dd4\u0db4\u0dd4\u0dc3\u0dca\u0dc3\u0dd0\u0dbd\u0dca\u0dbd\u0dcf\u0dc0",
    ta: "\u0b89\u0b9f\u0baa\u0bc1\u0bb8\u0bcd\u0bb8\u0bb2\u0bcd\u0bb2\u0bbe\u0bb5 - \u0bb5\u0bc6\u0bb2\u0bbf\u0bae\u0b9f \u0bb5\u0bc0\u0ba4\u0bbf, \u0b89\u0b9f\u0bc1\u0baa\u0bc1\u0bb8\u0bcd\u0bb8\u0bb2\u0bcd\u0bb2\u0bbe\u0bb5",
  },
  Udawalawa: {
    si: "\u0d8b\u0da9\u0dc0\u0dbd\u0dc0",
    ta: "\u0b89\u0b9f\u0bb5\u0bb2\u0bb5",
  },
  "Udesh Filling Station, Palapathwela": {
    si: "\u0d8b\u0daf\u0dda\u0dc1\u0dca \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0db4\u0dbd\u0dcf\u0db4\u0dad\u0dca\u0dc0\u0dd9\u0dbd",
    ta: "\u0b89\u0ba4\u0bc7\u0bb7\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0baa\u0bb2\u0baa\u0ba4\u0bcd\u0bb5\u0bc6\u0bb2",
  },
  Udubaddawa: {
    si: "\u0d8b\u0da9\u0dd4\u0db6\u0daf\u0dca\u0daf\u0dcf\u0dc0",
    ta: "\u0b89\u0b9f\u0bc1\u0baa\u0ba4\u0bcd\u0ba4\u0bbe\u0bb5\u0bbe",
  },
  "Udubaddawa Rd": {
    si: "\u0d8b\u0da9\u0dd4\u0db6\u0daf\u0dca\u0daf\u0dcf\u0dc0 \u0db4\u0dcf\u0dbb",
    ta: "\u0b89\u0b9f\u0bc1\u0baa\u0ba4\u0bcd\u0ba4\u0bbe\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  Udugama: {
    si: "\u0d8b\u0da9\u0dd4\u0d9c\u0db8",
    ta: "\u0b89\u0b9f\u0bc1\u0b95\u0bae",
  },
  "Uduwila-Batapola": {
    si: "\u0d8b\u0da9\u0dd4\u0dc0\u0dd2\u0dbd-\u0db6\u0da7\u0db4\u0ddc\u0dbd",
    ta: "\u0b89\u0b9f\u0bc1\u0bb5\u0bbf\u0bb2-\u0baa\u0b9f\u0baa\u0bca\u0bb2",
  },
  Uhana: {
    si: "\u0d8b\u0dc4\u0db1",
    ta: "\u0b89\u0bb9\u0bbe\u0ba9\u0bbe",
  },
  Ukuwela: {
    si: "\u0d8b\u0d9a\u0dd4\u0dc0\u0dd9\u0dbd",
    ta: "\u0b89\u0b95\u0bc1\u0bb5\u0bc6\u0bb2",
  },
  "Unawatuna Junction - Buttala": {
    si: "\u0d8b\u0dab\u0dc0\u0da7\u0dd4\u0db1 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba - \u0db6\u0dd4\u0dad\u0dca\u0dad\u0dbd",
    ta: "\u0b89\u0ba9\u0bb5\u0b9f\u0bc1\u0ba9 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf - \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb2",
  },
  Urala: {
    si: "\u0d8c\u0dbb\u0dbd",
    ta: "\u0b89\u0bb0\u0bb2",
  },
  Urumpirai: {
    si: "\u0d8b\u0dbb\u0dd4\u0db8\u0dca\u0db4\u0dd2\u0dbb\u0dcf\u0dba\u0dd2",
    ta: "\u0b89\u0bb0\u0bc1\u0bae\u0bcd\u0baa\u0bbf\u0bb0\u0bbe\u0baf\u0bcd",
  },
  "Uyilankulam, Adampan": {
    si: "\u0d8b\u0dba\u0dd2\u0dbd\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca, \u0d85\u0da9\u0db8\u0dca\u0db4\u0db1\u0dca",
    ta: "\u0b89\u0baf\u0bbf\u0bb2\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd, \u0b85\u0b9f\u0bae\u0bcd\u0baa\u0ba9\u0bcd",
  },
  "V L GUNATHILAKE": {
    si: "\u0dc0\u0dd3 \u0d91\u0dbd\u0dca \u0d9c\u0dd4\u0dab\u0dad\u0dd2\u0dbd\u0d9a",
    ta: "\u0bb5\u0bbf \u0b8e\u0bb2\u0bcd \u0b95\u0bc1\u0ba3\u0ba4\u0bbf\u0bb2\u0b95\u0bc7",
  },
  "V PARAMESHWARY": {
    si: "\u0dc0\u0dd3 \u0db4\u0dbb\u0db8\u0dda\u0dc1\u0dca\u0dc0\u0dbb\u0dd2",
    ta: "\u0bb5\u0bbf \u0baa\u0bb0\u0bae\u0bc7\u0bb8\u0bcd\u0bb5\u0bb0\u0bbf",
  },
  "V.R.H LANKA IOC FILLING STATION": {
    si: "V.R.H LANKA IOC \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "V.R.H \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8 IOC \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1\u0bae\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "V.W.M.GAMINI ANURA": {
    si: "\u0dc0\u0dd3.\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0d91\u0db8\u0dca.\u0d9c\u0dcf\u0db8\u0dd2\u0dab\u0dd3 \u0d85\u0db1\u0dd4\u0dbb",
    ta: "\u0bb5\u0bbf.\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0b8e\u0bae\u0bcd.\u0b95\u0bbe\u0bae\u0bbf\u0ba9\u0bbf \u0b85\u0ba9\u0bc1\u0bb0\u0bbe",
  },
  "V22J+GG4, Colombo - Batticaloa Hwy, Godagama, Sri Lanka": {
    si: "V22J+GG4, \u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 Hwy, \u0d9c\u0ddc\u0da9\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "V22J+GG4, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, \u0b95\u0bca\u0b9f\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "V2G6+QR4, Anamaduwa, Sri Lanka": {
    si: "V2G6+QR4, \u0d86\u0dab\u0db8\u0da9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "V2G6+QR4, \u0b86\u0ba9\u0bae\u0b9f\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "V2H6+RQF, B19, Anamaduwa, Sri Lanka": {
    si: "V2H6+RQF, B19, \u0d86\u0dab\u0db8\u0da9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "V2H6+RQF, B19, \u0b86\u0ba9\u0bae\u0b9f\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "V2PR+P7P, Sri Lanka": {
    si: "V2PR+P7P, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "V2PR+P7P, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "V2RP+3JV, Jaya Mawatha, Sri Lanka": {
    si: "V2RP+3JV, \u0da2\u0dba \u0db8\u0dcf\u0dc0\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "V2RP+3JV, \u0b9c\u0bc6\u0baf\u0bbe \u0bae\u0bbe\u0bb5\u0ba4\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "V345+4R4, Sri Lanka": {
    si: "V345+4R4, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "V345+4R4, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "V35R+8GR, Padukka, Sri Lanka": {
    si: "V35R+8GR, \u0db4\u0dcf\u0daf\u0dd4\u0d9a\u0dca\u0d9a, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "V35R+8GR, \u0baa\u0b9f\u0bc1\u0b95\u0bcd\u0b95\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "V3PQ+G2W, Hanwella, Sri Lanka": {
    si: "V3PQ+G2W, \u0dc4\u0d82\u0dc0\u0dd0\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "V3PQ+G2W, \u0bb9\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "V4G6+4WJ, Namunukula, Sri Lanka": {
    si: "V4G6+4WJ, \u0db1\u0db8\u0dd4\u0dab\u0dd4\u0d9a\u0dd4\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "V4G6+4WJ, \u0ba8\u0bae\u0bc1\u0ba9\u0bc1\u0b95\u0bc1\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "V6FW+35G, Eheliyagoda, Sri Lanka": {
    si: "V6FW+35G, \u0d87\u0dc4\u0dd0\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "V6FW+35G, \u0b8e\u0bb9\u0bc6\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "V736+JF8, Eheliyagoda, Sri Lanka": {
    si: "V736+JF8, \u0d87\u0dc4\u0dd0\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "V736+JF8, \u0b8e\u0bb9\u0bc6\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "V84Q+CV8, Colombo - Batticaloa Hwy, Hulandawa, Sri Lanka": {
    si: "V84Q+CV8, \u0d9a\u0ddc\u0dc5\u0db9 - \u0db8\u0da9\u0d9a\u0dbd\u0db4\u0dd4\u0dc0 Hwy, Hulandawa, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "V84Q+CV8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bae\u0b9f\u0bcd\u0b9f\u0b95\u0bcd\u0b95\u0bb3\u0baa\u0bcd\u0baa\u0bc1 Hwy, Hulandawa, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "V87V+CWV, A4, Monaragala, Sri Lanka": {
    si: "V87V+CWV, A4, Monaragala, Sri Lanka",
    ta: "V87V+CWV, A4, \u0bae\u0bca\u0ba9\u0bb0\u0bbe\u0b95\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "V8CX+QXH, Monaragala, Sri Lanka": {
    si: "V8CX+QXH, \u0db8\u0ddc\u0db1\u0dbb\u0dcf\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "V8CX+QXH, \u0bae\u0bca\u0ba9\u0bb0\u0bbe\u0b95\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VALI EAST NORTHERN DIVISION MPCS LT": {
    si: "\u0dc0\u0dbd\u0dd2 \u0db1\u0dd0\u0d9c\u0dd9\u0db1\u0dc4\u0dd2\u0dbb \u0d8b\u0dad\u0dd4\u0dbb\u0dd4 \u0d85\u0d82\u0dc1\u0dba MPCS LT",
    ta: "\u0bb5\u0bb2\u0bbf \u0b95\u0bbf\u0bb4\u0b95\u0bcd\u0b95\u0bc1 \u0bb5\u0b9f\u0b95\u0bcd\u0b95\u0bc1 \u0baa\u0bbf\u0bb0\u0bbf\u0bb5\u0bc1 MPCS LT",
  },
  "VALLI EAST SOUTHERN DIVISION MPCS L": {
    si: "\u0dc0\u0dbd\u0dca\u0dbd\u0dd2 \u0db1\u0dd0\u0d9c\u0dd9\u0db1\u0dc4\u0dd2\u0dbb \u0daf\u0d9a\u0dd4\u0dab\u0dd4 \u0d9a\u0ddc\u0da7\u0dca\u0da8\u0dcf\u0dc3\u0dba MPCS \u0d91\u0dbd\u0dca",
    ta: "\u0bb5\u0bb3\u0bcd\u0bb3\u0bbf \u0b95\u0bbf\u0bb4\u0b95\u0bcd\u0b95\u0bc1 \u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1 \u0baa\u0bbf\u0bb0\u0bbf\u0bb5\u0bc1 \u0b8e\u0bae\u0bcd.\u0baa\u0bbf.\u0b9a\u0bbf.\u0b8e\u0bb8\u0bcd \u0b8e\u0bb2\u0bcd",
  },
  "VAVUNAYA  SOUTH  MPCS  LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dc0\u0dc0\u0dca\u0db1\u0dcf\u0dba \u0daf\u0d9a\u0dd4\u0dab\u0dd4 MPCS",
    ta: "\u0bb5\u0bb5\u0bc1\u0ba3\u0bbe\u0baf \u0ba4\u0bc6\u0bb1\u0bcd\u0b95\u0bc1 MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "VAVUNIYA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0 MPCS",
    ta: "\u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe MPCS LTD",
  },
  "VAVUNIYA NORTH MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0 \u0db1\u0ddd\u0dbb\u0dca\u0dad\u0dca \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe \u0bb5\u0b9f\u0b95\u0bcd\u0b95\u0bc1 MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "VELANAI MPCS LTD": {
    si: "VELANAI MPCS LTD",
    ta: "\u0bb5\u0bc7\u0bb2\u0ba9\u0bc8 MPCS LTD",
  },
  "VELRO ENTERPRISES (PVT) LTD": {
    si: "VELRO ENTERPRISES (PVT) LTD",
    ta: "\u0bb5\u0bc6\u0bb2\u0bcd\u0bb0\u0bcb \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "VENGALA  CHEDDIKULAM   MPCS  LTD": {
    si: "Vengala Cheddikulam MPCS LTD",
    ta: "\u0bb5\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0bbe \u0b9a\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bc1\u0bb3\u0bae\u0bcd MPCS LTD",
  },
  "VG4V+G8 Thavapuram, Sri Lanka": {
    si: "VG4V+G8 \u0dad\u0dc0\u0db4\u0dd4\u0dbb\u0db8\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VG4V+G8 \u0ba4\u0bb5\u0baa\u0bc1\u0bb0\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VG6Q+PR5, Sri Lanka": {
    si: "VG6Q+PR5, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VG6Q+PR5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VG93+F3Q, Omanthai, Sri Lanka": {
    si: "VG93+F3Q, \u0d95\u0db8\u0db1\u0dca\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VG93+F3Q, \u0b93\u0bae\u0ba8\u0bcd\u0ba4\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VICTORIA FUEL MERCHANT (PVT) LTD": {
    si: "VICTORIA FUEL MERCHANT (PVT) LTD",
    ta: "\u0bb5\u0bbf\u0b95\u0bcd\u0b9f\u0bcb\u0bb0\u0bbf\u0baf\u0bbe \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0bb5\u0ba3\u0bbf\u0b95\u0bb0\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "VIHANGA DISTRIBUTORS (PVT) LTD": {
    si: "VIHANGA DISTRIBUTORS (PVT) LTD",
    ta: "\u0bb5\u0bbf\u0bb9\u0b99\u0bcd\u0b95\u0bbe \u0b9f\u0bbf\u0bb8\u0bcd\u0b9f\u0bcd\u0bb0\u0bbf\u0baa\u0bbf\u0baf\u0bc2\u0b9f\u0bcd\u0b9f\u0bb0\u0bcd\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "VIJAYA SERVICE STATION (PVT) LTD": {
    si: "\u0dc0\u0dd2\u0da2\u0dba \u0dc3\u0dbb\u0dca\u0dc0\u0dd2\u0dc3\u0dca \u0dc3\u0dca\u0da7\u0dda\u0dc2\u0db1\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0bb5\u0bbf\u0b9c\u0baf\u0bbe \u0b9a\u0bb0\u0bcd\u0bb5\u0bc0\u0bb8\u0bcd \u0bb8\u0bcd\u0b9f\u0bc7\u0bb7\u0ba9\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "VIJITHA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dc0\u0dd2\u0da2\u0dd2\u0dad \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca",
    ta: "\u0bb5\u0bbf\u0b9c\u0bbf\u0ba4\u0bbe \u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0b9a\u0bbf\u0b8e\u0bb8\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "VILATHTHAWA -PULIYAMKADAWALA": {
    si: "\u0dc0\u0dd2\u0dbd\u0dad\u0dca\u0dad\u0dc0 -\u0db4\u0dd4\u0dbd\u0dd2\u0dba\u0db8\u0dca\u0d9a\u0da9\u0dc0\u0dbd",
    ta: "\u0bb5\u0bbf\u0bb3\u0ba4\u0bcd\u0ba4\u0bbe\u0bb5 -\u0baa\u0bc1\u0bb3\u0bbf\u0baf\u0bae\u0bcd\u0b95\u0b9f\u0bb5\u0bb2",
  },
  "VISVAMADHU FARMER'SMPCSLTD": {
    si: "\u0dc0\u0dd2\u0dc1\u0dca\u0dc0\u0db8\u0db0\u0dd4 \u0dc6\u0dcf\u0db8\u0dbb\u0dca'SMPCSLTD",
    ta: "\u0bb5\u0bbf\u0bb8\u0bcd\u0bb5\u0bae\u0ba4\u0bc1 \u0b83\u0baa\u0bbe\u0bb0\u0bcd\u0bae\u0bb0\u0bcd\u0bb8\u0bcd \u0b8e\u0bb8\u0bcd\u0b8e\u0bae\u0bcd\u0baa\u0bbf\u0b9a\u0bbf\u0b8e\u0bb8\u0bcd\u0b8e\u0bb2\u0bcd\u0b9f\u0bbf",
  },
  "VIYALUWA MPCS LTD": {
    si: "\u0dc0\u0dd2\u0dba\u0dc5\u0dd4\u0dc0 MPCS LTD",
    ta: "\u0bb5\u0bbf\u0baf\u0bb2\u0bc1\u0bb5\u0bbe MPCS LTD",
  },
  "VJRX+23P, Dambulla, Sri Lanka": {
    si: "VJRX+23P, \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VJRX+23P, \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VMP2+2F4, Dambulla, Sri Lanka": {
    si: "VMP2+2F4, \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VMP2+2F4, \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VQV5+46 Viruthodai, Sri Lanka": {
    si: "VQV5+46 \u0dc0\u0dd2\u0dbb\u0dd4\u0dad\u0ddd\u0da9\u0dba\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VQV5+46 \u0bb5\u0bbf\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bcb\u0b9f\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VR8M+Q32, B374, Pottuvil, Sri Lanka": {
    si: "VR8M+Q32, B374, \u0db4\u0ddc\u0dad\u0dd4\u0dc0\u0dd2\u0dbd\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VR8M+Q32, B374, \u0baa\u0bca\u0ba4\u0bcd\u0ba4\u0bc1\u0bb5\u0bbf\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VRFH+MXH, Pottuvil, Sri Lanka": {
    si: "VRFH+MXH, \u0db4\u0ddc\u0dad\u0dd4\u0dc0\u0dd2\u0dbd\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VRFH+MXH, \u0baa\u0bca\u0ba4\u0bcd\u0ba4\u0bc1\u0bb5\u0bbf\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VRHH+3HP, Pottuvil, Sri Lanka": {
    si: "VRHH+3HP, \u0db4\u0ddc\u0dad\u0dd4\u0dc0\u0dd2\u0dbd\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VRHH+3HP, \u0baa\u0bca\u0ba4\u0bcd\u0ba4\u0bc1\u0bb5\u0bbf\u0bb2\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VRXC+H3 Madurankuli, Sri Lanka": {
    si: "VRXC+H3 \u0db8\u0daf\u0dd4\u0dbb\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VRXC+H3 \u0bae\u0ba4\u0bc1\u0bb0\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VV38+H9P, Dehiwala-Mount Lavinia, Sri Lanka": {
    si: "VV38+H9P, \u0daf\u0dd9\u0dc4\u0dd2\u0dc0\u0dbd-\u0d9c\u0dbd\u0dca\u0d9a\u0dd2\u0dc3\u0dca\u0dc3, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VV38+H9P, \u0ba4\u0bc6\u0bb9\u0bbf\u0bb5\u0bb3\u0bc8-\u0b95\u0bb2\u0bcd\u0b95\u0bbf\u0b9a\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VVV9+Q2H, Peradeniya-Badulla-Chenkaladi Hwy, Keppetipola, Sri Lanka": {
    si: "VVV9+Q2H, \u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba-\u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd-\u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2 Hwy, \u0d9a\u0dd0\u0db4\u0dca\u0db4\u0dd9\u0da7\u0dd2\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VVV9+Q2H, \u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8-\u0baa\u0ba4\u0bc1\u0bb3\u0bc8-\u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf Hwy, \u0b95\u0bc6\u0baa\u0bcd\u0baa\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baa\u0bca\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VW37+PJW, Maharagama 10280, Sri Lanka": {
    si: "VW37+PJW, \u0db8\u0dc4\u0dbb\u0d9c\u0db8 10280, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VW37+PJW, \u0bae\u0bb9\u0bb0\u0b95\u0bae\u0bbe 10280, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VW45+VHF, Nugegoda, Sri Lanka": {
    si: "VW45+VHF, \u0db1\u0dd4\u0d9c\u0dda\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VW45+VHF, \u0ba8\u0bc1\u0b95\u0bc7\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VW7R+RQG, Battaramulla - Pannipitiya Rd, Sri Jayawardenepura Kotte 10230, Sri Lanka":
    {
      si: "VW7R+RQG, \u0db6\u0dad\u0dca\u0dad\u0dbb\u0db8\u0dd4\u0dbd\u0dca\u0dbd - \u0db4\u0db1\u0dca\u0db1\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1\u0db4\u0dd4\u0dbb \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda 10230, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "VW7R+RQG, \u0baa\u0ba4\u0bcd\u0ba4\u0bb0\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe - \u0baa\u0ba9\u0bcd\u0ba9\u0bbf\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0b9a\u0bbe\u0bb2\u0bc8, \u0bb8\u0bcd\u0bb0\u0bc0 \u0b9c\u0bc6\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0baa\u0bc1\u0bb0 \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7 10230, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "VWFP+CX2, B47, Sri Jayawardenepura Kotte, Sri Lanka": {
    si: "VWFP+CX2, B47, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1\u0db4\u0dd4\u0dbb \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VWFP+CX2, B47, \u0bb8\u0bcd\u0bb0\u0bc0 \u0b9c\u0bc6\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0baa\u0bc1\u0bb0 \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VWG2+F9J, Nugegoda, Sri Lanka": {
    si: "VWG2+F9J, \u0db1\u0dd4\u0d9c\u0dda\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VWG2+F9J, \u0ba8\u0bc1\u0b95\u0bc7\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VWJ8+CGP, Sri Jayawardenepura Kotte 10100, Sri Lanka": {
    si: "VWJ8+CGP, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1\u0db4\u0dd4\u0dbb \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda 10100, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VWJ8+CGP, \u0bb8\u0bcd\u0bb0\u0bc0 \u0b9c\u0bc6\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0baa\u0bc1\u0bb0 \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7 10100, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VWRH+JF7, Battaramulla, Sri Lanka": {
    si: "VWRH+JF7, \u0db6\u0dad\u0dca\u0dad\u0dbb\u0db8\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VWRH+JF7, \u0baa\u0ba4\u0bcd\u0ba4\u0bb0\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VXQW+CQW, Sri Lanka": {
    si: "VXQW+CQW, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VXQW+CQW, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VXR7+M8X, Malabe, Sri Lanka": {
    si: "VXR7+M8X, \u0db8\u0dcf\u0dbd\u0db6\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VXR7+M8X, \u0bae\u0bbe\u0bb2\u0baa\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "VXVR+2R Adampan, Sri Lanka": {
    si: "VXVR+2R \u0d85\u0da9\u0db8\u0dca\u0db4\u0db1\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "VXVR+2R \u0b85\u0b9f\u0bae\u0bcd\u0baa\u0ba9\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Vadiyadi: {
    si: "\u0dc0\u0da9\u0dd2\u0dba\u0dcf\u0da9\u0dd2",
    ta: "\u0bb5\u0bbe\u0b9f\u0bbf\u0baf\u0bbe\u0b9f\u0bbf",
  },
  Valachchenai: {
    si: "\u0dc0\u0dcf\u0dbd\u0da0\u0dca\u0da0\u0dda\u0db1\u0dba\u0dd2",
    ta: "\u0bb5\u0bbe\u0bb4\u0b9a\u0bcd\u0b9a\u0bc7\u0ba9\u0bc8",
  },
  "Valaichchena Junction, Oddamavadi, Sri Lanka": {
    si: "\u0dc0\u0dcf\u0dbd\u0da0\u0dca\u0da0\u0dda\u0db1 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0d94\u0da9\u0dca\u0da9\u0db8\u0dcf\u0dc0\u0da9\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb5\u0bbe\u0bb4\u0bc8\u0b9a\u0bcd\u0b9a\u0bc7\u0ba9\u0bc8 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0b93\u0b9f\u0bcd\u0b9f\u0bae\u0bbe\u0bb5\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Valanthalai Junction,Karainagar": {
    si: "\u0dc0\u0dbd\u0db1\u0dca\u0dad\u0dbd\u0dd9\u0dba\u0dd2 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0d9a\u0dbb\u0dd9\u0dba\u0dd2\u0db1\u0d9c\u0dbb\u0dca",
    ta: "\u0bb5\u0bb2\u0ba8\u0bcd\u0ba4\u0bb2\u0bc8 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0b95\u0bbe\u0bb0\u0bc8\u0ba8\u0b95\u0bb0\u0bcd",
  },
  "Valavaithakulam Junction, Cheddikulam": {
    si: "\u0dc0\u0dbd\u0dc0\u0dba\u0dd2\u0dad\u0d9a\u0dd4\u0dbd\u0db8\u0dca \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0da0\u0dd9\u0da9\u0dca\u0da9\u0dd2\u0d9a\u0dd4\u0dbd\u0db8\u0dca",
    ta: "\u0bb5\u0bb3\u0bb5\u0bc8\u0ba4\u0bcd\u0ba4\u0b95\u0bc1\u0bb3\u0bae\u0bcd \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0b9a\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0b95\u0bc1\u0bb3\u0bae\u0bcd",
  },
  "Valukkairaru - Punkudutivu - Kurikadduwan Rd, Velanai": {
    si: "\u0dc0\u0dcf\u0dbd\u0dd4\u0d9a\u0dca\u0d9a\u0dba\u0dd2\u0dbb\u0dcf\u0dbb\u0dd4 - \u0db4\u0dd4\u0d82\u0d9a\u0dd4\u0da9\u0dd4\u0dad\u0dd2\u0dc0\u0dca - \u0d9a\u0dd4\u0dbb\u0dd2\u0d9a\u0da9\u0dca\u0da9\u0dd4\u0dc0\u0db1\u0dca \u0db4\u0dcf\u0dbb, \u0dc0\u0dda\u0dbd\u0db1\u0dba\u0dd2",
    ta: "\u0bb5\u0bb4\u0bc1\u0b95\u0bcd\u0b95\u0bc8\u0bb0\u0bbe\u0bb1\u0bc1 - \u0baa\u0bc1\u0b99\u0bcd\u0b95\u0bc1\u0b9f\u0bc1\u0ba4\u0bc0\u0bb5\u0bc1 - \u0b95\u0bc1\u0bb1\u0bbf\u0b95\u0b9f\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe\u0ba9\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bc7\u0bb2\u0ba3\u0bc8",
  },
  Valvettithurai: {
    si: "\u0dc0\u0dd0\u0dbd\u0dca\u0dc0\u0dd0\u0da7\u0dd2\u0dad\u0dd4\u0dbb\u0dd9\u0dba\u0dd2",
    ta: "\u0bb5\u0bb2\u0bcd\u0bb5\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0ba4\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  "Vappankulam, Kandy Road, Omanthi": {
    si: "\u0dc0\u0db4\u0dca\u0db4\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8\u0dca, \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d95\u0db8\u0db1\u0dca\u0dad\u0dd2",
    ta: "\u0bb5\u0bbe\u0baa\u0bcd\u0baa\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb5\u0bc0\u0ba4\u0bbf, \u0b93\u0bae\u0ba8\u0bcd\u0ba4\u0bbf",
  },
  "Vavunia-Horowpotana Hwy, Vavuniya": {
    si: "\u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0-\u0dc4\u0ddc\u0dbb\u0ddc\u0dc0\u0dca\u0db4\u0ddc\u0dad\u0dcf\u0db1 \u0dc4\u0dc0\u0dca\u0dba\u0dd2, \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0",
    ta: "\u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe-\u0bb9\u0bb0\u0bcb\u0bb5\u0bcd\u0baa\u0bca\u0b9f\u0bcd\u0b9f\u0bbe\u0ba9\u0bbe \u0bb9\u0bb5\u0bcd\u0bb5\u0bbf, \u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe",
  },
  Vavuniya: {
    si: "\u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0",
    ta: "\u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe",
  },
  "Vavuniya Tower, Clock Tower Roundabout, Vavuniya, Sri Lanka": {
    si: "\u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0 \u0d9a\u0dd4\u0dc5\u0dd4\u0dab, \u0d94\u0dbb\u0dbd\u0ddd\u0dc3\u0dd4 \u0d9a\u0dab\u0dd4\u0dc0 \u0dc0\u0da7\u0dbb\u0dc0\u0dd4\u0db8, \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe \u0b95\u0bcb\u0baa\u0bc1\u0bb0\u0bae\u0bcd, \u0bae\u0ba3\u0bbf\u0b95\u0bcd\u0b95\u0bc2\u0ba3\u0bcd\u0b9f\u0bc1 \u0b9a\u0bc1\u0bb1\u0bcd\u0bb1\u0bc1\u0bb5\u0b9f\u0bcd\u0b9f\u0bae\u0bcd, \u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Veppankulam, Vavuniya": {
    si: "\u0dc0\u0dd9\u0db4\u0dca\u0db4\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0db8, \u0dc0\u0dc0\u0dd4\u0db1\u0dd2\u0dba\u0dcf\u0dc0",
    ta: "\u0bb5\u0bc7\u0baa\u0bcd\u0baa\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bae\u0bcd, \u0bb5\u0bb5\u0bc1\u0ba9\u0bbf\u0baf\u0bbe",
  },
  "Veyangoda - Ruwanwella Rd, Veyangoda": {
    si: "\u0dc0\u0dda\u0dba\u0db1\u0dca\u0d9c\u0ddc\u0da9 - \u0dbb\u0dd4\u0dc0\u0db1\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0dc0\u0dda\u0dba\u0db1\u0dca\u0d9c\u0ddc\u0da9",
    ta: "\u0bb5\u0bc6\u0baf\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f - \u0bb0\u0bc1\u0bb5\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bc6\u0baf\u0b99\u0bcd\u0b95\u0bca\u0b9f",
  },
  "Veyangoda - Ruwanwella Rd, Waharaka": {
    si: "\u0dc0\u0dda\u0dba\u0db1\u0dca\u0d9c\u0ddc\u0da9 - \u0dbb\u0dd4\u0dc0\u0db1\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0dc0\u0dc4\u0dbb\u0d9a",
    ta: "\u0bb5\u0bc6\u0baf\u0b99\u0bcd\u0b95\u0bca\u0b9f - \u0bb0\u0bc1\u0bb5\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bb9\u0bb0\u0b95",
  },
  "Veyangoda - Ruwanwella Rd,Urapola": {
    si: "\u0dc0\u0dda\u0dba\u0db1\u0dca\u0d9c\u0ddc\u0da9 - \u0dbb\u0dd4\u0dc0\u0db1\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d8c\u0dbb\u0dcf\u0db4\u0ddc\u0dbd",
    ta: "\u0bb5\u0bc6\u0baf\u0b99\u0bcd\u0b95\u0bca\u0b9f - \u0bb0\u0bc1\u0bb5\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b8a\u0bb0\u0bbe\u0baa\u0bca\u0bb2",
  },
  "Vihara Mawatha, Rajanganaya": {
    si: "\u0dc0\u0dd2\u0dc4\u0dcf\u0dbb \u0db8\u0dcf\u0dc0\u0dad, \u0dbb\u0dcf\u0da2\u0dcf\u0d82\u0d9c\u0db1\u0dba",
    ta: "\u0bb5\u0bbf\u0bb9\u0bbe\u0bb0 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0bb0\u0bbe\u0b9c\u0bbe\u0b99\u0bcd\u0b95\u0ba9\u0bc8",
  },
  "Vindya Salon, 67/9 Bandaranayake Ave, Panadura, Sri Lanka": {
    si: "\u0dc0\u0dd2\u0db1\u0dca\u0daf\u0dca\u200d\u0dba\u0dcf \u0dc3\u0dd0\u0dbd\u0ddd\u0db1\u0dca, 67/9 \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0db1\u0dcf\u0dba\u0d9a \u0db8\u0dcf\u0dc0\u0dad, \u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb5\u0bbf\u0ba8\u0bcd\u0ba4\u0bbf\u0baf\u0bbe \u0b9a\u0bb2\u0bcb\u0ba9\u0bcd, 67/9 \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0b8f\u0bb5\u0bcd, \u0baa\u0bbe\u0ba3\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "W A G FERNANDO": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0d92 \u0da2\u0dd3 \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b8f \u0b9c\u0bbf \u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "W A I N P A WIJAYASINGHE": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0d92 \u0d85\u0dba\u0dd2 \u0d91\u0db1\u0dca \u0db4\u0dd3 \u0d92 \u0dc0\u0dd2\u0da2\u0dba\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b8f \u0b90 \u0b8e\u0ba9\u0bcd \u0baa\u0bbf \u0b8f \u0bb5\u0bbf\u0b9c\u0baf\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "W A PERERA & SON": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0d92 \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dcf",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b8f \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe & \u0bae\u0b95\u0ba9\u0bcd",
  },
  "W A R S.FERNANDO": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0d92 \u0d86\u0dbb\u0dca \u0d91\u0dc3\u0dca \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b8f \u0b86\u0bb0\u0bcd \u0b8e\u0bb8\u0bcd.\u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "W A SENAKA": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0d92 \u0dc3\u0dda\u0db1\u0d9a",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b8f \u0b9a\u0bc7\u0ba9\u0b95\u0bbe",
  },
  "W A VERANGA KARUNARATNE": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0d92 \u0dc0\u0dda\u0dbb\u0d82\u0d9c \u0d9a\u0dbb\u0dd4\u0dab\u0dcf\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b8f \u0bb5\u0bc6\u0bb0\u0b99\u0bcd\u0b95 \u0b95\u0bb0\u0bc1\u0ba3\u0bbe\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "W AJITH FERNANDO": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0d85\u0da2\u0dd2\u0dad\u0dca \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b85\u0b9c\u0bbf\u0ba4\u0bcd \u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "W B J P.FERNANDO": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0db6\u0dd3 \u0da2\u0dda \u0db4\u0dd3 \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0baa\u0bbf \u0b9c\u0bc7 \u0baa\u0bbf.\u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "W B P ARIYADASA & SONS": {
    si: "W B P ARIYADASA & SONS",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0baa\u0bbf \u0baa\u0bbf \u0b86\u0bb0\u0bbf\u0baf\u0ba4\u0bbe\u0b9a\u0bbe & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "W CALISTUS B PERERA & SONS": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0d9a\u0dd0\u0dbd\u0dd2\u0dc3\u0dca\u0da7\u0dc3\u0dca \u0db6\u0dd3 \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b95\u0bbe\u0bb2\u0bbf\u0bb8\u0bcd\u0b9f\u0bb8\u0bcd \u0baa\u0bbf \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "W D M PERERA": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0da9\u0dd3 \u0d91\u0db8\u0dca \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b9f\u0bbf \u0b8e\u0bae\u0bcd \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "W D W D SAMARASINGHE": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0da9\u0dd3 \u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0da9\u0dd3 \u0dc3\u0db8\u0dbb\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b9f\u0bbf \u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b9f\u0bbf \u0b9a\u0bae\u0bb0\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "W G A M RANAWEERA": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0da2\u0dd3 \u0d92 \u0d91\u0db8\u0dca \u0dbb\u0dab\u0dc0\u0dd3\u0dbb",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b9c\u0bbf \u0b8f \u0b8e\u0bae\u0bcd \u0bb0\u0ba3\u0bb5\u0bc0\u0bb0",
  },
  "W G D M PERERA": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0da2\u0dd3 \u0da9\u0dd3 \u0d91\u0db8\u0dca \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b9c\u0bbf \u0b9f\u0bbf \u0b8e\u0bae\u0bcd \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "W G NANDALAL": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0da2\u0dd3 \u0db1\u0db1\u0dca\u0daf\u0dbd\u0dcf\u0dbd\u0dca",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b9c\u0bbf \u0ba8\u0ba8\u0bcd\u0ba4\u0bb2\u0bbe\u0bb2\u0bcd",
  },
  "W I N SOVIS": {
    si: "W I N SOVIS",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b90 \u0b8e\u0ba9\u0bcd \u0b9a\u0bcb\u0bb5\u0bbf\u0bb8\u0bcd",
  },
  "W J FERNANDO": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0da2\u0dda \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b9c\u0bc7 \u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "W M A B WIJESINGHE": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0d91\u0db8\u0dca \u0d92 \u0db6\u0dd3 \u0dc0\u0dd2\u0da2\u0dda\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b8e\u0bae\u0bcd \u0b8f \u0baa\u0bbf \u0bb5\u0bbf\u0b9c\u0bc7\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "W M D K .UYANWATTE": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0d91\u0db8\u0dca \u0da9\u0dd3 \u0d9a\u0dda .\u0d8b\u0dba\u0db1\u0dca\u0dc0\u0dad\u0dca\u0dad",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b8e\u0bae\u0bcd \u0b9f\u0bbf \u0b95\u0bc7 .\u0b89\u0baf\u0ba9\u0bcd\u0bb5\u0b9f\u0bcd\u0b9f\u0bc7",
  },
  "W M N P WALPOLA": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0d91\u0db8\u0dca \u0d91\u0db1\u0dca \u0db4\u0dd3 \u0dc0\u0dbd\u0dca\u0db4\u0ddc\u0dbd",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b8e\u0bae\u0bcd \u0b8e\u0ba9\u0bcd \u0baa\u0bbf \u0bb5\u0bbe\u0bb2\u0bcd\u0baa\u0bcb\u0bb2\u0bbe",
  },
  "W M RANBANDA": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0d91\u0db8\u0dca \u0dbb\u0db1\u0dca\u0db6\u0dab\u0dca\u0da9\u0dcf",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b8e\u0bae\u0bcd \u0bb0\u0ba9\u0bcd\u0baa\u0ba3\u0bcd\u0b9f\u0bbe",
  },
  "W M.JAYASIRI ABEYRATNE": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0d91\u0db8\u0dca.\u0da2\u0dba\u0dc3\u0dd2\u0dbb\u0dd2 \u0d85\u0db6\u0dda\u0dbb\u0dad\u0dca\u0db1",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b8e\u0bae\u0bcd.\u0b9c\u0bc6\u0baf\u0b9a\u0bbf\u0bb1\u0bbf \u0b85\u0baa\u0bc7\u0bb0\u0ba4\u0bcd\u0ba9",
  },
  "W PALIHAWADANA & SONS": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0db4\u0dbd\u0dd2\u0dc4\u0dc0\u0da9\u0db1 \u0dc3\u0dc4 \u0db4\u0dd4\u0dad\u0dca\u200d\u0dbb\u0dba\u0ddd",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0baa\u0bb2\u0bbf\u0bb9\u0bb5\u0b9f\u0ba9\u0bbe & \u0b9a\u0ba9\u0bcd\u0bb8\u0bcd",
  },
  "W RUPASINGHE": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0dbb\u0dd6\u0db4\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0bb0\u0bc2\u0baa\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "W T P H PERERA": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0da7\u0dd3 \u0db4\u0dd3 \u0d91\u0da0\u0dca \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b9f\u0bbf \u0baa\u0bbf \u0b8e\u0b9a\u0bcd \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "W UPALI AMROS DABARERA": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0d8b\u0db4\u0dcf\u0dbd\u0dd2 \u0d85\u0db8\u0dca\u0dbb\u0ddd\u0dc3\u0dca \u0daf\u0dcf\u0db6\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b89\u0baa\u0bbe\u0bb2\u0bbf \u0b85\u0bae\u0bcd\u0bb0\u0bcb\u0bb8\u0bcd \u0b9f\u0baa\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "W.A.DE SILVA": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0d92.\u0da9\u0dd3 \u0dc3\u0dd2\u0dbd\u0dca\u0dc0\u0dcf",
    ta: "W.A.DE \u0b9a\u0bbf\u0bb2\u0bcd\u0bb5\u0bbe",
  },
  "W.A.G FERNANDO": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0d92.\u0da2\u0dd3 \u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4",
    ta: "W.A.G \u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb",
  },
  "W.A.J.FERNANDO ENTERPRISES": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0d92.\u0da2\u0dda.\u0db4\u0dca\u200d\u0dbb\u0db1\u0dcf\u0db1\u0dca\u0daf\u0dd4 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0b8f.\u0b9c\u0bc7.\u0baa\u0bc6\u0bb0\u0bcd\u0ba9\u0bbe\u0ba3\u0bcd\u0b9f\u0bcb \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "W.A.SUMATHIPALA": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0d92.\u0dc3\u0dd4\u0db8\u0dad\u0dd2\u0db4\u0dcf\u0dbd",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0b8f.\u0b9a\u0bc1\u0bae\u0ba4\u0bbf\u0baa\u0bbe\u0bb2",
  },
  "W.D.C.GROUP (PVT) LTD": {
    si: "W.D.C.GROUP (PVT) LTD",
    ta: "W.D.C.GROUP (PVT) LTD",
  },
  "W.D.MILTON PERERA": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0da9\u0dd3.\u0db8\u0dd2\u0dbd\u0dca\u0da7\u0db1\u0dca \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0b9f\u0bbf.\u0bae\u0bbf\u0bb2\u0bcd\u0b9f\u0ba9\u0bcd \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "W.D.SAMARAPALA": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0da9\u0dd3.\u0dc3\u0db8\u0dbb\u0db4\u0dcf\u0dbd",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0b9f\u0bbf.\u0b9a\u0bae\u0bb0\u0baa\u0bbe\u0bb2",
  },
  "W.D.l.Appuhamy Mawatha, Panadura": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0da9\u0dd3.\u0d91\u0dbd\u0dca.\u0d85\u0db4\u0dca\u0db4\u0dd4\u0dc4\u0dcf\u0db8\u0dd2 \u0db8\u0dcf\u0dc0\u0dad, \u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0b9f\u0bbf.\u0b8e\u0bb2\u0bcd.\u0b85\u0baa\u0bcd\u0baa\u0bc1\u0bb9\u0bbe\u0bae\u0bbf \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0baa\u0bbe\u0ba3\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  "W.G.M.P.WIJEWARDENE": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0da2\u0dd3.\u0d91\u0db8\u0dca.\u0db4\u0dd3.\u0dc0\u0dd2\u0da2\u0dda\u0dc0\u0dbb\u0dca\u0db0\u0db1",
    ta: "W.G.M.P.\u0bb5\u0bbf\u0b9c\u0bc7\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9",
  },
  "W.G.NANDALAL": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0da2\u0dd3.\u0db1\u0db1\u0dca\u0daf\u0dbd\u0dcf\u0dbd\u0dca",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0b9c\u0bbf.\u0ba8\u0ba8\u0bcd\u0ba4\u0bb2\u0bbe\u0bb2\u0bcd",
  },
  "W.K.ANURA GUNAWARDANA": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0d9a\u0dda.\u0d85\u0db1\u0dd4\u0dbb \u0d9c\u0dd4\u0dab\u0dc0\u0dbb\u0dca\u0db0\u0db1",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0b95\u0bc7.\u0b85\u0ba9\u0bc1\u0bb0 \u0b95\u0bc1\u0ba3\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9",
  },
  "W.L.BABASENA": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0d91\u0dbd\u0dca.\u0db6\u0db6\u0dc3\u0dda\u0db1",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0b8e\u0bb2\u0bcd.\u0baa\u0bbe\u0baa\u0b9a\u0bc7\u0ba9\u0bbe",
  },
  "W.M.UPALI SENAVIRATNA": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0d91\u0db8\u0dca.\u0d8b\u0db4\u0dcf\u0dbd\u0dd2 \u0dc3\u0dda\u0db1\u0dcf\u0dc0\u0dd2\u0dbb\u0dad\u0dca\u0db1",
    ta: "W.M.UPALI SENAVIRATNA",
  },
  "W.M.Y.N.WEERASINGHE": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0d91\u0db8\u0dca.\u0dc0\u0dba\u0dd2.\u0d91\u0db1\u0dca.\u0dc0\u0dd3\u0dbb\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "W.M.Y.N.\u0bb5\u0bc0\u0bb0\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "W.P.S.K.CHANDRASIRI": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0db4\u0dd3.\u0d91\u0dc3\u0dca.\u0d9a\u0dda.\u0da0\u0db1\u0dca\u0daf\u0dca\u200d\u0dbb\u0dc3\u0dd2\u0dbb\u0dd2",
    ta: "\u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2.\u0baa\u0bbf.\u0b8e\u0bb8\u0bcd.\u0b95\u0bc7.\u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0bb0\u0b9a\u0bbf\u0bb1\u0bbf",
  },
  "W.S.S.AUTO FUELS ( PRIVATE ) LTD": {
    si: "W.S.S.AUTO FUELS (Private) LTD",
    ta: "W.S.S.AUTO FUELS (Private) LTD",
  },
  "W.UPALI PERERA": {
    si: "\u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca.\u0d8b\u0db4\u0dcf\u0dbd\u0dd2 \u0db4\u0dd9\u0dbb\u0dda\u0dbb\u0dcf",
    ta: "\u0bb5.\u0b89\u0baa\u0bbe\u0bb2\u0bbf \u0baa\u0bc6\u0bb0\u0bc7\u0bb0\u0bbe",
  },
  "W2R7+QR7, Maradankadawala-Habarana-Thirukkondaiadimadu Hwy, Polonnaruwa, Sri Lanka":
    {
      si: "W2R7+QR7, \u0db8\u0dbb\u0daf\u0db1\u0dca\u0d9a\u0da9\u0dc0\u0dbd-\u0dc4\u0db6\u0dbb\u0dab-\u0dad\u0dd2\u0dbb\u0dd4\u0d9a\u0dca\u0d9a\u0ddc\u0db1\u0dca\u0daf\u0d85\u0da9\u0dd2\u0db8\u0da9\u0dd4 Hwy, \u0db4\u0ddc\u0dc5\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "W2R7+QR7, \u0bae\u0bb0\u0ba4\u0ba9\u0bcd\u0b95\u0b9f\u0bb5\u0bb2-\u0bb9\u0baa\u0bb0\u0ba3\u0bc8-\u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcd\u0b95\u0bca\u0ba3\u0bcd\u0b9f\u0bc8\u0baf\u0bbe\u0b9f\u0bbf\u0bae\u0b9f\u0bc1 Hwy, \u0baa\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "W35F+2PQ, Colombo - Hanwella Low Level Rd, Hanwella, Sri Lanka": {
    si: "W35F+2PQ, Colombo - Hanwella Low Level Rd, Hanwella, Sri Lanka",
    ta: "W35F+2PQ, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0bb9\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 \u0bb2\u0bcb \u0bb2\u0bc6\u0bb5\u0bb2\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1, \u0bb9\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "W3WR+9Q6, Kirindiwela - Urapola Road, Hanwella, Sri Lanka": {
    si: "W3WR+9Q6, \u0d9a\u0dd2\u0dbb\u0dd2\u0db3\u0dd2\u0dc0\u0dd0\u0dbd - \u0d8c\u0dbb\u0dcf\u0db4\u0ddc\u0dbd \u0db4\u0dcf\u0dbb, \u0dc4\u0d82\u0dc0\u0dd0\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "W3WR+9Q6, \u0b95\u0bbf\u0bb0\u0bbf\u0ba8\u0bcd\u0ba4\u0bbf\u0bb5\u0bc6\u0bb2 - \u0b8a\u0bb0\u0baa\u0bca\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb9\u0ba9\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "W5CJ+GG4, Sewanapitiya, Sri Lanka": {
    si: "W5CJ+GG4, \u0dc3\u0dd9\u0dc0\u0db1\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "W5CJ+GG4, \u0b9a\u0bc6\u0bb5\u0ba9\u0baa\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "W5P6+CQ Passara, Sri Lanka": {
    si: "W5P6+CQ \u0db4\u0dc3\u0dca\u0dc3\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "W5P6+CQ \u0baa\u0b9a\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "W5R6+2Q2, Avissawella, Sri Lanka": {
    si: "W5R6+2Q2, \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "W5R6+2Q2, \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "W69C+4X5, Madola, Sri Lanka": {
    si: "W69C+4X5, \u0db8\u0daf\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "W69C+4X5, \u0bae\u0b9f\u0bcb\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "W6JV+V8 Ambanpola, Sri Lanka": {
    si: "W6JV+V8 \u0d85\u0db9\u0db1\u0dca\u0db4\u0ddc\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "W6JV+V8 \u0b85\u0bae\u0bcd\u0baa\u0ba9\u0bcd\u0baa\u0bca\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "W6Q7+PPC, Avissawella, Sri Lanka": {
    si: "W6Q7+PPC, \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "W6Q7+PPC, \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "W6WV+4X9, Welikanda, Sri Lanka": {
    si: "W6WV+4X9, \u0dc0\u0dd0\u0dbd\u0dd2\u0d9a\u0db1\u0dca\u0daf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "W6WV+4X9, \u0bb5\u0bc6\u0bb2\u0bbf\u0b95\u0ba3\u0bcd\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "W82R+F3W, Monaragala, Sri Lanka": {
    si: "W82R+F3W, \u0db8\u0ddc\u0db1\u0dbb\u0dcf\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "W82R+F3W, \u0bae\u0bca\u0ba9\u0bb0\u0bbe\u0b95\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "W8HR+6QF, Deraniyagala, Sri Lanka": {
    si: "W8HR+6QF, \u0daf\u0dd0\u0dbb\u0dab\u0dd2\u0dba\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "W8HR+6QF, \u0ba4\u0bc6\u0bb0\u0ba3\u0bbf\u0baf\u0b95\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WADAMARACHCHI EAST FISHERMEN COOP S": {
    si: "\u0dc0\u0da9\u0db8\u0dcf\u0dbb\u0da0\u0dca\u0da0\u0dd2 \u0db1\u0dd0\u0d9c\u0dd9\u0db1\u0dc4\u0dd2\u0dbb \u0db0\u0dd3\u0dc0\u0dbb \u0dc3\u0db8\u0dd4\u0db4\u0d9a\u0dcf\u0dbb \u0d91\u0dc3\u0dca",
    ta: "\u0bb5\u0b9f\u0bae\u0bb0\u0bbe\u0b9f\u0bcd\u0b9a\u0bbf \u0b95\u0bbf\u0bb4\u0b95\u0bcd\u0b95\u0bc1 \u0b95\u0b9f\u0bb1\u0bcd\u0bb1\u0bca\u0bb4\u0bbf\u0bb2\u0bbe\u0bb3\u0bb0\u0bcd \u0b95\u0bc2\u0b9f\u0bcd\u0b9f\u0bc1\u0bb1\u0bb5\u0bc1 \u0b9a\u0b99\u0bcd\u0b95\u0bae\u0bcd \u0b8e\u0bb8\u0bcd",
  },
  "WALASMULLA MPCS LTD": {
    si: "\u0dc0\u0dbd\u0dc3\u0dca\u0db8\u0dd4\u0dbd\u0dca\u0dbd MPCS LTD",
    ta: "\u0bb5\u0bbe\u0bb2\u0bb8\u0bcd\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe MPCS \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  WANDURAMBA: {
    si: "\u0dc0\u0db3\u0dd4\u0dbb\u0db9",
    ta: "\u0bb5\u0ba8\u0bcd\u0ba4\u0bc1\u0bb0\u0bae\u0bcd\u0baa\u0bbe",
  },
  "WARAKAPOLA MPCS LTD": {
    si: "\u0dc0\u0dbb\u0d9a\u0dcf\u0db4\u0ddc\u0dbd MPCS LTD",
    ta: "\u0bb5\u0bbe\u0bb0\u0b95\u0bcd\u0b95\u0bbe\u0baa\u0bca\u0bb2 MPCS LTD",
  },
  "WARIYAPOLA MPCS LTD": {
    si: "\u0dc0\u0dcf\u0dbb\u0dd2\u0dba\u0db4\u0ddc\u0dbd MPCS LTD",
    ta: "\u0bb5\u0bbe\u0bb0\u0bbf\u0baf\u0baa\u0bca\u0bb2 MPCS LTD",
  },
  "WARNASURIYA ENTERPRISES": {
    si: "\u0dc0\u0dbb\u0dca\u0dab\u0dc3\u0dd6\u0dbb\u0dd2\u0dba \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0bb5\u0bb0\u0bcd\u0ba3\u0b9a\u0bc2\u0bb0\u0bbf\u0baf \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  WATTALA: {
    si: "\u0dc0\u0dad\u0dca\u0dad\u0dbd",
    ta: "\u0bb5\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8",
  },
  "WATTALA MPCS LTD": {
    si: "\u0dc0\u0dad\u0dca\u0dad\u0dbd MPCS LTD",
    ta: "\u0bb5\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8 MPCS LTD",
  },
  "WATTAWALA PLANTATIONS PLC": {
    si: "\u0dc0\u0dad\u0dca\u0dad\u0dc0\u0dbd \u0db4\u0dca\u0dbd\u0dcf\u0db1\u0dca\u0da7\u0dda\u0dc2\u0db1\u0dca\u0dc3\u0dca \u0db4\u0dd3\u0d91\u0dbd\u0dca\u0dc3\u0dd3",
    ta: "\u0bb5\u0ba4\u0bcd\u0ba4\u0bb5\u0bb3\u0bc8 \u0baa\u0bbf\u0bb3\u0bbe\u0ba9\u0bcd\u0b9f\u0bc7\u0bb7\u0ba9\u0bcd\u0bb8\u0bcd \u0baa\u0bbf\u0b8e\u0bb2\u0bcd\u0b9a\u0bbf",
  },
  "WATTAWALA.": {
    si: "\u0dc0\u0dad\u0dca\u0dad\u0dc0\u0dbd.",
    ta: "\u0bb5\u0ba4\u0bcd\u0ba4\u0bb5\u0bb3\u0bc8.",
  },
  "WC2R+32 Dombagahawela, Sri Lanka": {
    si: "WC2R+32 \u0daf\u0ddc\u0db9\u0d9c\u0dc4\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WC2R+32 \u0ba4\u0bca\u0bae\u0bcd\u0baa\u0b95\u0bb9\u0bb5\u0bc6\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WCXX+48 Mirissa, Sri Lanka": {
    si: "WCXX+48 \u0db8\u0dd2\u0dbb\u0dd2\u0dc3\u0dca\u0dc3, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WCXX+48 \u0bae\u0bbf\u0bb0\u0bbf\u0bb8\u0bcd\u0bb8\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WEERAKETIYA MPCS LTD": {
    si: "\u0dc3\u0dd3\u0db8\u0dcf\u0dc3\u0dc4\u0dd2\u0dad \u0dc0\u0dd3\u0dbb\u0d9a\u0dd0\u0da7\u0dd2\u0dba MPCS",
    ta: "\u0bb5\u0bc0\u0bb0\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf MPCS LTD",
  },
  "WELDISI PVT LTD": {
    si: "WELDISI PVT LTD",
    ta: "\u0bb5\u0bc6\u0bb2\u0bcd\u0b9f\u0bbf\u0b9a\u0bbf \u0baa\u0bbf\u0bb0\u0bc8\u0bb5\u0bc7\u0b9f\u0bcd \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "WELFARE ASSOCIATION SL AIR FORCE": {
    si: "\u0dc3\u0dd4\u0db7\u0dc3\u0dcf\u0db0\u0d9a \u0dc3\u0d82\u0d9c\u0db8\u0dba \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf \u0d9c\u0dd4\u0dc0\u0db1\u0dca \u0dc4\u0db8\u0dd4\u0daf\u0dcf\u0dc0",
    ta: "\u0bb5\u0bc6\u0bb2\u0bcd\u0b83\u0baa\u0bc7\u0bb0\u0bcd \u0b85\u0b9a\u0bcb\u0b9a\u0bbf\u0baf\u0bc7\u0bb7\u0ba9\u0bcd \u0b8e\u0bb8\u0bcd\u0b8e\u0bb2\u0bcd \u0b8f\u0bb0\u0bcd \u0b83\u0baa\u0bcb\u0bb0\u0bcd\u0bb8\u0bcd",
  },
  "WELIMADA MPCS LTD": {
    si: "\u0dc0\u0dd0\u0dbd\u0dd2\u0db8\u0da9 MPCS LTD",
    ta: "\u0bb5\u0bc6\u0bb2\u0bbf\u0bae\u0b9f\u0bbe MPCS LTD",
  },
  WELLAWAYA: {
    si: "\u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba",
    ta: "\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf",
  },
  "WELLINGTON FUEL MART (PVT) LTD": {
    si: "\u0dc0\u0dd9\u0dbd\u0dd2\u0db1\u0dca\u0da7\u0db1\u0dca FUEL MART (PVT) LTD",
    ta: "\u0bb5\u0bc6\u0bb2\u0bbf\u0b99\u0bcd\u0b9f\u0ba9\u0bcd \u0b83\u0baa\u0bcd\u0baf\u0bc2\u0bb2\u0bcd \u0bae\u0bbe\u0bb0\u0bcd\u0b9f\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  WENNAPPUWA: {
    si: "\u0dc0\u0dd9\u0db1\u0dca\u0db1\u0db4\u0dca\u0db4\u0dd4\u0dc0",
    ta: "\u0bb5\u0bc6\u0ba9\u0bcd\u0ba9\u0baa\u0bcd\u0baa\u0bc1\u0bb5",
  },
  "WENNAPPUWA MPCS LTD": {
    si: "\u0dc0\u0dd9\u0db1\u0dca\u0db1\u0db4\u0dca\u0db4\u0dd4\u0dc0 MPCS LTD",
    ta: "\u0bb5\u0bc6\u0ba9\u0bcd\u0ba9\u0baa\u0bcd\u0baa\u0bc1\u0bb5 MPCS LTD",
  },
  "WFRQ+5R9, Kamburugamuwa, Sri Lanka": {
    si: "WFRQ+5R9, \u0d9a\u0db9\u0dd4\u0dbb\u0dd4\u0d9c\u0db8\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WFRQ+5R9, \u0b95\u0bae\u0bcd\u0baa\u0bc1\u0bb0\u0bc1\u0b95\u0bae\u0bc1\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WG FRANCIS APPUHAMY SAMUHA VIYAPARA": {
    si: "WG \u0dc6\u0dca\u200d\u0dbb\u0dd0\u0db1\u0dca\u0dc3\u0dd2\u0dc3\u0dca \u0d85\u0db4\u0dca\u0db4\u0dd4\u0dc4\u0dcf\u0db8\u0dd2 \u0dc3\u0db8\u0dd4\u0dc4 \u0dc0\u0dd2\u0dba\u0db4\u0dbb",
    ta: "WG \u0baa\u0bbf\u0bb0\u0bbe\u0ba9\u0bcd\u0b9a\u0bbf\u0bb8\u0bcd \u0b85\u0baa\u0bcd\u0baa\u0bc1\u0bb9\u0bbe\u0bae\u0bbf \u0b9a\u0bae\u0bc1\u0bb9\u0bbe \u0bb5\u0bbf\u0baf\u0bbe\u0baa\u0bb0\u0bbe",
  },
  "WG6G+XG Oddamavadi, Sri Lanka": {
    si: "WG6G+XG \u0d94\u0da9\u0dca\u0da9\u0db8\u0dcf\u0dc0\u0da9\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WG6G+XG \u0b93\u0b9f\u0bcd\u0b9f\u0bae\u0bbe\u0bb5\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WG79+GWJ, Nortonbridge, Sri Lanka": {
    si: "WG79+GWJ, \u0db1\u0ddd\u0da7\u0db1\u0dca\u0db6\u0dca\u200d\u0dbb\u0dd2\u0da2\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WG79+GWJ, \u0ba8\u0bbe\u0bb0\u0bcd\u0b9f\u0ba9\u0bcd\u0baa\u0bbf\u0bb0\u0bbf\u0b9f\u0bcd\u0b9c\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WG7G+25W, Oddamavadi, Sri Lanka": {
    si: "WG7G+25W, Oddamavadi, Sri Lanka",
    ta: "WG7G+25W, \u0b93\u0b9f\u0bcd\u0b9f\u0bae\u0bbe\u0bb5\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WGG7+3C3, Oddamavadi, Sri Lanka": {
    si: "WGG7+3C3, \u0d94\u0da9\u0dca\u0da9\u0db8\u0dcf\u0dc0\u0da9\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WGG7+3C3, \u0b93\u0b9f\u0bcd\u0b9f\u0bae\u0bbe\u0bb5\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WGJW+9C Kalkudah, Sri Lanka": {
    si: "WGJW+9C \u0d9a\u0dbd\u0dca\u0d9a\u0dd4\u0da9\u0dcf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WGJW+9C \u0b95\u0bb2\u0bcd\u0b95\u0bc1\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WGXR+J33, Matara, Sri Lanka": {
    si: "WGXR+J33, \u0db8\u0dcf\u0dad\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WGXR+J33, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WGXW+36Q, Matara, Sri Lanka": {
    si: "WGXW+36Q, \u0db8\u0dcf\u0dad\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WGXW+36Q, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WH42+PC Siyambalanduwa, Sri Lanka": {
    si: "WH42+PC \u0dc3\u0dd2\u0dba\u0db9\u0dbd\u0dcf\u0dab\u0dca\u0da9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WH42+PC \u0b9a\u0bbf\u0baf\u0bbe\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0ba3\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WH44+JRP, Siyambalanduwa, Sri Lanka": {
    si: "WH44+JRP, \u0dc3\u0dd2\u0dba\u0db9\u0dbd\u0dcf\u0dab\u0dca\u0da9\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WH44+JRP, \u0b9a\u0bbf\u0baf\u0bbe\u0bae\u0bcd\u0baa\u0bb2\u0bbe\u0ba3\u0bcd\u0b9f\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WHGV+QQ Madatugama, Sri Lanka": {
    si: "WHGV+QQ \u0db8\u0da9\u0dcf\u0da7\u0dd4\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WHGV+QQ \u0bae\u0b9f\u0ba4\u0bc1\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WHW4+6GV, Matara, Sri Lanka": {
    si: "WHW4+6GV, \u0db8\u0dcf\u0dad\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WHW4+6GV, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WICKRAMASIRI ENTERPRISES (PVT) LTD": {
    si: "\u0dc0\u0dd2\u0d9a\u0dca\u200d\u0dbb\u0db8\u0dc3\u0dd2\u0dbb\u0dd2 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0bb5\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb0\u0bae\u0b9a\u0bbf\u0bb1\u0bbf \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "WICRAMASINGHE W D": {
    si: "\u0dc0\u0dd2\u0d9a\u0dca\u200d\u0dbb\u0db8\u0dc3\u0dd2\u0d82\u0dc4 \u0da9\u0db6\u0dca\u0dbd\u0dd2\u0dc0\u0dca \u0da9\u0dd3",
    ta: "\u0bb5\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb0\u0bae\u0b9a\u0bbf\u0b99\u0bcd\u0b95 \u0b9f\u0baa\u0bbf\u0bb3\u0bcd\u0baf\u0bc2 \u0b9f\u0bbf",
  },
  "WIJAYA LANKA TRADING (PVT) LTD": {
    si: "\u0dc0\u0dd2\u0da2\u0dba \u0dbd\u0d82\u0d9a\u0dcf \u0da7\u0dca\u200d\u0dbb\u0dda\u0da9\u0dd2\u0db1\u0dca (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0bb5\u0bbf\u0b9c\u0baf \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0b9f\u0bbf\u0bb0\u0bc7\u0b9f\u0bbf\u0b99\u0bcd (\u0baa\u0bbf.\u0bb5\u0bbf.\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "WIJERAMA ENTERPRISES": {
    si: "\u0dc0\u0dd2\u0da2\u0dda\u0dbb\u0dcf\u0db8 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0bb5\u0bbf\u0b9c\u0bc7\u0bb0\u0bbe\u0bae \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "WIJESINGHE ENTERPRICES": {
    si: "\u0dc0\u0dd2\u0da2\u0dda\u0dc3\u0dd2\u0d82\u0dc4 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0bb5\u0bbf\u0b9c\u0bc7\u0b9a\u0bbf\u0b99\u0bcd\u0b95 \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "WITHNAGE ENTERPRISES": {
    si: "WITHNAGE \u0dc0\u0dca\u0dba\u0dc0\u0dc3\u0dcf\u0dba\u0db1\u0dca",
    ta: "\u0bb5\u0bbf\u0ba4\u0bcd\u0ba9\u0bc7\u0b9c\u0bcd \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "WJF3+23M, Kotagala, Sri Lanka": {
    si: "WJF3+23M, \u0d9a\u0ddc\u0da7\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WJF3+23M, \u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0b95\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WJP6+628, Gandara, Sri Lanka": {
    si: "WJP6+628, \u0d9c\u0db1\u0dca\u0daf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WJP6+628, \u0b95\u0ba8\u0bcd\u0ba4\u0bbe\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WJP6+CGG, Gandara, Sri Lanka": {
    si: "WJP6+CGG, \u0d9c\u0db1\u0dca\u0daf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WJP6+CGG, \u0b95\u0ba8\u0bcd\u0ba4\u0bbe\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WJWR+6Q Koattagoda, Sri Lanka": {
    si: "WJWR+6Q \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WJWR+6Q \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0b95\u0bcb\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WJXQ+P6H, Koattagoda, Sri Lanka": {
    si: "WJXQ+P6H, \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WJXQ+P6H, \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0b95\u0bcb\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WM3C+82 Dambulla, Sri Lanka": {
    si: "WM3C+82 \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WM3C+82 \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WMPR+454, Dambulla, Sri Lanka": {
    si: "WMPR+454, \u0daf\u0db9\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WMPR+454, \u0ba4\u0bae\u0bcd\u0baa\u0bc1\u0bb3\u0bcd\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WMQ6+4HG, Talawakelle, Sri Lanka": {
    si: "WMQ6+4HG, \u0dad\u0dbd\u0dc0\u0d9a\u0dd0\u0dbd\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WMQ6+4HG, \u0ba4\u0bb2\u0bb5\u0bbe\u0b95\u0bcd\u0b95\u0bb2\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WMQ6+XFF, Talawakelle, Sri Lanka": {
    si: "WMQ6+XFF, \u0dad\u0dbd\u0dc0\u0dcf\u0d9a\u0dd0\u0dbd\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WMQ6+XFF, \u0ba4\u0bb2\u0bb5\u0bbe\u0b95\u0bcd\u0b95\u0bc6\u0bb2\u0bcd\u0bb2\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WPRV+2HP, Nanuoya, Sri Lanka": {
    si: "WPRV+2HP, \u0db1\u0dcf\u0db1\u0dd4\u0d94\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WPRV+2HP, \u0ba8\u0bbe\u0ba9\u0bc1\u0b93\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WR6F+9GX, Madurankuli, Sri Lanka": {
    si: "WR6F+9GX, \u0db8\u0daf\u0dd4\u0dbb\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WR6F+9GX, \u0bae\u0ba4\u0bc1\u0bb0\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WR6F+QCH, Puttalam - Colombo Road, Madurankuli, Sri Lanka": {
    si: "WR6F+QCH, \u0db4\u0dd4\u0dad\u0dca\u0dad\u0dbd\u0db8 - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0db8\u0daf\u0dd4\u0dbb\u0db1\u0dca\u0d9a\u0dd4\u0dbd\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WR6F+QCH, \u0baa\u0bc1\u0ba4\u0bcd\u0ba4\u0bb3\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0ba4\u0bc1\u0bb0\u0b99\u0bcd\u0b95\u0bc1\u0bb3\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WRF5+4C8, Welioya, Sri Lanka": {
    si: "WRF5+4C8, \u0dc0\u0dd0\u0dbd\u0dd2\u0d94\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WRF5+4C8, \u0bb5\u0bc6\u0bb2\u0bbf\u0b93\u0baf\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WRHX+5V5 Filling Station, Colombo 00200, Sri Lanka": {
    si: "WRHX+5V5 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0ddc\u0dc5\u0db9 00200, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WRHX+5V5 \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00200, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WV5X+FC5, Sri Jayawardenepura Kotte, Sri Lanka": {
    si: "WV5X+FC5, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1\u0db4\u0dd4\u0dbb \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WV5X+FC5, \u0bb8\u0bcd\u0bb0\u0bc0 \u0b9c\u0bc6\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0baa\u0bc1\u0bb0 \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WV67+HX2, Colombo 00700, Sri Lanka": {
    si: "WV67+HX2, \u0d9a\u0ddc\u0dc5\u0db9 00700, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WV67+HX2, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00700, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WV6G+JVW, Colombo 00700, Sri Lanka": {
    si: "WV6G+JVW, \u0d9a\u0ddc\u0dc5\u0db9 00700, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WV6G+JVW, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00700, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WV88+52R, Dr CWW Kannangara Mawatha, Colombo 00700, Sri Lanka": {
    si: "WV88+52R, Dr CWW \u0d9a\u0db1\u0dca\u0db1\u0db1\u0dca\u0d9c\u0dbb \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 00700, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WV88+52R, Dr CWW \u0b95\u0ba3\u0bcd\u0ba3\u0b99\u0bcd\u0b95\u0bb0\u0bbe \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00700, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WVC3+65P, Colombo 00200, Sri Lanka": {
    si: "WVC3+65P, \u0d9a\u0ddc\u0dc5\u0db9 00200, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WVC3+65P, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 00200, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WVHH+74F, Colombo 01000, Sri Lanka": {
    si: "WVHH+74F, \u0d9a\u0ddc\u0dc5\u0db9 01000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WVHH+74F, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 01000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WVHH+P3P, Colombo 01000, Sri Lanka": {
    si: "WVHH+P3P, \u0d9a\u0ddc\u0dc5\u0db9 01000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WVHH+P3P, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 01000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WVHX+5J2, Ambagasdowa, Sri Lanka": {
    si: "WVHX+5J2, \u0d85\u0db9\u0d9c\u0dc3\u0dca\u0daf\u0ddd\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WVHX+5J2, \u0b85\u0bae\u0bcd\u0baa\u0b95\u0bb8\u0bcd\u0b9f\u0bcb\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WVQ7+WQ5, Srimath Bandaranayake Mawatha, Colombo 01000, Sri Lanka": {
    si: "WVQ7+WQ5, \u0dc1\u0dca\u200d\u0dbb\u0dd3\u0db8\u0dad\u0dca \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0db1\u0dcf\u0dba\u0d9a \u0db8\u0dcf\u0dc0\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 01000, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WVQ7+WQ5, \u0bb8\u0bcd\u0bb0\u0bc0\u0bae\u0ba4\u0bcd \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0ba8\u0bbe\u0baf\u0b95\u0bcd\u0b95 \u0bae\u0bbe\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 01000, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WVQV+HX2, Wellampitiya, Sri Lanka": {
    si: "WVQV+HX2, \u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0db8\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WVQV+HX2, \u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bae\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WVV7+FRR, Colombo 01300, Sri Lanka": {
    si: "WVV7+FRR, \u0d9a\u0ddc\u0dc5\u0db9 01300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WVV7+FRR, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 01300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WVVH+3JX, Baseline Rd, Colombo, Sri Lanka": {
    si: "WVVH+3JX, Baseline Rd, Colombo, Sri Lanka",
    ta: "WVVH+3JX, Baseline Rd, Colombo, Sri Lanka",
  },
  "WVVH+V62, Colombo 01300, Sri Lanka": {
    si: "WVVH+V62, \u0d9a\u0ddc\u0dc5\u0db9 01300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WVVH+V62, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 01300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WVW7+3HG, Skinners's Rd, Colombo 01300, Sri Lanka": {
    si: "WVW7+3HG, \u0dc3\u0dca\u0d9a\u0dd2\u0db1\u0dbb\u0dca\u0dc3\u0dca \u0db4\u0dcf\u0dbb, \u0d9a\u0ddc\u0dc5\u0db9 01300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WVW7+3HG, \u0bb8\u0bcd\u0b95\u0bbf\u0ba9\u0bcd\u0ba9\u0bb0\u0bcd\u0bb8\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 01300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WVX5+HXF, Kotahena St, Colombo 01300, Sri Lanka": {
    si: "WVX5+HXF, \u0d9a\u0ddc\u0da7\u0dc4\u0dda\u0db1 \u0dc1\u0dcf\u0db1\u0dca\u0dad, \u0d9a\u0ddc\u0dc5\u0db9 01300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WVX5+HXF, Kotahena St, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 01300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WVXC+546, Colombo, Sri Lanka": {
    si: "WVXC+546, \u0d9a\u0ddc\u0dc5\u0db9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WVXC+546, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WW28+VV2, Kotte - Bope Rd, Battaramulla 10120, Sri Lanka": {
    si: "WW28+VV2, \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda - \u0db6\u0ddd\u0db4\u0dda \u0db4\u0dcf\u0dbb, \u0db6\u0dad\u0dca\u0dad\u0dbb\u0db8\u0dd4\u0dbd\u0dca\u0dbd 10120, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WW28+VV2, \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7 - \u0baa\u0bcb\u0baa\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1, \u0baa\u0ba4\u0bcd\u0ba4\u0bb0\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe 10120, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WW34+P43, Sri Jayawardenepura Kotte, Sri Lanka": {
    si: "WW34+P43, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0da2\u0dba\u0dc0\u0dbb\u0dca\u0db0\u0db1\u0db4\u0dd4\u0dbb \u0d9a\u0ddd\u0da7\u0dca\u0da7\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WW34+P43, \u0bb8\u0bcd\u0bb0\u0bc0 \u0b9c\u0bc6\u0baf\u0bb5\u0bb0\u0bcd\u0ba4\u0ba9\u0baa\u0bc1\u0bb0 \u0b95\u0bcb\u0b9f\u0bcd\u0b9f\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WW45+3R9, Peradeniya-Badulla-Chenkaladi Hwy, Welimada, Sri Lanka": {
    si: "WW45+3R9, \u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba-\u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd-\u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2 Hwy, \u0dc0\u0dd0\u0dbd\u0dd2\u0db8\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WW45+3R9, \u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8-\u0baa\u0ba4\u0bc1\u0bb3\u0bc8-\u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf Hwy, \u0bb5\u0bc6\u0bb2\u0bbf\u0bae\u0b9f\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WW5P+32C, Battaramulla, Sri Lanka": {
    si: "WW5P+32C, \u0db6\u0dad\u0dca\u0dad\u0dbb\u0db8\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WW5P+32C, \u0baa\u0ba4\u0bcd\u0ba4\u0bb0\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WWCW+364, Thiruketheeswaram Rd, Thiruketheeswaram, Sri Lanka": {
    si: "WWCW+364, \u0dad\u0dd2\u0dbb\u0dd4\u0d9a\u0dda\u0dad\u0dd3\u0dc3\u0dca\u0dc0\u0dbb\u0db8\u0dca \u0db4\u0dcf\u0dbb, \u0dad\u0dd2\u0dbb\u0dd4\u0d9a\u0dda\u0dad\u0dd3\u0dc3\u0dca\u0dc0\u0dbb\u0db8\u0dca, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WWCW+364, \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcd\u0b95\u0bc7\u0ba4\u0bc0\u0bb8\u0bcd\u0bb5\u0bb0\u0bae\u0bcd \u0b9a\u0bbe\u0bb2\u0bc8, \u0ba4\u0bbf\u0bb0\u0bc1\u0b95\u0bcd\u0b95\u0bc7\u0ba4\u0bc0\u0bb8\u0bcd\u0bb5\u0bb0\u0bae\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WWP8+8V5, Colombo, Sri Lanka": {
    si: "WWP8+8V5, \u0d9a\u0ddc\u0dc5\u0db9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WWP8+8V5, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WWPM+G4M, Sri Lanka": {
    si: "WWPM+G4M, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WWPM+G4M, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WXPF+G8C, AB10, Kaduwela, Sri Lanka": {
    si: "WXPF+G8C, AB10, \u0d9a\u0da9\u0dd4\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WXPF+G8C, AB10, \u0b95\u0b9f\u0bc1\u0bb5\u0bc6\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WXPJ+M9C, AB10, Kaduwela, Sri Lanka": {
    si: "WXPJ+M9C, AB10, \u0d9a\u0da9\u0dd4\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WXPJ+M9C, AB10, \u0b95\u0b9f\u0bc1\u0bb5\u0bc6\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WXPM+CP2, Kaduwela, Sri Lanka": {
    si: "WXPM+CP2, \u0d9a\u0da9\u0dd4\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WXPM+CP2, \u0b95\u0b9f\u0bc1\u0bb5\u0bc6\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WXPR+MXH, Badulla, Sri Lanka": {
    si: "WXPR+MXH, \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WXPR+MXH, \u0baa\u0ba4\u0bc1\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WXV6+C6V, Avissawella Rd, Welivita, Sri Lanka": {
    si: "WXV6+C6V, \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0dc0\u0dd0\u0dbd\u0dd2\u0dc0\u0dd2\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WXV6+C6V, \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bc6\u0bb2\u0bbf\u0bb5\u0bbf\u0b9f\u0bcd\u0b9f, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WXXR+FPF, Kaduwela, Sri Lanka": {
    si: "WXXR+FPF, \u0d9a\u0da9\u0dd4\u0dc0\u0dd9\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "WXXR+FPF, \u0b95\u0b9f\u0bc1\u0bb5\u0bc6\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "WYMAN EDIRISINGHE": {
    si: "\u0dc0\u0dba\u0dd2\u0db8\u0db1\u0dca \u0d91\u0daf\u0dd2\u0dbb\u0dd2\u0dc3\u0dd2\u0d82\u0dc4",
    ta: "\u0bb5\u0bc8\u0bae\u0ba9\u0bcd \u0b8e\u0ba4\u0bbf\u0bb0\u0bbf\u0b9a\u0bbf\u0b99\u0bcd\u0b95",
  },
  "Wakwella Rd, Galle": {
    si: "\u0dc0\u0d9a\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd",
    ta: "\u0bb5\u0b95\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bbe\u0bb2\u0bbf",
  },
  Walasmulla: {
    si: "\u0dc0\u0dbd\u0dc3\u0dca\u0db8\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0bb5\u0bb2\u0bb8\u0bcd\u0bae\u0bc1\u0bb2\u0bcd\u0bb2",
  },
  "Walasmulla North, 5M3X+W29, Walasmulla, Sri Lanka": {
    si: "\u0dc0\u0dbd\u0dc3\u0dca\u0db8\u0dd4\u0dbd\u0dca\u0dbd \u0d8b\u0dad\u0dd4\u0dbb, 5M3X+W29, \u0dc0\u0dbd\u0dc3\u0dca\u0db8\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb5\u0bb2\u0bb8\u0bcd\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe \u0bb5\u0b9f\u0b95\u0bcd\u0b95\u0bc1, 5M3X+W29, \u0bb5\u0bb2\u0bb8\u0bcd\u0bae\u0bc1\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Walasmulla Rd ,Weeraketiya": {
    si: "\u0dc0\u0dbd\u0dc3\u0dca\u0db8\u0dd4\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0dc0\u0dd3\u0dbb\u0d9a\u0dd0\u0da7\u0dd2\u0dba",
    ta: "\u0bb5\u0bb2\u0bb8\u0bcd\u0bae\u0bc1\u0bb2\u0bcd\u0bb2 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bc0\u0bb0\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Walgama Junction Bus Stop, Aturugiriya Rd, Sri Lanka": {
    si: "\u0dc0\u0dbd\u0dca\u0d9c\u0db8 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba \u0db6\u0dc3\u0dca \u0db1\u0dd0\u0dc0\u0dad\u0dd4\u0db8, \u0d85\u0dad\u0dd4\u0dbb\u0dd4\u0d9c\u0dd2\u0dbb\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb5\u0bbe\u0bb2\u0bcd\u0b95\u0bae \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf\u0baa\u0bcd\u0baa\u0bc1 \u0baa\u0bc7\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba8\u0bbf\u0bb1\u0bc1\u0ba4\u0bcd\u0ba4\u0bae\u0bcd, \u0b85\u0ba4\u0bc1\u0bb0\u0bc1\u0b95\u0bbf\u0bb0\u0bbf\u0baf \u0b9a\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Walgama Junction-Athrugiriya": {
    si: "\u0dc0\u0dbd\u0dca\u0d9c\u0db8 \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba-\u0d85\u0dad\u0dd4\u0dbb\u0dd4\u0d9c\u0dd2\u0dbb\u0dd2\u0dba",
    ta: "\u0bb5\u0bb2\u0bcd\u0b95\u0bae \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf-\u0b85\u0ba4\u0bcd\u0bb0\u0bc1\u0b95\u0bbf\u0bb0\u0bbf\u0baf",
  },
  "Walpita, Kotadeniyawa": {
    si: "Walpita, Kotadeniyawa",
    ta: "\u0bb5\u0bb2\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f, \u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe\u0bb5",
  },
  "Wanathamulla, Colombo": {
    si: "\u0dc0\u0db1\u0dcf\u0dad\u0db8\u0dd4\u0dbd\u0dca\u0dbd, \u0d9a\u0ddc\u0dc5\u0db9",
    ta: "\u0bb5\u0ba9\u0ba4\u0bcd\u0ba4\u0bae\u0bc1\u0bb2\u0bcd\u0bb2, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1",
  },
  "Waragoda Rd, Peliyagoda": {
    si: "\u0dc0\u0dbb\u0dcf\u0d9c\u0ddc\u0da9 \u0db4\u0dcf\u0dbb, \u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9",
    ta: "\u0bb5\u0bbe\u0bb0\u0b95\u0bca\u0b9f \u0bb5\u0bc0\u0ba4\u0bbf, \u0baa\u0bc7\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f",
  },
  Warakapola: {
    si: "\u0dc0\u0dbb\u0d9a\u0dcf\u0db4\u0ddc\u0dbd",
    ta: "\u0bb5\u0bb0\u0b95\u0bbe\u0baa\u0bca\u0bb2",
  },
  "Waralla, Galle-Deniyaya-Madampe Highway, Sri Lanka": {
    si: "\u0dc0\u0dbb\u0dbd\u0dca\u0dbd, \u0d9c\u0dcf\u0dbd\u0dca\u0dbd-\u0daf\u0dd9\u0dab\u0dd2\u0dba\u0dcf\u0dba-\u0db8\u0dcf\u0daf\u0db8\u0dca\u0db4\u0dda \u0d85\u0db0\u0dd2\u0dc0\u0dda\u0d9c\u0dd3 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb5\u0bb0\u0bb2\u0bcd\u0bb2, \u0b95\u0bbe\u0bb2\u0bbf-\u0ba4\u0bc6\u0ba9\u0bbf\u0baf\u0bbe\u0baf-\u0bae\u0b9f\u0bae\u0bcd\u0baa\u0bc7 \u0ba8\u0bc6\u0b9f\u0bc1\u0b9e\u0bcd\u0b9a\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Wariyagoda Filling Station, Kurunegala Rd Alawwa": {
    si: "\u0dc0\u0dcf\u0dbb\u0dd2\u0dba\u0d9c\u0ddc\u0da9 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0dd4\u0dbb\u0dd4\u0dab\u0dd1\u0d9c\u0dbd \u0db4\u0dcf\u0dbb \u0d85\u0dbd\u0dc0\u0dca\u0dc0",
    ta: "\u0bb5\u0bbe\u0bb0\u0bbf\u0baf\u0b95\u0bca\u0b9f \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0bc1\u0bb0\u0bc1\u0ba8\u0bbe\u0b95\u0bb2\u0bcd \u0bb5\u0bc0\u0ba4\u0bbf \u0b85\u0bb2\u0bb5\u0bcd\u0bb5",
  },
  "Wariyagoda, Alawwaththa, Sri Lanka": {
    si: "\u0dc0\u0dcf\u0dbb\u0dd2\u0dba\u0d9c\u0ddc\u0da9, \u0d85\u0dbd\u0dc0\u0dca\u0dc0\u0dad\u0dca\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb5\u0bbe\u0bb0\u0bbf\u0baf\u0b95\u0bca\u0b9f, \u0b85\u0bb2\u0bb5\u0bcd\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Wariyapola: {
    si: "\u0dc0\u0dcf\u0dbb\u0dd2\u0dba\u0db4\u0ddc\u0dc5",
    ta: "\u0bb5\u0bbe\u0bb0\u0bbf\u0baf\u0baa\u0bca\u0bb2",
  },
  "Wathurugama Rd, Malwathu Hiripitiya": {
    si: "\u0dc0\u0dad\u0dd4\u0dbb\u0dd4\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0db8\u0dbd\u0dca\u0dc0\u0dad\u0dd4 \u0dc4\u0dd2\u0dbb\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0bb5\u0ba4\u0bcd\u0ba4\u0bc1\u0bb0\u0bc1\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bb2\u0bcd\u0bb5\u0ba4\u0bcd\u0ba4\u0bc1 \u0bb9\u0bbf\u0bb0\u0bbf\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  Wattala: {
    si: "\u0dc0\u0dad\u0dca\u0dad\u0dbd",
    ta: "\u0bb5\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8",
  },
  Wattegama: {
    si: "\u0dc0\u0dad\u0dca\u0dad\u0dda\u0d9c\u0db8",
    ta: "\u0bb5\u0ba4\u0bcd\u0ba4\u0bc7\u0b95\u0bae",
  },
  "Weerahela - Tissamaharama": {
    si: "\u0dc0\u0dd3\u0dbb\u0dc4\u0dd9\u0dbd - \u0dad\u0dd2\u0dc3\u0dca\u0dc3\u0db8\u0dc4\u0dcf\u0dbb\u0dcf\u0db8",
    ta: "\u0bb5\u0bc0\u0bb0\u0bb9\u0bc6\u0bb2 - \u0ba4\u0bbf\u0bb8\u0bcd\u0bb8\u0bae\u0bb9\u0bbe\u0bb0\u0bbe\u0bae",
  },
  "Weeraketiya - Middeniya Rd, Weeraketiya": {
    si: "\u0dc0\u0dd3\u0dbb\u0d9a\u0dd0\u0da7\u0dd2\u0dba - \u0db8\u0dd2\u0daf\u0dca\u0daf\u0dd9\u0db1\u0dd2\u0dba \u0db4\u0dcf\u0dbb, \u0dc0\u0dd3\u0dbb\u0d9a\u0dd0\u0da7\u0dd2\u0dba",
    ta: "\u0bb5\u0bc0\u0bb0\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf - \u0bae\u0bbf\u0ba4\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0bc0\u0bb0\u0b95\u0bc6\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  "Wekada-Panadura": {
    si: "\u0dc0\u0dd1\u0d9a\u0da9-\u0db4\u0dcf\u0db1\u0daf\u0dd4\u0dbb",
    ta: "\u0bb5\u0bc6\u0b95\u0b9f - \u0baa\u0bbe\u0ba3\u0ba8\u0bcd\u0ba4\u0bc1\u0bb1\u0bc8",
  },
  Weligama: {
    si: "\u0dc0\u0dd0\u0dbd\u0dd2\u0d9c\u0db8",
    ta: "\u0bb5\u0bc6\u0bb2\u0bbf\u0b95\u0bae",
  },
  "Weligama By Pass Rd": {
    si: "\u0dc0\u0dd0\u0dbd\u0dd2\u0d9c\u0db8 \u0db6\u0dba\u0dd2\u0db4\u0dcf\u0dc3\u0dca \u0db4\u0dcf\u0dbb",
    ta: "\u0bb5\u0bc6\u0bb2\u0bbf\u0b95\u0bae \u0baa\u0bc8 \u0baa\u0bbe\u0bb8\u0bcd \u0bb0\u0bcb\u0b9f\u0bc1",
  },
  "Weligepola, Balangoda": {
    si: "\u0dc0\u0dd0\u0dbd\u0dd2\u0d9c\u0dd9\u0db4\u0ddc\u0dbd, \u0db6\u0dbd\u0d82\u0d9c\u0ddc\u0da9",
    ta: "\u0bb5\u0bc6\u0bb2\u0bbf\u0b95\u0bc7\u0baa\u0bca\u0bb2, \u0baa\u0bb2\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f",
  },
  Welikanda: {
    si: "\u0dc0\u0dd0\u0dbd\u0dd2\u0d9a\u0db1\u0dca\u0daf",
    ta: "\u0bb5\u0bc6\u0bb2\u0bbf\u0b95\u0ba8\u0bcd\u0ba4",
  },
  Welimada: {
    si: "\u0dc0\u0dd0\u0dbd\u0dd2\u0db8\u0d9e",
    ta: "\u0bb5\u0bc6\u0bb2\u0bbf\u0bae\u0b9f\u0bc8",
  },
  "Welimada Clock Tower, Peradeniya - Badulla - Chenkaladi Hwy, Welimada": {
    si: "\u0dc0\u0dd0\u0dbd\u0dd2\u0db8\u0da9 \u0d94\u0dbb\u0dbd\u0ddd\u0dc3\u0dd4 \u0d9a\u0dab\u0dd4\u0dc0, \u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba - \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd - \u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2 Hwy, \u0dc0\u0dd0\u0dbd\u0dd2\u0db8\u0da9",
    ta: "\u0bb5\u0bc6\u0bb2\u0bbf\u0bae\u0b9f\u0bc8 \u0bae\u0ba3\u0bbf\u0b95\u0bcd\u0b95\u0bc2\u0ba3\u0bcd\u0b9f\u0bc1, \u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8 - \u0baa\u0ba4\u0bc1\u0bb3\u0bc8 - \u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf Hwy, \u0bb5\u0bc6\u0bb2\u0bbf\u0bae\u0b9f\u0bc8",
  },
  "Welimada Clock Tower, Peradeniya-Badulla-Chenkaladi Hwy, Welimada, Sri Lanka":
    {
      si: "\u0dc0\u0dd0\u0dbd\u0dd2\u0db8\u0da9 \u0d94\u0dbb\u0dbd\u0ddd\u0dc3\u0dd4 \u0d9a\u0dab\u0dd4\u0dc0, \u0db4\u0dda\u0dbb\u0dcf\u0daf\u0dd9\u0dab\u0dd2\u0dba-\u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd-\u0da0\u0dd9\u0db1\u0dca\u0d9a\u0dbd\u0da9\u0dd2 Hwy, \u0dc0\u0dd0\u0dbd\u0dd2\u0db8\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "\u0bb5\u0bc6\u0bb2\u0bbf\u0bae\u0b9f\u0bc8 \u0bae\u0ba3\u0bbf\u0b95\u0bcd\u0b95\u0bc2\u0ba3\u0bcd\u0b9f\u0bc1, \u0baa\u0bc7\u0bb0\u0bbe\u0ba4\u0ba9\u0bc8-\u0baa\u0ba4\u0bc1\u0bb3\u0bc8-\u0b9a\u0bc6\u0b99\u0bcd\u0b95\u0bb2\u0b9f\u0bbf Hwy, \u0bb5\u0bc6\u0bb2\u0bbf\u0bae\u0b9f\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "Welimada, Bandarawela - Welimada Rd, Sri Lanka": {
    si: "\u0dc0\u0dd0\u0dbd\u0dd2\u0db8\u0da9, \u0db6\u0dab\u0dca\u0da9\u0dcf\u0dbb\u0dc0\u0dd9\u0dbd - \u0dc0\u0dd0\u0dbd\u0dd2\u0db8\u0da9 \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb5\u0bc6\u0bb2\u0bbf\u0bae\u0b9f\u0bbe, \u0baa\u0ba3\u0bcd\u0b9f\u0bbe\u0bb0\u0bb5\u0bb3\u0bc8 - \u0bb5\u0bc6\u0bb2\u0bbf\u0bae\u0b9f\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Welioya Junction, Rambewa, Sri Lanka": {
    si: "\u0dc0\u0dd0\u0dbd\u0dd2\u0d94\u0dba \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0dbb\u0db9\u0dd1\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb5\u0bc6\u0bb2\u0bbf\u0b93\u0baf\u0bbe \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0bb0\u0bae\u0bcd\u0baa\u0bc7\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Welipennagahamulla: {
    si: "\u0dc0\u0dd0\u0dbd\u0dd2\u0db4\u0dd0\u0db1\u0dca\u0db1\u0d9c\u0dc4\u0db8\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0bb5\u0bc6\u0bb2\u0bbf\u0baa\u0bc6\u0ba9\u0bcd\u0ba9\u0bbe\u0b95\u0bb9\u0bae\u0bc1\u0bb2\u0bcd\u0bb2",
  },
  "Welipennagahamulla Marawila - Udubaddawa Rd, 60240, Sri Lanka": {
    si: "\u0dc0\u0dd0\u0dbd\u0dd2\u0db4\u0dd0\u0db1\u0dca\u0db1\u0d9c\u0dc4\u0db8\u0dd4\u0dbd\u0dca\u0dbd \u0db8\u0dcf\u0dbb\u0dc0\u0dd2\u0dbd - \u0d8b\u0da9\u0dd4\u0db6\u0daf\u0dca\u0daf\u0dcf\u0dc0 \u0db4\u0dcf\u0dbb, 60240, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb5\u0bc6\u0bb2\u0bbf\u0baa\u0bc6\u0ba9\u0bcd\u0ba9\u0b95\u0bb9\u0bae\u0bc1\u0bb2\u0bcd\u0bb2 \u0bae\u0bbe\u0bb0\u0bb5\u0bbf\u0bb2 - \u0b89\u0b9f\u0bc1\u0baa\u0ba4\u0bcd\u0ba4\u0bbe\u0bb5 \u0bb5\u0bc0\u0ba4\u0bbf, 60240, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Welipennagahamulla, Sri Lanka": {
    si: "\u0dc0\u0dd0\u0dbd\u0dd2\u0db4\u0dd0\u0db1\u0dca\u0db1\u0d9c\u0dc4\u0db8\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb5\u0bc6\u0bb2\u0bbf\u0baa\u0bc6\u0ba9\u0bcd\u0ba9\u0b95\u0bb9\u0bae\u0bc1\u0bb2\u0bcd\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Weliweriya: {
    si: "\u0dc0\u0dd0\u0dbd\u0dd2\u0dc0\u0dda\u0dbb\u0dd2\u0dba",
    ta: "\u0bb5\u0bc6\u0bb2\u0bbf\u0bb5\u0bc7\u0bb0\u0bbf\u0baf",
  },
  "Wella, Chilaw": {
    si: "\u0dc0\u0dd0\u0dbd\u0dca\u0dbd, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad",
    ta: "\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd",
  },
  Wellamankara: {
    si: "\u0dc0\u0dd9\u0dbd\u0dca\u0dbd\u0db8\u0d82\u0d9a\u0dbb",
    ta: "\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bae\u0b99\u0bcd\u0b95\u0bb0\u0bc8",
  },
  Wellampitiya: {
    si: "\u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0db8\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba",
    ta: "\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bae\u0bcd\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf",
  },
  Wellawa: {
    si: "\u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0",
    ta: "\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5",
  },
  Wellawaya: {
    si: "\u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba",
    ta: "\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf",
  },
  "Wellawaya Rd, Monaragala": {
    si: "\u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dc0\u0dcf\u0dba \u0db4\u0dcf\u0dbb, \u0db8\u0ddc\u0db1\u0dbb\u0dcf\u0d9c\u0dbd",
    ta: "\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5\u0bbe\u0baf \u0bb5\u0bc0\u0ba4\u0bbf, \u0bae\u0bca\u0ba9\u0bb0\u0bbe\u0b95\u0bb2\u0bc8",
  },
  Wennappuwa: {
    si: "\u0dc0\u0dd9\u0db1\u0dca\u0db1\u0db4\u0dca\u0db4\u0dd4\u0dc0",
    ta: "\u0bb5\u0bc6\u0ba9\u0bcd\u0ba9\u0baa\u0bcd\u0baa\u0bc1\u0bb5",
  },
  "Weralabada, Chilaw": {
    si: "\u0dc0\u0dd9\u0dbb\u0dbd\u0db6\u0da9, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad",
    ta: "\u0bb5\u0bc6\u0bb0\u0bb2\u0baa\u0b9f, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd",
  },
  "Werellana, Sri Lanka": {
    si: "\u0dc0\u0dd0\u0dbb\u0dd0\u0dbd\u0dca\u0dbd\u0db1, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0bb5\u0bc6\u0bb0\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe\u0ba9\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Weweldeniya: {
    si: "\u0dc0\u0dda\u0dc0\u0dd0\u0dbd\u0dca\u0daf\u0dd9\u0dab\u0dd2\u0dba",
    ta: "\u0bb5\u0bc6\u0bb5\u0bc6\u0bb2\u0bcd\u0ba4\u0bc6\u0ba9\u0bbf\u0baf",
  },
  "When was the data updated?": {
    si: "\u0daf\u0dad\u0dca\u0dad \u0dba\u0dcf\u0dc0\u0dad\u0dca\u0d9a\u0dcf\u0dbd\u0dd3\u0db1 \u0d9a\u0dc5\u0dda \u0d9a\u0dc0\u0daf\u0dcf\u0daf?",
    ta: "\u0ba4\u0bb0\u0bb5\u0bc1 \u0b8e\u0baa\u0bcd\u0baa\u0bcb\u0ba4\u0bc1 \u0baa\u0bc1\u0ba4\u0bc1\u0baa\u0bcd\u0baa\u0bbf\u0b95\u0bcd\u0b95\u0baa\u0bcd\u0baa\u0b9f\u0bcd\u0b9f\u0ba4\u0bc1?",
  },
  "When was the shed's last update?": {
    si: "\u0db8\u0da9\u0dd4\u0dc0\u0dda \u0d85\u0dc0\u0dc3\u0dcf\u0db1 \u0dba\u0dcf\u0dc0\u0dad\u0dca\u0d9a\u0dcf\u0dbd\u0dd3\u0db1\u0dba \u0d9a\u0dc0\u0daf\u0dcf\u0daf?",
    ta: "\u0b95\u0bca\u0b9f\u0bcd\u0b9f\u0b95\u0bc8\u0baf\u0bbf\u0ba9\u0bcd \u0b95\u0b9f\u0bc8\u0b9a\u0bbf\u0baa\u0bcd \u0baa\u0bc1\u0ba4\u0bc1\u0baa\u0bcd\u0baa\u0bbf\u0baa\u0bcd\u0baa\u0bc1 \u0b8e\u0baa\u0bcd\u0baa\u0bcb\u0ba4\u0bc1?",
  },
  Wilgamuwa: {
    si: "\u0dc0\u0dd2\u0dbd\u0dca\u0d9c\u0db8\u0dd4\u0dc0",
    ta: "\u0bb5\u0bbf\u0bb2\u0bcd\u0b95\u0bae\u0bc1\u0bb5",
  },
  "Wipula Dharmadasa": {
    si: "\u0dc0\u0dd2\u0db4\u0dd4\u0dbd \u0db0\u0dbb\u0dca\u0db8\u0daf\u0dcf\u0dc3",
    ta: "\u0bb5\u0bbf\u0baa\u0bc1\u0bb2 \u0ba4\u0bb0\u0bcd\u0bae\u0ba4\u0bbe\u0b9a",
  },
  "Withikuliya Junction": {
    si: "\u0dc0\u0dd2\u0dad\u0dd2\u0d9a\u0dd4\u0dbd\u0dd2\u0dba \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba",
    ta: "\u0bb5\u0bbf\u0ba4\u0bcd\u0ba4\u0bbf\u0b95\u0bc1\u0bb3\u0bbf\u0baf\u0bbe \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf",
  },
  "X26P+C7C, Hali-ela, Sri Lanka": {
    si: "X26P+C7C, \u0dc4\u0dcf\u0dbd\u0dd2-\u0d91\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "X26P+C7C, \u0bb9\u0bbe\u0bb2\u0bbf-\u0b8e\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "X2CJ+JH7, Polonnaruwa, Sri Lanka": {
    si: "X2CJ+JH7, \u0db4\u0ddc\u0dc5\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "X2CJ+JH7, \u0baa\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "X3M5+6C4, Lower King Street, Badulla, Sri Lanka": {
    si: "X3M5+6C4, \u0db4\u0dc4\u0dc5 \u0dbb\u0da2 \u0dc0\u0dd3\u0daf\u0dd2\u0dba, \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "X3M5+6C4, \u0bb2\u0bcb\u0baf\u0bb0\u0bcd \u0b95\u0bbf\u0b99\u0bcd \u0bb8\u0bcd\u0b9f\u0bcd\u0bb0\u0bc0\u0b9f\u0bcd, \u0baa\u0ba4\u0bc1\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "X3M8+8XQ, Demodera - Spring Valley - Badulla Rd, Badulla, Sri Lanka": {
    si: "X3M8+8XQ, Demodera - Spring Valley - \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "X3M8+8XQ, \u0b9f\u0bc6\u0bae\u0bcb\u0b9f\u0bc6\u0bb0\u0bbe - \u0bb8\u0bcd\u0baa\u0bbf\u0bb0\u0bbf\u0b99\u0bcd \u0bb5\u0bc7\u0bb2\u0bbf - \u0baa\u0ba4\u0bc1\u0bb3\u0bc8 \u0b9a\u0bbe\u0bb2\u0bc8, \u0baa\u0ba4\u0bc1\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "X3X4+HPV, Mahiyangana Rd, Badulla, Sri Lanka": {
    si: "X3X4+HPV, \u0db8\u0dc4\u0dd2\u0dba\u0d82\u0d9c\u0db1 \u0db4\u0dcf\u0dbb, \u0db6\u0daf\u0dd4\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "X3X4+HPV, Mahiyangana Rd, \u0baa\u0ba4\u0bc1\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "X486+PRV, Nikawala, Sri Lanka": {
    si: "X486+PRV, \u0db1\u0dd2\u0d9a\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "X486+PRV, \u0ba8\u0bbf\u0b95\u0bbe\u0bb5\u0bbe\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "X4G9+5JR, B18, Pugoda, Sri Lanka": {
    si: "X4G9+5JR, B18, \u0db4\u0dd6\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "X4G9+5JR, B18, \u0baa\u0bc2\u0b95\u0bcb\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "X636+8R3, Avissawella, Sri Lanka": {
    si: "X636+8R3, \u0d85\u0dc0\u0dd2\u0dc3\u0dca\u0dc3\u0dcf\u0dc0\u0dda\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "X636+8R3, \u0b85\u0bb5\u0bbf\u0b9a\u0bbe\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "X87P+PW Kayankerni, Sri Lanka": {
    si: "X87P+PW Kayankerni, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "X87P+PW \u0b95\u0bbe\u0baf\u0b99\u0bcd\u0b95\u0bc7\u0bb0\u0bcd\u0ba9\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "X8V5+8W2, Habaraduwa, Sri Lanka": {
    si: "X8V5+8W2, \u0dc4\u0db6\u0dbb\u0dcf\u0daf\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "X8V5+8W2, \u0bb9\u0baa\u0bb0\u0bbe\u0ba4\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "X999+RV, Ahangama, Sri Lanka": {
    si: "X999+RV, \u0d85\u0dc4\u0d82\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "X999+RV, \u0b85\u0b95\u0b99\u0bcd\u0b95\u0bbe\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "X9C8+M63, Ahangama, Sri Lanka": {
    si: "X9C8+M63, \u0d85\u0dc4\u0d82\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "X9C8+M63, \u0b85\u0b95\u0b99\u0bcd\u0b95\u0bbe\u0bae\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XCCH+WG3, Weligama, Sri Lanka": {
    si: "XCCH+WG3, \u0dc0\u0dd0\u0dbd\u0dd2\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XCCH+WG3, \u0bb5\u0bc6\u0bb2\u0bbf\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XCFJ+F5H, Matara Rd, Weligama, Sri Lanka": {
    si: "XCFJ+F5H, \u0db8\u0dcf\u0dad\u0dbb \u0db4\u0dcf\u0dbb, \u0dc0\u0dd0\u0dbd\u0dd2\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XCFJ+F5H, Matara Rd, Weligama, Sri Lanka",
  },
  "XFM3+92G, Weligama, Sri Lanka": {
    si: "XFM3+92G, \u0dc0\u0dd0\u0dbd\u0dd2\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XFM3+92G, \u0bb5\u0bc6\u0bb2\u0bbf\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XG5W+273, B275, Matara, Sri Lanka": {
    si: "XG5W+273, B275, \u0db8\u0dcf\u0dad\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XG5W+273, B275, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb1\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XGG9+39G, Godagama, Sri Lanka": {
    si: "XGG9+39G, \u0d9c\u0ddc\u0da9\u0d9c\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XGG9+39G, \u0b95\u0bca\u0b9f\u0b95\u0bae, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XJ73+V5F, Kekanadura, Sri Lanka": {
    si: "XJ73+V5F, \u0d9a\u0dd0\u0d9a\u0db1\u0daf\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XJ73+V5F, \u0b95\u0bc7\u0b95\u0ba9\u0ba4\u0bc1\u0bb0\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XM7R+RGM, Dikwella, Sri Lanka": {
    si: "XM7R+RGM, \u0daf\u0dd2\u0d9a\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XM7R+RGM, \u0b9f\u0bbf\u0b95\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XM7V+F8J Bamunusinghe Fuel Station, Tangalle Rd, Dikwella 81200, Sri Lanka":
    {
      si: "XM7V+F8J \u0db6\u0db8\u0dd4\u0dab\u0dd4\u0dc3\u0dd2\u0d82\u0dc4 \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0dad\u0d82\u0d9c\u0dbd\u0dca\u0dbd \u0db4\u0dcf\u0dbb, \u0daf\u0dd2\u0d9a\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd 81200, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "XM7V+F8J \u0baa\u0bae\u0bc1\u0ba9\u0bc1\u0b9a\u0bbf\u0b99\u0bcd\u0b95 \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0ba4\u0b99\u0bcd\u0b95\u0bbe\u0bb2\u0bc8 \u0bb5\u0bc0\u0ba4\u0bbf, \u0ba4\u0bbf\u0b95\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2 81200, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "XMPX+2C4, Walasgala, Sri Lanka": {
    si: "XMPX+2C4, \u0dc0\u0dbd\u0dc3\u0dca\u0d9c\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XMPX+2C4, \u0bb5\u0bb2\u0bb8\u0bcd\u0b95\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XP89+G4Q, Nilwella, Sri Lanka": {
    si: "XP89+G4Q, \u0db1\u0dd2\u0dbd\u0dca\u0dc0\u0dd0\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XP89+G4Q, \u0ba8\u0bbf\u0bb2\u0bcd\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XPGM+P9V, Kudawella, Sri Lanka": {
    si: "XPGM+P9V, \u0d9a\u0dd4\u0da9\u0dcf\u0dc0\u0dd0\u0dbd\u0dca\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XPGM+P9V, \u0b95\u0bc1\u0b9f\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XPRG+VF2, Pahajjawa, Sri Lanka": {
    si: "XPRG+VF2, \u0db4\u0dc4\u0da2\u0dca\u0da2\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XPRG+VF2, \u0baa\u0bb9\u0b9c\u0bcd\u0b9c\u0bbe\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XQ88+RWX, PBC Hwy, Nuwara Eliya 22200, Sri Lanka": {
    si: "XQ88+RWX, PBC Hwy, \u0db1\u0dd4\u0dc0\u0dbb\u0d91\u0dc5\u0dd2\u0dba 22200, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XQ88+RWX, PBC Hwy, \u0ba8\u0bc1\u0bb5\u0bb0\u0bc6\u0bb2\u0bbf\u0baf\u0bbe 22200, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XQH4+VR Karamba, Sri Lanka": {
    si: "XQH4+VR \u0d9a\u0dbb\u0db8\u0dca\u0db6\u0dcf, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XQH4+VR \u0b95\u0bb0\u0bae\u0bcd\u0baa\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XV4H+4X4, AB10, Peliyagoda, Sri Lanka": {
    si: "XV4H+4X4, AB10, \u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XV4H+4X4, AB10, \u0baa\u0bc7\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XV4P+9H2, Kandy Rd,  , Sri Lanka": {
    si: "XV4P+9H2, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XV4P+9H2, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0b9a\u0bbe\u0bb2\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XV5R+83C, Kandy Rd, Peliyagoda, Sri Lanka": {
    si: "XV5R+83C, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XV5R+83C, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0baa\u0bc7\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XV7J+8HX, Chilaw - Colombo Main Rd, Wattala, Sri Lanka": {
    si: "XV7J+8HX, \u0dc4\u0dbd\u0dcf\u0dc0\u0dad - \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0dc0\u0dad\u0dca\u0dad\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XV7J+8HX, \u0b9a\u0bbf\u0bb2\u0bbe\u0baa\u0bae\u0bcd - \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0bb5\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XVFH+WQ8, Colombo, Sri Lanka": {
    si: "XVFH+WQ8, \u0d9a\u0ddc\u0dc5\u0db9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XVFH+WQ8, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XVQR+5VR, Wattala 11300, Sri Lanka": {
    si: "XVQR+5VR, \u0dc0\u0dad\u0dca\u0dad\u0dbd 11300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XVQR+5VR, \u0bb5\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8 11300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XVQV+CCV, Wattala 11300, Sri Lanka": {
    si: "XVQV+CCV, \u0dc0\u0dad\u0dca\u0dad\u0dbd 11300, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XVQV+CCV, \u0bb5\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8 11300, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XW24+GGP, Peliyagoda, Sri Lanka": {
    si: "XW24+GGP, \u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XW24+GGP, \u0baa\u0bc7\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XW2M+JFH, Peliyagoda, Sri Lanka": {
    si: "XW2M+JFH, \u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XW2M+JFH, \u0baa\u0bc7\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XW93+387, Peliyagoda, Sri Lanka": {
    si: "XW93+387, \u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XW93+387, \u0baa\u0bc7\u0bb2\u0bbf\u0baf\u0b95\u0bca\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XWGV+HHP, Makola Rd, Peliyagoda, Sri Lanka": {
    si: "XWGV+HHP, \u0db8\u0dcf\u0d9a\u0ddc\u0dc5 \u0db4\u0dcf\u0dbb, \u0db4\u0dd1\u0dbd\u0dd2\u0dba\u0d9c\u0ddc\u0da9, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XWGV+HHP, Makola Rd, Peliyagoda, Sri Lanka",
  },
  "XWH7+85P, Mannar, Sri Lanka": {
    si: "XWH7+85P, \u0db8\u0db1\u0dca\u0db1\u0dcf\u0dbb\u0db8, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XWH7+85P, \u0bae\u0ba9\u0bcd\u0ba9\u0bbe\u0bb0\u0bcd, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XWRQ+FXH, Colombo - Kandy Rd, Kadawatha, Sri Lanka": {
    si: "XWRQ+FXH, \u0d9a\u0ddc\u0dc5\u0db9 - \u0db1\u0dd4\u0dc0\u0dbb \u0db4\u0dcf\u0dbb, \u0d9a\u0da9\u0dc0\u0dad, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XWRQ+FXH, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 - \u0b95\u0ba3\u0bcd\u0b9f\u0bbf \u0bb0\u0bcb\u0b9f\u0bc1, \u0b95\u0b9f\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XWV7+VRW, Wattala, Sri Lanka": {
    si: "XWV7+VRW, \u0dc0\u0dad\u0dca\u0dad\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XWV7+VRW, \u0bb5\u0ba4\u0bcd\u0ba4\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XWWG+6FP, Girithale, Sri Lanka": {
    si: "XWWG+6FP, \u0d9c\u0dd2\u0dbb\u0dd2\u0dad\u0dbd\u0dda, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XWWG+6FP, \u0b95\u0bbf\u0bb0\u0bbf\u0ba4\u0bb2\u0bc7, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XWX3+WFQ, Udupussellawa, Sri Lanka": {
    si: "XWX3+WFQ, \u0d8b\u0da9\u0dd4\u0db4\u0dd4\u0dc3\u0dca\u0dc3\u0dd0\u0dbd\u0dca\u0dbd\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XWX3+WFQ, \u0b89\u0b9f\u0bc1\u0baa\u0bc1\u0bb8\u0bcd\u0bb8\u0bb2\u0bcd\u0bb2\u0bbe\u0bb5, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XX6J+WHM, Polonnaruwa, Sri Lanka": {
    si: "XX6J+WHM, \u0db4\u0ddc\u0dc5\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XX6J+WHM, \u0baa\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XXP6+V4 Polonnaruwa, Sri Lanka": {
    si: "XXP6+V4 \u0db4\u0ddc\u0dbd\u0ddc\u0db1\u0dca\u0db1\u0dbb\u0dd4\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XXP6+V4 \u0baa\u0bca\u0bb2\u0ba9\u0bcd\u0ba9\u0bb1\u0bc1\u0bb5\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "XXPF+JRF, Gonawala, Sri Lanka": {
    si: "XXPF+JRF, \u0d9c\u0ddd\u0db1\u0dc0\u0dbd, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "XXPF+JRF, \u0b95\u0bcb\u0ba9\u0bbe\u0bb5\u0bbe\u0bb2\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Y V A JANAKA": {
    si: "Y V A \u0da2\u0dcf\u0db1\u0d9a",
    ta: "\u0b92\u0baf\u0bcd \u0bb5\u0bbf \u0b8f \u0b9c\u0ba9\u0b95\u0bbe",
  },
  "YAKKALAMULLA MPCS LTD": {
    si: "\u0dba\u0d9a\u0dca\u0d9a\u0dbd\u0db8\u0dd4\u0dbd\u0dca\u0dbd MPCS LTD",
    ta: "\u0baf\u0b95\u0bcd\u0b95\u0bb2\u0bae\u0bc1\u0bb2\u0bcd\u0bb2 MPCS LTD",
  },
  "YASARATNA ENTERPRISES": {
    si: "\u0dba\u0dc3\u0dbb\u0dad\u0dca\u0db1 \u0d91\u0db1\u0dca\u0da7\u0dbb\u0dca\u0db4\u0dca\u200d\u0dbb\u0dba\u0dd2\u0dc3\u0dc3\u0dca",
    ta: "\u0baf\u0b9a\u0bb0\u0ba4\u0bcd\u0ba9\u0bbe \u0b8e\u0ba3\u0bcd\u0b9f\u0bb0\u0bcd\u0baa\u0bbf\u0bb0\u0bc8\u0b9a\u0bb8\u0bcd",
  },
  "YASASIRI LANKA FILLING STATION": {
    si: "\u0dba\u0dc3\u0dc3\u0dd2\u0dbb\u0dd2 \u0dbd\u0d82\u0d9a\u0dcf \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0baf\u0bbe\u0b9a\u0b9a\u0bbf\u0bb0\u0bbf \u0bb2\u0b99\u0bcd\u0b95\u0bbe \u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "YASHODHA FUEL MART": {
    si: "\u0dba\u0dc1\u0ddd\u0db0 \u0d89\u0db1\u0dca\u0db0\u0db1 \u0dc0\u0dd9\u0dc5\u0db3 \u0dc3\u0d82\u0d9a\u0dd3\u0dbb\u0dca\u0dab\u0dba",
    ta: "\u0baf\u0b9a\u0bcb\u0ba4\u0bbe \u0b83\u0baa\u0bcd\u0baf\u0bc2\u0bb2\u0bcd \u0bae\u0bbe\u0bb0\u0bcd\u0b9f\u0bcd",
  },
  "YATINUWARA GANGAPALATHA MPCS LTD": {
    si: "\u0dba\u0da7\u0dd2\u0db1\u0dd4\u0dc0\u0dbb \u0d9c\u0d82\u0d9c\u0dcf\u0db4\u0dcf\u0dbd\u0dad MPCS LTD",
    ta: "\u0baf\u0b9f\u0bcd\u0b9f\u0bbf\u0ba9\u0bc1\u0bb5\u0bb0 \u0b95\u0b99\u0bcd\u0b95\u0baa\u0bbe\u0bb2\u0ba4\u0bbe MPCS LTD",
  },
  "YATINUWARA MEDA PALATA MPCS LTD": {
    si: "\u0dba\u0da7\u0dd2\u0db1\u0dd4\u0dc0\u0dbb \u0db8\u0dd0\u0daf \u0db4\u0dbd\u0dcf\u0dad \u0d91\u0db8\u0dca\u0db4\u0dd3\u0dc3\u0dd3\u0d91\u0dc3\u0dca \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0baf\u0b9f\u0bbf\u0ba9\u0bc1\u0bb5\u0bbe\u0bb0 \u0bae\u0bc7\u0b9f\u0bbe \u0baa\u0bb2\u0bbe\u0b9f\u0bbe MPCS LTD",
  },
  "YATIYANTOTA MPCS LTD": {
    si: "\u0dba\u0da7\u0dd2\u0dba\u0db1\u0dca\u0dad\u0ddc\u0da7 MPCS LTD",
    ta: "\u0baf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 MPCS LTD",
  },
  "YOGESWARY SINNAIAH": {
    si: "\u0dba\u0ddd\u0d9c\u0dda\u0dc1\u0dca\u0dc0\u0dbb\u0dd2 \u0dc3\u0dd2\u0db1\u0dca\u0db1\u0dba\u0dd2\u0dba\u0dcf",
    ta: "\u0baf\u0bcb\u0b95\u0bc7\u0bb8\u0bcd\u0bb5\u0bb0\u0bbf \u0b9a\u0bbf\u0ba9\u0bcd\u0ba9\u0bc8\u0baf\u0bbe",
  },
  "YOMAL FILLING STATION (PVT) LTD": {
    si: "\u0dba\u0ddc\u0db8\u0dcf\u0dbd\u0dca \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd (\u0db4\u0dd4\u0daf\u0dca\u0d9c\u0dbd\u0dd2\u0d9a) \u0dbd\u0dd2\u0db8\u0dd2\u0da7\u0da9\u0dca",
    ta: "\u0baf\u0bcb\u0bae\u0bb2\u0bcd \u0b83\u0baa\u0bbf\u0bb2\u0bcd\u0bb2\u0bbf\u0b99\u0bcd \u0bb8\u0bcd\u0b9f\u0bc7\u0bb7\u0ba9\u0bcd (\u0baa\u0bbf\u0bb5\u0bbf\u0b9f\u0bbf) \u0bb2\u0bbf\u0bae\u0bbf\u0b9f\u0bc6\u0b9f\u0bcd",
  },
  "Yakalla, Ibbagamuwa, Bakmeegolla": {
    si: "\u0dba\u0d9a\u0dbd\u0dca\u0dbd, \u0d89\u0db6\u0dca\u0db6\u0dcf\u0d9c\u0db8\u0dd4\u0dc0, \u0db6\u0d9a\u0dca\u0db8\u0dd3\u0d9c\u0ddc\u0dbd\u0dca\u0dbd",
    ta: "\u0baf\u0b95\u0bb2\u0bcd\u0bb2, \u0b87\u0baa\u0b95\u0bae\u0bc1\u0bb5, \u0baa\u0b95\u0bcd\u0bae\u0bc0\u0b95\u0bca\u0bb2\u0bcd\u0bb2",
  },
  "Yakalla, Ibbagamuwa, GCJP+X6V, Bakmeegolla, Sri Lanka": {
    si: "\u0dba\u0d9a\u0dbd\u0dca\u0dbd, \u0d89\u0db6\u0dca\u0db6\u0dcf\u0d9c\u0db8\u0dd4\u0dc0, GCJP+X6V, Bakmeegolla, Sri Lanka",
    ta: "\u0baf\u0b95\u0bb2\u0bcd\u0bb2\u0bbe, \u0b87\u0baa\u0b95\u0bae\u0bc1\u0bb5\u0bbe, GCJP+X6V, \u0baa\u0b95\u0bcd\u0bae\u0bc0\u0b95\u0bca\u0bb2\u0bcd\u0bb2, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  Yakkala: {
    si: "\u0dba\u0d9a\u0dca\u0d9a\u0dbd",
    ta: "\u0baf\u0b95\u0bcd\u0b95\u0bb2\u0bbe",
  },
  "Yakkala - Radawana Rd, Yakkala": {
    si: "\u0dba\u0d9a\u0dca\u0d9a\u0dbd - \u0dbb\u0daf\u0dcf\u0dc0\u0dcf\u0db1 \u0db4\u0dcf\u0dbb, \u0dba\u0d9a\u0dca\u0d9a\u0dbd",
    ta: "\u0baf\u0b95\u0bcd\u0b95\u0bb2\u0bbe - \u0bb0\u0bbe\u0b9f\u0bb5\u0bbe\u0ba9\u0bbe \u0bb0\u0bcb\u0b9f\u0bc1, \u0baf\u0b95\u0bcd\u0b95\u0bb2\u0bbe",
  },
  Yakkalamulla: {
    si: "\u0dba\u0d9a\u0dca\u0d9a\u0dbd\u0db8\u0dd4\u0dbd\u0dca\u0dbd",
    ta: "\u0baf\u0b95\u0bcd\u0b95\u0bb2\u0bae\u0bc1\u0bb2\u0bcd\u0bb2",
  },
  "Yatadola, Nagoda-mathugama-kalawellawa-bellapitiya Road": {
    si: "\u0dba\u0da7\u0daf\u0ddc\u0dbd, \u0db1\u0dcf\u0d9c\u0ddc\u0da9-\u0db8\u0dad\u0dd4\u0d9c\u0db8-\u0d9a\u0dbd\u0dc0\u0dd0\u0dbd\u0dca\u0dbd\u0dcf\u0dc0-\u0db6\u0dd0\u0dbd\u0dca\u0dbd\u0db4\u0dd2\u0da7\u0dd2\u0dba \u0db4\u0dcf\u0dbb",
    ta: "\u0baf\u0b9f\u0ba4\u0bcb\u0bb2, \u0ba8\u0bbe\u0b95\u0bca\u0b9f-\u0bae\u0ba4\u0bc1\u0b95\u0bae-\u0b95\u0bb2\u0bb5\u0bc6\u0bb2\u0bcd\u0bb2\u0bb5-\u0baa\u0bc6\u0bb2\u0bcd\u0bb2\u0baa\u0bbf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf \u0bb5\u0bc0\u0ba4\u0bbf",
  },
  "Yatinuwara St, Kandy": {
    si: "\u0dba\u0da7\u0dd2\u0db1\u0dd4\u0dc0\u0dbb \u0dc1\u0dcf\u0db1\u0dca\u0dad, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb",
    ta: "\u0baf\u0b9f\u0bcd\u0b9f\u0bbf\u0ba8\u0bc1\u0bb5\u0bb0 \u0b9a\u0bc6\u0baf\u0bbf\u0ba9\u0bcd\u0b9f\u0bcd, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf",
  },
  "Yatiyana Fuel Station": {
    si: "\u0dba\u0da7\u0dd2\u0dba\u0db1 \u0d89\u0db1\u0dca\u0db0\u0db1 \u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd",
    ta: "\u0baf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0bbe\u0ba9 \u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd",
  },
  "Yatiyana Rd, Kekanadura": {
    si: "\u0dba\u0da7\u0dd2\u0dba\u0db1 \u0db4\u0dcf\u0dbb, \u0d9a\u0dd0\u0d9a\u0db1\u0daf\u0dd4\u0dbb",
    ta: "\u0baf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0bbe\u0ba9 \u0bb5\u0bc0\u0ba4\u0bbf, \u0b95\u0bc7\u0b95\u0ba9\u0ba4\u0bc1\u0bb0",
  },
  "Yatiyana-Minuwangoda": {
    si: "\u0dba\u0da7\u0dd2\u0dba\u0db1-\u0db8\u0dd2\u0db1\u0dd4\u0dc0\u0db1\u0dca\u0d9c\u0ddc\u0da9",
    ta: "\u0baf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0bbe\u0ba9-\u0bae\u0bbf\u0ba9\u0bc1\u0bb5\u0bbe\u0b99\u0bcd\u0b95\u0bca\u0b9f",
  },
  "Yatiyanthota Clock Tower, A7, Yatiyanthota, Sri Lanka": {
    si: "\u0dba\u0da7\u0dd2\u0dba\u0db1\u0dca\u0dad\u0ddc\u0da7 \u0d94\u0dbb\u0dbd\u0ddd\u0dc3\u0dd4 \u0d9a\u0dab\u0dd4\u0dc0, A7, \u0dba\u0da7\u0dd2\u0dba\u0db1\u0dca\u0dad\u0ddc\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8 \u0bae\u0ba3\u0bbf\u0b95\u0bcd\u0b95\u0bc2\u0ba3\u0bcd\u0b9f\u0bc1, A7, \u0baf\u0b9f\u0bcd\u0b9f\u0bbf\u0baf\u0ba8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "Yelakkara Junction,yatawatta,matale": {
    si: "\u0dba\u0dd9\u0dbd\u0d9a\u0dca\u0d9a\u0dbb \u0dc4\u0db1\u0dca\u0daf\u0dd2\u0dba, \u0dba\u0da7\u0dc0\u0dad\u0dca\u0dad, \u0db8\u0dcf\u0dad\u0dbd\u0dda",
    ta: "\u0b8f\u0bb2\u0b95\u0bcd\u0b95\u0bbe\u0bb0 \u0b9a\u0ba8\u0bcd\u0ba4\u0bbf, \u0baf\u0ba4\u0bb5\u0ba4\u0bcd\u0ba4\u0bc8, \u0bae\u0bbe\u0ba4\u0bcd\u0ba4\u0bb3\u0bc8",
  },
  "Zoom Out": {
    si: "\u0dc0\u0dd2\u0dc1\u0dcf\u0dbd\u0db1\u0dba \u0d9a\u0dbb\u0db1\u0dca\u0db1",
    ta: "\u0baa\u0bc6\u0bb0\u0bbf\u0ba4\u0bbe\u0b95\u0bcd\u0b95\u0bb5\u0bc1\u0bae\u0bcd",
  },
  "[Invalid LatLng]": {
    si: "[\u0d85\u0dc0\u0dbd\u0d82\u0d9c\u0dd4 LatLng]",
    ta: "[\u0ba4\u0bb5\u0bb1\u0bbe\u0ba9 LatLng]",
  },
  "a18 Pelmadulla - Embilipitiya Hwy, Embilipitiya 70200, Sri Lanka": {
    si: "a18 \u0db4\u0dd0\u0dbd\u0dca\u0db8\u0da9\u0dd4\u0dbd\u0dca\u0dbd - \u0d87\u0db9\u0dd2\u0dbd\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba Hwy, \u0d87\u0db9\u0dd2\u0dbd\u0dd2\u0db4\u0dd2\u0da7\u0dd2\u0dba 70200, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "a18 Pelmadulla - Embilipitiya Hwy, Embilipitiya 70200, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "a21 Kegalle-Bulathkohupitiya-Karawanella Hwy, Bulathkohupitiya 71230, Sri Lanka":
    {
      si: "a21 \u0d9a\u0dd1\u0d9c\u0dbd\u0dca\u0dbd-\u0db6\u0dd4\u0dbd\u0dad\u0dca\u0d9a\u0ddc\u0dc4\u0dd4\u0db4\u0dd2\u0da7\u0dd2\u0dba-\u0d9a\u0dbb\u0dc0\u0db1\u0dd0\u0dbd\u0dca\u0dbd Hwy, \u0db6\u0dd4\u0dbd\u0dad\u0dca\u0d9a\u0ddc\u0dc4\u0dd4\u0db4\u0dd2\u0da7\u0dd2\u0dba 71230, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "a21 \u0b95\u0bc7\u0b95\u0bbe\u0bb2\u0bc8-\u0baa\u0bc1\u0bb2\u0ba4\u0bcd\u0b95\u0bca\u0bb9\u0bc1\u0baa\u0bbf\u0b9f\u0bbf\u0baf-\u0b95\u0bb0\u0bb5\u0ba9\u0bc6\u0bb2\u0bcd\u0bb2\u0bbe Hwy, Bulathkohupitiya 71230, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  ago: {
    si: "\u0db4\u0dd9\u0dbb",
    ta: "\u0bae\u0bc1\u0ba9\u0bcd\u0baa\u0bc1",
  },
  "b157 Horana - Anguruwatota - Mathugama - Aluthgama Road, Anguruwatota, Sri Lanka":
    {
      si: "b157 \u0dc4\u0ddc\u0dbb\u0dab - \u0d85\u0d9f\u0dd4\u0dbb\u0dd4\u0dc0\u0dcf\u0dad\u0ddc\u0da7 - \u0db8\u0dad\u0dd4\u0d9c\u0db8 - \u0d85\u0dbd\u0dd4\u0dad\u0dca\u0d9c\u0db8 \u0db4\u0dcf\u0dbb, \u0d85\u0d9f\u0dd4\u0dbb\u0dd4\u0dc0\u0dcf\u0dad\u0ddc\u0da7, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
      ta: "b157 \u0bb9\u0bca\u0bb0\u0ba3 - \u0b85\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0bc1\u0bb5\u0ba4\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f - \u0bae\u0ba4\u0bcd\u0ba4\u0bc1\u0b95\u0bae - \u0b85\u0bb2\u0bc1\u0ba4\u0bcd\u0b95\u0bae \u0bb5\u0bc0\u0ba4\u0bbf, \u0b85\u0b99\u0bcd\u0b95\u0bc1\u0bb0\u0bc1\u0bb5\u0bbe\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bbe, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
    },
  "ceypetco Gas Station Pussellawa, Pussellawa, Sri Lanka": {
    si: "ceypetco \u0d9c\u0dd1\u0dc3\u0dca \u0dc4\u0dbd \u0db4\u0dd4\u0dc3\u0dca\u0dc3\u0dd0\u0dbd\u0dca\u0dbd\u0dcf\u0dc0, \u0db4\u0dd4\u0dc3\u0dca\u0dc3\u0dd0\u0dbd\u0dca\u0dbd\u0dcf\u0dc0, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "ceypetco \u0b8e\u0bb0\u0bbf\u0bb5\u0bbe\u0baf\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd Pussellawa, Pussellawa, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  days: {
    si: "\u0daf\u0dd2\u0db1",
    ta: "\u0ba8\u0bbe\u0b9f\u0bcd\u0b95\u0bb3\u0bbf\u0bb2\u0bcd",
  },
  "filling station, Colombo Rd, Ratnapura, Sri Lanka": {
    si: "\u0db4\u0dd2\u0dbb\u0dc0\u0dd4\u0db8\u0dca\u0dc4\u0dbd, \u0d9a\u0ddc\u0dc5\u0db9 \u0db4\u0dcf\u0dbb, \u0dbb\u0dad\u0dca\u0db1\u0db4\u0dd4\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0ba8\u0bbf\u0bb0\u0baa\u0bcd\u0baa\u0bc1 \u0ba8\u0bbf\u0bb2\u0bc8\u0baf\u0bae\u0bcd, \u0b95\u0bca\u0bb4\u0bc1\u0bae\u0bcd\u0baa\u0bc1 \u0b9a\u0bbe\u0bb2\u0bc8, \u0b87\u0bb0\u0ba4\u0bcd\u0ba4\u0bbf\u0ba9\u0baa\u0bc1\u0bb0\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  "fuel.gov.lk": {
    si: "\u0d89\u0db1\u0dca\u0db0\u0db1.gov.lk",
    ta: "\u0b8e\u0bb0\u0bbf\u0baa\u0bca\u0bb0\u0bc1\u0bb3\u0bcd.gov.lk",
  },
  "has been temporary shut down. Since this App sources data from fuel.gov.lk, dynamic data will be out of date. Sorry":
    {
      si: "\u0dad\u0dcf\u0dc0\u0d9a\u0dcf\u0dbd\u0dd2\u0d9a\u0dc0 \u0dc0\u0dc3\u0dcf \u0daf\u0db8\u0dcf \u0d87\u0dad. \u0db8\u0dd9\u0db8 \u0dba\u0dd9\u0daf\u0dd4\u0db8 \u0d89\u0db1\u0dca\u0db0\u0db1.gov.lk \u0dc0\u0dd9\u0dad\u0dd2\u0db1\u0dca \u0daf\u0dad\u0dca\u0dad \u0db8\u0dd6\u0dbd\u0dcf\u0dc1\u0dca\u200d\u0dbb \u0d9c\u0db1\u0dca\u0db1\u0dcf \u0db6\u0dd0\u0dc0\u0dd2\u0db1\u0dca \u0d9c\u0dad\u0dd2\u0d9a \u0daf\u0dad\u0dca\u0dad \u0d9a\u0dbd\u0dca \u0d89\u0d9a\u0dd4\u0dad\u0dca \u0dc0\u0db1\u0dd4 \u0d87\u0dad. \u0dc3\u0db8\u0dcf\u0dc0\u0db1\u0dca\u0db1",
      ta: "\u0ba4\u0bb1\u0bcd\u0b95\u0bbe\u0bb2\u0bbf\u0b95\u0bae\u0bbe\u0b95 \u0bae\u0bc2\u0b9f\u0baa\u0bcd\u0baa\u0b9f\u0bcd\u0b9f\u0bc1\u0bb3\u0bcd\u0bb3\u0ba4\u0bc1. \u0b87\u0ba8\u0bcd\u0ba4 \u0b86\u0baa\u0bcd\u0bb8\u0bcd, fuel.gov.lk \u0b87\u0bb2\u0bbf\u0bb0\u0bc1\u0ba8\u0bcd\u0ba4\u0bc1 \u0ba4\u0bb0\u0bb5\u0bc8 \u0b86\u0ba4\u0bbe\u0bb0\u0bae\u0bbe\u0b95\u0b95\u0bcd \u0b95\u0bca\u0ba3\u0bcd\u0b9f\u0bbf\u0bb0\u0bc1\u0baa\u0bcd\u0baa\u0ba4\u0bbe\u0bb2\u0bcd, \u0b9f\u0bc8\u0ba9\u0bae\u0bbf\u0b95\u0bcd \u0ba4\u0bb0\u0bb5\u0bc1 \u0b95\u0bbe\u0bb2\u0bbe\u0bb5\u0ba4\u0bbf\u0baf\u0bbe\u0b95\u0bbf\u0bb5\u0bbf\u0b9f\u0bc1\u0bae\u0bcd. \u0bae\u0ba9\u0bcd\u0ba9\u0bbf\u0b95\u0bcd\u0b95\u0bb5\u0bc1\u0bae\u0bcd",
    },
  hours: {
    si: "\u0db4\u0dd0\u0dba",
    ta: "\u0bae\u0ba3\u0bbf",
  },
  "main streer (opposite to base hospital, WXRM+76X, Pulmoddai, Sri Lanka": {
    si: "\u0db4\u0dca\u200d\u0dbb\u0db0\u0dcf\u0db1 \u0db8\u0dcf\u0dbb\u0dca\u0d9c\u0dba (\u0db8\u0dd6\u0dbd\u0dd2\u0d9a \u0dbb\u0ddd\u0dc4\u0dbd \u0d89\u0daf\u0dd2\u0dbb\u0dd2\u0db4\u0dd2\u0da7, WXRM+76X, \u0db4\u0dd4\u0dbd\u0dca\u0db8\u0ddc\u0da9\u0dd9\u0dba\u0dd2, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0baa\u0bbf\u0bb0\u0ba4\u0bbe\u0ba9 \u0bb8\u0bcd\u0b9f\u0bcd\u0bb0\u0bc0\u0baf\u0bb0\u0bcd (\u0b85\u0b9f\u0bbf\u0baa\u0bcd\u0baa\u0b9f\u0bc8 \u0bae\u0bb0\u0bc1\u0ba4\u0bcd\u0ba4\u0bc1\u0bb5\u0bae\u0ba9\u0bc8\u0b95\u0bcd\u0b95\u0bc1 \u0b8e\u0ba4\u0bbf\u0bb0\u0bc7, WXRM+76X, \u0baa\u0bc1\u0bb2\u0bcd\u0bae\u0bcb\u0b9f\u0bcd\u0b9f\u0bc8, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  minutes: {
    si: "\u0db8\u0dd2\u0db1\u0dd2\u0dad\u0dca\u0dad\u0dd4",
    ta: "\u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0b99\u0bcd\u0b95\u0bb3\u0bcd",
  },
  "mutuwal road, 6QQ7+CQJ, Kalpitiya, Sri Lanka": {
    si: "mutuwal \u0db4\u0dcf\u0dbb, 6QQ7+CQJ, \u0d9a\u0dbd\u0dca\u0db4\u0dd2\u0da7\u0dd2\u0dba, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "mutuwal road, 6QQ7+CQJ, Kalpitiya, Sri Lanka",
  },
  "no 362 Katugastota Rd, Kandy, Sri Lanka": {
    si: "\u0d85\u0d82\u0d9a 362 \u0d9a\u0da7\u0dd4\u0d9c\u0dc3\u0dca\u0dad\u0ddc\u0da7 \u0db4\u0dcf\u0dbb, \u0db8\u0dc4\u0db1\u0dd4\u0dc0\u0dbb, \u0dc1\u0dca\u200d\u0dbb\u0dd3 \u0dbd\u0d82\u0d9a\u0dcf\u0dc0",
    ta: "\u0b8e\u0ba3\u0bcd 362 \u0b95\u0b9f\u0bc1\u0b95\u0bb8\u0bcd\u0ba4\u0bcb\u0b9f\u0bcd\u0b9f\u0bbe \u0b9a\u0bbe\u0bb2\u0bc8, \u0b95\u0ba3\u0bcd\u0b9f\u0bbf, \u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  },
  seconds: {
    si: "\u0dad\u0dad\u0dca\u0db4\u0dbb",
    ta: "\u0bb5\u0bbf\u0ba9\u0bbe\u0b9f\u0bbf\u0b95\u0bb3\u0bcd",
  },
};
export default DICTIONARY;
